(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[888],{

/***/ 4429:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ composeRefs; },
/* harmony export */   "e": function() { return /* binding */ useComposedRefs; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

function setRef(ref, value) {
  if (typeof ref === "function") {
    ref(value);
  } else if (ref) {
    ;
    ref.current = value;
  }
}
function composeRefs(...refs) {
  return (node) => refs.forEach((ref) => setRef(ref, node));
}
function useComposedRefs(...refs) {
  return react__WEBPACK_IMPORTED_MODULE_0__.useCallback(composeRefs(...refs), refs);
}

//# sourceMappingURL=compose-refs.js.map


/***/ }),

/***/ 76758:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ getBoundingClientRect; }
/* harmony export */ });
const getBoundingClientRect = (node) => {
  var _a;
  if (!node || node.nodeType !== 1)
    return;
  return (_a = node.getBoundingClientRect) == null ? void 0 : _a.call(node);
};

//# sourceMappingURL=getBoundingClientRect.js.map


/***/ }),

/***/ 75234:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ getRect; }
/* harmony export */ });
/* harmony import */ var _getBoundingClientRect__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76758);

const getRect = (node) => {
  const rect = (0,_getBoundingClientRect__WEBPACK_IMPORTED_MODULE_0__/* .getBoundingClientRect */ .L)(node);
  if (!rect)
    return;
  const { x, y, top, left } = rect;
  return { x, y, width: node.offsetWidth, height: node.offsetHeight, top, left };
};

//# sourceMappingURL=getRect.js.map


/***/ }),

/***/ 3379:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ measureLayout; },
/* harmony export */   "g": function() { return /* binding */ useElementLayout; }
/* harmony export */ });
/* harmony import */ var _tamagui_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11649);
/* harmony import */ var _tamagui_use_event__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4751);
/* harmony import */ var _helpers_getBoundingClientRect__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76758);
/* harmony import */ var _helpers_getRect__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75234);




const LayoutHandlers = /* @__PURE__ */ new WeakMap();
let resizeObserver = null;
if (typeof window !== "undefined" && "ResizeObserver" in window) {
  resizeObserver = new ResizeObserver((entries) => {
    for (const { target } of entries) {
      const onLayout = LayoutHandlers.get(target);
      if (typeof onLayout !== "function")
        return;
      measureLayout(target, null, (x, y, width, height, left, top) => {
        onLayout({
          nativeEvent: {
            layout: { x, y, width, height, left, top },
            target
          },
          timeStamp: Date.now()
        });
      });
    }
  });
}
const measureLayout = (node, relativeTo, callback) => {
  const relativeNode = relativeTo || (node == null ? void 0 : node.parentNode);
  if (relativeNode instanceof HTMLElement) {
    setTimeout(() => {
      const relativeRect = (0,_helpers_getBoundingClientRect__WEBPACK_IMPORTED_MODULE_2__/* .getBoundingClientRect */ .L)(relativeNode);
      const { height, left, top, width } = (0,_helpers_getRect__WEBPACK_IMPORTED_MODULE_3__/* .getRect */ .D)(node);
      const x = left - relativeRect.left;
      const y = top - relativeRect.top;
      callback(x, y, width, height, left, top);
    }, 0);
  }
};
const idFn = () => {
};
function useElementLayout(ref, onLayout) {
  const hasLayoutEvent = !!onLayout;
  const onLayoutEvent = (0,_tamagui_use_event__WEBPACK_IMPORTED_MODULE_1__/* .useEvent */ .z)(onLayout || idFn);
  (0,_tamagui_constants__WEBPACK_IMPORTED_MODULE_0__/* .useIsomorphicLayoutEffect */ .LI)(() => {
    if (!resizeObserver || !hasLayoutEvent)
      return;
    const node = ref.current;
    if (!node)
      return;
    LayoutHandlers.set(node, onLayoutEvent);
    resizeObserver.observe(node);
    return () => {
      resizeObserver == null ? void 0 : resizeObserver.unobserve(node);
    };
  }, [ref, hasLayoutEvent]);
}

//# sourceMappingURL=useElementLayout.js.map


/***/ }),

/***/ 29561:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ usePlatformMethods; }
/* harmony export */ });
/* harmony import */ var _tamagui_web__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11649);
/* harmony import */ var _helpers_getRect__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75234);
/* harmony import */ var _useElementLayout__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3379);



function usePlatformMethods(hostRef) {
  (0,_tamagui_web__WEBPACK_IMPORTED_MODULE_0__/* .useIsomorphicLayoutEffect */ .LI)(() => {
    const node = hostRef.current;
    if (!node)
      return;
    node.measure = (callback) => (0,_useElementLayout__WEBPACK_IMPORTED_MODULE_1__/* .measureLayout */ .V)(node, null, callback);
    node.measureLayout = (relativeToNode, success) => (0,_useElementLayout__WEBPACK_IMPORTED_MODULE_1__/* .measureLayout */ .V)(node, relativeToNode, success);
    node.measureInWindow = (callback) => {
      if (!node)
        return;
      setTimeout(() => {
        const { height, left, top, width } = (0,_helpers_getRect__WEBPACK_IMPORTED_MODULE_2__/* .getRect */ .D)(node);
        callback(left, top, width, height);
      }, 0);
    };
  }, [hostRef]);
}

//# sourceMappingURL=usePlatformMethods.js.map


/***/ }),

/***/ 96397:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ clamp; }
/* harmony export */ });
function clamp(value, [min, max]) {
  return Math.min(max, Math.max(min, value));
}

//# sourceMappingURL=clamp.js.map


/***/ }),

/***/ 91093:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ composeEventHandlers; }
/* harmony export */ });
function composeEventHandlers(og, next, { checkDefaultPrevented = true } = {}) {
  if (!og || !next) {
    return next || og;
  }
  return function composedEventHandler(event) {
    og == null ? void 0 : og(event);
    if (!event || !(checkDefaultPrevented && "defaultPrevented" in event) || // @ts-ignore
    "defaultPrevented" in event && !event.defaultPrevented) {
      return next == null ? void 0 : next(event);
    }
  };
}

//# sourceMappingURL=composeEventHandlers.js.map


/***/ }),

/***/ 31016:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ concatClassName; }
/* harmony export */ });
function concatClassName(_cn) {
  const args = arguments;
  const usedPrefixes = [];
  let final = "";
  const len = args.length;
  let propObjects = null;
  for (let x = len; x >= 0; x--) {
    const cns = args[x];
    if (!cns)
      continue;
    if (!Array.isArray(cns) && typeof cns !== "string") {
      propObjects = propObjects || [];
      propObjects.push(cns);
      continue;
    }
    const names = Array.isArray(cns) ? cns : cns.split(" ");
    const numNames = names.length;
    for (let i = numNames - 1; i >= 0; i--) {
      const name = names[i];
      if (!name || name === " ")
        continue;
      if (name[0] !== "_") {
        final = name + " " + final;
        continue;
      }
      const splitIndex = name.indexOf("-");
      if (splitIndex < 1) {
        final = name + " " + final;
        continue;
      }
      const nextChar = name[splitIndex + 1];
      const isMediaQuery = nextChar === "_";
      const styleKey = name.slice(1, name.lastIndexOf("-"));
      const mediaKey = isMediaQuery ? name.slice(splitIndex + 2, splitIndex + 7) : null;
      const uid = mediaKey ? styleKey + mediaKey : styleKey;
      if (usedPrefixes.indexOf(uid) > -1) {
        continue;
      }
      usedPrefixes.push(uid);
      const propName = styleKey;
      if (propName && propObjects) {
        if (propObjects.some((po) => {
          if (mediaKey) {
            const propKey = pseudoInvert[mediaKey];
            return po && po[propKey] && propName in po[propKey] && po[propKey] !== null;
          }
          const res = po && propName in po && po[propName] !== null;
          return res;
        })) {
          continue;
        }
      }
      final = name + " " + final;
    }
  }
  return final;
}
const pseudoInvert = {
  hover: "hoverStyle",
  focus: "focusStyle",
  press: "pressStyle"
};

//# sourceMappingURL=concatClassName.js.map


/***/ }),

/***/ 45792:
/***/ (function() {

//# sourceMappingURL=types.js.map


/***/ }),

/***/ 21152:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dc": function() { return /* binding */ stylePropsTransform; },
/* harmony export */   "FB": function() { return /* binding */ stylePropsText; },
/* harmony export */   "Ji": function() { return /* binding */ stylePropsView; },
/* harmony export */   "M6": function() { return /* binding */ validPseudoKeys; },
/* harmony export */   "Qn": function() { return /* binding */ validStyles; },
/* harmony export */   "bX": function() { return /* binding */ validStylesOnBaseProps; },
/* harmony export */   "cC": function() { return /* binding */ stylePropsAll; },
/* harmony export */   "hT": function() { return /* binding */ stylePropsTextOnly; }
/* harmony export */ });
const stylePropsTransform = Object.freeze({
  x: true,
  y: true,
  scale: true,
  perspective: true,
  scaleX: true,
  scaleY: true,
  skewX: true,
  skewY: true,
  matrix: true,
  rotate: true,
  rotateY: true,
  rotateX: true,
  rotateZ: true
});
const validStylesOnBaseProps = Object.freeze({
  placeholderTextColor: true
});
const stylePropsView = Object.freeze({
  backfaceVisibility: true,
  backgroundColor: true,
  borderBottomColor: true,
  borderBottomEndRadius: true,
  borderBottomLeftRadius: true,
  borderBottomRightRadius: true,
  borderBottomStartRadius: true,
  borderBottomWidth: true,
  borderColor: true,
  borderEndColor: true,
  borderLeftColor: true,
  borderLeftWidth: true,
  borderRadius: true,
  borderRightColor: true,
  borderRightWidth: true,
  borderStartColor: true,
  borderStyle: true,
  borderTopColor: true,
  borderTopEndRadius: true,
  borderTopLeftRadius: true,
  borderTopRightRadius: true,
  borderTopStartRadius: true,
  borderTopWidth: true,
  borderWidth: true,
  opacity: true,
  transform: true,
  alignContent: true,
  alignItems: true,
  alignSelf: true,
  aspectRatio: true,
  borderEndWidth: true,
  borderStartWidth: true,
  bottom: true,
  display: true,
  end: true,
  flex: true,
  flexBasis: true,
  flexDirection: true,
  flexGrow: true,
  flexShrink: true,
  flexWrap: true,
  gap: true,
  gapColumn: true,
  gapRow: true,
  height: true,
  justifyContent: true,
  left: true,
  margin: true,
  marginBottom: true,
  marginEnd: true,
  marginHorizontal: true,
  marginLeft: true,
  marginRight: true,
  marginStart: true,
  marginTop: true,
  marginVertical: true,
  maxHeight: true,
  maxWidth: true,
  minHeight: true,
  minWidth: true,
  overflow: true,
  padding: true,
  paddingBottom: true,
  paddingEnd: true,
  paddingHorizontal: true,
  paddingLeft: true,
  paddingRight: true,
  paddingStart: true,
  paddingTop: true,
  paddingVertical: true,
  position: true,
  right: true,
  start: true,
  top: true,
  width: true,
  zIndex: true,
  direction: true,
  shadowColor: true,
  shadowOffset: true,
  shadowOpacity: true,
  shadowRadius: true,
  ...validStylesOnBaseProps,
  ...stylePropsTransform,
  // allow a few web only ones
  ... true && {
    // RN doesn't support specific border styles per-edge
    borderBottomStyle: true,
    borderTopStyle: true,
    borderLeftStyle: true,
    borderRightStyle: true,
    overflowX: true,
    overflowY: true,
    userSelect: true,
    cursor: true,
    contain: true,
    pointerEvents: true,
    boxSizing: true,
    boxShadow: true,
    outlineColor: true,
    outlineStyle: true,
    outlineOffset: true,
    outlineWidth: true
  }
});
const stylePropsTextOnly = Object.freeze({
  color: true,
  fontFamily: true,
  fontSize: true,
  fontStyle: true,
  fontWeight: true,
  letterSpacing: true,
  lineHeight: true,
  textAlign: true,
  textDecorationLine: true,
  textDecorationStyle: true,
  textDecorationColor: true,
  textShadowColor: true,
  textShadowOffset: true,
  textShadowRadius: true,
  textTransform: true,
  // allow some web only ones
  ... true && {
    whiteSpace: true,
    wordWrap: true,
    textOverflow: true,
    textDecorationDistance: true,
    userSelect: true,
    selectable: true,
    cursor: true,
    WebkitLineClamp: true,
    WebkitBoxOrient: true
  }
});
const stylePropsText = Object.freeze({
  ...stylePropsView,
  ...stylePropsTextOnly
});
const stylePropsAll = stylePropsText;
const validPseudoKeys = Object.freeze({
  enterStyle: true,
  exitStyle: true,
  hoverStyle: true,
  pressStyle: true,
  focusStyle: true
});
const validStyles = Object.freeze({
  ...validPseudoKeys,
  ...stylePropsView
});

//# sourceMappingURL=validStyleProps.js.map


/***/ }),

/***/ 73347:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ names; }
/* harmony export */ });
const names = {
  transparent: 0,
  // http://www.w3.org/TR/css3-color/#svg-color
  aliceblue: 4042850303,
  antiquewhite: 4209760255,
  aqua: 16777215,
  aquamarine: 2147472639,
  azure: 4043309055,
  beige: 4126530815,
  bisque: 4293182719,
  black: 255,
  blanchedalmond: 4293643775,
  blue: 65535,
  blueviolet: 2318131967,
  brown: 2771004159,
  burlywood: 3736635391,
  burntsienna: 3934150143,
  cadetblue: 1604231423,
  chartreuse: 2147418367,
  chocolate: 3530104575,
  coral: 4286533887,
  cornflowerblue: 1687547391,
  cornsilk: 4294499583,
  crimson: 3692313855,
  cyan: 16777215,
  darkblue: 35839,
  darkcyan: 9145343,
  darkgoldenrod: 3095792639,
  darkgray: 2846468607,
  darkgreen: 6553855,
  darkgrey: 2846468607,
  darkkhaki: 3182914559,
  darkmagenta: 2332068863,
  darkolivegreen: 1433087999,
  darkorange: 4287365375,
  darkorchid: 2570243327,
  darkred: 2332033279,
  darksalmon: 3918953215,
  darkseagreen: 2411499519,
  darkslateblue: 1211993087,
  darkslategray: 793726975,
  darkslategrey: 793726975,
  darkturquoise: 13554175,
  darkviolet: 2483082239,
  deeppink: 4279538687,
  deepskyblue: 12582911,
  dimgray: 1768516095,
  dimgrey: 1768516095,
  dodgerblue: 512819199,
  firebrick: 2988581631,
  floralwhite: 4294635775,
  forestgreen: 579543807,
  fuchsia: 4278255615,
  gainsboro: 3705462015,
  ghostwhite: 4177068031,
  gold: 4292280575,
  goldenrod: 3668254975,
  gray: 2155905279,
  green: 8388863,
  greenyellow: 2919182335,
  grey: 2155905279,
  honeydew: 4043305215,
  hotpink: 4285117695,
  indianred: 3445382399,
  indigo: 1258324735,
  ivory: 4294963455,
  khaki: 4041641215,
  lavender: 3873897215,
  lavenderblush: 4293981695,
  lawngreen: 2096890111,
  lemonchiffon: 4294626815,
  lightblue: 2916673279,
  lightcoral: 4034953471,
  lightcyan: 3774873599,
  lightgoldenrodyellow: 4210742015,
  lightgray: 3553874943,
  lightgreen: 2431553791,
  lightgrey: 3553874943,
  lightpink: 4290167295,
  lightsalmon: 4288707327,
  lightseagreen: 548580095,
  lightskyblue: 2278488831,
  lightslategray: 2005441023,
  lightslategrey: 2005441023,
  lightsteelblue: 2965692159,
  lightyellow: 4294959359,
  lime: 16711935,
  limegreen: 852308735,
  linen: 4210091775,
  magenta: 4278255615,
  maroon: 2147483903,
  mediumaquamarine: 1724754687,
  mediumblue: 52735,
  mediumorchid: 3126187007,
  mediumpurple: 2473647103,
  mediumseagreen: 1018393087,
  mediumslateblue: 2070474495,
  mediumspringgreen: 16423679,
  mediumturquoise: 1221709055,
  mediumvioletred: 3340076543,
  midnightblue: 421097727,
  mintcream: 4127193855,
  mistyrose: 4293190143,
  moccasin: 4293178879,
  navajowhite: 4292783615,
  navy: 33023,
  oldlace: 4260751103,
  olive: 2155872511,
  olivedrab: 1804477439,
  orange: 4289003775,
  orangered: 4282712319,
  orchid: 3664828159,
  palegoldenrod: 4008225535,
  palegreen: 2566625535,
  paleturquoise: 2951671551,
  palevioletred: 3681588223,
  papayawhip: 4293907967,
  peachpuff: 4292524543,
  peru: 3448061951,
  pink: 4290825215,
  plum: 3718307327,
  powderblue: 2967529215,
  purple: 2147516671,
  rebeccapurple: 1714657791,
  red: 4278190335,
  rosybrown: 3163525119,
  royalblue: 1097458175,
  saddlebrown: 2336560127,
  salmon: 4202722047,
  sandybrown: 4104413439,
  seagreen: 780883967,
  seashell: 4294307583,
  sienna: 2689740287,
  silver: 3233857791,
  skyblue: 2278484991,
  slateblue: 1784335871,
  slategray: 1887473919,
  slategrey: 1887473919,
  snow: 4294638335,
  springgreen: 16744447,
  steelblue: 1182971135,
  tan: 3535047935,
  teal: 8421631,
  thistle: 3636451583,
  tomato: 4284696575,
  turquoise: 1088475391,
  violet: 4001558271,
  wheat: 4125012991,
  white: 4294967295,
  whitesmoke: 4126537215,
  yellow: 4294902015,
  yellowgreen: 2597139199
};

//# sourceMappingURL=names.native.js.map


/***/ }),

/***/ 26826:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Gy": function() { return /* reexport */ useResponderEvents; }
});

// UNUSED EXPORTS: canUseDOM, getBoundingClientRect, getLowestCommonAncestor, getResponderPaths, hasTargetTouches, hasValidSelection, isPrimaryPointerDown, isSelectionValid, setResponderId

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ./node_modules/@tamagui/react-native-use-responder-events/dist/esm/utils.js
const keyName = "__reactResponderId";
const canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
const getBoundingClientRect = (node) => {
  if (!node)
    return;
  if (node.nodeType !== 1)
    return;
  if (node.getBoundingClientRect) {
    return node.getBoundingClientRect();
  }
};
function getEventPath(domEvent) {
  var _a;
  if (domEvent.type === "selectionchange") {
    const target = (_a = window.getSelection()) == null ? void 0 : _a.anchorNode;
    return composedPathFallback(target);
  } else {
    const path = domEvent.composedPath != null ? domEvent.composedPath() : composedPathFallback(domEvent.target);
    return path;
  }
}
function composedPathFallback(target) {
  const path = [];
  while (target != null && target !== document.body) {
    path.push(target);
    target = target.parentNode;
  }
  return path;
}
function getResponderId(node) {
  if (node != null) {
    return node[keyName];
  }
  return null;
}
function setResponderId(node, id) {
  if (node != null) {
    node[keyName] = id;
  }
}
function getResponderPaths(domEvent) {
  const idPath = [];
  const nodePath = [];
  const eventPath = getEventPath(domEvent);
  for (let i = 0; i < eventPath.length; i++) {
    const node = eventPath[i];
    const id = getResponderId(node);
    if (id != null) {
      idPath.push(id);
      nodePath.push(node);
    }
  }
  return { idPath, nodePath };
}
function getLowestCommonAncestor(pathA, pathB) {
  let pathALength = pathA.length;
  let pathBLength = pathB.length;
  if (
    // If either path is empty
    pathALength === 0 || pathBLength === 0 || // If the last elements aren't the same there can't be a common ancestor
    // that is connected to the responder system
    pathA[pathALength - 1] !== pathB[pathBLength - 1]
  ) {
    return null;
  }
  let itemA = pathA[0];
  let indexA = 0;
  let itemB = pathB[0];
  let indexB = 0;
  if (pathALength - pathBLength > 0) {
    indexA = pathALength - pathBLength;
    itemA = pathA[indexA];
    pathALength = pathBLength;
  }
  if (pathBLength - pathALength > 0) {
    indexB = pathBLength - pathALength;
    itemB = pathB[indexB];
    pathBLength = pathALength;
  }
  let depth = pathALength;
  while (depth--) {
    if (itemA === itemB) {
      return itemA;
    }
    itemA = pathA[indexA++];
    itemB = pathB[indexB++];
  }
  return null;
}
function hasTargetTouches(target, touches) {
  if (!touches || touches.length === 0) {
    return false;
  }
  for (let i = 0; i < touches.length; i++) {
    const node = touches[i].target;
    if (node != null) {
      if (target.contains(node)) {
        return true;
      }
    }
  }
  return false;
}
function hasValidSelection(domEvent) {
  if (domEvent.type === "selectionchange") {
    return isSelectionValid();
  }
  return domEvent.type === "select";
}
function isPrimaryPointerDown(domEvent) {
  const { altKey, button, buttons, ctrlKey, type } = domEvent;
  const isTouch = type === "touchstart" || type === "touchmove";
  const isPrimaryMouseDown = type === "mousedown" && (button === 0 || buttons === 1);
  const isPrimaryMouseMove = type === "mousemove" && buttons === 1;
  const noModifiers = altKey === false && ctrlKey === false;
  if (isTouch || isPrimaryMouseDown && noModifiers || isPrimaryMouseMove && noModifiers) {
    return true;
  }
  return false;
}
function isSelectionValid() {
  const selection = window.getSelection();
  if (!selection)
    return false;
  const string = selection.toString();
  const anchorNode = selection.anchorNode;
  const focusNode = selection.focusNode;
  const isTextNode = anchorNode && anchorNode.nodeType === window.Node.TEXT_NODE || focusNode && focusNode.nodeType === window.Node.TEXT_NODE;
  return string.length >= 1 && string !== "\n" && !!isTextNode;
}

//# sourceMappingURL=utils.js.map

;// CONCATENATED MODULE: ./node_modules/@tamagui/react-native-use-responder-events/dist/esm/createResponderEvent.js

const emptyFunction = () => {
};
const emptyObject = {};
const emptyArray = [];
function normalizeIdentifier(identifier) {
  return identifier > 20 ? identifier % 20 : identifier;
}
function createResponderEvent(domEvent, responderTouchHistoryStore) {
  let rect;
  let propagationWasStopped = false;
  let changedTouches;
  let touches;
  const domEventChangedTouches = domEvent.changedTouches;
  const domEventType = domEvent.type;
  const metaKey = domEvent.metaKey === true;
  const shiftKey = domEvent.shiftKey === true;
  const force = (domEventChangedTouches == null ? void 0 : domEventChangedTouches[0].force) || 0;
  const identifier = normalizeIdentifier((domEventChangedTouches == null ? void 0 : domEventChangedTouches[0].identifier) || 0);
  const clientX = (domEventChangedTouches == null ? void 0 : domEventChangedTouches[0].clientX) || domEvent.clientX;
  const clientY = (domEventChangedTouches == null ? void 0 : domEventChangedTouches[0].clientY) || domEvent.clientY;
  const pageX = (domEventChangedTouches == null ? void 0 : domEventChangedTouches[0].pageX) || domEvent.pageX;
  const pageY = (domEventChangedTouches == null ? void 0 : domEventChangedTouches[0].pageY) || domEvent.pageY;
  const preventDefault = typeof domEvent.preventDefault === "function" ? domEvent.preventDefault.bind(domEvent) : emptyFunction;
  const timestamp = domEvent.timeStamp;
  function normalizeTouches(touches2) {
    return Array.prototype.slice.call(touches2).map((touch) => {
      return {
        force: touch.force,
        identifier: normalizeIdentifier(touch.identifier),
        get locationX() {
          return locationX(touch.clientX);
        },
        get locationY() {
          return locationY(touch.clientY);
        },
        pageX: touch.pageX,
        pageY: touch.pageY,
        target: touch.target,
        timestamp
      };
    });
  }
  if (domEventChangedTouches != null) {
    changedTouches = normalizeTouches(domEventChangedTouches);
    touches = normalizeTouches(domEvent.touches);
  } else {
    const emulatedTouches = [
      {
        force,
        identifier,
        get locationX() {
          return locationX(clientX);
        },
        get locationY() {
          return locationY(clientY);
        },
        pageX,
        pageY,
        target: domEvent.target,
        timestamp
      }
    ];
    changedTouches = emulatedTouches;
    touches = domEventType === "mouseup" || domEventType === "dragstart" ? emptyArray : emulatedTouches;
  }
  const responderEvent = {
    bubbles: true,
    cancelable: true,
    // `currentTarget` is set before dispatch
    currentTarget: null,
    defaultPrevented: domEvent.defaultPrevented,
    dispatchConfig: emptyObject,
    eventPhase: domEvent.eventPhase,
    isDefaultPrevented() {
      return domEvent.defaultPrevented;
    },
    isPropagationStopped() {
      return propagationWasStopped;
    },
    isTrusted: domEvent.isTrusted,
    nativeEvent: {
      altKey: false,
      ctrlKey: false,
      metaKey,
      shiftKey,
      changedTouches,
      force,
      identifier,
      get locationX() {
        return locationX(clientX);
      },
      get locationY() {
        return locationY(clientY);
      },
      pageX,
      pageY,
      target: domEvent.target,
      timestamp,
      touches,
      type: domEventType
    },
    persist: emptyFunction,
    preventDefault,
    stopPropagation() {
      propagationWasStopped = true;
    },
    target: domEvent.target,
    timeStamp: timestamp,
    touchHistory: responderTouchHistoryStore.touchHistory
  };
  function locationX(x) {
    rect = rect || getBoundingClientRect(responderEvent.currentTarget);
    if (rect) {
      return x - rect.left;
    }
  }
  function locationY(y) {
    rect = rect || getBoundingClientRect(responderEvent.currentTarget);
    if (rect) {
      return y - rect.top;
    }
  }
  return responderEvent;
}

//# sourceMappingURL=createResponderEvent.js.map

;// CONCATENATED MODULE: ./node_modules/@tamagui/react-native-use-responder-events/dist/esm/types.js
const BLUR = "blur";
const CONTEXT_MENU = "contextmenu";
const FOCUS_OUT = "focusout";
const MOUSE_DOWN = "mousedown";
const MOUSE_MOVE = "mousemove";
const MOUSE_UP = "mouseup";
const MOUSE_CANCEL = "dragstart";
const TOUCH_START = "touchstart";
const TOUCH_MOVE = "touchmove";
const TOUCH_END = "touchend";
const TOUCH_CANCEL = "touchcancel";
const SCROLL = "scroll";
const SELECT = "select";
const SELECTION_CHANGE = "selectionchange";
function isStartish(eventType) {
  return eventType === TOUCH_START || eventType === MOUSE_DOWN;
}
function isMoveish(eventType) {
  return eventType === TOUCH_MOVE || eventType === MOUSE_MOVE;
}
function isEndish(eventType) {
  return eventType === TOUCH_END || eventType === MOUSE_UP || isCancelish(eventType);
}
function isCancelish(eventType) {
  return eventType === TOUCH_CANCEL || eventType === MOUSE_CANCEL;
}
function isScroll(eventType) {
  return eventType === SCROLL;
}
function isSelectionChange(eventType) {
  return eventType === SELECT || eventType === SELECTION_CHANGE;
}

//# sourceMappingURL=types.js.map

;// CONCATENATED MODULE: ./node_modules/@tamagui/react-native-use-responder-events/dist/esm/ResponderTouchHistoryStore.js

const MAX_TOUCH_BANK = 20;
function timestampForTouch(touch) {
  return touch["timeStamp"] || touch.timestamp;
}
function createTouchRecord(touch) {
  return {
    touchActive: true,
    startPageX: touch.pageX,
    startPageY: touch.pageY,
    startTimeStamp: timestampForTouch(touch),
    currentPageX: touch.pageX,
    currentPageY: touch.pageY,
    currentTimeStamp: timestampForTouch(touch),
    previousPageX: touch.pageX,
    previousPageY: touch.pageY,
    previousTimeStamp: timestampForTouch(touch)
  };
}
function resetTouchRecord(touchRecord, touch) {
  touchRecord.touchActive = true;
  touchRecord.startPageX = touch.pageX;
  touchRecord.startPageY = touch.pageY;
  touchRecord.startTimeStamp = timestampForTouch(touch);
  touchRecord.currentPageX = touch.pageX;
  touchRecord.currentPageY = touch.pageY;
  touchRecord.currentTimeStamp = timestampForTouch(touch);
  touchRecord.previousPageX = touch.pageX;
  touchRecord.previousPageY = touch.pageY;
  touchRecord.previousTimeStamp = timestampForTouch(touch);
}
function getTouchIdentifier({ identifier }) {
  if (identifier == null) {
    console.error("Touch object is missing identifier.");
  }
  if (false) {}
  return identifier;
}
function recordTouchStart(touch, touchHistory) {
  const identifier = getTouchIdentifier(touch);
  const touchRecord = touchHistory.touchBank[identifier];
  if (touchRecord) {
    resetTouchRecord(touchRecord, touch);
  } else {
    touchHistory.touchBank[identifier] = createTouchRecord(touch);
  }
  touchHistory.mostRecentTimeStamp = timestampForTouch(touch);
}
function recordTouchMove(touch, touchHistory) {
  const touchRecord = touchHistory.touchBank[getTouchIdentifier(touch)];
  if (touchRecord) {
    touchRecord.touchActive = true;
    touchRecord.previousPageX = touchRecord.currentPageX;
    touchRecord.previousPageY = touchRecord.currentPageY;
    touchRecord.previousTimeStamp = touchRecord.currentTimeStamp;
    touchRecord.currentPageX = touch.pageX;
    touchRecord.currentPageY = touch.pageY;
    touchRecord.currentTimeStamp = timestampForTouch(touch);
    touchHistory.mostRecentTimeStamp = timestampForTouch(touch);
  } else {
    console.warn(
      "Cannot record touch move without a touch start.\n",
      `Touch Move: ${printTouch(touch)}
`,
      `Touch Bank: ${printTouchBank(touchHistory)}`
    );
  }
}
function recordTouchEnd(touch, touchHistory) {
  const touchRecord = touchHistory.touchBank[getTouchIdentifier(touch)];
  if (touchRecord) {
    touchRecord.touchActive = false;
    touchRecord.previousPageX = touchRecord.currentPageX;
    touchRecord.previousPageY = touchRecord.currentPageY;
    touchRecord.previousTimeStamp = touchRecord.currentTimeStamp;
    touchRecord.currentPageX = touch.pageX;
    touchRecord.currentPageY = touch.pageY;
    touchRecord.currentTimeStamp = timestampForTouch(touch);
    touchHistory.mostRecentTimeStamp = timestampForTouch(touch);
  } else {
    console.warn(
      "Cannot record touch end without a touch start.\n",
      `Touch End: ${printTouch(touch)}
`,
      `Touch Bank: ${printTouchBank(touchHistory)}`
    );
  }
}
function printTouch(touch) {
  return JSON.stringify({
    identifier: touch.identifier,
    pageX: touch.pageX,
    pageY: touch.pageY,
    timestamp: timestampForTouch(touch)
  });
}
function printTouchBank(touchHistory) {
  const { touchBank } = touchHistory;
  let printed = JSON.stringify(touchBank.slice(0, MAX_TOUCH_BANK));
  if (touchBank.length > MAX_TOUCH_BANK) {
    printed += ` (original size: ${touchBank.length})`;
  }
  return printed;
}
class ResponderTouchHistoryStore {
  constructor() {
    this._touchHistory = {
      touchBank: [],
      //Array<TouchRecord>
      numberActiveTouches: 0,
      // If there is only one active touch, we remember its location. This prevents
      // us having to loop through all of the touches all the time in the most
      // common case.
      indexOfSingleActiveTouch: -1,
      mostRecentTimeStamp: 0
    };
  }
  recordTouchTrack(topLevelType, nativeEvent) {
    const touchHistory = this._touchHistory;
    if (isMoveish(topLevelType)) {
      nativeEvent.changedTouches.forEach(
        (touch) => recordTouchMove(touch, touchHistory)
      );
    } else if (isStartish(topLevelType)) {
      nativeEvent.changedTouches.forEach(
        (touch) => recordTouchStart(touch, touchHistory)
      );
      touchHistory.numberActiveTouches = nativeEvent.touches.length;
      if (touchHistory.numberActiveTouches === 1) {
        touchHistory.indexOfSingleActiveTouch = nativeEvent.touches[0].identifier;
      }
    } else if (isEndish(topLevelType)) {
      nativeEvent.changedTouches.forEach(
        (touch) => recordTouchEnd(touch, touchHistory)
      );
      touchHistory.numberActiveTouches = nativeEvent.touches.length;
      if (touchHistory.numberActiveTouches === 1) {
        const { touchBank } = touchHistory;
        for (let i = 0; i < touchBank.length; i++) {
          const touchTrackToCheck = touchBank[i];
          if (touchTrackToCheck == null ? void 0 : touchTrackToCheck.touchActive) {
            touchHistory.indexOfSingleActiveTouch = i;
            break;
          }
        }
        if (false) {}
      }
    }
  }
  get touchHistory() {
    return this._touchHistory;
  }
}

//# sourceMappingURL=ResponderTouchHistoryStore.js.map

;// CONCATENATED MODULE: ./node_modules/@tamagui/react-native-use-responder-events/dist/esm/ResponderSystem.js





const ResponderSystem_emptyObject = {};
const startRegistration = [
  "onStartShouldSetResponderCapture",
  "onStartShouldSetResponder",
  { bubbles: true }
];
const moveRegistration = [
  "onMoveShouldSetResponderCapture",
  "onMoveShouldSetResponder",
  { bubbles: true }
];
const scrollRegistration = [
  "onScrollShouldSetResponderCapture",
  "onScrollShouldSetResponder",
  { bubbles: false }
];
const shouldSetResponderEvents = {
  touchstart: startRegistration,
  mousedown: startRegistration,
  touchmove: moveRegistration,
  mousemove: moveRegistration,
  scroll: scrollRegistration
};
const emptyResponder = { id: null, idPath: null, node: null };
const responderListenersMap = /* @__PURE__ */ new Map();
let isEmulatingMouseEvents = false;
let trackedTouchCount = 0;
let currentResponder = {
  id: null,
  node: null,
  idPath: null
};
const responderTouchHistoryStore = new ResponderTouchHistoryStore();
function changeCurrentResponder(responder) {
  currentResponder = responder;
}
function getResponderConfig(id) {
  const config = responderListenersMap.get(id);
  return config != null ? config : ResponderSystem_emptyObject;
}
function eventListener(domEvent) {
  const eventType = domEvent.type;
  const eventTarget = domEvent.target;
  if (eventType === "touchstart") {
    isEmulatingMouseEvents = true;
  }
  if (eventType === "touchmove" || trackedTouchCount > 1) {
    isEmulatingMouseEvents = false;
  }
  if (
    // Ignore browser emulated mouse events
    eventType === "mousedown" && isEmulatingMouseEvents || eventType === "mousemove" && isEmulatingMouseEvents || // Ignore mousemove if a mousedown didn't occur first
    eventType === "mousemove" && trackedTouchCount < 1
  ) {
    return;
  }
  if (isEmulatingMouseEvents && eventType === "mouseup") {
    if (trackedTouchCount === 0) {
      isEmulatingMouseEvents = false;
    }
    return;
  }
  const isStartEvent = isStartish(eventType) && isPrimaryPointerDown(domEvent);
  const isMoveEvent = isMoveish(eventType);
  const isEndEvent = isEndish(eventType);
  const isScrollEvent = isScroll(eventType);
  const isSelectionChangeEvent = isSelectionChange(eventType);
  const responderEvent = createResponderEvent(domEvent, responderTouchHistoryStore);
  if (isStartEvent || isMoveEvent || isEndEvent) {
    if (domEvent.touches) {
      trackedTouchCount = domEvent.touches.length;
    } else {
      if (isStartEvent) {
        trackedTouchCount = 1;
      } else if (isEndEvent) {
        trackedTouchCount = 0;
      }
    }
    responderTouchHistoryStore.recordTouchTrack(
      eventType,
      responderEvent.nativeEvent
    );
  }
  let eventPaths = getResponderPaths(domEvent);
  let wasNegotiated = false;
  let wantsResponder;
  if (isStartEvent || isMoveEvent || isScrollEvent && trackedTouchCount > 0) {
    const currentResponderIdPath = currentResponder.idPath;
    const eventIdPath = eventPaths.idPath;
    if (currentResponderIdPath != null && eventIdPath != null) {
      const lowestCommonAncestor = getLowestCommonAncestor(
        currentResponderIdPath,
        eventIdPath
      );
      if (lowestCommonAncestor != null) {
        const indexOfLowestCommonAncestor = eventIdPath.indexOf(lowestCommonAncestor);
        const index = indexOfLowestCommonAncestor + (lowestCommonAncestor === currentResponder.id ? 1 : 0);
        eventPaths = {
          idPath: eventIdPath.slice(index),
          nodePath: eventPaths.nodePath.slice(index)
        };
      } else {
        eventPaths = null;
      }
    }
    if (eventPaths != null) {
      wantsResponder = findWantsResponder(eventPaths, domEvent, responderEvent);
      if (wantsResponder != null) {
        attemptTransfer(responderEvent, wantsResponder);
        wasNegotiated = true;
      }
    }
  }
  if (currentResponder.id != null && currentResponder.node != null) {
    const { id, node } = currentResponder;
    const {
      onResponderStart,
      onResponderMove,
      onResponderEnd,
      onResponderRelease,
      onResponderTerminate,
      onResponderTerminationRequest
    } = getResponderConfig(id);
    responderEvent.bubbles = false;
    responderEvent.cancelable = false;
    responderEvent.currentTarget = node;
    if (isStartEvent) {
      if (onResponderStart != null) {
        responderEvent.dispatchConfig.registrationName = "onResponderStart";
        onResponderStart(responderEvent);
      }
    } else if (isMoveEvent) {
      if (onResponderMove != null) {
        responderEvent.dispatchConfig.registrationName = "onResponderMove";
        onResponderMove(responderEvent);
      }
    } else {
      const isTerminateEvent = isCancelish(eventType) || // native context menu
      eventType === "contextmenu" || // window blur
      eventType === "blur" && eventTarget === window || // responder (or ancestors) blur
      eventType === "blur" && eventTarget.contains(node) && domEvent.relatedTarget !== node || // native scroll without using a pointer
      isScrollEvent && trackedTouchCount === 0 || // native scroll on node that is parent of the responder (allow siblings to scroll)
      isScrollEvent && eventTarget.contains(node) && eventTarget !== node || // native select/selectionchange on node
      isSelectionChangeEvent && hasValidSelection(domEvent);
      const isReleaseEvent = isEndEvent && !isTerminateEvent && !hasTargetTouches(node, domEvent.touches);
      if (isEndEvent) {
        if (onResponderEnd != null) {
          responderEvent.dispatchConfig.registrationName = "onResponderEnd";
          onResponderEnd(responderEvent);
        }
      }
      if (isReleaseEvent) {
        if (onResponderRelease != null) {
          responderEvent.dispatchConfig.registrationName = "onResponderRelease";
          onResponderRelease(responderEvent);
        }
        changeCurrentResponder(emptyResponder);
      }
      if (isTerminateEvent) {
        let shouldTerminate = true;
        if (eventType === "contextmenu" || eventType === "scroll" || eventType === "selectionchange") {
          if (wasNegotiated) {
            shouldTerminate = false;
          } else if (onResponderTerminationRequest != null) {
            responderEvent.dispatchConfig.registrationName = "onResponderTerminationRequest";
            if (onResponderTerminationRequest(responderEvent) === false) {
              shouldTerminate = false;
            }
          }
        }
        if (shouldTerminate) {
          if (onResponderTerminate != null) {
            responderEvent.dispatchConfig.registrationName = "onResponderTerminate";
            onResponderTerminate(responderEvent);
          }
          changeCurrentResponder(emptyResponder);
          isEmulatingMouseEvents = false;
          trackedTouchCount = 0;
        }
      }
    }
  }
}
function findWantsResponder(eventPaths, domEvent, responderEvent) {
  const shouldSetCallbacks = shouldSetResponderEvents[domEvent.type];
  if (shouldSetCallbacks != null) {
    const { idPath, nodePath } = eventPaths;
    const shouldSetCallbackCaptureName = shouldSetCallbacks[0];
    const shouldSetCallbackBubbleName = shouldSetCallbacks[1];
    const { bubbles } = shouldSetCallbacks[2];
    const check = function(id, node, callbackName) {
      const config = getResponderConfig(id);
      const shouldSetCallback = config[callbackName];
      if (shouldSetCallback != null) {
        responderEvent.currentTarget = node;
        if (shouldSetCallback(responderEvent) === true) {
          const prunedIdPath = idPath.slice(idPath.indexOf(id));
          return { id, node, idPath: prunedIdPath };
        }
      }
    };
    for (let i = idPath.length - 1; i >= 0; i--) {
      const id = idPath[i];
      const node = nodePath[i];
      const result = check(id, node, shouldSetCallbackCaptureName);
      if (result != null) {
        return result;
      }
      if (responderEvent.isPropagationStopped() === true) {
        return;
      }
    }
    if (bubbles) {
      for (let i = 0; i < idPath.length; i++) {
        const id = idPath[i];
        const node = nodePath[i];
        const result = check(id, node, shouldSetCallbackBubbleName);
        if (result != null) {
          return result;
        }
        if (responderEvent.isPropagationStopped() === true) {
          return;
        }
      }
    } else {
      const id = idPath[0];
      const node = nodePath[0];
      const target = domEvent.target;
      if (target === node) {
        return check(id, node, shouldSetCallbackBubbleName);
      }
    }
  }
}
function attemptTransfer(responderEvent, wantsResponder) {
  const { id: currentId, node: currentNode } = currentResponder;
  const { id, node } = wantsResponder;
  const { onResponderGrant, onResponderReject } = getResponderConfig(id);
  responderEvent.bubbles = false;
  responderEvent.cancelable = false;
  responderEvent.currentTarget = node;
  if (currentId == null) {
    if (onResponderGrant != null) {
      responderEvent.currentTarget = node;
      responderEvent.dispatchConfig.registrationName = "onResponderGrant";
      onResponderGrant(responderEvent);
    }
    changeCurrentResponder(wantsResponder);
  } else {
    const { onResponderTerminate, onResponderTerminationRequest } = getResponderConfig(currentId);
    let allowTransfer = true;
    if (onResponderTerminationRequest != null) {
      responderEvent.currentTarget = currentNode;
      responderEvent.dispatchConfig.registrationName = "onResponderTerminationRequest";
      if (onResponderTerminationRequest(responderEvent) === false) {
        allowTransfer = false;
      }
    }
    if (allowTransfer) {
      if (onResponderTerminate != null) {
        responderEvent.currentTarget = currentNode;
        responderEvent.dispatchConfig.registrationName = "onResponderTerminate";
        onResponderTerminate(responderEvent);
      }
      if (onResponderGrant != null) {
        responderEvent.currentTarget = node;
        responderEvent.dispatchConfig.registrationName = "onResponderGrant";
        onResponderGrant(responderEvent);
      }
      changeCurrentResponder(wantsResponder);
    } else {
      if (onResponderReject != null) {
        responderEvent.currentTarget = node;
        responderEvent.dispatchConfig.registrationName = "onResponderReject";
        onResponderReject(responderEvent);
      }
    }
  }
}
const documentEventsCapturePhase = ["blur", "scroll"];
const documentEventsBubblePhase = [
  // mouse
  "mousedown",
  "mousemove",
  "mouseup",
  "dragstart",
  // touch
  "touchstart",
  "touchmove",
  "touchend",
  "touchcancel",
  // other
  "contextmenu",
  "select",
  "selectionchange"
];
const isTamaguiResponderActive = Symbol();
function attachListeners() {
  if (canUseDOM && !window[isTamaguiResponderActive]) {
    window.addEventListener("blur", eventListener);
    documentEventsBubblePhase.forEach((eventType) => {
      document.addEventListener(eventType, eventListener);
    });
    documentEventsCapturePhase.forEach((eventType) => {
      document.addEventListener(eventType, eventListener, true);
    });
    window[isTamaguiResponderActive] = true;
  }
}
function addNode(id, node, config) {
  setResponderId(node, id);
  responderListenersMap.set(id, config);
}
function removeNode(id) {
  if (currentResponder.id === id) {
    terminateResponder();
  }
  if (responderListenersMap.has(id)) {
    responderListenersMap.delete(id);
  }
}
function terminateResponder() {
  const { id, node } = currentResponder;
  if (id != null && node != null) {
    const { onResponderTerminate } = getResponderConfig(id);
    if (onResponderTerminate != null) {
      const event = createResponderEvent({}, responderTouchHistoryStore);
      event.currentTarget = node;
      onResponderTerminate(event);
    }
    changeCurrentResponder(emptyResponder);
  }
  isEmulatingMouseEvents = false;
  trackedTouchCount = 0;
}
function getResponderNode() {
  return currentResponder.node;
}

//# sourceMappingURL=ResponderSystem.js.map

;// CONCATENATED MODULE: ./node_modules/@tamagui/react-native-use-responder-events/dist/esm/useResponderEvents.js



const useResponderEvents_emptyObject = {};
function useResponderEvents(hostRef, config = useResponderEvents_emptyObject) {
  const id = react.useId();
  const isAttachedRef = react.useRef(false);
  react.useEffect(() => {
    attachListeners();
    return () => {
      removeNode(id);
    };
  }, [id]);
  react.useEffect(() => {
    const {
      onMoveShouldSetResponder,
      onMoveShouldSetResponderCapture,
      onScrollShouldSetResponder,
      onScrollShouldSetResponderCapture,
      onSelectionChangeShouldSetResponder,
      onSelectionChangeShouldSetResponderCapture,
      onStartShouldSetResponder,
      onStartShouldSetResponderCapture
    } = config;
    const requiresResponderSystem = onMoveShouldSetResponder != null || onMoveShouldSetResponderCapture != null || onScrollShouldSetResponder != null || onScrollShouldSetResponderCapture != null || onSelectionChangeShouldSetResponder != null || onSelectionChangeShouldSetResponderCapture != null || onStartShouldSetResponder != null || onStartShouldSetResponderCapture != null;
    const node = hostRef.current;
    if (requiresResponderSystem) {
      addNode(id, node, config);
      isAttachedRef.current = true;
    } else if (isAttachedRef.current) {
      removeNode(id);
      isAttachedRef.current = false;
    }
  }, [config, hostRef, id]);
  if (false) {}
}

//# sourceMappingURL=useResponderEvents.js.map

;// CONCATENATED MODULE: ./node_modules/@tamagui/react-native-use-responder-events/dist/esm/index.js

//# sourceMappingURL=index.js.map


/***/ }),

/***/ 14709:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ simpleHash; },
/* harmony export */   "z": function() { return /* binding */ isValidCSSCharCode; }
/* harmony export */ });
const simpleHash = (str, hashMin = 10) => {
  let hash = 0;
  let valids = "";
  const len = str.length;
  for (let i = 0; i < len; i++) {
    const char = str.charCodeAt(i);
    if (isValidCSSCharCode(char) && len <= hashMin) {
      valids += str[i];
    } else {
      hash = (hash << 5) - hash + char;
      hash &= hash;
    }
  }
  return valids + (hash ? new Uint32Array([hash])[0].toString(36) : "");
};
function isValidCSSCharCode(code) {
  return (
    // A-Z
    code >= 65 && code <= 90 || // a-z
    code >= 97 && code <= 122 || // _
    code === 95 || // -
    code === 45 || // 0-9
    code >= 48 && code <= 57
  );
}

//# sourceMappingURL=index.js.map


/***/ }),

/***/ 43635:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ useDidFinishSSR; }
/* harmony export */ });
/* harmony import */ var _tamagui_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11649);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);


function useDidFinishSSR() {
  if (_tamagui_constants__WEBPACK_IMPORTED_MODULE_0__/* .isServer */ .sk || _tamagui_constants__WEBPACK_IMPORTED_MODULE_0__/* .isRSC */ .PS) {
    return false;
  }
  const [did, setDid] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
  (0,_tamagui_constants__WEBPACK_IMPORTED_MODULE_0__/* .useIsomorphicLayoutEffect */ .LI)(() => {
    (0,react__WEBPACK_IMPORTED_MODULE_1__.startTransition)(() => {
      setDid(true);
    });
  }, []);
  return did;
}

//# sourceMappingURL=index.js.map


/***/ }),

/***/ 68709:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CW": function() { return /* binding */ getValueFromIdentifier; },
/* harmony export */   "eH": function() { return /* binding */ setIdentifierValue; },
/* harmony export */   "jS": function() { return /* binding */ Tamagui; }
/* harmony export */ });
/* harmony import */ var _tamagui_helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95591);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47269);
/* harmony import */ var _helpers_insertStyleRule_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16746);
/* harmony import */ var _hooks_useMedia_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5755);




class TamaguiManager {
  constructor() {
    this.Helpers = _tamagui_helpers__WEBPACK_IMPORTED_MODULE_0__;
  }
  get mediaState() {
    return { ..._hooks_useMedia_js__WEBPACK_IMPORTED_MODULE_1__/* .mediaState */ .nA };
  }
  get config() {
    return (0,_config_js__WEBPACK_IMPORTED_MODULE_2__/* .getConfig */ .iE)();
  }
  get insertedRules() {
    return (0,_helpers_insertStyleRule_js__WEBPACK_IMPORTED_MODULE_3__/* .getAllRules */ .UY)();
  }
  get allSelectors() {
    return (0,_helpers_insertStyleRule_js__WEBPACK_IMPORTED_MODULE_3__/* .getAllSelectors */ .tN)();
  }
  get allTransforms() {
    return (0,_helpers_insertStyleRule_js__WEBPACK_IMPORTED_MODULE_3__/* .getAllTransforms */ .lj)();
  }
  get identifierToValue() {
    return identifierToValue;
  }
}
const Tamagui = new TamaguiManager();
const identifierToValue = /* @__PURE__ */ new Map();
const getValueFromIdentifier = (identifier) => {
  return identifierToValue.get(identifier);
};
const setIdentifierValue = (identifier, value) => {
  identifierToValue.set(identifier, value);
};

//# sourceMappingURL=Tamagui.js.map


/***/ }),

/***/ 38226:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ addTheme; }
/* harmony export */ });
/* harmony import */ var _tamagui_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11649);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47269);
/* harmony import */ var _helpers_getThemeCSSRules__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54024);
/* harmony import */ var _helpers_themes_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13027);




function addTheme(props) {
  var _a;
  const config = (0,_config_js__WEBPACK_IMPORTED_MODULE_1__/* .getConfig */ .iE)();
  if (false) {}
  const { name: themeName, theme: themeIn, insertCSS } = props;
  const theme = { ...themeIn };
  for (const key in theme) {
    (0,_helpers_themes_js__WEBPACK_IMPORTED_MODULE_2__/* .ensureThemeVariable */ .n)(theme, key);
  }
  const themeProxied = (0,_helpers_themes_js__WEBPACK_IMPORTED_MODULE_2__/* .proxyThemeToParents */ .k)(themeName, theme, config.themes);
  config.themes[themeName] = themeProxied;
  let cssRules = [];
  if (_tamagui_constants__WEBPACK_IMPORTED_MODULE_0__/* .isWeb */ .$L) {
    if (insertCSS) {
      cssRules = (0,_helpers_getThemeCSSRules__WEBPACK_IMPORTED_MODULE_3__/* .getThemeCSSRules */ .Q)({
        // @ts-ignore this works but should be fixed types
        config,
        themeName,
        names: [themeName],
        theme
      });
      const id = `t_theme_style_${themeName}`;
      const existing = document.querySelector(`#${id}`);
      const style = document.createElement("style");
      style.id = id;
      style.appendChild(document.createTextNode(cssRules.join("\n")));
      document.head.appendChild(style);
      if (existing) {
        (_a = existing.parentElement) == null ? void 0 : _a.removeChild(existing);
      }
    }
  }
  (0,_config_js__WEBPACK_IMPORTED_MODULE_1__/* .updateConfig */ .rF)("themes", { ...config.themes, [themeName]: themeProxied });
  return {
    theme: themeProxied,
    cssRules
  };
}

//# sourceMappingURL=addTheme.js.map


/***/ }),

/***/ 47269:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RC": function() { return /* binding */ getThemes; },
/* harmony export */   "iE": function() { return /* binding */ getConfig; },
/* harmony export */   "lI": function() { return /* binding */ setConfigFont; },
/* harmony export */   "lz": function() { return /* binding */ getTokens; },
/* harmony export */   "rF": function() { return /* binding */ updateConfig; },
/* harmony export */   "v6": function() { return /* binding */ setConfig; },
/* harmony export */   "xC": function() { return /* binding */ onConfiguredOnce; },
/* harmony export */   "zG": function() { return /* binding */ configListeners; }
/* harmony export */ });
/* unused harmony exports getFont, useTokens */
let conf;
const setConfig = (next) => {
  conf = next;
  configListeners.forEach((cb) => cb(next));
};
const setConfigFont = (name, font, fontParsed) => {
  if (false) {}
  conf.fonts[name] = font;
  conf.fontsParsed[`$${name}`] = fontParsed;
};
const getConfig = () => {
  if (!conf) {
    throw new Error(
       false ? 0 : "Err0"
    );
  }
  return conf;
};
let cached;
const getTokens = ({
  prefixed
} = {}) => {
  if (!conf)
    throw new Error(`never called createTamagui`);
  if (prefixed === false)
    return conf.tokens;
  if (prefixed === true)
    return conf.tokensParsed;
  return cached ??= Object.freeze({
    size: {
      ...conf.tokens["size"],
      ...conf.tokensParsed["size"]
    },
    space: {
      ...conf.tokens["space"],
      ...conf.tokensParsed["space"]
    },
    radius: {
      ...conf.tokens["radius"],
      ...conf.tokensParsed["radius"]
    },
    zIndex: {
      ...conf.tokens["zIndex"],
      ...conf.tokensParsed["zIndex"]
    },
    color: {
      ...conf.tokens["color"],
      ...conf.tokensParsed["color"]
    }
  });
};
const useTokens = () => getTokens();
const getThemes = () => conf.themes;
const configListeners = /* @__PURE__ */ new Set();
const onConfiguredOnce = (cb) => {
  if (conf) {
    cb(conf);
  } else {
    configListeners.add(cb);
  }
};
const updateConfig = (key, value) => {
  Object.assign(key, value);
};
const getFont = (name) => {
  var _a;
  const conf2 = getConfig();
  return conf2.fontsParsed[name] ?? ((_a = Object.entries(conf2.fontsParsed).find(
    ([k]) => {
      var _a2, _b;
      return ((_b = (_a2 = conf2.fontsParsed[k]) == null ? void 0 : _a2.family) == null ? void 0 : _b["val"]) === name;
    }
  )) == null ? void 0 : _a[1]);
};

//# sourceMappingURL=config.js.map


/***/ }),

/***/ 74288:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F2": function() { return /* binding */ webOnlyDefaultStyles; },
/* harmony export */   "L2": function() { return /* binding */ THEME_NAME_SEPARATOR; },
/* harmony export */   "nx": function() { return /* binding */ THEME_CLASSNAME_PREFIX; },
/* harmony export */   "tn": function() { return /* binding */ stackDefaultStyles; }
/* harmony export */ });
const THEME_NAME_SEPARATOR = "_";
const THEME_CLASSNAME_PREFIX = "t_";
const webOnlyDefaultStyles = {
  display: "flex",
  flexBasis: "auto",
  boxSizing: "border-box",
  position: "relative",
  minHeight: 0,
  minWidth: 0
};
const stackDefaultStyles = {
  alignItems: "stretch",
  flexShrink: 0,
  ...webOnlyDefaultStyles
};

//# sourceMappingURL=constants.js.map


/***/ }),

/***/ 19924:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ ButtonNestingContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

const ButtonNestingContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(false);

//# sourceMappingURL=ButtonNestingContext.js.map


/***/ }),

/***/ 38839:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ FontLanguageContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

const FontLanguageContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);

//# sourceMappingURL=FontLanguageContext.js.map


/***/ }),

/***/ 67364:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ TextAncestorContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

const TextAncestorContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(false);

//# sourceMappingURL=TextAncestorContext.js.map


/***/ }),

/***/ 6905:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "LZ": function() { return /* binding */ Spacer; },
  "GJ": function() { return /* binding */ Unspaced; },
  "LM": function() { return /* binding */ createComponent; },
  "Lb": function() { return /* binding */ defaultComponentState; },
  "s0": function() { return /* binding */ mouseUps; },
  "P9": function() { return /* binding */ spacedChildren; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./node_modules/@tamagui/compose-refs/dist/esm/compose-refs.js
var compose_refs = __webpack_require__(4429);
// EXTERNAL MODULE: ./node_modules/@tamagui/constants/dist/esm/index.mjs
var esm = __webpack_require__(11649);
// EXTERNAL MODULE: ./node_modules/@tamagui/helpers/dist/esm/index.mjs
var dist_esm = __webpack_require__(95591);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./node_modules/@tamagui/web/dist/esm/config.js
var config = __webpack_require__(47269);
// EXTERNAL MODULE: ./node_modules/@tamagui/web/dist/esm/constants/constants.js
var constants = __webpack_require__(74288);
// EXTERNAL MODULE: ./node_modules/@tamagui/web/dist/esm/contexts/FontLanguageContext.js
var FontLanguageContext = __webpack_require__(38839);
// EXTERNAL MODULE: ./node_modules/@tamagui/web/dist/esm/contexts/TextAncestorContext.js
var TextAncestorContext = __webpack_require__(67364);
// EXTERNAL MODULE: ./node_modules/@tamagui/web/dist/esm/createVariable.js
var createVariable = __webpack_require__(13209);
// EXTERNAL MODULE: ./node_modules/@tamagui/web/dist/esm/helpers/createPropMapper.js + 1 modules
var createPropMapper = __webpack_require__(37323);
// EXTERNAL MODULE: ./node_modules/@tamagui/web/dist/esm/helpers/mergeProps.js
var mergeProps = __webpack_require__(88410);
;// CONCATENATED MODULE: ./node_modules/@tamagui/web/dist/esm/helpers/extendStaticConfig.js



function extendStaticConfig(config, parent) {
  if (!(parent && "staticConfig" in parent)) {
    return parseStaticConfig(config);
  }
  const parentStaticConf = parent.staticConfig;
  const variants = {
    ...parentStaticConf.variants
  };
  if (config.variants) {
    for (const key in config.variants) {
      if (variants[key]) {
        variants[key] = {
          ...variants[key],
          ...config.variants[key]
        };
      } else {
        variants[key] = config.variants[key];
      }
    }
  }
  const parentNames = [...parentStaticConf.parentNames || []];
  if (parentStaticConf.componentName) {
    parentNames.push(parentStaticConf.componentName);
  }
  const deoptProps = config.deoptProps || /* @__PURE__ */ new Set();
  return parseStaticConfig({
    ...parentStaticConf,
    ...config,
    deoptProps,
    variants,
    parentNames,
    validStyles: config.validStyles ? {
      ...parentStaticConf.validStyles,
      ...config.validStyles
    } : parentStaticConf.validStyles || dist_esm.stylePropsView,
    defaultProps: (0,mergeProps/* mergeProps */.d)(
      {
        ...parentStaticConf.defaultProps,
        ...parentStaticConf.defaultVariants
      },
      {
        ...config.defaultProps,
        ...config.defaultVariants
      }
    )[0]
  });
}
const parseStaticConfig = (config) => {
  const parsed = {
    defaultProps: {},
    ...config,
    parsed: true
  };
  return {
    ...parsed,
    propMapper: (0,createPropMapper/* createPropMapper */.qq)(parsed)
  };
};

//# sourceMappingURL=extendStaticConfig.js.map

// EXTERNAL MODULE: ./node_modules/@tamagui/web/dist/esm/helpers/getSplitStyles.js + 1 modules
var getSplitStyles = __webpack_require__(49678);
// EXTERNAL MODULE: ./node_modules/@tamagui/web/dist/esm/helpers/proxyThemeVariables.js
var proxyThemeVariables = __webpack_require__(8503);
// EXTERNAL MODULE: ./node_modules/@tamagui/web/dist/esm/helpers/useShallowSetState.js
var useShallowSetState = __webpack_require__(1493);
// EXTERNAL MODULE: ./node_modules/@tamagui/web/dist/esm/hooks/useMedia.js
var useMedia = __webpack_require__(5755);
// EXTERNAL MODULE: ./node_modules/@tamagui/web/dist/esm/hooks/useServerHooks.js
var useServerHooks = __webpack_require__(24579);
// EXTERNAL MODULE: ./node_modules/@tamagui/web/dist/esm/hooks/useTheme.js + 1 modules
var useTheme = __webpack_require__(39107);
// EXTERNAL MODULE: ./node_modules/@tamagui/web/dist/esm/setupHooks.js
var setupHooks = __webpack_require__(46713);
// EXTERNAL MODULE: ./node_modules/@tamagui/web/dist/esm/views/Slot.js
var Slot = __webpack_require__(84367);
// EXTERNAL MODULE: ./node_modules/@tamagui/web/dist/esm/views/Theme.js
var Theme = __webpack_require__(56283);
;// CONCATENATED MODULE: ./node_modules/@tamagui/web/dist/esm/createComponent.js






















"web";
const defaultComponentState = {
  hover: false,
  press: false,
  pressIn: false,
  focus: false,
  unmounted: true
};
const defaultComponentStateMounted = {
  ...defaultComponentState,
  unmounted: false
};
let tamaguiConfig;
let AnimatedText;
let AnimatedView;
let initialTheme;
const mouseUps = /* @__PURE__ */ new Set();
if (typeof document !== "undefined") {
  const cancelTouches = () => {
    mouseUps.forEach((x) => x());
    mouseUps.clear();
  };
  addEventListener("mouseup", cancelTouches);
  addEventListener("touchend", cancelTouches);
  addEventListener("touchcancel", cancelTouches);
}
function mergeShorthands({ defaultProps }, { shorthands }) {
  for (const key of Object.keys(defaultProps)) {
    defaultProps[shorthands[key] || key] = defaultProps[key];
  }
}
let BaseText;
let BaseView;
let hasSetupBaseViews = false;
function createComponent(configIn, ParentComponent) {
  const staticConfig = (() => {
    const next = extendStaticConfig(configIn, ParentComponent);
    if ("parsed" in next) {
      return next;
    } else {
      return parseStaticConfig(next);
    }
  })();
  const defaultComponentClassName = `is_${staticConfig.componentName}`;
  let tamaguiDefaultProps;
  let defaultTag;
  const component = (0,react.forwardRef)((propsIn, forwardedRef) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n;
    if (false) {}
    if (false) {}
    let props;
    if (tamaguiDefaultProps && !propsIn.asChild) {
      props = (0,mergeProps/* mergeProps */.d)(tamaguiDefaultProps, propsIn)[0];
    } else {
      props = propsIn;
    }
    const debugProp = props["debug"];
    const { Component, isText, isZStack } = staticConfig;
    const componentName = props.componentName || staticConfig.componentName;
    const componentClassName = props.asChild ? "" : props.componentName ? `is_${props.componentName}` : defaultComponentClassName;
    const animationsConfig = tamaguiConfig.animations;
    const useAnimations = animationsConfig == null ? void 0 : animationsConfig.useAnimations;
    const avoidClassesWhileAnimating = animationsConfig.isReactNative;
    const hasEnterStyle = !!props.enterStyle;
    const needsMount = Boolean(
      (esm/* isWeb */.$L ? esm/* isClient */.C5 : true) && (hasEnterStyle || props.animation)
    );
    const states = (0,useServerHooks/* useServerState */.V)(
      needsMount ? defaultComponentState : defaultComponentStateMounted
    );
    const state = propsIn.forceStyle ? { ...states[0], [propsIn.forceStyle]: true } : states[0];
    const setState = states[1];
    const setStateShallow = (0,useShallowSetState/* useShallowSetState */.S)(setState, debugProp, componentName);
    const stateRef = (0,react.useRef)(
      void 0
    );
    stateRef.current ??= {};
    const isAnimated = (() => {
      const next = !!(!staticConfig.isHOC && useAnimations && (props.animation || props.style && hasAnimatedStyleValue(props.style)));
      if (next && !stateRef.current.hasAnimated) {
        stateRef.current.hasAnimated = true;
      }
      return next || stateRef.current.hasAnimated;
    })();
    const usePresence = (_c = tamaguiConfig.animations) == null ? void 0 : _c.usePresence;
    const presence = !esm/* isRSC */.PS && isAnimated ? usePresence() : null;
    if (isAnimated && presence) {
      const presenceState = presence[2];
      if (presenceState) {
        if (state.unmounted && presenceState.enterVariant) {
          props[presenceState.enterVariant] = true;
        }
        if (!presenceState.isPresent && presenceState.exitVariant) {
          props[presenceState.exitVariant] = true;
        }
      }
    }
    const isReactNative = Boolean(
      staticConfig.isReactNative || isAnimated && tamaguiConfig.animations.isReactNative
    );
    if (false) {}
    const shouldAvoidClasses = !esm/* isWeb */.$L || !!(props.animation && avoidClassesWhileAnimating) || !staticConfig.acceptsClassName;
    const shouldForcePseudo = !!propsIn.forceStyle;
    const noClassNames = shouldAvoidClasses || shouldForcePseudo;
    const themeState = (0,useTheme/* useThemeWithState */.WU)({
      name: props.theme,
      componentName,
      reset: props.reset,
      inverse: props.themeInverse,
      // @ts-expect-error
      disable: props["data-themeable"],
      debug: props.debug,
      shouldUpdate: () => !!stateRef.current.didAccessThemeVariableValue
    });
    const hasTextAncestor = !!(esm/* isWeb */.$L && isText ? (0,react.useContext)(TextAncestorContext/* TextAncestorContext */.M) : false);
    const languageContext = esm/* isRSC */.PS ? null : (0,react.useContext)(FontLanguageContext/* FontLanguageContext */.H);
    const isDisabled = props.disabled ?? ((_d = props.accessibilityState) == null ? void 0 : _d.disabled);
    const isTaggable = !Component || typeof Component === "string";
    const element = esm/* isWeb */.$L ? isTaggable ? props.tag || defaultTag || Component : Component : Component;
    const BaseTextComponent = BaseText || element || "span";
    const BaseViewComponent = BaseView || element || (hasTextAncestor ? "span" : "div");
    let elementType = isText ? (isAnimated ? AnimatedText : null) || BaseTextComponent : (isAnimated ? AnimatedView : null) || BaseViewComponent;
    elementType = Component || elementType;
    const isStringElement = typeof elementType === "string";
    const isExiting = (presence == null ? void 0 : presence[0]) === false;
    const mediaState = (0,useMedia/* useMedia */.GS)(
      // @ts-ignore, we just pass a stable object so we can get it later with
      // should match to the one used in `setMediaShouldUpdate` below
      stateRef,
      debugProp ? { props, staticConfig } : null
    );
    (0,createVariable/* setDidGetVariableValue */.zY)(false);
    const splitStyles = (0,getSplitStyles/* useSplitStyles */.DP)(
      props,
      staticConfig,
      themeState.theme,
      {
        ...state,
        mediaState,
        noClassNames,
        dynamicStylesInline: noClassNames,
        hasTextAncestor,
        resolveVariablesAs: "auto",
        isExiting
      },
      null,
      languageContext || void 0,
      elementType,
      debugProp
    );
    const isMediaSpaced = Array.isArray(splitStyles.hasMedia);
    const shouldListenForMedia = (0,createVariable/* didGetVariableValue */.yx)() || isMediaSpaced || noClassNames && splitStyles.hasMedia === true;
    (0,useMedia/* setMediaShouldUpdate */.Zv)(stateRef, {
      enabled: shouldListenForMedia,
      keys: noClassNames && isMediaSpaced ? splitStyles.hasMedia : null
    });
    const hostRef = (0,useServerHooks/* useServerRef */.l)(null);
    const isAnimatedReactNativeWeb = isAnimated && avoidClassesWhileAnimating;
    if (false) {}
    const {
      viewProps: viewPropsIn,
      pseudos,
      style: splitStylesStyle,
      classNames,
      space
    } = splitStyles;
    const propsWithAnimation = props;
    let animationStyles;
    if (!esm/* isRSC */.PS && isAnimated && useAnimations && !staticConfig.isHOC) {
      const animations = useAnimations({
        props: propsWithAnimation,
        style: splitStylesStyle,
        presence,
        state,
        pseudos: pseudos || null,
        onDidAnimate: props.onDidAnimate,
        hostRef,
        staticConfig
      });
      if (animations) {
        animationStyles = animations.style;
      }
    }
    const {
      asChild,
      children,
      onPress,
      onPressIn,
      onPressOut,
      onHoverIn,
      onHoverOut,
      themeShallow,
      spaceDirection: _spaceDirection,
      disabled: disabledProp,
      onMouseUp,
      onMouseDown,
      onMouseEnter,
      onMouseLeave,
      separator,
      // ignore from here on out
      forceStyle: _forceStyle,
      // @ts-ignore  for next/link compat etc
      onClick,
      theme: _themeProp,
      // @ts-ignore
      defaultVariants,
      ...nonTamaguiProps
    } = viewPropsIn;
    const disabled = ((_e = props.accessibilityState) == null ? void 0 : _e.disabled) || props.accessibilityDisabled;
    let viewProps = nonTamaguiProps;
    if ( true && !isReactNative && !asChild) {
      viewProps = (_g = (_f = setupHooks/* hooks */.P).usePropsTransform) == null ? void 0 : _g.call(_f, elementType, nonTamaguiProps, hostRef);
    } else {
      viewProps = nonTamaguiProps;
    }
    viewProps.ref = (0,compose_refs/* useComposedRefs */.e)(hostRef, forwardedRef);
    if (false) {}
    const unPress = (0,react.useCallback)(() => {
      setStateShallow({
        press: false,
        pressIn: false
      });
    }, [setStateShallow]);
    if (esm/* isWeb */.$L) {
      (0,react.useEffect)(() => {
        return () => {
          mouseUps.delete(unPress);
        };
      }, []);
    }
    const shouldSetMounted = needsMount && state.unmounted;
    (0,react.useEffect)(() => {
      if (!shouldSetMounted)
        return;
      if (state.unmounted === true && needsMount) {
        setStateShallow({
          unmounted: false
        });
        return;
      }
      setStateShallow({
        unmounted: false
      });
    }, [shouldSetMounted, state.unmounted]);
    let styles;
    if (isStringElement && shouldAvoidClasses && !shouldForcePseudo) {
      styles = {
        ...animationStyles ?? splitStylesStyle
      };
    } else {
      styles = [animationStyles ?? splitStylesStyle];
      if (shouldForcePseudo) {
        const next = {};
        styles.forEach((style) => Object.assign(next, style));
        Object.assign(splitStyles.style, next);
      }
    }
    let fontFamily = isText ? splitStyles.fontFamily || staticConfig.defaultProps.fontFamily : null;
    if (fontFamily && fontFamily[0] === "$") {
      fontFamily = fontFamily.slice(1);
    }
    const fontFamilyClassName = fontFamily ? `font_${fontFamily}` : "";
    const classList = [
      hasEnterStyle && (state.unmounted && needsMount || !esm/* isClient */.C5) ? "t_will-mount" : "",
      componentName ? componentClassName : "",
      fontFamilyClassName,
      classNames ? Object.values(classNames).join(" ") : ""
    ];
    const className = classList.join(" ");
    if (true) {
      const style = animationStyles ?? splitStyles.style;
      if (isAnimatedReactNativeWeb) {
        viewProps.style = style;
      } else if (isReactNative) {
        const cnStyles = { $$css: true };
        for (const name of className.split(" ")) {
          cnStyles[name] = name;
        }
        viewProps.style = [...Array.isArray(style) ? style : [style], cnStyles];
        if (false) {}
      } else {
        viewProps.className = className;
        viewProps.style = style;
      }
    }
    if (false) {}
    const runtimePressStyle = !disabled && noClassNames && (pseudos == null ? void 0 : pseudos.pressStyle);
    const attachPress = Boolean(
      runtimePressStyle || onPress || onPressOut || onPressIn || onClick
    );
    const runtimeHoverStyle = !disabled && noClassNames && (pseudos == null ? void 0 : pseudos.hoverStyle);
    const isHoverable = esm/* isWeb */.$L && !!(runtimeHoverStyle || onHoverIn || onHoverOut || onMouseEnter || onMouseLeave);
    const handlesPressEvents = !(esm/* isWeb */.$L || asChild);
    const shouldAttach = Boolean(
      attachPress || isHoverable || noClassNames && "pressStyle" in props || esm/* isWeb */.$L && noClassNames && "hoverStyle" in props
    );
    const events = shouldAttach && !esm/* isRSC */.PS && !isDisabled && !asChild ? {
      onPressOut: attachPress ? (e) => {
        unPress();
        onPressOut == null ? void 0 : onPressOut(e);
        onMouseUp == null ? void 0 : onMouseUp(e);
      } : void 0,
      ...isHoverable && {
        onMouseEnter: isHoverable ? (e) => {
          const next = {};
          if (isHoverable) {
            next.hover = true;
          }
          if (state.pressIn) {
            next.press = true;
          }
          if (isHoverable || state.pressIn) {
            setStateShallow(next);
          }
          onHoverIn == null ? void 0 : onHoverIn(e);
          onMouseEnter == null ? void 0 : onMouseEnter(e);
        } : void 0,
        onMouseLeave: isHoverable ? (e) => {
          const next = {};
          mouseUps.add(unPress);
          if (isHoverable) {
            next.hover = false;
          }
          if (state.pressIn) {
            next.press = false;
            next.pressIn = false;
          }
          if (Object.keys(next).length) {
            setStateShallow(next);
          }
          onHoverOut == null ? void 0 : onHoverOut(e);
          onMouseLeave == null ? void 0 : onMouseLeave(e);
        } : void 0
      },
      onPressIn: attachPress ? (e) => {
        setStateShallow({
          press: true,
          pressIn: true,
          hover: false
        });
        onPressIn == null ? void 0 : onPressIn(e);
        onMouseDown == null ? void 0 : onMouseDown(e);
        if (esm/* isWeb */.$L) {
          mouseUps.add(unPress);
        }
      } : void 0,
      onPress: attachPress ? (e) => {
        unPress();
        esm/* isWeb */.$L && (onClick == null ? void 0 : onClick(e));
        onPress == null ? void 0 : onPress(e);
      } : void 0
    } : null;
    if (false) {}
    (_l = (_k = setupHooks/* hooks */.P).useEvents) == null ? void 0 : _l.call(_k, viewProps, events, splitStyles, setStateShallow);
    const shouldReset = !!(themeShallow && themeState.isNewTheme);
    if (shouldReset) {
      stateRef.current.themeShallow = true;
    }
    let content = !children || asChild ? children : spacedChildren({
      separator,
      children,
      space,
      direction: props.spaceDirection || "both",
      isZStack,
      debug: debugProp
    });
    if (asChild) {
      elementType = Slot/* Slot */.g7;
      viewProps = {
        ...viewProps,
        onPress,
        onPressIn,
        onPressOut
      };
    }
    content = (0,react.createElement)(elementType, viewProps, content);
    content = (0,Theme/* useThemedChildren */.y)(themeState, content, {
      shallow: stateRef.current.themeShallow
      // passPropsToChildren: true,
    });
    if (true) {
      if (events || isAnimatedReactNativeWeb) {
        content = /* @__PURE__ */ (0,jsx_runtime.jsx)(
          "span",
          {
            className: `${isAnimatedReactNativeWeb ? className : ""}  _dsp_contents`,
            ...events && {
              onMouseEnter: events.onMouseEnter,
              onMouseLeave: events.onMouseLeave,
              onClick: events.onPress,
              onMouseDown: events.onPressIn,
              onMouseUp: events.onPressOut,
              onTouchStart: events.onPressIn,
              onTouchEnd: events.onPressOut
            },
            children: content
          }
        );
      }
    }
    if (false) {}
    return content;
  });
  if (staticConfig.componentName) {
    component.displayName = staticConfig.componentName;
  }
  (0,config/* onConfiguredOnce */.xC)((conf) => {
    if (!tamaguiConfig) {
      tamaguiConfig = conf;
      if (tamaguiConfig.animations) {
        AnimatedText = tamaguiConfig.animations.Text;
        AnimatedView = tamaguiConfig.animations.View;
      }
      if (!initialTheme) {
        const next = conf.themes[Object.keys(conf.themes)[0]];
        initialTheme = (0,proxyThemeVariables/* proxyThemeVariables */.Q)(next);
        if (false) {}
      }
    }
    mergeShorthands(staticConfig, tamaguiConfig);
    let defaultPropsIn = staticConfig.defaultProps || {};
    const parentNames = [...staticConfig.parentNames || [], staticConfig.componentName];
    if (tamaguiConfig.defaultProps && parentNames && staticConfig.componentName) {
      defaultPropsIn = mergeConfigDefaultProps(
        staticConfig.componentName,
        defaultPropsIn,
        tamaguiConfig.defaultProps,
        parentNames,
        tamaguiConfig
      );
    }
    const debug = defaultPropsIn["debug"];
    const [ourProps, ourClassNames] = (0,mergeProps/* mergeProps */.d)(defaultPropsIn, {});
    if (ourProps.tag) {
      defaultTag = ourProps.tag;
    }
    const noClassNames = !staticConfig.acceptsClassName;
    const { name, variants, defaultVariants, ...restProps } = ourProps;
    const [defaults, defaultsClassnames] = (0,mergeProps/* mergeProps */.d)(component.defaultProps, {
      ...defaultVariants,
      ...restProps
    });
    if (!esm/* isWeb */.$L) {
      for (const key in staticConfig.defaultProps) {
        const val = staticConfig.defaultProps[key];
        if (dist_esm.validPseudoKeys[key])
          continue;
        defaults[key] = val;
      }
    }
    tamaguiDefaultProps = defaults;
    if (false) {}
  });
  let res = component;
  if (configIn.memo) {
    res = (0,react.memo)(res);
  }
  res.staticConfig = {
    validStyles: staticConfig.validStyles || dist_esm.stylePropsView,
    ...staticConfig
  };
  res.extractable = (Component, conf) => {
    Component.staticConfig = extendStaticConfig(
      {
        Component,
        ...conf,
        neverFlatten: true,
        isHOC: true,
        defaultProps: {
          ...Component.defaultProps,
          ...conf == null ? void 0 : conf.defaultProps
        }
      },
      res
    );
    return Component;
  };
  return res;
}
const Unspaced = (props) => {
  return props.children;
};
Unspaced["isUnspaced"] = true;
const Spacer = createComponent({
  acceptsClassName: true,
  memo: true,
  componentName: "Spacer",
  validStyles: dist_esm.validStyles,
  defaultProps: {
    ...constants/* stackDefaultStyles */.tn,
    // avoid nesting issues
    tag: "span",
    size: true,
    pointerEvents: "none"
  },
  variants: {
    size: {
      "...size": (size, { tokens }) => {
        size = size === true ? "$true" : size;
        const sizePx = tokens.space[size] ?? size;
        return {
          width: sizePx,
          height: sizePx,
          minWidth: sizePx,
          minHeight: sizePx
        };
      }
    },
    flex: {
      true: {
        flexGrow: 1
      }
    },
    direction: {
      horizontal: {
        height: 0,
        minHeight: 0
      },
      vertical: {
        width: 0,
        minWidth: 0
      },
      both: {}
    }
  }
});
function spacedChildren(props) {
  var _a, _b, _c;
  const { isZStack, children, space, direction, spaceFlex, separator } = props;
  const hasSpace = !!(space || spaceFlex);
  const hasSeparator = !(separator === void 0 || separator === null);
  if (!(hasSpace || hasSeparator || isZStack)) {
    return children;
  }
  const childrenList = react.Children.toArray(children);
  const len = childrenList.length;
  if (len <= 1 && !isZStack && !((_b = (_a = childrenList[0]) == null ? void 0 : _a["type"]) == null ? void 0 : _b["shouldForwardSpace"])) {
    return childrenList;
  }
  const final = [];
  for (let [index, child] of childrenList.entries()) {
    const isEmpty = child === null || child === void 0 || Array.isArray(child) && child.length === 0;
    if (!isEmpty && react.isValidElement(child) && ((_c = child.type) == null ? void 0 : _c["shouldForwardSpace"])) {
      child = react.cloneElement(child, {
        space,
        spaceFlex,
        separator,
        key: child.key
      });
    }
    if (isEmpty || !child || child["key"] && !isZStack) {
      final.push(child);
    } else {
      final.push(
        /* @__PURE__ */ (0,jsx_runtime.jsx)(react.Fragment, { children: isZStack ? /* @__PURE__ */ (0,jsx_runtime.jsx)(AbsoluteFill, { children: child }) : child }, index)
      );
    }
    if (isUnspaced(child) && index === 0)
      continue;
    if (isZStack)
      continue;
    const next = childrenList[index + 1];
    if (next && !isUnspaced(next)) {
      if (separator) {
        if (hasSpace) {
          final.push(
            createSpacer({
              key: `_${index}_00tmgui`,
              direction,
              space,
              spaceFlex
            })
          );
        }
        final.push(
          react.isValidElement(separator) ? react.cloneElement(separator, { key: `sep_${index}` }) : separator
        );
        if (hasSpace) {
          final.push(
            createSpacer({
              key: `_${index}01tmgui`,
              direction,
              space,
              spaceFlex
            })
          );
        }
      } else {
        final.push(
          createSpacer({
            key: `_${index}02tmgui`,
            direction,
            space,
            spaceFlex
          })
        );
      }
    }
  }
  if (false) {}
  return final;
}
function createSpacer({ key, direction, space, spaceFlex }) {
  return /* @__PURE__ */ (0,jsx_runtime.jsx)(
    Spacer,
    {
      size: space,
      direction,
      ...typeof spaceFlex !== "undefined" && {
        flex: spaceFlex === true ? 1 : spaceFlex === false ? 0 : spaceFlex
      }
    },
    key
  );
}
function isUnspaced(child) {
  const t = child == null ? void 0 : child["type"];
  return (t == null ? void 0 : t["isVisuallyHidden"]) || (t == null ? void 0 : t["isUnspaced"]);
}
const DefaultProps = /* @__PURE__ */ new Map();
function mergeConfigDefaultProps(name, props, configDefaults, parentNames, conf) {
  const len = parentNames.length;
  let prev;
  for (let i = 0; i < len; i++) {
    const n = parentNames[i];
    if (!n)
      continue;
    if (DefaultProps.has(n)) {
      prev = DefaultProps.get(n);
      continue;
    }
    const props2 = configDefaults[n];
    if (!props2) {
      if (prev) {
        DefaultProps.set(n, prev);
      }
      continue;
    }
    prev = (0,mergeProps/* mergeProps */.d)(prev || {}, props2, false, conf.inverseShorthands)[0];
    DefaultProps.set(n, prev);
  }
  const ourDefaultsMerged = DefaultProps.get(name);
  if (ourDefaultsMerged) {
    return (0,mergeProps/* mergeProps */.d)(props, ourDefaultsMerged, false, conf.inverseShorthands)[0];
  }
  return props;
}
const AbsoluteFill = createComponent({
  defaultProps: {
    ...constants/* stackDefaultStyles */.tn,
    flexDirection: "column",
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    pointerEvents: "box-none"
  }
});
function hasAnimatedStyleValue(style) {
  return Object.keys(style).some((k) => {
    const val = style[k];
    return val && typeof val === "object" && "_animation" in val;
  });
}

//# sourceMappingURL=createComponent.js.map


/***/ }),

/***/ 47727:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ createFont; }
/* harmony export */ });
const fontWeights = [
  "100",
  "200",
  "300",
  "400",
  "500",
  "600",
  "700",
  "800",
  "900"
];
const processSection = (section, keys, defaultValue) => {
  if (typeof section === "string")
    return section;
  const sectionKeys = Object.keys(section);
  let fillValue = section[sectionKeys[0]];
  return Object.fromEntries(
    [.../* @__PURE__ */ new Set([...keys, ...sectionKeys])].map((key) => {
      const value = section[key] ?? defaultValue ?? fillValue;
      fillValue = value;
      defaultValue = value;
      return [key, value];
    })
  );
};
const createFont = (font) => {
  const sizeKeys = Object.keys(font.size);
  const processedFont = Object.fromEntries(
    Object.entries(font).map(([key, section]) => {
      return [
        key,
        processSection(
          section,
          key === "face" ? fontWeights : sizeKeys,
          key === "face" ? { normal: font.family } : void 0
        )
      ];
    })
  );
  return Object.freeze(processedFont);
};

//# sourceMappingURL=createFont.js.map


/***/ }),

/***/ 8396:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ createShorthands; }
/* harmony export */ });
function createShorthands(shorthands) {
  return Object.freeze(shorthands);
}

//# sourceMappingURL=createShorthands.js.map


/***/ }),

/***/ 44417:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ createTamagui; }
/* harmony export */ });
/* harmony import */ var _tamagui_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11649);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47269);
/* harmony import */ var _createVariables_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61298);
/* harmony import */ var _helpers_getThemeCSSRules_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(54024);
/* harmony import */ var _helpers_insertStyleRule_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16746);
/* harmony import */ var _helpers_registerCSSVariable_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26095);
/* harmony import */ var _helpers_themes_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(13027);
/* harmony import */ var _hooks_useMedia_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5755);
/* harmony import */ var _insertFont_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62498);










const createdConfigs = /* @__PURE__ */ new WeakMap();
function createTamagui(configIn) {
  var _a;
  if (createdConfigs.has(configIn)) {
    return configIn;
  }
  if (false) {}
  (0,_helpers_insertStyleRule_js__WEBPACK_IMPORTED_MODULE_1__/* .scanAllSheets */ .jc)();
  (0,_helpers_insertStyleRule_js__WEBPACK_IMPORTED_MODULE_1__/* .listenForSheetChanges */ .OJ)();
  const fontTokens = Object.fromEntries(
    Object.entries(configIn.fonts).map(([k, v]) => {
      return [k, (0,_createVariables_js__WEBPACK_IMPORTED_MODULE_2__/* .createVariables */ .D)(v, "f", true)];
    })
  );
  const fontsParsed = (() => {
    const res = {};
    for (const familyName in fontTokens) {
      res[`$${familyName}`] = (0,_insertFont_js__WEBPACK_IMPORTED_MODULE_3__/* .parseFont */ .ZL)(fontTokens[familyName]);
    }
    return res;
  })();
  const themeConfig = (() => {
    const themes = { ...configIn.themes };
    const cssRuleSets = [];
    if (_tamagui_constants__WEBPACK_IMPORTED_MODULE_0__/* .isWeb */ .$L) {
      let declarationsToRuleSet2 = function(decs, selector = "") {
        return `:root${selector} {${sep}${[...decs].join(`;${sep}`)}${sep}}`;
      };
      var declarationsToRuleSet = declarationsToRuleSet2;
      const declarations = [];
      const fontDeclarations = {};
      for (const key in configIn.tokens) {
        for (const skey in configIn.tokens[key]) {
          const val = configIn.tokens[key][skey];
          (0,_helpers_registerCSSVariable_js__WEBPACK_IMPORTED_MODULE_4__/* .registerCSSVariable */ .Im)(val);
          declarations.push((0,_helpers_registerCSSVariable_js__WEBPACK_IMPORTED_MODULE_4__/* .variableToCSS */ .nw)(val));
        }
      }
      for (const key in fontsParsed) {
        const fontParsed = fontsParsed[key];
        const [name, language] = key.includes("_") ? key.split("_") : [key];
        const fontVars = (0,_insertFont_js__WEBPACK_IMPORTED_MODULE_3__/* .registerFontVariables */ .QF)(fontParsed);
        fontDeclarations[key] = {
          name: name.slice(1),
          declarations: fontVars,
          language
        };
      }
      const sep =  false ? 0 : "";
      cssRuleSets.push(declarationsToRuleSet2(declarations));
      if (fontDeclarations) {
        for (const key in fontDeclarations) {
          const { name, declarations: declarations2, language = "default" } = fontDeclarations[key];
          const fontSelector = `.font_${name}`;
          const langSelector = `:root .t_lang-${name}-${language} ${fontSelector}`;
          const selectors = language === "default" ? ` ${fontSelector}, ${langSelector}` : langSelector;
          const specificRuleSet = declarationsToRuleSet2(declarations2, selectors);
          cssRuleSets.push(specificRuleSet);
        }
      }
    }
    const dedupedThemes = {};
    const existing = /* @__PURE__ */ new Map();
    for (const themeName in themes) {
      const rawTheme = themes[themeName];
      const key = JSON.stringify(rawTheme);
      if (existing.has(key)) {
        const e = existing.get(key);
        themes[themeName] = e.theme;
        e.names.push(themeName);
        continue;
      }
      const theme = { ...rawTheme };
      for (const key2 in theme) {
        (0,_helpers_themes_js__WEBPACK_IMPORTED_MODULE_5__/* .ensureThemeVariable */ .n)(theme, key2);
      }
      themes[themeName] = theme;
      dedupedThemes[themeName] = {
        names: [themeName],
        theme
      };
      existing.set(key, dedupedThemes[themeName]);
    }
    let themeRuleSets = [];
    if (_tamagui_constants__WEBPACK_IMPORTED_MODULE_0__/* .isWeb */ .$L || _tamagui_constants__WEBPACK_IMPORTED_MODULE_0__/* .isRSC */ .PS) {
      for (const themeName in dedupedThemes) {
        themeRuleSets = [
          ...themeRuleSets,
          ...(0,_helpers_getThemeCSSRules_js__WEBPACK_IMPORTED_MODULE_6__/* .getThemeCSSRules */ .Q)({
            config: configIn,
            themeName,
            ...dedupedThemes[themeName]
          })
        ];
      }
    }
    for (const themeName in themes) {
      themes[themeName] = (0,_helpers_themes_js__WEBPACK_IMPORTED_MODULE_5__/* .proxyThemeToParents */ .k)(themeName, themes[themeName], themes);
    }
    _helpers_registerCSSVariable_js__WEBPACK_IMPORTED_MODULE_4__/* .tokensValueToVariable.clear */ .c.clear();
    return {
      themes,
      cssRuleSets,
      themeRuleSets
    };
  })();
  const tokensParsed = Object.fromEntries(
    Object.entries(configIn.tokens).map(([k, v]) => {
      const val = Object.fromEntries(Object.entries(v).map(([k2, v2]) => [`$${k2}`, v2]));
      _createVariables_js__WEBPACK_IMPORTED_MODULE_2__/* .tokensKeysOrdered.set */ .O.set(val, _createVariables_js__WEBPACK_IMPORTED_MODULE_2__/* .tokensKeysOrdered.get */ .O.get(v));
      return [k, val];
    })
  );
  const shorthands = configIn.shorthands || {};
  const config = {
    fontLanguages: [],
    animations: {},
    media: {},
    ...configIn,
    // already processed by createTokens()
    tokens: configIn.tokens,
    // vite made this into a function if it wasn't set
    shorthands: { ...shorthands },
    inverseShorthands: shorthands ? Object.fromEntries(Object.entries(shorthands).map(([k, v]) => [v, k])) : {},
    themes: themeConfig.themes,
    fontsParsed,
    themeConfig,
    tokensParsed,
    parsed: true,
    getCSS: (separator = "\n") => {
      return `
._ovs-contain {overscroll-behavior:contain;}
.t_unmounted .t_will-mount {opacity:0;visibility:hidden;}
.is_Text .is_Text {display:inline-flex;}
._dsp_contents {display:contents;}
${themeConfig.cssRuleSets.join(separator)}
${themeConfig.themeRuleSets.join(separator)}
${(0,_helpers_insertStyleRule_js__WEBPACK_IMPORTED_MODULE_1__/* .getAllRules */ .UY)().join(separator)}`;
    }
    // const tokens = [...getToken(tokens.size[0])]
    // .spacer-sm + ._dsp_contents._dsp-sm-hidden { margin-left: -var(--${}) }
  };
  (0,_hooks_useMedia_js__WEBPACK_IMPORTED_MODULE_7__/* .configureMedia */ .jl)(config);
  (0,_config_js__WEBPACK_IMPORTED_MODULE_8__/* .setConfig */ .v6)(config);
  if (_config_js__WEBPACK_IMPORTED_MODULE_8__/* .configListeners.size */ .zG.size) {
    _config_js__WEBPACK_IMPORTED_MODULE_8__/* .configListeners.forEach */ .zG.forEach((cb) => cb(config));
    _config_js__WEBPACK_IMPORTED_MODULE_8__/* .configListeners.clear */ .zG.clear();
  }
  createdConfigs.set(config, true);
  if (false) {}
  return config;
}

//# sourceMappingURL=createTamagui.js.map


/***/ }),

/***/ 65139:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ createTheme; }
/* harmony export */ });
const createTheme = (theme) => {
  return theme;
};

//# sourceMappingURL=createTheme.js.map


/***/ }),

/***/ 93122:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ createTokens; }
/* harmony export */ });
/* harmony import */ var _createVariables_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61298);

function createTokens(tokens2) {
  return (0,_createVariables_js__WEBPACK_IMPORTED_MODULE_0__/* .createVariables */ .D)(tokens2);
}
const tokens = createTokens({
  size: { 0: 1 },
  space: { 0: 1 },
  radius: { 0: 1 },
  zIndex: { 0: 1 },
  color: { 0: "hi" }
});

//# sourceMappingURL=createTokens.js.map


/***/ }),

/***/ 13209:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E0": function() { return /* binding */ getVariable; },
/* harmony export */   "H": function() { return /* binding */ getVariableName; },
/* harmony export */   "Os": function() { return /* binding */ createVariable; },
/* harmony export */   "Ve": function() { return /* binding */ getVariableValue; },
/* harmony export */   "bK": function() { return /* binding */ createCSSVariable; },
/* harmony export */   "cG": function() { return /* binding */ isVariable; },
/* harmony export */   "kv": function() { return /* binding */ getVariableVariable; },
/* harmony export */   "lk": function() { return /* binding */ variableToString; },
/* harmony export */   "yx": function() { return /* binding */ didGetVariableValue; },
/* harmony export */   "zY": function() { return /* binding */ setDidGetVariableValue; }
/* harmony export */ });
/* harmony import */ var _tamagui_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11649);
/* harmony import */ var _tamagui_helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95591);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47269);



const IS_VAR = "isVar";
const createVariable = (props) => {
  if (isVariable(props))
    return props;
  const { key, name, val } = props;
  return {
    [IS_VAR]: true,
    key,
    name: (0,_tamagui_helpers__WEBPACK_IMPORTED_MODULE_1__.simpleHash)(name, 40),
    val,
    variable: _tamagui_constants__WEBPACK_IMPORTED_MODULE_0__/* .isWeb */ .$L ? createCSSVariable(name) : ""
  };
};
function variableToString(vrble, getValue = false) {
  if (isVariable(vrble)) {
    if (!getValue && _tamagui_constants__WEBPACK_IMPORTED_MODULE_0__/* .isWeb */ .$L && vrble.variable) {
      return vrble.variable;
    }
    return `${vrble.val}`;
  }
  return `${vrble || ""}`;
}
function isVariable(v) {
  return v && typeof v === "object" && IS_VAR in v;
}
function getVariable(nameOrVariable) {
  setDidGetVariableValue(true);
  if (isVariable(nameOrVariable)) {
    return variableToString(nameOrVariable);
  }
  const tokens = (0,_config_js__WEBPACK_IMPORTED_MODULE_2__/* .getConfig */ .iE)().tokensParsed;
  return variableToString(tokens[nameOrVariable] ?? nameOrVariable);
}
let accessed = false;
const setDidGetVariableValue = (val) => accessed = val;
const didGetVariableValue = () => accessed;
function getVariableValue(v) {
  if (isVariable(v)) {
    setDidGetVariableValue(true);
    return v.val;
  }
  return v;
}
function getVariableName(v) {
  if (isVariable(v))
    return v.name;
  return v;
}
function getVariableVariable(v) {
  if (isVariable(v))
    return v.variable;
  return v;
}
const createCSSVariable = (nameProp, includeVar = true) => {
  if (false) {}
  const name = (0,_tamagui_helpers__WEBPACK_IMPORTED_MODULE_1__.simpleHash)(nameProp, 60);
  return includeVar ? `var(--${name})` : name;
};

//# sourceMappingURL=createVariable.js.map


/***/ }),

/***/ 61298:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ createVariables; },
/* harmony export */   "O": function() { return /* binding */ tokensKeysOrdered; }
/* harmony export */ });
/* harmony import */ var _tamagui_helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95591);
/* harmony import */ var _createVariable_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13209);


const tokensKeysOrdered = /* @__PURE__ */ new WeakMap();
const createVariables = (tokens, parentPath = "", isFont = false) => {
  const res = {};
  let i = 0;
  for (let key in tokens) {
    i++;
    const val = tokens[key];
    if (key[0] === "$") {
      key = key.slice(1);
    }
    if ((0,_createVariable_js__WEBPACK_IMPORTED_MODULE_1__/* .isVariable */ .cG)(val)) {
      res[key] = val;
      continue;
    }
    const niceKey = (0,_tamagui_helpers__WEBPACK_IMPORTED_MODULE_0__.simpleHash)(key);
    let name = isFont ? niceKey.slice(0, 2) : i;
    name = parentPath ? `${parentPath}-${name}` : niceKey;
    if (val && typeof val === "object") {
      res[key] = createVariables(tokens[key], name);
      continue;
    }
    res[key] = (0,_createVariable_js__WEBPACK_IMPORTED_MODULE_1__/* .isVariable */ .cG)(val) ? val : (0,_createVariable_js__WEBPACK_IMPORTED_MODULE_1__/* .createVariable */ .Os)({ val, name, key: niceKey });
  }
  if (parentPath === "size" || parentPath === "space") {
    tokensKeysOrdered.set(res, Object.keys(tokens));
  }
  return res;
};

//# sourceMappingURL=createVariables.js.map


/***/ }),

/***/ 71228:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ ThemeManagerContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

const ThemeManagerContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);

//# sourceMappingURL=ThemeManagerContext.js.map


/***/ }),

/***/ 37323:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "qq": function() { return /* binding */ createPropMapper; },
  "zd": function() { return /* binding */ getPropMappedFontFamily; }
});

// UNUSED EXPORTS: getFontFamilyFromNameOrVariable, getReturnVariablesAs

// EXTERNAL MODULE: ./node_modules/@tamagui/constants/dist/esm/index.mjs
var esm = __webpack_require__(11649);
// EXTERNAL MODULE: ./node_modules/@tamagui/web/dist/esm/config.js
var config = __webpack_require__(47269);
// EXTERNAL MODULE: ./node_modules/@tamagui/web/dist/esm/createVariable.js
var createVariable = __webpack_require__(13209);
// EXTERNAL MODULE: ./node_modules/@tamagui/web/dist/esm/helpers/expandStyle.js
var expandStyle = __webpack_require__(26150);
// EXTERNAL MODULE: ./node_modules/@tamagui/web/dist/esm/helpers/expandStyles.js + 1 modules
var expandStyles = __webpack_require__(38217);
// EXTERNAL MODULE: ./node_modules/@tamagui/web/dist/esm/helpers/getVariantExtras.js
var getVariantExtras = __webpack_require__(40192);
;// CONCATENATED MODULE: ./node_modules/@tamagui/web/dist/esm/helpers/isObj.js
const isObj = (x) => x && !Array.isArray(x) && typeof x === "object";

//# sourceMappingURL=isObj.js.map

// EXTERNAL MODULE: ./node_modules/@tamagui/web/dist/esm/helpers/mergeProps.js
var mergeProps = __webpack_require__(88410);
;// CONCATENATED MODULE: ./node_modules/@tamagui/web/dist/esm/helpers/createPropMapper.js









const getReturnVariablesAs = (props, state) => {
  return !!props.animation || state.resolveVariablesAs === "value" ? esm/* isWeb */.$L ? "non-color-value" : "value" : "auto";
};
const createPropMapper = (staticConfig) => {
  const variants = staticConfig.variants || {};
  const defaultProps = (0,mergeProps/* mergeProps */.d)(staticConfig.defaultProps || {}, {}, false)[0];
  let conf;
  const mapper = (key, value, theme, propsIn, state, languageContext, avoidDefaultProps = false, debug) => {
    conf ||= (0,config/* getConfig */.iE)();
    const props = state.fallbackProps || propsIn;
    const returnVariablesAs = getReturnVariablesAs(props, state);
    const fontFamily = props[conf.inverseShorthands.fontFamily] || props.fontFamily || defaultProps.fontFamily || propsIn.fontFamily || "$body";
    const variantValue = resolveVariants(
      key,
      value,
      props,
      defaultProps,
      theme,
      variants,
      fontFamily,
      conf,
      returnVariablesAs,
      staticConfig,
      "",
      languageContext,
      avoidDefaultProps,
      debug
    );
    if (variantValue) {
      return variantValue;
    }
    let shouldReturn = value !== void 0 && value !== null;
    if (key in conf.shorthands) {
      shouldReturn = true;
      key = conf.shorthands[key];
    }
    if (value) {
      if (value[0] === "$") {
        value = getToken(
          key,
          value,
          conf,
          theme,
          fontFamily,
          languageContext,
          returnVariablesAs,
          debug
        );
      } else if ((0,createVariable/* isVariable */.cG)(value)) {
        value = resolveVariableValue(key, value, returnVariablesAs);
      }
    }
    if (shouldReturn) {
      return (0,expandStyle/* expandStyle */.h)(key, value) || [[key, value]];
    }
  };
  return mapper;
};
const resolveVariants = (key, value, props, defaultProps, theme, variants, fontFamily, conf, returnVariablesAs, staticConfig, parentVariantKey, languageContext, avoidDefaultProps = false, debug) => {
  var _a;
  const variant = variants == null ? void 0 : variants[key];
  if (!variant || value === void 0) {
    return;
  }
  let variantValue = getVariantDefinition(variant, key, value, conf);
  if (!variantValue) {
    if (false) {}
    return;
  }
  if (typeof variantValue === "function") {
    const fn = variantValue;
    variantValue = fn(
      value,
      (0,getVariantExtras/* getVariantExtras */.A)(props, languageContext, theme, defaultProps, avoidDefaultProps)
    );
  }
  let fontFamilyResult;
  if (isObj(variantValue)) {
    const fontFamilyUpdate = variantValue.fontFamily || variantValue[conf.inverseShorthands.fontFamily];
    if (fontFamilyUpdate) {
      fontFamilyResult = getFontFamilyFromNameOrVariable(fontFamilyUpdate, conf);
    }
    variantValue = resolveTokensAndVariants(
      key,
      variantValue,
      props,
      defaultProps,
      theme,
      variants,
      fontFamilyResult || fontFamily,
      conf,
      returnVariablesAs,
      staticConfig,
      parentVariantKey,
      languageContext,
      avoidDefaultProps,
      debug
    );
  }
  if (variantValue) {
    const next = Object.entries((0,expandStyles/* expandStyles */.Z)(variantValue));
    if (fontFamilyResult && fontFamilyResult[0] === "$") {
      fontFamilyCache.set(next, (0,createVariable/* getVariableValue */.Ve)(fontFamilyResult));
    }
    return next;
  }
};
function getFontFamilyFromNameOrVariable(input, conf) {
  if ((0,createVariable/* isVariable */.cG)(input)) {
    const val = variableToFontNameCache.get(input);
    if (val) {
      return val;
    } else {
      for (const key in conf.fontsParsed) {
        const familyVariable = conf.fontsParsed[key].family;
        if ((0,createVariable/* isVariable */.cG)(familyVariable)) {
          variableToFontNameCache.set(familyVariable, key);
          if (familyVariable === input) {
            return key;
          }
        }
      }
    }
  } else if (typeof input === "string") {
    if ((input == null ? void 0 : input[0]) === "$") {
      return input;
    } else {
      if (false) {}
    }
  }
}
const variableToFontNameCache = /* @__PURE__ */ new WeakMap();
const fontFamilyCache = /* @__PURE__ */ new WeakMap();
const getPropMappedFontFamily = (expanded) => {
  return expanded && fontFamilyCache.get(expanded);
};
const resolveTokensAndVariants = (key, value, props, defaultProps, theme, variants, fontFamily, conf, returnVariablesAs, staticConfig, parentVariantKey, languageContext, avoidDefaultProps, debug) => {
  var _a;
  const res = {};
  for (const rKey in value) {
    const fKey = conf.shorthands[rKey] || rKey;
    const val = value[rKey];
    if (fKey in variants) {
      if (parentVariantKey && parentVariantKey === key) {
        res[fKey] = val;
      } else {
        const variantOut = resolveVariants(
          fKey,
          val,
          props,
          defaultProps,
          theme,
          variants,
          fontFamily,
          conf,
          returnVariablesAs,
          staticConfig,
          key,
          languageContext,
          avoidDefaultProps,
          debug
        );
        const { pressStyle, hoverStyle, focusStyle, enterStyle, exitStyle, ...rest } = Object.fromEntries(variantOut);
        const subs = { pressStyle, hoverStyle, focusStyle, enterStyle, exitStyle };
        Object.assign(res, rest);
        for (const key2 in subs) {
          if (subs[key2]) {
            res[key2] ??= {};
            Object.assign(res[key2], subs[key2]);
          }
        }
      }
      continue;
    }
    if ((0,createVariable/* isVariable */.cG)(val)) {
      res[fKey] = !esm/* isWeb */.$L || returnVariablesAs === "value" ? val.val : val.variable;
      continue;
    }
    if (typeof val === "string") {
      const fVal = val[0] === "$" ? getToken(
        fKey,
        val,
        conf,
        theme,
        fontFamily,
        languageContext,
        returnVariablesAs,
        debug
      ) : val;
      res[fKey] = fVal;
      continue;
    }
    if (isObj(val)) {
      res[fKey] ??= {};
      Object.assign(
        res[fKey],
        resolveTokensAndVariants(
          fKey,
          val,
          props,
          defaultProps,
          theme,
          variants,
          fontFamily,
          conf,
          returnVariablesAs,
          staticConfig,
          key,
          languageContext,
          avoidDefaultProps,
          debug
        )
      );
    } else {
      res[fKey] = val;
    }
    if (false) {}
  }
  return res;
};
const tokenCats = ["size", "color", "radius", "space", "zIndex"].map((name) => ({
  name,
  spreadName: `...${name}`
}));
function getVariantDefinition(variant, key, value, conf) {
  if (typeof variant === "function") {
    return variant;
  }
  if (variant[value]) {
    return variant[value];
  }
  const { tokensParsed } = conf;
  for (const { name, spreadName } of tokenCats) {
    if (variant[spreadName] && value in tokensParsed[name]) {
      return variant[spreadName];
    }
  }
  let fn;
  const type = typeof value;
  if (type === "number") {
    fn = variant[":number"];
  } else if (type === "string") {
    fn = variant[":string"];
  } else if (value === true || value === false) {
    fn = variant[":boolean"];
  }
  return fn || variant["..."] || variant["...size"];
}
const fontShorthand = {
  fontSize: "size",
  fontWeight: "weight"
};
const getToken = (key, value, conf, theme, fontFamily = "$body", languageContext, resolveAs, debug) => {
  var _a, _b, _c;
  const tokensParsed = conf.tokensParsed;
  const fontsParsed = languageContext ? (0,getVariantExtras/* getFontsForLanguage */.r)(conf.fontsParsed, languageContext) : conf.fontsParsed;
  let valOrVar;
  let hasSet = false;
  if (value in theme) {
    valOrVar = theme[value];
    hasSet = true;
  } else {
    switch (key) {
      case "fontFamily":
        valOrVar = ((_a = fontsParsed[value]) == null ? void 0 : _a.family) || value;
        hasSet = true;
        break;
      case "fontSize":
      case "lineHeight":
      case "letterSpacing":
      case "fontWeight":
        valOrVar = ((_c = (_b = fontsParsed[fontFamily]) == null ? void 0 : _b[fontShorthand[key] || key]) == null ? void 0 : _c[value]) || value;
        hasSet = true;
        break;
    }
    for (const cat in tokenCategories) {
      if (key in tokenCategories[cat]) {
        const res = tokensParsed[cat][value];
        if (res) {
          valOrVar = res;
          hasSet = true;
        }
      }
    }
    if (!hasSet) {
      const spaceVar = tokensParsed.space[value];
      if (spaceVar) {
        valOrVar = spaceVar;
        hasSet = true;
      }
    }
  }
  if (false) {}
  if (hasSet) {
    return resolveVariableValue(key, valOrVar, resolveAs);
  }
  if (false) {}
  return value;
};
function resolveVariableValue(key, valOrVar, resolveAs = "auto") {
  if ((0,createVariable/* isVariable */.cG)(valOrVar)) {
    if (resolveAs === "variable") {
      return valOrVar;
    }
    if (resolveAs === "non-color-value") {
      if (esm/* isWeb */.$L) {
        if (key in tokenCategories.color) {
          return valOrVar.variable;
        }
      }
      return valOrVar.val;
    }
    if (!esm/* isWeb */.$L || resolveAs === "value") {
      return valOrVar.val;
    }
    return valOrVar.variable;
  }
  return valOrVar;
}
const tokenCategories = {
  radius: {
    borderRadius: true,
    borderTopLeftRadius: true,
    borderTopRightRadius: true,
    borderBottomLeftRadius: true,
    borderBottomRightRadius: true
  },
  size: {
    width: true,
    height: true,
    minWidth: true,
    minHeight: true,
    maxWidth: true,
    maxHeight: true
  },
  color: {
    color: true,
    backgroundColor: true,
    borderColor: true,
    borderBottomColor: true,
    borderTopColor: true,
    borderLeftColor: true,
    borderRightColor: true
  }
};

//# sourceMappingURL=createPropMapper.js.map


/***/ }),

/***/ 37264:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ createProxy; }
/* harmony export */ });
function createProxy(target, handler) {
  if (false) {}
  return new Proxy(target || {}, handler);
}

//# sourceMappingURL=createProxy.js.map


/***/ }),

/***/ 37649:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ defaultOffset; }
/* harmony export */ });
const defaultOffset = { height: 0, width: 0 };

//# sourceMappingURL=defaultOffset.js.map


/***/ }),

/***/ 26150:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ expandStyle; }
/* harmony export */ });
/* harmony import */ var _tamagui_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11649);
var _a;

function expandStyle(key, value) {
  if (true) {
    if (key === "flex") {
      return [
        ["flexGrow", value],
        ["flexShrink", 1],
        ["flexBasis", "auto"]
      ];
    }
    switch (key) {
      case "textAlignVertical": {
        return [["verticalAlign", value === "center" ? "middle" : value]];
      }
      case "writingDirection": {
        return [["direction", value]];
      }
    }
  }
  const longKey = EXPANSIONS[key];
  if (longKey) {
    return longKey.map((key2) => {
      return [key2, value];
    });
  }
}
const all = ["Top", "Right", "Bottom", "Left"];
const horiz = ["Right", "Left"];
const vert = ["Top", "Bottom"];
const xy = ["X", "Y"];
const EXPANSIONS = {
  borderColor: ["TopColor", "RightColor", "BottomColor", "LeftColor"],
  borderRadius: [
    "TopLeftRadius",
    "TopRightRadius",
    "BottomRightRadius",
    "BottomLeftRadius"
  ],
  borderWidth: ["TopWidth", "RightWidth", "BottomWidth", "LeftWidth"],
  margin: all,
  marginHorizontal: horiz,
  marginVertical: vert,
  overscrollBehavior: xy,
  padding: all,
  paddingHorizontal: horiz,
  paddingVertical: vert,
  ..._tamagui_constants__WEBPACK_IMPORTED_MODULE_0__/* .isWeb */ .$L && {
    // react-native only supports borderStyle
    borderStyle: ["TopStyle", "RightStyle", "BottomStyle", "LeftStyle"],
    // react-native doesn't support X / Y
    overflow: xy
  }
};
for (const parent in EXPANSIONS) {
  const prefix = parent.slice(0, ((_a = /[A-Z]/.exec(parent)) == null ? void 0 : _a.index) ?? parent.length);
  EXPANSIONS[parent] = EXPANSIONS[parent].map((k) => `${prefix}${k}`);
}

//# sourceMappingURL=expandStyle.js.map


/***/ }),

/***/ 38217:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ expandStyles; },
  "S": function() { return /* binding */ fixStyles; }
});

// EXTERNAL MODULE: ./node_modules/@tamagui/constants/dist/esm/index.mjs
var esm = __webpack_require__(11649);
// EXTERNAL MODULE: ./node_modules/@tamagui/web/dist/esm/config.js
var esm_config = __webpack_require__(47269);
// EXTERNAL MODULE: ./node_modules/@tamagui/web/dist/esm/helpers/expandStyle.js
var expandStyle = __webpack_require__(26150);
// EXTERNAL MODULE: ./node_modules/@tamagui/web/dist/esm/helpers/defaultOffset.js
var defaultOffset = __webpack_require__(37649);
// EXTERNAL MODULE: ./node_modules/@tamagui/web/dist/esm/helpers/normalizeValueWithProperty.js + 1 modules
var normalizeValueWithProperty = __webpack_require__(35709);
;// CONCATENATED MODULE: ./node_modules/@tamagui/web/dist/esm/helpers/normalizeShadow.js


function normalizeShadow({
  shadowColor,
  shadowOffset,
  shadowOpacity = 1,
  shadowRadius
}) {
  const { height, width } = shadowOffset || defaultOffset/* defaultOffset */.Y;
  return {
    shadowOffset: {
      width: (0,normalizeValueWithProperty/* normalizeValueWithProperty */.Y)(width || 0),
      height: (0,normalizeValueWithProperty/* normalizeValueWithProperty */.Y)(height || 0)
    },
    shadowRadius: (0,normalizeValueWithProperty/* normalizeValueWithProperty */.Y)(shadowRadius || 0),
    shadowColor,
    shadowOpacity
  };
}

//# sourceMappingURL=normalizeShadow.js.map

// EXTERNAL MODULE: ./node_modules/@tamagui/web/dist/esm/helpers/pseudoDescriptors.js
var pseudoDescriptors = __webpack_require__(58325);
;// CONCATENATED MODULE: ./node_modules/@tamagui/web/dist/esm/helpers/expandStyles.js






let shorthands = null;
function expandStyles(style, config = (0,esm_config/* getConfig */.iE)()) {
  const res = {};
  for (let key in style) {
    shorthands = shorthands || (config ? config.shorthands : null);
    if (shorthands) {
      key = shorthands[key] || key;
    }
    if (key in pseudoDescriptors/* pseudoDescriptors */.Q) {
      res[key] = expandStyles(style[key]);
      continue;
    }
    const val = (0,normalizeValueWithProperty/* normalizeValueWithProperty */.Y)(style[key], key);
    const out = (0,expandStyle/* expandStyle */.h)(key, val);
    if (out) {
      Object.assign(res, Object.fromEntries(out));
    } else {
      res[key] = val;
    }
  }
  fixStyles(res);
  return res;
}
function fixStyles(style) {
  if (style.shadowRadius || style.shadowColor || style.shadowOpacity || style.shadowOffset) {
    Object.assign(style, normalizeShadow(style));
  }
  for (const key in borderDefaults) {
    if (key in style && !style[borderDefaults[key]]) {
      style[borderDefaults[key]] = "solid";
    }
  }
}
const nativeStyle = esm/* isWeb */.$L ? null : "borderStyle";
const borderDefaults = {
  borderWidth: "borderStyle",
  borderBottomWidth: nativeStyle || "borderBottomStyle",
  borderTopWidth: nativeStyle || "borderTopStyle",
  borderLeftWidth: nativeStyle || "borderLeftStyle",
  borderRightWidth: nativeStyle || "borderRightStyle"
};

//# sourceMappingURL=expandStyles.js.map


/***/ }),

/***/ 12500:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ getAnimationDriver; }
/* harmony export */ });
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47269);

function getAnimationDriver() {
  return (0,_config_js__WEBPACK_IMPORTED_MODULE_0__/* .getConfig */ .iE)().animations;
}

//# sourceMappingURL=getAnimationDriver.js.map


/***/ }),

/***/ 57248:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ getExpandedShorthands; }
/* harmony export */ });
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47269);

function getExpandedShorthands(props) {
  const shorthands = (0,_config_js__WEBPACK_IMPORTED_MODULE_0__/* .getConfig */ .iE)().shorthands;
  if (!shorthands)
    return props;
  const res = {};
  for (const key in props) {
    res[shorthands[key] || key] = props[key];
  }
  return res;
}

//# sourceMappingURL=getExpandedShorthands.js.map


/***/ }),

/***/ 49678:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Fu": function() { return /* binding */ PROP_SPLIT; },
  "Dt": function() { return /* binding */ getSplitStyles; },
  "AQ": function() { return /* binding */ getSubStyle; },
  "ts": function() { return /* binding */ insertSplitStyles; },
  "DP": function() { return /* binding */ useSplitStyles; }
});

// EXTERNAL MODULE: ./node_modules/@tamagui/constants/dist/esm/index.mjs
var esm = __webpack_require__(11649);
// EXTERNAL MODULE: ./node_modules/@tamagui/helpers/dist/esm/index.mjs
var dist_esm = __webpack_require__(95591);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./node_modules/@tamagui/web/dist/esm/config.js
var config = __webpack_require__(47269);
// EXTERNAL MODULE: ./node_modules/@tamagui/web/dist/esm/hooks/useMedia.js
var useMedia = __webpack_require__(5755);
;// CONCATENATED MODULE: ./node_modules/@tamagui/web/dist/esm/helpers/createMediaStyle.js

const MEDIA_SEP = "_";
let prefixes = null;
let selectors = null;
const createMediaStyle = ({ property, identifier, rules }, mediaKey, mediaQueries, negate) => {
  if (!(prefixes && selectors)) {
    const mediaKeys = Object.keys(mediaQueries);
    prefixes = Object.fromEntries(
      mediaKeys.map((key, index) => [key, new Array(index + 1).fill(":root").join("")])
    );
    selectors = Object.fromEntries(
      mediaKeys.map((key) => [key, (0,useMedia/* mediaObjectToString */.yS)(mediaQueries[key])])
    );
  }
  const precendencePrefix = prefixes[mediaKey];
  const mediaSelector = selectors[mediaKey];
  const negKey = negate ? "0" : "";
  const ogPrefix = identifier.slice(0, identifier.indexOf("-") + 1);
  const nextIdentifier = `${identifier.replace(
    ogPrefix,
    `${ogPrefix}${MEDIA_SEP}${mediaKey}${negKey}${MEDIA_SEP}`
  )}`;
  const screenStr = negate ? "not all and" : "";
  const mediaQuery = `${screenStr} ${mediaSelector}`;
  const styleInner = rules.map((rule) => rule.replace(identifier, nextIdentifier)).join(";");
  let styleRule = "";
  if (styleInner.includes("@media")) {
    styleRule = styleInner.replace("{", ` and ${mediaQuery} {`);
  } else {
    styleRule = `@media ${mediaQuery} { ${precendencePrefix} ${styleInner} }`;
  }
  return {
    property,
    rules: [styleRule],
    identifier: nextIdentifier
  };
};

//# sourceMappingURL=createMediaStyle.js.map

// EXTERNAL MODULE: ./node_modules/@tamagui/web/dist/esm/helpers/createPropMapper.js + 1 modules
var createPropMapper = __webpack_require__(37323);
// EXTERNAL MODULE: ./node_modules/@tamagui/web/dist/esm/helpers/expandStyles.js + 1 modules
var expandStyles = __webpack_require__(38217);
// EXTERNAL MODULE: ./node_modules/@tamagui/web/dist/esm/helpers/getStylesAtomic.js
var getStylesAtomic = __webpack_require__(89249);
// EXTERNAL MODULE: ./node_modules/@tamagui/web/dist/esm/helpers/insertStyleRule.js
var insertStyleRule = __webpack_require__(16746);
// EXTERNAL MODULE: ./node_modules/@tamagui/web/dist/esm/helpers/normalizeValueWithProperty.js + 1 modules
var normalizeValueWithProperty = __webpack_require__(35709);
// EXTERNAL MODULE: ./node_modules/@tamagui/web/dist/esm/helpers/pseudoDescriptors.js
var pseudoDescriptors = __webpack_require__(58325);
;// CONCATENATED MODULE: ./node_modules/@tamagui/web/dist/esm/helpers/getSplitStyles.js













const skipProps = {
  animation: true,
  space: true,
  animateOnly: true,
  debug: true,
  componentName: true,
  tag: true
};
if (false) {}
const IS_STATIC = "" === "is_static";
if (false) {}
const accessibilityDirectMap = {};
if (true) {
  const items = {
    Hidden: true,
    ActiveDescendant: true,
    Atomic: true,
    AutoComplete: true,
    Busy: true,
    Checked: true,
    ColumnCount: "colcount",
    ColumnIndex: "colindex",
    ColumnSpan: "colspan",
    Current: true,
    Details: true,
    ErrorMessage: true,
    Expanded: true,
    HasPopup: true,
    Invalid: true,
    Label: true,
    Level: true,
    Modal: true,
    Multiline: true,
    MultiSelectable: true,
    Orientation: true,
    Owns: true,
    Placeholder: true,
    PosInSet: true,
    Pressed: true,
    RoleDescription: true,
    RowCount: true,
    RowIndex: true,
    RowSpan: true,
    Selected: true,
    SetSize: true,
    Sort: true,
    ValueMax: true,
    ValueMin: true,
    ValueNow: true,
    ValueText: true
  };
  for (const key in items) {
    let val = items[key];
    if (val === true) {
      val = key.toLowerCase();
    }
    accessibilityDirectMap[`accessibility${key}`] = `aria-${val}`;
  }
}
let conf;
const PROP_SPLIT = "-";
const accessibilityRoleToWebRole = {
  adjustable: "slider",
  header: "heading",
  image: "img",
  link: "link",
  none: "presentation",
  summary: "region"
};
const isMediaKey = (key) => Boolean(key[0] === "$" && useMedia/* mediaKeysWithAndWithout$.has */.sZ.has(key));
const getSplitStyles = (props, staticConfig, theme, state, parentSplitStyles, languageContext, elementType, debug) => {
  var _a, _b, _c;
  if (cache.has(props)) {
    return cache.get(props);
  }
  conf = conf || (0,config/* getConfig */.iE)();
  const { shorthands } = conf;
  const { variants, propMapper, isReactNative, inlineProps, inlineWhenUnflattened } = staticConfig;
  const validStyleProps = staticConfig.isText ? dist_esm.stylePropsText : dist_esm.validStyles;
  const viewProps = {};
  let pseudos = null;
  let psuedosUsed = null;
  const mediaState = state.mediaState || useMedia/* mediaState */.nA;
  const usedKeys = {};
  const propKeys = Object.keys(props);
  let space = props.space;
  let hasMedia = false;
  const shouldDoClasses = staticConfig.acceptsClassName && (esm/* isWeb */.$L || IS_STATIC) && !state.noClassNames;
  let style = {};
  const flatTransforms = {};
  const len = propKeys.length;
  const rulesToInsert = [];
  const classNames = {};
  let className = "";
  const transforms = {};
  let fontFamily;
  const styleState = {
    classNames,
    conf,
    props,
    state,
    staticConfig,
    style,
    theme,
    usedKeys,
    viewProps,
    languageContext
  };
  if (false) {}
  if (props.className) {
    for (const cn of props.className.split(" ")) {
      if (cn[0] === "_") {
        const [shorthand, mediaOrPseudo] = cn.slice(1).split("-");
        const isMedia = mediaOrPseudo[0] === "_";
        const isPseudo = mediaOrPseudo[0] === "0";
        const isMediaOrPseudo = isMedia || isPseudo;
        let fullKey = shorthands[shorthand];
        if (isMedia) {
          let mediaShortKey = mediaOrPseudo.slice(1);
          mediaShortKey = mediaShortKey.slice(0, mediaShortKey.indexOf("_"));
          fullKey += `${PROP_SPLIT}${mediaShortKey}`;
        } else if (isPseudo) {
          const pseudoShortKey = mediaOrPseudo.slice(1);
          fullKey += `${PROP_SPLIT}${pseudoShortKey}`;
        }
        usedKeys[fullKey] = 1;
        mergeClassName(transforms, classNames, fullKey, cn, isMediaOrPseudo);
      } else if (cn) {
        className += ` ${cn}`;
      }
    }
  }
  for (let i = len - 1; i >= 0; i--) {
    let keyInit = propKeys[i];
    if (keyInit === "className")
      continue;
    let valInit = props[keyInit];
    if (keyInit in shorthands) {
      keyInit = shorthands[keyInit];
    }
    if (false) {}
    if (!staticConfig.isHOC) {
      if (keyInit in skipProps) {
        continue;
      }
    }
    if (keyInit in usedKeys) {
      continue;
    }
    if (typeof valInit === "string" && valInit[0] === "_") {
      if (keyInit in validStyleProps || keyInit.includes("-")) {
        if (shouldDoClasses) {
          classNames[keyInit] = valInit;
        } else {
          style[keyInit] = (0,normalizeValueWithProperty/* reverseMapClassNameToValue */.R)(keyInit, valInit);
        }
        usedKeys[keyInit] = 1;
        continue;
      }
    }
    if (keyInit === "dataSet") {
      for (const key in valInit) {
        viewProps[`data-${hyphenate(key)}`] = valInit[key];
      }
      continue;
    }
    const isMainStyle = keyInit === "style";
    if (isMainStyle || keyInit.startsWith("_style")) {
      if (!valInit)
        continue;
      const styles = Array.isArray(valInit) ? valInit : [valInit];
      const styleLen = styles.length;
      for (let j = styleLen; j >= 0; j--) {
        const cur = styles[j];
        if (!cur)
          continue;
        for (const key in cur) {
          if (!isMainStyle && usedKeys[key]) {
            continue;
          }
          usedKeys[key] = 1;
          style[key] = cur[key];
        }
      }
      continue;
    }
    if (true) {
      if (keyInit === "disabled" && valInit === true) {
        usedKeys[keyInit] = 1;
        viewProps["aria-disabled"] = true;
        if (elementType === "button" || elementType === "form" || elementType === "input" || elementType === "select" || elementType === "textarea") {
          viewProps.disabled = true;
        }
        if (!(variants == null ? void 0 : variants.disabled)) {
          continue;
        }
      }
      if (keyInit === "testID") {
        usedKeys[keyInit] = 1;
        viewProps[isReactNative ? "testId" : "data-testid"] = valInit;
        continue;
      }
      if (keyInit === "id" || keyInit === "nativeID") {
        usedKeys[keyInit] = 1;
        if (isReactNative) {
          viewProps.nativeID = valInit;
        } else {
          viewProps.id = valInit;
        }
        continue;
      }
      let didUseKeyInit = false;
      if (isReactNative) {
        if (accessibilityDirectMap[keyInit] || keyInit.startsWith("accessibility")) {
          viewProps[keyInit] = valInit;
          usedKeys[keyInit] = 1;
          continue;
        }
      } else {
        didUseKeyInit = true;
        if (accessibilityDirectMap[keyInit]) {
          viewProps[accessibilityDirectMap[keyInit]] = valInit;
        } else {
          switch (keyInit) {
            case "accessibilityRole": {
              if (valInit === "none") {
                viewProps.role = "presentation";
              } else {
                viewProps.role = accessibilityRoleToWebRole[valInit] || valInit;
              }
              continue;
            }
            case "accessibilityLabelledBy":
            case "accessibilityFlowTo":
            case "accessibilityControls":
            case "accessibilityDescribedBy": {
              viewProps[`aria-${keyInit.replace("accessibility", "").toLowerCase()}`] = processIDRefList(valInit);
              continue;
            }
            case "accessibilityKeyShortcuts": {
              if (Array.isArray(valInit)) {
                viewProps["aria-keyshortcuts"] = valInit.join(" ");
              }
              continue;
            }
            case "accessibilityLiveRegion": {
              viewProps["aria-live"] = valInit === "none" ? "off" : valInit;
              continue;
            }
            case "accessibilityReadOnly": {
              viewProps["aria-readonly"] = valInit;
              if (elementType === "input" || elementType === "select" || elementType === "textarea") {
                viewProps.readOnly = true;
              }
              continue;
            }
            case "accessibilityRequired": {
              viewProps["aria-required"] = valInit;
              if (elementType === "input" || elementType === "select" || elementType === "textarea") {
                viewProps.required = valInit;
              }
              continue;
            }
            default: {
              didUseKeyInit = false;
            }
          }
        }
      }
      if (didUseKeyInit) {
        usedKeys[keyInit] = 1;
        continue;
      }
      if (valInit && valInit[0] === "_") {
        const isValidClassName = dist_esm.validStyles[keyInit];
        const isMediaOrPseudo = !isValidClassName && keyInit.includes(PROP_SPLIT) && dist_esm.validStyles[keyInit.split(PROP_SPLIT)[0]];
        if (isValidClassName || isMediaOrPseudo) {
          usedKeys[keyInit] = 1;
          if (false) {}
          mergeClassName(transforms, classNames, keyInit, valInit, isMediaOrPseudo);
          continue;
        }
      }
    }
    let isMedia = isMediaKey(keyInit);
    let isPseudo = keyInit in dist_esm.validPseudoKeys;
    const isHOCShouldPassThrough = staticConfig.isHOC && (isMedia || isPseudo);
    const shouldPassProp = !(isMedia || isPseudo || (variants == null ? void 0 : variants[keyInit]) || keyInit in validStyleProps || keyInit in shorthands);
    const shouldPassThrough = shouldPassProp || isHOCShouldPassThrough;
    if (false) {}
    if (shouldPassThrough) {
      usedKeys[keyInit] = 1;
      viewProps[keyInit] = valInit;
      continue;
    }
    if (false) {}
    const expanded = isMedia || isPseudo ? [[keyInit, valInit]] : propMapper(
      keyInit,
      valInit,
      theme,
      props,
      state,
      languageContext,
      void 0,
      debug
    );
    if (!fontFamily) {
      fontFamily = (0,createPropMapper/* getPropMappedFontFamily */.zd)(expanded);
    }
    if (false) {}
    if (!expanded)
      continue;
    for (const [key, val] of expanded) {
      if (val === void 0)
        continue;
      isMedia = isMediaKey(key);
      isPseudo = key in dist_esm.validPseudoKeys;
      const isMediaOrPseudo = isMedia || isPseudo;
      if (!isMediaOrPseudo && usedKeys[key]) {
        if (false) {}
        continue;
      }
      if ((inlineProps == null ? void 0 : inlineProps.has(key)) || (inlineWhenUnflattened == null ? void 0 : inlineWhenUnflattened.has(key))) {
        usedKeys[key] = 1;
        viewProps[key] = props[key] ?? val;
      }
      if (isPseudo) {
        if (!val)
          continue;
        const pseudoStyleObject = getSubStyle(
          styleState,
          key,
          val,
          true,
          state.noClassNames
        );
        const descriptor = pseudoDescriptors/* pseudoDescriptors */.Q[key];
        const isEnter = descriptor.name === "enter";
        const isExit = descriptor.name === "exit";
        if (!descriptor || isExit && !state.isExiting) {
          continue;
        }
        if (!shouldDoClasses || IS_STATIC) {
          pseudos ||= {};
          pseudos[key] ||= {};
          Object.assign(pseudos[key], pseudoStyleObject);
        }
        if (shouldDoClasses && !isEnter && !isExit) {
          const pseudoStyles = (0,getStylesAtomic/* getAtomicStyle */.sG)(pseudoStyleObject, descriptor);
          for (const psuedoStyle of pseudoStyles) {
            const fullKey = `${psuedoStyle.property}${PROP_SPLIT}${descriptor.name}`;
            if (!usedKeys[fullKey]) {
              usedKeys[fullKey] = 1;
              addStyleToInsertRules(rulesToInsert, psuedoStyle);
              mergeClassName(
                transforms,
                classNames,
                fullKey,
                psuedoStyle.identifier,
                isMediaOrPseudo
              );
            }
          }
        } else {
          if (usedKeys[key]) {
            continue;
          }
          let isDisabled = !state[descriptor.stateKey || descriptor.name];
          if (esm/* isWeb */.$L && !esm/* isClient */.C5 && isEnter) {
            isDisabled = false;
          }
          if (!isDisabled) {
            if (valInit === staticConfig.defaultProps[keyInit]) {
            } else {
              usedKeys[key] ||= 1;
              if (false) {}
            }
          }
          psuedosUsed ||= {};
          const importance = descriptor.priority;
          for (const pkey in pseudoStyleObject) {
            const val2 = pseudoStyleObject[pkey];
            if (isDisabled) {
              if (!(pkey in usedKeys) && pkey in animatableDefaults) {
                const defaultVal = animatableDefaults[pkey];
                mergeStyle(styleState, flatTransforms, pkey, defaultVal, true);
              }
              continue;
            }
            const curImportance = psuedosUsed[importance] || 0;
            const shouldMerge = importance >= curImportance;
            if (shouldMerge) {
              psuedosUsed[pkey] = importance;
              pseudos ||= {};
              pseudos[key] ||= {};
              pseudos[key][pkey] = val2;
              mergeStyle(styleState, flatTransforms, pkey, val2);
            }
            if (false) {}
          }
        }
        continue;
      }
      if (isMedia) {
        if (!val)
          continue;
        hasMedia ||= true;
        const mediaStyle = getSubStyle(
          styleState,
          key,
          val,
          // TODO try true like pseudo
          false
        );
        const mediaKeyShort = key.slice(1);
        if (false) {}
        if ("space" in mediaStyle) {
          if (!Array.isArray(hasMedia)) {
            hasMedia = [];
          }
          hasMedia.push(mediaKeyShort);
        }
        if (shouldDoClasses) {
          if ("space" in mediaStyle) {
            delete mediaStyle["space"];
            if (mediaState[mediaKeyShort]) {
              const val2 = valInit.space;
              const importance = (0,useMedia/* getMediaImportanceIfMoreImportant */.ae)(
                mediaKeyShort,
                "space",
                usedKeys
              );
              if (importance) {
                space = val2;
                usedKeys["space"] = importance;
                if (false) {}
              }
            }
          }
          const mediaStyles = (0,getStylesAtomic/* getStylesAtomic */.yq)(mediaStyle);
          for (const style2 of mediaStyles) {
            const out = createMediaStyle(style2, mediaKeyShort, useMedia/* mediaQueryConfig */.aN);
            const fullKey = `${style2.property}${PROP_SPLIT}${mediaKeyShort}`;
            if (!usedKeys[fullKey]) {
              usedKeys[fullKey] = 1;
              addStyleToInsertRules(rulesToInsert, out);
              mergeClassName(transforms, classNames, fullKey, out.identifier, true);
            }
          }
        } else if (mediaState[mediaKeyShort]) {
          for (const subKey in mediaStyle) {
            const importance = (0,useMedia/* getMediaImportanceIfMoreImportant */.ae)(
              mediaKeyShort,
              subKey,
              usedKeys
            );
            if (importance === null)
              continue;
            if (subKey === "space") {
              space = valInit.space;
              continue;
            }
            (0,useMedia/* mergeMediaByImportance */.Pb)(
              style,
              mediaKeyShort,
              subKey,
              mediaStyle[subKey],
              usedKeys
            );
            if (key === "fontFamily") {
              fontFamily = mediaStyle[key];
            }
          }
        }
        continue;
      }
      if (false) {}
      if (key === "fontFamily" && !fontFamily && valInit && val) {
        fontFamily = valInit[0] === "$" ? valInit : val;
      }
      if (key in validStyleProps) {
        mergeStyle(styleState, flatTransforms, key, val);
        continue;
      }
      if (!variants || !(key in variants)) {
        if (!(key in skipProps)) {
          viewProps[key] = val;
          usedKeys[key] = 1;
        }
      }
    }
  }
  (0,expandStyles/* fixStyles */.S)(style);
  if (esm/* isWeb */.$L) {
    (0,getStylesAtomic/* styleToCSS */.FL)(style);
  }
  if (false) {}
  if (flatTransforms) {
    if (false) {}
    mergeTransforms(style, flatTransforms, true);
  }
  if (parentSplitStyles) {
    if (true) {
      if (shouldDoClasses) {
        for (const key in parentSplitStyles.classNames) {
          const val = parentSplitStyles.classNames[key];
          if (key in style || key in classNames)
            continue;
          classNames[key] = val;
        }
      }
    }
    if (!shouldDoClasses) {
      for (const key in parentSplitStyles.style) {
        if (key in classNames || key in style)
          continue;
        style[key] = parentSplitStyles.style[key];
      }
    }
  }
  if (true) {
    if (shouldDoClasses) {
      const retainedStyles = {};
      if (style["$$css"]) {
      } else {
        const atomic = (0,getStylesAtomic/* getStylesAtomic */.yq)(style);
        for (const atomicStyle of atomic) {
          const key = atomicStyle.property;
          if (props.animateOnly && props.animateOnly.includes(key)) {
            retainedStyles[key] = atomicStyle.value;
          } else {
            addStyleToInsertRules(rulesToInsert, atomicStyle);
            mergeClassName(transforms, classNames, key, atomicStyle.identifier);
          }
        }
        if (!IS_STATIC) {
          style = retainedStyles;
        }
      }
    }
    if (transforms) {
      for (const namespace in transforms) {
        if (!transforms[namespace]) {
          if (false) {}
          continue;
        }
        const [hash, val] = transforms[namespace];
        const identifier = `_transform${hash}`;
        if (esm/* isClient */.C5 && !insertStyleRule/* insertedTransforms */.MD[identifier]) {
          const rule = `.${identifier} { transform: ${val}; }`;
          addStyleToInsertRules(rulesToInsert, {
            identifier,
            rules: [rule],
            property: namespace
          });
        }
        classNames[namespace] = identifier;
      }
    }
  }
  const result = {
    space,
    hasMedia,
    fontFamily,
    viewProps,
    style,
    pseudos,
    classNames,
    rulesToInsert
  };
  if (className) {
    classNames.className = className;
  }
  if (false) {}
  cache.set(props, result);
  return result;
};
function mergeClassName(transforms, classNames, key, val, isMediaOrPseudo = false) {
  if (true) {
    if (!val)
      return;
    if (val[0] === "_" && val.startsWith("_transform-")) {
      const ns = isMediaOrPseudo ? key : "transform";
      let transform = insertStyleRule/* insertedTransforms */.MD[val];
      if (esm/* isClient */.C5 && !transform) {
        (0,insertStyleRule/* scanAllSheets */.jc)();
        transform = insertStyleRule/* insertedTransforms */.MD[val];
        if (!transform && esm/* isWeb */.$L && val[0] !== "_") {
          transform = val;
        }
      }
      transforms[ns] ||= ["", ""];
      transforms[ns][0] += val.replace("_transform", "");
      if (transform) {
        transforms[ns][1] += transform;
      }
    } else {
      classNames[key] = val;
    }
  }
}
const cache = /* @__PURE__ */ new WeakMap();
function getSubStyleProps(defaultProps, baseProps, specificProps) {
  const key = specificProps || baseProps;
  if (!cache.has(key)) {
    cache.set(key, {
      ...defaultProps,
      ...baseProps,
      ...specificProps
    });
  }
  return cache.get(key);
}
function mergeStyle({ usedKeys, classNames, viewProps, style }, flatTransforms, key, val, dontSetUsed = false) {
  if (!dontSetUsed) {
    usedKeys[key] ||= 1;
  }
  if (val && val[0] === "_") {
    classNames[key] = val;
  } else if (key in dist_esm.stylePropsTransform) {
    flatTransforms ||= {};
    flatTransforms[key] = val;
  } else {
    const out = (0,normalizeValueWithProperty/* normalizeValueWithProperty */.Y)(val, key);
    if (key in dist_esm.validStylesOnBaseProps) {
      viewProps[key] = out;
    } else {
      style[key] = out;
    }
  }
}
const getSubStyle = (styleState, subKey, styleIn, avoidDefaultProps, avoidMergeTransform) => {
  const { staticConfig, theme, props, state, conf: conf2, languageContext } = styleState;
  const styleOut = {};
  for (let key in styleIn) {
    const val = styleIn[key];
    key = conf2.shorthands[key] || key;
    const expanded = staticConfig.propMapper(
      key,
      val,
      theme,
      getSubStyleProps(staticConfig.defaultProps, props, props[subKey]),
      state,
      languageContext,
      avoidDefaultProps
    );
    if (!expanded)
      continue;
    for (const [skey, sval] of expanded) {
      if (!avoidMergeTransform && skey in dist_esm.stylePropsTransform) {
        mergeTransform(styleOut, skey, sval);
      } else {
        styleOut[skey] = (0,normalizeValueWithProperty/* normalizeValueWithProperty */.Y)(sval, key);
      }
    }
  }
  (0,expandStyles/* fixStyles */.S)(styleOut);
  return styleOut;
};
const insertSplitStyles = (...args) => {
  const res = getSplitStyles(...args);
  (0,insertStyleRule/* insertStyleRules */._N)(res.rulesToInsert);
  return res;
};
const useInsertEffectCompat = esm/* isWeb */.$L ? react.useInsertionEffect || esm/* useIsomorphicLayoutEffect */.LI : () => {
};
const useSplitStyles = (...args) => {
  const res = getSplitStyles(...args);
  if (!esm/* isRSC */.PS) {
    useInsertEffectCompat(() => {
      (0,insertStyleRule/* insertStyleRules */._N)(res.rulesToInsert);
    }, [res.rulesToInsert]);
  }
  return res;
};
function addStyleToInsertRules(rulesToInsert, styleObject) {
  if (true) {
    if (!(0,insertStyleRule/* shouldInsertStyleRules */.Jt)(styleObject)) {
      return;
    }
    (0,insertStyleRule/* updateRules */.GU)(styleObject.identifier, styleObject.rules);
    rulesToInsert.push(styleObject);
  }
}
function processIDRefList(idRefList) {
  return Array.isArray(idRefList) ? idRefList.join(" ") : idRefList;
}
const animatableDefaults = {
  opacity: 1,
  scale: 1,
  rotate: "0deg",
  rotateY: "0deg",
  rotateX: "0deg"
};
const lowercaseHyphenate = (match) => `-${match.toLowerCase()}`;
const hyphenate = (str) => str.replace(/[A-Z]/g, lowercaseHyphenate);
const mergeTransform = (obj, key, val, backwards = false) => {
  obj.transform ||= [];
  obj.transform[backwards ? "unshift" : "push"]({
    [mapTransformKeys[key] || key]: val
  });
};
const mergeTransforms = (obj, flatTransforms, backwards = false) => {
  Object.entries(flatTransforms).forEach(([key, val]) => {
    mergeTransform(obj, key, val, backwards);
  });
};
const mapTransformKeys = {
  x: "translateX",
  y: "translateY"
};

//# sourceMappingURL=getSplitStyles.js.map


/***/ }),

/***/ 89249:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FL": function() { return /* binding */ styleToCSS; },
/* harmony export */   "sG": function() { return /* binding */ getAtomicStyle; },
/* harmony export */   "yq": function() { return /* binding */ getStylesAtomic; }
/* harmony export */ });
/* harmony import */ var _tamagui_helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95591);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47269);
/* harmony import */ var _defaultOffset_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37649);
/* harmony import */ var _normalizeValueWithProperty_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35709);
/* harmony import */ var _pseudoDescriptors_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58325);





const pseudosOrdered = [
  _pseudoDescriptors_js__WEBPACK_IMPORTED_MODULE_1__/* .pseudoDescriptors.hoverStyle */ .Q.hoverStyle,
  _pseudoDescriptors_js__WEBPACK_IMPORTED_MODULE_1__/* .pseudoDescriptors.pressStyle */ .Q.pressStyle,
  _pseudoDescriptors_js__WEBPACK_IMPORTED_MODULE_1__/* .pseudoDescriptors.focusStyle */ .Q.focusStyle
];
function getStylesAtomic(stylesIn) {
  if (!(stylesIn.hoverStyle || stylesIn.pressStyle || stylesIn.focusStyle)) {
    return getAtomicStyle(stylesIn);
  }
  const { hoverStyle, pressStyle, focusStyle, ...base } = stylesIn;
  let res = [];
  for (const [index, style] of [hoverStyle, pressStyle, focusStyle, base].entries()) {
    if (!style)
      continue;
    const pseudo = pseudosOrdered[index];
    res = [...res, ...getAtomicStyle(style, pseudo)];
  }
  return res;
}
const cache = /* @__PURE__ */ new Map();
function getAtomicStyle(style, pseudo) {
  if (!style)
    return [];
  const key = JSON.stringify(style) + (pseudo ? JSON.stringify(pseudo) : "");
  if (cache.has(key)) {
    return cache.get(key);
  }
  if (cache.size > 800) {
    cache.clear();
  }
  if (false) {}
  const out = generateAtomicStyles(style, pseudo);
  cache.set(key, out);
  return out;
}
let conf;
const generateAtomicStyles = (styleIn, pseudo) => {
  conf = conf || (0,_config_js__WEBPACK_IMPORTED_MODULE_2__/* .getConfig */ .iE)();
  const style = styleIn;
  if (style.transform && Array.isArray(style.transform)) {
    style.transform = style.transform.map(
      // { scale: 2 } => 'scale(2)'
      // { translateX: 20 } => 'translateX(20px)'
      // { matrix: [1,2,3,4,5,6] } => 'matrix(1,2,3,4,5,6)'
      (transform) => {
        const type = Object.keys(transform)[0];
        const value = transform[type];
        if (type === "matrix" || type === "matrix3d") {
          return `${type}(${value.join(",")})`;
        }
        return `${type}(${(0,_normalizeValueWithProperty_js__WEBPACK_IMPORTED_MODULE_3__/* .normalizeValueWithProperty */ .Y)(value, type)})`;
      }
    ).join(" ");
  }
  styleToCSS(style);
  const out = [];
  for (const key in style) {
    const value = (0,_normalizeValueWithProperty_js__WEBPACK_IMPORTED_MODULE_3__/* .normalizeValueWithProperty */ .Y)(style[key], key);
    if (value == null || value == void 0)
      continue;
    const hash = presetHashes[value] ? value : typeof value === "string" ? (0,_tamagui_helpers__WEBPACK_IMPORTED_MODULE_0__.simpleHash)(value) : `${value}`.replace(".", "dot");
    const pseudoPrefix = pseudo ? `0${pseudo.name}-` : "";
    const shortProp = conf.inverseShorthands[key] || key;
    const identifier = `_${shortProp}-${pseudoPrefix}${hash}`;
    const rules = createAtomicRules(identifier, key, value, pseudo);
    const styleObject = {
      property: key,
      pseudo: pseudo == null ? void 0 : pseudo.name,
      value,
      identifier,
      rules
    };
    out.push(styleObject);
  }
  return out;
};
const presetHashes = {
  none: true
};
function styleToCSS(style) {
  const { shadowOffset, shadowRadius, shadowColor } = style;
  if (style.shadowRadius !== void 0) {
    const offset = shadowOffset || _defaultOffset_js__WEBPACK_IMPORTED_MODULE_4__/* .defaultOffset */ .Y;
    const shadow = `${(0,_normalizeValueWithProperty_js__WEBPACK_IMPORTED_MODULE_3__/* .normalizeValueWithProperty */ .Y)(
      offset.width
    )} ${(0,_normalizeValueWithProperty_js__WEBPACK_IMPORTED_MODULE_3__/* .normalizeValueWithProperty */ .Y)(offset.height)} ${(0,_normalizeValueWithProperty_js__WEBPACK_IMPORTED_MODULE_3__/* .normalizeValueWithProperty */ .Y)(
      shadowRadius
    )} ${shadowColor}`;
    style.boxShadow = style.boxShadow ? `${style.boxShadow}, ${shadow}` : shadow;
    style.shadowOffset = void 0;
    style.shadowRadius = void 0;
    style.shadowColor = void 0;
  }
  const { textShadowColor, textShadowOffset, textShadowRadius } = style;
  if (textShadowColor || textShadowOffset || textShadowRadius) {
    const { height, width } = textShadowOffset || _defaultOffset_js__WEBPACK_IMPORTED_MODULE_4__/* .defaultOffset */ .Y;
    const radius = textShadowRadius || 0;
    const color = (0,_normalizeValueWithProperty_js__WEBPACK_IMPORTED_MODULE_3__/* .normalizeValueWithProperty */ .Y)(textShadowColor, "textShadowColor");
    if (color && (height !== 0 || width !== 0 || radius !== 0)) {
      const blurRadius = (0,_normalizeValueWithProperty_js__WEBPACK_IMPORTED_MODULE_3__/* .normalizeValueWithProperty */ .Y)(radius);
      const offsetX = (0,_normalizeValueWithProperty_js__WEBPACK_IMPORTED_MODULE_3__/* .normalizeValueWithProperty */ .Y)(width);
      const offsetY = (0,_normalizeValueWithProperty_js__WEBPACK_IMPORTED_MODULE_3__/* .normalizeValueWithProperty */ .Y)(height);
      style.textShadow = `${offsetX} ${offsetY} ${blurRadius} ${color}`;
    }
    style.textShadowColor = void 0;
    style.textShadowOffset = void 0;
    style.textShadowRadius = void 0;
  }
}
function createDeclarationBlock(style, important = false) {
  let next = "";
  for (const key in style) {
    const prop = hyphenateStyleName(key);
    const value = style[key];
    next += `${prop}:${value}${important ? " !important" : ""};`;
  }
  return `{${next}}`;
}
const hcache = {};
const toHyphenLower = (match) => `-${match.toLowerCase()}`;
const hyphenateStyleName = (key) => {
  let val = hcache[key];
  if (val)
    return val;
  hcache[key] = val = key.replace(/[A-Z]/g, toHyphenLower);
  return val;
};
const pseudoSelectorPrefixes = (() => {
  const res = {};
  for (const key in _pseudoDescriptors_js__WEBPACK_IMPORTED_MODULE_1__/* .pseudoDescriptors */ .Q) {
    const pseudo = _pseudoDescriptors_js__WEBPACK_IMPORTED_MODULE_1__/* .pseudoDescriptors */ .Q[key];
    res[pseudo.name] = `${[...Array(pseudo.priority)].map(() => ":root").join("")} `;
  }
  return res;
})();
function createAtomicRules(identifier, property, value, pseudo) {
  const selector = pseudo ? `${pseudoSelectorPrefixes[pseudo.name]} .${identifier}:${pseudo.name}` : `.${identifier}`;
  const important = !!pseudo;
  let rules = [];
  switch (property) {
    case "placeholderTextColor": {
      const block = createDeclarationBlock({ color: value, opacity: 1 }, important);
      rules.push(`${selector}::placeholder${block}`);
      break;
    }
    case "backgroundClip":
    case "userSelect": {
      const propertyCapitalized = `${property[0].toUpperCase()}${property.slice(1)}`;
      const webkitProperty = `Webkit${propertyCapitalized}`;
      const block = createDeclarationBlock(
        { [property]: value, [webkitProperty]: value },
        important
      );
      rules.push(`${selector}${block}`);
      break;
    }
    case "pointerEvents": {
      let finalValue = value;
      if (value === "auto" || value === "box-only") {
        finalValue = "auto";
        if (value === "box-only") {
          rules.push(`${selector}>*${boxOnly}`);
        }
      } else if (value === "none" || value === "box-none") {
        finalValue = "none";
        if (value === "box-none") {
          rules.push(`${selector}>*${boxNone}`);
        }
      }
      const block = createDeclarationBlock({ pointerEvents: finalValue }, true);
      rules.push(`${selector}${block}`);
      break;
    }
    default: {
      const block = createDeclarationBlock({ [property]: value }, important);
      rules.push(`${selector}${block}`);
      break;
    }
  }
  if (pseudo && pseudo.name === "hover") {
    rules = rules.map((r) => `@media not all and (hover: none) { ${r} }`);
  }
  return rules;
}
const boxNone = createDeclarationBlock({ pointerEvents: "auto" }, true);
const boxOnly = createDeclarationBlock({ pointerEvents: "none" }, true);

//# sourceMappingURL=getStylesAtomic.js.map


/***/ }),

/***/ 54024:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ getThemeCSSRules; }
/* harmony export */ });
/* harmony import */ var _tamagui_helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95591);
/* harmony import */ var _constants_constants_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74288);
/* harmony import */ var _createVariable_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13209);
/* harmony import */ var _registerCSSVariable_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26095);




function getThemeCSSRules({
  config,
  themeName,
  theme,
  names
}) {
  const cssRuleSets = [];
  const hasDarkLight = "light" in config.themes && "dark" in config.themes;
  const CNP = `.${_constants_constants_js__WEBPACK_IMPORTED_MODULE_1__/* .THEME_CLASSNAME_PREFIX */ .nx}`;
  let vars = "";
  for (const themeKey in theme) {
    const variable = theme[themeKey];
    let value = null;
    if (!_registerCSSVariable_js__WEBPACK_IMPORTED_MODULE_2__/* .tokensValueToVariable.has */ .c.has(variable.val)) {
      value = variable.val;
    } else {
      value = _registerCSSVariable_js__WEBPACK_IMPORTED_MODULE_2__/* .tokensValueToVariable.get */ .c.get(variable.val).variable;
    }
    vars += `--${(0,_tamagui_helpers__WEBPACK_IMPORTED_MODULE_0__.simpleHash)(themeKey, 40)}:${value};`;
  }
  const isDarkOrLightBase = themeName === "dark" || themeName === "light";
  const selectorsSet = new Set(
    names.map((name) => {
      return `${CNP}${name}`;
    })
  );
  if (hasDarkLight) {
    for (const subName of names) {
      const isDark = themeName === "dark" || subName.startsWith("dark_");
      const maxDepth = config.maxDarkLightNesting ?? 3;
      if (!(isDark || subName.startsWith("light_"))) {
        selectorsSet.add(`:root:root ${CNP}${subName}`);
        continue;
      }
      const childSelector = `${CNP}${subName.replace(isDark ? "dark_" : "light_", "")}`;
      const [altLightDark, altSubTheme] = [
        isDark ? ["dark", "light"] : ["light", "dark"],
        isDark ? ["dark", "sub_theme"] : ["light", "sub_theme"]
      ];
      for (const order of [altLightDark, altSubTheme]) {
        if (isDarkOrLightBase) {
          order.reverse();
        }
        const [stronger, weaker] = order;
        const numSelectors = Math.round(maxDepth * 1.5);
        for (let depth = 0; depth < numSelectors; depth++) {
          const isOdd = depth % 2 === 1;
          if (isOdd && depth < 3) {
            continue;
          }
          const parents = new Array(depth + 1).fill(0).map((_, psi) => {
            return `${CNP}${psi % 2 === 0 ? stronger : weaker}`;
          });
          let parentSelectors = parents.length > 1 ? parents.slice(1) : parents;
          if (isOdd) {
            const [_first, second, ...rest] = parentSelectors;
            parentSelectors = [second, ...rest, second];
          }
          const lastParentSelector = parentSelectors[parentSelectors.length - 1];
          const nextChildSelector = childSelector === lastParentSelector ? "" : childSelector;
          selectorsSet.add(`${parentSelectors.join(" ")} ${nextChildSelector}`.trim());
        }
      }
    }
  }
  const selectors = [...selectorsSet];
  const selectorsString = selectors.map((x) => {
    const rootSep = isBaseTheme(x) && config.themeClassNameOnRoot ? "" : " ";
    return `:root${rootSep}${x}`;
  }).join(", ");
  const css = `${selectorsString} {${vars}}`;
  cssRuleSets.push(css);
  if (config.shouldAddPrefersColorThemes) {
    const bgString = (0,_createVariable_js__WEBPACK_IMPORTED_MODULE_3__/* .variableToString */ .lk)(theme.background);
    const fgString = (0,_createVariable_js__WEBPACK_IMPORTED_MODULE_3__/* .variableToString */ .lk)(theme.color);
    const bodyRules = `body{background:${bgString};color:${fgString};}`;
    const isDark = themeName.startsWith("dark");
    const baseName = isDark ? "dark" : "light";
    const lessSpecificSelectors = selectors.map((x) => {
      if (x == darkSelector || x === lightSelector)
        return `:root`;
      return x.replace(/^\.t_(dark|light) /, "").trim();
    }).filter(Boolean).join(", ");
    const themeRules = `${lessSpecificSelectors} {${vars}}`;
    const prefersMediaSelectors = `@media(prefers-color-scheme:${baseName}){
  ${bodyRules}
  ${themeRules}
}`;
    cssRuleSets.push(prefersMediaSelectors);
  }
  return cssRuleSets;
}
const darkSelector = ".t_dark";
const lightSelector = ".t_light";
const isBaseTheme = (x) => x === darkSelector || x === lightSelector || x.startsWith(".t_dark ") || x.startsWith(".t_light ");

//# sourceMappingURL=getThemeCSSRules.js.map


/***/ }),

/***/ 40192:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ getVariantExtras; },
/* harmony export */   "r": function() { return /* binding */ getFontsForLanguage; }
/* harmony export */ });
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47269);
/* harmony import */ var _createProxy_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37264);


const extrasCache = /* @__PURE__ */ new WeakMap();
function getVariantExtras(props, languageContext, theme, defaultProps, avoidDefaultProps = false) {
  const conf = (0,_config_js__WEBPACK_IMPORTED_MODULE_0__/* .getConfig */ .iE)();
  if (extrasCache.has(props)) {
    return extrasCache.get(props);
  }
  let fonts = conf.fontsParsed;
  if (languageContext) {
    fonts = getFontsForLanguage(conf.fontsParsed, languageContext);
  }
  const next = {
    fonts,
    tokens: conf.tokensParsed,
    theme,
    // TODO do this in splitstlye
    // we avoid passing in default props for media queries because that would confuse things like SizableText.size:
    props: avoidDefaultProps ? props : (0,_createProxy_js__WEBPACK_IMPORTED_MODULE_1__/* .createProxy */ .D)(props, {
      // handles shorthands
      get(target, key) {
        const shorthand = conf.inverseShorthands[key];
        if (shorthand && Reflect.has(target, shorthand)) {
          return Reflect.get(target, shorthand);
        }
        if (Reflect.has(target, key)) {
          return Reflect.get(target, key);
        }
        if (defaultProps) {
          if (shorthand && Reflect.has(defaultProps, shorthand)) {
            return Reflect.get(defaultProps, shorthand);
          }
          if (Reflect.has(defaultProps, key)) {
            return Reflect.get(defaultProps, key);
          }
        }
      }
    })
  };
  extrasCache.set(props, next);
  return next;
}
const fontLanguageCache = /* @__PURE__ */ new WeakMap();
function getFontsForLanguage(fonts, language) {
  if (fontLanguageCache.has(language)) {
    return fontLanguageCache.get(language);
  }
  const next = {
    ...fonts,
    ...Object.fromEntries(
      Object.entries(language).map(([name, lang]) => {
        if (lang === "default") {
          return [];
        }
        const langKey = `$${name}_${lang}`;
        return [`$${name}`, fonts[langKey]];
      })
    )
  };
  fontLanguageCache.set(language, next);
  return next;
}

//# sourceMappingURL=getVariantExtras.js.map


/***/ }),

/***/ 16746:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GU": function() { return /* binding */ updateRules; },
/* harmony export */   "Jt": function() { return /* binding */ shouldInsertStyleRules; },
/* harmony export */   "MD": function() { return /* binding */ insertedTransforms; },
/* harmony export */   "OJ": function() { return /* binding */ listenForSheetChanges; },
/* harmony export */   "UY": function() { return /* binding */ getAllRules; },
/* harmony export */   "_N": function() { return /* binding */ insertStyleRules; },
/* harmony export */   "jc": function() { return /* binding */ scanAllSheets; },
/* harmony export */   "lj": function() { return /* binding */ getAllTransforms; },
/* harmony export */   "tN": function() { return /* binding */ getAllSelectors; }
/* harmony export */ });
const allSelectors = {};
const allRules = {};
const insertedTransforms = {};
const getAllSelectors = () => allSelectors;
const getAllRules = () => Object.values(allRules);
const getAllTransforms = () => insertedTransforms;
function addTransform(identifier, css, rule) {
  const s = css.indexOf("transform:");
  if (s === -1) {
    if (false) {}
    return false;
  }
  const startI = s + "transform:".length;
  const endI = css.indexOf(";");
  const value = css.slice(startI, endI);
  if (!insertedTransforms[identifier]) {
    insertedTransforms[identifier] = value;
    return true;
  }
  return false;
}
const isClient = typeof document !== "undefined";
const scannedCache = /* @__PURE__ */ new WeakMap();
const totalSheetSelectors = /* @__PURE__ */ new Map();
function listenForSheetChanges() {
  if (!isClient)
    return;
  function handleNode(node, remove = false) {
    if (node instanceof HTMLStyleElement && node.sheet) {
      updateSheetStyles(node.sheet, remove);
    }
  }
  const mo = new MutationObserver((entries) => {
    for (const entry of entries) {
      entry.addedNodes.forEach((node) => handleNode(node));
      entry.removedNodes.forEach((node) => handleNode(node, true));
    }
  });
  mo.observe(document.head, {
    childList: true
  });
}
function scanAllSheets() {
  if (false)
    {}
  if (!isClient)
    return;
  const sheets = document.styleSheets;
  if (!sheets)
    return;
  for (let i = 0; i < sheets.length; i++) {
    const sheet2 = sheets[i];
    if (!sheet2)
      continue;
    updateSheetStyles(sheet2);
  }
}
function track(id, remove = false) {
  const next = (totalSheetSelectors.get(id) || 0) + (remove ? -1 : 1);
  totalSheetSelectors.set(id, next);
  return next;
}
function updateSheetStyles(sheet2, remove = false) {
  var _a, _b;
  let rules;
  try {
    rules = sheet2.cssRules;
  } catch {
    return;
  }
  const firstSelector = (_a = getTamaguiSelector(rules[0])) == null ? void 0 : _a[0];
  if (!firstSelector) {
    return;
  }
  const lastSelector = (_b = getTamaguiSelector(rules[rules.length - 1])) == null ? void 0 : _b[0];
  const cacheKey = `${rules.length}${firstSelector}${lastSelector}`;
  const lastScanned = scannedCache.get(sheet2);
  if (!remove) {
    if (lastScanned === cacheKey) {
      return;
    }
  }
  const len = rules.length;
  for (let i = 0; i < len; i++) {
    const rule = rules[i];
    const response = getTamaguiSelector(rule);
    if (!response) {
      return;
    }
    const [identifier, cssRule] = response;
    const total = track(identifier, remove);
    if (remove) {
      if (total === 0) {
        delete allSelectors[identifier];
      }
    } else {
      if (!(identifier in allSelectors)) {
        const isTransform = identifier.startsWith("_transform");
        const shouldInsert = isTransform ? addTransform(identifier, cssRule.cssText, cssRule) : true;
        if (shouldInsert) {
          allSelectors[identifier] = cssRule.cssText;
        }
      }
    }
  }
  scannedCache.set(sheet2, cacheKey);
}
function getTamaguiSelector(rule) {
  if (rule instanceof CSSStyleRule) {
    const text = rule.selectorText;
    if (text[0] === "." && text[1] === "_") {
      return [text.slice(1), rule];
    }
    if (text.startsWith(":root") && text.includes("._")) {
      return [getIdentifierFromTamaguiSelector(text), rule];
    }
  } else if (rule instanceof CSSMediaRule) {
    if (rule.cssRules.length > 1)
      return null;
    return getTamaguiSelector(rule.cssRules[0]);
  }
  return null;
}
const getIdentifierFromTamaguiSelector = (selector) => selector.replace(/(:root)+\s+/, "").replace(/:[a-z]+$/, "").slice(1);
const sheet = isClient ? document.head.appendChild(document.createElement("style")).sheet : null;
function updateRules(identifier, rules) {
  if (allRules[identifier])
    return false;
  allRules[identifier] = rules.join(" ");
  if (identifier.startsWith("_transform")) {
    return addTransform(identifier, rules[0]);
  }
  return true;
}
function insertStyleRules(rulesToInsert) {
  if (!rulesToInsert.length)
    return;
  if (isClient && !sheet) {
    if (false)
      {}
    return;
  }
  for (const { identifier, rules } of rulesToInsert) {
    if (identifier in allSelectors)
      continue;
    allSelectors[identifier] =  false ? 0 : " ";
    updateRules(identifier, rules);
    if (sheet) {
      for (const rule of rules) {
        try {
          sheet.insertRule(rule, sheet.cssRules.length);
        } catch (err) {
          if (false) {}
        }
      }
    }
  }
}
const IS_STATIC = "" === "is_static";
function shouldInsertStyleRules(styleObject) {
  if (IS_STATIC) {
    return true;
  }
  return !(styleObject.identifier in allSelectors);
}

//# sourceMappingURL=insertStyleRule.js.map


/***/ }),

/***/ 85120:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ isTamaguiComponent; }
/* harmony export */ });
function isTamaguiComponent(comp, name) {
  const config = comp == null ? void 0 : comp["staticConfig"];
  return (config == null ? void 0 : config.parsed) && (name ? name === config.componentName : true) || false;
}

//# sourceMappingURL=isTamaguiComponent.js.map


/***/ }),

/***/ 67423:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ isTamaguiElement; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _isTamaguiComponent_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85120);


const isTamaguiElement = (child, name) => {
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.isValidElement)(child) && (0,_isTamaguiComponent_js__WEBPACK_IMPORTED_MODULE_1__/* .isTamaguiComponent */ .R)(child.type, name);
};

//# sourceMappingURL=isTamaguiElement.js.map


/***/ }),

/***/ 80906:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ setupMatchMedia; },
/* harmony export */   "L": function() { return /* binding */ matchMedia; }
/* harmony export */ });
const matchMedia = typeof window !== "undefined" && window.matchMedia || matchMediaFallback;
function matchMediaFallback(_) {
  return {
    addListener() {
    },
    removeListener() {
    },
    matches: false
  };
}
function setupMatchMedia(_) {
}

//# sourceMappingURL=matchMedia.js.map


/***/ }),

/***/ 88410:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ mergeProps; }
/* harmony export */ });
const mergeProps = (a, b, leaveOutClassNames = false, inverseShorthands) => {
  const out = {};
  const outCns = leaveOutClassNames ? {} : null;
  for (const key in a) {
    mergeProp(out, outCns, a, b, key, leaveOutClassNames, inverseShorthands);
  }
  for (const key in b) {
    mergeProp(out, outCns, b, void 0, key, leaveOutClassNames, inverseShorthands);
  }
  return [out, outCns];
};
function mergeProp(out, outCns, a, b, key, leaveOutClassNames, inverseShorthands) {
  const val = a[key];
  const shorthand = (inverseShorthands == null ? void 0 : inverseShorthands[key]) || null;
  if (b && (key in b || shorthand && shorthand in b)) {
    return;
  }
  if (shorthand) {
    key = shorthand;
  }
  if (leaveOutClassNames && (val == null ? void 0 : val[0]) === "_") {
    outCns[key] = val;
  } else {
    out[key] = val;
  }
}

//# sourceMappingURL=mergeProps.js.map


/***/ }),

/***/ 97202:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "R5": function() { return /* binding */ normalizeColor_names; },
  "ut": function() { return /* binding */ normalizeColor; },
  "m4": function() { return /* binding */ normalizeColor_rgba; }
});

// EXTERNAL MODULE: ./node_modules/@tamagui/constants/dist/esm/index.mjs
var esm = __webpack_require__(11649);
;// CONCATENATED MODULE: ./node_modules/@tamagui/normalize-css-color/dist/esm/names.js
/* provided dependency */ var process = __webpack_require__(34406);
const names = {
  // keep the basics
  transparent: 0,
  white: 4294967295,
  black: 255
};
if (process.env.INCLUDE_CSS_COLOR_NAMES || "web" === "native") {
  const allNames = (__webpack_require__(73347)/* .names */ .R);
  Object.assign(names, allNames);
}

//# sourceMappingURL=names.js.map

;// CONCATENATED MODULE: ./node_modules/@tamagui/normalize-css-color/dist/esm/index.mjs


function normalizeCSSColor(color) {
  let match = null;
  if (color in names) {
    return names[color];
  }
  if (typeof color === "number") {
    if (color >>> 0 === color && color >= 0 && color <= 4294967295) {
      return color;
    }
    return null;
  }
  if (match = matchers.hex6.exec(color)) {
    return parseInt(match[1] + "ff", 16) >>> 0;
  }
  if (match = matchers.rgb.exec(color)) {
    return (parse255(match[1]) << 24 | // r
    parse255(match[2]) << 16 | // g
    parse255(match[3]) << 8 | // b
    255) >>> // a
    0;
  }
  if (match = matchers.rgba.exec(color)) {
    return (parse255(match[1]) << 24 | // r
    parse255(match[2]) << 16 | // g
    parse255(match[3]) << 8 | // b
    parse1(match[4])) >>> // a
    0;
  }
  if (match = matchers.hex3.exec(color)) {
    return parseInt(
      match[1] + match[1] + // r
      match[2] + match[2] + // g
      match[3] + match[3] + // b
      "ff",
      // a
      16
    ) >>> 0;
  }
  if (match = matchers.hex8.exec(color)) {
    return parseInt(match[1], 16) >>> 0;
  }
  if (match = matchers.hex4.exec(color)) {
    return parseInt(
      match[1] + match[1] + // r
      match[2] + match[2] + // g
      match[3] + match[3] + // b
      match[4] + match[4],
      // a
      16
    ) >>> 0;
  }
  if (match = matchers.hsl.exec(color)) {
    return (hslToRgb(
      parse360(match[1]),
      // h
      parsePercentage(match[2]),
      // s
      parsePercentage(match[3])
      // l
    ) | 255) >>> // a
    0;
  }
  if (match = matchers.hsla.exec(color)) {
    return (hslToRgb(
      parse360(match[1]),
      // h
      parsePercentage(match[2]),
      // s
      parsePercentage(match[3])
      // l
    ) | parse1(match[4])) >>> // a
    0;
  }
  return null;
}
function hue2rgb(p, q, t) {
  if (t < 0) {
    t += 1;
  }
  if (t > 1) {
    t -= 1;
  }
  if (t < 1 / 6) {
    return p + (q - p) * 6 * t;
  }
  if (t < 1 / 2) {
    return q;
  }
  if (t < 2 / 3) {
    return p + (q - p) * (2 / 3 - t) * 6;
  }
  return p;
}
function hslToRgb(h, s, l) {
  var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
  var p = 2 * l - q;
  var r = hue2rgb(p, q, h + 1 / 3);
  var g = hue2rgb(p, q, h);
  var b = hue2rgb(p, q, h - 1 / 3);
  return Math.round(r * 255) << 24 | Math.round(g * 255) << 16 | Math.round(b * 255) << 8;
}
var NUMBER = "[-+]?\\d*\\.?\\d+";
var PERCENTAGE = NUMBER + "%";
function call(...args) {
  return "\\(\\s*(" + args.join(")\\s*,\\s*(") + ")\\s*\\)";
}
var matchers = {
  rgb: new RegExp("rgb" + call(NUMBER, NUMBER, NUMBER)),
  rgba: new RegExp("rgba" + call(NUMBER, NUMBER, NUMBER, NUMBER)),
  hsl: new RegExp("hsl" + call(NUMBER, PERCENTAGE, PERCENTAGE)),
  hsla: new RegExp("hsla" + call(NUMBER, PERCENTAGE, PERCENTAGE, NUMBER)),
  hex3: /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex4: /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex6: /^#([0-9a-fA-F]{6})$/,
  hex8: /^#([0-9a-fA-F]{8})$/
};
function parse255(str) {
  var int = parseInt(str, 10);
  if (int < 0) {
    return 0;
  }
  if (int > 255) {
    return 255;
  }
  return int;
}
function parse360(str) {
  var int = parseFloat(str);
  return (int % 360 + 360) % 360 / 360;
}
function parse1(str) {
  var num = parseFloat(str);
  if (num < 0) {
    return 0;
  }
  if (num > 1) {
    return 255;
  }
  return Math.round(num * 255);
}
function parsePercentage(str) {
  const int = parseFloat(str, 10);
  if (int < 0) {
    return 0;
  }
  if (int > 100) {
    return 1;
  }
  return int / 100;
}
function rgba(colorInt) {
  var r = Math.round((colorInt & 4278190080) >>> 24);
  var g = Math.round((colorInt & 16711680) >>> 16);
  var b = Math.round((colorInt & 65280) >>> 8);
  var a = ((colorInt & 255) >>> 0) / 255;
  return {
    r,
    g,
    b,
    a
  };
}
var src_default = (/* unused pure expression or super */ null && (normalizeCSSColor));

//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ./node_modules/@tamagui/web/dist/esm/helpers/normalizeColor.js


const normalizeColor_rgba = rgba;
const normalizeColor_names = names;
const normalizeColor = (color, opacity) => {
  if (!color)
    return;
  if (color[0] === "$")
    return color;
  if (esm/* isWeb */.$L && opacity === 1)
    return color;
  const colorProcessed = normalizeCSSColor(color);
  if (typeof colorProcessed === "number") {
    const { r, g, b, a } = normalizeColor_rgba(colorProcessed);
    const alpha = (opacity ?? a ?? 1).toFixed(2);
    return `rgba(${r},${g},${b},${alpha})`;
  }
  if (false) {}
  return color;
};

//# sourceMappingURL=normalizeColor.js.map


/***/ }),

/***/ 35709:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Y": function() { return /* binding */ normalizeValueWithProperty; },
  "R": function() { return /* binding */ reverseMapClassNameToValue; }
});

// EXTERNAL MODULE: ./node_modules/@tamagui/constants/dist/esm/index.mjs
var esm = __webpack_require__(11649);
// EXTERNAL MODULE: ./node_modules/@tamagui/web/dist/esm/helpers/insertStyleRule.js
var insertStyleRule = __webpack_require__(16746);
// EXTERNAL MODULE: ./node_modules/@tamagui/web/dist/esm/helpers/normalizeColor.js + 2 modules
var normalizeColor = __webpack_require__(97202);
;// CONCATENATED MODULE: ./node_modules/@tamagui/web/dist/esm/helpers/normalizeStylePropKeys.js
const normalizeStylePropKeys = {};

//# sourceMappingURL=normalizeStylePropKeys.js.map

;// CONCATENATED MODULE: ./node_modules/@tamagui/web/dist/esm/helpers/normalizeValueWithProperty.js




const colorCache = {};
function normalizeValueWithProperty(value, property) {
  if (value in colorCache) {
    return colorCache[value];
  }
  if (property && property in unitlessNumbers) {
    return value;
  }
  let res = value;
  if (property && (property in normalizeStylePropKeys || value in normalizeColor/* names */.R5)) {
    res = (0,normalizeColor/* normalizeColor */.ut)(value);
    colorCache[value] = res;
  } else if ( true && typeof value === "number" && (property === void 0 || !(property in unitlessNumbers || property in stringNumbers))) {
    res = `${value}px`;
  } else if (esm/* isWeb */.$L && property !== void 0 && property in stringNumbers) {
    res = `${res}`;
  }
  return res;
}
const stringNumbers = {
  zIndex: true
};
const unitlessNumbers = {
  WebkitLineClamp: true,
  animationIterationCount: true,
  aspectRatio: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  columnCount: true,
  flex: true,
  flexGrow: true,
  flexBasis: true,
  flexOrder: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  fontWeight: true,
  gridRow: true,
  gridRowEnd: true,
  gridRowGap: true,
  gridRowStart: true,
  gridColumn: true,
  gridColumnEnd: true,
  gridColumnGap: true,
  gridColumnStart: true,
  lineClamp: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zoom: true,
  scale: true,
  scaleX: true,
  scaleY: true,
  scaleZ: true,
  shadowOpacity: true
};
const rcache = {};
function reverseMapClassNameToValue(key, className) {
  const selectors = (0,insertStyleRule/* getAllSelectors */.tN)();
  const cssRule = selectors[className];
  if (rcache[cssRule])
    return rcache[cssRule];
  if (!cssRule) {
    return;
  }
  const cssVal = cssRule.replace(/.*:/, "").replace(/;.*/, "").trim();
  let res;
  if (cssVal.startsWith("var(")) {
    res = cssVal;
  } else if (unitlessNumbers[key]) {
    res = +cssVal;
  } else if (cssVal.endsWith("px")) {
    res = +cssVal.replace("px", "");
  } else {
    res = cssVal;
  }
  rcache[cssRule] = res;
  if (false) {}
  return res;
}

//# sourceMappingURL=normalizeValueWithProperty.js.map


/***/ }),

/***/ 8503:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ proxyThemeVariables; }
/* harmony export */ });
/* harmony import */ var _createProxy_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37264);

function proxyThemeVariables(obj) {
  return (0,_createProxy_js__WEBPACK_IMPORTED_MODULE_0__/* .createProxy */ .D)(obj || {}, {
    has(target, key) {
      return Reflect.has(target, removeStarting$(key));
    },
    get(target, key) {
      return Reflect.get(target, removeStarting$(key));
    }
  });
}
const removeStarting$ = (str) => typeof str === "string" && str[0] === "$" ? str.slice(1) : str;

//# sourceMappingURL=proxyThemeVariables.js.map


/***/ }),

/***/ 58325:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ pseudoDescriptors; }
/* harmony export */ });
const pseudoDescriptors = {
  hoverStyle: {
    name: "hover",
    priority: 1
  },
  pressStyle: {
    name: "active",
    stateKey: "press",
    priority: 2
  },
  focusStyle: {
    name: "focus",
    priority: 3
  },
  enterStyle: {
    name: "enter",
    stateKey: "unmounted",
    priority: 4
  },
  exitStyle: {
    name: "exit",
    stateKey: "isExiting",
    priority: 5
  }
};

//# sourceMappingURL=pseudoDescriptors.js.map


/***/ }),

/***/ 26095:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Im": function() { return /* binding */ registerCSSVariable; },
/* harmony export */   "c": function() { return /* binding */ tokensValueToVariable; },
/* harmony export */   "nw": function() { return /* binding */ variableToCSS; }
/* harmony export */ });
/* harmony import */ var _createVariable_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13209);

const registerCSSVariable = (v) => {
  tokensValueToVariable.set(v.val, v);
};
const variableToCSS = (v) => {
  return `--${(0,_createVariable_js__WEBPACK_IMPORTED_MODULE_0__/* .createCSSVariable */ .bK)(v.name, false)}:${typeof v.val === "number" ? `${v.val}px` : v.val}`;
};
const tokensValueToVariable = /* @__PURE__ */ new Map();

//# sourceMappingURL=registerCSSVariable.js.map


/***/ }),

/***/ 8573:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ themeable; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _views_Theme_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56283);



function themeable(component, opts) {
  const withThemeComponent = (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function WithTheme(props, ref) {
    const { themeInverse, theme, componentName, themeReset, ...rest } = props;
    const element = react__WEBPACK_IMPORTED_MODULE_1__.createElement(component, { ...rest, ref });
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
      _views_Theme_js__WEBPACK_IMPORTED_MODULE_2__/* .Theme */ .Q,
      {
        inverse: themeInverse,
        componentName: componentName || (opts == null ? void 0 : opts.componentName),
        name: theme || null,
        "data-themeable": true,
        debug: props.debug,
        reset: props.themeReset,
        children: element
      }
    );
  });
  const withTheme = withThemeComponent;
  withTheme.displayName = `Themed(${(component == null ? void 0 : component.displayName) || (component == null ? void 0 : component.name) || "Anonymous"})`;
  return withTheme;
}

//# sourceMappingURL=themeable.js.map


/***/ }),

/***/ 13027:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ proxyThemeToParents; },
/* harmony export */   "n": function() { return /* binding */ ensureThemeVariable; }
/* harmony export */ });
/* harmony import */ var _createVariable_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13209);
/* harmony import */ var _hooks_getThemeUnwrapped_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4195);


function ensureThemeVariable(theme, key) {
  const val = theme[key];
  const themeKey = key;
  if (!(0,_createVariable_js__WEBPACK_IMPORTED_MODULE_0__/* .isVariable */ .cG)(val)) {
    theme[key] = (0,_createVariable_js__WEBPACK_IMPORTED_MODULE_0__/* .createVariable */ .Os)({
      key: themeKey,
      name: themeKey,
      val
    });
  } else {
    if (val.name !== themeKey) {
      theme[key] = (0,_createVariable_js__WEBPACK_IMPORTED_MODULE_0__/* .createVariable */ .Os)({
        key: val.name,
        name: themeKey,
        val: val.val
      });
    }
  }
}
function proxyThemeToParents(themeName, theme, themes) {
  const cur = [];
  const parents = themeName.split("_").slice(0, -1).map((part) => {
    cur.push(part);
    return cur.join("_");
  });
  const numParents = parents.length;
  return new Proxy(theme, {
    get(target, key) {
      if (key === _hooks_getThemeUnwrapped_js__WEBPACK_IMPORTED_MODULE_1__/* .GetThemeUnwrapped */ .N)
        return theme;
      if (numParents && !Reflect.has(target, key)) {
        for (let i = numParents - 1; i >= 0; i--) {
          const parent = themes[parents[i]];
          if (!parent)
            continue;
          if (Reflect.has(parent, key)) {
            return Reflect.get(parent, key);
          }
        }
      }
      return Reflect.get(target, key);
    }
  });
}

//# sourceMappingURL=themes.js.map


/***/ }),

/***/ 1493:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ useShallowSetState; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

function useShallowSetState(setter, debug, debugName) {
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (next) => {
      const shouldTransition = Object.keys(next).every(
        (k) => transitionKeys.has(k)
      );
      const run = shouldTransition ? react__WEBPACK_IMPORTED_MODULE_0__.startTransition : (_) => _();
      run(() => {
        setter((prev) => {
          for (const key in next) {
            if (prev[key] !== next[key]) {
              if (false) {}
              return { ...prev, ...next };
            }
          }
          return prev;
        });
      });
    },
    [setter]
  );
}
const transitionKeys = /* @__PURE__ */ new Set([
  "press",
  "pressIn",
  "focus",
  "unmounted"
]);

//# sourceMappingURL=useShallowSetState.js.map


/***/ }),

/***/ 74387:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ withStaticProperties; }
/* harmony export */ });
const withStaticProperties = function(component, staticProps) {
  const next = typeof component === "function" ? component : { ...component };
  Object.assign(next, staticProps);
  return next;
};

//# sourceMappingURL=withStaticProperties.js.map


/***/ }),

/***/ 4195:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ GetThemeUnwrapped; },
/* harmony export */   "Y": function() { return /* binding */ getThemeUnwrapped; }
/* harmony export */ });
const getThemeUnwrapped = (theme) => {
  return (theme == null ? void 0 : theme[GetThemeUnwrapped]) || theme;
};
const GetThemeUnwrapped = Symbol();

//# sourceMappingURL=getThemeUnwrapped.js.map


/***/ }),

/***/ 33744:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* reexport safe */ react__WEBPACK_IMPORTED_MODULE_0__.useId; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);


//# sourceMappingURL=useId.js.map


/***/ }),

/***/ 45856:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ useIsTouchDevice; }
/* harmony export */ });
/* harmony import */ var _tamagui_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11649);
/* harmony import */ var _tamagui_use_did_finish_ssr__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43635);


const useIsTouchDevice = () => {
  return !_tamagui_constants__WEBPACK_IMPORTED_MODULE_0__/* .isWeb */ .$L ? true : (0,_tamagui_use_did_finish_ssr__WEBPACK_IMPORTED_MODULE_1__/* .useDidFinishSSR */ .S)() ? _tamagui_constants__WEBPACK_IMPORTED_MODULE_0__/* .isTouchable */ .wT : false;
};

//# sourceMappingURL=useIsTouchDevice.js.map


/***/ }),

/***/ 5755:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GS": function() { return /* binding */ useMedia; },
/* harmony export */   "Pb": function() { return /* binding */ mergeMediaByImportance; },
/* harmony export */   "Zv": function() { return /* binding */ setMediaShouldUpdate; },
/* harmony export */   "aN": function() { return /* binding */ mediaQueryConfig; },
/* harmony export */   "ae": function() { return /* binding */ getMediaImportanceIfMoreImportant; },
/* harmony export */   "jl": function() { return /* binding */ configureMedia; },
/* harmony export */   "lA": function() { return /* binding */ useMediaPropsActive; },
/* harmony export */   "nA": function() { return /* binding */ mediaState; },
/* harmony export */   "om": function() { return /* binding */ getMedia; },
/* harmony export */   "sZ": function() { return /* binding */ mediaKeysWithAndWithout$; },
/* harmony export */   "xn": function() { return /* binding */ useMediaListeners; },
/* harmony export */   "yS": function() { return /* binding */ mediaObjectToString; }
/* harmony export */ });
/* unused harmony exports getInitialMediaState, getMediaKeyImportance, setupMediaListeners */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _helpers_matchMedia__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80906);
/* harmony import */ var _useSafeRef_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67180);





let mediaState = (
  // development only safeguard
   false ? 0 : {}
);
const mediaQueryConfig = {};
const getMedia = () => mediaState;
const mediaKeysWithAndWithout$ = /* @__PURE__ */ new Set();
let initState;
const getInitialMediaState = () => {
  return (getConfig().disableSSR ? mediaState : initState) || {};
};
let mediaKeysOrdered;
const getMediaKeyImportance = (key) => {
  if (false) {}
  return mediaKeysOrdered.indexOf(key) + 2;
};
const dispose = /* @__PURE__ */ new Set();
const configureMedia = (config) => {
  const { media, mediaQueryDefaultActive } = config;
  if (!media)
    return;
  for (const key in media) {
    mediaState[key] = (mediaQueryDefaultActive == null ? void 0 : mediaQueryDefaultActive[key]) || false;
    mediaKeysWithAndWithout$.add(key);
    mediaKeysWithAndWithout$.add(`$${key}`);
  }
  Object.assign(mediaQueryConfig, media);
  initState = { ...mediaState };
  updateCurrentState();
  mediaKeysOrdered = Object.keys(media);
  if (config.disableSSR) {
    setupMediaListeners();
  }
};
function unlisten() {
  dispose.forEach((cb) => cb());
  dispose.clear();
}
let configuredKey = "";
function setupMediaListeners() {
  const nextKey = JSON.stringify(mediaQueryConfig);
  if (nextKey === configuredKey)
    return;
  configuredKey = nextKey;
  unlisten();
  for (const key in mediaQueryConfig) {
    let update2 = function() {
      const next = !!getMatch().matches;
      if (next === mediaState[key])
        return;
      mediaState = { ...mediaState, [key]: next };
      updateCurrentState();
    };
    var update = update2;
    const str = mediaObjectToString(mediaQueryConfig[key]);
    const getMatch = () => (0,_helpers_matchMedia__WEBPACK_IMPORTED_MODULE_1__/* .matchMedia */ .L)(str);
    const match = getMatch();
    if (!match) {
      throw new Error("\u26A0\uFE0F No match");
    }
    match.addListener(update2);
    dispose.add(() => {
      match.removeListener(update2);
    });
    update2();
  }
}
function useMediaListeners(config) {
  if (config.disableSSR)
    return;
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    setupMediaListeners();
  }, []);
}
const listeners = /* @__PURE__ */ new Set();
let flushing = false;
function updateCurrentState() {
  if (flushing)
    return;
  flushing = true;
  Promise.resolve().then(() => {
    flushing = false;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.startTransition)(() => {
      listeners.forEach((cb) => cb(mediaState));
    });
  });
}
const shouldUpdate = /* @__PURE__ */ new WeakMap();
function setMediaShouldUpdate(ref, props) {
  return shouldUpdate.set(ref, props);
}
function subscribe(subscriber) {
  listeners.add(subscriber);
  return () => listeners.delete(subscriber);
}
function useMedia(uid, debug) {
  const internal = (0,_useSafeRef_js__WEBPACK_IMPORTED_MODULE_2__/* .useSafeRef */ .p)(void 0);
  if (!internal.current) {
    internal.current = {
      prev: initState
    };
  }
  const state = (0,react__WEBPACK_IMPORTED_MODULE_0__.useSyncExternalStore)(
    subscribe,
    () => {
      const { touched, prev } = internal.current;
      const componentState = uid ? shouldUpdate.get(uid) : void 0;
      if ((componentState == null ? void 0 : componentState.enabled) === false) {
        return prev;
      }
      const testKeys = (componentState == null ? void 0 : componentState.keys) ?? ((!componentState || componentState.enabled) && touched ? [...touched] : null);
      const hasntUpdated = testKeys == null ? void 0 : testKeys.every((key) => mediaState[key] === prev[key]);
      if (hasntUpdated) {
        return prev;
      }
      internal.current.prev = mediaState;
      return mediaState;
    },
    () => initState
  );
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => {
    return new Proxy(state, {
      get(_, key) {
        if (typeof key === "string") {
          internal.current.touched ||= /* @__PURE__ */ new Set();
          internal.current.touched.add(key);
        }
        return Reflect.get(state, key);
      }
    });
  }, [state]);
}
function useMediaPropsActive(props) {
  const media = useMedia();
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => {
    const next = {};
    const importancesUsed = {};
    const propNames = Object.keys(props);
    for (let i = propNames.length - 1; i >= 0; i--) {
      const key = propNames[i];
      const val = props[key];
      if (key[0] === "$") {
        const mediaKey = key.slice(1);
        if (!media[mediaKey])
          continue;
        if (val && typeof val === "object") {
          const subKeys = Object.keys(val);
          for (let j = subKeys.length; j--; j >= 0) {
            const subKey = subKeys[j];
            mergeMediaByImportance(next, mediaKey, subKey, val[subKey], importancesUsed);
          }
        }
      } else {
        mergeMediaByImportance(next, "", key, val, importancesUsed);
      }
    }
    return next;
  }, [media, props]);
}
const getMediaImportanceIfMoreImportant = (mediaKey, key, importancesUsed) => {
  const importance = getMediaKeyImportance(mediaKey);
  return !importancesUsed[key] || importance > importancesUsed[key] ? importance : null;
};
function mergeMediaByImportance(onto, mediaKey, key, value, importancesUsed) {
  const importance = getMediaImportanceIfMoreImportant(mediaKey, key, importancesUsed);
  if (importance === null) {
    return false;
  }
  importancesUsed[key] = importance;
  onto[key] = value;
  return true;
}
function camelToHyphen(str) {
  return str.replace(/[A-Z]/g, (m) => `-${m.toLowerCase()}`).toLowerCase();
}
function mediaObjectToString(query) {
  if (typeof query === "string") {
    return query;
  }
  return Object.entries(query).map(([feature, value]) => {
    feature = camelToHyphen(feature);
    if (typeof value === "string") {
      return `(${feature}: ${value})`;
    }
    if (typeof value === "number" && /[height|width]$/.test(feature)) {
      value = `${value}px`;
    }
    return `(${feature}: ${value})`;
  }).join(" and ");
}

//# sourceMappingURL=useMedia.js.map


/***/ }),

/***/ 67180:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ useSafeRef; }
/* harmony export */ });
/* harmony import */ var _tamagui_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11649);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);


const useSafeRef = (initialValue) => {
  const rawRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
  if (!rawRef.current) {
    rawRef.current = {
      hold: true,
      next: initialValue,
      cur: initialValue,
      ref: {
        get current() {
          return raw.hold ? raw.cur : raw.next;
        },
        set current(v) {
          if (!raw.hold) {
            raw.next = v;
          }
          raw.cur = v;
        }
      }
    };
  }
  const raw = rawRef.current;
  raw.hold = true;
  raw.cur = raw.next;
  (0,_tamagui_constants__WEBPACK_IMPORTED_MODULE_0__/* .useIsomorphicLayoutEffect */ .LI)(() => {
    raw.hold = false;
    raw.next = raw.cur;
  });
  return raw.ref;
};

//# sourceMappingURL=useSafeRef.js.map


/***/ }),

/***/ 24579:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ useServerState; },
/* harmony export */   "l": function() { return /* binding */ useServerRef; }
/* harmony export */ });
/* harmony import */ var _tamagui_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11649);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);


const useServerState = _tamagui_constants__WEBPACK_IMPORTED_MODULE_0__/* .isRSC */ .PS ? (val) => [val, idFn] : react__WEBPACK_IMPORTED_MODULE_1__.useState;
const useServerRef = _tamagui_constants__WEBPACK_IMPORTED_MODULE_0__/* .isRSC */ .PS ? (val) => ({ current: val }) : react__WEBPACK_IMPORTED_MODULE_1__.useRef;
const idFn = () => {
};

//# sourceMappingURL=useServerHooks.js.map


/***/ }),

/***/ 75428:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ useStyle; }
/* harmony export */ });
/* harmony import */ var _tamagui_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11649);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _contexts_FontLanguageContext_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38839);
/* harmony import */ var _contexts_TextAncestorContext_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67364);
/* harmony import */ var _helpers_getSplitStyles_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(49678);
/* harmony import */ var _useMedia_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5755);
/* harmony import */ var _useTheme_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(39107);







function useStyle(base, style, options) {
  const isText = base.staticConfig.isText;
  const hasTextAncestor = !!(_tamagui_constants__WEBPACK_IMPORTED_MODULE_0__/* .isWeb */ .$L && isText ? (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_contexts_TextAncestorContext_js__WEBPACK_IMPORTED_MODULE_2__/* .TextAncestorContext */ .M) : false);
  const languageContext = _tamagui_constants__WEBPACK_IMPORTED_MODULE_0__/* .isRSC */ .PS ? null : (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_contexts_FontLanguageContext_js__WEBPACK_IMPORTED_MODULE_3__/* .FontLanguageContext */ .H);
  const theme = (0,_useTheme_js__WEBPACK_IMPORTED_MODULE_4__/* .useTheme */ .Fg)();
  const media = (0,_useMedia_js__WEBPACK_IMPORTED_MODULE_5__/* .useMedia */ .GS)();
  const out = (0,_helpers_getSplitStyles_js__WEBPACK_IMPORTED_MODULE_6__/* .useSplitStyles */ .DP)(
    style,
    base.staticConfig,
    theme,
    {
      ...options,
      mediaState: media,
      hasTextAncestor,
      resolveVariablesAs: "auto"
    },
    null,
    languageContext || void 0,
    isText ? "span" : "div",
    options == null ? void 0 : options.debug
  );
  return {
    style: Object.keys(out.style).length ? out.style : null,
    classNames: out.classNames
  };
}

//# sourceMappingURL=useStyle.js.map


/***/ }),

/***/ 39107:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "UP": function() { return /* binding */ activeThemeManagers; },
  "Wk": function() { return /* binding */ getThemeProxied; },
  "fe": function() { return /* binding */ useChangeThemeEffect; },
  "Fg": function() { return /* binding */ useTheme; },
  "WU": function() { return /* binding */ useThemeWithState; }
});

// EXTERNAL MODULE: ./node_modules/@tamagui/constants/dist/esm/index.mjs
var esm = __webpack_require__(11649);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./node_modules/@tamagui/web/dist/esm/config.js
var esm_config = __webpack_require__(47269);
// EXTERNAL MODULE: ./node_modules/@tamagui/web/dist/esm/helpers/createProxy.js
var createProxy = __webpack_require__(37264);
// EXTERNAL MODULE: ./node_modules/@tamagui/web/dist/esm/constants/constants.js
var constants = __webpack_require__(74288);
// EXTERNAL MODULE: ./node_modules/@tamagui/web/dist/esm/hooks/getThemeUnwrapped.js
var getThemeUnwrapped = __webpack_require__(4195);
;// CONCATENATED MODULE: ./node_modules/@tamagui/web/dist/esm/helpers/ThemeManager.js



const emptyState = { name: "" };
function hasNoThemeUpdatingProps(props) {
  return !(props.name || props.componentName || props.inverse || props.reset);
}
class ThemeManager {
  constructor(props = {}, parentManager) {
    this.props = props;
    this.themeListeners = /* @__PURE__ */ new Set();
    this.parentManager = null;
    this.state = emptyState;
    this._allKeys = null;
    if (parentManager === "root") {
      this.updateState(props, false);
      return;
    }
    if (!parentManager) {
      if (false) {}
      throw `\u274C`;
    }
    this.themeListeners = parentManager.themeListeners;
    if (hasNoThemeUpdatingProps(props)) {
      return parentManager;
    }
    if (parentManager) {
      this.parentManager = parentManager;
    }
    const updatedState = this.getStateIfChanged(props);
    if (updatedState) {
      this.state = updatedState;
      return;
    }
    return parentManager || this;
  }
  updateState(props = this.props || {}, notify = true) {
    const shouldFlush = (() => {
      if (props.forceTheme) {
        this.state.theme = props.forceTheme;
        this.state.name = props.name || "";
        return true;
      }
      const nextState = this.getStateIfChanged(props);
      if (nextState) {
        this.state = nextState;
        return true;
      }
    })();
    if (shouldFlush) {
      this._allKeys = null;
      notify && this.notify();
      return this.state;
    }
  }
  getStateIfChanged(props = this.props, state = this.state, parentManager = this.parentManager) {
    const _ = this.getState(props, parentManager);
    if (state && state !== emptyState && !_) {
      return parentManager == null ? void 0 : parentManager.state;
    }
    if (this.getStateShouldChange(_, state)) {
      return _;
    }
  }
  getStateShouldChange(nextState, state = this.state) {
    if (!(nextState == null ? void 0 : nextState.theme) || nextState.theme === (state == null ? void 0 : state.theme)) {
      return false;
    }
    return true;
  }
  getState(props = this.props, parentManager = this.parentManager) {
    return getState(props, parentManager) || ( false ? 0 : null);
  }
  get allKeys() {
    var _a;
    this._allKeys ||= /* @__PURE__ */ new Set([
      ...((_a = this.parentManager) == null ? void 0 : _a.allKeys) || [],
      ...Object.keys(this.state.theme || {})
    ]);
    return this._allKeys;
  }
  // gets value going up to parents
  getValue(key, state) {
    if (!key)
      return;
    let theme = (state || this.state).theme;
    let manager = this;
    while (theme && manager) {
      if (key in theme) {
        return theme[key];
      }
      manager = manager.parentManager;
      theme = manager == null ? void 0 : manager.state.theme;
    }
    const tokens = (0,esm_config/* getTokens */.lz)();
    if (key in tokens.color) {
      return tokens.color[key];
    }
  }
  notify() {
    this.themeListeners.forEach((cb) => cb(this.state.name, this));
  }
  onChangeTheme(cb) {
    this.themeListeners.add(cb);
    return () => {
      this.themeListeners.delete(cb);
    };
  }
}
function getNextThemeClassName(name, isInverting = false) {
  const next = `t_sub_theme ${constants/* THEME_CLASSNAME_PREFIX */.nx}${name}`;
  if (isInverting) {
    return next + // ensure you invert to base dark as well as specific dark
    // ... logic should likely be elsewhere
    (next.includes("dark_") ? ` t_dark` : next.includes("light_") ? ` t_light` : "");
  }
  return next.replace("light_", "").replace("dark_", "");
}
const cache = /* @__PURE__ */ new WeakMap();
function getState(props, parentManager) {
  var _a, _b, _c;
  const cached = cache.get(props);
  if (cached && cached[0] === parentManager) {
    return cached[1];
  }
  const themes = (0,esm_config/* getThemes */.RC)();
  if (props.name && props.reset) {
    throw new Error("Cannot reset + set new name");
  }
  if (props.reset && !(parentManager == null ? void 0 : parentManager.parentManager)) {
    console.warn("Cannot reset no grandparent exists");
    return null;
  }
  let result = null;
  const nextName = props.reset ? ((_b = (_a = parentManager == null ? void 0 : parentManager.parentManager) == null ? void 0 : _a.state) == null ? void 0 : _b.name) || "" : props.name || "";
  const { componentName } = props;
  const parentName = ((_c = parentManager == null ? void 0 : parentManager.state) == null ? void 0 : _c.name) || "";
  const base = parentName.split(constants/* THEME_NAME_SEPARATOR */.L2);
  const lastSegment = base[base.length - 1];
  const isParentAComponentTheme = parentName && lastSegment[0].toUpperCase() === lastSegment[0];
  if (isParentAComponentTheme) {
    base.pop();
  }
  const parentBaseTheme = isParentAComponentTheme ? base.slice(0, base.length).join(constants/* THEME_NAME_SEPARATOR */.L2) : parentName;
  const max = base.length;
  const min = componentName && !nextName ? max : 0;
  if (false)
    {}
  for (let i = max; i >= min; i--) {
    let prefix = base.slice(0, i).join(constants/* THEME_NAME_SEPARATOR */.L2);
    if (props.inverse) {
      prefix = inverseThemeName(prefix);
    }
    const potentials = [];
    if (prefix && prefix !== parentBaseTheme) {
      potentials.push(prefix);
    }
    if (nextName) {
      potentials.unshift(prefix ? `${prefix}_${nextName}` : nextName);
    }
    if (i === 1) {
      const lastSegment2 = potentials.findIndex((x) => !x.includes("_"));
      if (lastSegment2 > 0) {
        potentials.splice(lastSegment2, 0, nextName);
      }
    }
    if (componentName) {
      if (nextName) {
        potentials.push(
          `${prefix.slice(
            0,
            prefix.indexOf(constants/* THEME_NAME_SEPARATOR */.L2)
          )}_${nextName}_${componentName}`
        );
      }
      potentials.push(`${prefix}_${componentName}`);
      if (nextName) {
        potentials.unshift(`${prefix}_${nextName}_${componentName}`);
      }
    }
    const found = potentials.find((t) => t in themes);
    if (false)
      {}
    if (found) {
      if (found === parentName) {
        break;
      }
      result = {
        name: found,
        theme: (0,getThemeUnwrapped/* getThemeUnwrapped */.Y)(themes[found]),
        className: getNextThemeClassName(found, props.inverse),
        parentName
      };
      break;
    }
  }
  if (parentManager) {
    cache.set(props, [parentManager, result]);
  }
  return result;
}
const inverseThemeName = (themeName) => {
  return themeName.startsWith("light") ? themeName.replace(/^light/, "dark") : themeName.replace(/^dark/, "light");
};

//# sourceMappingURL=ThemeManager.js.map

// EXTERNAL MODULE: ./node_modules/@tamagui/web/dist/esm/helpers/ThemeManagerContext.js
var ThemeManagerContext = __webpack_require__(71228);
// EXTERNAL MODULE: ./node_modules/@tamagui/web/dist/esm/hooks/useServerHooks.js
var useServerHooks = __webpack_require__(24579);
;// CONCATENATED MODULE: ./node_modules/@tamagui/web/dist/esm/hooks/useTheme.js









const emptyProps = { name: null };
function getDefaultThemeProxied() {
  const config = (0,esm_config/* getConfig */.iE)();
  const name = Object.keys(config.themes)[0];
  return getThemeProxied({
    theme: config.themes[name],
    name
  });
}
const useTheme = (props = emptyProps) => {
  var _a;
  return (esm/* isRSC */.PS ? null : (_a = useThemeWithState(props)) == null ? void 0 : _a.theme) || getDefaultThemeProxied();
};
const useThemeWithState = (props) => {
  var _a;
  const keys = (0,useServerHooks/* useServerRef */.l)([]);
  const changedTheme = useChangeThemeEffect(
    props,
    false,
    esm/* isClient */.C5 ? () => {
      var _a2;
      return ((_a2 = props.shouldUpdate) == null ? void 0 : _a2.call(props)) ?? keys.current.length === 0;
    } : void 0
  );
  const { themeManager, isNewTheme, theme, name, className } = changedTheme;
  if (false) {}
  if (!changedTheme.theme) {
    if (false) {}
    return null;
  }
  const proxiedTheme = (0,react.useMemo)(() => {
    return getThemeProxied(changedTheme);
  }, [theme, isNewTheme, name, className, themeManager]);
  return {
    ...changedTheme,
    theme: proxiedTheme
  };
};
function getThemeProxied({
  theme,
  themeManager,
  keys
}) {
  return (0,createProxy/* createProxy */.D)(theme, {
    has(_, key) {
      if (typeof key === "string") {
        if (key[0] === "$")
          key = key.slice(1);
        return themeManager == null ? void 0 : themeManager.allKeys.has(key);
      }
      return Reflect.has(theme, key);
    },
    get(_, key) {
      if (key === getThemeUnwrapped/* GetThemeUnwrapped */.N) {
        return theme;
      }
      if (key === "undefined" || key === "__proto__" || key === "$typeof" || typeof key !== "string" || !themeManager) {
        return Reflect.get(_, key);
      }
      const keyString = key;
      if (key[0] === "$") {
        key = key.slice(1);
      }
      const val = themeManager.getValue(key);
      const currentKeys = keys == null ? void 0 : keys.current;
      if (val && currentKeys) {
        return new Proxy(val, {
          // when they touch the actual value we only track it
          // if its a variable (web), its ignored!
          get(_2, subkey) {
            if (subkey === "val" && !currentKeys.includes(keyString)) {
              currentKeys.push(keyString);
            }
            return Reflect.get(val, subkey);
          }
        });
      }
      return val;
    }
  });
}
const activeThemeManagers = /* @__PURE__ */ new Set();
const useChangeThemeEffect = (props, root = false, disableUpdate) => {
  if (esm/* isRSC */.PS) {
    return {
      ...createState().state,
      themeManager: null
    };
  }
  const parentManager = (0,react.useContext)(ThemeManagerContext/* ThemeManagerContext */.r);
  const {
    debug,
    // @ts-expect-error internal use only
    disable
  } = props;
  if (disable) {
    if (!parentManager)
      throw `\u274C`;
    return {
      ...parentManager.state,
      isNewTheme: false,
      themeManager: parentManager
    };
  }
  const [themeState, setThemeState] = (0,react.useState)(createState);
  const { isNewTheme, state, themeManager, mounted } = themeState;
  if (!esm/* isServer */.sk) {
    (0,react.useEffect)(() => {
      if (disable)
        return;
      if (props.inverse && !mounted) {
        setThemeState({ ...themeState, mounted: true });
        return;
      }
      activeThemeManagers.add(themeManager);
      return () => {
        activeThemeManagers.delete(themeManager);
      };
    }, [disable, state, isNewTheme, debug]);
  }
  const isInversingOnMount = Boolean(!themeState.mounted && props.inverse);
  const shouldReturnParentState = hasNoThemeUpdatingProps(props) || isInversingOnMount;
  if (shouldReturnParentState) {
    if (!parentManager)
      throw "impossible";
    if (false)
      {}
    return {
      ...parentManager.state,
      className: isInversingOnMount ? "" : parentManager.state.className,
      themeManager: parentManager,
      isNewTheme: false
    };
  }
  updateState();
  return {
    ...state,
    isNewTheme,
    themeManager
  };
  function createState(prev) {
    if (prev && (disableUpdate == null ? void 0 : disableUpdate())) {
      return prev;
    }
    const _ = new ThemeManager(props, root ? "root" : parentManager);
    const isNewTheme2 = _ !== parentManager;
    const mounted2 = !props.inverse ? true : root || (prev == null ? void 0 : prev.mounted);
    return {
      // ThemeManager returns parentManager if no change
      isNewTheme: isNewTheme2,
      state: { ..._.state },
      themeManager: _,
      mounted: mounted2
    };
  }
  function updateState(updatingManager) {
    if (disableUpdate == null ? void 0 : disableUpdate()) {
      return;
    }
    const manager = updatingManager ?? themeManager;
    const next = manager.getState(props, parentManager);
    const shouldChange = manager.getStateShouldChange(next, isNewTheme ? state : null);
    if (shouldChange) {
      setThemeState(createState);
    } else {
      if (!next && (parentManager == null ? void 0 : parentManager.state.name) !== state.name) {
        setThemeState(createState);
      }
    }
  }
};

//# sourceMappingURL=useTheme.js.map


/***/ }),

/***/ 55173:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ useThemeName; }
/* harmony export */ });
/* harmony import */ var _tamagui_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11649);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47269);
/* harmony import */ var _helpers_ThemeManagerContext_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71228);




function useThemeName(opts) {
  if (_tamagui_constants__WEBPACK_IMPORTED_MODULE_0__/* .isRSC */ .PS) {
    const config = (0,_config_js__WEBPACK_IMPORTED_MODULE_2__/* .getConfig */ .iE)();
    return config.themes[Object.keys(config.themes)[0]];
  }
  const manager = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_helpers_ThemeManagerContext_js__WEBPACK_IMPORTED_MODULE_3__/* .ThemeManagerContext */ .r);
  const [name, setName] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)((manager == null ? void 0 : manager.state.name) || "");
  (0,_tamagui_constants__WEBPACK_IMPORTED_MODULE_0__/* .useIsomorphicLayoutEffect */ .LI)(() => {
    if (!manager)
      return;
    setName(manager.state.name);
    return manager.onChangeTheme((next, manager2) => {
      const name2 = (opts == null ? void 0 : opts.parent) ? manager2.state.parentName || next : next;
      if (!name2)
        return;
      setName(name2);
    });
  }, [manager == null ? void 0 : manager.state.name]);
  return name;
}

//# sourceMappingURL=useThemeName.js.map


/***/ }),

/***/ 62498:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QF": function() { return /* binding */ registerFontVariables; },
/* harmony export */   "ZL": function() { return /* binding */ parseFont; },
/* harmony export */   "os": function() { return /* binding */ insertFont; }
/* harmony export */ });
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47269);
/* harmony import */ var _createFont_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47727);
/* harmony import */ var _createVariables_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61298);
/* harmony import */ var _helpers_registerCSSVariable_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26095);




function insertFont(name, fontIn) {
  const font = (0,_createFont_js__WEBPACK_IMPORTED_MODULE_0__/* .createFont */ .v)(fontIn);
  const tokened = (0,_createVariables_js__WEBPACK_IMPORTED_MODULE_1__/* .createVariables */ .D)(font, name);
  const parsed = parseFont(tokened);
  if ( true && typeof document !== "undefined") {
    const fontVars = registerFontVariables(parsed);
    const style = document.createElement("style");
    style.innerText = `:root .font_${name} {${fontVars.join(";")}}`;
    style.setAttribute("data-tamagui-font", name);
    document.head.appendChild(style);
  }
  (0,_config_js__WEBPACK_IMPORTED_MODULE_2__/* .setConfigFont */ .lI)(name, tokened, parsed);
  return parsed;
}
function parseFont(definition) {
  var _a;
  const parsed = {};
  for (const attrKey in definition) {
    const attr = definition[attrKey];
    if (attrKey === "family" || attrKey === "face") {
      parsed[attrKey] = attr;
      continue;
    }
    parsed[attrKey] = {};
    for (const key in attr) {
      let val = attr[key];
      if (((_a = val.val) == null ? void 0 : _a[0]) === "$") {
        val = val.val;
      }
      parsed[attrKey][`$${key}`] = val;
    }
  }
  return parsed;
}
function registerFontVariables(parsedFont) {
  const response = [];
  for (const fkey in parsedFont) {
    if (fkey === "face")
      continue;
    if (fkey === "family") {
      const val = parsedFont[fkey];
      (0,_helpers_registerCSSVariable_js__WEBPACK_IMPORTED_MODULE_3__/* .registerCSSVariable */ .Im)(val);
      response.push((0,_helpers_registerCSSVariable_js__WEBPACK_IMPORTED_MODULE_3__/* .variableToCSS */ .nw)(val));
    } else {
      for (const fskey in parsedFont[fkey]) {
        const fval = parsedFont[fkey][fskey];
        if (typeof fval === "string") {
        } else {
          const val = parsedFont[fkey][fskey];
          (0,_helpers_registerCSSVariable_js__WEBPACK_IMPORTED_MODULE_3__/* .registerCSSVariable */ .Im)(val);
          response.push((0,_helpers_registerCSSVariable_js__WEBPACK_IMPORTED_MODULE_3__/* .variableToCSS */ .nw)(val));
        }
      }
    }
  }
  return response;
}

//# sourceMappingURL=insertFont.js.map


/***/ }),

/***/ 46713:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ hooks; },
/* harmony export */   "b": function() { return /* binding */ setupHooks; }
/* harmony export */ });
const hooks = {};
function setupHooks(next) {
  Object.assign(hooks, next);
}

//# sourceMappingURL=setupHooks.js.map


/***/ }),

/***/ 26575:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GE": function() { return /* binding */ ReactNativeStaticConfigs; },
/* harmony export */   "Gy": function() { return /* binding */ setupReactNative; },
/* harmony export */   "fA": function() { return /* binding */ getReactNativeConfig; }
/* harmony export */ });
const ReactNativeStaticConfigs = /* @__PURE__ */ new WeakMap();
function getReactNativeConfig(Component) {
  return ReactNativeStaticConfigs.get(Component);
}
function setupReactNative(rnExports) {
  for (const key in rnExports) {
    if (key[0].toLowerCase() === key[0])
      continue;
    const val = rnExports[key];
    if (val && typeof val === "object") {
      ReactNativeStaticConfigs.set(val, {
        isReactNative: true,
        isText: key === "Text" || key === "TextInput",
        isInput: key === "TextInput" || key === "TextArea",
        inlineProps: key === "Image" ? /* @__PURE__ */ new Set(["src", "width", "height"]) : void 0
      });
    }
  }
}

//# sourceMappingURL=setupReactNative.js.map


/***/ }),

/***/ 90662:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ styled; }
/* harmony export */ });
/* harmony import */ var _tamagui_helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95591);
/* harmony import */ var _createComponent_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6905);
/* harmony import */ var _setupReactNative_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26575);



function styled(Component, options, staticExtractionOptions) {
  if (false) {}
  const parentStaticConfig = "staticConfig" in Component ? Component.staticConfig : null;
  const isTamagui = !!parentStaticConfig;
  const isReactNative = Boolean(
    _setupReactNative_js__WEBPACK_IMPORTED_MODULE_1__/* .ReactNativeStaticConfigs.has */ .GE.has(Component) || (staticExtractionOptions == null ? void 0 : staticExtractionOptions.isReactNative) || _setupReactNative_js__WEBPACK_IMPORTED_MODULE_1__/* .ReactNativeStaticConfigs.has */ .GE.has(parentStaticConfig == null ? void 0 : parentStaticConfig.Component) || (parentStaticConfig == null ? void 0 : parentStaticConfig.isReactNative)
  );
  const staticConfigProps = (() => {
    if (options) {
      const {
        variants,
        name,
        defaultVariants,
        acceptsClassName: acceptsClassNameProp,
        ...defaultProps
      } = options;
      if (defaultVariants) {
        Object.assign(defaultProps, defaultVariants);
      }
      const Comp = isReactNative ? (parentStaticConfig == null ? void 0 : parentStaticConfig.Component) || Component : Component;
      const nativeConf = isReactNative && _setupReactNative_js__WEBPACK_IMPORTED_MODULE_1__/* .ReactNativeStaticConfigs.get */ .GE.get(Comp) || null;
      const isText = Boolean(
        (staticExtractionOptions == null ? void 0 : staticExtractionOptions.isText) || (parentStaticConfig == null ? void 0 : parentStaticConfig.isText)
      );
      const acceptsClassName = acceptsClassNameProp ?? (isTamagui || isReactNative);
      const conf = {
        ...staticExtractionOptions,
        ...!isTamagui && {
          Component: Comp
        },
        // this type gets messed up by options?: Partial<GetProps<ParentComponent>> above
        // take away the Partial<> and it's fine
        variants,
        defaultProps,
        defaultVariants,
        componentName: name,
        isReactNative,
        isText,
        acceptsClassName,
        ...nativeConf
      };
      if (defaultProps.children || !acceptsClassName) {
        conf.neverFlatten = true;
      }
      return conf;
    }
  })();
  const component = (0,_createComponent_js__WEBPACK_IMPORTED_MODULE_2__/* .createComponent */ .LM)(staticConfigProps || {}, Component);
  return component;
}

//# sourceMappingURL=styled.js.map


/***/ }),

/***/ 66335:
/***/ (function() {

//# sourceMappingURL=types.js.map


/***/ }),

/***/ 91885:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ updateTheme; }
/* harmony export */ });
/* harmony import */ var _addTheme_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38226);


function updateTheme({
  name,
  theme
}) {
  const next = (0,_addTheme_js__WEBPACK_IMPORTED_MODULE_0__/* .addTheme */ ._)({ name, theme, insertCSS: true, update: true });
  if (false) {}
  return next;
}

//# sourceMappingURL=updateTheme.js.map


/***/ }),

/***/ 26815:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ FontLanguage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);

const FontLanguage = ({ children, ...props }) => {
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
    "div",
    {
      style: {
        display: "contents"
      },
      className: Object.entries(props).map(([name, language]) => `t_lang-${name}-${language}`).join(" "),
      children
    }
  );
};

//# sourceMappingURL=FontLanguage.js.map


/***/ }),

/***/ 84367:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A4": function() { return /* binding */ Slottable; },
/* harmony export */   "g7": function() { return /* binding */ Slot; },
/* harmony export */   "qR": function() { return /* binding */ mergeEvent; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _tamagui_compose_refs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4429);
/* harmony import */ var _tamagui_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11649);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);




const Slot = (0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)(function Slot2(props, forwardedRef) {
  const { children, ...slotProps } = props;
  if ((0,react__WEBPACK_IMPORTED_MODULE_2__.isValidElement)(children)) {
    const childProps = {
      ...mergeSlotProps(children, slotProps),
      ref: (0,_tamagui_compose_refs__WEBPACK_IMPORTED_MODULE_3__/* .composeRefs */ .F)(forwardedRef, children.ref)
    };
    return (0,react__WEBPACK_IMPORTED_MODULE_2__.cloneElement)(children, childProps);
  }
  return react__WEBPACK_IMPORTED_MODULE_2__.Children.count(children) > 1 ? react__WEBPACK_IMPORTED_MODULE_2__.Children.only(null) : null;
});
const Slottable = ({ children }) => {
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children });
};
const pressMap = _tamagui_constants__WEBPACK_IMPORTED_MODULE_1__/* .isWeb */ .$L ? {
  onPress: "onClick",
  onPressOut: "onMouseUp",
  onPressIn: "onMouseDown"
} : {};
function mergeSlotProps(child, slotProps) {
  const childProps = child.props;
  const overrideProps = { ...childProps };
  const isHTMLChild = typeof child.type === "string";
  if (isHTMLChild) {
    for (const key in pressMap) {
      if (key in slotProps) {
        slotProps[pressMap[key]] = slotProps[key];
        delete slotProps[key];
      }
    }
  }
  for (let propName in childProps) {
    const slotPropValue = slotProps[propName];
    const childPropValue = childProps[propName];
    if (isHTMLChild && pressMap[propName]) {
      propName = pressMap[propName];
      delete overrideProps[propName];
    }
    const isHandler = handleRegex.test(propName);
    if (isHandler) {
      overrideProps[propName] = mergeEvent(childPropValue, slotPropValue);
    } else if (propName === "style") {
      overrideProps[propName] = { ...slotPropValue, ...childPropValue };
    } else if (propName === "className") {
      overrideProps[propName] = [slotPropValue, childPropValue].filter(Boolean).join(" ");
    }
  }
  return { ...slotProps, ...overrideProps };
}
const handleRegex = /^on[A-Z]/;
function mergeEvent(a, b) {
  return (...args) => {
    a == null ? void 0 : a(...args);
    b == null ? void 0 : b(...args);
  };
}

//# sourceMappingURL=Slot.js.map


/***/ }),

/***/ 42039:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ Stack; }
/* harmony export */ });
/* harmony import */ var _constants_constants_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74288);
/* harmony import */ var _createComponent_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6905);


const Stack = (0,_createComponent_js__WEBPACK_IMPORTED_MODULE_0__/* .createComponent */ .LM)({
  componentName: "Stack",
  acceptsClassName: true,
  defaultProps: {
    ..._constants_constants_js__WEBPACK_IMPORTED_MODULE_1__/* .stackDefaultStyles */ .tn,
    flexDirection: "column"
  }
});

//# sourceMappingURL=Stack.js.map


/***/ }),

/***/ 57450:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ TamaguiProvider; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _tamagui_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11649);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var _contexts_ButtonNestingContext_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19924);
/* harmony import */ var _contexts_TextAncestorContext_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67364);
/* harmony import */ var _hooks_useMedia_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5755);
/* harmony import */ var _ThemeProvider_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(83589);







function TamaguiProvider({
  children,
  disableInjectCSS,
  config,
  ...themePropsProvider
}) {
  if (_tamagui_constants__WEBPACK_IMPORTED_MODULE_1__/* .isRSC */ .PS) {
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
      "span",
      {
        style: { display: "contents" },
        className: `t_${Object.keys(config.themes)[0] || "light"}`,
        children
      }
    );
  }
  if (!(_tamagui_constants__WEBPACK_IMPORTED_MODULE_1__/* .isWeb */ .$L && _tamagui_constants__WEBPACK_IMPORTED_MODULE_1__/* .isServer */ .sk)) {
    (0,_hooks_useMedia_js__WEBPACK_IMPORTED_MODULE_3__/* .useMediaListeners */ .xn)(config);
  }
  if (_tamagui_constants__WEBPACK_IMPORTED_MODULE_1__/* .isClient */ .C5) {
    react__WEBPACK_IMPORTED_MODULE_2__.useLayoutEffect(() => {
      if (document.documentElement.classList.contains("t_unmounted")) {
        document.documentElement.classList.remove("t_unmounted");
      }
      if (disableInjectCSS)
        return;
      const style = document.createElement("style");
      style.appendChild(document.createTextNode(config.getCSS()));
      document.head.appendChild(style);
      return () => {
        document.head.removeChild(style);
      };
    }, [config, disableInjectCSS]);
  }
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_contexts_ButtonNestingContext_js__WEBPACK_IMPORTED_MODULE_4__/* .ButtonNestingContext.Provider */ .e.Provider, { value: false, children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_contexts_TextAncestorContext_js__WEBPACK_IMPORTED_MODULE_5__/* .TextAncestorContext.Provider */ .M.Provider, { value: false, children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
    _ThemeProvider_js__WEBPACK_IMPORTED_MODULE_6__/* .ThemeProvider */ .f,
    {
      themeClassNameOnRoot: config.themeClassNameOnRoot,
      disableRootThemeClass: config.disableRootThemeClass,
      ...themePropsProvider,
      defaultTheme: themePropsProvider.defaultTheme ?? Object.keys(config.themes)[0],
      children
    }
  ) }) });
}

//# sourceMappingURL=TamaguiProvider.js.map


/***/ }),

/***/ 8669:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ Text; }
/* harmony export */ });
/* harmony import */ var _tamagui_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11649);
/* harmony import */ var _tamagui_helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95591);
/* harmony import */ var _createComponent_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6905);



const ellipseStyle = {
  maxWidth: "100%",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap"
};
const Text = (0,_createComponent_js__WEBPACK_IMPORTED_MODULE_2__/* .createComponent */ .LM)({
  componentName: "Text",
  acceptsClassName: true,
  isText: true,
  defaultProps: {
    // @ts-ignore
    display: "flex",
    fontFamily: "System",
    ..._tamagui_constants__WEBPACK_IMPORTED_MODULE_0__/* .isWeb */ .$L ? {
      display: "inline",
      boxSizing: "border-box",
      wordWrap: "break-word",
      margin: 0
    } : {
      suppressHighlighting: true
    }
  },
  inlineWhenUnflattened: /* @__PURE__ */ new Set(["fontFamily"]),
  variants: {
    ..._tamagui_constants__WEBPACK_IMPORTED_MODULE_0__/* .isWeb */ .$L && {
      numberOfLines: {
        1: ellipseStyle,
        ":number": (numberOfLines) => numberOfLines >= 1 ? {
          WebkitLineClamp: numberOfLines,
          WebkitBoxOrient: "vertical",
          display: "-webkit-box",
          overflow: "hidden"
        } : null
      }
    },
    // ??
    ellipsizeMode: {
      "...": () => null
    },
    selectable: {
      true: {
        userSelect: "text",
        cursor: "text"
      },
      false: {
        userSelect: "none",
        cursor: "default"
      }
    },
    ellipse: {
      true: _tamagui_constants__WEBPACK_IMPORTED_MODULE_0__/* .isWeb */ .$L ? ellipseStyle : {
        numberOfLines: 1,
        lineBreakMode: "clip"
      }
    }
  },
  deoptProps: new Set(_tamagui_constants__WEBPACK_IMPORTED_MODULE_0__/* .isWeb */ .$L ? [] : ["ellipse"]),
  validStyles: {
    ..._tamagui_helpers__WEBPACK_IMPORTED_MODULE_1__.validStyles,
    ..._tamagui_helpers__WEBPACK_IMPORTED_MODULE_1__.stylePropsTextOnly
  }
});

//# sourceMappingURL=Text.js.map


/***/ }),

/***/ 56283:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ Theme; },
/* harmony export */   "y": function() { return /* binding */ useThemedChildren; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _tamagui_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11649);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var _createVariable_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(13209);
/* harmony import */ var _helpers_ThemeManagerContext_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(71228);
/* harmony import */ var _hooks_useServerHooks_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24579);
/* harmony import */ var _hooks_useTheme_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39107);







function Theme(props) {
  if (props.disable)
    return props.children;
  const isRoot = !!props["_isRoot"];
  const themeState = (0,_hooks_useTheme_js__WEBPACK_IMPORTED_MODULE_3__/* .useChangeThemeEffect */ .fe)(props, isRoot);
  const children = props["data-themeable"] ? react__WEBPACK_IMPORTED_MODULE_2__.Children.map(
    props.children,
    (child) => (0,react__WEBPACK_IMPORTED_MODULE_2__.cloneElement)(child, { ["data-themeable"]: true })
  ) : props.children;
  return useThemedChildren(themeState, children, props, isRoot);
}
function useThemedChildren(themeState, children, options, isRoot = false) {
  const { themeManager, isNewTheme, className, theme } = themeState;
  const { shallow, forceClassName } = options;
  const hasEverThemed = (0,_hooks_useServerHooks_js__WEBPACK_IMPORTED_MODULE_4__/* .useServerRef */ .l)(false);
  if (isNewTheme) {
    hasEverThemed.current = true;
  }
  if (isNewTheme || hasEverThemed.current || forceClassName || isRoot) {
    let next = react__WEBPACK_IMPORTED_MODULE_2__.Children.toArray(children);
    if (shallow && themeManager) {
      next = next.map((child) => {
        return (0,react__WEBPACK_IMPORTED_MODULE_2__.isValidElement)(child) ? (0,react__WEBPACK_IMPORTED_MODULE_2__.cloneElement)(
          child,
          void 0,
          /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Theme, { name: themeManager.state.parentName, children: child.props.children })
        ) : child;
      });
    }
    const wrapped = /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_helpers_ThemeManagerContext_js__WEBPACK_IMPORTED_MODULE_5__/* .ThemeManagerContext.Provider */ .r.Provider, { value: themeManager, children: next });
    if (forceClassName === false) {
      return wrapped;
    }
    if (_tamagui_constants__WEBPACK_IMPORTED_MODULE_1__/* .isWeb */ .$L && !options.passPropsToChildren) {
      const themeColor = theme && isNewTheme ? (0,_createVariable_js__WEBPACK_IMPORTED_MODULE_6__/* .variableToString */ .lk)(theme.color) : "";
      const colorStyle = {
        color: themeColor
      };
      return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", { className: `${className || ""} _dsp_contents`, style: colorStyle, children: wrapped });
    }
    return wrapped;
  }
  return children;
}

//# sourceMappingURL=Theme.js.map


/***/ }),

/***/ 83589:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ ThemeProviderRootContext; },
/* harmony export */   "f": function() { return /* binding */ ThemeProvider; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _tamagui_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11649);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var _constants_constants_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74288);
/* harmony import */ var _Theme_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(56283);





const ThemeProviderRootContext = (0,react__WEBPACK_IMPORTED_MODULE_2__.createContext)(null);
const ThemeProvider = (props) => {
  if (_tamagui_constants__WEBPACK_IMPORTED_MODULE_1__/* .isClient */ .C5) {
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useLayoutEffect)(() => {
      if (props.disableRootThemeClass)
        return;
      const cn = `${_constants_constants_js__WEBPACK_IMPORTED_MODULE_3__/* .THEME_CLASSNAME_PREFIX */ .nx}${props.defaultTheme}`;
      const target = props.themeClassNameOnRoot ? document.documentElement : document.body;
      target.classList.add(cn);
      return () => {
        target.classList.remove(cn);
      };
    }, [props.defaultTheme, props.disableRootThemeClass, props.themeClassNameOnRoot]);
  }
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
    ThemeProviderRootContext.Provider,
    {
      value: (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(() => {
        return {
          defaultTheme: props.defaultTheme
        };
      }, []),
      children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
        _Theme_js__WEBPACK_IMPORTED_MODULE_4__/* .Theme */ .Q,
        {
          className: props.className,
          name: props.defaultTheme,
          forceClassName: props.disableRootThemeClass ? false : void 0,
          _isRoot: true,
          children: props.children
        }
      )
    }
  );
};

//# sourceMappingURL=ThemeProvider.js.map


/***/ }),

/***/ 66379:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "arrow": function() { return /* binding */ arrow; },
/* harmony export */   "autoPlacement": function() { return /* reexport safe */ _floating_ui_dom__WEBPACK_IMPORTED_MODULE_0__.X5; },
/* harmony export */   "autoUpdate": function() { return /* reexport safe */ _floating_ui_dom__WEBPACK_IMPORTED_MODULE_1__.Me; },
/* harmony export */   "computePosition": function() { return /* reexport safe */ _floating_ui_dom__WEBPACK_IMPORTED_MODULE_1__.oo; },
/* harmony export */   "detectOverflow": function() { return /* reexport safe */ _floating_ui_dom__WEBPACK_IMPORTED_MODULE_0__.US; },
/* harmony export */   "flip": function() { return /* reexport safe */ _floating_ui_dom__WEBPACK_IMPORTED_MODULE_0__.RR; },
/* harmony export */   "getOverflowAncestors": function() { return /* reexport safe */ _floating_ui_dom__WEBPACK_IMPORTED_MODULE_1__.Kx; },
/* harmony export */   "hide": function() { return /* reexport safe */ _floating_ui_dom__WEBPACK_IMPORTED_MODULE_0__.Cp; },
/* harmony export */   "inline": function() { return /* reexport safe */ _floating_ui_dom__WEBPACK_IMPORTED_MODULE_0__.Qo; },
/* harmony export */   "limitShift": function() { return /* reexport safe */ _floating_ui_dom__WEBPACK_IMPORTED_MODULE_0__.dr; },
/* harmony export */   "offset": function() { return /* reexport safe */ _floating_ui_dom__WEBPACK_IMPORTED_MODULE_0__.cv; },
/* harmony export */   "platform": function() { return /* reexport safe */ _floating_ui_dom__WEBPACK_IMPORTED_MODULE_1__.Jv; },
/* harmony export */   "shift": function() { return /* reexport safe */ _floating_ui_dom__WEBPACK_IMPORTED_MODULE_0__.uY; },
/* harmony export */   "size": function() { return /* reexport safe */ _floating_ui_dom__WEBPACK_IMPORTED_MODULE_0__.dp; },
/* harmony export */   "useFloating": function() { return /* binding */ useFloating; }
/* harmony export */ });
/* harmony import */ var _floating_ui_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20189);
/* harmony import */ var _floating_ui_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40771);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28316);






/**
 * A data provider that provides data to position an inner element of the
 * floating element (usually a triangle or caret) so that it is centered to the
 * reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */
const arrow = options => {
  const {
    element,
    padding
  } = options;
  function isRef(value) {
    return Object.prototype.hasOwnProperty.call(value, 'current');
  }
  return {
    name: 'arrow',
    options,
    fn(args) {
      if (isRef(element)) {
        if (element.current != null) {
          return (0,_floating_ui_dom__WEBPACK_IMPORTED_MODULE_0__/* .arrow */ .x7)({
            element: element.current,
            padding
          }).fn(args);
        }
        return {};
      } else if (element) {
        return (0,_floating_ui_dom__WEBPACK_IMPORTED_MODULE_0__/* .arrow */ .x7)({
          element,
          padding
        }).fn(args);
      }
      return {};
    }
  };
};

var index = typeof document !== 'undefined' ? react__WEBPACK_IMPORTED_MODULE_2__.useLayoutEffect : react__WEBPACK_IMPORTED_MODULE_2__.useEffect;

// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function deepEqual(a, b) {
  if (a === b) {
    return true;
  }
  if (typeof a !== typeof b) {
    return false;
  }
  if (typeof a === 'function' && a.toString() === b.toString()) {
    return true;
  }
  let length, i, keys;
  if (a && b && typeof a == 'object') {
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;) {
        if (!deepEqual(a[i], b[i])) {
          return false;
        }
      }
      return true;
    }
    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) {
      return false;
    }
    for (i = length; i-- !== 0;) {
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) {
        return false;
      }
    }
    for (i = length; i-- !== 0;) {
      const key = keys[i];
      if (key === '_owner' && a.$$typeof) {
        continue;
      }
      if (!deepEqual(a[key], b[key])) {
        return false;
      }
    }
    return true;
  }
  return a !== a && b !== b;
}

function useLatestRef(value) {
  const ref = react__WEBPACK_IMPORTED_MODULE_2__.useRef(value);
  index(() => {
    ref.current = value;
  });
  return ref;
}

/**
 * Provides data to position a floating element.
 * @see https://floating-ui.com/docs/react
 */
function useFloating(options) {
  if (options === void 0) {
    options = {};
  }
  const {
    placement = 'bottom',
    strategy = 'absolute',
    middleware = [],
    platform,
    whileElementsMounted,
    open
  } = options;
  const [data, setData] = react__WEBPACK_IMPORTED_MODULE_2__.useState({
    x: null,
    y: null,
    strategy,
    placement,
    middlewareData: {},
    isPositioned: false
  });
  const [latestMiddleware, setLatestMiddleware] = react__WEBPACK_IMPORTED_MODULE_2__.useState(middleware);
  if (!deepEqual(latestMiddleware, middleware)) {
    setLatestMiddleware(middleware);
  }
  const referenceRef = react__WEBPACK_IMPORTED_MODULE_2__.useRef(null);
  const floatingRef = react__WEBPACK_IMPORTED_MODULE_2__.useRef(null);
  const dataRef = react__WEBPACK_IMPORTED_MODULE_2__.useRef(data);
  const whileElementsMountedRef = useLatestRef(whileElementsMounted);
  const platformRef = useLatestRef(platform);
  const [reference, _setReference] = react__WEBPACK_IMPORTED_MODULE_2__.useState(null);
  const [floating, _setFloating] = react__WEBPACK_IMPORTED_MODULE_2__.useState(null);
  const setReference = react__WEBPACK_IMPORTED_MODULE_2__.useCallback(node => {
    if (referenceRef.current !== node) {
      referenceRef.current = node;
      _setReference(node);
    }
  }, []);
  const setFloating = react__WEBPACK_IMPORTED_MODULE_2__.useCallback(node => {
    if (floatingRef.current !== node) {
      floatingRef.current = node;
      _setFloating(node);
    }
  }, []);
  const update = react__WEBPACK_IMPORTED_MODULE_2__.useCallback(() => {
    if (!referenceRef.current || !floatingRef.current) {
      return;
    }
    const config = {
      placement,
      strategy,
      middleware: latestMiddleware
    };
    if (platformRef.current) {
      config.platform = platformRef.current;
    }
    (0,_floating_ui_dom__WEBPACK_IMPORTED_MODULE_1__/* .computePosition */ .oo)(referenceRef.current, floatingRef.current, config).then(data => {
      const fullData = {
        ...data,
        isPositioned: true
      };
      if (isMountedRef.current && !deepEqual(dataRef.current, fullData)) {
        dataRef.current = fullData;
        react_dom__WEBPACK_IMPORTED_MODULE_3__.flushSync(() => {
          setData(fullData);
        });
      }
    });
  }, [latestMiddleware, placement, strategy, platformRef]);
  index(() => {
    if (open === false && dataRef.current.isPositioned) {
      dataRef.current.isPositioned = false;
      setData(data => ({
        ...data,
        isPositioned: false
      }));
    }
  }, [open]);
  const isMountedRef = react__WEBPACK_IMPORTED_MODULE_2__.useRef(false);
  index(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);
  index(() => {
    if (reference && floating) {
      if (whileElementsMountedRef.current) {
        return whileElementsMountedRef.current(reference, floating, update);
      } else {
        update();
      }
    }
  }, [reference, floating, update, whileElementsMountedRef]);
  const refs = react__WEBPACK_IMPORTED_MODULE_2__.useMemo(() => ({
    reference: referenceRef,
    floating: floatingRef,
    setReference,
    setFloating
  }), [setReference, setFloating]);
  const elements = react__WEBPACK_IMPORTED_MODULE_2__.useMemo(() => ({
    reference,
    floating
  }), [reference, floating]);
  return react__WEBPACK_IMPORTED_MODULE_2__.useMemo(() => ({
    ...data,
    update,
    refs,
    elements,
    reference: setReference,
    floating: setFloating
  }), [data, update, refs, elements, setReference, setFloating]);
}




/***/ }),

/***/ 67777:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "FloatingDelayGroup": function() { return /* binding */ FloatingDelayGroup; },
  "FloatingFocusManager": function() { return /* binding */ FloatingFocusManager; },
  "FloatingNode": function() { return /* binding */ FloatingNode; },
  "FloatingOverlay": function() { return /* binding */ FloatingOverlay; },
  "FloatingPortal": function() { return /* binding */ FloatingPortal; },
  "FloatingTree": function() { return /* binding */ FloatingTree; },
  "arrow": function() { return /* reexport */ floating_ui_react_dom_esm.arrow; },
  "autoPlacement": function() { return /* reexport */ floating_ui_core_browser_min/* autoPlacement */.X5; },
  "autoUpdate": function() { return /* reexport */ floating_ui_dom_browser_min/* autoUpdate */.Me; },
  "computePosition": function() { return /* reexport */ floating_ui_dom_browser_min/* computePosition */.oo; },
  "detectOverflow": function() { return /* reexport */ floating_ui_core_browser_min/* detectOverflow */.US; },
  "flip": function() { return /* reexport */ floating_ui_core_browser_min/* flip */.RR; },
  "getOverflowAncestors": function() { return /* reexport */ floating_ui_dom_browser_min/* getOverflowAncestors */.Kx; },
  "hide": function() { return /* reexport */ floating_ui_core_browser_min/* hide */.Cp; },
  "inline": function() { return /* reexport */ floating_ui_core_browser_min/* inline */.Qo; },
  "inner": function() { return /* binding */ inner; },
  "limitShift": function() { return /* reexport */ floating_ui_core_browser_min/* limitShift */.dr; },
  "offset": function() { return /* reexport */ floating_ui_core_browser_min/* offset */.cv; },
  "platform": function() { return /* reexport */ floating_ui_dom_browser_min/* platform */.Jv; },
  "safePolygon": function() { return /* binding */ safePolygon; },
  "shift": function() { return /* reexport */ floating_ui_core_browser_min/* shift */.uY; },
  "size": function() { return /* reexport */ floating_ui_core_browser_min/* size */.dp; },
  "useClick": function() { return /* binding */ useClick; },
  "useDelayGroup": function() { return /* binding */ useDelayGroup; },
  "useDelayGroupContext": function() { return /* binding */ useDelayGroupContext; },
  "useDismiss": function() { return /* binding */ useDismiss; },
  "useFloating": function() { return /* binding */ useFloating; },
  "useFloatingNodeId": function() { return /* binding */ useFloatingNodeId; },
  "useFloatingParentNodeId": function() { return /* binding */ useFloatingParentNodeId; },
  "useFloatingPortalNode": function() { return /* binding */ useFloatingPortalNode; },
  "useFloatingTree": function() { return /* binding */ useFloatingTree; },
  "useFocus": function() { return /* binding */ useFocus; },
  "useHover": function() { return /* binding */ useHover; },
  "useId": function() { return /* binding */ useId; },
  "useInnerOffset": function() { return /* binding */ useInnerOffset; },
  "useInteractions": function() { return /* binding */ useInteractions; },
  "useListNavigation": function() { return /* binding */ useListNavigation; },
  "useMergeRefs": function() { return /* binding */ useMergeRefs; },
  "useRole": function() { return /* binding */ useRole; },
  "useTransitionStatus": function() { return /* binding */ useTransitionStatus; },
  "useTransitionStyles": function() { return /* binding */ useTransitionStyles; },
  "useTypeahead": function() { return /* binding */ useTypeahead; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
var react_namespaceObject = /*#__PURE__*/__webpack_require__.t(react, 2);
// EXTERNAL MODULE: ../../node_modules/aria-hidden/dist/es2015/index.js
var es2015 = __webpack_require__(49732);
;// CONCATENATED MODULE: ../../node_modules/tabbable/dist/index.esm.js
/*!
* tabbable 6.1.1
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
// NOTE: separate `:not()` selectors has broader browser support than the newer
//  `:not([inert], [inert] *)` (Feb 2023)
// CAREFUL: JSDom does not support `:not([inert] *)` as a selector; using it causes
//  the entire query to fail, resulting in no nodes found, which will break a lot
//  of things... so we have to rely on JS to identify nodes inside an inert container
var candidateSelectors = ['input:not([inert])', 'select:not([inert])', 'textarea:not([inert])', 'a[href]:not([inert])', 'button:not([inert])', '[tabindex]:not(slot):not([inert])', 'audio[controls]:not([inert])', 'video[controls]:not([inert])', '[contenteditable]:not([contenteditable="false"]):not([inert])', 'details>summary:first-of-type:not([inert])', 'details:not([inert])'];
var candidateSelector = /* #__PURE__ */candidateSelectors.join(',');
var NoElement = typeof Element === 'undefined';
var matches = NoElement ? function () {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var getRootNode = !NoElement && Element.prototype.getRootNode ? function (element) {
  var _element$getRootNode;
  return element === null || element === void 0 ? void 0 : (_element$getRootNode = element.getRootNode) === null || _element$getRootNode === void 0 ? void 0 : _element$getRootNode.call(element);
} : function (element) {
  return element === null || element === void 0 ? void 0 : element.ownerDocument;
};

/**
 * Determines if a node is inert or in an inert ancestor.
 * @param {Element} [node]
 * @param {boolean} [lookUp] If true and `node` is not inert, looks up at ancestors to
 *  see if any of them are inert. If false, only `node` itself is considered.
 * @returns {boolean} True if inert itself or by way of being in an inert ancestor.
 *  False if `node` is falsy.
 */
var isInert = function isInert(node, lookUp) {
  var _node$getAttribute;
  if (lookUp === void 0) {
    lookUp = true;
  }
  // CAREFUL: JSDom does not support inert at all, so we can't use the `HTMLElement.inert`
  //  JS API property; we have to check the attribute, which can either be empty or 'true';
  //  if it's `null` (not specified) or 'false', it's an active element
  var inertAtt = node === null || node === void 0 ? void 0 : (_node$getAttribute = node.getAttribute) === null || _node$getAttribute === void 0 ? void 0 : _node$getAttribute.call(node, 'inert');
  var inert = inertAtt === '' || inertAtt === 'true';

  // NOTE: this could also be handled with `node.matches('[inert], :is([inert] *)')`
  //  if it weren't for `matches()` not being a function on shadow roots; the following
  //  code works for any kind of node
  // CAREFUL: JSDom does not appear to support certain selectors like `:not([inert] *)`
  //  so it likely would not support `:is([inert] *)` either...
  var result = inert || lookUp && node && isInert(node.parentNode); // recursive

  return result;
};

/**
 * Determines if a node's content is editable.
 * @param {Element} [node]
 * @returns True if it's content-editable; false if it's not or `node` is falsy.
 */
var isContentEditable = function isContentEditable(node) {
  var _node$getAttribute2;
  // CAREFUL: JSDom does not support the `HTMLElement.isContentEditable` API so we have
  //  to use the attribute directly to check for this, which can either be empty or 'true';
  //  if it's `null` (not specified) or 'false', it's a non-editable element
  var attValue = node === null || node === void 0 ? void 0 : (_node$getAttribute2 = node.getAttribute) === null || _node$getAttribute2 === void 0 ? void 0 : _node$getAttribute2.call(node, 'contenteditable');
  return attValue === '' || attValue === 'true';
};

/**
 * @param {Element} el container to check in
 * @param {boolean} includeContainer add container to check
 * @param {(node: Element) => boolean} filter filter candidates
 * @returns {Element[]}
 */
var getCandidates = function getCandidates(el, includeContainer, filter) {
  // even if `includeContainer=false`, we still have to check it for inertness because
  //  if it's inert, all its children are inert
  if (isInert(el)) {
    return [];
  }
  var candidates = Array.prototype.slice.apply(el.querySelectorAll(candidateSelector));
  if (includeContainer && matches.call(el, candidateSelector)) {
    candidates.unshift(el);
  }
  candidates = candidates.filter(filter);
  return candidates;
};

/**
 * @callback GetShadowRoot
 * @param {Element} element to check for shadow root
 * @returns {ShadowRoot|boolean} ShadowRoot if available or boolean indicating if a shadowRoot is attached but not available.
 */

/**
 * @callback ShadowRootFilter
 * @param {Element} shadowHostNode the element which contains shadow content
 * @returns {boolean} true if a shadow root could potentially contain valid candidates.
 */

/**
 * @typedef {Object} CandidateScope
 * @property {Element} scopeParent contains inner candidates
 * @property {Element[]} candidates list of candidates found in the scope parent
 */

/**
 * @typedef {Object} IterativeOptions
 * @property {GetShadowRoot|boolean} getShadowRoot true if shadow support is enabled; falsy if not;
 *  if a function, implies shadow support is enabled and either returns the shadow root of an element
 *  or a boolean stating if it has an undisclosed shadow root
 * @property {(node: Element) => boolean} filter filter candidates
 * @property {boolean} flatten if true then result will flatten any CandidateScope into the returned list
 * @property {ShadowRootFilter} shadowRootFilter filter shadow roots;
 */

/**
 * @param {Element[]} elements list of element containers to match candidates from
 * @param {boolean} includeContainer add container list to check
 * @param {IterativeOptions} options
 * @returns {Array.<Element|CandidateScope>}
 */
var getCandidatesIteratively = function getCandidatesIteratively(elements, includeContainer, options) {
  var candidates = [];
  var elementsToCheck = Array.from(elements);
  while (elementsToCheck.length) {
    var element = elementsToCheck.shift();
    if (isInert(element, false)) {
      // no need to look up since we're drilling down
      // anything inside this container will also be inert
      continue;
    }
    if (element.tagName === 'SLOT') {
      // add shadow dom slot scope (slot itself cannot be focusable)
      var assigned = element.assignedElements();
      var content = assigned.length ? assigned : element.children;
      var nestedCandidates = getCandidatesIteratively(content, true, options);
      if (options.flatten) {
        candidates.push.apply(candidates, nestedCandidates);
      } else {
        candidates.push({
          scopeParent: element,
          candidates: nestedCandidates
        });
      }
    } else {
      // check candidate element
      var validCandidate = matches.call(element, candidateSelector);
      if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) {
        candidates.push(element);
      }

      // iterate over shadow content if possible
      var shadowRoot = element.shadowRoot ||
      // check for an undisclosed shadow
      typeof options.getShadowRoot === 'function' && options.getShadowRoot(element);

      // no inert look up because we're already drilling down and checking for inertness
      //  on the way down, so all containers to this root node should have already been
      //  vetted as non-inert
      var validShadowRoot = !isInert(shadowRoot, false) && (!options.shadowRootFilter || options.shadowRootFilter(element));
      if (shadowRoot && validShadowRoot) {
        // add shadow dom scope IIF a shadow root node was given; otherwise, an undisclosed
        //  shadow exists, so look at light dom children as fallback BUT create a scope for any
        //  child candidates found because they're likely slotted elements (elements that are
        //  children of the web component element (which has the shadow), in the light dom, but
        //  slotted somewhere _inside_ the undisclosed shadow) -- the scope is created below,
        //  _after_ we return from this recursive call
        var _nestedCandidates = getCandidatesIteratively(shadowRoot === true ? element.children : shadowRoot.children, true, options);
        if (options.flatten) {
          candidates.push.apply(candidates, _nestedCandidates);
        } else {
          candidates.push({
            scopeParent: element,
            candidates: _nestedCandidates
          });
        }
      } else {
        // there's not shadow so just dig into the element's (light dom) children
        //  __without__ giving the element special scope treatment
        elementsToCheck.unshift.apply(elementsToCheck, element.children);
      }
    }
  }
  return candidates;
};
var getTabindex = function getTabindex(node, isScope) {
  if (node.tabIndex < 0) {
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    // `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    // yet they are still part of the regular tab order; in FF, they get a default
    // `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    // order, consider their tab index to be 0.
    // Also browsers do not return `tabIndex` correctly for contentEditable nodes;
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    //
    // isScope is positive for custom element with shadow root or slot that by default
    // have tabIndex -1, but need to be sorted by document order in order for their
    // content to be inserted in the correct position
    if ((isScope || /^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || isContentEditable(node)) && isNaN(parseInt(node.getAttribute('tabindex'), 10))) {
      return 0;
    }
  }
  return node.tabIndex;
};
var sortOrderedTabbables = function sortOrderedTabbables(a, b) {
  return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};
var isInput = function isInput(node) {
  return node.tagName === 'INPUT';
};
var isHiddenInput = function isHiddenInput(node) {
  return isInput(node) && node.type === 'hidden';
};
var isDetailsWithSummary = function isDetailsWithSummary(node) {
  var r = node.tagName === 'DETAILS' && Array.prototype.slice.apply(node.children).some(function (child) {
    return child.tagName === 'SUMMARY';
  });
  return r;
};
var getCheckedRadio = function getCheckedRadio(nodes, form) {
  for (var i = 0; i < nodes.length; i++) {
    if (nodes[i].checked && nodes[i].form === form) {
      return nodes[i];
    }
  }
};
var isTabbableRadio = function isTabbableRadio(node) {
  if (!node.name) {
    return true;
  }
  var radioScope = node.form || getRootNode(node);
  var queryRadios = function queryRadios(name) {
    return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
  };
  var radioSet;
  if (typeof window !== 'undefined' && typeof window.CSS !== 'undefined' && typeof window.CSS.escape === 'function') {
    radioSet = queryRadios(window.CSS.escape(node.name));
  } else {
    try {
      radioSet = queryRadios(node.name);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s', err.message);
      return false;
    }
  }
  var checked = getCheckedRadio(radioSet, node.form);
  return !checked || checked === node;
};
var isRadio = function isRadio(node) {
  return isInput(node) && node.type === 'radio';
};
var isNonTabbableRadio = function isNonTabbableRadio(node) {
  return isRadio(node) && !isTabbableRadio(node);
};

// determines if a node is ultimately attached to the window's document
var isNodeAttached = function isNodeAttached(node) {
  var _nodeRoot;
  // The root node is the shadow root if the node is in a shadow DOM; some document otherwise
  //  (but NOT _the_ document; see second 'If' comment below for more).
  // If rootNode is shadow root, it'll have a host, which is the element to which the shadow
  //  is attached, and the one we need to check if it's in the document or not (because the
  //  shadow, and all nodes it contains, is never considered in the document since shadows
  //  behave like self-contained DOMs; but if the shadow's HOST, which is part of the document,
  //  is hidden, or is not in the document itself but is detached, it will affect the shadow's
  //  visibility, including all the nodes it contains). The host could be any normal node,
  //  or a custom element (i.e. web component). Either way, that's the one that is considered
  //  part of the document, not the shadow root, nor any of its children (i.e. the node being
  //  tested).
  // To further complicate things, we have to look all the way up until we find a shadow HOST
  //  that is attached (or find none) because the node might be in nested shadows...
  // If rootNode is not a shadow root, it won't have a host, and so rootNode should be the
  //  document (per the docs) and while it's a Document-type object, that document does not
  //  appear to be the same as the node's `ownerDocument` for some reason, so it's safer
  //  to ignore the rootNode at this point, and use `node.ownerDocument`. Otherwise,
  //  using `rootNode.contains(node)` will _always_ be true we'll get false-positives when
  //  node is actually detached.
  // NOTE: If `nodeRootHost` or `node` happens to be the `document` itself (which is possible
  //  if a tabbable/focusable node was quickly added to the DOM, focused, and then removed
  //  from the DOM as in https://github.com/focus-trap/focus-trap-react/issues/905), then
  //  `ownerDocument` will be `null`, hence the optional chaining on it.
  var nodeRoot = node && getRootNode(node);
  var nodeRootHost = (_nodeRoot = nodeRoot) === null || _nodeRoot === void 0 ? void 0 : _nodeRoot.host;

  // in some cases, a detached node will return itself as the root instead of a document or
  //  shadow root object, in which case, we shouldn't try to look further up the host chain
  var attached = false;
  if (nodeRoot && nodeRoot !== node) {
    var _nodeRootHost, _nodeRootHost$ownerDo, _node$ownerDocument;
    attached = !!((_nodeRootHost = nodeRootHost) !== null && _nodeRootHost !== void 0 && (_nodeRootHost$ownerDo = _nodeRootHost.ownerDocument) !== null && _nodeRootHost$ownerDo !== void 0 && _nodeRootHost$ownerDo.contains(nodeRootHost) || node !== null && node !== void 0 && (_node$ownerDocument = node.ownerDocument) !== null && _node$ownerDocument !== void 0 && _node$ownerDocument.contains(node));
    while (!attached && nodeRootHost) {
      var _nodeRoot2, _nodeRootHost2, _nodeRootHost2$ownerD;
      // since it's not attached and we have a root host, the node MUST be in a nested shadow DOM,
      //  which means we need to get the host's host and check if that parent host is contained
      //  in (i.e. attached to) the document
      nodeRoot = getRootNode(nodeRootHost);
      nodeRootHost = (_nodeRoot2 = nodeRoot) === null || _nodeRoot2 === void 0 ? void 0 : _nodeRoot2.host;
      attached = !!((_nodeRootHost2 = nodeRootHost) !== null && _nodeRootHost2 !== void 0 && (_nodeRootHost2$ownerD = _nodeRootHost2.ownerDocument) !== null && _nodeRootHost2$ownerD !== void 0 && _nodeRootHost2$ownerD.contains(nodeRootHost));
    }
  }
  return attached;
};
var isZeroArea = function isZeroArea(node) {
  var _node$getBoundingClie = node.getBoundingClientRect(),
    width = _node$getBoundingClie.width,
    height = _node$getBoundingClie.height;
  return width === 0 && height === 0;
};
var isHidden = function isHidden(node, _ref) {
  var displayCheck = _ref.displayCheck,
    getShadowRoot = _ref.getShadowRoot;
  // NOTE: visibility will be `undefined` if node is detached from the document
  //  (see notes about this further down), which means we will consider it visible
  //  (this is legacy behavior from a very long way back)
  // NOTE: we check this regardless of `displayCheck="none"` because this is a
  //  _visibility_ check, not a _display_ check
  if (getComputedStyle(node).visibility === 'hidden') {
    return true;
  }
  var isDirectSummary = matches.call(node, 'details>summary:first-of-type');
  var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
  if (matches.call(nodeUnderDetails, 'details:not([open]) *')) {
    return true;
  }
  if (!displayCheck || displayCheck === 'full' || displayCheck === 'legacy-full') {
    if (typeof getShadowRoot === 'function') {
      // figure out if we should consider the node to be in an undisclosed shadow and use the
      //  'non-zero-area' fallback
      var originalNode = node;
      while (node) {
        var parentElement = node.parentElement;
        var rootNode = getRootNode(node);
        if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true // check if there's an undisclosed shadow
        ) {
          // node has an undisclosed shadow which means we can only treat it as a black box, so we
          //  fall back to a non-zero-area test
          return isZeroArea(node);
        } else if (node.assignedSlot) {
          // iterate up slot
          node = node.assignedSlot;
        } else if (!parentElement && rootNode !== node.ownerDocument) {
          // cross shadow boundary
          node = rootNode.host;
        } else {
          // iterate up normal dom
          node = parentElement;
        }
      }
      node = originalNode;
    }
    // else, `getShadowRoot` might be true, but all that does is enable shadow DOM support
    //  (i.e. it does not also presume that all nodes might have undisclosed shadows); or
    //  it might be a falsy value, which means shadow DOM support is disabled

    // Since we didn't find it sitting in an undisclosed shadow (or shadows are disabled)
    //  now we can just test to see if it would normally be visible or not, provided it's
    //  attached to the main document.
    // NOTE: We must consider case where node is inside a shadow DOM and given directly to
    //  `isTabbable()` or `isFocusable()` -- regardless of `getShadowRoot` option setting.

    if (isNodeAttached(node)) {
      // this works wherever the node is: if there's at least one client rect, it's
      //  somehow displayed; it also covers the CSS 'display: contents' case where the
      //  node itself is hidden in place of its contents; and there's no need to search
      //  up the hierarchy either
      return !node.getClientRects().length;
    }

    // Else, the node isn't attached to the document, which means the `getClientRects()`
    //  API will __always__ return zero rects (this can happen, for example, if React
    //  is used to render nodes onto a detached tree, as confirmed in this thread:
    //  https://github.com/facebook/react/issues/9117#issuecomment-284228870)
    //
    // It also means that even window.getComputedStyle(node).display will return `undefined`
    //  because styles are only computed for nodes that are in the document.
    //
    // NOTE: THIS HAS BEEN THE CASE FOR YEARS. It is not new, nor is it caused by tabbable
    //  somehow. Though it was never stated officially, anyone who has ever used tabbable
    //  APIs on nodes in detached containers has actually implicitly used tabbable in what
    //  was later (as of v5.2.0 on Apr 9, 2021) called `displayCheck="none"` mode -- essentially
    //  considering __everything__ to be visible because of the innability to determine styles.
    //
    // v6.0.0: As of this major release, the default 'full' option __no longer treats detached
    //  nodes as visible with the 'none' fallback.__
    if (displayCheck !== 'legacy-full') {
      return true; // hidden
    }
    // else, fallback to 'none' mode and consider the node visible
  } else if (displayCheck === 'non-zero-area') {
    // NOTE: Even though this tests that the node's client rect is non-zero to determine
    //  whether it's displayed, and that a detached node will __always__ have a zero-area
    //  client rect, we don't special-case for whether the node is attached or not. In
    //  this mode, we do want to consider nodes that have a zero area to be hidden at all
    //  times, and that includes attached or not.
    return isZeroArea(node);
  }

  // visible, as far as we can tell, or per current `displayCheck=none` mode, we assume
  //  it's visible
  return false;
};

// form fields (nested) inside a disabled fieldset are not focusable/tabbable
//  unless they are in the _first_ <legend> element of the top-most disabled
//  fieldset
var isDisabledFromFieldset = function isDisabledFromFieldset(node) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
    var parentNode = node.parentElement;
    // check if `node` is contained in a disabled <fieldset>
    while (parentNode) {
      if (parentNode.tagName === 'FIELDSET' && parentNode.disabled) {
        // look for the first <legend> among the children of the disabled <fieldset>
        for (var i = 0; i < parentNode.children.length; i++) {
          var child = parentNode.children.item(i);
          // when the first <legend> (in document order) is found
          if (child.tagName === 'LEGEND') {
            // if its parent <fieldset> is not nested in another disabled <fieldset>,
            // return whether `node` is a descendant of its first <legend>
            return matches.call(parentNode, 'fieldset[disabled] *') ? true : !child.contains(node);
          }
        }
        // the disabled <fieldset> containing `node` has no <legend>
        return true;
      }
      parentNode = parentNode.parentElement;
    }
  }

  // else, node's tabbable/focusable state should not be affected by a fieldset's
  //  enabled/disabled state
  return false;
};
var isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable(options, node) {
  if (node.disabled ||
  // we must do an inert look up to filter out any elements inside an inert ancestor
  //  because we're limited in the type of selectors we can use in JSDom (see related
  //  note related to `candidateSelectors`)
  isInert(node) || isHiddenInput(node) || isHidden(node, options) ||
  // For a details element with a summary, the summary element gets the focus
  isDetailsWithSummary(node) || isDisabledFromFieldset(node)) {
    return false;
  }
  return true;
};
var isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable(options, node) {
  if (isNonTabbableRadio(node) || getTabindex(node) < 0 || !isNodeMatchingSelectorFocusable(options, node)) {
    return false;
  }
  return true;
};
var isValidShadowRootTabbable = function isValidShadowRootTabbable(shadowHostNode) {
  var tabIndex = parseInt(shadowHostNode.getAttribute('tabindex'), 10);
  if (isNaN(tabIndex) || tabIndex >= 0) {
    return true;
  }
  // If a custom element has an explicit negative tabindex,
  // browsers will not allow tab targeting said element's children.
  return false;
};

/**
 * @param {Array.<Element|CandidateScope>} candidates
 * @returns Element[]
 */
var sortByOrder = function sortByOrder(candidates) {
  var regularTabbables = [];
  var orderedTabbables = [];
  candidates.forEach(function (item, i) {
    var isScope = !!item.scopeParent;
    var element = isScope ? item.scopeParent : item;
    var candidateTabindex = getTabindex(element, isScope);
    var elements = isScope ? sortByOrder(item.candidates) : element;
    if (candidateTabindex === 0) {
      isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
    } else {
      orderedTabbables.push({
        documentOrder: i,
        tabIndex: candidateTabindex,
        item: item,
        isScope: isScope,
        content: elements
      });
    }
  });
  return orderedTabbables.sort(sortOrderedTabbables).reduce(function (acc, sortable) {
    sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
    return acc;
  }, []).concat(regularTabbables);
};
var tabbable = function tabbable(el, options) {
  options = options || {};
  var candidates;
  if (options.getShadowRoot) {
    candidates = getCandidatesIteratively([el], options.includeContainer, {
      filter: isNodeMatchingSelectorTabbable.bind(null, options),
      flatten: false,
      getShadowRoot: options.getShadowRoot,
      shadowRootFilter: isValidShadowRootTabbable
    });
  } else {
    candidates = getCandidates(el, options.includeContainer, isNodeMatchingSelectorTabbable.bind(null, options));
  }
  return sortByOrder(candidates);
};
var focusable = function focusable(el, options) {
  options = options || {};
  var candidates;
  if (options.getShadowRoot) {
    candidates = getCandidatesIteratively([el], options.includeContainer, {
      filter: isNodeMatchingSelectorFocusable.bind(null, options),
      flatten: true,
      getShadowRoot: options.getShadowRoot
    });
  } else {
    candidates = getCandidates(el, options.includeContainer, isNodeMatchingSelectorFocusable.bind(null, options));
  }
  return candidates;
};
var isTabbable = function isTabbable(node, options) {
  options = options || {};
  if (!node) {
    throw new Error('No node provided');
  }
  if (matches.call(node, candidateSelector) === false) {
    return false;
  }
  return isNodeMatchingSelectorTabbable(options, node);
};
var focusableCandidateSelector = /* #__PURE__ */(/* unused pure expression or super */ null && (candidateSelectors.concat('iframe').join(',')));
var isFocusable = function isFocusable(node, options) {
  options = options || {};
  if (!node) {
    throw new Error('No node provided');
  }
  if (matches.call(node, focusableCandidateSelector) === false) {
    return false;
  }
  return isNodeMatchingSelectorFocusable(options, node);
};


//# sourceMappingURL=index.esm.js.map

// EXTERNAL MODULE: ../../node_modules/react-dom/index.js
var react_dom = __webpack_require__(28316);
// EXTERNAL MODULE: ../../node_modules/@floating-ui/dom/dist/floating-ui.dom.browser.min.mjs
var floating_ui_dom_browser_min = __webpack_require__(40771);
// EXTERNAL MODULE: ../../node_modules/@floating-ui/core/dist/floating-ui.core.browser.min.mjs
var floating_ui_core_browser_min = __webpack_require__(20189);
// EXTERNAL MODULE: ../../node_modules/@floating-ui/react-dom/dist/floating-ui.react-dom.esm.js
var floating_ui_react_dom_esm = __webpack_require__(66379);
;// CONCATENATED MODULE: ../../node_modules/@floating-ui/react/dist/floating-ui.react.esm.js








var index = typeof document !== 'undefined' ? react.useLayoutEffect : react.useEffect;

let serverHandoffComplete = false;
let count = 0;
const genId = () => "floating-ui-" + count++;
function useFloatingId() {
  const [id, setId] = react.useState(() => serverHandoffComplete ? genId() : undefined);
  index(() => {
    if (id == null) {
      setId(genId());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  react.useEffect(() => {
    if (!serverHandoffComplete) {
      serverHandoffComplete = true;
    }
  }, []);
  return id;
}

// `toString()` prevents bundlers from trying to `import { useId } from 'react'`
const useReactId = react_namespaceObject[/*#__PURE__*/'useId'.toString()];

/**
 * Uses React 18's built-in `useId()` when available, or falls back to a
 * slightly less performant (requiring a double render) implementation for
 * earlier React versions.
 * @see https://floating-ui.com/docs/useId
 */
const useId = useReactId || useFloatingId;

function createPubSub() {
  const map = new Map();
  return {
    emit(event, data) {
      var _map$get;
      (_map$get = map.get(event)) == null ? void 0 : _map$get.forEach(handler => handler(data));
    },
    on(event, listener) {
      map.set(event, [...(map.get(event) || []), listener]);
    },
    off(event, listener) {
      map.set(event, (map.get(event) || []).filter(l => l !== listener));
    }
  };
}

const FloatingNodeContext = /*#__PURE__*/react.createContext(null);
const FloatingTreeContext = /*#__PURE__*/react.createContext(null);
const useFloatingParentNodeId = () => {
  var _React$useContext;
  return ((_React$useContext = react.useContext(FloatingNodeContext)) == null ? void 0 : _React$useContext.id) || null;
};
const useFloatingTree = () => react.useContext(FloatingTreeContext);

/**
 * Registers a node into the floating tree, returning its id.
 */
const useFloatingNodeId = customParentId => {
  const id = useId();
  const tree = useFloatingTree();
  const reactParentId = useFloatingParentNodeId();
  const parentId = customParentId || reactParentId;
  index(() => {
    const node = {
      id,
      parentId
    };
    tree == null ? void 0 : tree.addNode(node);
    return () => {
      tree == null ? void 0 : tree.removeNode(node);
    };
  }, [tree, id, parentId]);
  return id;
};

/**
 * Provides parent node context for nested floating elements.
 * @see https://floating-ui.com/docs/FloatingTree
 */
const FloatingNode = _ref => {
  let {
    children,
    id
  } = _ref;
  const parentId = useFloatingParentNodeId();
  return /*#__PURE__*/react.createElement(FloatingNodeContext.Provider, {
    value: react.useMemo(() => ({
      id,
      parentId
    }), [id, parentId])
  }, children);
};

/**
 * Provides context for nested floating elements when they are not children of
 * each other on the DOM (i.e. portalled to a common node, rather than their
 * respective parent).
 * @see https://floating-ui.com/docs/FloatingTree
 */
const FloatingTree = _ref2 => {
  let {
    children
  } = _ref2;
  const nodesRef = react.useRef([]);
  const addNode = react.useCallback(node => {
    nodesRef.current = [...nodesRef.current, node];
  }, []);
  const removeNode = react.useCallback(node => {
    nodesRef.current = nodesRef.current.filter(n => n !== node);
  }, []);
  const events = react.useState(() => createPubSub())[0];
  return /*#__PURE__*/react.createElement(FloatingTreeContext.Provider, {
    value: react.useMemo(() => ({
      nodesRef,
      addNode,
      removeNode,
      events
    }), [nodesRef, addNode, removeNode, events])
  }, children);
};

function getDocument(node) {
  return (node == null ? void 0 : node.ownerDocument) || document;
}

// Avoid Chrome DevTools blue warning.
function getPlatform() {
  const uaData = navigator.userAgentData;
  if (uaData != null && uaData.platform) {
    return uaData.platform;
  }
  return navigator.platform;
}
function getUserAgent() {
  const uaData = navigator.userAgentData;
  if (uaData && Array.isArray(uaData.brands)) {
    return uaData.brands.map(_ref => {
      let {
        brand,
        version
      } = _ref;
      return brand + "/" + version;
    }).join(' ');
  }
  return navigator.userAgent;
}

function getWindow(value) {
  return getDocument(value).defaultView || window;
}
function isElement(value) {
  return value ? value instanceof getWindow(value).Element : false;
}
function isHTMLElement(value) {
  return value ? value instanceof getWindow(value).HTMLElement : false;
}
function isShadowRoot(node) {
  // Browsers without `ShadowRoot` support
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }
  const OwnElement = getWindow(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}

// License: https://github.com/adobe/react-spectrum/blob/b35d5c02fe900badccd0cf1a8f23bb593419f238/packages/@react-aria/utils/src/isVirtualEvent.ts
function isVirtualClick(event) {
  if (event.mozInputSource === 0 && event.isTrusted) {
    return true;
  }
  const androidRe = /Android/i;
  if ((androidRe.test(getPlatform()) || androidRe.test(getUserAgent())) && event.pointerType) {
    return event.type === 'click' && event.buttons === 1;
  }
  return event.detail === 0 && !event.pointerType;
}
function isVirtualPointerEvent(event) {
  return event.width === 0 && event.height === 0 || event.width === 1 && event.height === 1 && event.pressure === 0 && event.detail === 0 && event.pointerType !== 'mouse' ||
  // iOS VoiceOver returns 0.333• for width/height.
  event.width < 1 && event.height < 1 && event.pressure === 0 && event.detail === 0;
}
function isSafari() {
  // Chrome DevTools does not complain about navigator.vendor
  return /apple/i.test(navigator.vendor);
}
function isMac() {
  return getPlatform().toLowerCase().startsWith('mac') && !navigator.maxTouchPoints;
}
function isMouseLikePointerType(pointerType, strict) {
  // On some Linux machines with Chromium, mouse inputs return a `pointerType`
  // of "pen": https://github.com/floating-ui/floating-ui/issues/2015
  const values = ['mouse', 'pen'];
  if (!strict) {
    values.push('', undefined);
  }
  return values.includes(pointerType);
}

function useLatestRef(value) {
  const ref = (0,react.useRef)(value);
  index(() => {
    ref.current = value;
  });
  return ref;
}

const safePolygonIdentifier = 'data-floating-ui-safe-polygon';
function getDelay(value, prop, pointerType) {
  if (pointerType && !isMouseLikePointerType(pointerType)) {
    return 0;
  }
  if (typeof value === 'number') {
    return value;
  }
  return value == null ? void 0 : value[prop];
}
/**
 * Opens the floating element while hovering over the reference element, like
 * CSS `:hover`.
 * @see https://floating-ui.com/docs/useHover
 */
const useHover = function (context, _temp) {
  let {
    enabled = true,
    delay = 0,
    handleClose = null,
    mouseOnly = false,
    restMs = 0,
    move = true
  } = _temp === void 0 ? {} : _temp;
  const {
    open,
    onOpenChange,
    dataRef,
    events,
    elements: {
      domReference,
      floating
    },
    refs
  } = context;
  const tree = useFloatingTree();
  const parentId = useFloatingParentNodeId();
  const handleCloseRef = useLatestRef(handleClose);
  const delayRef = useLatestRef(delay);
  const pointerTypeRef = react.useRef();
  const timeoutRef = react.useRef();
  const handlerRef = react.useRef();
  const restTimeoutRef = react.useRef();
  const blockMouseMoveRef = react.useRef(true);
  const performedPointerEventsMutationRef = react.useRef(false);
  const unbindMouseMoveRef = react.useRef(() => {});
  const isHoverOpen = react.useCallback(() => {
    var _dataRef$current$open;
    const type = (_dataRef$current$open = dataRef.current.openEvent) == null ? void 0 : _dataRef$current$open.type;
    return (type == null ? void 0 : type.includes('mouse')) && type !== 'mousedown';
  }, [dataRef]);

  // When dismissing before opening, clear the delay timeouts to cancel it
  // from showing.
  react.useEffect(() => {
    if (!enabled) {
      return;
    }
    function onDismiss() {
      clearTimeout(timeoutRef.current);
      clearTimeout(restTimeoutRef.current);
      blockMouseMoveRef.current = true;
    }
    events.on('dismiss', onDismiss);
    return () => {
      events.off('dismiss', onDismiss);
    };
  }, [enabled, events]);
  react.useEffect(() => {
    if (!enabled || !handleCloseRef.current || !open) {
      return;
    }
    function onLeave() {
      if (isHoverOpen()) {
        onOpenChange(false);
      }
    }
    const html = getDocument(floating).documentElement;
    html.addEventListener('mouseleave', onLeave);
    return () => {
      html.removeEventListener('mouseleave', onLeave);
    };
  }, [floating, open, onOpenChange, enabled, handleCloseRef, dataRef, isHoverOpen]);
  const closeWithDelay = react.useCallback(function (runElseBranch) {
    if (runElseBranch === void 0) {
      runElseBranch = true;
    }
    const closeDelay = getDelay(delayRef.current, 'close', pointerTypeRef.current);
    if (closeDelay && !handlerRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => onOpenChange(false), closeDelay);
    } else if (runElseBranch) {
      clearTimeout(timeoutRef.current);
      onOpenChange(false);
    }
  }, [delayRef, onOpenChange]);
  const cleanupMouseMoveHandler = react.useCallback(() => {
    unbindMouseMoveRef.current();
    handlerRef.current = undefined;
  }, []);
  const clearPointerEvents = react.useCallback(() => {
    if (performedPointerEventsMutationRef.current) {
      const body = getDocument(refs.floating.current).body;
      body.style.pointerEvents = '';
      body.removeAttribute(safePolygonIdentifier);
      performedPointerEventsMutationRef.current = false;
    }
  }, [refs]);

  // Registering the mouse events on the reference directly to bypass React's
  // delegation system. If the cursor was on a disabled element and then entered
  // the reference (no gap), `mouseenter` doesn't fire in the delegation system.
  react.useEffect(() => {
    if (!enabled) {
      return;
    }
    function isClickLikeOpenEvent() {
      return dataRef.current.openEvent ? ['click', 'mousedown'].includes(dataRef.current.openEvent.type) : false;
    }
    function onMouseEnter(event) {
      clearTimeout(timeoutRef.current);
      blockMouseMoveRef.current = false;
      if (mouseOnly && !isMouseLikePointerType(pointerTypeRef.current) || restMs > 0 && getDelay(delayRef.current, 'open') === 0) {
        return;
      }
      dataRef.current.openEvent = event;
      const openDelay = getDelay(delayRef.current, 'open', pointerTypeRef.current);
      if (openDelay) {
        timeoutRef.current = setTimeout(() => {
          onOpenChange(true);
        }, openDelay);
      } else {
        onOpenChange(true);
      }
    }
    function onMouseLeave(event) {
      if (isClickLikeOpenEvent()) {
        return;
      }
      unbindMouseMoveRef.current();
      const doc = getDocument(floating);
      clearTimeout(restTimeoutRef.current);
      if (handleCloseRef.current) {
        // Prevent clearing `onScrollMouseLeave` timeout.
        if (!open) {
          clearTimeout(timeoutRef.current);
        }
        handlerRef.current = handleCloseRef.current({
          ...context,
          tree,
          x: event.clientX,
          y: event.clientY,
          onClose() {
            clearPointerEvents();
            cleanupMouseMoveHandler();
            closeWithDelay();
          }
        });
        const handler = handlerRef.current;
        doc.addEventListener('mousemove', handler);
        unbindMouseMoveRef.current = () => {
          doc.removeEventListener('mousemove', handler);
        };
        return;
      }
      closeWithDelay();
    }

    // Ensure the floating element closes after scrolling even if the pointer
    // did not move.
    // https://github.com/floating-ui/floating-ui/discussions/1692
    function onScrollMouseLeave(event) {
      if (isClickLikeOpenEvent()) {
        return;
      }
      handleCloseRef.current == null ? void 0 : handleCloseRef.current({
        ...context,
        tree,
        x: event.clientX,
        y: event.clientY,
        onClose() {
          clearPointerEvents();
          cleanupMouseMoveHandler();
          closeWithDelay();
        }
      })(event);
    }
    if (isElement(domReference)) {
      const ref = domReference;
      open && ref.addEventListener('mouseleave', onScrollMouseLeave);
      floating == null ? void 0 : floating.addEventListener('mouseleave', onScrollMouseLeave);
      move && ref.addEventListener('mousemove', onMouseEnter, {
        once: true
      });
      ref.addEventListener('mouseenter', onMouseEnter);
      ref.addEventListener('mouseleave', onMouseLeave);
      return () => {
        open && ref.removeEventListener('mouseleave', onScrollMouseLeave);
        floating == null ? void 0 : floating.removeEventListener('mouseleave', onScrollMouseLeave);
        move && ref.removeEventListener('mousemove', onMouseEnter);
        ref.removeEventListener('mouseenter', onMouseEnter);
        ref.removeEventListener('mouseleave', onMouseLeave);
      };
    }
  }, [domReference, floating, enabled, context, mouseOnly, restMs, move, closeWithDelay, cleanupMouseMoveHandler, clearPointerEvents, onOpenChange, open, tree, delayRef, handleCloseRef, dataRef]);

  // Block pointer-events of every element other than the reference and floating
  // while the floating element is open and has a `handleClose` handler. Also
  // handles nested floating elements.
  // https://github.com/floating-ui/floating-ui/issues/1722
  index(() => {
    var _handleCloseRef$curre;
    if (!enabled) {
      return;
    }
    if (open && (_handleCloseRef$curre = handleCloseRef.current) != null && _handleCloseRef$curre.__options.blockPointerEvents && isHoverOpen()) {
      const body = getDocument(floating).body;
      body.setAttribute(safePolygonIdentifier, '');
      body.style.pointerEvents = 'none';
      performedPointerEventsMutationRef.current = true;
      if (isElement(domReference) && floating) {
        var _tree$nodesRef$curren, _tree$nodesRef$curren2;
        const ref = domReference;
        const parentFloating = tree == null ? void 0 : (_tree$nodesRef$curren = tree.nodesRef.current.find(node => node.id === parentId)) == null ? void 0 : (_tree$nodesRef$curren2 = _tree$nodesRef$curren.context) == null ? void 0 : _tree$nodesRef$curren2.elements.floating;
        if (parentFloating) {
          parentFloating.style.pointerEvents = '';
        }
        ref.style.pointerEvents = 'auto';
        floating.style.pointerEvents = 'auto';
        return () => {
          ref.style.pointerEvents = '';
          floating.style.pointerEvents = '';
        };
      }
    }
  }, [enabled, open, parentId, floating, domReference, tree, handleCloseRef, dataRef, isHoverOpen]);
  index(() => {
    if (!open) {
      pointerTypeRef.current = undefined;
      cleanupMouseMoveHandler();
      clearPointerEvents();
    }
  }, [open, cleanupMouseMoveHandler, clearPointerEvents]);
  react.useEffect(() => {
    return () => {
      cleanupMouseMoveHandler();
      clearTimeout(timeoutRef.current);
      clearTimeout(restTimeoutRef.current);
      clearPointerEvents();
    };
  }, [enabled, cleanupMouseMoveHandler, clearPointerEvents]);
  return react.useMemo(() => {
    if (!enabled) {
      return {};
    }
    function setPointerRef(event) {
      pointerTypeRef.current = event.pointerType;
    }
    return {
      reference: {
        onPointerDown: setPointerRef,
        onPointerEnter: setPointerRef,
        onMouseMove() {
          if (open || restMs === 0) {
            return;
          }
          clearTimeout(restTimeoutRef.current);
          restTimeoutRef.current = setTimeout(() => {
            if (!blockMouseMoveRef.current) {
              onOpenChange(true);
            }
          }, restMs);
        }
      },
      floating: {
        onMouseEnter() {
          clearTimeout(timeoutRef.current);
        },
        onMouseLeave() {
          events.emit('dismiss', {
            type: 'mouseLeave',
            data: {
              returnFocus: false
            }
          });
          closeWithDelay(false);
        }
      }
    };
  }, [events, enabled, restMs, open, onOpenChange, closeWithDelay]);
};

const FloatingDelayGroupContext = /*#__PURE__*/react.createContext({
  delay: 0,
  initialDelay: 0,
  timeoutMs: 0,
  currentId: null,
  setCurrentId: () => {},
  setState: () => {},
  isInstantPhase: false
});
const useDelayGroupContext = () => react.useContext(FloatingDelayGroupContext);

/**
 * Provides context for a group of floating elements that should share a
 * `delay`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */
const FloatingDelayGroup = _ref => {
  let {
    children,
    delay,
    timeoutMs = 0
  } = _ref;
  const [state, setState] = react.useReducer((prev, next) => ({
    ...prev,
    ...next
  }), {
    delay,
    timeoutMs,
    initialDelay: delay,
    currentId: null,
    isInstantPhase: false
  });
  const initialCurrentIdRef = react.useRef(null);
  const setCurrentId = react.useCallback(currentId => {
    setState({
      currentId
    });
  }, []);
  index(() => {
    if (state.currentId) {
      if (initialCurrentIdRef.current === null) {
        initialCurrentIdRef.current = state.currentId;
      } else {
        setState({
          isInstantPhase: true
        });
      }
    } else {
      setState({
        isInstantPhase: false
      });
      initialCurrentIdRef.current = null;
    }
  }, [state.currentId]);
  return /*#__PURE__*/react.createElement(FloatingDelayGroupContext.Provider, {
    value: react.useMemo(() => ({
      ...state,
      setState,
      setCurrentId
    }), [state, setState, setCurrentId])
  }, children);
};
const useDelayGroup = (_ref2, _ref3) => {
  let {
    open,
    onOpenChange
  } = _ref2;
  let {
    id
  } = _ref3;
  const {
    currentId,
    setCurrentId,
    initialDelay,
    setState,
    timeoutMs
  } = useDelayGroupContext();
  react.useEffect(() => {
    if (currentId) {
      setState({
        delay: {
          open: 1,
          close: getDelay(initialDelay, 'close')
        }
      });
      if (currentId !== id) {
        onOpenChange(false);
      }
    }
  }, [id, onOpenChange, setState, currentId, initialDelay]);
  react.useEffect(() => {
    function unset() {
      onOpenChange(false);
      setState({
        delay: initialDelay,
        currentId: null
      });
    }
    if (!open && currentId === id) {
      if (timeoutMs) {
        const timeout = window.setTimeout(unset, timeoutMs);
        return () => {
          clearTimeout(timeout);
        };
      } else {
        unset();
      }
    }
  }, [open, setState, currentId, id, onOpenChange, initialDelay, timeoutMs]);
  react.useEffect(() => {
    if (open) {
      setCurrentId(id);
    }
  }, [open, setCurrentId, id]);
};

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

/**
 * Find the real active element. Traverses into shadowRoots.
 */
function activeElement$1(doc) {
  let activeElement = doc.activeElement;
  while (((_activeElement = activeElement) == null ? void 0 : (_activeElement$shadow = _activeElement.shadowRoot) == null ? void 0 : _activeElement$shadow.activeElement) != null) {
    var _activeElement, _activeElement$shadow;
    activeElement = activeElement.shadowRoot.activeElement;
  }
  return activeElement;
}

function contains(parent, child) {
  if (!parent || !child) {
    return false;
  }
  const rootNode = child.getRootNode && child.getRootNode();

  // First, attempt with faster native method
  if (parent.contains(child)) {
    return true;
  }
  // then fallback to custom implementation with Shadow DOM support
  else if (rootNode && isShadowRoot(rootNode)) {
    let next = child;
    do {
      if (next && parent === next) {
        return true;
      }
      // @ts-ignore
      next = next.parentNode || next.host;
    } while (next);
  }

  // Give up, the result is false
  return false;
}

let rafId = 0;
function enqueueFocus(el, options) {
  if (options === void 0) {
    options = {};
  }
  const {
    preventScroll = false,
    cancelPrevious = true,
    sync = false
  } = options;
  cancelPrevious && cancelAnimationFrame(rafId);
  const exec = () => el == null ? void 0 : el.focus({
    preventScroll
  });
  if (sync) {
    exec();
  } else {
    rafId = requestAnimationFrame(exec);
  }
}

function getAncestors(nodes, id) {
  var _nodes$find;
  let allAncestors = [];
  let currentParentId = (_nodes$find = nodes.find(node => node.id === id)) == null ? void 0 : _nodes$find.parentId;
  while (currentParentId) {
    const currentNode = nodes.find(node => node.id === currentParentId);
    currentParentId = currentNode == null ? void 0 : currentNode.parentId;
    if (currentNode) {
      allAncestors = allAncestors.concat(currentNode);
    }
  }
  return allAncestors;
}

function getChildren(nodes, id) {
  let allChildren = nodes.filter(node => {
    var _node$context;
    return node.parentId === id && ((_node$context = node.context) == null ? void 0 : _node$context.open);
  }) || [];
  let currentChildren = allChildren;
  while (currentChildren.length) {
    currentChildren = nodes.filter(node => {
      var _currentChildren;
      return (_currentChildren = currentChildren) == null ? void 0 : _currentChildren.some(n => {
        var _node$context2;
        return node.parentId === n.id && ((_node$context2 = node.context) == null ? void 0 : _node$context2.open);
      });
    }) || [];
    allChildren = allChildren.concat(currentChildren);
  }
  return allChildren;
}

function getTarget(event) {
  if ('composedPath' in event) {
    return event.composedPath()[0];
  }

  // TS thinks `event` is of type never as it assumes all browsers support
  // `composedPath()`, but browsers without shadow DOM don't.
  return event.target;
}

const TYPEABLE_SELECTOR = "input:not([type='hidden']):not([disabled])," + "[contenteditable]:not([contenteditable='false']),textarea:not([disabled])";
function isTypeableElement(element) {
  return isHTMLElement(element) && element.matches(TYPEABLE_SELECTOR);
}

function stopEvent(event) {
  event.preventDefault();
  event.stopPropagation();
}

const getTabbableOptions = () => ({
  getShadowRoot: true,
  displayCheck:
  // JSDOM does not support the `tabbable` library. To solve this we can
  // check if `ResizeObserver` is a real function (not polyfilled), which
  // determines if the current environment is JSDOM-like.
  typeof ResizeObserver === 'function' && ResizeObserver.toString().includes('[native code]') ? 'full' : 'none'
});
function getTabbableIn(container, direction) {
  const allTabbable = tabbable(container, getTabbableOptions());
  if (direction === 'prev') {
    allTabbable.reverse();
  }
  const activeIndex = allTabbable.indexOf(activeElement$1(getDocument(container)));
  const nextTabbableElements = allTabbable.slice(activeIndex + 1);
  return nextTabbableElements[0];
}
function getNextTabbable() {
  return getTabbableIn(document.body, 'next');
}
function getPreviousTabbable() {
  return getTabbableIn(document.body, 'prev');
}
function isOutsideEvent(event, container) {
  const containerElement = container || event.currentTarget;
  const relatedTarget = event.relatedTarget;
  return !relatedTarget || !contains(containerElement, relatedTarget);
}
function disableFocusInside(container) {
  const tabbableElements = tabbable(container, getTabbableOptions());
  tabbableElements.forEach(element => {
    element.dataset.tabindex = element.getAttribute('tabindex') || '';
    element.setAttribute('tabindex', '-1');
  });
}
function enableFocusInside(container) {
  const elements = container.querySelectorAll('[data-tabindex]');
  elements.forEach(element => {
    const tabindex = element.dataset.tabindex;
    delete element.dataset.tabindex;
    if (tabindex) {
      element.setAttribute('tabindex', tabindex);
    } else {
      element.removeAttribute('tabindex');
    }
  });
}

// `toString()` prevents bundlers from trying to `import { useInsertionEffect } from 'react'`
const useInsertionEffect = react_namespaceObject[/*#__PURE__*/'useInsertionEffect'.toString()];
const useSafeInsertionEffect = useInsertionEffect || (fn => fn());
function useEvent(callback) {
  const ref = react.useRef(() => {
    if (false) {}
  });
  useSafeInsertionEffect(() => {
    ref.current = callback;
  });
  return react.useCallback(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return ref.current == null ? void 0 : ref.current(...args);
  }, []);
}

// See Diego Haz's Sandbox for making this logic work well on Safari/iOS:
// https://codesandbox.io/s/tabbable-portal-f4tng?file=/src/FocusTrap.tsx

const HIDDEN_STYLES = {
  border: 0,
  clip: 'rect(0 0 0 0)',
  height: '1px',
  margin: '-1px',
  overflow: 'hidden',
  padding: 0,
  position: 'fixed',
  whiteSpace: 'nowrap',
  width: '1px',
  top: 0,
  left: 0
};
let activeElement;
let timeoutId;
function setActiveElementOnTab(event) {
  if (event.key === 'Tab') {
    activeElement = event.target;
    clearTimeout(timeoutId);
  }
}
function isTabFocus(event) {
  const result = activeElement === event.relatedTarget;
  activeElement = event.relatedTarget;
  clearTimeout(timeoutId);
  return result;
}
const FocusGuard = /*#__PURE__*/react.forwardRef(function FocusGuard(props, ref) {
  const onFocus = useEvent(props.onFocus);
  const [role, setRole] = react.useState();
  index(() => {
    if (isSafari()) {
      // Unlike other screen readers such as NVDA and JAWS, the virtual cursor
      // on VoiceOver does trigger the onFocus event, so we can use the focus
      // trap element. On Safari, only buttons trigger the onFocus event.
      // NB: "group" role in the Sandbox no longer appears to work, must be a
      // button role.
      setRole('button');
    }
    document.addEventListener('keydown', setActiveElementOnTab);
    return () => {
      document.removeEventListener('keydown', setActiveElementOnTab);
    };
  }, []);
  return /*#__PURE__*/react.createElement("span", _extends({}, props, {
    ref: ref,
    tabIndex: 0
    // Role is only for VoiceOver
    ,
    role: role,
    "aria-hidden": role ? undefined : true,
    "data-floating-ui-focus-guard": "",
    style: HIDDEN_STYLES,
    onFocus: event => {
      if (isSafari() && isMac() && !isTabFocus(event)) {
        // On macOS we need to wait a little bit before moving
        // focus again.
        event.persist();
        timeoutId = window.setTimeout(() => {
          onFocus(event);
        }, 50);
      } else {
        onFocus(event);
      }
    }
  }));
});

const PortalContext = /*#__PURE__*/react.createContext(null);
const useFloatingPortalNode = function (_temp) {
  let {
    id,
    enabled = true
  } = _temp === void 0 ? {} : _temp;
  const [portalEl, setPortalEl] = react.useState(null);
  const uniqueId = useId();
  const portalContext = usePortalContext();
  index(() => {
    if (!enabled) {
      return;
    }
    const rootNode = id ? document.getElementById(id) : null;
    if (rootNode) {
      rootNode.setAttribute('data-floating-ui-portal', '');
      setPortalEl(rootNode);
    } else {
      const newPortalEl = document.createElement('div');
      if (id !== '') {
        newPortalEl.id = id || uniqueId;
      }
      newPortalEl.setAttribute('data-floating-ui-portal', '');
      setPortalEl(newPortalEl);
      const container = (portalContext == null ? void 0 : portalContext.portalNode) || document.body;
      container.appendChild(newPortalEl);
      return () => {
        container.removeChild(newPortalEl);
      };
    }
  }, [id, portalContext, uniqueId, enabled]);
  return portalEl;
};

/**
 * Portals the floating element into a given container element — by default,
 * outside of the app root and into the body.
 * @see https://floating-ui.com/docs/FloatingPortal
 */
const FloatingPortal = _ref => {
  let {
    children,
    id,
    root = null,
    preserveTabOrder = true
  } = _ref;
  const portalNode = useFloatingPortalNode({
    id,
    enabled: !root
  });
  const [focusManagerState, setFocusManagerState] = react.useState(null);
  const beforeOutsideRef = react.useRef(null);
  const afterOutsideRef = react.useRef(null);
  const beforeInsideRef = react.useRef(null);
  const afterInsideRef = react.useRef(null);
  const shouldRenderGuards =
  // The FocusManager and therefore floating element are currently open/
  // rendered.
  !!focusManagerState &&
  // Guards are only for non-modal focus management.
  !focusManagerState.modal && !!(root || portalNode) && preserveTabOrder;

  // https://codesandbox.io/s/tabbable-portal-f4tng?file=/src/TabbablePortal.tsx
  react.useEffect(() => {
    if (!portalNode || !preserveTabOrder || focusManagerState != null && focusManagerState.modal) {
      return;
    }

    // Make sure elements inside the portal element are tabbable only when the
    // portal has already been focused, either by tabbing into a focus trap
    // element outside or using the mouse.
    function onFocus(event) {
      if (portalNode && isOutsideEvent(event)) {
        const focusing = event.type === 'focusin';
        const manageFocus = focusing ? enableFocusInside : disableFocusInside;
        manageFocus(portalNode);
      }
    }
    // Listen to the event on the capture phase so they run before the focus
    // trap elements onFocus prop is called.
    portalNode.addEventListener('focusin', onFocus, true);
    portalNode.addEventListener('focusout', onFocus, true);
    return () => {
      portalNode.removeEventListener('focusin', onFocus, true);
      portalNode.removeEventListener('focusout', onFocus, true);
    };
  }, [portalNode, preserveTabOrder, focusManagerState == null ? void 0 : focusManagerState.modal]);
  return /*#__PURE__*/react.createElement(PortalContext.Provider, {
    value: react.useMemo(() => ({
      preserveTabOrder,
      beforeOutsideRef,
      afterOutsideRef,
      beforeInsideRef,
      afterInsideRef,
      portalNode,
      setFocusManagerState
    }), [preserveTabOrder, portalNode])
  }, shouldRenderGuards && portalNode && /*#__PURE__*/react.createElement(FocusGuard, {
    "data-type": "outside",
    ref: beforeOutsideRef,
    onFocus: event => {
      if (isOutsideEvent(event, portalNode)) {
        var _beforeInsideRef$curr;
        (_beforeInsideRef$curr = beforeInsideRef.current) == null ? void 0 : _beforeInsideRef$curr.focus();
      } else {
        const prevTabbable = getPreviousTabbable() || (focusManagerState == null ? void 0 : focusManagerState.refs.domReference.current);
        prevTabbable == null ? void 0 : prevTabbable.focus();
      }
    }
  }), shouldRenderGuards && portalNode && /*#__PURE__*/react.createElement("span", {
    "aria-owns": portalNode.id,
    style: HIDDEN_STYLES
  }), root ? /*#__PURE__*/(0,react_dom.createPortal)(children, root) : portalNode ? /*#__PURE__*/(0,react_dom.createPortal)(children, portalNode) : null, shouldRenderGuards && portalNode && /*#__PURE__*/react.createElement(FocusGuard, {
    "data-type": "outside",
    ref: afterOutsideRef,
    onFocus: event => {
      if (isOutsideEvent(event, portalNode)) {
        var _afterInsideRef$curre;
        (_afterInsideRef$curre = afterInsideRef.current) == null ? void 0 : _afterInsideRef$curre.focus();
      } else {
        const nextTabbable = getNextTabbable() || (focusManagerState == null ? void 0 : focusManagerState.refs.domReference.current);
        nextTabbable == null ? void 0 : nextTabbable.focus();
        (focusManagerState == null ? void 0 : focusManagerState.closeOnFocusOut) && (focusManagerState == null ? void 0 : focusManagerState.onOpenChange(false));
      }
    }
  }));
};
const usePortalContext = () => react.useContext(PortalContext);

const VisuallyHiddenDismiss = /*#__PURE__*/react.forwardRef(function VisuallyHiddenDismiss(props, ref) {
  return /*#__PURE__*/react.createElement("button", _extends({}, props, {
    type: "button",
    ref: ref,
    tabIndex: -1,
    style: HIDDEN_STYLES
  }));
});
/**
 * Provides focus management for the floating element.
 * @see https://floating-ui.com/docs/FloatingFocusManager
 */
function FloatingFocusManager(_ref) {
  let {
    context,
    children,
    order = ['content'],
    guards = true,
    initialFocus = 0,
    returnFocus = true,
    modal = true,
    visuallyHiddenDismiss = false,
    closeOnFocusOut = true
  } = _ref;
  const {
    refs,
    nodeId,
    onOpenChange,
    events,
    dataRef,
    elements: {
      domReference,
      floating
    }
  } = context;
  const orderRef = useLatestRef(order);
  const tree = useFloatingTree();
  const portalContext = usePortalContext();
  const [tabbableContentLength, setTabbableContentLength] = react.useState(null);

  // Controlled by `useListNavigation`.
  const ignoreInitialFocus = typeof initialFocus === 'number' && initialFocus < 0;
  const startDismissButtonRef = react.useRef(null);
  const endDismissButtonRef = react.useRef(null);
  const preventReturnFocusRef = react.useRef(false);
  const previouslyFocusedElementRef = react.useRef(null);
  const isPointerDownRef = react.useRef(false);
  const isInsidePortal = portalContext != null;

  // If the reference is a combobox and is typeable (e.g. input/textarea),
  // there are different focus semantics. The guards should not be rendered, but
  // aria-hidden should be applied to all nodes still. Further, the visually
  // hidden dismiss button should only appear at the end of the list, not the
  // start.
  const isTypeableCombobox = domReference && domReference.getAttribute('role') === 'combobox' && isTypeableElement(domReference);
  const getTabbableContent = react.useCallback(function (container) {
    if (container === void 0) {
      container = floating;
    }
    return container ? tabbable(container, getTabbableOptions()) : [];
  }, [floating]);
  const getTabbableElements = react.useCallback(container => {
    const content = getTabbableContent(container);
    return orderRef.current.map(type => {
      if (domReference && type === 'reference') {
        return domReference;
      }
      if (floating && type === 'floating') {
        return floating;
      }
      return content;
    }).filter(Boolean).flat();
  }, [domReference, floating, orderRef, getTabbableContent]);
  react.useEffect(() => {
    if (!modal) {
      return;
    }
    function onKeyDown(event) {
      if (event.key === 'Tab') {
        // The focus guards have nothing to focus, so we need to stop the event.
        if (getTabbableContent().length === 0 && !isTypeableCombobox) {
          stopEvent(event);
        }
        const els = getTabbableElements();
        const target = getTarget(event);
        if (orderRef.current[0] === 'reference' && target === domReference) {
          stopEvent(event);
          if (event.shiftKey) {
            enqueueFocus(els[els.length - 1]);
          } else {
            enqueueFocus(els[1]);
          }
        }
        if (orderRef.current[1] === 'floating' && target === floating && event.shiftKey) {
          stopEvent(event);
          enqueueFocus(els[0]);
        }
      }
    }
    const doc = getDocument(floating);
    doc.addEventListener('keydown', onKeyDown);
    return () => {
      doc.removeEventListener('keydown', onKeyDown);
    };
  }, [domReference, floating, modal, orderRef, refs, isTypeableCombobox, getTabbableContent, getTabbableElements]);
  react.useEffect(() => {
    if (!closeOnFocusOut) {
      return;
    }

    // In Safari, buttons lose focus when pressing them.
    function handlePointerDown() {
      isPointerDownRef.current = true;
      setTimeout(() => {
        isPointerDownRef.current = false;
      });
    }
    function handleFocusOutside(event) {
      const relatedTarget = event.relatedTarget;
      const movedToUnrelatedNode = !(contains(domReference, relatedTarget) || contains(floating, relatedTarget) || contains(relatedTarget, floating) || contains(portalContext == null ? void 0 : portalContext.portalNode, relatedTarget) || relatedTarget != null && relatedTarget.hasAttribute('data-floating-ui-focus-guard') || tree && (getChildren(tree.nodesRef.current, nodeId).find(node => {
        var _node$context, _node$context2;
        return contains((_node$context = node.context) == null ? void 0 : _node$context.elements.floating, relatedTarget) || contains((_node$context2 = node.context) == null ? void 0 : _node$context2.elements.domReference, relatedTarget);
      }) || getAncestors(tree.nodesRef.current, nodeId).find(node => {
        var _node$context3, _node$context4;
        return ((_node$context3 = node.context) == null ? void 0 : _node$context3.elements.floating) === relatedTarget || ((_node$context4 = node.context) == null ? void 0 : _node$context4.elements.domReference) === relatedTarget;
      })));

      // Focus did not move inside the floating tree, and there are no tabbable
      // portal guards to handle closing.
      if (relatedTarget && movedToUnrelatedNode && !isPointerDownRef.current &&
      // Fix React 18 Strict Mode returnFocus due to double rendering.
      relatedTarget !== previouslyFocusedElementRef.current) {
        preventReturnFocusRef.current = true;
        // On iOS VoiceOver, dismissing the nested submenu will cause the
        // first item of the list to receive focus. Delaying it appears to fix
        // the issue.
        setTimeout(() => onOpenChange(false));
      }
    }
    if (floating && isHTMLElement(domReference)) {
      domReference.addEventListener('focusout', handleFocusOutside);
      domReference.addEventListener('pointerdown', handlePointerDown);
      !modal && floating.addEventListener('focusout', handleFocusOutside);
      return () => {
        domReference.removeEventListener('focusout', handleFocusOutside);
        domReference.removeEventListener('pointerdown', handlePointerDown);
        !modal && floating.removeEventListener('focusout', handleFocusOutside);
      };
    }
  }, [domReference, floating, modal, nodeId, tree, portalContext, onOpenChange, closeOnFocusOut]);
  react.useEffect(() => {
    var _portalContext$portal;
    // Don't hide portals nested within the parent portal.
    const portalNodes = Array.from((portalContext == null ? void 0 : (_portalContext$portal = portalContext.portalNode) == null ? void 0 : _portalContext$portal.querySelectorAll('[data-floating-ui-portal]')) || []);
    function getDismissButtons() {
      return [startDismissButtonRef.current, endDismissButtonRef.current].filter(Boolean);
    }
    if (floating && modal) {
      const insideNodes = [floating, ...portalNodes, ...getDismissButtons()];
      const cleanup = (0,es2015/* hideOthers */.Ry)(orderRef.current.includes('reference') || isTypeableCombobox ? insideNodes.concat(domReference || []) : insideNodes);
      return () => {
        cleanup();
      };
    }
  }, [domReference, floating, modal, orderRef, portalContext, isTypeableCombobox]);
  react.useEffect(() => {
    if (modal && !guards && floating) {
      const tabIndexValues = [];
      const options = getTabbableOptions();
      const allTabbable = tabbable(getDocument(floating).body, options);
      const floatingTabbable = getTabbableElements();

      // Exclude all tabbable elements that are part of the order
      const elements = allTabbable.filter(el => !floatingTabbable.includes(el));
      elements.forEach((el, i) => {
        tabIndexValues[i] = el.getAttribute('tabindex');
        el.setAttribute('tabindex', '-1');
      });
      return () => {
        elements.forEach((el, i) => {
          const value = tabIndexValues[i];
          if (value == null) {
            el.removeAttribute('tabindex');
          } else {
            el.setAttribute('tabindex', value);
          }
        });
      };
    }
  }, [floating, modal, guards, getTabbableElements]);
  index(() => {
    if (!floating) return;
    const doc = getDocument(floating);
    let returnFocusValue = returnFocus;
    let preventReturnFocusScroll = false;
    const previouslyFocusedElement = activeElement$1(doc);
    const contextData = dataRef.current;
    previouslyFocusedElementRef.current = previouslyFocusedElement;
    const focusableElements = getTabbableElements(floating);
    const elToFocus = (typeof initialFocus === 'number' ? focusableElements[initialFocus] : initialFocus.current) || floating;

    // If the `useListNavigation` hook is active, always ignore `initialFocus`
    // because it has its own handling of the initial focus.
    !ignoreInitialFocus && enqueueFocus(elToFocus, {
      preventScroll: elToFocus === floating
    });

    // Dismissing via outside press should always ignore `returnFocus` to
    // prevent unwanted scrolling.
    function onDismiss(payload) {
      if (payload.type === 'escapeKey' && refs.domReference.current) {
        previouslyFocusedElementRef.current = refs.domReference.current;
      }
      if (['referencePress', 'escapeKey'].includes(payload.type)) {
        return;
      }
      const returnFocus = payload.data.returnFocus;
      if (typeof returnFocus === 'object') {
        returnFocusValue = true;
        preventReturnFocusScroll = returnFocus.preventScroll;
      } else {
        returnFocusValue = returnFocus;
      }
    }
    events.on('dismiss', onDismiss);
    return () => {
      events.off('dismiss', onDismiss);
      if (contains(floating, activeElement$1(doc)) && refs.domReference.current) {
        previouslyFocusedElementRef.current = refs.domReference.current;
      }
      if (returnFocusValue && isHTMLElement(previouslyFocusedElementRef.current) && !preventReturnFocusRef.current) {
        // `isPointerDownRef.current` to avoid the focus ring from appearing on
        // the reference element when click-toggling it.
        if (!refs.domReference.current || isPointerDownRef.current) {
          enqueueFocus(previouslyFocusedElementRef.current, {
            // When dismissing nested floating elements, by the time the rAF has
            // executed, the menus will all have been unmounted. When they try
            // to get focused, the calls get ignored — leaving the root
            // reference focused as desired.
            cancelPrevious: false,
            preventScroll: preventReturnFocusScroll
          });
        } else {
          var _previouslyFocusedEle;
          // If the user has specified a `keydown` listener that calls
          // setOpen(false) (e.g. selecting an item and closing the floating
          // element), then sync return focus causes `useClick` to immediately
          // re-open it, unless they call `event.preventDefault()` in the
          // `keydown` listener. This helps keep backwards compatibility with
          // older examples.
          contextData.__syncReturnFocus = true;

          // In Safari, `useListNavigation` moves focus sync, so making this
          // sync ensures the initial item remains focused despite this being
          // invoked in Strict Mode due to double-invoked useEffects. This also
          // has the positive side effect of closing a modally focus-managed
          // <Menu> on `Tab` keydown to move naturally to the next focusable
          // element.
          (_previouslyFocusedEle = previouslyFocusedElementRef.current) == null ? void 0 : _previouslyFocusedEle.focus({
            preventScroll: preventReturnFocusScroll
          });
          setTimeout(() => {
            // This isn't an actual property the user should access, make sure
            // it doesn't persist.
            delete contextData.__syncReturnFocus;
          });
        }
      }
    };
  }, [floating, getTabbableElements, initialFocus, returnFocus, dataRef, refs, events, ignoreInitialFocus]);

  // Synchronize the `context` & `modal` value to the FloatingPortal context.
  // It will decide whether or not it needs to render its own guards.
  index(() => {
    if (!portalContext) return;
    portalContext.setFocusManagerState({
      ...context,
      modal,
      closeOnFocusOut
      // Not concerned about the <RT> generic type.
    });

    return () => {
      portalContext.setFocusManagerState(null);
    };
  }, [portalContext, modal, closeOnFocusOut, context]);
  index(() => {
    if (ignoreInitialFocus || !floating) return;
    function setState() {
      setTabbableContentLength(getTabbableContent().length);
    }
    setState();
    if (typeof MutationObserver === 'function') {
      const observer = new MutationObserver(setState);
      observer.observe(floating, {
        childList: true,
        subtree: true
      });
      return () => {
        observer.disconnect();
      };
    }
  }, [floating, getTabbableContent, ignoreInitialFocus, refs]);
  const shouldRenderGuards = guards && (isInsidePortal || modal) && !isTypeableCombobox;
  function renderDismissButton(location) {
    return visuallyHiddenDismiss && modal ? /*#__PURE__*/react.createElement(VisuallyHiddenDismiss, {
      ref: location === 'start' ? startDismissButtonRef : endDismissButtonRef,
      onClick: () => onOpenChange(false)
    }, typeof visuallyHiddenDismiss === 'string' ? visuallyHiddenDismiss : 'Dismiss') : null;
  }
  return /*#__PURE__*/react.createElement(react.Fragment, null, shouldRenderGuards && /*#__PURE__*/react.createElement(FocusGuard, {
    "data-type": "inside",
    ref: portalContext == null ? void 0 : portalContext.beforeInsideRef,
    onFocus: event => {
      if (modal) {
        const els = getTabbableElements();
        enqueueFocus(order[0] === 'reference' ? els[0] : els[els.length - 1]);
      } else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
        preventReturnFocusRef.current = false;
        if (isOutsideEvent(event, portalContext.portalNode)) {
          const nextTabbable = getNextTabbable() || domReference;
          nextTabbable == null ? void 0 : nextTabbable.focus();
        } else {
          var _portalContext$before;
          (_portalContext$before = portalContext.beforeOutsideRef.current) == null ? void 0 : _portalContext$before.focus();
        }
      }
    }
  }), isTypeableCombobox ? null : renderDismissButton('start'), /*#__PURE__*/react.cloneElement(children, tabbableContentLength === 0 || order.includes('floating') ? {
    tabIndex: 0
  } : {}), renderDismissButton('end'), shouldRenderGuards && /*#__PURE__*/react.createElement(FocusGuard, {
    "data-type": "inside",
    ref: portalContext == null ? void 0 : portalContext.afterInsideRef,
    onFocus: event => {
      if (modal) {
        enqueueFocus(getTabbableElements()[0]);
      } else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
        preventReturnFocusRef.current = true;
        if (isOutsideEvent(event, portalContext.portalNode)) {
          const prevTabbable = getPreviousTabbable() || domReference;
          prevTabbable == null ? void 0 : prevTabbable.focus();
        } else {
          var _portalContext$afterO;
          (_portalContext$afterO = portalContext.afterOutsideRef.current) == null ? void 0 : _portalContext$afterO.focus();
        }
      }
    }
  }));
}

const identifier = 'data-floating-ui-scroll-lock';

/**
 * Provides base styling for a fixed overlay element to dim content or block
 * pointer events behind a floating element.
 * It's a regular `<div>`, so it can be styled via any CSS solution you prefer.
 * @see https://floating-ui.com/docs/FloatingOverlay
 */
const FloatingOverlay = /*#__PURE__*/react.forwardRef(function FloatingOverlay(_ref, ref) {
  let {
    lockScroll = false,
    ...rest
  } = _ref;
  index(() => {
    var _window$visualViewpor, _window$visualViewpor2;
    if (!lockScroll) {
      return;
    }
    const alreadyLocked = document.body.hasAttribute(identifier);
    if (alreadyLocked) {
      return;
    }
    document.body.setAttribute(identifier, '');

    // RTL <body> scrollbar
    const scrollbarX = Math.round(document.documentElement.getBoundingClientRect().left) + document.documentElement.scrollLeft;
    const paddingProp = scrollbarX ? 'paddingLeft' : 'paddingRight';
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

    // Only iOS doesn't respect `overflow: hidden` on document.body, and this
    // technique has fewer side effects.
    if (!/iP(hone|ad|od)|iOS/.test(getPlatform())) {
      Object.assign(document.body.style, {
        overflow: 'hidden',
        [paddingProp]: scrollbarWidth + "px"
      });
      return () => {
        document.body.removeAttribute(identifier);
        Object.assign(document.body.style, {
          overflow: '',
          [paddingProp]: ''
        });
      };
    }

    // iOS 12 does not support `visualViewport`.
    const offsetLeft = ((_window$visualViewpor = window.visualViewport) == null ? void 0 : _window$visualViewpor.offsetLeft) || 0;
    const offsetTop = ((_window$visualViewpor2 = window.visualViewport) == null ? void 0 : _window$visualViewpor2.offsetTop) || 0;
    const scrollX = window.pageXOffset;
    const scrollY = window.pageYOffset;
    Object.assign(document.body.style, {
      position: 'fixed',
      overflow: 'hidden',
      top: -(scrollY - Math.floor(offsetTop)) + "px",
      left: -(scrollX - Math.floor(offsetLeft)) + "px",
      right: '0',
      [paddingProp]: scrollbarWidth + "px"
    });
    return () => {
      Object.assign(document.body.style, {
        position: '',
        overflow: '',
        top: '',
        left: '',
        right: '',
        [paddingProp]: ''
      });
      document.body.removeAttribute(identifier);
      window.scrollTo(scrollX, scrollY);
    };
  }, [lockScroll]);
  return /*#__PURE__*/react.createElement("div", _extends({
    ref: ref
  }, rest, {
    style: {
      position: 'fixed',
      overflow: 'auto',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      ...rest.style
    }
  }));
});

function isButtonTarget(event) {
  return isHTMLElement(event.target) && event.target.tagName === 'BUTTON';
}
function isSpaceIgnored(element) {
  return isTypeableElement(element);
}
/**
 * Opens or closes the floating element when clicking the reference element.
 * @see https://floating-ui.com/docs/useClick
 */
const useClick = function (_ref, _temp) {
  let {
    open,
    onOpenChange,
    dataRef,
    elements: {
      domReference
    }
  } = _ref;
  let {
    enabled = true,
    event: eventOption = 'click',
    toggle = true,
    ignoreMouse = false,
    keyboardHandlers = true
  } = _temp === void 0 ? {} : _temp;
  const pointerTypeRef = react.useRef();
  return react.useMemo(() => {
    if (!enabled) {
      return {};
    }
    return {
      reference: {
        onPointerDown(event) {
          pointerTypeRef.current = event.pointerType;
        },
        onMouseDown(event) {
          // Ignore all buttons except for the "main" button.
          // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/button
          if (event.button !== 0) {
            return;
          }
          if (isMouseLikePointerType(pointerTypeRef.current, true) && ignoreMouse) {
            return;
          }
          if (eventOption === 'click') {
            return;
          }
          if (open) {
            if (toggle && (dataRef.current.openEvent ? dataRef.current.openEvent.type === 'mousedown' : true)) {
              onOpenChange(false);
            }
          } else {
            // Prevent stealing focus from the floating element
            event.preventDefault();
            onOpenChange(true);
          }
          dataRef.current.openEvent = event.nativeEvent;
        },
        onClick(event) {
          if (dataRef.current.__syncReturnFocus) {
            return;
          }
          if (eventOption === 'mousedown' && pointerTypeRef.current) {
            pointerTypeRef.current = undefined;
            return;
          }
          if (isMouseLikePointerType(pointerTypeRef.current, true) && ignoreMouse) {
            return;
          }
          if (open) {
            if (toggle && (dataRef.current.openEvent ? dataRef.current.openEvent.type === 'click' : true)) {
              onOpenChange(false);
            }
          } else {
            onOpenChange(true);
          }
          dataRef.current.openEvent = event.nativeEvent;
        },
        onKeyDown(event) {
          pointerTypeRef.current = undefined;
          if (!keyboardHandlers) {
            return;
          }
          if (isButtonTarget(event)) {
            return;
          }
          if (event.key === ' ' && !isSpaceIgnored(domReference)) {
            // Prevent scrolling
            event.preventDefault();
          }
          if (event.key === 'Enter') {
            if (open) {
              if (toggle) {
                onOpenChange(false);
              }
            } else {
              onOpenChange(true);
            }
          }
        },
        onKeyUp(event) {
          if (!keyboardHandlers) {
            return;
          }
          if (isButtonTarget(event) || isSpaceIgnored(domReference)) {
            return;
          }
          if (event.key === ' ') {
            if (open) {
              if (toggle) {
                onOpenChange(false);
              }
            } else {
              onOpenChange(true);
            }
          }
        }
      }
    };
  }, [enabled, dataRef, eventOption, ignoreMouse, keyboardHandlers, domReference, toggle, open, onOpenChange]);
};

/**
 * Check whether the event.target is within the provided node. Uses event.composedPath if available for custom element support.
 *
 * @param event The event whose target/composedPath to check
 * @param node The node to check against
 * @returns Whether the event.target/composedPath is within the node.
 */
function isEventTargetWithin(event, node) {
  if (node == null) {
    return false;
  }
  if ('composedPath' in event) {
    return event.composedPath().includes(node);
  }

  // TS thinks `event` is of type never as it assumes all browsers support composedPath, but browsers without shadow dom don't
  const e = event;
  return e.target != null && node.contains(e.target);
}

const bubbleHandlerKeys = {
  pointerdown: 'onPointerDown',
  mousedown: 'onMouseDown',
  click: 'onClick'
};
const captureHandlerKeys = {
  pointerdown: 'onPointerDownCapture',
  mousedown: 'onMouseDownCapture',
  click: 'onClickCapture'
};
const normalizeBubblesProp = function (bubbles) {
  var _bubbles$escapeKey, _bubbles$outsidePress;
  if (bubbles === void 0) {
    bubbles = true;
  }
  return {
    escapeKeyBubbles: typeof bubbles === 'boolean' ? bubbles : (_bubbles$escapeKey = bubbles.escapeKey) != null ? _bubbles$escapeKey : true,
    outsidePressBubbles: typeof bubbles === 'boolean' ? bubbles : (_bubbles$outsidePress = bubbles.outsidePress) != null ? _bubbles$outsidePress : true
  };
};
/**
 * Closes the floating element when a dismissal is requested — by default, when
 * the user presses the `escape` key or outside of the floating element.
 * @see https://floating-ui.com/docs/useDismiss
 */
const useDismiss = function (_ref, _temp) {
  let {
    open,
    onOpenChange,
    events,
    nodeId,
    elements: {
      reference,
      domReference,
      floating
    },
    dataRef
  } = _ref;
  let {
    enabled = true,
    escapeKey = true,
    outsidePress: unstable_outsidePress = true,
    outsidePressEvent = 'pointerdown',
    referencePress = false,
    referencePressEvent = 'pointerdown',
    ancestorScroll = false,
    bubbles = true
  } = _temp === void 0 ? {} : _temp;
  const tree = useFloatingTree();
  const nested = useFloatingParentNodeId() != null;
  const outsidePressFn = useEvent(typeof unstable_outsidePress === 'function' ? unstable_outsidePress : () => false);
  const outsidePress = typeof unstable_outsidePress === 'function' ? outsidePressFn : unstable_outsidePress;
  const insideReactTreeRef = react.useRef(false);
  const {
    escapeKeyBubbles,
    outsidePressBubbles
  } = normalizeBubblesProp(bubbles);
  react.useEffect(() => {
    if (!open || !enabled) {
      return;
    }
    dataRef.current.__escapeKeyBubbles = escapeKeyBubbles;
    dataRef.current.__outsidePressBubbles = outsidePressBubbles;
    function onKeyDown(event) {
      if (event.key === 'Escape') {
        const children = tree ? getChildren(tree.nodesRef.current, nodeId) : [];
        if (children.length > 0) {
          let shouldDismiss = true;
          children.forEach(child => {
            var _child$context;
            if ((_child$context = child.context) != null && _child$context.open && !child.context.dataRef.current.__escapeKeyBubbles) {
              shouldDismiss = false;
              return;
            }
          });
          if (!shouldDismiss) {
            return;
          }
        }
        events.emit('dismiss', {
          type: 'escapeKey',
          data: {
            returnFocus: {
              preventScroll: false
            }
          }
        });
        onOpenChange(false);
      }
    }
    function onOutsidePress(event) {
      // Given developers can stop the propagation of the synthetic event,
      // we can only be confident with a positive value.
      const insideReactTree = insideReactTreeRef.current;
      insideReactTreeRef.current = false;
      if (insideReactTree) {
        return;
      }
      if (typeof outsidePress === 'function' && !outsidePress(event)) {
        return;
      }
      const target = getTarget(event);

      // Check if the click occurred on the scrollbar
      if (isHTMLElement(target) && floating) {
        const win = floating.ownerDocument.defaultView || window;
        const canScrollX = target.scrollWidth > target.clientWidth;
        const canScrollY = target.scrollHeight > target.clientHeight;
        let xCond = canScrollY && event.offsetX > target.clientWidth;

        // In some browsers it is possible to change the <body> (or window)
        // scrollbar to the left side, but is very rare and is difficult to
        // check for. Plus, for modal dialogs with backdrops, it is more
        // important that the backdrop is checked but not so much the window.
        if (canScrollY) {
          const isRTL = win.getComputedStyle(target).direction === 'rtl';
          if (isRTL) {
            xCond = event.offsetX <= target.offsetWidth - target.clientWidth;
          }
        }
        if (xCond || canScrollX && event.offsetY > target.clientHeight) {
          return;
        }
      }
      const targetIsInsideChildren = tree && getChildren(tree.nodesRef.current, nodeId).some(node => {
        var _node$context;
        return isEventTargetWithin(event, (_node$context = node.context) == null ? void 0 : _node$context.elements.floating);
      });
      if (isEventTargetWithin(event, floating) || isEventTargetWithin(event, domReference) || targetIsInsideChildren) {
        return;
      }
      const children = tree ? getChildren(tree.nodesRef.current, nodeId) : [];
      if (children.length > 0) {
        let shouldDismiss = true;
        children.forEach(child => {
          var _child$context2;
          if ((_child$context2 = child.context) != null && _child$context2.open && !child.context.dataRef.current.__outsidePressBubbles) {
            shouldDismiss = false;
            return;
          }
        });
        if (!shouldDismiss) {
          return;
        }
      }
      events.emit('dismiss', {
        type: 'outsidePress',
        data: {
          returnFocus: nested ? {
            preventScroll: true
          } : isVirtualClick(event) || isVirtualPointerEvent(event)
        }
      });
      onOpenChange(false);
    }
    function onScroll() {
      onOpenChange(false);
    }
    const doc = getDocument(floating);
    escapeKey && doc.addEventListener('keydown', onKeyDown);
    outsidePress && doc.addEventListener(outsidePressEvent, onOutsidePress);
    let ancestors = [];
    if (ancestorScroll) {
      if (isElement(domReference)) {
        ancestors = (0,floating_ui_dom_browser_min/* getOverflowAncestors */.Kx)(domReference);
      }
      if (isElement(floating)) {
        ancestors = ancestors.concat((0,floating_ui_dom_browser_min/* getOverflowAncestors */.Kx)(floating));
      }
      if (!isElement(reference) && reference && reference.contextElement) {
        ancestors = ancestors.concat((0,floating_ui_dom_browser_min/* getOverflowAncestors */.Kx)(reference.contextElement));
      }
    }

    // Ignore the visual viewport for scrolling dismissal (allow pinch-zoom)
    ancestors = ancestors.filter(ancestor => {
      var _doc$defaultView;
      return ancestor !== ((_doc$defaultView = doc.defaultView) == null ? void 0 : _doc$defaultView.visualViewport);
    });
    ancestors.forEach(ancestor => {
      ancestor.addEventListener('scroll', onScroll, {
        passive: true
      });
    });
    return () => {
      escapeKey && doc.removeEventListener('keydown', onKeyDown);
      outsidePress && doc.removeEventListener(outsidePressEvent, onOutsidePress);
      ancestors.forEach(ancestor => {
        ancestor.removeEventListener('scroll', onScroll);
      });
    };
  }, [dataRef, floating, domReference, reference, escapeKey, outsidePress, outsidePressEvent, events, tree, nodeId, open, onOpenChange, ancestorScroll, enabled, escapeKeyBubbles, outsidePressBubbles, nested]);
  react.useEffect(() => {
    insideReactTreeRef.current = false;
  }, [outsidePress, outsidePressEvent]);
  return react.useMemo(() => {
    if (!enabled) {
      return {};
    }
    return {
      reference: {
        [bubbleHandlerKeys[referencePressEvent]]: () => {
          if (referencePress) {
            events.emit('dismiss', {
              type: 'referencePress',
              data: {
                returnFocus: false
              }
            });
            onOpenChange(false);
          }
        }
      },
      floating: {
        [captureHandlerKeys[outsidePressEvent]]: () => {
          insideReactTreeRef.current = true;
        }
      }
    };
  }, [enabled, events, referencePress, outsidePressEvent, referencePressEvent, onOpenChange]);
};

/**
 * Opens the floating element while the reference element has focus, like CSS
 * `:focus`.
 * @see https://floating-ui.com/docs/useFocus
 */
const useFocus = function (_ref, _temp) {
  let {
    open,
    onOpenChange,
    dataRef,
    events,
    refs,
    elements: {
      floating,
      domReference
    }
  } = _ref;
  let {
    enabled = true,
    keyboardOnly = true
  } = _temp === void 0 ? {} : _temp;
  const pointerTypeRef = react.useRef('');
  const blockFocusRef = react.useRef(false);
  const timeoutRef = react.useRef();
  react.useEffect(() => {
    if (!enabled) {
      return;
    }
    const doc = getDocument(floating);
    const win = doc.defaultView || window;

    // If the reference was focused and the user left the tab/window, and the
    // floating element was not open, the focus should be blocked when they
    // return to the tab/window.
    function onBlur() {
      if (!open && isHTMLElement(domReference) && domReference === activeElement$1(getDocument(domReference))) {
        blockFocusRef.current = true;
      }
    }
    win.addEventListener('blur', onBlur);
    return () => {
      win.removeEventListener('blur', onBlur);
    };
  }, [floating, domReference, open, enabled]);
  react.useEffect(() => {
    if (!enabled) {
      return;
    }
    function onDismiss(payload) {
      if (payload.type === 'referencePress' || payload.type === 'escapeKey') {
        blockFocusRef.current = true;
      }
    }
    events.on('dismiss', onDismiss);
    return () => {
      events.off('dismiss', onDismiss);
    };
  }, [events, enabled]);
  react.useEffect(() => {
    return () => {
      clearTimeout(timeoutRef.current);
    };
  }, []);
  return react.useMemo(() => {
    if (!enabled) {
      return {};
    }
    return {
      reference: {
        onPointerDown(_ref2) {
          let {
            pointerType
          } = _ref2;
          pointerTypeRef.current = pointerType;
          blockFocusRef.current = !!(pointerType && keyboardOnly);
        },
        onMouseLeave() {
          blockFocusRef.current = false;
        },
        onFocus(event) {
          var _dataRef$current$open;
          if (blockFocusRef.current) {
            return;
          }

          // Dismiss with click should ignore the subsequent `focus` trigger,
          // but only if the click originated inside the reference element.
          if (event.type === 'focus' && ((_dataRef$current$open = dataRef.current.openEvent) == null ? void 0 : _dataRef$current$open.type) === 'mousedown' && dataRef.current.openEvent && isEventTargetWithin(dataRef.current.openEvent, domReference)) {
            return;
          }
          dataRef.current.openEvent = event.nativeEvent;
          onOpenChange(true);
        },
        onBlur(event) {
          blockFocusRef.current = false;
          const relatedTarget = event.relatedTarget;

          // Hit the non-modal focus management portal guard. Focus will be
          // moved into the floating element immediately after.
          const movedToFocusGuard = isElement(relatedTarget) && relatedTarget.hasAttribute('data-floating-ui-focus-guard') && relatedTarget.getAttribute('data-type') === 'outside';

          // Wait for the window blur listener to fire.
          timeoutRef.current = setTimeout(() => {
            // When focusing the reference element (e.g. regular click), then
            // clicking into the floating element, prevent it from hiding.
            // Note: it must be focusable, e.g. `tabindex="-1"`.
            if (contains(refs.floating.current, relatedTarget) || contains(domReference, relatedTarget) || movedToFocusGuard) {
              return;
            }
            onOpenChange(false);
          });
        }
      }
    };
  }, [enabled, keyboardOnly, domReference, refs, dataRef, onOpenChange]);
};

let isPreventScrollSupported = false;
const ARROW_UP = 'ArrowUp';
const ARROW_DOWN = 'ArrowDown';
const ARROW_LEFT = 'ArrowLeft';
const ARROW_RIGHT = 'ArrowRight';
function isDifferentRow(index, cols, prevRow) {
  return Math.floor(index / cols) !== prevRow;
}
function isIndexOutOfBounds(listRef, index) {
  return index < 0 || index >= listRef.current.length;
}
function findNonDisabledIndex(listRef, _temp) {
  let {
    startingIndex = -1,
    decrement = false,
    disabledIndices,
    amount = 1
  } = _temp === void 0 ? {} : _temp;
  const list = listRef.current;
  let index = startingIndex;
  do {
    var _list$index, _list$index2;
    index = index + (decrement ? -amount : amount);
  } while (index >= 0 && index <= list.length - 1 && (disabledIndices ? disabledIndices.includes(index) : list[index] == null || ((_list$index = list[index]) == null ? void 0 : _list$index.hasAttribute('disabled')) || ((_list$index2 = list[index]) == null ? void 0 : _list$index2.getAttribute('aria-disabled')) === 'true'));
  return index;
}
function doSwitch(orientation, vertical, horizontal) {
  switch (orientation) {
    case 'vertical':
      return vertical;
    case 'horizontal':
      return horizontal;
    default:
      return vertical || horizontal;
  }
}
function isMainOrientationKey(key, orientation) {
  const vertical = key === ARROW_UP || key === ARROW_DOWN;
  const horizontal = key === ARROW_LEFT || key === ARROW_RIGHT;
  return doSwitch(orientation, vertical, horizontal);
}
function isMainOrientationToEndKey(key, orientation, rtl) {
  const vertical = key === ARROW_DOWN;
  const horizontal = rtl ? key === ARROW_LEFT : key === ARROW_RIGHT;
  return doSwitch(orientation, vertical, horizontal) || key === 'Enter' || key == ' ' || key === '';
}
function isCrossOrientationOpenKey(key, orientation, rtl) {
  const vertical = rtl ? key === ARROW_LEFT : key === ARROW_RIGHT;
  const horizontal = key === ARROW_DOWN;
  return doSwitch(orientation, vertical, horizontal);
}
function isCrossOrientationCloseKey(key, orientation, rtl) {
  const vertical = rtl ? key === ARROW_RIGHT : key === ARROW_LEFT;
  const horizontal = key === ARROW_UP;
  return doSwitch(orientation, vertical, horizontal);
}
function getMinIndex(listRef, disabledIndices) {
  return findNonDisabledIndex(listRef, {
    disabledIndices
  });
}
function getMaxIndex(listRef, disabledIndices) {
  return findNonDisabledIndex(listRef, {
    decrement: true,
    startingIndex: listRef.current.length,
    disabledIndices
  });
}
/**
 * Adds arrow key-based navigation of a list of items, either using real DOM
 * focus or virtual focus.
 * @see https://floating-ui.com/docs/useListNavigation
 */
const useListNavigation = function (_ref, _temp2) {
  let {
    open,
    onOpenChange,
    refs,
    elements: {
      domReference
    }
  } = _ref;
  let {
    listRef,
    activeIndex,
    onNavigate: unstable_onNavigate = () => {},
    enabled = true,
    selectedIndex = null,
    allowEscape = false,
    loop = false,
    nested = false,
    rtl = false,
    virtual = false,
    focusItemOnOpen = 'auto',
    focusItemOnHover = true,
    openOnArrowKeyDown = true,
    disabledIndices = undefined,
    orientation = 'vertical',
    cols = 1,
    scrollItemIntoView = true
  } = _temp2 === void 0 ? {
    listRef: {
      current: []
    },
    activeIndex: null,
    onNavigate: () => {}
  } : _temp2;
  if (false) {}
  const parentId = useFloatingParentNodeId();
  const tree = useFloatingTree();
  const onNavigate = useEvent(unstable_onNavigate);
  const focusItemOnOpenRef = react.useRef(focusItemOnOpen);
  const indexRef = react.useRef(selectedIndex != null ? selectedIndex : -1);
  const keyRef = react.useRef(null);
  const isPointerModalityRef = react.useRef(true);
  const previousOnNavigateRef = react.useRef(onNavigate);
  const previousOpenRef = react.useRef(open);
  const forceSyncFocus = react.useRef(false);
  const forceScrollIntoViewRef = react.useRef(false);
  const disabledIndicesRef = useLatestRef(disabledIndices);
  const latestOpenRef = useLatestRef(open);
  const scrollItemIntoViewRef = useLatestRef(scrollItemIntoView);
  const [activeId, setActiveId] = react.useState();
  const focusItem = react.useCallback(function (listRef, indexRef, forceScrollIntoView) {
    if (forceScrollIntoView === void 0) {
      forceScrollIntoView = false;
    }
    const item = listRef.current[indexRef.current];
    if (virtual) {
      setActiveId(item == null ? void 0 : item.id);
    } else {
      enqueueFocus(item, {
        preventScroll: true,
        // Mac Safari does not move the virtual cursor unless the focus call
        // is sync. However, for the very first focus call, we need to wait
        // for the position to be ready in order to prevent unwanted
        // scrolling. This means the virtual cursor will not move to the first
        // item when first opening the floating element, but will on
        // subsequent calls. `preventScroll` is supported in modern Safari,
        // so we can use that instead.
        // iOS Safari must be async or the first item will not be focused.
        sync: isMac() && isSafari() ? isPreventScrollSupported || forceSyncFocus.current : false
      });
    }
    requestAnimationFrame(() => {
      const scrollIntoViewOptions = scrollItemIntoViewRef.current;
      const shouldScrollIntoView = scrollIntoViewOptions && item && (forceScrollIntoView || !isPointerModalityRef.current);
      if (shouldScrollIntoView) {
        // JSDOM doesn't support `.scrollIntoView()` but it's widely supported
        // by all browsers.
        item.scrollIntoView == null ? void 0 : item.scrollIntoView(typeof scrollIntoViewOptions === 'boolean' ? {
          block: 'nearest',
          inline: 'nearest'
        } : scrollIntoViewOptions);
      }
    });
  }, [virtual, scrollItemIntoViewRef]);
  index(() => {
    document.createElement('div').focus({
      get preventScroll() {
        isPreventScrollSupported = true;
        return false;
      }
    });
  }, []);

  // Sync `selectedIndex` to be the `activeIndex` upon opening the floating
  // element. Also, reset `activeIndex` upon closing the floating element.
  index(() => {
    if (!enabled) {
      return;
    }
    if (open) {
      if (focusItemOnOpenRef.current && selectedIndex != null) {
        // Regardless of the pointer modality, we want to ensure the selected
        // item comes into view when the floating element is opened.
        forceScrollIntoViewRef.current = true;
        onNavigate(selectedIndex);
      }
    } else if (previousOpenRef.current) {
      // Since the user can specify `onNavigate` conditionally
      // (onNavigate: open ? setActiveIndex : setSelectedIndex),
      // we store and call the previous function.
      indexRef.current = -1;
      previousOnNavigateRef.current(null);
    }
  }, [enabled, open, selectedIndex, onNavigate]);

  // Sync `activeIndex` to be the focused item while the floating element is
  // open.
  index(() => {
    if (!enabled) {
      return;
    }
    if (open) {
      if (activeIndex == null) {
        forceSyncFocus.current = false;
        if (selectedIndex != null) {
          return;
        }

        // Reset while the floating element was open (e.g. the list changed).
        if (previousOpenRef.current) {
          indexRef.current = -1;
          focusItem(listRef, indexRef);
        }

        // Initial sync.
        if (!previousOpenRef.current && focusItemOnOpenRef.current && (keyRef.current != null || focusItemOnOpenRef.current === true && keyRef.current == null)) {
          indexRef.current = keyRef.current == null || isMainOrientationToEndKey(keyRef.current, orientation, rtl) || nested ? getMinIndex(listRef, disabledIndicesRef.current) : getMaxIndex(listRef, disabledIndicesRef.current);
          onNavigate(indexRef.current);
        }
      } else if (!isIndexOutOfBounds(listRef, activeIndex)) {
        indexRef.current = activeIndex;
        focusItem(listRef, indexRef, forceScrollIntoViewRef.current);
        forceScrollIntoViewRef.current = false;
      }
    }
  }, [enabled, open, activeIndex, selectedIndex, nested, listRef, orientation, rtl, onNavigate, focusItem, disabledIndicesRef]);

  // Ensure the parent floating element has focus when a nested child closes
  // to allow arrow key navigation to work after the pointer leaves the child.
  index(() => {
    if (!enabled) {
      return;
    }
    if (previousOpenRef.current && !open) {
      var _tree$nodesRef$curren, _tree$nodesRef$curren2;
      const parentFloating = tree == null ? void 0 : (_tree$nodesRef$curren = tree.nodesRef.current.find(node => node.id === parentId)) == null ? void 0 : (_tree$nodesRef$curren2 = _tree$nodesRef$curren.context) == null ? void 0 : _tree$nodesRef$curren2.elements.floating;
      if (parentFloating && !contains(parentFloating, activeElement$1(getDocument(parentFloating)))) {
        parentFloating.focus({
          preventScroll: true
        });
      }
    }
  }, [enabled, open, tree, parentId]);
  index(() => {
    keyRef.current = null;
    previousOnNavigateRef.current = onNavigate;
    previousOpenRef.current = open;
  });
  const hasActiveIndex = activeIndex != null;
  const item = react.useMemo(() => {
    function syncCurrentTarget(currentTarget) {
      if (!open) return;
      const index = listRef.current.indexOf(currentTarget);
      if (index !== -1) {
        onNavigate(index);
      }
    }
    const props = {
      onFocus(_ref2) {
        let {
          currentTarget
        } = _ref2;
        syncCurrentTarget(currentTarget);
      },
      onClick: _ref3 => {
        let {
          currentTarget
        } = _ref3;
        return currentTarget.focus({
          preventScroll: true
        });
      },
      // Safari
      ...(focusItemOnHover && {
        onMouseMove(_ref4) {
          let {
            currentTarget
          } = _ref4;
          syncCurrentTarget(currentTarget);
        },
        onPointerLeave() {
          if (!isPointerModalityRef.current) {
            return;
          }
          indexRef.current = -1;
          focusItem(listRef, indexRef);

          // Virtual cursor with VoiceOver on iOS needs this to be flushed
          // synchronously or there is a glitch that prevents nested
          // submenus from being accessible.
          (0,react_dom.flushSync)(() => onNavigate(null));
          if (!virtual) {
            var _refs$floating$curren;
            // This also needs to be sync to prevent fast mouse movements
            // from leaving behind a stale active item when landing on a
            // disabled button item.
            (_refs$floating$curren = refs.floating.current) == null ? void 0 : _refs$floating$curren.focus({
              preventScroll: true
            });
          }
        }
      })
    };
    return props;
  }, [open, refs, focusItem, focusItemOnHover, listRef, onNavigate, virtual]);
  return react.useMemo(() => {
    if (!enabled) {
      return {};
    }
    const disabledIndices = disabledIndicesRef.current;
    function onKeyDown(event) {
      isPointerModalityRef.current = false;
      forceSyncFocus.current = true;

      // If the floating element is animating out, ignore navigation. Otherwise,
      // the `activeIndex` gets set to 0 despite not being open so the next time
      // the user ArrowDowns, the first item won't be focused.
      if (!latestOpenRef.current && event.currentTarget === refs.floating.current) {
        return;
      }
      if (nested && isCrossOrientationCloseKey(event.key, orientation, rtl)) {
        stopEvent(event);
        onOpenChange(false);
        if (isHTMLElement(domReference)) {
          domReference.focus();
        }
        return;
      }
      const currentIndex = indexRef.current;
      const minIndex = getMinIndex(listRef, disabledIndices);
      const maxIndex = getMaxIndex(listRef, disabledIndices);
      if (event.key === 'Home') {
        indexRef.current = minIndex;
        onNavigate(indexRef.current);
      }
      if (event.key === 'End') {
        indexRef.current = maxIndex;
        onNavigate(indexRef.current);
      }

      // Grid navigation.
      if (cols > 1) {
        const prevIndex = indexRef.current;
        if (event.key === ARROW_UP) {
          stopEvent(event);
          if (prevIndex === -1) {
            indexRef.current = maxIndex;
          } else {
            indexRef.current = findNonDisabledIndex(listRef, {
              startingIndex: prevIndex,
              amount: cols,
              decrement: true,
              disabledIndices
            });
            if (loop && (prevIndex - cols < minIndex || indexRef.current < 0)) {
              const col = prevIndex % cols;
              const maxCol = maxIndex % cols;
              const offset = maxIndex - (maxCol - col);
              if (maxCol === col) {
                indexRef.current = maxIndex;
              } else {
                indexRef.current = maxCol > col ? offset : offset - cols;
              }
            }
          }
          if (isIndexOutOfBounds(listRef, indexRef.current)) {
            indexRef.current = prevIndex;
          }
          onNavigate(indexRef.current);
        }
        if (event.key === ARROW_DOWN) {
          stopEvent(event);
          if (prevIndex === -1) {
            indexRef.current = minIndex;
          } else {
            indexRef.current = findNonDisabledIndex(listRef, {
              startingIndex: prevIndex,
              amount: cols,
              disabledIndices
            });
            if (loop && prevIndex + cols > maxIndex) {
              indexRef.current = findNonDisabledIndex(listRef, {
                startingIndex: prevIndex % cols - cols,
                amount: cols,
                disabledIndices
              });
            }
          }
          if (isIndexOutOfBounds(listRef, indexRef.current)) {
            indexRef.current = prevIndex;
          }
          onNavigate(indexRef.current);
        }

        // Remains on the same row/column.
        if (orientation === 'both') {
          const prevRow = Math.floor(prevIndex / cols);
          if (event.key === ARROW_RIGHT) {
            stopEvent(event);
            if (prevIndex % cols !== cols - 1) {
              indexRef.current = findNonDisabledIndex(listRef, {
                startingIndex: prevIndex,
                disabledIndices
              });
              if (loop && isDifferentRow(indexRef.current, cols, prevRow)) {
                indexRef.current = findNonDisabledIndex(listRef, {
                  startingIndex: prevIndex - prevIndex % cols - 1,
                  disabledIndices
                });
              }
            } else if (loop) {
              indexRef.current = findNonDisabledIndex(listRef, {
                startingIndex: prevIndex - prevIndex % cols - 1,
                disabledIndices
              });
            }
            if (isDifferentRow(indexRef.current, cols, prevRow)) {
              indexRef.current = prevIndex;
            }
          }
          if (event.key === ARROW_LEFT) {
            stopEvent(event);
            if (prevIndex % cols !== 0) {
              indexRef.current = findNonDisabledIndex(listRef, {
                startingIndex: prevIndex,
                disabledIndices,
                decrement: true
              });
              if (loop && isDifferentRow(indexRef.current, cols, prevRow)) {
                indexRef.current = findNonDisabledIndex(listRef, {
                  startingIndex: prevIndex + (cols - prevIndex % cols),
                  decrement: true,
                  disabledIndices
                });
              }
            } else if (loop) {
              indexRef.current = findNonDisabledIndex(listRef, {
                startingIndex: prevIndex + (cols - prevIndex % cols),
                decrement: true,
                disabledIndices
              });
            }
            if (isDifferentRow(indexRef.current, cols, prevRow)) {
              indexRef.current = prevIndex;
            }
          }
          const lastRow = Math.floor(maxIndex / cols) === prevRow;
          if (isIndexOutOfBounds(listRef, indexRef.current)) {
            if (loop && lastRow) {
              indexRef.current = event.key === ARROW_LEFT ? maxIndex : findNonDisabledIndex(listRef, {
                startingIndex: prevIndex - prevIndex % cols - 1,
                disabledIndices
              });
            } else {
              indexRef.current = prevIndex;
            }
          }
          onNavigate(indexRef.current);
          return;
        }
      }
      if (isMainOrientationKey(event.key, orientation)) {
        stopEvent(event);

        // Reset the index if no item is focused.
        if (open && !virtual && activeElement$1(event.currentTarget.ownerDocument) === event.currentTarget) {
          indexRef.current = isMainOrientationToEndKey(event.key, orientation, rtl) ? minIndex : maxIndex;
          onNavigate(indexRef.current);
          return;
        }
        if (isMainOrientationToEndKey(event.key, orientation, rtl)) {
          if (loop) {
            indexRef.current = currentIndex >= maxIndex ? allowEscape && currentIndex !== listRef.current.length ? -1 : minIndex : findNonDisabledIndex(listRef, {
              startingIndex: currentIndex,
              disabledIndices
            });
          } else {
            indexRef.current = Math.min(maxIndex, findNonDisabledIndex(listRef, {
              startingIndex: currentIndex,
              disabledIndices
            }));
          }
        } else {
          if (loop) {
            indexRef.current = currentIndex <= minIndex ? allowEscape && currentIndex !== -1 ? listRef.current.length : maxIndex : findNonDisabledIndex(listRef, {
              startingIndex: currentIndex,
              decrement: true,
              disabledIndices
            });
          } else {
            indexRef.current = Math.max(minIndex, findNonDisabledIndex(listRef, {
              startingIndex: currentIndex,
              decrement: true,
              disabledIndices
            }));
          }
        }
        if (isIndexOutOfBounds(listRef, indexRef.current)) {
          onNavigate(null);
        } else {
          onNavigate(indexRef.current);
        }
      }
    }
    function checkVirtualMouse(event) {
      if (focusItemOnOpen === 'auto' && isVirtualClick(event.nativeEvent)) {
        focusItemOnOpenRef.current = true;
      }
    }
    function checkVirtualPointer(event) {
      // `pointerdown` fires first, reset the state then perform the checks.
      focusItemOnOpenRef.current = focusItemOnOpen;
      if (focusItemOnOpen === 'auto' && isVirtualPointerEvent(event.nativeEvent)) {
        focusItemOnOpenRef.current = true;
      }
    }
    const ariaActiveDescendantProp = virtual && open && hasActiveIndex && {
      'aria-activedescendant': activeId
    };
    return {
      reference: {
        ...ariaActiveDescendantProp,
        onKeyDown(event) {
          isPointerModalityRef.current = false;
          const isArrowKey = event.key.indexOf('Arrow') === 0;
          if (virtual && open) {
            return onKeyDown(event);
          }

          // If a floating element should not open on arrow key down, avoid
          // setting `activeIndex` while it's closed.
          if (!open && !openOnArrowKeyDown && isArrowKey) {
            return;
          }
          const isNavigationKey = isArrowKey || event.key === 'Enter' || event.key === ' ' || event.key === '';
          if (isNavigationKey) {
            keyRef.current = event.key;
          }
          if (nested) {
            if (isCrossOrientationOpenKey(event.key, orientation, rtl)) {
              stopEvent(event);
              if (open) {
                indexRef.current = getMinIndex(listRef, disabledIndices);
                onNavigate(indexRef.current);
              } else {
                onOpenChange(true);
              }
            }
            return;
          }
          if (isMainOrientationKey(event.key, orientation)) {
            if (selectedIndex != null) {
              indexRef.current = selectedIndex;
            }
            stopEvent(event);
            if (!open && openOnArrowKeyDown) {
              onOpenChange(true);
            } else {
              onKeyDown(event);
            }
            if (open) {
              onNavigate(indexRef.current);
            }
          }
        },
        onFocus() {
          if (open) {
            onNavigate(null);
          }
        },
        onPointerDown: checkVirtualPointer,
        onMouseDown: checkVirtualMouse,
        onClick: checkVirtualMouse
      },
      floating: {
        'aria-orientation': orientation === 'both' ? undefined : orientation,
        ...ariaActiveDescendantProp,
        onKeyDown,
        onPointerMove() {
          isPointerModalityRef.current = true;
        }
      },
      item
    };
  }, [domReference, refs, activeId, disabledIndicesRef, latestOpenRef, listRef, enabled, orientation, rtl, virtual, open, hasActiveIndex, nested, selectedIndex, openOnArrowKeyDown, allowEscape, cols, loop, focusItemOnOpen, onNavigate, onOpenChange, item]);
};

/**
 * Merges an array of refs into a single memoized callback ref or `null`.
 * @see https://floating-ui.com/docs/useMergeRefs
 */
function useMergeRefs(refs) {
  return react.useMemo(() => {
    if (refs.every(ref => ref == null)) {
      return null;
    }
    return value => {
      refs.forEach(ref => {
        if (typeof ref === 'function') {
          ref(value);
        } else if (ref != null) {
          ref.current = value;
        }
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, refs);
}

/**
 * Adds base screen reader props to the reference and floating elements for a
 * given floating element `role`.
 * @see https://floating-ui.com/docs/useRole
 */
const useRole = function (_ref, _temp) {
  let {
    open
  } = _ref;
  let {
    enabled = true,
    role = 'dialog'
  } = _temp === void 0 ? {} : _temp;
  const rootId = useId();
  const referenceId = useId();
  return react.useMemo(() => {
    const floatingProps = {
      id: rootId,
      role
    };
    if (!enabled) {
      return {};
    }
    if (role === 'tooltip') {
      return {
        reference: {
          'aria-describedby': open ? rootId : undefined
        },
        floating: floatingProps
      };
    }
    return {
      reference: {
        'aria-expanded': open ? 'true' : 'false',
        'aria-haspopup': role === 'alertdialog' ? 'dialog' : role,
        'aria-controls': open ? rootId : undefined,
        ...(role === 'listbox' && {
          role: 'combobox'
        }),
        ...(role === 'menu' && {
          id: referenceId
        })
      },
      floating: {
        ...floatingProps,
        ...(role === 'menu' && {
          'aria-labelledby': referenceId
        })
      }
    };
  }, [enabled, role, open, rootId, referenceId]);
};

// Converts a JS style key like `backgroundColor` to a CSS transition-property
// like `background-color`.
const camelCaseToKebabCase = str => str.replace(/[A-Z]+(?![a-z])|[A-Z]/g, ($, ofs) => (ofs ? '-' : '') + $.toLowerCase());
function useDelayUnmount(open, durationMs) {
  const [isMounted, setIsMounted] = react.useState(open);
  if (open && !isMounted) {
    setIsMounted(true);
  }
  react.useEffect(() => {
    if (!open) {
      const timeout = setTimeout(() => setIsMounted(false), durationMs);
      return () => clearTimeout(timeout);
    }
  }, [open, durationMs]);
  return isMounted;
}
/**
 * Provides a status string to apply CSS transitions to a floating element,
 * correctly handling placement-aware transitions.
 * @see https://floating-ui.com/docs/useTransition#usetransitionstatus
 */
function useTransitionStatus(_ref, _temp) {
  let {
    open,
    elements: {
      floating
    }
  } = _ref;
  let {
    duration = 250
  } = _temp === void 0 ? {} : _temp;
  const isNumberDuration = typeof duration === 'number';
  const closeDuration = (isNumberDuration ? duration : duration.close) || 0;
  const [initiated, setInitiated] = react.useState(false);
  const [status, setStatus] = react.useState('unmounted');
  const isMounted = useDelayUnmount(open, closeDuration);

  // `initiated` check prevents this `setState` call from breaking
  // <FloatingPortal />. This call is necessary to ensure subsequent opens
  // after the initial one allows the correct side animation to play when the
  // placement has changed.
  index(() => {
    if (initiated && !isMounted) {
      setStatus('unmounted');
    }
  }, [initiated, isMounted]);
  index(() => {
    if (!floating) return;
    if (open) {
      setStatus('initial');
      const frame = requestAnimationFrame(() => {
        setStatus('open');
      });
      return () => {
        cancelAnimationFrame(frame);
      };
    } else {
      setInitiated(true);
      setStatus('close');
    }
  }, [open, floating]);
  return {
    isMounted,
    status
  };
}
/**
 * Provides styles to apply CSS transitions to a floating element, correctly
 * handling placement-aware transitions. Wrapper around `useTransitionStatus`.
 * @see https://floating-ui.com/docs/useTransition#usetransitionstyles
 */
function useTransitionStyles(context, _temp2) {
  let {
    initial: unstable_initial = {
      opacity: 0
    },
    open: unstable_open,
    close: unstable_close,
    common: unstable_common,
    duration = 250
  } = _temp2 === void 0 ? {} : _temp2;
  const placement = context.placement;
  const side = placement.split('-')[0];
  const [styles, setStyles] = react.useState({});
  const {
    isMounted,
    status
  } = useTransitionStatus(context, {
    duration
  });
  const initialRef = useLatestRef(unstable_initial);
  const openRef = useLatestRef(unstable_open);
  const closeRef = useLatestRef(unstable_close);
  const commonRef = useLatestRef(unstable_common);
  const isNumberDuration = typeof duration === 'number';
  const openDuration = (isNumberDuration ? duration : duration.open) || 0;
  const closeDuration = (isNumberDuration ? duration : duration.close) || 0;
  index(() => {
    const fnArgs = {
      side,
      placement
    };
    const initial = initialRef.current;
    const close = closeRef.current;
    const open = openRef.current;
    const common = commonRef.current;
    const initialStyles = typeof initial === 'function' ? initial(fnArgs) : initial;
    const closeStyles = typeof close === 'function' ? close(fnArgs) : close;
    const commonStyles = typeof common === 'function' ? common(fnArgs) : common;
    const openStyles = (typeof open === 'function' ? open(fnArgs) : open) || Object.keys(initialStyles).reduce((acc, key) => {
      acc[key] = '';
      return acc;
    }, {});
    if (status === 'initial' || status === 'unmounted') {
      setStyles(styles => ({
        transitionProperty: styles.transitionProperty,
        ...commonStyles,
        ...initialStyles
      }));
    }
    if (status === 'open') {
      setStyles({
        transitionProperty: Object.keys(openStyles).map(camelCaseToKebabCase).join(','),
        transitionDuration: openDuration + "ms",
        ...commonStyles,
        ...openStyles
      });
    }
    if (status === 'close') {
      const styles = closeStyles || initialStyles;
      setStyles({
        transitionProperty: Object.keys(styles).map(camelCaseToKebabCase).join(','),
        transitionDuration: closeDuration + "ms",
        ...commonStyles,
        ...styles
      });
    }
  }, [side, placement, closeDuration, closeRef, initialRef, openRef, commonRef, openDuration, status]);
  return {
    isMounted,
    styles
  };
}

/**
 * Provides a matching callback that can be used to focus an item as the user
 * types, often used in tandem with `useListNavigation()`.
 * @see https://floating-ui.com/docs/useTypeahead
 */
const useTypeahead = function (_ref, _temp) {
  var _ref2;
  let {
    open,
    dataRef,
    refs
  } = _ref;
  let {
    listRef,
    activeIndex,
    onMatch: unstable_onMatch = () => {},
    enabled = true,
    findMatch = null,
    resetMs = 1000,
    ignoreKeys = [],
    selectedIndex = null
  } = _temp === void 0 ? {
    listRef: {
      current: []
    },
    activeIndex: null
  } : _temp;
  const timeoutIdRef = react.useRef();
  const stringRef = react.useRef('');
  const prevIndexRef = react.useRef((_ref2 = selectedIndex != null ? selectedIndex : activeIndex) != null ? _ref2 : -1);
  const matchIndexRef = react.useRef(null);
  const onMatch = useEvent(unstable_onMatch);
  const findMatchRef = useLatestRef(findMatch);
  const ignoreKeysRef = useLatestRef(ignoreKeys);
  index(() => {
    if (open) {
      clearTimeout(timeoutIdRef.current);
      matchIndexRef.current = null;
      stringRef.current = '';
    }
  }, [open]);
  index(() => {
    // Sync arrow key navigation but not typeahead navigation.
    if (open && stringRef.current === '') {
      var _ref3;
      prevIndexRef.current = (_ref3 = selectedIndex != null ? selectedIndex : activeIndex) != null ? _ref3 : -1;
    }
  }, [open, selectedIndex, activeIndex]);
  return react.useMemo(() => {
    if (!enabled) {
      return {};
    }
    function onKeyDown(event) {
      var _refs$floating$curren;
      // Correctly scope nested non-portalled floating elements. Since the nested
      // floating element is inside of the another, we find the closest role
      // that indicates the floating element scope.
      const target = getTarget(event.nativeEvent);
      if (isElement(target) && (activeElement$1(getDocument(target)) !== event.currentTarget ? (_refs$floating$curren = refs.floating.current) != null && _refs$floating$curren.contains(target) ? target.closest('[role="dialog"],[role="menu"],[role="listbox"],[role="tree"],[role="grid"]') !== event.currentTarget : false : !event.currentTarget.contains(target))) {
        return;
      }
      if (stringRef.current.length > 0 && stringRef.current[0] !== ' ') {
        dataRef.current.typing = true;
        if (event.key === ' ') {
          stopEvent(event);
        }
      }
      const listContent = listRef.current;
      if (listContent == null || ignoreKeysRef.current.includes(event.key) ||
      // Character key.
      event.key.length !== 1 ||
      // Modifier key.
      event.ctrlKey || event.metaKey || event.altKey) {
        return;
      }

      // Bail out if the list contains a word like "llama" or "aaron". TODO:
      // allow it in this case, too.
      const allowRapidSuccessionOfFirstLetter = listContent.every(text => {
        var _text$, _text$2;
        return text ? ((_text$ = text[0]) == null ? void 0 : _text$.toLocaleLowerCase()) !== ((_text$2 = text[1]) == null ? void 0 : _text$2.toLocaleLowerCase()) : true;
      });

      // Allows the user to cycle through items that start with the same letter
      // in rapid succession.
      if (allowRapidSuccessionOfFirstLetter && stringRef.current === event.key) {
        stringRef.current = '';
        prevIndexRef.current = matchIndexRef.current;
      }
      stringRef.current += event.key;
      clearTimeout(timeoutIdRef.current);
      timeoutIdRef.current = setTimeout(() => {
        stringRef.current = '';
        prevIndexRef.current = matchIndexRef.current;
        dataRef.current.typing = false;
      }, resetMs);
      const prevIndex = prevIndexRef.current;
      const orderedList = [...listContent.slice((prevIndex || 0) + 1), ...listContent.slice(0, (prevIndex || 0) + 1)];
      const str = findMatchRef.current ? findMatchRef.current(orderedList, stringRef.current) : orderedList.find(text => (text == null ? void 0 : text.toLocaleLowerCase().indexOf(stringRef.current.toLocaleLowerCase())) === 0);
      const index = str ? listContent.indexOf(str) : -1;
      if (index !== -1) {
        onMatch(index);
        matchIndexRef.current = index;
      }
    }
    return {
      reference: {
        onKeyDown
      },
      floating: {
        onKeyDown
      }
    };
  }, [enabled, dataRef, listRef, resetMs, ignoreKeysRef, findMatchRef, onMatch, refs]);
};

function getArgsWithCustomFloatingHeight(state, height) {
  return {
    ...state,
    rects: {
      ...state.rects,
      floating: {
        ...state.rects.floating,
        height
      }
    }
  };
}
/**
 * Positions the floating element such that an inner element inside
 * of it is anchored to the reference element.
 * @see https://floating-ui.com/docs/inner
 */
const inner = props => ({
  name: 'inner',
  options: props,
  async fn(state) {
    const {
      listRef,
      overflowRef,
      onFallbackChange,
      offset: innerOffset = 0,
      index = 0,
      minItemsVisible = 4,
      referenceOverflowThreshold = 0,
      scrollRef,
      ...detectOverflowOptions
    } = props;
    const {
      rects,
      elements: {
        floating
      }
    } = state;
    const item = listRef.current[index];
    if (false) {}
    if (!item) {
      return {};
    }
    const nextArgs = {
      ...state,
      ...(await (0,floating_ui_core_browser_min/* offset */.cv)(-item.offsetTop - rects.reference.height / 2 - item.offsetHeight / 2 - innerOffset).fn(state))
    };
    const el = (scrollRef == null ? void 0 : scrollRef.current) || floating;
    const overflow = await (0,floating_ui_core_browser_min/* detectOverflow */.US)(getArgsWithCustomFloatingHeight(nextArgs, el.scrollHeight), detectOverflowOptions);
    const refOverflow = await (0,floating_ui_core_browser_min/* detectOverflow */.US)(nextArgs, {
      ...detectOverflowOptions,
      elementContext: 'reference'
    });
    const diffY = Math.max(0, overflow.top);
    const nextY = nextArgs.y + diffY;
    const maxHeight = Math.max(0, el.scrollHeight - diffY - Math.max(0, overflow.bottom));
    el.style.maxHeight = maxHeight + "px";
    el.scrollTop = diffY;

    // There is not enough space, fallback to standard anchored positioning
    if (onFallbackChange) {
      if (el.offsetHeight < item.offsetHeight * Math.min(minItemsVisible, listRef.current.length - 1) - 1 || refOverflow.top >= -referenceOverflowThreshold || refOverflow.bottom >= -referenceOverflowThreshold) {
        (0,react_dom.flushSync)(() => onFallbackChange(true));
      } else {
        (0,react_dom.flushSync)(() => onFallbackChange(false));
      }
    }
    if (overflowRef) {
      overflowRef.current = await (0,floating_ui_core_browser_min/* detectOverflow */.US)(getArgsWithCustomFloatingHeight({
        ...nextArgs,
        y: nextY
      }, el.offsetHeight), detectOverflowOptions);
    }
    return {
      y: nextY
    };
  }
});
/**
 * Changes the `inner` middleware's `offset` upon a `wheel` event to
 * expand the floating element's height, revealing more list items.
 * @see https://floating-ui.com/docs/inner
 */
const useInnerOffset = (_ref, _ref2) => {
  let {
    open,
    elements
  } = _ref;
  let {
    enabled = true,
    overflowRef,
    scrollRef,
    onChange: unstable_onChange
  } = _ref2;
  const onChange = useEvent(unstable_onChange);
  const controlledScrollingRef = react.useRef(false);
  const prevScrollTopRef = react.useRef(null);
  const initialOverflowRef = react.useRef(null);
  react.useEffect(() => {
    if (!enabled) {
      return;
    }
    function onWheel(e) {
      if (e.ctrlKey || !el || overflowRef.current == null) {
        return;
      }
      const dY = e.deltaY;
      const isAtTop = overflowRef.current.top >= -0.5;
      const isAtBottom = overflowRef.current.bottom >= -0.5;
      const remainingScroll = el.scrollHeight - el.clientHeight;
      const sign = dY < 0 ? -1 : 1;
      const method = dY < 0 ? 'max' : 'min';
      if (el.scrollHeight <= el.clientHeight) {
        return;
      }
      if (!isAtTop && dY > 0 || !isAtBottom && dY < 0) {
        e.preventDefault();
        (0,react_dom.flushSync)(() => {
          onChange(d => d + Math[method](dY, remainingScroll * sign));
        });
      } else if (/firefox/i.test(getUserAgent())) {
        // Needed to propagate scrolling during momentum scrolling phase once
        // it gets limited by the boundary. UX improvement, not critical.
        el.scrollTop += dY;
      }
    }
    const el = (scrollRef == null ? void 0 : scrollRef.current) || elements.floating;
    if (open && el) {
      el.addEventListener('wheel', onWheel);

      // Wait for the position to be ready.
      requestAnimationFrame(() => {
        prevScrollTopRef.current = el.scrollTop;
        if (overflowRef.current != null) {
          initialOverflowRef.current = {
            ...overflowRef.current
          };
        }
      });
      return () => {
        prevScrollTopRef.current = null;
        initialOverflowRef.current = null;
        el.removeEventListener('wheel', onWheel);
      };
    }
  }, [enabled, open, elements.floating, overflowRef, scrollRef, onChange]);
  return react.useMemo(() => {
    if (!enabled) {
      return {};
    }
    return {
      floating: {
        onKeyDown() {
          controlledScrollingRef.current = true;
        },
        onWheel() {
          controlledScrollingRef.current = false;
        },
        onPointerMove() {
          controlledScrollingRef.current = false;
        },
        onScroll() {
          const el = (scrollRef == null ? void 0 : scrollRef.current) || elements.floating;
          if (!overflowRef.current || !el || !controlledScrollingRef.current) {
            return;
          }
          if (prevScrollTopRef.current !== null) {
            const scrollDiff = el.scrollTop - prevScrollTopRef.current;
            if (overflowRef.current.bottom < -0.5 && scrollDiff < -1 || overflowRef.current.top < -0.5 && scrollDiff > 1) {
              (0,react_dom.flushSync)(() => onChange(d => d + scrollDiff));
            }
          }

          // [Firefox] Wait for the height change to have been applied.
          requestAnimationFrame(() => {
            prevScrollTopRef.current = el.scrollTop;
          });
        }
      }
    };
  }, [enabled, overflowRef, elements.floating, scrollRef, onChange]);
};

function isPointInPolygon(point, polygon) {
  const [x, y] = point;
  let isInside = false;
  const length = polygon.length;
  for (let i = 0, j = length - 1; i < length; j = i++) {
    const [xi, yi] = polygon[i] || [0, 0];
    const [xj, yj] = polygon[j] || [0, 0];
    const intersect = yi >= y !== yj >= y && x <= (xj - xi) * (y - yi) / (yj - yi) + xi;
    if (intersect) {
      isInside = !isInside;
    }
  }
  return isInside;
}
function isInside(point, rect) {
  return point[0] >= rect.x && point[0] <= rect.x + rect.width && point[1] >= rect.y && point[1] <= rect.y + rect.height;
}
function safePolygon(_temp) {
  let {
    restMs = 0,
    buffer = 0.5,
    blockPointerEvents = false
  } = _temp === void 0 ? {} : _temp;
  let timeoutId;
  let isInsideRect = false;
  let hasLanded = false;
  const fn = _ref => {
    let {
      x,
      y,
      placement,
      elements,
      onClose,
      nodeId,
      tree
    } = _ref;
    return function onMouseMove(event) {
      function close() {
        clearTimeout(timeoutId);
        onClose();
      }
      clearTimeout(timeoutId);
      if (!elements.domReference || !elements.floating || placement == null || x == null || y == null) {
        return;
      }
      const {
        clientX,
        clientY
      } = event;
      const clientPoint = [clientX, clientY];
      const target = getTarget(event);
      const isLeave = event.type === 'mouseleave';
      const isOverFloatingEl = contains(elements.floating, target);
      const isOverReferenceEl = contains(elements.domReference, target);
      const refRect = elements.domReference.getBoundingClientRect();
      const rect = elements.floating.getBoundingClientRect();
      const side = placement.split('-')[0];
      const cursorLeaveFromRight = x > rect.right - rect.width / 2;
      const cursorLeaveFromBottom = y > rect.bottom - rect.height / 2;
      const isOverReferenceRect = isInside(clientPoint, refRect);
      if (isOverFloatingEl) {
        hasLanded = true;
        if (!isLeave) {
          return;
        }
      }
      if (isOverReferenceEl) {
        hasLanded = false;
      }
      if (isOverReferenceEl && !isLeave) {
        hasLanded = true;
        return;
      }

      // Prevent overlapping floating element from being stuck in an open-close
      // loop: https://github.com/floating-ui/floating-ui/issues/1910
      if (isLeave && isElement(event.relatedTarget) && contains(elements.floating, event.relatedTarget)) {
        return;
      }

      // If any nested child is open, abort.
      if (tree && getChildren(tree.nodesRef.current, nodeId).some(_ref2 => {
        let {
          context
        } = _ref2;
        return context == null ? void 0 : context.open;
      })) {
        return;
      }

      // If the pointer is leaving from the opposite side, the "buffer" logic
      // creates a point where the floating element remains open, but should be
      // ignored.
      // A constant of 1 handles floating point rounding errors.
      if (side === 'top' && y >= refRect.bottom - 1 || side === 'bottom' && y <= refRect.top + 1 || side === 'left' && x >= refRect.right - 1 || side === 'right' && x <= refRect.left + 1) {
        return close();
      }

      // Ignore when the cursor is within the rectangular trough between the
      // two elements. Since the triangle is created from the cursor point,
      // which can start beyond the ref element's edge, traversing back and
      // forth from the ref to the floating element can cause it to close. This
      // ensures it always remains open in that case.
      let rectPoly = [];
      switch (side) {
        case 'top':
          rectPoly = [[rect.left, refRect.top + 1], [rect.left, rect.bottom - 1], [rect.right, rect.bottom - 1], [rect.right, refRect.top + 1]];
          isInsideRect = clientX >= rect.left && clientX <= rect.right && clientY >= rect.top && clientY <= refRect.top + 1;
          break;
        case 'bottom':
          rectPoly = [[rect.left, rect.top + 1], [rect.left, refRect.bottom - 1], [rect.right, refRect.bottom - 1], [rect.right, rect.top + 1]];
          isInsideRect = clientX >= rect.left && clientX <= rect.right && clientY >= refRect.bottom - 1 && clientY <= rect.bottom;
          break;
        case 'left':
          rectPoly = [[rect.right - 1, rect.bottom], [rect.right - 1, rect.top], [refRect.left + 1, rect.top], [refRect.left + 1, rect.bottom]];
          isInsideRect = clientX >= rect.left && clientX <= refRect.left + 1 && clientY >= rect.top && clientY <= rect.bottom;
          break;
        case 'right':
          rectPoly = [[refRect.right - 1, rect.bottom], [refRect.right - 1, rect.top], [rect.left + 1, rect.top], [rect.left + 1, rect.bottom]];
          isInsideRect = clientX >= refRect.right - 1 && clientX <= rect.right && clientY >= rect.top && clientY <= rect.bottom;
          break;
      }
      function getPolygon(_ref3) {
        let [x, y] = _ref3;
        const isFloatingWider = rect.width > refRect.width;
        const isFloatingTaller = rect.height > refRect.height;
        switch (side) {
          case 'top':
            {
              const cursorPointOne = [isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4, y + buffer + 1];
              const cursorPointTwo = [isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4, y + buffer + 1];
              const commonPoints = [[rect.left, cursorLeaveFromRight ? rect.bottom - buffer : isFloatingWider ? rect.bottom - buffer : rect.top], [rect.right, cursorLeaveFromRight ? isFloatingWider ? rect.bottom - buffer : rect.top : rect.bottom - buffer]];
              return [cursorPointOne, cursorPointTwo, ...commonPoints];
            }
          case 'bottom':
            {
              const cursorPointOne = [isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4, y - buffer];
              const cursorPointTwo = [isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4, y - buffer];
              const commonPoints = [[rect.left, cursorLeaveFromRight ? rect.top + buffer : isFloatingWider ? rect.top + buffer : rect.bottom], [rect.right, cursorLeaveFromRight ? isFloatingWider ? rect.top + buffer : rect.bottom : rect.top + buffer]];
              return [cursorPointOne, cursorPointTwo, ...commonPoints];
            }
          case 'left':
            {
              const cursorPointOne = [x + buffer + 1, isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4];
              const cursorPointTwo = [x + buffer + 1, isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4];
              const commonPoints = [[cursorLeaveFromBottom ? rect.right - buffer : isFloatingTaller ? rect.right - buffer : rect.left, rect.top], [cursorLeaveFromBottom ? isFloatingTaller ? rect.right - buffer : rect.left : rect.right - buffer, rect.bottom]];
              return [...commonPoints, cursorPointOne, cursorPointTwo];
            }
          case 'right':
            {
              const cursorPointOne = [x - buffer, isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4];
              const cursorPointTwo = [x - buffer, isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4];
              const commonPoints = [[cursorLeaveFromBottom ? rect.left + buffer : isFloatingTaller ? rect.left + buffer : rect.right, rect.top], [cursorLeaveFromBottom ? isFloatingTaller ? rect.left + buffer : rect.right : rect.left + buffer, rect.bottom]];
              return [cursorPointOne, cursorPointTwo, ...commonPoints];
            }
        }
      }
      const poly = isInsideRect ? rectPoly : getPolygon([x, y]);
      if (isInsideRect) {
        return;
      } else if (hasLanded && !isOverReferenceRect) {
        return close();
      }
      if (!isPointInPolygon([clientX, clientY], poly)) {
        close();
      } else if (restMs && !hasLanded) {
        timeoutId = setTimeout(close, restMs);
      }
    };
  };
  fn.__options = {
    blockPointerEvents
  };
  return fn;
}

/**
 * Provides data to position a floating element and context to add interactions.
 * @see https://floating-ui.com/docs/react
 */
function useFloating(options) {
  if (options === void 0) {
    options = {};
  }
  const {
    open = false,
    onOpenChange: unstable_onOpenChange,
    nodeId
  } = options;
  const position = (0,floating_ui_react_dom_esm.useFloating)(options);
  const tree = useFloatingTree();
  const domReferenceRef = react.useRef(null);
  const dataRef = react.useRef({});
  const events = react.useState(() => createPubSub())[0];
  const [domReference, setDomReference] = react.useState(null);
  const setPositionReference = react.useCallback(node => {
    const positionReference = isElement(node) ? {
      getBoundingClientRect: () => node.getBoundingClientRect(),
      contextElement: node
    } : node;
    position.refs.setReference(positionReference);
  }, [position.refs]);
  const setReference = react.useCallback(node => {
    if (isElement(node) || node === null) {
      domReferenceRef.current = node;
      setDomReference(node);
    }

    // Backwards-compatibility for passing a virtual element to `reference`
    // after it has set the DOM reference.
    if (isElement(position.refs.reference.current) || position.refs.reference.current === null ||
    // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    node !== null && !isElement(node)) {
      position.refs.setReference(node);
    }
  }, [position.refs]);
  const refs = react.useMemo(() => ({
    ...position.refs,
    setReference,
    setPositionReference,
    domReference: domReferenceRef
  }), [position.refs, setReference, setPositionReference]);
  const elements = react.useMemo(() => ({
    ...position.elements,
    domReference: domReference
  }), [position.elements, domReference]);
  const onOpenChange = useEvent(unstable_onOpenChange);
  const context = react.useMemo(() => ({
    ...position,
    refs,
    elements,
    dataRef,
    nodeId,
    events,
    open,
    onOpenChange
  }), [position, nodeId, events, open, onOpenChange, refs, elements]);
  index(() => {
    const node = tree == null ? void 0 : tree.nodesRef.current.find(node => node.id === nodeId);
    if (node) {
      node.context = context;
    }
  });
  return react.useMemo(() => ({
    ...position,
    context,
    refs,
    reference: setReference,
    positionReference: setPositionReference
  }), [position, refs, context, setReference, setPositionReference]);
}

function mergeProps(userProps, propsList, elementKey) {
  const map = new Map();
  return {
    ...(elementKey === 'floating' && {
      tabIndex: -1
    }),
    ...userProps,
    ...propsList.map(value => value ? value[elementKey] : null).concat(userProps).reduce((acc, props) => {
      if (!props) {
        return acc;
      }
      Object.entries(props).forEach(_ref => {
        let [key, value] = _ref;
        if (key.indexOf('on') === 0) {
          if (!map.has(key)) {
            map.set(key, []);
          }
          if (typeof value === 'function') {
            var _map$get;
            (_map$get = map.get(key)) == null ? void 0 : _map$get.push(value);
            acc[key] = function () {
              var _map$get2;
              for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
              }
              (_map$get2 = map.get(key)) == null ? void 0 : _map$get2.forEach(fn => fn(...args));
            };
          }
        } else {
          acc[key] = value;
        }
      });
      return acc;
    }, {})
  };
}
const useInteractions = function (propsList) {
  if (propsList === void 0) {
    propsList = [];
  }
  // The dependencies are a dynamic array, so we can't use the linter's
  // suggestion to add it to the deps array.
  const deps = propsList;
  const getReferenceProps = react.useCallback(userProps => mergeProps(userProps, propsList, 'reference'),
  // eslint-disable-next-line react-hooks/exhaustive-deps
  deps);
  const getFloatingProps = react.useCallback(userProps => mergeProps(userProps, propsList, 'floating'),
  // eslint-disable-next-line react-hooks/exhaustive-deps
  deps);
  const getItemProps = react.useCallback(userProps => mergeProps(userProps, propsList, 'item'),
  // Granularly check for `item` changes, because the `getItemProps` getter
  // should be as referentially stable as possible since it may be passed as
  // a prop to many components. All `item` key values must therefore be
  // memoized.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  propsList.map(key => key == null ? void 0 : key.item));
  return react.useMemo(() => ({
    getReferenceProps,
    getFloatingProps,
    getItemProps
  }), [getReferenceProps, getFloatingProps, getItemProps]);
};




/***/ }),

/***/ 11960:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "useEscapeKeydown": function() { return /* binding */ useEscapeKeydown; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../node_modules/@radix-ui/react-use-callback-ref/dist/index.module.js
function useCallbackRef(r){const t=react.useRef(r);return react.useEffect((()=>{t.current=r})),react.useMemo((()=>(...e)=>{var r;return null===(r=t.current)||void 0===r?void 0:r.call(t,...e)}),[])}
//# sourceMappingURL=index.module.js.map

;// CONCATENATED MODULE: ../../node_modules/@radix-ui/react-use-escape-keydown/dist/index.module.js
function useEscapeKeydown(n){const o=useCallbackRef(n);react.useEffect((()=>{const e=e=>{"Escape"===e.key&&o(e)};return document.addEventListener("keydown",e),()=>document.removeEventListener("keydown",e)}),[o])}
//# sourceMappingURL=index.module.js.map


/***/ }),

/***/ 69586:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "usePrevious": function() { return /* binding */ usePrevious; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
function usePrevious(r){const u=react__WEBPACK_IMPORTED_MODULE_0__.useRef({value:r,previous:r});return react__WEBPACK_IMPORTED_MODULE_0__.useMemo((()=>(u.current.value!==r&&(u.current.previous=u.current.value,u.current.value=r),u.current.previous)),[r])}
//# sourceMappingURL=index.module.js.map


/***/ }),

/***/ 69614:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Adapt_exports = {};
__export(Adapt_exports, {
  Adapt: () => Adapt,
  AdaptContents: () => AdaptContents,
  AdaptParentContext: () => AdaptParentContext,
  useAdaptParent: () => useAdaptParent
});
module.exports = __toCommonJS(Adapt_exports);
var import_jsx_runtime = __webpack_require__(52322);
var import_core = __webpack_require__(44996);
var import_react = __webpack_require__(2784);
const AdaptParentContext = (0, import_react.createContext)(null);
const AdaptContents = (props) => {
  const context = (0, import_react.useContext)(AdaptParentContext);
  if (!(context == null ? void 0 : context.Contents)) {
    throw new Error("Adapt not supported by this component");
  }
  return (0, import_react.createElement)(context.Contents, props);
};
AdaptContents["shouldForwardSpace"] = true;
const useAdaptParent = ({
  Contents
}) => {
  const [when, setWhen] = (0, import_react.useState)(null);
  const AdaptProvider = (0, import_react.useMemo)(() => {
    const context = {
      Contents,
      setWhen
    };
    function AdaptProviderView(props) {
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AdaptParentContext.Provider, { value: context, children: props.children });
    }
    return AdaptProviderView;
  }, [Contents]);
  return {
    AdaptProvider,
    when
  };
};
const Adapt = (0, import_core.withStaticProperties)(
  function Adapt2({ platform, when, children }) {
    const context = (0, import_react.useContext)(AdaptParentContext);
    let enabled = !platform;
    if (platform === "touch")
      enabled = import_core.isTouchable;
    if (platform === "native")
      enabled = !import_core.isWeb;
    if (platform === "web")
      enabled = import_core.isWeb;
    (0, import_core.useIsomorphicLayoutEffect)(() => {
      if (!enabled)
        return;
      context == null ? void 0 : context.setWhen(when || enabled);
    }, [when, context, enabled]);
    if (!enabled) {
      return null;
    }
    return children;
  },
  {
    Contents: AdaptContents
  }
);
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=Adapt.js.map


/***/ }),

/***/ 8242:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var src_exports = {};
module.exports = __toCommonJS(src_exports);
__reExport(src_exports, __webpack_require__(69614), module.exports);
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 58635:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var AlertDialog_exports = {};
__export(AlertDialog_exports, {
  AlertDialog: () => AlertDialog,
  AlertDialogAction: () => AlertDialogAction,
  AlertDialogCancel: () => AlertDialogCancel,
  AlertDialogContent: () => AlertDialogContent,
  AlertDialogDescription: () => AlertDialogDescription,
  AlertDialogOverlay: () => AlertDialogOverlay,
  AlertDialogPortal: () => AlertDialogPortal,
  AlertDialogTitle: () => AlertDialogTitle,
  AlertDialogTrigger: () => AlertDialogTrigger,
  createAlertDialogScope: () => createAlertDialogScope
});
module.exports = __toCommonJS(AlertDialog_exports);
var import_jsx_runtime = __webpack_require__(52322);
var import_compose_refs = __webpack_require__(7199);
var import_core = __webpack_require__(44996);
var import_create_context = __webpack_require__(71913);
var import_dialog = __webpack_require__(5339);
var import_stacks = __webpack_require__(84432);
var import_use_controllable_state = __webpack_require__(12113);
var React = __toESM(__webpack_require__(2784));
var import_react_native = __webpack_require__(22164);
const ROOT_NAME = "AlertDialog";
const [createAlertDialogContext, createAlertDialogScope] = (0, import_create_context.createContextScope)(ROOT_NAME, [
  import_dialog.createDialogScope
]);
const useDialogScope = (0, import_dialog.createDialogScope)();
const TRIGGER_NAME = "AlertDialogTrigger";
const NativeAlertDialogTriggerFrame = (0, import_core.styled)(import_stacks.YStack, {
  name: "DialogTrigger"
});
const AlertDialogTrigger = React.forwardRef(
  (props, forwardedRef) => {
    if (props["__native"]) {
      const { __native, onPress, __onPress, ...rest } = props;
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
        NativeAlertDialogTriggerFrame,
        {
          ...rest,
          onPress: (0, import_core.composeEventHandlers)(onPress, __onPress)
        }
      );
    }
    const { __scopeAlertDialog, ...triggerProps } = props;
    const dialogScope = useDialogScope(__scopeAlertDialog);
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_dialog.DialogTrigger, { ...dialogScope, ...triggerProps, ref: forwardedRef });
  }
);
AlertDialogTrigger.displayName = TRIGGER_NAME;
const PORTAL_NAME = "AlertDialogPortal";
const AlertDialogPortal = (props) => {
  const { __scopeAlertDialog, ...portalProps } = props;
  const dialogScope = useDialogScope(__scopeAlertDialog);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_dialog.DialogPortal, { ...dialogScope, ...portalProps });
};
AlertDialogPortal.displayName = PORTAL_NAME;
const OVERLAY_NAME = "AlertDialogOverlay";
const AlertDialogOverlay = React.forwardRef(
  (props, forwardedRef) => {
    const { __scopeAlertDialog, ...overlayProps } = props;
    const dialogScope = useDialogScope(__scopeAlertDialog);
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_dialog.DialogOverlay, { ...dialogScope, ...overlayProps, ref: forwardedRef });
  }
);
AlertDialogOverlay.displayName = OVERLAY_NAME;
const CONTENT_NAME = "AlertDialogContent";
const [AlertDialogContentProvider, useAlertDialogContentContext] = createAlertDialogContext(CONTENT_NAME);
const AlertDialogContent = React.forwardRef(
  (props, forwardedRef) => {
    const { __scopeAlertDialog, children, ...contentProps } = props;
    const dialogScope = useDialogScope(__scopeAlertDialog);
    const contentRef = React.useRef(null);
    const composedRefs = (0, import_compose_refs.useComposedRefs)(forwardedRef, contentRef);
    const cancelRef = React.useRef(null);
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
      import_dialog.DialogWarningProvider,
      {
        contentName: CONTENT_NAME,
        titleName: TITLE_NAME,
        docsSlug: "alert-dialog",
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AlertDialogContentProvider, { scope: __scopeAlertDialog, cancelRef, children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(
          import_dialog.DialogContent,
          {
            role: "alertdialog",
            ...dialogScope,
            ...contentProps,
            ref: composedRefs,
            onOpenAutoFocus: (0, import_core.composeEventHandlers)(
              contentProps.onOpenAutoFocus,
              (event) => {
                var _a;
                event.preventDefault();
                if (import_core.isWeb) {
                  (_a = cancelRef.current) == null ? void 0 : _a.focus({ preventScroll: true });
                }
              }
            ),
            onPointerDownOutside: (event) => event.preventDefault(),
            onInteractOutside: (event) => event.preventDefault(),
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_core.Slottable, { children }),
               false && /* @__PURE__ */ 0
            ]
          }
        ) })
      }
    );
  }
);
AlertDialogContent.displayName = CONTENT_NAME;
const TITLE_NAME = "AlertDialogTitle";
const AlertDialogTitle = React.forwardRef(
  (props, forwardedRef) => {
    const { __scopeAlertDialog, ...titleProps } = props;
    const dialogScope = useDialogScope(__scopeAlertDialog);
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_dialog.DialogTitle, { ...dialogScope, ...titleProps, ref: forwardedRef });
  }
);
AlertDialogTitle.displayName = TITLE_NAME;
const DESCRIPTION_NAME = "AlertDialogDescription";
const AlertDialogDescription = React.forwardRef((props, forwardedRef) => {
  const { __scopeAlertDialog, ...descriptionProps } = props;
  const dialogScope = useDialogScope(__scopeAlertDialog);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_dialog.DialogDescription, { ...dialogScope, ...descriptionProps, ref: forwardedRef });
});
AlertDialogDescription.displayName = DESCRIPTION_NAME;
const ACTION_NAME = "AlertDialogAction";
const AlertDialogAction = React.forwardRef(
  (props, forwardedRef) => {
    const { __scopeAlertDialog, ...actionProps } = props;
    const dialogScope = useDialogScope(__scopeAlertDialog);
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_dialog.DialogClose, { ...dialogScope, ...actionProps, ref: forwardedRef });
  }
);
AlertDialogAction.displayName = ACTION_NAME;
const CANCEL_NAME = "AlertDialogCancel";
const AlertDialogCancel = React.forwardRef(
  (props, forwardedRef) => {
    const { __scopeAlertDialog, ...cancelProps } = props;
    const { cancelRef } = useAlertDialogContentContext(CANCEL_NAME, __scopeAlertDialog);
    const dialogScope = useDialogScope(__scopeAlertDialog);
    const ref = (0, import_compose_refs.useComposedRefs)(forwardedRef, cancelRef);
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_dialog.DialogClose, { ...dialogScope, ...cancelProps, ref });
  }
);
AlertDialogCancel.displayName = CANCEL_NAME;
const DescriptionWarning = ({ contentRef }) => {
  if (false) {}
  return null;
};
const AlertDialogInner = (props) => {
  const { __scopeAlertDialog, native, ...alertDialogProps } = props;
  const dialogScope = useDialogScope(__scopeAlertDialog);
  if (false) {}
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_dialog.Dialog, { ...dialogScope, ...alertDialogProps, modal: true });
};
function forEachChildDeep(children, onChild) {
  for (const child of children) {
    if (!React.isValidElement(child))
      continue;
    if (!onChild(child))
      continue;
    if (child.props.children) {
      forEachChildDeep(React.Children.toArray(child.props.children), onChild);
    }
  }
}
function getStringChildren(child) {
  let string = "";
  forEachChildDeep(React.Children.toArray(child), (child2) => {
    if (typeof child2.props.children === "string") {
      string = child2.props.children;
      return false;
    }
    return true;
  });
  return string;
}
const AlertDialog = (0, import_core.withStaticProperties)(AlertDialogInner, {
  Trigger: AlertDialogTrigger,
  Portal: AlertDialogPortal,
  Overlay: AlertDialogOverlay,
  Content: AlertDialogContent,
  Action: AlertDialogAction,
  Cancel: AlertDialogCancel,
  Title: AlertDialogTitle,
  Description: AlertDialogDescription
});
AlertDialog.displayName = ROOT_NAME;
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=AlertDialog.js.map


/***/ }),

/***/ 85217:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var src_exports = {};
module.exports = __toCommonJS(src_exports);
__reExport(src_exports, __webpack_require__(58635), module.exports);
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 9188:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var AnimatePresence_exports = {};
__export(AnimatePresence_exports, {
  AnimatePresence: () => AnimatePresence
});
module.exports = __toCommonJS(AnimatePresence_exports);
var import_jsx_runtime = __webpack_require__(52322);
var import_web = __webpack_require__(44571);
var import_react = __toESM(__webpack_require__(2784));
var import_LayoutGroupContext = __webpack_require__(67867);
var import_PresenceChild = __webpack_require__(44764);
const getChildKey = (child) => child.key || "";
const isDev = "production" !== "production";
function updateChildLookup(children, allChildren) {
  const seenChildren = isDev ? /* @__PURE__ */ new Set() : null;
  children.forEach((child) => {
    const key = getChildKey(child);
    if (isDev && seenChildren && seenChildren.has(key)) {
      console.warn(
        `Children of AnimatePresence require unique keys. "${key}" is a duplicate.`
      );
      seenChildren.add(key);
    }
    allChildren.set(key, child);
  });
}
function onlyElements(children) {
  const filtered = [];
  import_react.Children.forEach(children, (child, index) => {
    if ((0, import_react.isValidElement)(child)) {
      if (!child.key) {
        if (false) {}
        filtered.push(
          import_react.default.cloneElement(child, {
            key: index
          })
        );
      } else {
        filtered.push(child);
      }
    }
  });
  return filtered;
}
const AnimatePresence = ({
  children,
  enterVariant,
  exitVariant,
  initial = true,
  onExitComplete,
  exitBeforeEnter,
  presenceAffectsLayout = true
}) => {
  let forceRender = (0, import_web.useForceUpdate)();
  const isClientMounted = (0, import_web.useDidFinishSSR)();
  const forceRenderLayoutGroup = (0, import_react.useContext)(import_LayoutGroupContext.LayoutGroupContext).forceRender;
  if (forceRenderLayoutGroup)
    forceRender = forceRenderLayoutGroup;
  const isMounted = (0, import_react.useRef)(false);
  const filteredChildren = onlyElements(children);
  let childrenToRender = filteredChildren;
  const exiting = /* @__PURE__ */ new Set();
  const presentChildren = (0, import_react.useRef)(childrenToRender);
  const allChildren = (0, import_react.useRef)(/* @__PURE__ */ new Map()).current;
  const isInitialRender = (0, import_react.useRef)(true);
  (0, import_react.useEffect)(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
      isInitialRender.current = true;
      allChildren.clear();
      exiting.clear();
    };
  }, []);
  (0, import_web.useIsomorphicLayoutEffect)(() => {
    isInitialRender.current = false;
    updateChildLookup(filteredChildren, allChildren);
    presentChildren.current = childrenToRender;
  });
  const hasWarned =  false ? 0 : null;
  if (isInitialRender.current) {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, { children: childrenToRender.map((child) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
      import_PresenceChild.PresenceChild,
      {
        isPresent: Boolean(isClientMounted ? true : isMounted.current),
        exitVariant,
        enterVariant,
        initial: initial ? void 0 : false,
        presenceAffectsLayout,
        children: child
      },
      getChildKey(child)
    )) });
  }
  childrenToRender = [...childrenToRender];
  const presentKeys = presentChildren.current.map(getChildKey);
  const targetKeys = filteredChildren.map(getChildKey);
  const numPresent = presentKeys.length;
  for (let i = 0; i < numPresent; i++) {
    const key = presentKeys[i];
    if (targetKeys.indexOf(key) === -1) {
      exiting.add(key);
    }
  }
  if (exitBeforeEnter && exiting.size) {
    childrenToRender = [];
  }
  exiting.forEach((key) => {
    if (targetKeys.indexOf(key) !== -1)
      return;
    const child = allChildren.get(key);
    if (!child)
      return;
    const insertionIndex = presentKeys.indexOf(key);
    childrenToRender.splice(
      insertionIndex,
      0,
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
        import_PresenceChild.PresenceChild,
        {
          isPresent: false,
          onExitComplete: () => {
            allChildren.delete(key);
            exiting.delete(key);
            const removeIndex = presentChildren.current.findIndex(
              (presentChild) => presentChild.key === key
            );
            presentChildren.current.splice(removeIndex, 1);
            if (!exiting.size) {
              presentChildren.current = filteredChildren;
              if (isMounted.current === false)
                return;
              forceRender();
              onExitComplete == null ? void 0 : onExitComplete();
            }
          },
          exitVariant,
          enterVariant,
          presenceAffectsLayout,
          children: child
        },
        getChildKey(child)
      )
    );
  });
  childrenToRender = childrenToRender.map((child) => {
    const key = child.key;
    return exiting.has(key) ? child : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
      import_PresenceChild.PresenceChild,
      {
        isPresent: true,
        exitVariant,
        enterVariant,
        presenceAffectsLayout,
        children: child
      },
      getChildKey(child)
    );
  });
  if (false) {}
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, { children: exiting.size ? childrenToRender : childrenToRender.map((child) => (0, import_react.cloneElement)(child)) });
};
AnimatePresence.displayName = "AnimatePresence";
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=AnimatePresence.js.map


/***/ }),

/***/ 67867:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var LayoutGroupContext_exports = {};
__export(LayoutGroupContext_exports, {
  LayoutGroupContext: () => LayoutGroupContext
});
module.exports = __toCommonJS(LayoutGroupContext_exports);
var import_react = __webpack_require__(2784);
const LayoutGroupContext = (0, import_react.createContext)({});
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=LayoutGroupContext.js.map


/***/ }),

/***/ 44764:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var PresenceChild_exports = {};
__export(PresenceChild_exports, {
  PresenceChild: () => PresenceChild
});
module.exports = __toCommonJS(PresenceChild_exports);
var import_jsx_runtime = __webpack_require__(52322);
var import_use_presence = __webpack_require__(6185);
var React = __toESM(__webpack_require__(2784));
var import_react = __webpack_require__(2784);
const PresenceChild = ({
  children,
  initial,
  isPresent,
  onExitComplete,
  exitVariant,
  enterVariant,
  presenceAffectsLayout
}) => {
  const presenceChildren = React.useMemo(newChildrenMap, []);
  const id = (0, import_react.useId)() || "";
  const context = React.useMemo(
    () => {
      return {
        id,
        initial,
        isPresent,
        exitVariant,
        enterVariant,
        onExitComplete: (id2) => {
          presenceChildren.set(id2, true);
          for (const isComplete of presenceChildren.values()) {
            if (!isComplete) {
              return;
            }
          }
          onExitComplete == null ? void 0 : onExitComplete();
        },
        register: (id2) => {
          presenceChildren.set(id2, false);
          return () => presenceChildren.delete(id2);
        }
      };
    },
    /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */
    // eslint-disable-next-line react-hooks/exhaustive-deps
    presenceAffectsLayout ? void 0 : [isPresent, exitVariant, enterVariant]
  );
  React.useMemo(() => {
    presenceChildren.forEach((_, key) => presenceChildren.set(key, false));
  }, [isPresent]);
  React.useEffect(() => {
    !(isPresent || presenceChildren.size) && (onExitComplete == null ? void 0 : onExitComplete());
  }, [isPresent]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_use_presence.PresenceContext.Provider, { value: context, children });
};
function newChildrenMap() {
  return /* @__PURE__ */ new Map();
}
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=PresenceChild.js.map


/***/ }),

/***/ 90625:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var src_exports = {};
module.exports = __toCommonJS(src_exports);
__reExport(src_exports, __webpack_require__(9188), module.exports);
__reExport(src_exports, __webpack_require__(6185), module.exports);
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 37898:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "AnimatedText": function() { return /* reexport */ AnimatedText; },
  "AnimatedView": function() { return /* reexport */ AnimatedView; },
  "createAnimations": function() { return /* reexport */ createAnimations; },
  "useAnimatedNumber": function() { return /* reexport */ useAnimatedNumber; },
  "useAnimatedNumberReaction": function() { return /* reexport */ useAnimatedNumberReaction; },
  "useAnimatedNumberStyle": function() { return /* reexport */ useAnimatedNumberStyle; }
});

// EXTERNAL MODULE: ../../node_modules/@tamagui/use-presence/dist/esm/index.mjs + 2 modules
var esm = __webpack_require__(41539);
// EXTERNAL MODULE: ./node_modules/@tamagui/web/dist/esm/hooks/useSafeRef.js
var useSafeRef = __webpack_require__(67180);
// EXTERNAL MODULE: ./node_modules/@tamagui/constants/dist/esm/index.mjs
var dist_esm = __webpack_require__(11649);
// EXTERNAL MODULE: ./node_modules/@tamagui/use-event/dist/esm/index.mjs + 2 modules
var use_event_dist_esm = __webpack_require__(4751);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/exports/Animated/index.js + 37 modules
var Animated = __webpack_require__(48923);
;// CONCATENATED MODULE: ../../node_modules/@tamagui/animations-react-native/dist/esm/createAnimations.js




const animatedStyleKey = {
  transform: true,
  opacity: true
};
const AnimatedView = Animated/* default.View */.Z.View;
const AnimatedText = Animated/* default.Text */.Z.Text;
function useAnimatedNumber(initial) {
  const state = (0,useSafeRef/* useSafeRef */.p)(
    null
  );
  if (!state.current) {
    state.current = {
      composite: null,
      val: new Animated/* default.Value */.Z.Value(initial),
      strategy: { type: "spring" }
    };
  }
  return {
    getInstance() {
      return state.current.val;
    },
    getValue() {
      return state.current.val["_value"];
    },
    stop() {
      var _a;
      (_a = state.current.composite) == null ? void 0 : _a.stop();
      state.current.composite = null;
    },
    setValue(next, { type, ...config } = { type: "spring" }) {
      var _a, _b;
      const val = state.current.val;
      if (type === "direct") {
        val.setValue(next);
      } else if (type === "spring") {
        (_a = state.current.composite) == null ? void 0 : _a.stop();
        const composite = Animated/* default.spring */.Z.spring(val, {
          ...config,
          toValue: next,
          useNativeDriver: !dist_esm/* isWeb */.$L
        });
        composite.start();
        state.current.composite = composite;
      } else {
        (_b = state.current.composite) == null ? void 0 : _b.stop();
        const composite = Animated/* default.timing */.Z.timing(val, {
          ...config,
          toValue: next,
          useNativeDriver: !dist_esm/* isWeb */.$L
        });
        composite.start();
        state.current.composite = composite;
      }
    }
  };
}
function useAnimatedNumberReaction(value, cb) {
  const onChange = (0,use_event_dist_esm/* useEvent */.z)((current) => {
    cb(current.value);
  });
  (0,react.useEffect)(() => {
    const id = value.getInstance().addListener(onChange);
    return () => {
      value.getInstance().removeListener(id);
    };
  }, [value, onChange]);
}
function useAnimatedNumberStyle(value, getStyle) {
  return getStyle(value.getInstance());
}
function createAnimations(animations) {
  AnimatedView["displayName"] = "AnimatedView";
  AnimatedText["displayName"] = "AnimatedText";
  return {
    isReactNative: true,
    animations,
    View: AnimatedView,
    Text: AnimatedText,
    useAnimatedNumber,
    useAnimatedNumberReaction,
    useAnimatedNumberStyle,
    usePresence: esm/* usePresence */.oO,
    useAnimations: ({ props, onDidAnimate, style, state, presence }) => {
      const isExiting = (presence == null ? void 0 : presence[0]) === false;
      const sendExitComplete = presence == null ? void 0 : presence[1];
      const mergedStyles = style;
      const animateStyles = (0,useSafeRef/* useSafeRef */.p)({});
      const animatedTranforms = (0,useSafeRef/* useSafeRef */.p)([]);
      const animationsState = (0,useSafeRef/* useSafeRef */.p)(null);
      if (!animationsState.current) {
        animationsState.current = /* @__PURE__ */ new WeakMap();
      }
      const args = [
        JSON.stringify(mergedStyles),
        JSON.stringify(state),
        isExiting,
        !!onDidAnimate
      ];
      const res = (0,react.useMemo)(() => {
        var _a;
        const runners = [];
        const completions = [];
        const nonAnimatedStyle = {};
        for (const key in mergedStyles) {
          const val = mergedStyles[key];
          if (!animatedStyleKey[key]) {
            nonAnimatedStyle[key] = val;
            continue;
          }
          if (key !== "transform") {
            animateStyles.current[key] = update(key, animateStyles.current[key], val);
            continue;
          }
          if (!val)
            continue;
          for (const [index, transform] of val.entries()) {
            if (!transform)
              continue;
            const tkey = Object.keys(transform)[0];
            const currentTransform = (_a = animatedTranforms.current[index]) == null ? void 0 : _a[tkey];
            animatedTranforms.current[index] = {
              [tkey]: update(tkey, currentTransform, transform[tkey])
            };
            animatedTranforms.current = [...animatedTranforms.current];
          }
        }
        const animatedStyle = {
          ...Object.fromEntries(
            Object.entries(animateStyles.current).map(([k, v]) => {
              var _a2;
              return [
                k,
                ((_a2 = animationsState.current.get(v)) == null ? void 0 : _a2.interopolation) || v
              ];
            })
          ),
          transform: animatedTranforms.current.map((r) => {
            var _a2;
            const key = Object.keys(r)[0];
            const val = ((_a2 = animationsState.current.get(r[key])) == null ? void 0 : _a2.interopolation) || r[key];
            return { [key]: val };
          })
        };
        return {
          runners,
          completions,
          style: [nonAnimatedStyle, animatedStyle]
        };
        function update(key, animated, valIn) {
          const [val, type] = getValue(valIn);
          const value = animated || new Animated/* default.Value */.Z.Value(val);
          if (dist_esm/* isWeb */.$L) {
            if (animated && val === animated["_value"]) {
              return value;
            }
          }
          let interpolateArgs;
          if (type) {
            const curInterpolation = animationsState.current.get(value);
            interpolateArgs = getInterpolated(
              (curInterpolation == null ? void 0 : curInterpolation.current) ?? value["_value"],
              val,
              type
            );
            animationsState.current.set(value, {
              interopolation: value.interpolate(interpolateArgs),
              current: val
            });
          }
          if (value) {
            const animationConfig = getAnimationConfig(key, animations, props.animation);
            let resolve;
            const promise = new Promise((res2) => {
              resolve = res2;
            });
            completions.push(promise);
            runners.push(() => {
              value.stopAnimation();
              Animated/* default */.Z[animationConfig.type || "spring"](value, {
                toValue: val,
                useNativeDriver: !dist_esm/* isWeb */.$L,
                ...animationConfig
              }).start(({ finished }) => {
                if (finished) {
                  resolve();
                }
              });
            });
          }
          if (false) {}
          return value;
        }
      }, args);
      (0,dist_esm/* useIsomorphicLayoutEffect */.LI)(() => {
        res.runners.forEach((r) => r());
        let cancel = false;
        Promise.all(res.completions).then(() => {
          if (cancel)
            return;
          onDidAnimate == null ? void 0 : onDidAnimate();
          if (isExiting) {
            sendExitComplete == null ? void 0 : sendExitComplete();
          }
        });
        return () => {
          cancel = true;
        };
      }, args);
      if (false) {}
      return res;
    }
  };
}
function getInterpolated(current, next, postfix = "deg") {
  if (next === current) {
    current = next - 1e-9;
  }
  const inputRange = [current, next];
  const outputRange = [`${current}${postfix}`, `${next}${postfix}`];
  if (next < current) {
    inputRange.reverse();
    outputRange.reverse();
  }
  return {
    inputRange,
    outputRange
  };
}
function getAnimationConfig(key, animations, animation) {
  if (typeof animation === "string") {
    return animations[animation];
  }
  let type = "";
  let extraConf;
  if (Array.isArray(animation)) {
    type = animation[0];
    const conf = animation[1] && animation[1][key];
    if (conf) {
      if (typeof conf === "string") {
        type = conf;
      } else {
        type = conf.type || type;
        extraConf = conf;
      }
    }
  } else {
    const val = animation == null ? void 0 : animation[key];
    type = val == null ? void 0 : val.type;
    extraConf = val;
  }
  const found = animations[type];
  if (!found) {
    throw new Error(`No animation of type "${type}" for key "${key}"`);
  }
  return {
    ...found,
    ...extraConf
  };
}
function getValue(input) {
  if (typeof input !== "string") {
    return [input];
  }
  const [_, number, after] = input.match(/([-0-9]+)(deg|%|px)/) ?? [];
  return [+number, after];
}

//# sourceMappingURL=createAnimations.js.map

;// CONCATENATED MODULE: ../../node_modules/@tamagui/animations-react-native/dist/esm/index.js


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 26782:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Avatar_exports = {};
__export(Avatar_exports, {
  Avatar: () => Avatar,
  AvatarFallback: () => AvatarFallback,
  AvatarFallbackFrame: () => AvatarFallbackFrame,
  AvatarFrame: () => AvatarFrame,
  AvatarImage: () => AvatarImage,
  createAvatarScope: () => createAvatarScope
});
module.exports = __toCommonJS(Avatar_exports);
var import_jsx_runtime = __webpack_require__(52322);
var import_core = __webpack_require__(44996);
var import_create_context = __webpack_require__(71913);
var import_image = __webpack_require__(11335);
var import_shapes = __webpack_require__(68534);
var import_stacks = __webpack_require__(84432);
var React = __toESM(__webpack_require__(2784));
const AVATAR_NAME = "Avatar";
const [createAvatarContext, createAvatarScope] = (0, import_create_context.createContextScope)(AVATAR_NAME);
const [AvatarProvider, useAvatarContext] = createAvatarContext(AVATAR_NAME);
const IMAGE_NAME = "AvatarImage";
const AvatarImage = React.forwardRef(
  (props, forwardedRef) => {
    var _a;
    const { __scopeAvatar, src, onLoadingStatusChange = () => {
    }, ...imageProps } = props;
    const context = useAvatarContext(IMAGE_NAME, __scopeAvatar);
    const [status, setStatus] = React.useState("idle");
    const extras = (0, import_core.getVariantExtras)(props);
    const shapeSize = (0, import_core.getVariableValue)(
      (_a = (0, import_shapes.getShapeSize)(context.size, extras)) == null ? void 0 : _a.width
    );
    React.useEffect(() => {
      setStatus("idle");
    }, [JSON.stringify(src)]);
    React.useEffect(() => {
      onLoadingStatusChange(status);
      context.onImageLoadingStatusChange(status);
    }, [status]);
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_stacks.YStack, { fullscreen: true, zIndex: 1, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
      import_image.Image,
      {
        fullscreen: true,
        ...typeof shapeSize === "number" && !isNaN(shapeSize) && {
          width: shapeSize,
          height: shapeSize
        },
        ...imageProps,
        ref: forwardedRef,
        src,
        onError: () => {
          setStatus("error");
        },
        onLoad: () => {
          setStatus("loaded");
        }
      }
    ) });
  }
);
AvatarImage.displayName = IMAGE_NAME;
const FALLBACK_NAME = "AvatarFallback";
const AvatarFallbackFrame = (0, import_core.styled)(import_stacks.YStack, {
  name: FALLBACK_NAME,
  position: "absolute",
  fullscreen: true,
  zIndex: 0
});
const AvatarFallback = AvatarFallbackFrame.extractable(
  React.forwardRef(
    (props, forwardedRef) => {
      const { __scopeAvatar, delayMs, ...fallbackProps } = props;
      const context = useAvatarContext(FALLBACK_NAME, __scopeAvatar);
      const [canRender, setCanRender] = React.useState(delayMs === void 0);
      React.useEffect(() => {
        if (delayMs !== void 0) {
          const timerId = setTimeout(() => setCanRender(true), delayMs);
          return () => clearTimeout(timerId);
        }
      }, [delayMs]);
      return canRender && context.imageLoadingStatus !== "loaded" ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AvatarFallbackFrame, { ...fallbackProps, ref: forwardedRef }) : null;
    }
  )
);
AvatarFallback.displayName = FALLBACK_NAME;
const AvatarFrame = (0, import_core.styled)(import_shapes.Square, {
  name: AVATAR_NAME,
  position: "relative",
  overflow: "hidden"
});
const Avatar = (0, import_core.withStaticProperties)(
  React.forwardRef(
    (props, forwardedRef) => {
      const { __scopeAvatar, size = "$true", ...avatarProps } = props;
      const [imageLoadingStatus, setImageLoadingStatus] = React.useState("idle");
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
        AvatarProvider,
        {
          size,
          scope: __scopeAvatar,
          imageLoadingStatus,
          onImageLoadingStatusChange: setImageLoadingStatus,
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AvatarFrame, { size, ...avatarProps, ref: forwardedRef })
        }
      );
    }
  ),
  {
    Image: AvatarImage,
    Fallback: AvatarFallback
  }
);
Avatar.displayName = AVATAR_NAME;
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=Avatar.js.map


/***/ }),

/***/ 92434:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var src_exports = {};
module.exports = __toCommonJS(src_exports);
__reExport(src_exports, __webpack_require__(26782), module.exports);
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 35810:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Button_exports = {};
__export(Button_exports, {
  Button: () => Button2,
  ButtonFrame: () => ButtonFrame,
  ButtonText: () => ButtonText,
  buttonStaticConfig: () => buttonStaticConfig,
  useButton: () => useButton
});
module.exports = __toCommonJS(Button_exports);
var import_jsx_runtime = __webpack_require__(52322);
var import_font_size = __webpack_require__(99140);
var import_get_button_sized = __webpack_require__(56701);
var import_helpers_tamagui = __webpack_require__(28920);
var import_stacks = __webpack_require__(84432);
var import_text = __webpack_require__(48175);
var import_web = __webpack_require__(44571);
var import_react = __webpack_require__(2784);
const NAME = "Button";
const ButtonFrame = (0, import_web.styled)(import_stacks.ThemeableStack, {
  name: NAME,
  tag: "button",
  justifyContent: "center",
  alignItems: "center",
  flexWrap: "nowrap",
  flexDirection: "row",
  cursor: "pointer",
  variants: {
    defaultStyle: {
      true: {
        focusable: true,
        hoverTheme: true,
        pressTheme: true,
        backgrounded: true,
        borderWidth: 1,
        borderColor: "transparent",
        pressStyle: {
          borderColor: "transparent"
        },
        hoverStyle: {
          borderColor: "transparent"
        },
        focusStyle: {
          borderColor: "$borderColorFocus"
        }
      }
    },
    size: {
      "...size": import_get_button_sized.getButtonSized
    },
    active: {
      true: {
        hoverStyle: {
          backgroundColor: "$background"
        }
      }
    },
    disabled: {
      true: {
        pointerEvents: "none"
      }
    }
  },
  defaultVariants: {
    size: "$true"
  }
});
const ButtonText = (0, import_web.styled)(import_text.SizableText, {
  name: "ButtonText",
  userSelect: "none",
  cursor: "pointer",
  // flexGrow 1 leads to inconsistent native style where text pushes to start of view
  flexGrow: 0,
  flexShrink: 1,
  ellipse: true,
  variants: {
    defaultStyle: {
      true: {
        color: "$color"
      }
    }
  }
});
const ButtonComponent = (0, import_react.forwardRef)(function Button(props, ref) {
  const {
    props: { unstyled, ...buttonProps }
  } = useButton(props);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ButtonFrame, { defaultStyle: !unstyled, ...buttonProps, ref });
});
const buttonStaticConfig = {
  inlineProps: /* @__PURE__ */ new Set([
    // text props go here (can't really optimize them, but we never fully extract button anyway)
    // may be able to remove this entirely, as the compiler / runtime have gotten better
    "color",
    "fontWeight",
    "fontSize",
    "fontFamily",
    "letterSpacing",
    "textAlign",
    "unstyled"
  ])
};
const Button2 = ButtonFrame.extractable(
  (0, import_web.themeable)(ButtonComponent, ButtonFrame.staticConfig),
  buttonStaticConfig
);
function useButton(propsIn, { Text = ButtonText } = { Text: ButtonText }) {
  const {
    children,
    icon,
    iconAfter,
    noTextWrap,
    theme: themeName,
    space,
    spaceFlex,
    scaleIcon = 1,
    scaleSpace = 0.66,
    separator,
    // text props
    color,
    fontWeight,
    letterSpacing,
    fontSize,
    fontFamily,
    textAlign,
    textProps,
    ...rest
  } = propsIn;
  const isNested = import_web.isRSC ? false : (0, import_react.useContext)(import_web.ButtonNestingContext);
  const propsActive = (0, import_web.useMediaPropsActive)(propsIn);
  const size = propsActive.size || "$true";
  const iconSize = (typeof size === "number" ? size * 0.5 : (0, import_font_size.getFontSize)(size)) * scaleIcon;
  const getThemedIcon = (0, import_helpers_tamagui.useGetThemedIcon)({ size: iconSize, color });
  const [themedIcon, themedIconAfter] = [icon, iconAfter].map(getThemedIcon);
  const spaceSize = propsActive.space ?? (0, import_web.getVariableValue)(iconSize) * scaleSpace;
  const contents = (0, import_text.wrapChildrenInText)(
    Text,
    propsActive,
    Text === ButtonText ? {
      defaultStyle: !propsIn.unstyled
    } : void 0
  );
  const inner = (0, import_web.spacedChildren)({
    // a bit arbitrary but scaling to font size is necessary so long as button does
    space: spaceSize,
    spaceFlex,
    separator,
    direction: propsActive.flexDirection === "column" || propsActive.flexDirection === "column-reverse" ? "vertical" : "horizontal",
    children: [themedIcon, ...contents, themedIconAfter]
  });
  const tag = isNested ? "span" : (
    // defaults to <a /> when accessibilityRole = link
    // see https://github.com/tamagui/tamagui/issues/505
    propsIn.accessibilityRole === "link" ? "a" : void 0
  );
  const props = {
    ...propsActive.disabled && {
      // in rnw - false still has keyboard tabIndex, undefined = not actually focusable
      focusable: void 0,
      // even with tabIndex unset, it will keep focusStyle on web so disable it here
      focusStyle: {
        borderColor: "$background"
      }
    },
    tag,
    ...rest,
    children: import_web.isRSC ? inner : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_web.ButtonNestingContext.Provider, { value: true, children: inner })
  };
  return {
    spaceSize,
    isNested,
    props
  };
}
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=Button.js.map


/***/ }),

/***/ 45517:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var src_exports = {};
module.exports = __toCommonJS(src_exports);
__reExport(src_exports, __webpack_require__(35810), module.exports);
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 16922:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Card_exports = {};
__export(Card_exports, {
  Card: () => Card,
  CardBackground: () => CardBackground,
  CardFooter: () => CardFooter,
  CardFrame: () => CardFrame,
  CardHeader: () => CardHeader
});
module.exports = __toCommonJS(Card_exports);
var import_jsx_runtime = (
  // <CardProvider scope={__scopeCard} size={size}>
  __webpack_require__(52322)
);
var import_stacks = __webpack_require__(84432);
var import_web = __webpack_require__(44571);
var import_react = __toESM(__webpack_require__(2784));
const CardFrame = (0, import_web.styled)(import_stacks.ThemeableStack, {
  name: "Card",
  backgroundColor: "$background",
  position: "relative",
  overflow: "hidden",
  variants: {
    size: {
      "...size": (val, { tokens }) => {
        return {
          borderRadius: tokens.radius[val] ?? val
        };
      }
    }
  },
  defaultVariants: {
    size: "$true"
  }
});
const CardHeader = (0, import_web.styled)(import_stacks.ThemeableStack, {
  name: "CardHeader",
  zIndex: 10,
  backgroundColor: "transparent",
  marginBottom: "auto",
  variants: {
    size: {
      "...size": (val, { tokens }) => {
        return {
          padding: tokens.space[val] ?? val
        };
      }
    }
  }
});
const CardFooter = (0, import_web.styled)(CardHeader, {
  name: "CardFooter",
  zIndex: 5,
  flexDirection: "row",
  marginTop: "auto",
  marginBottom: 0
});
const CardBackground = (0, import_web.styled)(import_stacks.ThemeableStack, {
  name: "CardBackground",
  zIndex: 0,
  fullscreen: true,
  overflow: "hidden",
  pointerEvents: "none",
  padding: 0
});
const Card = (0, import_web.withStaticProperties)(
  CardFrame.extractable(
    (0, import_react.forwardRef)(
      ({ size, __scopeCard, children, ...props }, ref) => {
        return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CardFrame, { ref, ...props, children: import_react.default.Children.map(children, (child) => {
          if ((0, import_web.isTamaguiElement)(child) && !child.props.size) {
            return (0, import_react.cloneElement)(child, {
              size
            });
          }
          return child;
        }) });
      }
    )
  ),
  {
    Header: CardHeader,
    Footer: CardFooter,
    Background: CardBackground
  }
);
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=Card.js.map


/***/ }),

/***/ 65936:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var src_exports = {};
module.exports = __toCommonJS(src_exports);
__reExport(src_exports, __webpack_require__(16922), module.exports);
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 46959:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Checkbox_exports = {};
__export(Checkbox_exports, {
  BubbleInput: () => BubbleInput,
  Checkbox: () => Checkbox,
  CheckboxFrame: () => CheckboxFrame,
  createCheckboxScope: () => createCheckboxScope,
  getState: () => getState,
  isIndeterminate: () => isIndeterminate
});
module.exports = __toCommonJS(Checkbox_exports);
var import_jsx_runtime = __webpack_require__(52322);
var import_react_use_previous = __webpack_require__(69586);
var import_core = __webpack_require__(44996);
var import_create_context = __webpack_require__(71913);
var import_focusable = __webpack_require__(31390);
var import_font_size = __webpack_require__(99140);
var import_get_size = __webpack_require__(20157);
var import_helpers_tamagui = __webpack_require__(28920);
var import_label = __webpack_require__(28339);
var import_stacks = __webpack_require__(84432);
var import_use_controllable_state = __webpack_require__(12113);
var React = __toESM(__webpack_require__(2784));
function isIndeterminate(checked) {
  return checked === "indeterminate";
}
function getState(checked) {
  return isIndeterminate(checked) ? "indeterminate" : checked ? "checked" : "unchecked";
}
const BubbleInput = (props) => {
  const { checked, bubbles = true, control, isHidden, ...inputProps } = props;
  const ref = React.useRef(null);
  const prevChecked = (0, import_react_use_previous.usePrevious)(checked);
  React.useEffect(() => {
    const input = ref.current;
    const inputProto = window.HTMLInputElement.prototype;
    const descriptor = Object.getOwnPropertyDescriptor(
      inputProto,
      "checked"
    );
    const setChecked = descriptor.set;
    if (prevChecked !== checked && setChecked) {
      const event = new Event("click", { bubbles });
      input.indeterminate = isIndeterminate(checked);
      setChecked.call(input, isIndeterminate(checked) ? false : checked);
      input.dispatchEvent(event);
    }
  }, [prevChecked, checked, bubbles]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
    "input",
    {
      type: "checkbox",
      defaultChecked: isIndeterminate(checked) ? false : checked,
      ...inputProps,
      tabIndex: -1,
      ref,
      "aria-hidden": isHidden,
      style: {
        ...isHidden ? {
          // ...controlSize,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0
        } : {
          appearance: "auto",
          accentColor: "var(--color6)"
        },
        ...props.style
      }
    }
  );
};
const INDICATOR_NAME = "CheckboxIndicator";
const CheckboxIndicatorFrame = (0, import_core.styled)(import_stacks.ThemeableStack, {
  // use Checkbox for easier themes
  name: INDICATOR_NAME
});
const CheckboxIndicator = CheckboxIndicatorFrame.extractable(
  React.forwardRef(
    (props, forwardedRef) => {
      const {
        __scopeCheckbox,
        children: childrenProp,
        forceMount,
        disablePassStyles,
        ...indicatorProps
      } = props;
      const context = useCheckboxContext(INDICATOR_NAME, __scopeCheckbox);
      const iconSize = (typeof context.size === "number" ? context.size * 0.65 : (0, import_font_size.getFontSize)(context.size)) * context.scaleIcon;
      const theme = (0, import_core.useTheme)();
      const getThemedIcon = (0, import_helpers_tamagui.useGetThemedIcon)({ size: iconSize, color: theme.color });
      const childrens = React.Children.toArray(childrenProp);
      const children = childrens.map((child) => {
        if (disablePassStyles || !React.isValidElement(child)) {
          return child;
        }
        return getThemedIcon(child);
      });
      if (forceMount || isIndeterminate(context.state) || context.state === true)
        return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
          CheckboxIndicatorFrame,
          {
            "data-state": getState(context.state),
            "data-disabled": context.disabled ? "" : void 0,
            pointerEvents: "none",
            ...indicatorProps,
            ref: forwardedRef,
            children
          }
        );
      return null;
    }
  )
);
CheckboxIndicator.displayName = INDICATOR_NAME;
const CHECKBOX_NAME = "Checkbox";
const CheckboxFrame = (0, import_core.styled)(import_stacks.ThemeableStack, {
  name: CHECKBOX_NAME,
  tag: "button",
  variants: {
    unstyled: {
      false: {
        size: "$true",
        backgroundColor: "$background",
        alignItems: "center",
        justifyContent: "center",
        pressTheme: true,
        focusable: true,
        borderWidth: 1,
        borderColor: "$borderColor",
        hoverStyle: {
          borderColor: "$borderColorHover"
        },
        focusStyle: {
          borderColor: "$borderColorFocus"
        }
      }
    },
    size: {
      "...size": (val, { tokens }) => {
        const radiusToken = (0, import_core.getVariableValue)((0, import_get_size.getSize)(val)) / 8;
        return {
          borderRadius: radiusToken
        };
      }
    }
  },
  defaultVariants: {
    unstyled: false
  }
});
const [createCheckboxContext, createCheckboxScope] = (0, import_create_context.createContextScope)(CHECKBOX_NAME);
const [CheckboxProvider, useCheckboxContext] = createCheckboxContext(CHECKBOX_NAME);
const Checkbox = (0, import_core.withStaticProperties)(
  CheckboxFrame.extractable(
    React.forwardRef(
      (props, forwardedRef) => {
        const {
          __scopeCheckbox,
          labelledBy: ariaLabelledby,
          name,
          checked: checkedProp,
          defaultChecked,
          required,
          scaleIcon = 1,
          scaleSize = 0.45,
          sizeAdjust = 0,
          disabled,
          value = "on",
          onCheckedChange,
          native,
          ...checkboxProps
        } = props;
        const [button, setButton] = React.useState(null);
        const composedRefs = (0, import_core.useComposedRefs)(forwardedRef, (node) => setButton(node));
        const hasConsumerStoppedPropagationRef = React.useRef(false);
        const propsActive = (0, import_core.useMediaPropsActive)(props);
        const isFormControl = import_core.isWeb ? button ? Boolean(button.closest("form")) : true : false;
        const [checked = false, setChecked] = (0, import_use_controllable_state.useControllableState)({
          prop: checkedProp,
          defaultProp: defaultChecked,
          onChange: onCheckedChange
        });
        const adjustedSize = (0, import_core.getVariableValue)(
          (0, import_get_size.stepTokenUpOrDown)("size", propsActive.size, sizeAdjust)
        );
        const size = scaleSize ? Math.round(adjustedSize * scaleSize) : adjustedSize;
        const labelId = (0, import_label.useLabelContext)(button);
        const labelledBy = ariaLabelledby || labelId;
        if (false) {}
        return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
          CheckboxProvider,
          {
            scope: __scopeCheckbox,
            state: checked,
            disabled,
            size,
            scaleIcon,
            children: import_core.isWeb && native ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
              BubbleInput,
              {
                control: button,
                bubbles: !hasConsumerStoppedPropagationRef.current,
                name,
                value,
                checked,
                required,
                disabled,
                id: props.id
              }
            ) : /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, { children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
                CheckboxFrame,
                {
                  width: size,
                  height: size,
                  tag: "button",
                  role: "checkbox",
                  "aria-labelledby": labelledBy,
                  "aria-checked": isIndeterminate(checked) ? "mixed" : checked,
                  "aria-required": required,
                  "data-state": getState(checked),
                  "data-disabled": disabled ? "" : void 0,
                  disabled,
                  ...checkboxProps,
                  ref: composedRefs,
                  ...import_core.isWeb && {
                    type: "button",
                    value,
                    onKeyDown: (0, import_core.composeEventHandlers)(
                      props.onKeyDown,
                      (event) => {
                        if (event.key === "Enter")
                          event.preventDefault();
                      }
                    )
                  },
                  onPress: (0, import_core.composeEventHandlers)(props.onPress, (event) => {
                    setChecked(
                      (prevChecked) => isIndeterminate(prevChecked) ? true : !prevChecked
                    );
                    if (isFormControl) {
                      hasConsumerStoppedPropagationRef.current = event.isPropagationStopped();
                      if (!hasConsumerStoppedPropagationRef.current)
                        event.stopPropagation();
                    }
                  })
                }
              ),
              import_core.isWeb && isFormControl ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
                BubbleInput,
                {
                  isHidden: true,
                  control: button,
                  bubbles: !hasConsumerStoppedPropagationRef.current,
                  name,
                  value,
                  checked,
                  required,
                  disabled
                }
              ) : null
            ] })
          }
        );
      }
    )
  ),
  {
    Indicator: CheckboxIndicator
  }
);
Checkbox.displayName = CHECKBOX_NAME;
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=Checkbox.js.map


/***/ }),

/***/ 24117:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var src_exports = {};
module.exports = __toCommonJS(src_exports);
__reExport(src_exports, __webpack_require__(46959), module.exports);
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 48733:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Collection_exports = {};
__export(Collection_exports, {
  createCollection: () => createCollection
});
module.exports = __toCommonJS(Collection_exports);
var import_jsx_runtime = __webpack_require__(52322);
var import_compose_refs = __webpack_require__(7199);
var import_core = __webpack_require__(44996);
var import_create_context = __webpack_require__(71913);
var import_react = __toESM(__webpack_require__(2784));
function createCollection(name) {
  const PROVIDER_NAME = name + "CollectionProvider";
  const [createCollectionContext, createCollectionScope] = (0, import_create_context.createContextScope)(PROVIDER_NAME);
  const [CollectionProviderImpl, useCollectionContext] = createCollectionContext(PROVIDER_NAME, {
    collectionRef: { current: null },
    itemMap: /* @__PURE__ */ new Map()
  });
  const CollectionProvider = (props) => {
    const { scope, children } = props;
    const ref = import_react.default.useRef(null);
    const itemMap = import_react.default.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CollectionProviderImpl, { scope, itemMap, collectionRef: ref, children });
  };
  CollectionProvider.displayName = PROVIDER_NAME;
  const COLLECTION_SLOT_NAME = name + "CollectionSlot";
  const CollectionSlot = import_react.default.forwardRef(
    (props, forwardedRef) => {
      const { scope, children } = props;
      const context = useCollectionContext(COLLECTION_SLOT_NAME, scope);
      const composedRefs = (0, import_compose_refs.useComposedRefs)(forwardedRef, context.collectionRef);
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_core.Slot, { ref: composedRefs, children });
    }
  );
  CollectionSlot.displayName = COLLECTION_SLOT_NAME;
  const ITEM_SLOT_NAME = name + "CollectionItemSlot";
  const ITEM_DATA_ATTR = "data-collection-item";
  const CollectionItemSlot = import_react.default.forwardRef(
    (props, forwardedRef) => {
      const { scope, children, ...itemData } = props;
      const ref = import_react.default.useRef(null);
      const composedRefs = (0, import_compose_refs.useComposedRefs)(forwardedRef, ref);
      const context = useCollectionContext(ITEM_SLOT_NAME, scope);
      import_react.default.useEffect(() => {
        context.itemMap.set(ref, { ref, ...itemData });
        return () => void context.itemMap.delete(ref);
      });
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_core.Slot, { ...{ [ITEM_DATA_ATTR]: "" }, ref: composedRefs, children });
    }
  );
  CollectionItemSlot.displayName = ITEM_SLOT_NAME;
  function useCollection(scope) {
    const context = useCollectionContext(name + "CollectionConsumer", scope);
    const getItems = import_react.default.useCallback(() => {
      const collectionNode = context.collectionRef.current;
      if (!collectionNode)
        return [];
      const orderedNodes = Array.from(
        collectionNode.querySelectorAll(`[${ITEM_DATA_ATTR}]`)
      );
      const items = Array.from(context.itemMap.values());
      const orderedItems = items.sort(
        (a, b) => orderedNodes.indexOf(a.ref.current) - orderedNodes.indexOf(b.ref.current)
      );
      return orderedItems;
    }, [context.collectionRef, context.itemMap]);
    return getItems;
  }
  return [
    { Provider: CollectionProvider, Slot: CollectionSlot, ItemSlot: CollectionItemSlot },
    useCollection,
    createCollectionScope
  ];
}
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=Collection.js.map


/***/ }),

/***/ 38987:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var src_exports = {};
module.exports = __toCommonJS(src_exports);
__reExport(src_exports, __webpack_require__(48733), module.exports);
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 28258:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var blackA_exports = {};
__export(blackA_exports, {
  blackA: () => blackA
});
module.exports = __toCommonJS(blackA_exports);
const blackA = {
  blackA1: "hsla(0, 0%, 0%, 0.012)",
  blackA2: "hsla(0, 0%, 0%, 0.027)",
  blackA3: "hsla(0, 0%, 0%, 0.047)",
  blackA4: "hsla(0, 0%, 0%, 0.071)",
  blackA5: "hsla(0, 0%, 0%, 0.090)",
  blackA6: "hsla(0, 0%, 0%, 0.114)",
  blackA7: "hsla(0, 0%, 0%, 0.141)",
  blackA8: "hsla(0, 0%, 0%, 0.220)",
  blackA9: "hsla(0, 0%, 0%, 0.439)",
  blackA10: "hsla(0, 0%, 0%, 0.478)",
  blackA11: "hsla(0, 0%, 0%, 0.565)",
  blackA12: "hsla(0, 0%, 0%, 0.910)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=blackA.js.map


/***/ }),

/***/ 30335:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var amber_exports = {};
__export(amber_exports, {
  amber: () => amber
});
module.exports = __toCommonJS(amber_exports);
const amber = {
  amber1: "hsl(36, 100%, 6.1%)",
  amber2: "hsl(35, 100%, 7.6%)",
  amber3: "hsl(32, 100%, 10.2%)",
  amber4: "hsl(32, 100%, 12.4%)",
  amber5: "hsl(33, 100%, 14.6%)",
  amber6: "hsl(35, 100%, 17.1%)",
  amber7: "hsl(35, 91.0%, 21.6%)",
  amber8: "hsl(36, 100%, 25.5%)",
  amber9: "hsl(39, 100%, 57.0%)",
  amber10: "hsl(43, 100%, 64.0%)",
  amber11: "hsl(39, 90.0%, 49.8%)",
  amber12: "hsl(39, 97.0%, 93.2%)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=amber.js.map


/***/ }),

/***/ 17550:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var amberA_exports = {};
__export(amberA_exports, {
  amberA: () => amberA
});
module.exports = __toCommonJS(amberA_exports);
const amberA = {
  amberA1: "hsla(0, 0%, 0%, 0)",
  amberA2: "hsla(31, 100%, 49.7%, 0.036)",
  amberA3: "hsla(27, 100%, 49.9%, 0.094)",
  amberA4: "hsla(29, 100%, 50.0%, 0.143)",
  amberA5: "hsla(31, 100%, 50.0%, 0.192)",
  amberA6: "hsla(35, 100%, 50.0%, 0.250)",
  amberA7: "hsla(34, 99.6%, 52.9%, 0.331)",
  amberA8: "hsla(36, 100%, 50.0%, 0.442)",
  amberA9: "hsla(40, 100%, 57.2%, 0.980)",
  amberA10: "hsla(44, 100%, 64.2%, 0.980)",
  amberA11: "hsla(39, 99.9%, 52.7%, 0.938)",
  amberA12: "hsla(45, 100%, 94.2%, 0.980)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=amberA.js.map


/***/ }),

/***/ 99888:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var blue_exports = {};
__export(blue_exports, {
  blue: () => blue
});
module.exports = __toCommonJS(blue_exports);
const blue = {
  blue1: "hsl(212, 35.0%, 9.2%)",
  blue2: "hsl(216, 50.0%, 11.8%)",
  blue3: "hsl(214, 59.4%, 15.3%)",
  blue4: "hsl(214, 65.8%, 17.9%)",
  blue5: "hsl(213, 71.2%, 20.2%)",
  blue6: "hsl(212, 77.4%, 23.1%)",
  blue7: "hsl(211, 85.1%, 27.4%)",
  blue8: "hsl(211, 89.7%, 34.1%)",
  blue9: "hsl(206, 100%, 50.0%)",
  blue10: "hsl(209, 100%, 60.6%)",
  blue11: "hsl(210, 100%, 66.1%)",
  blue12: "hsl(206, 98.0%, 95.8%)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=blue.js.map


/***/ }),

/***/ 53869:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var blueA_exports = {};
__export(blueA_exports, {
  blueA: () => blueA
});
module.exports = __toCommonJS(blueA_exports);
const blueA = {
  blueA1: "hsla(0, 0%, 0%, 0)",
  blueA2: "hsla(221, 97.8%, 52.4%, 0.059)",
  blueA3: "hsla(215, 99.3%, 54.2%, 0.135)",
  blueA4: "hsla(215, 99.3%, 53.8%, 0.198)",
  blueA5: "hsla(213, 99.4%, 52.8%, 0.252)",
  blueA6: "hsla(212, 99.9%, 51.7%, 0.323)",
  blueA7: "hsla(211, 100%, 50.7%, 0.435)",
  blueA8: "hsla(211, 99.8%, 50.9%, 0.597)",
  blueA9: "hsla(205, 100%, 50.0%, 0.980)",
  blueA10: "hsla(208, 100%, 60.7%, 0.980)",
  blueA11: "hsla(209, 100%, 66.3%, 0.980)",
  blueA12: "hsla(196, 100%, 96.8%, 0.980)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=blueA.js.map


/***/ }),

/***/ 88098:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var bronze_exports = {};
__export(bronze_exports, {
  bronze: () => bronze
});
module.exports = __toCommonJS(bronze_exports);
const bronze = {
  bronze1: "hsl(17, 10.0%, 8.8%)",
  bronze2: "hsl(15, 14.8%, 10.6%)",
  bronze3: "hsl(15, 16.3%, 14.3%)",
  bronze4: "hsl(16, 17.1%, 17.2%)",
  bronze5: "hsl(16, 17.6%, 19.6%)",
  bronze6: "hsl(16, 18.1%, 22.9%)",
  bronze7: "hsl(17, 18.8%, 28.8%)",
  bronze8: "hsl(17, 19.6%, 38.0%)",
  bronze9: "hsl(17, 20.0%, 54.0%)",
  bronze10: "hsl(18, 24.0%, 59.0%)",
  bronze11: "hsl(18, 35.0%, 68.5%)",
  bronze12: "hsl(18, 57.0%, 94.1%)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=bronze.js.map


/***/ }),

/***/ 68495:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var bronzeA_exports = {};
__export(bronzeA_exports, {
  bronzeA: () => bronzeA
});
module.exports = __toCommonJS(bronzeA_exports);
const bronzeA = {
  bronzeA1: "hsla(0, 0%, 0%, 0)",
  bronzeA2: "hsla(20, 88.2%, 74.2%, 0.027)",
  bronzeA3: "hsla(10, 99.4%, 83.0%, 0.074)",
  bronzeA4: "hsla(18, 96.0%, 81.1%, 0.114)",
  bronzeA5: "hsla(18, 99.4%, 81.7%, 0.148)",
  bronzeA6: "hsla(15, 98.1%, 82.4%, 0.192)",
  bronzeA7: "hsla(16, 99.2%, 82.9%, 0.270)",
  bronzeA8: "hsla(18, 99.5%, 82.6%, 0.396)",
  bronzeA9: "hsla(18, 99.3%, 85.0%, 0.592)",
  bronzeA10: "hsla(18, 99.6%, 85.2%, 0.657)",
  bronzeA11: "hsla(17, 99.9%, 86.1%, 0.774)",
  bronzeA12: "hsla(20, 99.8%, 96.4%, 0.974)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=bronzeA.js.map


/***/ }),

/***/ 6675:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var brown_exports = {};
__export(brown_exports, {
  brown: () => brown
});
module.exports = __toCommonJS(brown_exports);
const brown = {
  brown1: "hsl(22, 15.0%, 8.7%)",
  brown2: "hsl(20, 28.3%, 10.4%)",
  brown3: "hsl(20, 28.0%, 14.0%)",
  brown4: "hsl(21, 28.4%, 16.5%)",
  brown5: "hsl(22, 28.7%, 18.9%)",
  brown6: "hsl(23, 29.0%, 22.3%)",
  brown7: "hsl(25, 29.5%, 27.8%)",
  brown8: "hsl(27, 30.1%, 35.9%)",
  brown9: "hsl(28, 34.0%, 51.0%)",
  brown10: "hsl(28, 41.4%, 55.8%)",
  brown11: "hsl(28, 60.0%, 64.5%)",
  brown12: "hsl(30, 67.0%, 94.0%)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=brown.js.map


/***/ }),

/***/ 38378:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var brownA_exports = {};
__export(brownA_exports, {
  brownA: () => brownA
});
module.exports = __toCommonJS(brownA_exports);
const brownA = {
  brownA1: "hsla(0, 0%, 0%, 0)",
  brownA2: "hsla(22, 99.6%, 53.6%, 0.035)",
  brownA3: "hsla(18, 97.8%, 69.0%, 0.088)",
  brownA4: "hsla(21, 98.2%, 71.0%, 0.123)",
  brownA5: "hsla(25, 98.4%, 72.1%, 0.158)",
  brownA6: "hsla(25, 98.7%, 73.5%, 0.206)",
  brownA7: "hsla(25, 99.0%, 74.6%, 0.289)",
  brownA8: "hsla(28, 99.2%, 75.3%, 0.407)",
  brownA9: "hsla(28, 100%, 74.8%, 0.642)",
  brownA10: "hsla(28, 99.9%, 74.9%, 0.712)",
  brownA11: "hsla(28, 99.9%, 74.9%, 0.843)",
  brownA12: "hsla(32, 98.2%, 95.7%, 0.979)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=brownA.js.map


/***/ }),

/***/ 31076:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var crimson_exports = {};
__export(crimson_exports, {
  crimson: () => crimson
});
module.exports = __toCommonJS(crimson_exports);
const crimson = {
  crimson1: "hsl(335, 20.0%, 9.6%)",
  crimson2: "hsl(335, 32.2%, 11.6%)",
  crimson3: "hsl(335, 42.5%, 16.5%)",
  crimson4: "hsl(335, 47.2%, 19.3%)",
  crimson5: "hsl(335, 50.9%, 21.8%)",
  crimson6: "hsl(335, 55.7%, 25.3%)",
  crimson7: "hsl(336, 62.9%, 30.8%)",
  crimson8: "hsl(336, 74.9%, 39.0%)",
  crimson9: "hsl(336, 80.0%, 57.8%)",
  crimson10: "hsl(339, 84.1%, 62.6%)",
  crimson11: "hsl(341, 90.0%, 67.3%)",
  crimson12: "hsl(332, 87.0%, 96.0%)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=crimson.js.map


/***/ }),

/***/ 64396:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var crimsonA_exports = {};
__export(crimsonA_exports, {
  crimsonA: () => crimsonA
});
module.exports = __toCommonJS(crimsonA_exports);
const crimsonA = {
  crimsonA1: "hsla(0, 0%, 0%, 0)",
  crimsonA2: "hsla(336, 96.8%, 53.2%, 0.045)",
  crimsonA3: "hsla(335, 98.7%, 59.3%, 0.138)",
  crimsonA4: "hsla(336, 99.1%, 59.9%, 0.191)",
  crimsonA5: "hsla(335, 99.4%, 59.4%, 0.244)",
  crimsonA6: "hsla(335, 99.4%, 59.4%, 0.315)",
  crimsonA7: "hsla(336, 99.5%, 57.8%, 0.439)",
  crimsonA8: "hsla(336, 99.9%, 55.4%, 0.642)",
  crimsonA9: "hsla(336, 99.9%, 62.8%, 0.903)",
  crimsonA10: "hsla(339, 99.9%, 66.3%, 0.934)",
  crimsonA11: "hsla(341, 99.9%, 69.5%, 0.965)",
  crimsonA12: "hsla(327, 100%, 97.1%, 0.980)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=crimsonA.js.map


/***/ }),

/***/ 20201:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var cyan_exports = {};
__export(cyan_exports, {
  cyan: () => cyan
});
module.exports = __toCommonJS(cyan_exports);
const cyan = {
  cyan1: "hsl(192, 60.0%, 7.2%)",
  cyan2: "hsl(192, 71.4%, 8.2%)",
  cyan3: "hsl(192, 75.9%, 10.8%)",
  cyan4: "hsl(192, 79.3%, 12.8%)",
  cyan5: "hsl(192, 82.5%, 14.6%)",
  cyan6: "hsl(192, 86.6%, 16.9%)",
  cyan7: "hsl(192, 92.6%, 20.1%)",
  cyan8: "hsl(192, 100%, 24.5%)",
  cyan9: "hsl(190, 95.0%, 39.0%)",
  cyan10: "hsl(188, 100%, 40.0%)",
  cyan11: "hsl(186, 100%, 42.2%)",
  cyan12: "hsl(185, 73.0%, 93.2%)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=cyan.js.map


/***/ }),

/***/ 7878:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var cyanA_exports = {};
__export(cyanA_exports, {
  cyanA: () => cyanA
});
module.exports = __toCommonJS(cyanA_exports);
const cyanA = {
  cyanA1: "hsla(0, 0%, 0%, 0)",
  cyanA2: "hsla(196, 100%, 50.0%, 0.031)",
  cyanA3: "hsla(192, 98.0%, 50.9%, 0.085)",
  cyanA4: "hsla(194, 99.6%, 51.3%, 0.133)",
  cyanA5: "hsla(192, 99.5%, 51.3%, 0.173)",
  cyanA6: "hsla(193, 99.7%, 50.4%, 0.226)",
  cyanA7: "hsla(192, 100%, 50.0%, 0.310)",
  cyanA8: "hsla(193, 100%, 50.0%, 0.425)",
  cyanA9: "hsla(190, 99.8%, 50.8%, 0.731)",
  cyanA10: "hsla(188, 100%, 50.0%, 0.775)",
  cyanA11: "hsla(186, 100%, 49.9%, 0.824)",
  cyanA12: "hsla(185, 99.8%, 95.1%, 0.978)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=cyanA.js.map


/***/ }),

/***/ 3199:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var gold_exports = {};
__export(gold_exports, {
  gold: () => gold
});
module.exports = __toCommonJS(gold_exports);
const gold = {
  gold1: "hsl(44, 9.0%, 8.3%)",
  gold2: "hsl(43, 14.3%, 9.6%)",
  gold3: "hsl(42, 15.5%, 13.0%)",
  gold4: "hsl(41, 16.4%, 15.6%)",
  gold5: "hsl(41, 16.9%, 17.8%)",
  gold6: "hsl(40, 17.6%, 20.8%)",
  gold7: "hsl(38, 18.5%, 26.4%)",
  gold8: "hsl(36, 19.6%, 35.1%)",
  gold9: "hsl(36, 20.0%, 49.5%)",
  gold10: "hsl(36, 22.3%, 54.5%)",
  gold11: "hsl(35, 30.0%, 64.0%)",
  gold12: "hsl(49, 52.0%, 93.8%)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=gold.js.map


/***/ }),

/***/ 67948:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var goldA_exports = {};
__export(goldA_exports, {
  goldA: () => goldA
});
module.exports = __toCommonJS(goldA_exports);
const goldA = {
  goldA1: "hsla(0, 0%, 0%, 0)",
  goldA2: "hsla(40, 93.7%, 70.6%, 0.022)",
  goldA3: "hsla(40, 97.5%, 80.6%, 0.065)",
  goldA4: "hsla(40, 95.9%, 80.8%, 0.100)",
  goldA5: "hsla(38, 97.3%, 82.1%, 0.130)",
  goldA6: "hsla(39, 97.2%, 82.5%, 0.169)",
  goldA7: "hsla(37, 99.3%, 82.4%, 0.246)",
  goldA8: "hsla(35, 98.7%, 82.2%, 0.363)",
  goldA9: "hsla(36, 99.7%, 82.8%, 0.552)",
  goldA10: "hsla(35, 99.2%, 83.7%, 0.613)",
  goldA11: "hsla(35, 99.3%, 85.3%, 0.725)",
  goldA12: "hsla(49, 98.6%, 96.7%, 0.966)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=goldA.js.map


/***/ }),

/***/ 63641:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var grass_exports = {};
__export(grass_exports, {
  grass: () => grass
});
module.exports = __toCommonJS(grass_exports);
const grass = {
  grass1: "hsl(146, 30.0%, 7.4%)",
  grass2: "hsl(136, 33.3%, 8.8%)",
  grass3: "hsl(137, 36.0%, 11.4%)",
  grass4: "hsl(137, 37.6%, 13.7%)",
  grass5: "hsl(136, 38.7%, 16.0%)",
  grass6: "hsl(135, 39.6%, 19.1%)",
  grass7: "hsl(134, 40.3%, 23.8%)",
  grass8: "hsl(131, 40.1%, 30.8%)",
  grass9: "hsl(131, 41.0%, 46.5%)",
  grass10: "hsl(131, 39.0%, 52.1%)",
  grass11: "hsl(131, 43.0%, 57.2%)",
  grass12: "hsl(137, 72.0%, 94.0%)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=grass.js.map


/***/ }),

/***/ 73841:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var grassA_exports = {};
__export(grassA_exports, {
  grassA: () => grassA
});
module.exports = __toCommonJS(grassA_exports);
const grassA = {
  grassA1: "hsla(0, 0%, 0%, 0)",
  grassA2: "hsla(107, 97.2%, 61.9%, 0.022)",
  grassA3: "hsla(128, 96.5%, 69.8%, 0.066)",
  grassA4: "hsla(130, 100%, 70.2%, 0.100)",
  grassA5: "hsla(130, 98.2%, 69.1%, 0.140)",
  grassA6: "hsla(132, 99.9%, 69.3%, 0.187)",
  grassA7: "hsla(132, 99.9%, 69.8%, 0.261)",
  grassA8: "hsla(130, 99.6%, 70.5%, 0.370)",
  grassA9: "hsla(130, 99.7%, 70.6%, 0.618)",
  grassA10: "hsla(131, 100%, 73.5%, 0.674)",
  grassA11: "hsla(130, 99.7%, 75.6%, 0.731)",
  grassA12: "hsla(137, 100%, 95.8%, 0.980)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=grassA.js.map


/***/ }),

/***/ 95356:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var gray_exports = {};
__export(gray_exports, {
  gray: () => gray
});
module.exports = __toCommonJS(gray_exports);
const gray = {
  gray1: "hsl(0, 0%, 8.5%)",
  gray2: "hsl(0, 0%, 11.0%)",
  gray3: "hsl(0, 0%, 13.6%)",
  gray4: "hsl(0, 0%, 15.8%)",
  gray5: "hsl(0, 0%, 17.9%)",
  gray6: "hsl(0, 0%, 20.5%)",
  gray7: "hsl(0, 0%, 24.3%)",
  gray8: "hsl(0, 0%, 31.2%)",
  gray9: "hsl(0, 0%, 43.9%)",
  gray10: "hsl(0, 0%, 49.4%)",
  gray11: "hsl(0, 0%, 62.8%)",
  gray12: "hsl(0, 0%, 93.0%)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=gray.js.map


/***/ }),

/***/ 76446:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var grayA_exports = {};
__export(grayA_exports, {
  grayA: () => grayA
});
module.exports = __toCommonJS(grayA_exports);
const grayA = {
  grayA1: "hsla(0, 0%, 100%, 0)",
  grayA2: "hsla(0, 0%, 100%, 0.026)",
  grayA3: "hsla(0, 0%, 100%, 0.056)",
  grayA4: "hsla(0, 0%, 100%, 0.077)",
  grayA5: "hsla(0, 0%, 100%, 0.103)",
  grayA6: "hsla(0, 0%, 100%, 0.129)",
  grayA7: "hsla(0, 0%, 100%, 0.172)",
  grayA8: "hsla(0, 0%, 100%, 0.249)",
  grayA9: "hsla(0, 0%, 100%, 0.386)",
  grayA10: "hsla(0, 0%, 100%, 0.446)",
  grayA11: "hsla(0, 0%, 100%, 0.592)",
  grayA12: "hsla(0, 0%, 100%, 0.923)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=grayA.js.map


/***/ }),

/***/ 83783:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var green_exports = {};
__export(green_exports, {
  green: () => green
});
module.exports = __toCommonJS(green_exports);
const green = {
  green1: "hsl(146, 30.0%, 7.4%)",
  green2: "hsl(155, 44.2%, 8.4%)",
  green3: "hsl(155, 46.7%, 10.9%)",
  green4: "hsl(154, 48.4%, 12.9%)",
  green5: "hsl(154, 49.7%, 14.9%)",
  green6: "hsl(154, 50.9%, 17.6%)",
  green7: "hsl(153, 51.8%, 21.8%)",
  green8: "hsl(151, 51.7%, 28.4%)",
  green9: "hsl(151, 55.0%, 41.5%)",
  green10: "hsl(151, 49.3%, 46.5%)",
  green11: "hsl(151, 50.0%, 53.2%)",
  green12: "hsl(137, 72.0%, 94.0%)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=green.js.map


/***/ }),

/***/ 11626:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var greenA_exports = {};
__export(greenA_exports, {
  greenA: () => greenA
});
module.exports = __toCommonJS(greenA_exports);
const greenA = {
  greenA1: "hsla(0, 0%, 0%, 0)",
  greenA2: "hsla(169, 100%, 48.5%, 0.027)",
  greenA3: "hsla(162, 98.7%, 57.9%, 0.070)",
  greenA4: "hsla(158, 98.6%, 59.7%, 0.105)",
  greenA5: "hsla(158, 98.6%, 60.7%, 0.140)",
  greenA6: "hsla(156, 99.9%, 62.0%, 0.187)",
  greenA7: "hsla(154, 99.5%, 63.1%, 0.257)",
  greenA8: "hsla(152, 99.7%, 64.2%, 0.370)",
  greenA9: "hsla(151, 99.7%, 63.8%, 0.605)",
  greenA10: "hsla(152, 99.9%, 66.5%, 0.661)",
  greenA11: "hsla(151, 99.7%, 69.2%, 0.740)",
  greenA12: "hsla(137, 100%, 95.8%, 0.980)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=greenA.js.map


/***/ }),

/***/ 22501:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var indigo_exports = {};
__export(indigo_exports, {
  indigo: () => indigo
});
module.exports = __toCommonJS(indigo_exports);
const indigo = {
  indigo1: "hsl(229, 24.0%, 10.0%)",
  indigo2: "hsl(230, 36.4%, 12.9%)",
  indigo3: "hsl(228, 43.3%, 17.5%)",
  indigo4: "hsl(227, 47.2%, 21.0%)",
  indigo5: "hsl(227, 50.0%, 24.1%)",
  indigo6: "hsl(226, 52.9%, 28.2%)",
  indigo7: "hsl(226, 56.0%, 34.5%)",
  indigo8: "hsl(226, 58.2%, 44.1%)",
  indigo9: "hsl(226, 70.0%, 55.5%)",
  indigo10: "hsl(227, 75.2%, 61.6%)",
  indigo11: "hsl(228, 100%, 75.9%)",
  indigo12: "hsl(226, 83.0%, 96.3%)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=indigo.js.map


/***/ }),

/***/ 85639:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var indigoA_exports = {};
__export(indigoA_exports, {
  indigoA: () => indigoA
});
module.exports = __toCommonJS(indigoA_exports);
const indigoA = {
  indigoA1: "hsla(0, 0%, 0%, 0)",
  indigoA2: "hsla(234, 97.4%, 59.9%, 0.059)",
  indigoA3: "hsla(228, 99.2%, 61.7%, 0.144)",
  indigoA4: "hsla(227, 99.7%, 62.0%, 0.211)",
  indigoA5: "hsla(227, 99.2%, 62.3%, 0.270)",
  indigoA6: "hsla(226, 99.9%, 62.1%, 0.350)",
  indigoA7: "hsla(226, 99.9%, 62.0%, 0.471)",
  indigoA8: "hsla(226, 99.9%, 62.1%, 0.655)",
  indigoA9: "hsla(226, 99.9%, 63.6%, 0.848)",
  indigoA10: "hsla(227, 99.8%, 67.7%, 0.893)",
  indigoA11: "hsla(227, 100%, 76.3%, 0.980)",
  indigoA12: "hsla(226, 100%, 97.5%, 0.980)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=indigoA.js.map


/***/ }),

/***/ 77727:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var lime_exports = {};
__export(lime_exports, {
  lime: () => lime
});
module.exports = __toCommonJS(lime_exports);
const lime = {
  lime1: "hsl(75, 55.0%, 6.0%)",
  lime2: "hsl(74, 56.8%, 7.3%)",
  lime3: "hsl(78, 50.2%, 9.9%)",
  lime4: "hsl(79, 50.3%, 12.1%)",
  lime5: "hsl(79, 52.6%, 14.2%)",
  lime6: "hsl(78, 55.7%, 16.7%)",
  lime7: "hsl(77, 59.7%, 20.1%)",
  lime8: "hsl(75, 64.8%, 24.5%)",
  lime9: "hsl(81, 67.0%, 50.0%)",
  lime10: "hsl(75, 85.0%, 60.0%)",
  lime11: "hsl(81, 70.0%, 43.8%)",
  lime12: "hsl(84, 79.0%, 92.6%)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=lime.js.map


/***/ }),

/***/ 32600:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var limeA_exports = {};
__export(limeA_exports, {
  limeA: () => limeA
});
module.exports = __toCommonJS(limeA_exports);
const limeA = {
  limeA1: "hsla(0, 0%, 0%, 0)",
  limeA2: "hsla(75, 96.4%, 59.6%, 0.022)",
  limeA3: "hsla(88, 98.0%, 70.4%, 0.061)",
  limeA4: "hsla(81, 97.8%, 67.4%, 0.096)",
  limeA5: "hsla(82, 98.4%, 65.6%, 0.135)",
  limeA6: "hsla(79, 99.7%, 64.3%, 0.182)",
  limeA7: "hsla(77, 99.1%, 62.1%, 0.252)",
  limeA8: "hsla(75, 100%, 60.0%, 0.342)",
  limeA9: "hsla(81, 99.8%, 59.7%, 0.819)",
  limeA10: "hsla(75, 99.8%, 63.7%, 0.936)",
  limeA11: "hsla(81, 99.9%, 58.7%, 0.719)",
  limeA12: "hsla(83, 100%, 94.2%, 0.980)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=limeA.js.map


/***/ }),

/***/ 2178:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var mauve_exports = {};
__export(mauve_exports, {
  mauve: () => mauve
});
module.exports = __toCommonJS(mauve_exports);
const mauve = {
  mauve1: "hsl(246, 6.0%, 9.0%)",
  mauve2: "hsl(240, 5.1%, 11.6%)",
  mauve3: "hsl(241, 5.0%, 14.3%)",
  mauve4: "hsl(242, 4.9%, 16.5%)",
  mauve5: "hsl(243, 4.9%, 18.8%)",
  mauve6: "hsl(244, 4.9%, 21.5%)",
  mauve7: "hsl(245, 4.9%, 25.4%)",
  mauve8: "hsl(247, 4.8%, 32.5%)",
  mauve9: "hsl(252, 4.0%, 45.2%)",
  mauve10: "hsl(247, 3.4%, 50.7%)",
  mauve11: "hsl(253, 4.0%, 63.7%)",
  mauve12: "hsl(256, 6.0%, 93.2%)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=mauve.js.map


/***/ }),

/***/ 67548:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var mauveA_exports = {};
__export(mauveA_exports, {
  mauveA: () => mauveA
});
module.exports = __toCommonJS(mauveA_exports);
const mauveA = {
  mauveA1: "hsla(0, 0%, 0%, 0)",
  mauveA2: "hsla(240, 76.7%, 91.2%, 0.031)",
  mauveA3: "hsla(240, 86.0%, 95.8%, 0.061)",
  mauveA4: "hsla(240, 91.8%, 94.7%, 0.087)",
  mauveA5: "hsla(240, 91.5%, 95.8%, 0.113)",
  mauveA6: "hsla(240, 92.0%, 93.8%, 0.148)",
  mauveA7: "hsla(240, 94.8%, 95.3%, 0.191)",
  mauveA8: "hsla(249, 98.1%, 95.2%, 0.273)",
  mauveA9: "hsla(248, 97.6%, 96.2%, 0.416)",
  mauveA10: "hsla(248, 95.5%, 96.6%, 0.477)",
  mauveA11: "hsla(250, 98.0%, 98.0%, 0.615)",
  mauveA12: "hsla(240, 93.9%, 99.6%, 0.931)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=mauveA.js.map


/***/ }),

/***/ 87202:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var mint_exports = {};
__export(mint_exports, {
  mint: () => mint
});
module.exports = __toCommonJS(mint_exports);
const mint = {
  mint1: "hsl(173, 50.0%, 6.6%)",
  mint2: "hsl(176, 73.0%, 7.3%)",
  mint3: "hsl(175, 79.3%, 8.9%)",
  mint4: "hsl(174, 84.8%, 10.3%)",
  mint5: "hsl(174, 90.2%, 11.9%)",
  mint6: "hsl(173, 96.0%, 13.8%)",
  mint7: "hsl(172, 100%, 16.8%)",
  mint8: "hsl(170, 100%, 21.4%)",
  mint9: "hsl(167, 65.0%, 66.0%)",
  mint10: "hsl(163, 80.0%, 77.0%)",
  mint11: "hsl(167, 70.0%, 48.0%)",
  mint12: "hsl(165, 80.0%, 94.8%)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=mint.js.map


/***/ }),

/***/ 28245:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var mintA_exports = {};
__export(mintA_exports, {
  mintA: () => mintA
});
module.exports = __toCommonJS(mintA_exports);
const mintA = {
  mintA1: "hsla(0, 0%, 0%, 0)",
  mintA2: "hsla(180, 100%, 49.2%, 0.031)",
  mintA3: "hsla(176, 100%, 49.7%, 0.070)",
  mintA4: "hsla(173, 100%, 49.7%, 0.105)",
  mintA5: "hsla(173, 100%, 49.8%, 0.144)",
  mintA6: "hsla(172, 100%, 49.8%, 0.192)",
  mintA7: "hsla(171, 100%, 49.9%, 0.266)",
  mintA8: "hsla(169, 100%, 49.9%, 0.366)",
  mintA9: "hsla(167, 99.8%, 75.0%, 0.870)",
  mintA10: "hsla(163, 99.9%, 80.7%, 0.948)",
  mintA11: "hsla(167, 99.9%, 58.7%, 0.796)",
  mintA12: "hsla(169, 100%, 96.2%, 0.980)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=mintA.js.map


/***/ }),

/***/ 31106:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var olive_exports = {};
__export(olive_exports, {
  olive: () => olive
});
module.exports = __toCommonJS(olive_exports);
const olive = {
  olive1: "hsl(110, 5.0%, 8.6%)",
  olive2: "hsl(105, 7.4%, 10.6%)",
  olive3: "hsl(106, 6.4%, 13.1%)",
  olive4: "hsl(106, 5.8%, 15.3%)",
  olive5: "hsl(107, 5.3%, 17.4%)",
  olive6: "hsl(107, 4.9%, 19.9%)",
  olive7: "hsl(108, 4.4%, 23.6%)",
  olive8: "hsl(110, 3.8%, 30.6%)",
  olive9: "hsl(110, 6.0%, 42.5%)",
  olive10: "hsl(111, 4.8%, 48.2%)",
  olive11: "hsl(110, 5.0%, 61.8%)",
  olive12: "hsl(110, 6.0%, 93.0%)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=olive.js.map


/***/ }),

/***/ 87345:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var oliveA_exports = {};
__export(oliveA_exports, {
  oliveA: () => oliveA
});
module.exports = __toCommonJS(oliveA_exports);
const oliveA = {
  oliveA1: "hsla(0, 0%, 0%, 0)",
  oliveA2: "hsla(91, 97.0%, 84.0%, 0.026)",
  oliveA3: "hsla(101, 87.4%, 87.7%, 0.057)",
  oliveA4: "hsla(92, 91.8%, 94.1%, 0.078)",
  oliveA5: "hsla(101, 92.6%, 93.5%, 0.104)",
  oliveA6: "hsla(102, 91.1%, 94.6%, 0.130)",
  oliveA7: "hsla(102, 92.5%, 95.9%, 0.173)",
  oliveA8: "hsla(107, 100%, 96.5%, 0.250)",
  oliveA9: "hsla(110, 98.3%, 94.1%, 0.397)",
  oliveA10: "hsla(109, 99.6%, 95.3%, 0.457)",
  oliveA11: "hsla(113, 95.3%, 97.2%, 0.600)",
  oliveA12: "hsla(120, 93.5%, 99.6%, 0.927)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=oliveA.js.map


/***/ }),

/***/ 52185:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var orange_exports = {};
__export(orange_exports, {
  orange: () => orange
});
module.exports = __toCommonJS(orange_exports);
const orange = {
  orange1: "hsl(30, 70.0%, 7.2%)",
  orange2: "hsl(28, 100%, 8.4%)",
  orange3: "hsl(26, 91.1%, 11.6%)",
  orange4: "hsl(25, 88.3%, 14.1%)",
  orange5: "hsl(24, 87.6%, 16.6%)",
  orange6: "hsl(24, 88.6%, 19.8%)",
  orange7: "hsl(24, 92.4%, 24.0%)",
  orange8: "hsl(25, 100%, 29.0%)",
  orange9: "hsl(24, 94.0%, 50.0%)",
  orange10: "hsl(24, 100%, 58.5%)",
  orange11: "hsl(24, 100%, 62.2%)",
  orange12: "hsl(24, 97.0%, 93.2%)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=orange.js.map


/***/ }),

/***/ 83708:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var orangeA_exports = {};
__export(orangeA_exports, {
  orangeA: () => orangeA
});
module.exports = __toCommonJS(orangeA_exports);
const orangeA = {
  orangeA1: "hsla(0, 0%, 0%, 0)",
  orangeA2: "hsla(13, 100%, 49.7%, 0.054)",
  orangeA3: "hsla(20, 100%, 49.7%, 0.117)",
  orangeA4: "hsla(23, 100%, 49.8%, 0.166)",
  orangeA5: "hsla(23, 99.4%, 50.1%, 0.215)",
  orangeA6: "hsla(23, 99.8%, 51.1%, 0.286)",
  orangeA7: "hsla(23, 99.7%, 50.6%, 0.389)",
  orangeA8: "hsla(24, 100%, 49.9%, 0.523)",
  orangeA9: "hsla(24, 99.9%, 51.6%, 0.965)",
  orangeA10: "hsla(25, 100%, 58.6%, 0.980)",
  orangeA11: "hsla(24, 100%, 62.4%, 0.980)",
  orangeA12: "hsla(26, 100%, 94.2%, 0.980)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=orangeA.js.map


/***/ }),

/***/ 83978:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var pink_exports = {};
__export(pink_exports, {
  pink: () => pink
});
module.exports = __toCommonJS(pink_exports);
const pink = {
  pink1: "hsl(318, 25.0%, 9.6%)",
  pink2: "hsl(319, 32.2%, 11.6%)",
  pink3: "hsl(319, 41.0%, 16.0%)",
  pink4: "hsl(320, 45.4%, 18.7%)",
  pink5: "hsl(320, 49.0%, 21.1%)",
  pink6: "hsl(321, 53.6%, 24.4%)",
  pink7: "hsl(321, 61.1%, 29.7%)",
  pink8: "hsl(322, 74.9%, 37.5%)",
  pink9: "hsl(322, 65.0%, 54.5%)",
  pink10: "hsl(323, 72.8%, 59.2%)",
  pink11: "hsl(325, 90.0%, 66.4%)",
  pink12: "hsl(322, 90.0%, 95.8%)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=pink.js.map


/***/ }),

/***/ 16563:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var pinkA_exports = {};
__export(pinkA_exports, {
  pinkA: () => pinkA
});
module.exports = __toCommonJS(pinkA_exports);
const pinkA = {
  pinkA1: "hsla(0, 0%, 0%, 0)",
  pinkA2: "hsla(320, 98.1%, 64.1%, 0.036)",
  pinkA3: "hsla(320, 99.1%, 63.1%, 0.121)",
  pinkA4: "hsla(320, 99.5%, 62.7%, 0.170)",
  pinkA5: "hsla(319, 99.7%, 61.5%, 0.219)",
  pinkA6: "hsla(322, 99.4%, 60.8%, 0.291)",
  pinkA7: "hsla(321, 99.6%, 58.7%, 0.407)",
  pinkA8: "hsla(322, 99.7%, 55.4%, 0.608)",
  pinkA9: "hsla(322, 100%, 64.6%, 0.817)",
  pinkA10: "hsla(323, 100%, 66.3%, 0.875)",
  pinkA11: "hsla(325, 99.9%, 68.6%, 0.960)",
  pinkA12: "hsla(314, 100%, 96.9%, 0.980)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=pinkA.js.map


/***/ }),

/***/ 86166:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var plum_exports = {};
__export(plum_exports, {
  plum: () => plum
});
module.exports = __toCommonJS(plum_exports);
const plum = {
  plum1: "hsl(301, 20.0%, 9.4%)",
  plum2: "hsl(300, 29.8%, 11.2%)",
  plum3: "hsl(298, 34.4%, 15.3%)",
  plum4: "hsl(297, 36.8%, 18.3%)",
  plum5: "hsl(296, 38.5%, 21.1%)",
  plum6: "hsl(295, 40.4%, 24.7%)",
  plum7: "hsl(294, 42.7%, 30.6%)",
  plum8: "hsl(292, 45.1%, 40.0%)",
  plum9: "hsl(292, 45.0%, 51.0%)",
  plum10: "hsl(295, 50.0%, 55.4%)",
  plum11: "hsl(300, 60.0%, 62.0%)",
  plum12: "hsl(296, 74.0%, 95.7%)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=plum.js.map


/***/ }),

/***/ 80691:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var plumA_exports = {};
__export(plumA_exports, {
  plumA: () => plumA
});
module.exports = __toCommonJS(plumA_exports);
const plumA = {
  plumA1: "hsla(0, 0%, 0%, 0)",
  plumA2: "hsla(300, 96.4%, 58.4%, 0.036)",
  plumA3: "hsla(300, 99.4%, 67.1%, 0.102)",
  plumA4: "hsla(295, 99.8%, 66.3%, 0.155)",
  plumA5: "hsla(295, 99.4%, 67.1%, 0.204)",
  plumA6: "hsla(294, 99.0%, 67.8%, 0.262)",
  plumA7: "hsla(294, 99.9%, 67.7%, 0.363)",
  plumA8: "hsla(292, 99.8%, 67.5%, 0.527)",
  plumA9: "hsla(292, 99.9%, 69.2%, 0.695)",
  plumA10: "hsla(295, 99.9%, 70.8%, 0.748)",
  plumA11: "hsla(300, 99.8%, 72.9%, 0.828)",
  plumA12: "hsla(300, 100%, 97.1%, 0.980)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=plumA.js.map


/***/ }),

/***/ 72453:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var purple_exports = {};
__export(purple_exports, {
  purple: () => purple
});
module.exports = __toCommonJS(purple_exports);
const purple = {
  purple1: "hsl(284, 20.0%, 9.6%)",
  purple2: "hsl(283, 30.0%, 11.8%)",
  purple3: "hsl(281, 37.5%, 16.5%)",
  purple4: "hsl(280, 41.2%, 20.0%)",
  purple5: "hsl(279, 43.8%, 23.3%)",
  purple6: "hsl(277, 46.4%, 27.5%)",
  purple7: "hsl(275, 49.3%, 34.6%)",
  purple8: "hsl(272, 52.1%, 45.9%)",
  purple9: "hsl(272, 51.0%, 54.0%)",
  purple10: "hsl(273, 57.3%, 59.1%)",
  purple11: "hsl(275, 80.0%, 71.0%)",
  purple12: "hsl(279, 75.0%, 95.7%)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=purple.js.map


/***/ }),

/***/ 8262:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var purpleA_exports = {};
__export(purpleA_exports, {
  purpleA: () => purpleA
});
module.exports = __toCommonJS(purpleA_exports);
const purpleA = {
  purpleA1: "hsla(0, 0%, 0%, 0)",
  purpleA2: "hsla(280, 96.5%, 57.5%, 0.045)",
  purpleA3: "hsla(279, 98.7%, 62.8%, 0.129)",
  purpleA4: "hsla(279, 99.1%, 64.0%, 0.191)",
  purpleA5: "hsla(278, 99.8%, 64.2%, 0.248)",
  purpleA6: "hsla(276, 99.6%, 64.6%, 0.328)",
  purpleA7: "hsla(274, 99.9%, 64.6%, 0.456)",
  purpleA8: "hsla(272, 99.7%, 64.6%, 0.660)",
  purpleA9: "hsla(272, 99.9%, 69.1%, 0.748)",
  purpleA10: "hsla(273, 100%, 71.3%, 0.801)",
  purpleA11: "hsla(275, 99.9%, 75.3%, 0.934)",
  purpleA12: "hsla(286, 100%, 97.1%, 0.980)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=purpleA.js.map


/***/ }),

/***/ 15697:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var red_exports = {};
__export(red_exports, {
  red: () => red
});
module.exports = __toCommonJS(red_exports);
const red = {
  red1: "hsl(353, 23.0%, 9.8%)",
  red2: "hsl(357, 34.4%, 12.0%)",
  red3: "hsl(356, 43.4%, 16.4%)",
  red4: "hsl(356, 47.6%, 19.2%)",
  red5: "hsl(356, 51.1%, 21.9%)",
  red6: "hsl(356, 55.2%, 25.9%)",
  red7: "hsl(357, 60.2%, 31.8%)",
  red8: "hsl(358, 65.0%, 40.4%)",
  red9: "hsl(358, 75.0%, 59.0%)",
  red10: "hsl(358, 85.3%, 64.0%)",
  red11: "hsl(358, 100%, 69.5%)",
  red12: "hsl(351, 89.0%, 96.0%)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=red.js.map


/***/ }),

/***/ 10490:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var redA_exports = {};
__export(redA_exports, {
  redA: () => redA
});
module.exports = __toCommonJS(redA_exports);
const redA = {
  redA1: "hsla(0, 0%, 0%, 0)",
  redA2: "hsla(5, 98.5%, 53.8%, 0.045)",
  redA3: "hsla(359, 99.1%, 61.1%, 0.130)",
  redA4: "hsla(358, 98.8%, 61.0%, 0.184)",
  redA5: "hsla(357, 99.6%, 60.3%, 0.237)",
  redA6: "hsla(358, 99.6%, 60.3%, 0.322)",
  redA7: "hsla(357, 100%, 59.5%, 0.442)",
  redA8: "hsla(358, 99.8%, 59.1%, 0.621)",
  redA9: "hsla(358, 100%, 65.5%, 0.884)",
  redA10: "hsla(358, 100%, 67.5%, 0.942)",
  redA11: "hsla(358, 100%, 69.7%, 0.980)",
  redA12: "hsla(352, 100%, 97.1%, 0.980)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=redA.js.map


/***/ }),

/***/ 30739:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var sage_exports = {};
__export(sage_exports, {
  sage: () => sage
});
module.exports = __toCommonJS(sage_exports);
const sage = {
  sage1: "hsl(155, 7.0%, 8.4%)",
  sage2: "hsl(150, 7.4%, 10.6%)",
  sage3: "hsl(150, 6.7%, 13.1%)",
  sage4: "hsl(150, 6.4%, 15.3%)",
  sage5: "hsl(150, 6.1%, 17.4%)",
  sage6: "hsl(150, 5.8%, 19.9%)",
  sage7: "hsl(150, 5.5%, 23.6%)",
  sage8: "hsl(150, 5.1%, 30.6%)",
  sage9: "hsl(155, 6.0%, 42.5%)",
  sage10: "hsl(153, 4.8%, 48.2%)",
  sage11: "hsl(155, 5.0%, 61.8%)",
  sage12: "hsl(155, 6.0%, 93.0%)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=sage.js.map


/***/ }),

/***/ 4014:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var sageA_exports = {};
__export(sageA_exports, {
  sageA: () => sageA
});
module.exports = __toCommonJS(sageA_exports);
const sageA = {
  sageA1: "hsla(0, 0%, 0%, 0)",
  sageA2: "hsla(123, 94.4%, 91.4%, 0.026)",
  sageA3: "hsla(123, 82.9%, 91.0%, 0.057)",
  sageA4: "hsla(124, 97.9%, 94.5%, 0.082)",
  sageA5: "hsla(125, 90.0%, 95.2%, 0.104)",
  sageA6: "hsla(142, 95.1%, 94.8%, 0.134)",
  sageA7: "hsla(143, 92.8%, 95.7%, 0.173)",
  sageA8: "hsla(146, 94.7%, 95.3%, 0.255)",
  sageA9: "hsla(151, 98.2%, 94.4%, 0.397)",
  sageA10: "hsla(148, 99.5%, 95.5%, 0.457)",
  sageA11: "hsla(152, 95.1%, 97.3%, 0.600)",
  sageA12: "hsla(149, 93.3%, 99.6%, 0.927)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=sageA.js.map


/***/ }),

/***/ 24134:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var sand_exports = {};
__export(sand_exports, {
  sand: () => sand
});
module.exports = __toCommonJS(sand_exports);
const sand = {
  sand1: "hsl(61, 2.0%, 8.3%)",
  sand2: "hsl(60, 3.7%, 10.6%)",
  sand3: "hsl(58, 3.7%, 13.1%)",
  sand4: "hsl(57, 3.6%, 15.3%)",
  sand5: "hsl(56, 3.7%, 17.4%)",
  sand6: "hsl(55, 3.7%, 19.9%)",
  sand7: "hsl(53, 3.7%, 23.6%)",
  sand8: "hsl(50, 3.8%, 30.6%)",
  sand9: "hsl(50, 4.0%, 42.7%)",
  sand10: "hsl(52, 3.1%, 48.3%)",
  sand11: "hsl(50, 4.0%, 61.8%)",
  sand12: "hsl(56, 4.0%, 92.8%)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=sand.js.map


/***/ }),

/***/ 33643:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var sandA_exports = {};
__export(sandA_exports, {
  sandA: () => sandA
});
module.exports = __toCommonJS(sandA_exports);
const sandA = {
  sandA1: "hsla(0, 0%, 0%, 0)",
  sandA2: "hsla(60, 89.8%, 91.4%, 0.026)",
  sandA3: "hsla(60, 95.5%, 92.5%, 0.056)",
  sandA4: "hsla(60, 75.6%, 96.4%, 0.078)",
  sandA5: "hsla(60, 81.9%, 95.2%, 0.104)",
  sandA6: "hsla(41, 87.6%, 94.8%, 0.134)",
  sandA7: "hsla(60, 95.4%, 96.2%, 0.172)",
  sandA8: "hsla(49, 93.5%, 95.7%, 0.254)",
  sandA9: "hsla(52, 97.3%, 96.2%, 0.391)",
  sandA10: "hsla(52, 97.8%, 96.7%, 0.451)",
  sandA11: "hsla(51, 97.0%, 97.8%, 0.597)",
  sandA12: "hsla(60, 88.7%, 99.8%, 0.923)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=sandA.js.map


/***/ }),

/***/ 86510:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var sky_exports = {};
__export(sky_exports, {
  sky: () => sky
});
module.exports = __toCommonJS(sky_exports);
const sky = {
  sky1: "hsl(205, 45.0%, 8.6%)",
  sky2: "hsl(202, 71.4%, 9.6%)",
  sky3: "hsl(201, 74.6%, 12.2%)",
  sky4: "hsl(201, 77.4%, 14.4%)",
  sky5: "hsl(200, 80.3%, 16.5%)",
  sky6: "hsl(200, 84.1%, 18.9%)",
  sky7: "hsl(199, 90.2%, 22.1%)",
  sky8: "hsl(198, 100%, 26.1%)",
  sky9: "hsl(193, 98.0%, 70.0%)",
  sky10: "hsl(192, 100%, 77.0%)",
  sky11: "hsl(192, 85.0%, 55.8%)",
  sky12: "hsl(198, 98.0%, 95.8%)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=sky.js.map


/***/ }),

/***/ 12237:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var skyA_exports = {};
__export(skyA_exports, {
  skyA: () => skyA
});
module.exports = __toCommonJS(skyA_exports);
const skyA = {
  skyA1: "hsla(0, 0%, 0%, 0)",
  skyA2: "hsla(208, 100%, 49.8%, 0.045)",
  skyA3: "hsla(201, 100%, 49.8%, 0.099)",
  skyA4: "hsla(201, 100%, 50.0%, 0.148)",
  skyA5: "hsla(200, 100%, 49.8%, 0.198)",
  skyA6: "hsla(199, 100%, 49.9%, 0.256)",
  skyA7: "hsla(199, 100%, 49.9%, 0.337)",
  skyA8: "hsla(199, 100%, 50.0%, 0.453)",
  skyA9: "hsla(192, 100%, 70.8%, 0.980)",
  skyA10: "hsla(190, 100%, 77.6%, 0.980)",
  skyA11: "hsla(192, 99.9%, 59.6%, 0.924)",
  skyA12: "hsla(189, 100%, 96.8%, 0.980)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=skyA.js.map


/***/ }),

/***/ 23738:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var slate_exports = {};
__export(slate_exports, {
  slate: () => slate
});
module.exports = __toCommonJS(slate_exports);
const slate = {
  slate1: "hsl(200, 7.0%, 8.8%)",
  slate2: "hsl(195, 7.1%, 11.0%)",
  slate3: "hsl(197, 6.8%, 13.6%)",
  slate4: "hsl(198, 6.6%, 15.8%)",
  slate5: "hsl(199, 6.4%, 17.9%)",
  slate6: "hsl(201, 6.2%, 20.5%)",
  slate7: "hsl(203, 6.0%, 24.3%)",
  slate8: "hsl(207, 5.6%, 31.6%)",
  slate9: "hsl(206, 6.0%, 43.9%)",
  slate10: "hsl(206, 5.2%, 49.5%)",
  slate11: "hsl(206, 6.0%, 63.0%)",
  slate12: "hsl(210, 6.0%, 93.0%)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=slate.js.map


/***/ }),

/***/ 31606:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var slateA_exports = {};
__export(slateA_exports, {
  slateA: () => slateA
});
module.exports = __toCommonJS(slateA_exports);
const slateA = {
  slateA1: "hsla(0, 0%, 0%, 0)",
  slateA2: "hsla(181, 98.9%, 91.8%, 0.026)",
  slateA3: "hsla(182, 86.7%, 91.4%, 0.057)",
  slateA4: "hsla(209, 86.7%, 93.9%, 0.083)",
  slateA5: "hsla(200, 90.3%, 93.4%, 0.109)",
  slateA6: "hsla(209, 95.3%, 93.5%, 0.139)",
  slateA7: "hsla(204, 98.5%, 93.9%, 0.182)",
  slateA8: "hsla(209, 94.0%, 94.7%, 0.265)",
  slateA9: "hsla(207, 97.3%, 94.0%, 0.412)",
  slateA10: "hsla(209, 99.4%, 95.2%, 0.472)",
  slateA11: "hsla(208, 98.7%, 96.8%, 0.615)",
  slateA12: "hsla(211, 86.7%, 99.6%, 0.927)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=slateA.js.map


/***/ }),

/***/ 78524:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var teal_exports = {};
__export(teal_exports, {
  teal: () => teal
});
module.exports = __toCommonJS(teal_exports);
const teal = {
  teal1: "hsl(168, 48.0%, 6.5%)",
  teal2: "hsl(169, 77.8%, 7.1%)",
  teal3: "hsl(170, 76.1%, 9.2%)",
  teal4: "hsl(171, 75.8%, 11.0%)",
  teal5: "hsl(171, 75.7%, 12.8%)",
  teal6: "hsl(172, 75.8%, 15.1%)",
  teal7: "hsl(172, 76.7%, 18.6%)",
  teal8: "hsl(173, 80.2%, 23.7%)",
  teal9: "hsl(173, 80.0%, 36.0%)",
  teal10: "hsl(174, 83.9%, 38.2%)",
  teal11: "hsl(174, 90.0%, 40.7%)",
  teal12: "hsl(166, 73.0%, 93.1%)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=teal.js.map


/***/ }),

/***/ 96486:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var tealA_exports = {};
__export(tealA_exports, {
  tealA: () => tealA
});
module.exports = __toCommonJS(tealA_exports);
const tealA = {
  tealA1: "hsla(0, 0%, 0%, 0)",
  tealA2: "hsla(171, 100%, 49.2%, 0.031)",
  tealA3: "hsla(172, 100%, 49.7%, 0.070)",
  tealA4: "hsla(175, 100%, 49.7%, 0.105)",
  tealA5: "hsla(174, 98.9%, 50.1%, 0.140)",
  tealA6: "hsla(174, 100%, 51.8%, 0.187)",
  tealA7: "hsla(173, 99.6%, 53.2%, 0.257)",
  tealA8: "hsla(174, 99.6%, 53.3%, 0.366)",
  tealA9: "hsla(173, 99.9%, 54.6%, 0.609)",
  tealA10: "hsla(174, 99.9%, 53.8%, 0.670)",
  tealA11: "hsla(174, 100%, 52.0%, 0.748)",
  tealA12: "hsla(166, 98.6%, 95.0%, 0.979)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=tealA.js.map


/***/ }),

/***/ 22318:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var tomato_exports = {};
__export(tomato_exports, {
  tomato: () => tomato
});
module.exports = __toCommonJS(tomato_exports);
const tomato = {
  tomato1: "hsl(10, 23.0%, 9.4%)",
  tomato2: "hsl(9, 44.8%, 11.4%)",
  tomato3: "hsl(8, 52.0%, 15.3%)",
  tomato4: "hsl(7, 56.3%, 18.0%)",
  tomato5: "hsl(7, 60.1%, 20.6%)",
  tomato6: "hsl(8, 64.8%, 24.0%)",
  tomato7: "hsl(8, 71.2%, 29.1%)",
  tomato8: "hsl(10, 80.2%, 35.7%)",
  tomato9: "hsl(10, 78.0%, 54.0%)",
  tomato10: "hsl(10, 81.7%, 59.0%)",
  tomato11: "hsl(10, 85.0%, 62.8%)",
  tomato12: "hsl(10, 89.0%, 96.0%)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=tomato.js.map


/***/ }),

/***/ 89601:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var tomatoA_exports = {};
__export(tomatoA_exports, {
  tomatoA: () => tomatoA
});
module.exports = __toCommonJS(tomatoA_exports);
const tomatoA = {
  tomatoA1: "hsla(0, 0%, 0%, 0)",
  tomatoA2: "hsla(5, 100%, 49.6%, 0.058)",
  tomatoA3: "hsla(6, 99.6%, 54.9%, 0.133)",
  tomatoA4: "hsla(6, 99.2%, 55.4%, 0.191)",
  tomatoA5: "hsla(6, 99.5%, 55.8%, 0.244)",
  tomatoA6: "hsla(7, 99.7%, 55.9%, 0.319)",
  tomatoA7: "hsla(8, 99.8%, 54.8%, 0.434)",
  tomatoA8: "hsla(10, 99.8%, 53.5%, 0.598)",
  tomatoA9: "hsla(10, 100%, 59.7%, 0.885)",
  tomatoA10: "hsla(10, 100%, 63.6%, 0.916)",
  tomatoA11: "hsla(10, 99.7%, 66.4%, 0.939)",
  tomatoA12: "hsla(12, 100%, 97.1%, 0.980)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=tomatoA.js.map


/***/ }),

/***/ 79852:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var violet_exports = {};
__export(violet_exports, {
  violet: () => violet
});
module.exports = __toCommonJS(violet_exports);
const violet = {
  violet1: "hsl(250, 20.0%, 10.2%)",
  violet2: "hsl(255, 30.3%, 12.9%)",
  violet3: "hsl(253, 37.0%, 18.4%)",
  violet4: "hsl(252, 40.1%, 22.5%)",
  violet5: "hsl(252, 42.2%, 26.2%)",
  violet6: "hsl(251, 44.3%, 31.1%)",
  violet7: "hsl(250, 46.8%, 38.9%)",
  violet8: "hsl(250, 51.8%, 51.2%)",
  violet9: "hsl(252, 56.0%, 57.5%)",
  violet10: "hsl(251, 63.2%, 63.2%)",
  violet11: "hsl(250, 95.0%, 76.8%)",
  violet12: "hsl(252, 87.0%, 96.4%)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=violet.js.map


/***/ }),

/***/ 24243:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var violetA_exports = {};
__export(violetA_exports, {
  violetA: () => violetA
});
module.exports = __toCommonJS(violetA_exports);
const violetA = {
  violetA1: "hsla(0, 0%, 0%, 0)",
  violetA2: "hsla(258, 98.2%, 61.0%, 0.054)",
  violetA3: "hsla(252, 98.8%, 65.8%, 0.148)",
  violetA4: "hsla(253, 99.7%, 65.7%, 0.219)",
  violetA5: "hsla(252, 99.7%, 66.4%, 0.286)",
  violetA6: "hsla(251, 99.7%, 66.2%, 0.371)",
  violetA7: "hsla(250, 99.7%, 66.3%, 0.514)",
  violetA8: "hsla(250, 99.7%, 66.1%, 0.733)",
  violetA9: "hsla(252, 99.9%, 70.3%, 0.786)",
  violetA10: "hsla(251, 99.9%, 72.9%, 0.844)",
  violetA11: "hsla(250, 100%, 77.9%, 0.980)",
  violetA12: "hsla(254, 100%, 97.5%, 0.980)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=violetA.js.map


/***/ }),

/***/ 43170:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var yellow_exports = {};
__export(yellow_exports, {
  yellow: () => yellow
});
module.exports = __toCommonJS(yellow_exports);
const yellow = {
  yellow1: "hsl(45, 100%, 5.5%)",
  yellow2: "hsl(46, 100%, 6.7%)",
  yellow3: "hsl(45, 100%, 8.7%)",
  yellow4: "hsl(45, 100%, 10.4%)",
  yellow5: "hsl(47, 100%, 12.1%)",
  yellow6: "hsl(49, 100%, 14.3%)",
  yellow7: "hsl(49, 90.3%, 18.4%)",
  yellow8: "hsl(50, 100%, 22.0%)",
  yellow9: "hsl(53, 92.0%, 50.0%)",
  yellow10: "hsl(54, 100%, 68.0%)",
  yellow11: "hsl(48, 100%, 47.0%)",
  yellow12: "hsl(53, 100%, 91.0%)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=yellow.js.map


/***/ }),

/***/ 91567:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var yellowA_exports = {};
__export(yellowA_exports, {
  yellowA: () => yellowA
});
module.exports = __toCommonJS(yellowA_exports);
const yellowA = {
  yellowA1: "hsla(0, 0%, 0%, 0)",
  yellowA2: "hsla(49, 100%, 49.1%, 0.027)",
  yellowA3: "hsla(45, 100%, 49.7%, 0.071)",
  yellowA4: "hsla(46, 100%, 49.7%, 0.111)",
  yellowA5: "hsla(47, 100%, 49.9%, 0.150)",
  yellowA6: "hsla(51, 100%, 49.8%, 0.199)",
  yellowA7: "hsla(51, 99.8%, 53.6%, 0.269)",
  yellowA8: "hsla(51, 100%, 49.9%, 0.371)",
  yellowA9: "hsla(53, 100%, 52.0%, 0.956)",
  yellowA10: "hsla(56, 100%, 68.4%, 0.980)",
  yellowA11: "hsla(48, 100%, 50.0%, 0.934)",
  yellowA12: "hsla(60, 100%, 91.8%, 0.980)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=yellowA.js.map


/***/ }),

/***/ 22643:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var src_exports = {};
__export(src_exports, {
  amber: () => import_amber2.amber,
  amberA: () => import_amberA2.amberA,
  amberDark: () => import_amber.amber,
  amberDarkA: () => import_amberA.amberA,
  blackA: () => import_blackA.blackA,
  blue: () => import_blue2.blue,
  blueA: () => import_blueA2.blueA,
  blueDark: () => import_blue.blue,
  blueDarkA: () => import_blueA.blueA,
  bronze: () => import_bronze2.bronze,
  bronzeA: () => import_bronzeA2.bronzeA,
  bronzeDark: () => import_bronze.bronze,
  bronzeDarkA: () => import_bronzeA.bronzeA,
  brown: () => import_brown2.brown,
  brownA: () => import_brownA2.brownA,
  brownDark: () => import_brown.brown,
  brownDarkA: () => import_brownA.brownA,
  crimson: () => import_crimson2.crimson,
  crimsonA: () => import_crimsonA2.crimsonA,
  crimsonDark: () => import_crimson.crimson,
  crimsonDarkA: () => import_crimsonA.crimsonA,
  cyan: () => import_cyan2.cyan,
  cyanA: () => import_cyanA2.cyanA,
  cyanDark: () => import_cyan.cyan,
  cyanDarkA: () => import_cyanA.cyanA,
  gold: () => import_gold2.gold,
  goldA: () => import_goldA2.goldA,
  goldDark: () => import_gold.gold,
  goldDarkA: () => import_goldA.goldA,
  grass: () => import_grass2.grass,
  grassA: () => import_grassA2.grassA,
  grassDark: () => import_grass.grass,
  grassDarkA: () => import_grassA.grassA,
  gray: () => import_gray2.gray,
  grayA: () => import_grayA2.grayA,
  grayDark: () => import_gray.gray,
  grayDarkA: () => import_grayA.grayA,
  green: () => import_green2.green,
  greenA: () => import_greenA2.greenA,
  greenDark: () => import_green.green,
  greenDarkA: () => import_greenA.greenA,
  indigo: () => import_indigo2.indigo,
  indigoA: () => import_indigoA2.indigoA,
  indigoDark: () => import_indigo.indigo,
  indigoDarkA: () => import_indigoA.indigoA,
  lime: () => import_lime2.lime,
  limeA: () => import_limeA2.limeA,
  limeDark: () => import_lime.lime,
  limeDarkA: () => import_limeA.limeA,
  mauve: () => import_mauve2.mauve,
  mauveA: () => import_mauveA2.mauveA,
  mauveDark: () => import_mauve.mauve,
  mauveDarkA: () => import_mauveA.mauveA,
  mint: () => import_mint2.mint,
  mintA: () => import_mintA2.mintA,
  mintDark: () => import_mint.mint,
  mintDarkA: () => import_mintA.mintA,
  olive: () => import_olive2.olive,
  oliveA: () => import_oliveA2.oliveA,
  oliveDark: () => import_olive.olive,
  oliveDarkA: () => import_oliveA.oliveA,
  orange: () => import_orange2.orange,
  orangeA: () => import_orangeA2.orangeA,
  orangeDark: () => import_orange.orange,
  orangeDarkA: () => import_orangeA.orangeA,
  pink: () => import_pink2.pink,
  pinkA: () => import_pinkA2.pinkA,
  pinkDark: () => import_pink.pink,
  pinkDarkA: () => import_pinkA.pinkA,
  plum: () => import_plum2.plum,
  plumA: () => import_plumA2.plumA,
  plumDark: () => import_plum.plum,
  plumDarkA: () => import_plumA.plumA,
  purple: () => import_purple2.purple,
  purpleA: () => import_purpleA2.purpleA,
  purpleDark: () => import_purple.purple,
  purpleDarkA: () => import_purpleA.purpleA,
  red: () => import_red2.red,
  redA: () => import_redA2.redA,
  redDark: () => import_red.red,
  redDarkA: () => import_redA.redA,
  sage: () => import_sage2.sage,
  sageA: () => import_sageA2.sageA,
  sageDark: () => import_sage.sage,
  sageDarkA: () => import_sageA.sageA,
  sand: () => import_sand2.sand,
  sandA: () => import_sandA2.sandA,
  sandDark: () => import_sand.sand,
  sandDarkA: () => import_sandA.sandA,
  sky: () => import_sky2.sky,
  skyA: () => import_skyA2.skyA,
  skyDark: () => import_sky.sky,
  skyDarkA: () => import_skyA.skyA,
  slate: () => import_slate2.slate,
  slateA: () => import_slateA2.slateA,
  slateDark: () => import_slate.slate,
  slateDarkA: () => import_slateA.slateA,
  teal: () => import_teal2.teal,
  tealA: () => import_tealA2.tealA,
  tealDark: () => import_teal.teal,
  tealDarkA: () => import_tealA.tealA,
  tomato: () => import_tomato2.tomato,
  tomatoA: () => import_tomatoA2.tomatoA,
  tomatoDark: () => import_tomato.tomato,
  tomatoDarkA: () => import_tomatoA.tomatoA,
  violet: () => import_violet2.violet,
  violetA: () => import_violetA2.violetA,
  violetDark: () => import_violet.violet,
  violetDarkA: () => import_violetA.violetA,
  whiteA: () => import_whiteA.whiteA,
  yellow: () => import_yellow2.yellow,
  yellowA: () => import_yellowA2.yellowA,
  yellowDark: () => import_yellow.yellow,
  yellowDarkA: () => import_yellowA.yellowA
});
module.exports = __toCommonJS(src_exports);
var import_amber = __webpack_require__(30335);
var import_blue = __webpack_require__(99888);
var import_bronze = __webpack_require__(88098);
var import_brown = __webpack_require__(6675);
var import_crimson = __webpack_require__(31076);
var import_cyan = __webpack_require__(20201);
var import_gold = __webpack_require__(3199);
var import_grass = __webpack_require__(63641);
var import_gray = __webpack_require__(95356);
var import_green = __webpack_require__(83783);
var import_indigo = __webpack_require__(22501);
var import_lime = __webpack_require__(77727);
var import_mint = __webpack_require__(87202);
var import_olive = __webpack_require__(31106);
var import_orange = __webpack_require__(52185);
var import_pink = __webpack_require__(83978);
var import_plum = __webpack_require__(86166);
var import_purple = __webpack_require__(72453);
var import_mauve = __webpack_require__(2178);
var import_red = __webpack_require__(15697);
var import_sage = __webpack_require__(30739);
var import_sand = __webpack_require__(24134);
var import_sky = __webpack_require__(86510);
var import_slate = __webpack_require__(23738);
var import_teal = __webpack_require__(78524);
var import_tomato = __webpack_require__(22318);
var import_violet = __webpack_require__(79852);
var import_yellow = __webpack_require__(43170);
var import_amberA = __webpack_require__(17550);
var import_blueA = __webpack_require__(53869);
var import_bronzeA = __webpack_require__(68495);
var import_brownA = __webpack_require__(38378);
var import_crimsonA = __webpack_require__(64396);
var import_cyanA = __webpack_require__(7878);
var import_goldA = __webpack_require__(67948);
var import_grassA = __webpack_require__(73841);
var import_grayA = __webpack_require__(76446);
var import_greenA = __webpack_require__(11626);
var import_indigoA = __webpack_require__(85639);
var import_limeA = __webpack_require__(32600);
var import_mintA = __webpack_require__(28245);
var import_oliveA = __webpack_require__(87345);
var import_orangeA = __webpack_require__(83708);
var import_pinkA = __webpack_require__(16563);
var import_plumA = __webpack_require__(80691);
var import_purpleA = __webpack_require__(8262);
var import_mauveA = __webpack_require__(67548);
var import_redA = __webpack_require__(10490);
var import_sageA = __webpack_require__(4014);
var import_sandA = __webpack_require__(33643);
var import_skyA = __webpack_require__(12237);
var import_slateA = __webpack_require__(31606);
var import_tealA = __webpack_require__(96486);
var import_tomatoA = __webpack_require__(89601);
var import_violetA = __webpack_require__(24243);
var import_yellowA = __webpack_require__(91567);
var import_amber2 = __webpack_require__(40261);
var import_blue2 = __webpack_require__(71694);
var import_bronze2 = __webpack_require__(63256);
var import_brown2 = __webpack_require__(83313);
var import_crimson2 = __webpack_require__(62680);
var import_cyan2 = __webpack_require__(29012);
var import_gold2 = __webpack_require__(51420);
var import_grass2 = __webpack_require__(58845);
var import_gray2 = __webpack_require__(31749);
var import_green2 = __webpack_require__(43380);
var import_indigo2 = __webpack_require__(71143);
var import_lime2 = __webpack_require__(65041);
var import_mint2 = __webpack_require__(34196);
var import_olive2 = __webpack_require__(78513);
var import_orange2 = __webpack_require__(18715);
var import_pink2 = __webpack_require__(55958);
var import_plum2 = __webpack_require__(86745);
var import_purple2 = __webpack_require__(83131);
var import_mauve2 = __webpack_require__(88706);
var import_red2 = __webpack_require__(11947);
var import_sage2 = __webpack_require__(70991);
var import_sand2 = __webpack_require__(8258);
var import_sky2 = __webpack_require__(81800);
var import_slate2 = __webpack_require__(45435);
var import_teal2 = __webpack_require__(41565);
var import_tomato2 = __webpack_require__(5840);
var import_violet2 = __webpack_require__(48981);
var import_yellow2 = __webpack_require__(80353);
var import_amberA2 = __webpack_require__(84314);
var import_blueA2 = __webpack_require__(57655);
var import_bronzeA2 = __webpack_require__(77113);
var import_brownA2 = __webpack_require__(30073);
var import_crimsonA2 = __webpack_require__(90435);
var import_cyanA2 = __webpack_require__(97689);
var import_goldA2 = __webpack_require__(38405);
var import_grassA2 = __webpack_require__(45663);
var import_grayA2 = __webpack_require__(75117);
var import_greenA2 = __webpack_require__(77741);
var import_indigoA2 = __webpack_require__(2564);
var import_limeA2 = __webpack_require__(59067);
var import_mintA2 = __webpack_require__(55627);
var import_oliveA2 = __webpack_require__(97602);
var import_orangeA2 = __webpack_require__(34863);
var import_pinkA2 = __webpack_require__(86048);
var import_plumA2 = __webpack_require__(30338);
var import_purpleA2 = __webpack_require__(69666);
var import_mauveA2 = __webpack_require__(16729);
var import_redA2 = __webpack_require__(18151);
var import_sageA2 = __webpack_require__(18203);
var import_sandA2 = __webpack_require__(12638);
var import_skyA2 = __webpack_require__(8613);
var import_slateA2 = __webpack_require__(94451);
var import_tealA2 = __webpack_require__(246);
var import_tomatoA2 = __webpack_require__(33094);
var import_violetA2 = __webpack_require__(26985);
var import_yellowA2 = __webpack_require__(76827);
var import_blackA = __webpack_require__(28258);
var import_whiteA = __webpack_require__(49606);
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 40261:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var amber_exports = {};
__export(amber_exports, {
  amber: () => amber
});
module.exports = __toCommonJS(amber_exports);
const amber = {
  amber1: "hsl(39, 70.0%, 99.0%)",
  amber2: "hsl(40, 100%, 96.5%)",
  amber3: "hsl(44, 100%, 91.7%)",
  amber4: "hsl(43, 100%, 86.8%)",
  amber5: "hsl(42, 100%, 81.8%)",
  amber6: "hsl(38, 99.7%, 76.3%)",
  amber7: "hsl(36, 86.1%, 67.1%)",
  amber8: "hsl(35, 85.2%, 55.1%)",
  amber9: "hsl(39, 100%, 57.0%)",
  amber10: "hsl(35, 100%, 55.5%)",
  amber11: "hsl(30, 100%, 34.0%)",
  amber12: "hsl(20, 80.0%, 17.0%)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=amber.js.map


/***/ }),

/***/ 84314:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var amberA_exports = {};
__export(amberA_exports, {
  amberA: () => amberA
});
module.exports = __toCommonJS(amberA_exports);
const amberA = {
  amberA1: "hsla(40, 94.9%, 38.7%, 0.016)",
  amberA2: "hsla(40, 100%, 50.3%, 0.071)",
  amberA3: "hsla(44, 100%, 50.1%, 0.165)",
  amberA4: "hsla(43, 100%, 50.0%, 0.263)",
  amberA5: "hsla(42, 100%, 50.0%, 0.365)",
  amberA6: "hsla(38, 100%, 50.1%, 0.475)",
  amberA7: "hsla(36, 99.9%, 46.2%, 0.612)",
  amberA8: "hsla(35, 99.8%, 46.0%, 0.832)",
  amberA9: "hsla(39, 100%, 50.0%, 0.859)",
  amberA10: "hsla(35, 100%, 50.0%, 0.891)",
  amberA11: "hsla(29, 100%, 33.6%, 0.980)",
  amberA12: "hsla(20, 99.8%, 14.1%, 0.965)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=amberA.js.map


/***/ }),

/***/ 71694:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var blue_exports = {};
__export(blue_exports, {
  blue: () => blue
});
module.exports = __toCommonJS(blue_exports);
const blue = {
  blue1: "hsl(206, 100%, 99.2%)",
  blue2: "hsl(210, 100%, 98.0%)",
  blue3: "hsl(209, 100%, 96.5%)",
  blue4: "hsl(210, 98.8%, 94.0%)",
  blue5: "hsl(209, 95.0%, 90.1%)",
  blue6: "hsl(209, 81.2%, 84.5%)",
  blue7: "hsl(208, 77.5%, 76.9%)",
  blue8: "hsl(206, 81.9%, 65.3%)",
  blue9: "hsl(206, 100%, 50.0%)",
  blue10: "hsl(208, 100%, 47.3%)",
  blue11: "hsl(211, 100%, 43.2%)",
  blue12: "hsl(211, 100%, 15.0%)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=blue.js.map


/***/ }),

/***/ 57655:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var blueA_exports = {};
__export(blueA_exports, {
  blueA: () => blueA
});
module.exports = __toCommonJS(blueA_exports);
const blueA = {
  blueA1: "hsla(210, 100%, 51.0%, 0.016)",
  blueA2: "hsla(210, 100%, 51.0%, 0.040)",
  blueA3: "hsla(210, 100%, 50.3%, 0.071)",
  blueA4: "hsla(210, 100%, 50.1%, 0.118)",
  blueA5: "hsla(208, 99.1%, 47.1%, 0.189)",
  blueA6: "hsla(209, 99.5%, 45.3%, 0.283)",
  blueA7: "hsla(208, 99.9%, 43.8%, 0.412)",
  blueA8: "hsla(206, 99.8%, 45.1%, 0.632)",
  blueA9: "hsla(206, 100%, 50.0%, 0.980)",
  blueA10: "hsla(208, 100%, 47.2%, 0.980)",
  blueA11: "hsla(212, 100%, 43.0%, 0.980)",
  blueA12: "hsla(213, 100%, 14.4%, 0.980)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=blueA.js.map


/***/ }),

/***/ 63256:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var bronze_exports = {};
__export(bronze_exports, {
  bronze: () => bronze
});
module.exports = __toCommonJS(bronze_exports);
const bronze = {
  bronze1: "hsl(15, 30.0%, 99.1%)",
  bronze2: "hsl(17, 63.6%, 97.8%)",
  bronze3: "hsl(17, 42.1%, 95.2%)",
  bronze4: "hsl(17, 35.2%, 92.1%)",
  bronze5: "hsl(17, 31.5%, 88.2%)",
  bronze6: "hsl(17, 29.0%, 83.0%)",
  bronze7: "hsl(17, 26.9%, 75.6%)",
  bronze8: "hsl(17, 25.1%, 66.5%)",
  bronze9: "hsl(17, 20.0%, 54.0%)",
  bronze10: "hsl(17, 18.1%, 50.1%)",
  bronze11: "hsl(15, 20.0%, 43.1%)",
  bronze12: "hsl(12, 22.0%, 21.5%)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=bronze.js.map


/***/ }),

/***/ 77113:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var bronzeA_exports = {};
__export(bronzeA_exports, {
  bronzeA: () => bronzeA
});
module.exports = __toCommonJS(bronzeA_exports);
const bronzeA = {
  bronzeA1: "hsla(0, 89.3%, 18.3%, 0.012)",
  bronzeA2: "hsla(17, 95.1%, 40.1%, 0.036)",
  bronzeA3: "hsla(18, 98.3%, 29.8%, 0.067)",
  bronzeA4: "hsla(17, 99.6%, 26.0%, 0.106)",
  bronzeA5: "hsla(19, 99.6%, 23.8%, 0.157)",
  bronzeA6: "hsla(17, 99.2%, 22.5%, 0.220)",
  bronzeA7: "hsla(18, 99.7%, 21.6%, 0.310)",
  bronzeA8: "hsla(17, 99.5%, 20.2%, 0.420)",
  bronzeA9: "hsla(18, 99.9%, 16.7%, 0.553)",
  bronzeA10: "hsla(17, 99.2%, 15.4%, 0.589)",
  bronzeA11: "hsla(15, 99.9%, 13.2%, 0.655)",
  bronzeA12: "hsla(12, 98.7%, 5.7%, 0.832)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=bronzeA.js.map


/***/ }),

/***/ 83313:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var brown_exports = {};
__export(brown_exports, {
  brown: () => brown
});
module.exports = __toCommonJS(brown_exports);
const brown = {
  brown1: "hsl(30, 40.0%, 99.1%)",
  brown2: "hsl(30, 50.0%, 97.6%)",
  brown3: "hsl(30, 52.5%, 94.6%)",
  brown4: "hsl(30, 53.0%, 91.2%)",
  brown5: "hsl(29, 52.9%, 86.8%)",
  brown6: "hsl(29, 52.5%, 80.9%)",
  brown7: "hsl(29, 51.5%, 72.8%)",
  brown8: "hsl(28, 50.0%, 63.1%)",
  brown9: "hsl(28, 34.0%, 51.0%)",
  brown10: "hsl(27, 31.8%, 47.6%)",
  brown11: "hsl(25, 30.0%, 41.0%)",
  brown12: "hsl(20, 30.0%, 19.0%)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=brown.js.map


/***/ }),

/***/ 30073:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var brownA_exports = {};
__export(brownA_exports, {
  brownA: () => brownA
});
module.exports = __toCommonJS(brownA_exports);
const brownA = {
  brownA1: "hsla(30, 94.3%, 34.6%, 0.012)",
  brownA2: "hsla(30, 94.3%, 34.6%, 0.036)",
  brownA3: "hsla(30, 97.7%, 33.9%, 0.083)",
  brownA4: "hsla(31, 98.5%, 34.2%, 0.134)",
  brownA5: "hsla(29, 100%, 34.3%, 0.200)",
  brownA6: "hsla(28, 99.2%, 34.6%, 0.291)",
  brownA7: "hsla(29, 99.8%, 33.8%, 0.412)",
  brownA8: "hsla(28, 100%, 33.3%, 0.553)",
  brownA9: "hsla(28, 99.9%, 25.5%, 0.655)",
  brownA10: "hsla(27, 99.7%, 22.4%, 0.675)",
  brownA11: "hsla(25, 99.8%, 17.3%, 0.714)",
  brownA12: "hsla(21, 99.4%, 6.6%, 0.867)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=brownA.js.map


/***/ }),

/***/ 62680:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var crimson_exports = {};
__export(crimson_exports, {
  crimson: () => crimson
});
module.exports = __toCommonJS(crimson_exports);
const crimson = {
  crimson1: "hsl(332, 100%, 99.4%)",
  crimson2: "hsl(330, 100%, 98.4%)",
  crimson3: "hsl(331, 85.6%, 96.6%)",
  crimson4: "hsl(331, 78.1%, 94.2%)",
  crimson5: "hsl(332, 72.1%, 91.1%)",
  crimson6: "hsl(333, 67.0%, 86.7%)",
  crimson7: "hsl(335, 63.5%, 80.4%)",
  crimson8: "hsl(336, 62.3%, 72.9%)",
  crimson9: "hsl(336, 80.0%, 57.8%)",
  crimson10: "hsl(336, 73.7%, 53.5%)",
  crimson11: "hsl(336, 75.0%, 47.2%)",
  crimson12: "hsl(340, 65.0%, 14.5%)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=crimson.js.map


/***/ }),

/***/ 90435:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var crimsonA_exports = {};
__export(crimsonA_exports, {
  crimsonA: () => crimsonA
});
module.exports = __toCommonJS(crimsonA_exports);
const crimsonA = {
  crimsonA1: "hsla(340, 100%, 51.0%, 0.012)",
  crimsonA2: "hsla(330, 100%, 51.0%, 0.032)",
  crimsonA3: "hsla(332, 99.1%, 47.1%, 0.063)",
  crimsonA4: "hsla(331, 99.9%, 44.3%, 0.102)",
  crimsonA5: "hsla(333, 99.9%, 42.3%, 0.153)",
  crimsonA6: "hsla(333, 99.5%, 40.5%, 0.224)",
  crimsonA7: "hsla(335, 99.7%, 39.1%, 0.322)",
  crimsonA8: "hsla(336, 99.5%, 38.5%, 0.440)",
  crimsonA9: "hsla(336, 99.9%, 44.3%, 0.761)",
  crimsonA10: "hsla(336, 100%, 42.5%, 0.808)",
  crimsonA11: "hsla(336, 99.8%, 40.3%, 0.883)",
  crimsonA12: "hsla(340, 99.0%, 10.0%, 0.950)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=crimsonA.js.map


/***/ }),

/***/ 29012:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var cyan_exports = {};
__export(cyan_exports, {
  cyan: () => cyan
});
module.exports = __toCommonJS(cyan_exports);
const cyan = {
  cyan1: "hsl(185, 60.0%, 98.7%)",
  cyan2: "hsl(185, 73.3%, 97.1%)",
  cyan3: "hsl(186, 70.2%, 94.4%)",
  cyan4: "hsl(186, 63.8%, 90.6%)",
  cyan5: "hsl(187, 58.3%, 85.4%)",
  cyan6: "hsl(188, 54.6%, 78.4%)",
  cyan7: "hsl(189, 53.7%, 68.7%)",
  cyan8: "hsl(189, 60.3%, 52.5%)",
  cyan9: "hsl(190, 95.0%, 39.0%)",
  cyan10: "hsl(191, 91.2%, 36.8%)",
  cyan11: "hsl(192, 85.0%, 31.0%)",
  cyan12: "hsl(192, 88.0%, 12.5%)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=cyan.js.map


/***/ }),

/***/ 97689:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var cyanA_exports = {};
__export(cyanA_exports, {
  cyanA: () => cyanA
});
module.exports = __toCommonJS(cyanA_exports);
const cyanA = {
  cyanA1: "hsla(195, 95.2%, 41.2%, 0.020)",
  cyanA2: "hsla(185, 99.9%, 42.3%, 0.051)",
  cyanA3: "hsla(186, 97.8%, 42.2%, 0.095)",
  cyanA4: "hsla(186, 99.9%, 38.5%, 0.153)",
  cyanA5: "hsla(187, 99.3%, 36.6%, 0.232)",
  cyanA6: "hsla(188, 99.4%, 35.4%, 0.334)",
  cyanA7: "hsla(189, 99.6%, 35.0%, 0.483)",
  cyanA8: "hsla(189, 99.9%, 37.6%, 0.761)",
  cyanA9: "hsla(190, 100%, 37.8%, 0.980)",
  cyanA10: "hsla(191, 99.9%, 34.6%, 0.969)",
  cyanA11: "hsla(192, 100%, 27.6%, 0.953)",
  cyanA12: "hsla(192, 100%, 11.0%, 0.980)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=cyanA.js.map


/***/ }),

/***/ 51420:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var gold_exports = {};
__export(gold_exports, {
  gold: () => gold
});
module.exports = __toCommonJS(gold_exports);
const gold = {
  gold1: "hsl(50, 20.0%, 99.1%)",
  gold2: "hsl(47, 52.9%, 96.7%)",
  gold3: "hsl(46, 38.2%, 93.7%)",
  gold4: "hsl(44, 32.7%, 90.1%)",
  gold5: "hsl(43, 29.9%, 85.7%)",
  gold6: "hsl(41, 28.3%, 79.8%)",
  gold7: "hsl(39, 27.6%, 71.9%)",
  gold8: "hsl(36, 27.2%, 61.8%)",
  gold9: "hsl(36, 20.0%, 49.5%)",
  gold10: "hsl(36, 19.8%, 45.7%)",
  gold11: "hsl(36, 20.0%, 39.0%)",
  gold12: "hsl(36, 16.0%, 20.0%)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=gold.js.map


/***/ }),

/***/ 38405:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var goldA_exports = {};
__export(goldA_exports, {
  goldA: () => goldA
});
module.exports = __toCommonJS(goldA_exports);
const goldA = {
  goldA1: "hsla(60, 89.3%, 18.3%, 0.012)",
  goldA2: "hsla(47, 99.9%, 34.6%, 0.051)",
  goldA3: "hsla(45, 97.0%, 27.9%, 0.087)",
  goldA4: "hsla(46, 98.0%, 25.4%, 0.134)",
  goldA5: "hsla(43, 98.4%, 22.6%, 0.185)",
  goldA6: "hsla(41, 99.7%, 22.0%, 0.259)",
  goldA7: "hsla(38, 99.8%, 21.5%, 0.357)",
  goldA8: "hsla(36, 99.3%, 21.5%, 0.487)",
  goldA9: "hsla(36, 99.9%, 16.2%, 0.604)",
  goldA10: "hsla(36, 99.2%, 14.6%, 0.636)",
  goldA11: "hsla(35, 99.1%, 11.2%, 0.687)",
  goldA12: "hsla(38, 98.0%, 3.8%, 0.832)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=goldA.js.map


/***/ }),

/***/ 58845:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var grass_exports = {};
__export(grass_exports, {
  grass: () => grass
});
module.exports = __toCommonJS(grass_exports);
const grass = {
  grass1: "hsl(116, 50.0%, 98.9%)",
  grass2: "hsl(120, 60.0%, 97.1%)",
  grass3: "hsl(120, 53.6%, 94.8%)",
  grass4: "hsl(121, 47.5%, 91.4%)",
  grass5: "hsl(122, 42.6%, 86.5%)",
  grass6: "hsl(124, 39.0%, 79.7%)",
  grass7: "hsl(126, 37.1%, 70.2%)",
  grass8: "hsl(131, 38.1%, 56.3%)",
  grass9: "hsl(131, 41.0%, 46.5%)",
  grass10: "hsl(132, 43.1%, 42.2%)",
  grass11: "hsl(133, 50.0%, 32.5%)",
  grass12: "hsl(130, 30.0%, 14.9%)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=grass.js.map


/***/ }),

/***/ 45663:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var grassA_exports = {};
__export(grassA_exports, {
  grassA: () => grassA
});
module.exports = __toCommonJS(grassA_exports);
const grassA = {
  grassA1: "hsla(120, 94.9%, 38.7%, 0.016)",
  grassA2: "hsla(120, 94.9%, 38.7%, 0.048)",
  grassA3: "hsla(120, 98.0%, 35.5%, 0.079)",
  grassA4: "hsla(120, 98.7%, 31.5%, 0.126)",
  grassA5: "hsla(122, 98.5%, 29.9%, 0.193)",
  grassA6: "hsla(125, 99.2%, 27.9%, 0.283)",
  grassA7: "hsla(125, 99.9%, 27.0%, 0.408)",
  grassA8: "hsla(131, 100%, 27.6%, 0.604)",
  grassA9: "hsla(131, 99.7%, 26.3%, 0.726)",
  grassA10: "hsla(132, 99.9%, 24.0%, 0.761)",
  grassA11: "hsla(133, 99.5%, 19.5%, 0.840)",
  grassA12: "hsla(128, 98.0%, 4.9%, 0.895)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=grassA.js.map


/***/ }),

/***/ 31749:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var gray_exports = {};
__export(gray_exports, {
  gray: () => gray
});
module.exports = __toCommonJS(gray_exports);
const gray = {
  gray1: "hsl(0, 0%, 99.0%)",
  gray2: "hsl(0, 0%, 97.3%)",
  gray3: "hsl(0, 0%, 95.1%)",
  gray4: "hsl(0, 0%, 93.0%)",
  gray5: "hsl(0, 0%, 90.9%)",
  gray6: "hsl(0, 0%, 88.7%)",
  gray7: "hsl(0, 0%, 85.8%)",
  gray8: "hsl(0, 0%, 78.0%)",
  gray9: "hsl(0, 0%, 56.1%)",
  gray10: "hsl(0, 0%, 52.3%)",
  gray11: "hsl(0, 0%, 43.5%)",
  gray12: "hsl(0, 0%, 9.0%)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=gray.js.map


/***/ }),

/***/ 75117:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var grayA_exports = {};
__export(grayA_exports, {
  grayA: () => grayA
});
module.exports = __toCommonJS(grayA_exports);
const grayA = {
  grayA1: "hsla(0, 0%, 0%, 0.012)",
  grayA2: "hsla(0, 0%, 0%, 0.027)",
  grayA3: "hsla(0, 0%, 0%, 0.047)",
  grayA4: "hsla(0, 0%, 0%, 0.071)",
  grayA5: "hsla(0, 0%, 0%, 0.090)",
  grayA6: "hsla(0, 0%, 0%, 0.114)",
  grayA7: "hsla(0, 0%, 0%, 0.141)",
  grayA8: "hsla(0, 0%, 0%, 0.220)",
  grayA9: "hsla(0, 0%, 0%, 0.439)",
  grayA10: "hsla(0, 0%, 0%, 0.478)",
  grayA11: "hsla(0, 0%, 0%, 0.565)",
  grayA12: "hsla(0, 0%, 0%, 0.910)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=grayA.js.map


/***/ }),

/***/ 43380:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var green_exports = {};
__export(green_exports, {
  green: () => green
});
module.exports = __toCommonJS(green_exports);
const green = {
  green1: "hsl(136, 50.0%, 98.9%)",
  green2: "hsl(138, 62.5%, 96.9%)",
  green3: "hsl(139, 55.2%, 94.5%)",
  green4: "hsl(140, 48.7%, 91.0%)",
  green5: "hsl(141, 43.7%, 86.0%)",
  green6: "hsl(143, 40.3%, 79.0%)",
  green7: "hsl(146, 38.5%, 69.0%)",
  green8: "hsl(151, 40.2%, 54.1%)",
  green9: "hsl(151, 55.0%, 41.5%)",
  green10: "hsl(152, 57.5%, 37.6%)",
  green11: "hsl(153, 67.0%, 28.5%)",
  green12: "hsl(155, 40.0%, 14.0%)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=green.js.map


/***/ }),

/***/ 77741:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var greenA_exports = {};
__export(greenA_exports, {
  greenA: () => greenA
});
module.exports = __toCommonJS(greenA_exports);
const greenA = {
  greenA1: "hsla(140, 94.9%, 38.7%, 0.016)",
  greenA2: "hsla(138, 99.9%, 38.5%, 0.051)",
  greenA3: "hsla(139, 97.7%, 36.9%, 0.087)",
  greenA4: "hsla(139, 98.5%, 32.7%, 0.134)",
  greenA5: "hsla(141, 100%, 30.4%, 0.200)",
  greenA6: "hsla(142, 99.0%, 28.9%, 0.295)",
  greenA7: "hsla(146, 99.5%, 27.6%, 0.428)",
  greenA8: "hsla(151, 99.5%, 28.8%, 0.644)",
  greenA9: "hsla(151, 99.9%, 28.0%, 0.812)",
  greenA10: "hsla(152, 99.6%, 25.8%, 0.840)",
  greenA11: "hsla(153, 99.9%, 21.0%, 0.906)",
  greenA12: "hsla(155, 99.4%, 6.2%, 0.918)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=greenA.js.map


/***/ }),

/***/ 71143:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var indigo_exports = {};
__export(indigo_exports, {
  indigo: () => indigo
});
module.exports = __toCommonJS(indigo_exports);
const indigo = {
  indigo1: "hsl(225, 60.0%, 99.4%)",
  indigo2: "hsl(223, 100%, 98.6%)",
  indigo3: "hsl(223, 98.4%, 97.1%)",
  indigo4: "hsl(223, 92.9%, 95.0%)",
  indigo5: "hsl(224, 87.1%, 92.0%)",
  indigo6: "hsl(224, 81.9%, 87.8%)",
  indigo7: "hsl(225, 77.4%, 82.1%)",
  indigo8: "hsl(226, 75.4%, 74.5%)",
  indigo9: "hsl(226, 70.0%, 55.5%)",
  indigo10: "hsl(226, 58.6%, 51.3%)",
  indigo11: "hsl(226, 55.0%, 45.0%)",
  indigo12: "hsl(226, 62.0%, 17.0%)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=indigo.js.map


/***/ }),

/***/ 2564:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var indigoA_exports = {};
__export(indigoA_exports, {
  indigoA: () => indigoA
});
module.exports = __toCommonJS(indigoA_exports);
const indigoA = {
  indigoA1: "hsla(240, 92.6%, 26.5%, 0.008)",
  indigoA2: "hsla(223, 100%, 51.0%, 0.028)",
  indigoA3: "hsla(224, 100%, 50.1%, 0.059)",
  indigoA4: "hsla(223, 98.0%, 48.5%, 0.099)",
  indigoA5: "hsla(225, 98.6%, 46.4%, 0.150)",
  indigoA6: "hsla(224, 99.5%, 44.9%, 0.224)",
  indigoA7: "hsla(225, 99.7%, 43.9%, 0.318)",
  indigoA8: "hsla(226, 99.5%, 43.1%, 0.448)",
  indigoA9: "hsla(226, 100%, 41.2%, 0.757)",
  indigoA10: "hsla(226, 99.8%, 37.1%, 0.773)",
  indigoA11: "hsla(226, 99.6%, 31.1%, 0.797)",
  indigoA12: "hsla(226, 99.3%, 11.4%, 0.938)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=indigoA.js.map


/***/ }),

/***/ 65041:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var lime_exports = {};
__export(lime_exports, {
  lime: () => lime
});
module.exports = __toCommonJS(lime_exports);
const lime = {
  lime1: "hsl(85, 50.0%, 98.7%)",
  lime2: "hsl(85, 66.7%, 96.5%)",
  lime3: "hsl(85, 76.0%, 92.3%)",
  lime4: "hsl(84, 75.3%, 87.5%)",
  lime5: "hsl(84, 71.5%, 81.9%)",
  lime6: "hsl(82, 65.0%, 74.6%)",
  lime7: "hsl(79, 53.2%, 61.8%)",
  lime8: "hsl(76, 61.7%, 45.1%)",
  lime9: "hsl(81, 67.0%, 50.0%)",
  lime10: "hsl(80, 68.3%, 46.9%)",
  lime11: "hsl(75, 80.0%, 26.0%)",
  lime12: "hsl(78, 70.0%, 11.5%)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=lime.js.map


/***/ }),

/***/ 59067:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var limeA_exports = {};
__export(limeA_exports, {
  limeA: () => limeA
});
module.exports = __toCommonJS(limeA_exports);
const limeA = {
  limeA1: "hsla(80, 93.8%, 31.4%, 0.020)",
  limeA2: "hsla(85, 99.3%, 40.2%, 0.059)",
  limeA3: "hsla(84, 98.7%, 43.2%, 0.138)",
  limeA4: "hsla(84, 99.6%, 43.0%, 0.220)",
  limeA5: "hsla(85, 99.8%, 41.8%, 0.310)",
  limeA6: "hsla(82, 99.8%, 39.3%, 0.420)",
  limeA7: "hsla(79, 99.7%, 34.6%, 0.585)",
  limeA8: "hsla(76, 99.8%, 33.7%, 0.828)",
  limeA9: "hsla(81, 99.8%, 40.2%, 0.836)",
  limeA10: "hsla(80, 100%, 37.6%, 0.851)",
  limeA11: "hsla(75, 99.5%, 22.0%, 0.950)",
  limeA12: "hsla(78, 99.6%, 8.4%, 0.965)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=limeA.js.map


/***/ }),

/***/ 88706:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var mauve_exports = {};
__export(mauve_exports, {
  mauve: () => mauve
});
module.exports = __toCommonJS(mauve_exports);
const mauve = {
  mauve1: "hsl(300, 20.0%, 99.0%)",
  mauve2: "hsl(300, 7.7%, 97.5%)",
  mauve3: "hsl(294, 5.5%, 95.3%)",
  mauve4: "hsl(289, 4.7%, 93.3%)",
  mauve5: "hsl(283, 4.4%, 91.3%)",
  mauve6: "hsl(278, 4.1%, 89.1%)",
  mauve7: "hsl(271, 3.9%, 86.3%)",
  mauve8: "hsl(255, 3.7%, 78.8%)",
  mauve9: "hsl(252, 4.0%, 57.3%)",
  mauve10: "hsl(253, 3.5%, 53.5%)",
  mauve11: "hsl(252, 4.0%, 44.8%)",
  mauve12: "hsl(260, 25.0%, 11.0%)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=mauve.js.map


/***/ }),

/***/ 16729:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var mauveA_exports = {};
__export(mauveA_exports, {
  mauveA: () => mauveA
});
module.exports = __toCommonJS(mauveA_exports);
const mauveA = {
  mauveA1: "hsla(300, 89.3%, 18.3%, 0.012)",
  mauveA2: "hsla(300, 78.1%, 9.0%, 0.028)",
  mauveA3: "hsla(300, 99.5%, 7.7%, 0.051)",
  mauveA4: "hsla(270, 90.5%, 6.1%, 0.071)",
  mauveA5: "hsla(270, 83.0%, 5.2%, 0.091)",
  mauveA6: "hsla(300, 93.5%, 3.7%, 0.114)",
  mauveA7: "hsla(270, 82.6%, 3.3%, 0.142)",
  mauveA8: "hsla(255, 95.2%, 3.7%, 0.220)",
  mauveA9: "hsla(255, 94.8%, 3.7%, 0.444)",
  mauveA10: "hsla(253, 96.5%, 3.8%, 0.483)",
  mauveA11: "hsla(247, 97.9%, 3.2%, 0.569)",
  mauveA12: "hsla(261, 98.7%, 3.0%, 0.918)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=mauveA.js.map


/***/ }),

/***/ 34196:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var mint_exports = {};
__export(mint_exports, {
  mint: () => mint
});
module.exports = __toCommonJS(mint_exports);
const mint = {
  mint1: "hsl(165, 80.0%, 98.8%)",
  mint2: "hsl(164, 88.2%, 96.7%)",
  mint3: "hsl(164, 76.6%, 93.3%)",
  mint4: "hsl(165, 68.8%, 89.5%)",
  mint5: "hsl(165, 60.6%, 84.5%)",
  mint6: "hsl(165, 53.5%, 76.9%)",
  mint7: "hsl(166, 50.7%, 66.1%)",
  mint8: "hsl(168, 52.8%, 51.0%)",
  mint9: "hsl(167, 65.0%, 66.0%)",
  mint10: "hsl(167, 59.3%, 63.1%)",
  mint11: "hsl(172, 72.0%, 28.5%)",
  mint12: "hsl(172, 70.0%, 12.0%)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=mint.js.map


/***/ }),

/***/ 55627:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var mintA_exports = {};
__export(mintA_exports, {
  mintA: () => mintA
});
module.exports = __toCommonJS(mintA_exports);
const mintA = {
  mintA1: "hsla(168, 95.4%, 42.8%, 0.024)",
  mintA2: "hsla(164, 99.1%, 47.1%, 0.063)",
  mintA3: "hsla(164, 99.3%, 43.5%, 0.118)",
  mintA4: "hsla(164, 99.3%, 41.3%, 0.177)",
  mintA5: "hsla(165, 99.0%, 37.5%, 0.248)",
  mintA6: "hsla(165, 100%, 35.0%, 0.353)",
  mintA7: "hsla(166, 99.9%, 33.5%, 0.510)",
  mintA8: "hsla(168, 99.6%, 34.6%, 0.750)",
  mintA9: "hsla(167, 99.9%, 39.5%, 0.561)",
  mintA10: "hsla(167, 99.7%, 37.4%, 0.589)",
  mintA11: "hsla(172, 99.8%, 22.4%, 0.922)",
  mintA12: "hsla(172, 99.7%, 8.8%, 0.965)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=mintA.js.map


/***/ }),

/***/ 78513:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var olive_exports = {};
__export(olive_exports, {
  olive: () => olive
});
module.exports = __toCommonJS(olive_exports);
const olive = {
  olive1: "hsl(110, 20.0%, 99.0%)",
  olive2: "hsl(120, 16.7%, 97.6%)",
  olive3: "hsl(119, 10.1%, 95.2%)",
  olive4: "hsl(118, 8.1%, 93.0%)",
  olive5: "hsl(117, 7.1%, 90.8%)",
  olive6: "hsl(115, 6.4%, 88.5%)",
  olive7: "hsl(114, 5.9%, 85.4%)",
  olive8: "hsl(110, 5.2%, 77.3%)",
  olive9: "hsl(110, 3.5%, 55.5%)",
  olive10: "hsl(111, 2.8%, 51.7%)",
  olive11: "hsl(110, 3.0%, 43.0%)",
  olive12: "hsl(110, 25.0%, 9.5%)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=olive.js.map


/***/ }),

/***/ 97602:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var oliveA_exports = {};
__export(oliveA_exports, {
  oliveA: () => oliveA
});
module.exports = __toCommonJS(oliveA_exports);
const oliveA = {
  oliveA1: "hsla(120, 89.3%, 18.3%, 0.012)",
  oliveA2: "hsla(120, 87.7%, 16.0%, 0.028)",
  oliveA3: "hsla(120, 99.5%, 7.7%, 0.051)",
  oliveA4: "hsla(120, 92.3%, 8.5%, 0.075)",
  oliveA5: "hsla(120, 86.0%, 6.9%, 0.099)",
  oliveA6: "hsla(120, 94.8%, 6.8%, 0.122)",
  oliveA7: "hsla(120, 99.3%, 5.2%, 0.153)",
  oliveA8: "hsla(110, 93.8%, 5.2%, 0.240)",
  oliveA9: "hsla(111, 98.7%, 3.0%, 0.459)",
  oliveA10: "hsla(111, 93.5%, 2.9%, 0.499)",
  oliveA11: "hsla(111, 95.2%, 2.5%, 0.585)",
  oliveA12: "hsla(110, 97.6%, 2.6%, 0.930)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=oliveA.js.map


/***/ }),

/***/ 18715:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var orange_exports = {};
__export(orange_exports, {
  orange: () => orange
});
module.exports = __toCommonJS(orange_exports);
const orange = {
  orange1: "hsl(24, 70.0%, 99.0%)",
  orange2: "hsl(24, 83.3%, 97.6%)",
  orange3: "hsl(24, 100%, 95.3%)",
  orange4: "hsl(25, 100%, 92.2%)",
  orange5: "hsl(25, 100%, 88.2%)",
  orange6: "hsl(25, 100%, 82.8%)",
  orange7: "hsl(24, 100%, 75.3%)",
  orange8: "hsl(24, 94.5%, 64.3%)",
  orange9: "hsl(24, 94.0%, 50.0%)",
  orange10: "hsl(24, 100%, 46.5%)",
  orange11: "hsl(24, 100%, 37.0%)",
  orange12: "hsl(15, 60.0%, 17.0%)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=orange.js.map


/***/ }),

/***/ 34863:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var orangeA_exports = {};
__export(orangeA_exports, {
  orangeA: () => orangeA
});
module.exports = __toCommonJS(orangeA_exports);
const orangeA = {
  orangeA1: "hsla(20, 94.9%, 38.7%, 0.016)",
  orangeA2: "hsla(24, 95.8%, 46.5%, 0.044)",
  orangeA3: "hsla(25, 100%, 50.5%, 0.095)",
  orangeA4: "hsla(26, 100%, 50.0%, 0.157)",
  orangeA5: "hsla(25, 100%, 50.1%, 0.236)",
  orangeA6: "hsla(25, 100%, 50.1%, 0.346)",
  orangeA7: "hsla(24, 100%, 50.1%, 0.495)",
  orangeA8: "hsla(24, 99.7%, 48.7%, 0.695)",
  orangeA9: "hsla(24, 99.9%, 48.4%, 0.969)",
  orangeA10: "hsla(23, 100%, 46.4%, 0.980)",
  orangeA11: "hsla(23, 100%, 36.8%, 0.980)",
  orangeA12: "hsla(15, 99.4%, 11.0%, 0.934)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=orangeA.js.map


/***/ }),

/***/ 55958:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var pink_exports = {};
__export(pink_exports, {
  pink: () => pink
});
module.exports = __toCommonJS(pink_exports);
const pink = {
  pink1: "hsl(322, 100%, 99.4%)",
  pink2: "hsl(323, 100%, 98.4%)",
  pink3: "hsl(323, 86.3%, 96.5%)",
  pink4: "hsl(323, 78.7%, 94.2%)",
  pink5: "hsl(323, 72.2%, 91.1%)",
  pink6: "hsl(323, 66.3%, 86.6%)",
  pink7: "hsl(323, 62.0%, 80.1%)",
  pink8: "hsl(323, 60.3%, 72.4%)",
  pink9: "hsl(322, 65.0%, 54.5%)",
  pink10: "hsl(322, 63.9%, 50.7%)",
  pink11: "hsl(322, 75.0%, 46.0%)",
  pink12: "hsl(320, 70.0%, 13.5%)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=pink.js.map


/***/ }),

/***/ 86048:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var pinkA_exports = {};
__export(pinkA_exports, {
  pinkA: () => pinkA
});
module.exports = __toCommonJS(pinkA_exports);
const pinkA = {
  pinkA1: "hsla(320, 100%, 51.0%, 0.012)",
  pinkA2: "hsla(323, 100%, 51.0%, 0.032)",
  pinkA3: "hsla(323, 98.9%, 47.3%, 0.067)",
  pinkA4: "hsla(323, 99.9%, 44.3%, 0.102)",
  pinkA5: "hsla(324, 99.9%, 42.3%, 0.153)",
  pinkA6: "hsla(323, 99.5%, 39.6%, 0.224)",
  pinkA7: "hsla(323, 99.7%, 38.5%, 0.322)",
  pinkA8: "hsla(323, 99.5%, 37.7%, 0.444)",
  pinkA9: "hsla(322, 99.7%, 39.3%, 0.750)",
  pinkA10: "hsla(322, 100%, 39.1%, 0.808)",
  pinkA11: "hsla(322, 99.8%, 39.0%, 0.887)",
  pinkA12: "hsla(321, 99.8%, 10.0%, 0.961)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=pinkA.js.map


/***/ }),

/***/ 86745:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var plum_exports = {};
__export(plum_exports, {
  plum: () => plum
});
module.exports = __toCommonJS(plum_exports);
const plum = {
  plum1: "hsl(292, 90.0%, 99.4%)",
  plum2: "hsl(300, 100%, 98.6%)",
  plum3: "hsl(299, 71.2%, 96.4%)",
  plum4: "hsl(299, 62.0%, 93.8%)",
  plum5: "hsl(298, 56.1%, 90.5%)",
  plum6: "hsl(296, 51.3%, 85.8%)",
  plum7: "hsl(295, 48.2%, 78.9%)",
  plum8: "hsl(292, 47.7%, 70.8%)",
  plum9: "hsl(292, 45.0%, 51.0%)",
  plum10: "hsl(292, 50.2%, 46.9%)",
  plum11: "hsl(292, 60.0%, 42.5%)",
  plum12: "hsl(291, 66.0%, 14.0%)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=plum.js.map


/***/ }),

/***/ 30338:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var plumA_exports = {};
__export(plumA_exports, {
  plumA: () => plumA
});
module.exports = __toCommonJS(plumA_exports);
const plumA = {
  plumA1: "hsla(280, 100%, 51.0%, 0.012)",
  plumA2: "hsla(300, 100%, 51.0%, 0.028)",
  plumA3: "hsla(300, 99.0%, 40.9%, 0.063)",
  plumA4: "hsla(300, 99.9%, 38.5%, 0.102)",
  plumA5: "hsla(298, 98.2%, 35.9%, 0.150)",
  plumA6: "hsla(297, 99.6%, 33.7%, 0.216)",
  plumA7: "hsla(295, 99.7%, 32.6%, 0.314)",
  plumA8: "hsla(292, 99.6%, 32.4%, 0.432)",
  plumA9: "hsla(292, 99.9%, 31.0%, 0.710)",
  plumA10: "hsla(292, 99.9%, 30.8%, 0.765)",
  plumA11: "hsla(292, 99.8%, 30.7%, 0.832)",
  plumA12: "hsla(291, 99.9%, 9.7%, 0.953)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=plumA.js.map


/***/ }),

/***/ 83131:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var purple_exports = {};
__export(purple_exports, {
  purple: () => purple
});
module.exports = __toCommonJS(purple_exports);
const purple = {
  purple1: "hsl(280, 65.0%, 99.4%)",
  purple2: "hsl(276, 100%, 99.0%)",
  purple3: "hsl(276, 83.1%, 97.0%)",
  purple4: "hsl(275, 76.4%, 94.7%)",
  purple5: "hsl(275, 70.8%, 91.8%)",
  purple6: "hsl(274, 65.4%, 87.8%)",
  purple7: "hsl(273, 61.0%, 81.7%)",
  purple8: "hsl(272, 60.0%, 73.5%)",
  purple9: "hsl(272, 51.0%, 54.0%)",
  purple10: "hsl(272, 46.8%, 50.3%)",
  purple11: "hsl(272, 50.0%, 45.8%)",
  purple12: "hsl(272, 66.0%, 16.0%)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=purple.js.map


/***/ }),

/***/ 69666:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var purpleA_exports = {};
__export(purpleA_exports, {
  purpleA: () => purpleA
});
module.exports = __toCommonJS(purpleA_exports);
const purpleA = {
  purpleA1: "hsla(300, 94.3%, 34.6%, 0.012)",
  purpleA2: "hsla(276, 100%, 51.0%, 0.020)",
  purpleA3: "hsla(277, 99.6%, 46.5%, 0.055)",
  purpleA4: "hsla(274, 97.9%, 44.3%, 0.095)",
  purpleA5: "hsla(276, 98.6%, 42.0%, 0.142)",
  purpleA6: "hsla(275, 100%, 39.2%, 0.200)",
  purpleA7: "hsla(273, 99.2%, 38.2%, 0.295)",
  purpleA8: "hsla(272, 99.7%, 37.6%, 0.424)",
  purpleA9: "hsla(272, 99.6%, 34.0%, 0.695)",
  purpleA10: "hsla(272, 99.7%, 32.0%, 0.730)",
  purpleA11: "hsla(272, 99.8%, 29.7%, 0.773)",
  purpleA12: "hsla(272, 99.2%, 11.3%, 0.946)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=purpleA.js.map


/***/ }),

/***/ 11947:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var red_exports = {};
__export(red_exports, {
  red: () => red
});
module.exports = __toCommonJS(red_exports);
const red = {
  red1: "hsl(359, 100%, 99.4%)",
  red2: "hsl(359, 100%, 98.6%)",
  red3: "hsl(360, 100%, 96.8%)",
  red4: "hsl(360, 97.9%, 94.8%)",
  red5: "hsl(360, 90.2%, 91.9%)",
  red6: "hsl(360, 81.7%, 87.8%)",
  red7: "hsl(359, 74.2%, 81.7%)",
  red8: "hsl(359, 69.5%, 74.3%)",
  red9: "hsl(358, 75.0%, 59.0%)",
  red10: "hsl(358, 69.4%, 55.2%)",
  red11: "hsl(358, 65.0%, 48.7%)",
  red12: "hsl(354, 50.0%, 14.6%)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=red.js.map


/***/ }),

/***/ 18151:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var redA_exports = {};
__export(redA_exports, {
  redA: () => redA
});
module.exports = __toCommonJS(redA_exports);
const redA = {
  redA1: "hsla(0, 100%, 51.0%, 0.012)",
  redA2: "hsla(0, 100%, 51.0%, 0.032)",
  redA3: "hsla(0, 100%, 50.2%, 0.063)",
  redA4: "hsla(0, 100%, 50.0%, 0.102)",
  redA5: "hsla(0, 99.9%, 47.5%, 0.153)",
  redA6: "hsla(0, 99.5%, 44.9%, 0.224)",
  redA7: "hsla(359, 99.7%, 42.7%, 0.318)",
  redA8: "hsla(359, 99.6%, 41.1%, 0.436)",
  redA9: "hsla(358, 99.9%, 42.9%, 0.718)",
  redA10: "hsla(358, 99.9%, 41.0%, 0.761)",
  redA11: "hsla(358, 99.8%, 38.3%, 0.832)",
  redA12: "hsla(355, 99.3%, 7.9%, 0.926)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=redA.js.map


/***/ }),

/***/ 70991:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var sage_exports = {};
__export(sage_exports, {
  sage: () => sage
});
module.exports = __toCommonJS(sage_exports);
const sage = {
  sage1: "hsl(155, 30.0%, 98.8%)",
  sage2: "hsl(150, 16.7%, 97.6%)",
  sage3: "hsl(151, 10.6%, 95.2%)",
  sage4: "hsl(151, 8.8%, 93.0%)",
  sage5: "hsl(151, 7.8%, 90.8%)",
  sage6: "hsl(152, 7.2%, 88.4%)",
  sage7: "hsl(153, 6.7%, 85.3%)",
  sage8: "hsl(154, 6.1%, 77.5%)",
  sage9: "hsl(155, 3.5%, 55.5%)",
  sage10: "hsl(154, 2.8%, 51.7%)",
  sage11: "hsl(155, 3.0%, 43.0%)",
  sage12: "hsl(155, 24.0%, 9.0%)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=sage.js.map


/***/ }),

/***/ 18203:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var sageA_exports = {};
__export(sageA_exports, {
  sageA: () => sageA
});
module.exports = __toCommonJS(sageA_exports);
const sageA = {
  sageA1: "hsla(150, 92.6%, 26.5%, 0.016)",
  sageA2: "hsla(150, 87.7%, 16.0%, 0.028)",
  sageA3: "hsla(160, 98.4%, 10.9%, 0.055)",
  sageA4: "hsla(140, 92.3%, 8.5%, 0.075)",
  sageA5: "hsla(160, 86.0%, 6.9%, 0.099)",
  sageA6: "hsla(156, 95.1%, 8.2%, 0.126)",
  sageA7: "hsla(156, 98.6%, 6.3%, 0.157)",
  sageA8: "hsla(154, 94.6%, 6.0%, 0.240)",
  sageA9: "hsla(154, 98.7%, 3.0%, 0.459)",
  sageA10: "hsla(154, 93.5%, 2.9%, 0.499)",
  sageA11: "hsla(154, 95.2%, 2.5%, 0.585)",
  sageA12: "hsla(158, 97.0%, 2.4%, 0.934)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=sageA.js.map


/***/ }),

/***/ 8258:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var sand_exports = {};
__export(sand_exports, {
  sand: () => sand
});
module.exports = __toCommonJS(sand_exports);
const sand = {
  sand1: "hsl(50, 20.0%, 99.0%)",
  sand2: "hsl(60, 7.7%, 97.5%)",
  sand3: "hsl(59, 6.5%, 95.1%)",
  sand4: "hsl(58, 6.1%, 92.9%)",
  sand5: "hsl(57, 6.0%, 90.7%)",
  sand6: "hsl(56, 5.9%, 88.4%)",
  sand7: "hsl(55, 5.9%, 85.2%)",
  sand8: "hsl(51, 6.0%, 77.1%)",
  sand9: "hsl(50, 2.0%, 55.7%)",
  sand10: "hsl(55, 1.7%, 51.9%)",
  sand11: "hsl(50, 2.0%, 43.1%)",
  sand12: "hsl(50, 6.0%, 10.0%)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=sand.js.map


/***/ }),

/***/ 12638:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var sandA_exports = {};
__export(sandA_exports, {
  sandA: () => sandA
});
module.exports = __toCommonJS(sandA_exports);
const sandA = {
  sandA1: "hsla(60, 89.3%, 18.3%, 0.012)",
  sandA2: "hsla(60, 78.1%, 9.0%, 0.028)",
  sandA3: "hsla(60, 99.0%, 3.9%, 0.051)",
  sandA4: "hsla(60, 88.9%, 5.9%, 0.075)",
  sandA5: "hsla(60, 86.0%, 6.9%, 0.099)",
  sandA6: "hsla(60, 93.2%, 5.2%, 0.122)",
  sandA7: "hsla(60, 98.3%, 5.1%, 0.157)",
  sandA8: "hsla(51, 94.1%, 6.0%, 0.244)",
  sandA9: "hsla(60, 99.8%, 1.7%, 0.451)",
  sandA10: "hsla(60, 90.7%, 1.8%, 0.491)",
  sandA11: "hsla(45, 93.7%, 1.5%, 0.577)",
  sandA12: "hsla(60, 98.0%, 0.7%, 0.906)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=sandA.js.map


/***/ }),

/***/ 81800:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var sky_exports = {};
__export(sky_exports, {
  sky: () => sky
});
module.exports = __toCommonJS(sky_exports);
const sky = {
  sky1: "hsl(193, 100%, 98.8%)",
  sky2: "hsl(193, 100%, 97.3%)",
  sky3: "hsl(193, 99.0%, 94.7%)",
  sky4: "hsl(193, 91.4%, 91.4%)",
  sky5: "hsl(194, 82.0%, 86.6%)",
  sky6: "hsl(194, 74.1%, 79.5%)",
  sky7: "hsl(194, 72.3%, 69.6%)",
  sky8: "hsl(193, 77.9%, 53.9%)",
  sky9: "hsl(193, 98.0%, 70.0%)",
  sky10: "hsl(193, 87.0%, 66.5%)",
  sky11: "hsl(195, 100%, 31.5%)",
  sky12: "hsl(195, 100%, 13.0%)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=sky.js.map


/***/ }),

/***/ 8613:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var skyA_exports = {};
__export(skyA_exports, {
  skyA: () => skyA
});
module.exports = __toCommonJS(skyA_exports);
const skyA = {
  skyA1: "hsla(190, 100%, 51.0%, 0.024)",
  skyA2: "hsla(193, 100%, 50.1%, 0.055)",
  skyA3: "hsla(193, 100%, 50.1%, 0.106)",
  skyA4: "hsla(194, 99.6%, 47.7%, 0.165)",
  skyA5: "hsla(194, 99.2%, 45.4%, 0.244)",
  skyA6: "hsla(194, 99.9%, 42.3%, 0.357)",
  skyA7: "hsla(194, 99.8%, 42.2%, 0.526)",
  skyA8: "hsla(193, 99.9%, 43.8%, 0.820)",
  skyA9: "hsla(193, 99.7%, 49.4%, 0.593)",
  skyA10: "hsla(193, 99.8%, 46.6%, 0.628)",
  skyA11: "hsla(196, 100%, 31.2%, 0.980)",
  skyA12: "hsla(196, 100%, 12.2%, 0.980)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=skyA.js.map


/***/ }),

/***/ 45435:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var slate_exports = {};
__export(slate_exports, {
  slate: () => slate
});
module.exports = __toCommonJS(slate_exports);
const slate = {
  slate1: "hsl(206, 30.0%, 98.8%)",
  slate2: "hsl(210, 16.7%, 97.6%)",
  slate3: "hsl(209, 13.3%, 95.3%)",
  slate4: "hsl(209, 12.2%, 93.2%)",
  slate5: "hsl(208, 11.7%, 91.1%)",
  slate6: "hsl(208, 11.3%, 88.9%)",
  slate7: "hsl(207, 11.1%, 85.9%)",
  slate8: "hsl(205, 10.7%, 78.0%)",
  slate9: "hsl(206, 6.0%, 56.1%)",
  slate10: "hsl(206, 5.8%, 52.3%)",
  slate11: "hsl(206, 6.0%, 43.5%)",
  slate12: "hsl(206, 24.0%, 9.0%)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=slate.js.map


/***/ }),

/***/ 94451:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var slateA_exports = {};
__export(slateA_exports, {
  slateA: () => slateA
});
module.exports = __toCommonJS(slateA_exports);
const slateA = {
  slateA1: "hsla(210, 92.6%, 26.5%, 0.016)",
  slateA2: "hsla(210, 87.7%, 16.0%, 0.028)",
  slateA3: "hsla(210, 98.8%, 14.4%, 0.055)",
  slateA4: "hsla(210, 94.1%, 11.1%, 0.075)",
  slateA5: "hsla(216, 91.1%, 10.9%, 0.099)",
  slateA6: "hsla(206, 96.4%, 11.3%, 0.126)",
  slateA7: "hsla(210, 99.1%, 10.1%, 0.157)",
  slateA8: "hsla(205, 96.5%, 10.0%, 0.244)",
  slateA9: "hsla(206, 98.8%, 5.9%, 0.467)",
  slateA10: "hsla(206, 99.6%, 5.4%, 0.506)",
  slateA11: "hsla(206, 97.0%, 4.8%, 0.593)",
  slateA12: "hsla(202, 97.0%, 2.4%, 0.934)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=slateA.js.map


/***/ }),

/***/ 41565:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var teal_exports = {};
__export(teal_exports, {
  teal: () => teal
});
module.exports = __toCommonJS(teal_exports);
const teal = {
  teal1: "hsl(165, 60.0%, 98.8%)",
  teal2: "hsl(169, 64.7%, 96.7%)",
  teal3: "hsl(169, 59.8%, 94.0%)",
  teal4: "hsl(169, 53.1%, 90.2%)",
  teal5: "hsl(170, 47.1%, 85.0%)",
  teal6: "hsl(170, 42.6%, 77.9%)",
  teal7: "hsl(170, 39.9%, 68.1%)",
  teal8: "hsl(172, 42.1%, 52.5%)",
  teal9: "hsl(173, 80.0%, 36.0%)",
  teal10: "hsl(173, 83.4%, 32.5%)",
  teal11: "hsl(174, 90.0%, 25.2%)",
  teal12: "hsl(170, 50.0%, 12.5%)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=teal.js.map


/***/ }),

/***/ 246:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var tealA_exports = {};
__export(tealA_exports, {
  tealA: () => tealA
});
module.exports = __toCommonJS(tealA_exports);
const tealA = {
  tealA1: "hsla(165, 95.2%, 41.2%, 0.020)",
  tealA2: "hsla(169, 99.5%, 39.4%, 0.055)",
  tealA3: "hsla(167, 97.6%, 38.1%, 0.095)",
  tealA4: "hsla(168, 98.1%, 34.6%, 0.150)",
  tealA5: "hsla(170, 99.4%, 32.3%, 0.220)",
  tealA6: "hsla(170, 99.7%, 30.1%, 0.314)",
  tealA7: "hsla(170, 99.3%, 28.7%, 0.448)",
  tealA8: "hsla(172, 99.8%, 29.7%, 0.675)",
  tealA9: "hsla(173, 99.8%, 31.1%, 0.930)",
  tealA10: "hsla(173, 99.7%, 28.7%, 0.946)",
  tealA11: "hsla(174, 99.8%, 23.3%, 0.977)",
  tealA12: "hsla(171, 98.8%, 6.8%, 0.938)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=tealA.js.map


/***/ }),

/***/ 5840:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var tomato_exports = {};
__export(tomato_exports, {
  tomato: () => tomato
});
module.exports = __toCommonJS(tomato_exports);
const tomato = {
  tomato1: "hsl(10, 100%, 99.4%)",
  tomato2: "hsl(8, 100%, 98.4%)",
  tomato3: "hsl(8, 100%, 96.6%)",
  tomato4: "hsl(8, 100%, 94.3%)",
  tomato5: "hsl(8, 92.8%, 91.0%)",
  tomato6: "hsl(9, 84.7%, 86.3%)",
  tomato7: "hsl(10, 77.3%, 79.5%)",
  tomato8: "hsl(10, 71.6%, 71.0%)",
  tomato9: "hsl(10, 78.0%, 54.0%)",
  tomato10: "hsl(10, 71.5%, 50.0%)",
  tomato11: "hsl(10, 82.0%, 43.5%)",
  tomato12: "hsl(10, 50.0%, 13.5%)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=tomato.js.map


/***/ }),

/***/ 33094:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var tomatoA_exports = {};
__export(tomatoA_exports, {
  tomatoA: () => tomatoA
});
module.exports = __toCommonJS(tomatoA_exports);
const tomatoA = {
  tomatoA1: "hsla(0, 100%, 51.0%, 0.012)",
  tomatoA2: "hsla(8, 100%, 51.0%, 0.032)",
  tomatoA3: "hsla(7, 100%, 50.2%, 0.067)",
  tomatoA4: "hsla(8, 100%, 50.1%, 0.114)",
  tomatoA5: "hsla(7, 99.5%, 47.9%, 0.173)",
  tomatoA6: "hsla(9, 99.9%, 46.2%, 0.255)",
  tomatoA7: "hsla(10, 99.8%, 43.6%, 0.365)",
  tomatoA8: "hsla(10, 99.5%, 41.8%, 0.499)",
  tomatoA9: "hsla(10, 99.9%, 43.8%, 0.820)",
  tomatoA10: "hsla(10, 100%, 41.8%, 0.859)",
  tomatoA11: "hsla(10, 99.9%, 38.8%, 0.922)",
  tomatoA12: "hsla(10, 99.0%, 7.4%, 0.934)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=tomatoA.js.map


/***/ }),

/***/ 48981:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var violet_exports = {};
__export(violet_exports, {
  violet: () => violet
});
module.exports = __toCommonJS(violet_exports);
const violet = {
  violet1: "hsl(255, 65.0%, 99.4%)",
  violet2: "hsl(252, 100%, 99.0%)",
  violet3: "hsl(252, 96.9%, 97.4%)",
  violet4: "hsl(252, 91.5%, 95.5%)",
  violet5: "hsl(252, 85.1%, 93.0%)",
  violet6: "hsl(252, 77.8%, 89.4%)",
  violet7: "hsl(252, 71.0%, 83.7%)",
  violet8: "hsl(252, 68.6%, 76.3%)",
  violet9: "hsl(252, 56.0%, 57.5%)",
  violet10: "hsl(251, 48.1%, 53.5%)",
  violet11: "hsl(250, 43.0%, 48.0%)",
  violet12: "hsl(254, 60.0%, 18.5%)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=violet.js.map


/***/ }),

/***/ 26985:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var violetA_exports = {};
__export(violetA_exports, {
  violetA: () => violetA
});
module.exports = __toCommonJS(violetA_exports);
const violetA = {
  violetA1: "hsla(270, 94.3%, 34.6%, 0.012)",
  violetA2: "hsla(252, 100%, 51.0%, 0.020)",
  violetA3: "hsla(254, 100%, 50.0%, 0.051)",
  violetA4: "hsla(251, 98.3%, 48.2%, 0.087)",
  violetA5: "hsla(252, 99.0%, 45.7%, 0.130)",
  violetA6: "hsla(251, 99.1%, 44.0%, 0.189)",
  violetA7: "hsla(252, 99.5%, 41.7%, 0.279)",
  violetA8: "hsla(252, 100%, 40.7%, 0.400)",
  violetA9: "hsla(252, 99.9%, 35.8%, 0.663)",
  violetA10: "hsla(251, 99.6%, 32.5%, 0.691)",
  violetA11: "hsla(250, 99.8%, 28.4%, 0.726)",
  violetA12: "hsla(254, 99.5%, 11.9%, 0.926)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=violetA.js.map


/***/ }),

/***/ 80353:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var yellow_exports = {};
__export(yellow_exports, {
  yellow: () => yellow
});
module.exports = __toCommonJS(yellow_exports);
const yellow = {
  yellow1: "hsl(60, 54.0%, 98.5%)",
  yellow2: "hsl(52, 100%, 95.5%)",
  yellow3: "hsl(55, 100%, 90.9%)",
  yellow4: "hsl(54, 100%, 86.6%)",
  yellow5: "hsl(52, 97.9%, 82.0%)",
  yellow6: "hsl(50, 89.4%, 76.1%)",
  yellow7: "hsl(47, 80.4%, 68.0%)",
  yellow8: "hsl(48, 100%, 46.1%)",
  yellow9: "hsl(53, 92.0%, 50.0%)",
  yellow10: "hsl(50, 100%, 48.5%)",
  yellow11: "hsl(42, 100%, 29.0%)",
  yellow12: "hsl(40, 55.0%, 13.5%)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=yellow.js.map


/***/ }),

/***/ 76827:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var yellowA_exports = {};
__export(yellowA_exports, {
  yellowA: () => yellowA
});
module.exports = __toCommonJS(yellowA_exports);
const yellowA = {
  yellowA1: "hsla(60, 94.3%, 34.6%, 0.024)",
  yellowA2: "hsla(52, 100%, 50.4%, 0.091)",
  yellowA3: "hsla(55, 100%, 50.2%, 0.181)",
  yellowA4: "hsla(54, 100%, 50.1%, 0.267)",
  yellowA5: "hsla(52, 99.9%, 49.5%, 0.357)",
  yellowA6: "hsla(50, 100%, 47.4%, 0.451)",
  yellowA7: "hsla(47, 99.8%, 44.6%, 0.577)",
  yellowA8: "hsla(48, 100%, 46.0%, 0.980)",
  yellowA9: "hsla(53, 100%, 48.0%, 0.961)",
  yellowA10: "hsla(50, 100%, 48.4%, 0.980)",
  yellowA11: "hsla(42, 100%, 28.6%, 0.980)",
  yellowA12: "hsla(41, 98.9%, 8.0%, 0.942)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=yellowA.js.map


/***/ }),

/***/ 49606:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var whiteA_exports = {};
__export(whiteA_exports, {
  whiteA: () => whiteA
});
module.exports = __toCommonJS(whiteA_exports);
const whiteA = {
  whiteA1: "hsla(0, 0%, 100%, 0)",
  whiteA2: "hsla(0, 0%, 100%, 0.013)",
  whiteA3: "hsla(0, 0%, 100%, 0.034)",
  whiteA4: "hsla(0, 0%, 100%, 0.056)",
  whiteA5: "hsla(0, 0%, 100%, 0.086)",
  whiteA6: "hsla(0, 0%, 100%, 0.124)",
  whiteA7: "hsla(0, 0%, 100%, 0.176)",
  whiteA8: "hsla(0, 0%, 100%, 0.249)",
  whiteA9: "hsla(0, 0%, 100%, 0.386)",
  whiteA10: "hsla(0, 0%, 100%, 0.446)",
  whiteA11: "hsla(0, 0%, 100%, 0.592)",
  whiteA12: "hsla(0, 0%, 100%, 0.923)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=whiteA.js.map


/***/ }),

/***/ 276:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var compose_refs_exports = {};
__export(compose_refs_exports, {
  composeRefs: () => composeRefs,
  useComposedRefs: () => useComposedRefs
});
module.exports = __toCommonJS(compose_refs_exports);
var React = __toESM(__webpack_require__(2784));
function setRef(ref, value) {
  if (typeof ref === "function") {
    ref(value);
  } else if (ref) {
    ;
    ref.current = value;
  }
}
function composeRefs(...refs) {
  return (node) => refs.forEach((ref) => setRef(ref, node));
}
function useComposedRefs(...refs) {
  return React.useCallback(composeRefs(...refs), refs);
}
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=compose-refs.js.map


/***/ }),

/***/ 7199:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var src_exports = {};
module.exports = __toCommonJS(src_exports);
__reExport(src_exports, __webpack_require__(276), module.exports);
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 14598:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ composeRefs; },
/* harmony export */   "e": function() { return /* binding */ useComposedRefs; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

function setRef(ref, value) {
  if (typeof ref === "function") {
    ref(value);
  } else if (ref) {
    ;
    ref.current = value;
  }
}
function composeRefs(...refs) {
  return (node) => refs.forEach((ref) => setRef(ref, node));
}
function useComposedRefs(...refs) {
  return react__WEBPACK_IMPORTED_MODULE_0__.useCallback(composeRefs(...refs), refs);
}

//# sourceMappingURL=compose-refs.js.map


/***/ }),

/***/ 35213:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(34406);

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var src_exports = {};
__export(src_exports, {
  isChrome: () => isChrome,
  isClient: () => isClient,
  isRSC: () => isRSC,
  isServer: () => isServer,
  isTouchable: () => isTouchable,
  isWeb: () => isWeb,
  isWebTouchable: () => isWebTouchable,
  isWindowDefined: () => isWindowDefined,
  useIsomorphicLayoutEffect: () => useIsomorphicLayoutEffect
});
module.exports = __toCommonJS(src_exports);
var import_react = __webpack_require__(2784);
const import_meta = {};
const isWeb = "web" === "web";
const isWindowDefined = typeof window !== "undefined";
const isServer = isWeb && !isWindowDefined;
const isClient = isWeb && isWindowDefined;
const isRSC = process.env.ENABLE_RSC ? (
  // note this is statically analyzed so no funny business, just access it without optional chaining
  // @ts-ignore
  import_meta.env ? (
    // @ts-ignore
    import_meta.env.SSR
  ) : false
) : false;
const idFn = () => {
};
const useIsomorphicLayoutEffect = isRSC ? idFn : isServer ? import_react.useEffect : import_react.useLayoutEffect;
const isChrome = typeof navigator !== "undefined" && /Chrome/.test(navigator.userAgent || "");
const isWebTouchable = isClient && ("ontouchstart" in window || navigator.maxTouchPoints > 0);
const isTouchable = !isWeb || isWebTouchable;
if (false) {}
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 53498:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var create_context_exports = {};
__export(create_context_exports, {
  createContext: () => createContext,
  createContextScope: () => createContextScope
});
module.exports = __toCommonJS(create_context_exports);
var import_jsx_runtime = __webpack_require__(52322);
var React = __toESM(__webpack_require__(2784));
function createContext(rootComponentName, defaultContext) {
  const Context = React.createContext(defaultContext);
  function Provider(props) {
    const { children, ...context } = props;
    const value = React.useMemo(() => context, Object.values(context));
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Context.Provider, { value, children });
  }
  function useContext(consumerName) {
    const context = React.useContext(Context);
    if (context)
      return context;
    if (defaultContext !== void 0)
      return defaultContext;
    throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
  }
  Provider.displayName = `${rootComponentName}Provider`;
  return [Provider, useContext];
}
function createContextScope(scopeName, createContextScopeDeps = []) {
  let defaultContexts = [];
  function createContext2(rootComponentName, defaultContext) {
    const BaseContext = React.createContext(defaultContext);
    const index = defaultContexts.length;
    defaultContexts = [...defaultContexts, defaultContext];
    function Provider(props) {
      const { scope, children, ...context } = props;
      const Context = (scope == null ? void 0 : scope[scopeName][index]) || BaseContext;
      const value = React.useMemo(
        () => context,
        Object.values(context)
      );
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Context.Provider, { value, children });
    }
    function useContext(consumerName, scope, options) {
      const Context = (scope == null ? void 0 : scope[scopeName][index]) || BaseContext;
      const context = React.useContext(Context);
      if (context)
        return context;
      if (defaultContext !== void 0)
        return defaultContext;
      const missingContextMessage = `\`${consumerName}\` must be used within \`${rootComponentName}\``;
      if (options == null ? void 0 : options.fallback) {
        if ((options == null ? void 0 : options.warn) !== false) {
          console.warn(missingContextMessage);
        }
        return options.fallback;
      } else {
        throw new Error(missingContextMessage);
      }
    }
    Provider.displayName = `${rootComponentName}Provider`;
    return [Provider, useContext];
  }
  const createScope = () => {
    const scopeContexts = defaultContexts.map((defaultContext) => {
      return React.createContext(defaultContext);
    });
    return function useScope(scope) {
      const contexts = (scope == null ? void 0 : scope[scopeName]) || scopeContexts;
      return React.useMemo(
        () => ({ [`__scope${scopeName}`]: { ...scope, [scopeName]: contexts } }),
        [scope, contexts]
      );
    };
  };
  createScope.scopeName = scopeName;
  return [
    createContext2,
    composeContextScopes(createScope, ...createContextScopeDeps)
  ];
}
function composeContextScopes(...scopes) {
  const baseScope = scopes[0];
  if (scopes.length === 1)
    return baseScope;
  const createScope = () => {
    const scopeHooks = scopes.map((createScope2) => ({
      useScope: createScope2(),
      scopeName: createScope2.scopeName
    }));
    return function useComposedScopes(overrideScopes) {
      const nextScopes = scopeHooks.reduce((nextScopes2, { useScope, scopeName }) => {
        const scopeProps = useScope(overrideScopes);
        const currentScope = scopeProps[`__scope${scopeName}`];
        return { ...nextScopes2, ...currentScope };
      }, {});
      return React.useMemo(
        () => ({ [`__scope${baseScope.scopeName}`]: nextScopes }),
        [nextScopes]
      );
    };
  };
  createScope.scopeName = baseScope.scopeName;
  return createScope;
}
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=create-context.js.map


/***/ }),

/***/ 71913:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var src_exports = {};
module.exports = __toCommonJS(src_exports);
__reExport(src_exports, __webpack_require__(53498), module.exports);
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 57846:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ createContextScope; },
/* harmony export */   "k": function() { return /* binding */ createContext; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);


function createContext(rootComponentName, defaultContext) {
  const Context = react__WEBPACK_IMPORTED_MODULE_1__.createContext(defaultContext);
  function Provider(props) {
    const { children, ...context } = props;
    const value = react__WEBPACK_IMPORTED_MODULE_1__.useMemo(() => context, Object.values(context));
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Context.Provider, { value, children });
  }
  function useContext(consumerName) {
    const context = react__WEBPACK_IMPORTED_MODULE_1__.useContext(Context);
    if (context)
      return context;
    if (defaultContext !== void 0)
      return defaultContext;
    throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
  }
  Provider.displayName = `${rootComponentName}Provider`;
  return [Provider, useContext];
}
function createContextScope(scopeName, createContextScopeDeps = []) {
  let defaultContexts = [];
  function createContext2(rootComponentName, defaultContext) {
    const BaseContext = react__WEBPACK_IMPORTED_MODULE_1__.createContext(defaultContext);
    const index = defaultContexts.length;
    defaultContexts = [...defaultContexts, defaultContext];
    function Provider(props) {
      const { scope, children, ...context } = props;
      const Context = (scope == null ? void 0 : scope[scopeName][index]) || BaseContext;
      const value = react__WEBPACK_IMPORTED_MODULE_1__.useMemo(
        () => context,
        Object.values(context)
      );
      return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Context.Provider, { value, children });
    }
    function useContext(consumerName, scope, options) {
      const Context = (scope == null ? void 0 : scope[scopeName][index]) || BaseContext;
      const context = react__WEBPACK_IMPORTED_MODULE_1__.useContext(Context);
      if (context)
        return context;
      if (defaultContext !== void 0)
        return defaultContext;
      const missingContextMessage = `\`${consumerName}\` must be used within \`${rootComponentName}\``;
      if (options == null ? void 0 : options.fallback) {
        if ((options == null ? void 0 : options.warn) !== false) {
          console.warn(missingContextMessage);
        }
        return options.fallback;
      } else {
        throw new Error(missingContextMessage);
      }
    }
    Provider.displayName = `${rootComponentName}Provider`;
    return [Provider, useContext];
  }
  const createScope = () => {
    const scopeContexts = defaultContexts.map((defaultContext) => {
      return react__WEBPACK_IMPORTED_MODULE_1__.createContext(defaultContext);
    });
    return function useScope(scope) {
      const contexts = (scope == null ? void 0 : scope[scopeName]) || scopeContexts;
      return react__WEBPACK_IMPORTED_MODULE_1__.useMemo(
        () => ({ [`__scope${scopeName}`]: { ...scope, [scopeName]: contexts } }),
        [scope, contexts]
      );
    };
  };
  createScope.scopeName = scopeName;
  return [
    createContext2,
    composeContextScopes(createScope, ...createContextScopeDeps)
  ];
}
function composeContextScopes(...scopes) {
  const baseScope = scopes[0];
  if (scopes.length === 1)
    return baseScope;
  const createScope = () => {
    const scopeHooks = scopes.map((createScope2) => ({
      useScope: createScope2(),
      scopeName: createScope2.scopeName
    }));
    return function useComposedScopes(overrideScopes) {
      const nextScopes = scopeHooks.reduce((nextScopes2, { useScope, scopeName }) => {
        const scopeProps = useScope(overrideScopes);
        const currentScope = scopeProps[`__scope${scopeName}`];
        return { ...nextScopes2, ...currentScope };
      }, {});
      return react__WEBPACK_IMPORTED_MODULE_1__.useMemo(
        () => ({ [`__scope${baseScope.scopeName}`]: nextScopes }),
        [nextScopes]
      );
    };
  };
  createScope.scopeName = baseScope.scopeName;
  return createScope;
}

//# sourceMappingURL=create-context.js.map


/***/ }),

/***/ 5774:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var src_exports = {};
__export(src_exports, {
  addChildren: () => addChildren,
  applyMask: () => applyMask,
  createShiftMask: () => createShiftMask,
  createStrengthenMask: () => createStrengthenMask,
  createTheme: () => createTheme,
  createWeakenMask: () => createWeakenMask
});
module.exports = __toCommonJS(src_exports);
const THEME_INFO = /* @__PURE__ */ new WeakMap();
function createTheme(palette, definition, options) {
  const theme = {
    ...Object.fromEntries(
      Object.entries(definition).map(([key, offset]) => {
        return [key, getValue(palette, offset)];
      })
    ),
    ...options == null ? void 0 : options.nonInheritedValues
  };
  THEME_INFO.set(theme, { palette, definition, cache: /* @__PURE__ */ new Map() });
  return theme;
}
const getValue = (palette, value) => {
  if (typeof value === "string")
    return value;
  const max = palette.length - 1;
  const isPositive = value === 0 ? !isMinusZero(value) : value >= 0;
  const next = isPositive ? value : max + value;
  const index = Math.min(Math.max(0, next), max);
  return palette[index];
};
function addChildren(themes, getChildren) {
  const out = { ...themes };
  for (const key in themes) {
    const subThemes = getChildren(key, themes[key]);
    for (const sKey in subThemes) {
      out[`${key}_${sKey}`] = subThemes[sKey];
    }
  }
  return out;
}
const createShiftMask = ({ inverse } = {}) => {
  return (template, { skip, max: maxIn, palette, min = 0, strength = 1 }) => {
    const values = Object.entries(template);
    const max = maxIn ?? (palette ? Object.values(palette).length - 1 : Infinity);
    const out = {};
    for (const [key, value] of values) {
      if (typeof value === "string")
        continue;
      if (skip && key in skip) {
        continue;
      }
      const isPositive = value === 0 ? !isMinusZero(value) : value >= 0;
      const direction = isPositive ? 1 : -1;
      const invert = inverse ? -1 : 1;
      const next = value + strength * direction * invert;
      const clamped = isPositive ? Math.max(min, Math.min(max, next)) : Math.min(-min, Math.max(-max, next));
      out[key] = clamped;
    }
    return out;
  };
};
const createWeakenMask = () => createShiftMask();
const createStrengthenMask = () => createShiftMask({ inverse: true });
function isMinusZero(value) {
  return 1 / value === -Infinity;
}
const MaskKeyCache = /* @__PURE__ */ new WeakMap();
function applyMask(theme, mask, options = {}) {
  const info = THEME_INFO.get(theme);
  if (!info) {
    throw new Error(
       false ? 0 : `\u274C Err2`
    );
  }
  const maskKey = MaskKeyCache.get(mask) ?? `${Math.random()}`;
  MaskKeyCache.set(mask, maskKey);
  const key = `${maskKey}${JSON.stringify(options)}`;
  if (info.cache.has(key)) {
    return info.cache.get(key);
  }
  const template = mask(info.definition, {
    palette: info.palette,
    ...options
  });
  const next = createTheme(info.palette, template);
  info.cache.set(key, next);
  return next;
}
if (false) {}
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 95964:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Dialog_exports = {};
__export(Dialog_exports, {
  Dialog: () => Dialog,
  DialogClose: () => DialogClose,
  DialogContent: () => DialogContent,
  DialogDescription: () => DialogDescription,
  DialogOverlay: () => DialogOverlay,
  DialogPortal: () => DialogPortal,
  DialogPortalFrame: () => DialogPortalFrame,
  DialogSheetContents: () => DialogSheetContents,
  DialogTitle: () => DialogTitle,
  DialogTrigger: () => DialogTrigger,
  DialogWarningProvider: () => DialogWarningProvider,
  createDialogScope: () => createDialogScope
});
module.exports = __toCommonJS(Dialog_exports);
var import_jsx_runtime = __webpack_require__(52322);
var import_adapt = __webpack_require__(8242);
var import_animate_presence = __webpack_require__(90625);
var import_aria_hidden = __webpack_require__(95613);
var import_compose_refs = __webpack_require__(7199);
var import_core = __webpack_require__(44996);
var import_create_context = __webpack_require__(71913);
var import_dismissable = __webpack_require__(51818);
var import_focus_scope = __webpack_require__(50807);
var import_portal = __webpack_require__(69564);
var import_remove_scroll = __webpack_require__(85293);
var import_sheet = __webpack_require__(24226);
var import_stacks = __webpack_require__(84432);
var import_text = __webpack_require__(48175);
var import_use_controllable_state = __webpack_require__(12113);
var React = __toESM(__webpack_require__(2784));
const DIALOG_NAME = "Dialog";
const [createDialogContext, createDialogScope] = (0, import_create_context.createContextScope)(DIALOG_NAME);
const [DialogProvider, useDialogContext] = createDialogContext(DIALOG_NAME);
const TRIGGER_NAME = "DialogTrigger";
const DialogTriggerFrame = (0, import_core.styled)(import_stacks.YStack, {
  name: TRIGGER_NAME
});
const DialogTrigger = React.forwardRef(
  (props, forwardedRef) => {
    const { __scopeDialog, ...triggerProps } = props;
    const context = useDialogContext(TRIGGER_NAME, __scopeDialog);
    const composedTriggerRef = (0, import_compose_refs.useComposedRefs)(forwardedRef, context.triggerRef);
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
      DialogTriggerFrame,
      {
        tag: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": context.open,
        "aria-controls": context.contentId,
        "data-state": getState(context.open),
        ...triggerProps,
        ref: composedTriggerRef,
        onPress: (0, import_core.composeEventHandlers)(props.onPress, context.onOpenToggle)
      }
    );
  }
);
DialogTrigger.displayName = TRIGGER_NAME;
const PORTAL_NAME = "DialogPortal";
const [PortalProvider, usePortalContext] = createDialogContext(
  PORTAL_NAME,
  {
    forceMount: void 0
  }
);
const DialogPortalFrame = (0, import_core.styled)(import_stacks.YStack, {
  alignItems: "center",
  justifyContent: "center",
  fullscreen: true,
  zIndex: 100,
  ...import_core.isWeb && {
    maxHeight: "100vh",
    position: "fixed"
  }
});
const DialogPortalItem = (props) => {
  const themeName = (0, import_core.useThemeName)();
  const context = useDialogContext(PORTAL_NAME, props.__scopeDialog);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_portal.PortalItem, { hostName: props.hostName, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(DialogPortalItemContent, { ...props, themeName, context }) });
};
function DialogPortalItemContent(props) {
  const {
    __scopeDialog,
    children,
    context,
    themeName,
    space,
    spaceDirection,
    separator
  } = props;
  let childrenSpaced = children;
  if (space || separator) {
    childrenSpaced = (0, import_core.spacedChildren)({
      children,
      separator,
      space,
      direction: spaceDirection
    });
  }
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(DialogProvider, { scope: __scopeDialog, ...context, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_core.Theme, { name: themeName, children: childrenSpaced }) });
}
const DialogPortal = (props) => {
  const { __scopeDialog, forceMount, children, ...frameProps } = props;
  const context = useDialogContext(PORTAL_NAME, __scopeDialog);
  const isShowing = forceMount || context.open;
  const [isFullyHidden, setIsFullyHidden] = React.useState(!isShowing);
  if (isShowing && isFullyHidden) {
    setIsFullyHidden(false);
  }
  const contents = /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
    import_animate_presence.AnimatePresence,
    {
      onExitComplete: () => {
        setIsFullyHidden(true);
      },
      children: isShowing ? children : null
    }
  );
  const isSheet = useShowDialogSheet(context);
  if (isSheet) {
    return children;
  }
  if (context.modal) {
    if (isFullyHidden) {
      return null;
    }
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(DialogPortalItem, { __scopeDialog, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(PortalProvider, { scope: __scopeDialog, forceMount, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(DialogPortalFrame, { pointerEvents: isShowing ? "auto" : "none", ...frameProps, children: contents }) }) });
  }
  return contents;
};
DialogPortal.displayName = PORTAL_NAME;
const OVERLAY_NAME = "DialogOverlay";
const DialogOverlayFrame = (0, import_core.styled)(import_stacks.ThemeableStack, {
  name: OVERLAY_NAME,
  backgrounded: true,
  fullscreen: true
});
const DialogOverlay = React.forwardRef(
  ({ __scopeDialog, ...props }, forwardedRef) => {
    const portalContext = usePortalContext(OVERLAY_NAME, __scopeDialog);
    const { forceMount = portalContext.forceMount, ...overlayProps } = props;
    const context = useDialogContext(OVERLAY_NAME, __scopeDialog);
    const showSheet = useShowDialogSheet(context);
    if (!forceMount) {
      if (!context.modal || showSheet) {
        return null;
      }
    }
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(DialogOverlayImpl, { context, ...overlayProps, ref: forwardedRef });
  }
);
DialogOverlay.displayName = OVERLAY_NAME;
const DialogOverlayImpl = React.forwardRef(
  (props, forwardedRef) => {
    const { context, ...overlayProps } = props;
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
        DialogOverlayFrame,
        {
          "data-state": getState(context.open),
          pointerEvents: context.open ? "auto" : "none",
          ...overlayProps,
          ref: forwardedRef
        }
      )
    );
  }
);
const CONTENT_NAME = "DialogContent";
const DialogContentFrame = (0, import_core.styled)(import_stacks.ThemeableStack, {
  name: CONTENT_NAME,
  tag: "dialog",
  position: "relative",
  backgrounded: true,
  padded: true,
  radiused: true,
  elevate: true,
  variants: {
    size: {
      "...size": (val, extras) => {
        return {};
      }
    }
  },
  defaultVariants: {
    size: "$true"
  }
});
const DialogContent = DialogContentFrame.extractable(
  React.forwardRef(
    ({ __scopeDialog, ...props }, forwardedRef) => {
      const portalContext = usePortalContext(CONTENT_NAME, __scopeDialog);
      const { forceMount = portalContext.forceMount, ...contentProps } = props;
      const context = useDialogContext(CONTENT_NAME, __scopeDialog);
      const contents = context.modal ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(DialogContentModal, { context, ...contentProps, ref: forwardedRef }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(DialogContentNonModal, { context, ...contentProps, ref: forwardedRef });
      if (!import_core.isWeb) {
        return contents;
      }
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
        import_remove_scroll.RemoveScroll,
        {
          forwardProps: true,
          enabled: context.open,
          allowPinchZoom: context.allowPinchZoom,
          shards: [context.contentRef],
          removeScrollBar: false,
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", { className: "_dsp_contents", children: contents })
        }
      );
    }
  )
);
DialogContent.displayName = CONTENT_NAME;
const DialogContentModal = React.forwardRef(
  ({ children, context, ...props }, forwardedRef) => {
    const contentRef = React.useRef(null);
    const composedRefs = (0, import_compose_refs.useComposedRefs)(forwardedRef, context.contentRef, contentRef);
    if (import_core.isWeb) {
      React.useEffect(() => {
        if (!context.open)
          return;
        const content = contentRef.current;
        if (content)
          return (0, import_aria_hidden.hideOthers)(content);
      }, [context.open]);
    }
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
      DialogContentImpl,
      {
        ...props,
        context,
        ref: composedRefs,
        disableOutsidePointerEvents: true,
        onCloseAutoFocus: (0, import_core.composeEventHandlers)(props.onCloseAutoFocus, (event) => {
          var _a;
          event.preventDefault();
          (_a = context.triggerRef.current) == null ? void 0 : _a.focus();
        }),
        onPointerDownOutside: (0, import_core.composeEventHandlers)(
          props.onPointerDownOutside,
          (event) => {
            const originalEvent = event["detail"].originalEvent;
            const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
            const isRightClick = originalEvent.button === 2 || ctrlLeftClick;
            if (isRightClick)
              event.preventDefault();
          }
        ),
        onFocusOutside: (0, import_core.composeEventHandlers)(
          props.onFocusOutside,
          (event) => event.preventDefault()
        ),
        children
      }
    );
  }
);
const DialogContentNonModal = React.forwardRef(
  (props, forwardedRef) => {
    const hasInteractedOutsideRef = React.useRef(false);
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
      DialogContentImpl,
      {
        ...props,
        ref: forwardedRef,
        trapFocus: false,
        disableOutsidePointerEvents: false,
        onCloseAutoFocus: (event) => {
          var _a, _b;
          (_a = props.onCloseAutoFocus) == null ? void 0 : _a.call(props, event);
          if (!event.defaultPrevented) {
            if (!hasInteractedOutsideRef.current) {
              (_b = props.context.triggerRef.current) == null ? void 0 : _b.focus();
            }
            event.preventDefault();
          }
          hasInteractedOutsideRef.current = false;
        },
        onInteractOutside: (event) => {
          var _a;
          (_a = props.onInteractOutside) == null ? void 0 : _a.call(props, event);
          if (!event.defaultPrevented)
            hasInteractedOutsideRef.current = true;
          const target = event.target;
          const trigger = props.context.triggerRef.current;
          if (!(trigger instanceof HTMLElement))
            return;
          const targetIsTrigger = trigger.contains(target);
          if (targetIsTrigger)
            event.preventDefault();
        }
      }
    );
  }
);
const DialogContentImpl = React.forwardRef(
  (props, forwardedRef) => {
    const {
      __scopeDialog,
      trapFocus,
      onOpenAutoFocus,
      onCloseAutoFocus,
      disableOutsidePointerEvents,
      onEscapeKeyDown,
      onPointerDownOutside,
      onFocusOutside,
      onInteractOutside,
      context,
      ...contentProps
    } = props;
    const contentRef = React.useRef(null);
    const composedRefs = (0, import_compose_refs.useComposedRefs)(forwardedRef, contentRef);
    const showSheet = useShowDialogSheet(context);
    const contents = /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
      DialogContentFrame,
      {
        id: context.contentId,
        "aria-describedby": context.descriptionId,
        "aria-labelledby": context.titleId,
        "data-state": getState(context.open),
        ...contentProps
      }
    );
    if (showSheet) {
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(DialogPortalItem, { hostName: getSheetContentsName(context), children: contentProps.children });
    }
    if (!import_core.isWeb) {
      return contents;
    }
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, { children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
        import_focus_scope.FocusScope,
        {
          loop: true,
          trapped: trapFocus,
          onMountAutoFocus: onOpenAutoFocus,
          forceUnmount: !context.open,
          onUnmountAutoFocus: onCloseAutoFocus,
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
            import_dismissable.Dismissable,
            {
              disableOutsidePointerEvents: context.open && disableOutsidePointerEvents,
              forceUnmount: !context.open,
              onEscapeKeyDown,
              onPointerDownOutside,
              onFocusOutside,
              onInteractOutside,
              ref: composedRefs,
              onDismiss: () => context.onOpenChange(false),
              children: contents
            }
          )
        }
      ),
       false && /* @__PURE__ */ 0
    ] });
  }
);
const TITLE_NAME = "DialogTitle";
const DialogTitleFrame = (0, import_core.styled)(import_text.H2, {
  name: TITLE_NAME
});
const DialogTitle = React.forwardRef(
  (props, forwardedRef) => {
    const { __scopeDialog, ...titleProps } = props;
    const context = useDialogContext(TITLE_NAME, __scopeDialog);
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(DialogTitleFrame, { id: context.titleId, ...titleProps, ref: forwardedRef });
  }
);
DialogTitle.displayName = TITLE_NAME;
const DialogDescriptionFrame = (0, import_core.styled)(import_text.Paragraph, {
  name: "DialogDescription"
});
const DESCRIPTION_NAME = "DialogDescription";
const DialogDescription = React.forwardRef(
  (props, forwardedRef) => {
    const { __scopeDialog, ...descriptionProps } = props;
    const context = useDialogContext(DESCRIPTION_NAME, __scopeDialog);
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
      DialogDescriptionFrame,
      {
        id: context.descriptionId,
        ...descriptionProps,
        ref: forwardedRef
      }
    );
  }
);
DialogDescription.displayName = DESCRIPTION_NAME;
const CLOSE_NAME = "DialogClose";
const DialogClose = React.forwardRef(
  (props, forwardedRef) => {
    const { __scopeDialog, displayWhenAdapted, ...closeProps } = props;
    const context = useDialogContext(CLOSE_NAME, __scopeDialog, {
      warn: false,
      fallback: {}
    });
    const isSheet = useShowDialogSheet(context);
    if (isSheet && !displayWhenAdapted) {
      return null;
    }
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
      import_stacks.YStack,
      {
        tag: "button",
        accessibilityLabel: "Dialog Close",
        ...closeProps,
        ref: forwardedRef,
        onPress: (0, import_core.composeEventHandlers)(
          props.onPress,
          () => context.onOpenChange(false)
        )
      }
    );
  }
);
DialogClose.displayName = CLOSE_NAME;
function getState(open) {
  return open ? "open" : "closed";
}
const TITLE_WARNING_NAME = "DialogTitleWarning";
const [DialogWarningProvider, useWarningContext] = (0, import_create_context.createContext)(TITLE_WARNING_NAME, {
  contentName: CONTENT_NAME,
  titleName: TITLE_NAME,
  docsSlug: "dialog"
});
const TitleWarning = ({ titleId }) => {
  if (false) {}
  return null;
};
const DESCRIPTION_WARNING_NAME = "DialogDescriptionWarning";
const DescriptionWarning = ({
  contentRef,
  descriptionId
}) => {
  if (false) {}
  return null;
};
const Dialog = (0, import_core.withStaticProperties)(
  React.forwardRef(function Dialog2(props, ref) {
    const {
      __scopeDialog,
      children,
      open: openProp,
      defaultOpen = false,
      onOpenChange,
      modal = true,
      allowPinchZoom = false
    } = props;
    const scopeId = (0, import_core.useId)();
    const contentId = (0, import_core.useId)();
    const titleId = (0, import_core.useId)();
    const descriptionId = (0, import_core.useId)();
    const scopeKey = __scopeDialog ? Object.keys(__scopeDialog)[0] : scopeId;
    const sheetContentsName = getSheetContentsName({ scopeKey, contentId });
    const triggerRef = React.useRef(null);
    const contentRef = React.useRef(null);
    const [open, setOpen] = (0, import_use_controllable_state.useControllableState)({
      prop: openProp,
      defaultProp: defaultOpen,
      onChange: onOpenChange
    });
    const onOpenToggle = React.useCallback(
      () => setOpen((prevOpen) => !prevOpen),
      [setOpen]
    );
    const context = {
      scope: __scopeDialog,
      scopeKey,
      triggerRef,
      contentRef,
      contentId,
      titleId,
      descriptionId,
      open,
      onOpenChange: setOpen,
      onOpenToggle,
      modal,
      allowPinchZoom
    };
    const { when, AdaptProvider } = (0, import_adapt.useAdaptParent)({
      Contents: React.useCallback(
        (props2) => {
          return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_portal.PortalHost, { forwardProps: props2, name: sheetContentsName });
        },
        [sheetContentsName]
      )
    });
    React.useImperativeHandle(
      ref,
      () => ({
        open: setOpen
      }),
      [setOpen]
    );
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AdaptProvider, { children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(DialogProvider, { ...context, sheetBreakpoint: when, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(DialogSheetController, { onOpenChange: setOpen, __scopeDialog, children }) }) });
  }),
  {
    Trigger: DialogTrigger,
    Portal: DialogPortal,
    Overlay: DialogOverlay,
    Content: DialogContent,
    Title: DialogTitle,
    Description: DialogDescription,
    Close: DialogClose,
    Sheet: import_sheet.ControlledSheet,
    Adapt: import_adapt.Adapt
  }
);
const SHEET_CONTENTS_NAME = "DialogSheetContents";
const DialogSheetContents = ({
  name,
  ...props
}) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_portal.PortalHost, { forwardProps: props, name });
};
DialogSheetContents.displayName = SHEET_CONTENTS_NAME;
const getSheetContentsName = ({
  scopeKey,
  contentId
}) => `${scopeKey || contentId}SheetContents`;
const DialogSheetController = (props) => {
  const context = useDialogContext("DialogSheetController", props.__scopeDialog);
  const showSheet = useShowDialogSheet(context);
  const breakpointActive = useSheetBreakpointActive(context);
  const getShowSheet = (0, import_core.useGet)(showSheet);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
    import_sheet.SheetController,
    {
      onOpenChange: (val) => {
        if (getShowSheet()) {
          props.onOpenChange(val);
        }
      },
      open: context.open,
      hidden: breakpointActive === false,
      children: props.children
    }
  );
};
const useSheetBreakpointActive = (context) => {
  const media = (0, import_core.useMedia)();
  if (!context.sheetBreakpoint)
    return false;
  if (context.sheetBreakpoint === true)
    return true;
  return media[context.sheetBreakpoint];
};
const useShowDialogSheet = (context) => {
  const breakpointActive = useSheetBreakpointActive(context);
  return context.open === false ? false : breakpointActive;
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=Dialog.js.map


/***/ }),

/***/ 5339:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var src_exports = {};
module.exports = __toCommonJS(src_exports);
__reExport(src_exports, __webpack_require__(95964), module.exports);
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 71158:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Dismissable_exports = {};
__export(Dismissable_exports, {
  Dismissable: () => Dismissable,
  DismissableBranch: () => DismissableBranch
});
module.exports = __toCommonJS(Dismissable_exports);
var import_jsx_runtime = __webpack_require__(52322);
var import_react_use_escape_keydown = __webpack_require__(11960);
var import_compose_refs = __webpack_require__(7199);
var import_core = __webpack_require__(44996);
var import_use_event = __webpack_require__(36552);
var React = __toESM(__webpack_require__(2784));
var ReactDOM = __toESM(__webpack_require__(28316));
function dispatchDiscreteCustomEvent(target, event) {
  if (target)
    ReactDOM.flushSync(() => target.dispatchEvent(event));
}
const DISMISSABLE_LAYER_NAME = "Dismissable";
const CONTEXT_UPDATE = "dismissable.update";
const POINTER_DOWN_OUTSIDE = "dismissable.pointerDownOutside";
const FOCUS_OUTSIDE = "dismissable.focusOutside";
let originalBodyPointerEvents;
const DismissableContext = React.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
});
const Dismissable = React.forwardRef(
  (props, forwardedRef) => {
    const {
      disableOutsidePointerEvents = false,
      forceUnmount,
      onEscapeKeyDown,
      onPointerDownOutside,
      onFocusOutside,
      onInteractOutside,
      onDismiss,
      ...layerProps
    } = props;
    const context = React.useContext(DismissableContext);
    const [node, setNode] = React.useState(null);
    const [, force] = React.useState({});
    const composedRefs = (0, import_compose_refs.useComposedRefs)(forwardedRef, (node2) => setNode(node2));
    const layers = Array.from(context.layers);
    const [highestLayerWithOutsidePointerEventsDisabled] = [
      ...context.layersWithOutsidePointerEventsDisabled
    ].slice(-1);
    const highestLayerWithOutsidePointerEventsDisabledIndex = layers.indexOf(
      highestLayerWithOutsidePointerEventsDisabled
    );
    const index = node ? layers.indexOf(node) : -1;
    const isBodyPointerEventsDisabled = context.layersWithOutsidePointerEventsDisabled.size > 0;
    const isPointerEventsEnabled = index >= highestLayerWithOutsidePointerEventsDisabledIndex;
    const pointerDownOutside = usePointerDownOutside((event) => {
      const target = event.target;
      const isPointerDownOnBranch = [...context.branches].some(
        (branch) => branch.contains(target)
      );
      if (!isPointerEventsEnabled || isPointerDownOnBranch)
        return;
      onPointerDownOutside == null ? void 0 : onPointerDownOutside(event);
      onInteractOutside == null ? void 0 : onInteractOutside(event);
      if (!event.defaultPrevented)
        onDismiss == null ? void 0 : onDismiss();
    });
    const focusOutside = useFocusOutside((event) => {
      const target = event.target;
      const isFocusInBranch = [...context.branches].some(
        (branch) => branch.contains(target)
      );
      if (isFocusInBranch)
        return;
      onFocusOutside == null ? void 0 : onFocusOutside(event);
      onInteractOutside == null ? void 0 : onInteractOutside(event);
      if (!event.defaultPrevented)
        onDismiss == null ? void 0 : onDismiss();
    });
    (0, import_react_use_escape_keydown.useEscapeKeydown)((event) => {
      const isHighestLayer = index === context.layers.size - 1;
      if (!isHighestLayer)
        return;
      onEscapeKeyDown == null ? void 0 : onEscapeKeyDown(event);
      if (!event.defaultPrevented && onDismiss) {
        event.preventDefault();
        onDismiss();
      }
    });
    React.useEffect(() => {
      if (!node)
        return;
      if (disableOutsidePointerEvents) {
        if (context.layersWithOutsidePointerEventsDisabled.size === 0) {
          originalBodyPointerEvents = document.body.style.pointerEvents;
          document.body.style.pointerEvents = "none";
        }
        context.layersWithOutsidePointerEventsDisabled.add(node);
      }
      context.layers.add(node);
      dispatchUpdate();
      return () => {
        if (disableOutsidePointerEvents && context.layersWithOutsidePointerEventsDisabled.size === 1) {
          document.body.style.pointerEvents = originalBodyPointerEvents;
        }
      };
    }, [node, disableOutsidePointerEvents, context]);
    React.useEffect(() => {
      if (forceUnmount)
        return;
      return () => {
        if (!node)
          return;
        context.layers.delete(node);
        context.layersWithOutsidePointerEventsDisabled.delete(node);
        dispatchUpdate();
      };
    }, [node, context, forceUnmount]);
    React.useEffect(() => {
      const handleUpdate = () => {
        force({});
      };
      document.addEventListener(CONTEXT_UPDATE, handleUpdate);
      return () => document.removeEventListener(CONTEXT_UPDATE, handleUpdate);
    }, []);
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
      "div",
      {
        ...layerProps,
        ref: composedRefs,
        style: {
          display: "contents",
          pointerEvents: isBodyPointerEventsDisabled ? isPointerEventsEnabled ? "auto" : "none" : void 0,
          // @ts-ignore
          ...props.style
        },
        onFocusCapture: (0, import_core.composeEventHandlers)(
          // @ts-ignore
          props.onFocusCapture,
          focusOutside.onFocusCapture
        ),
        onBlurCapture: (0, import_core.composeEventHandlers)(
          // @ts-ignore
          props.onBlurCapture,
          focusOutside.onBlurCapture
        ),
        onPointerDownCapture: (0, import_core.composeEventHandlers)(
          // @ts-ignore
          props.onPointerDownCapture,
          pointerDownOutside.onPointerDownCapture
        )
      }
    );
  }
);
Dismissable.displayName = DISMISSABLE_LAYER_NAME;
const BRANCH_NAME = "DismissableBranch";
const DismissableBranch = React.forwardRef(
  (props, forwardedRef) => {
    const context = React.useContext(DismissableContext);
    const ref = React.useRef(null);
    const composedRefs = (0, import_compose_refs.useComposedRefs)(forwardedRef, ref);
    React.useEffect(() => {
      const node = ref.current;
      if (node) {
        context.branches.add(node);
        return () => {
          context.branches.delete(node);
        };
      }
    }, [context.branches]);
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", { style: { display: "contents" }, ...props, ref: composedRefs });
  }
);
DismissableBranch.displayName = BRANCH_NAME;
function usePointerDownOutside(onPointerDownOutside) {
  const handlePointerDownOutside = (0, import_use_event.useEvent)(onPointerDownOutside);
  const isPointerInsideReactTreeRef = React.useRef(false);
  const handleClickRef = React.useRef(() => {
  });
  React.useEffect(() => {
    const handlePointerDown = (event) => {
      if (event.target && !isPointerInsideReactTreeRef.current) {
        let handleAndDispatchPointerDownOutsideEvent2 = function() {
          handleAndDispatchCustomEvent(
            POINTER_DOWN_OUTSIDE,
            handlePointerDownOutside,
            eventDetail,
            { discrete: true }
          );
        };
        var handleAndDispatchPointerDownOutsideEvent = handleAndDispatchPointerDownOutsideEvent2;
        const eventDetail = { originalEvent: event };
        if (event.pointerType === "touch") {
          document.removeEventListener("click", handleClickRef.current);
          handleClickRef.current = handleAndDispatchPointerDownOutsideEvent2;
          document.addEventListener("click", handleClickRef.current, { once: true });
        } else {
          handleAndDispatchPointerDownOutsideEvent2();
        }
      }
      isPointerInsideReactTreeRef.current = false;
    };
    const timerId = setTimeout(() => {
      document.addEventListener("pointerdown", handlePointerDown);
    }, 0);
    return () => {
      window.clearTimeout(timerId);
      document.removeEventListener("pointerdown", handlePointerDown);
      document.removeEventListener("click", handleClickRef.current);
    };
  }, [handlePointerDownOutside]);
  return {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => isPointerInsideReactTreeRef.current = true
  };
}
function useFocusOutside(onFocusOutside) {
  const handleFocusOutside = (0, import_use_event.useEvent)(onFocusOutside);
  const isFocusInsideReactTreeRef = React.useRef(false);
  React.useEffect(() => {
    const handleFocus = (event) => {
      if (event.target && !isFocusInsideReactTreeRef.current) {
        const eventDetail = { originalEvent: event };
        handleAndDispatchCustomEvent(FOCUS_OUTSIDE, handleFocusOutside, eventDetail, {
          discrete: false
        });
      }
    };
    document.addEventListener("focusin", handleFocus);
    return () => document.removeEventListener("focusin", handleFocus);
  }, [handleFocusOutside]);
  return {
    onFocusCapture: () => isFocusInsideReactTreeRef.current = true,
    onBlurCapture: () => isFocusInsideReactTreeRef.current = false
  };
}
function dispatchUpdate() {
  const event = new CustomEvent(CONTEXT_UPDATE);
  document.dispatchEvent(event);
}
function handleAndDispatchCustomEvent(name, handler, detail, { discrete }) {
  const target = detail.originalEvent.target;
  const event = new CustomEvent(name, { bubbles: false, cancelable: true, detail });
  if (handler)
    target.addEventListener(name, handler, { once: true });
  if (discrete) {
    dispatchDiscreteCustomEvent(target, event);
  } else {
    target.dispatchEvent(event);
  }
}
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=Dismissable.js.map


/***/ }),

/***/ 51818:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var src_exports = {};
module.exports = __toCommonJS(src_exports);
__reExport(src_exports, __webpack_require__(71158), module.exports);
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 6783:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Floating_exports = {};
module.exports = __toCommonJS(Floating_exports);
__reExport(Floating_exports, __webpack_require__(66379), module.exports);
//# sourceMappingURL=Floating.js.map


/***/ }),

/***/ 80159:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var src_exports = {};
__export(src_exports, {
  FloatingOverrideContext: () => import_useFloating.FloatingOverrideContext,
  useFloating: () => import_useFloating.useFloating
});
module.exports = __toCommonJS(src_exports);
__reExport(src_exports, __webpack_require__(6783), module.exports);
var import_useFloating = __webpack_require__(83526);
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 83526:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var useFloating_exports = {};
__export(useFloating_exports, {
  FloatingOverrideContext: () => FloatingOverrideContext,
  useFloating: () => useFloating
});
module.exports = __toCommonJS(useFloating_exports);
var import_react = __webpack_require__(2784);
var Floating = __toESM(__webpack_require__(6783));
const FloatingOverrideContext = (0, import_react.createContext)(null);
const useFloating = (props) => {
  var _a;
  const context = (0, import_react.useContext)(FloatingOverrideContext);
  return (_a = context || Floating.useFloating) == null ? void 0 : _a(props);
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=useFloating.js.map


/***/ }),

/***/ 3560:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Form_exports = {};
__export(Form_exports, {
  Form: () => Form,
  FormFrame: () => FormFrame,
  FormProvider: () => FormProvider,
  FormTrigger: () => FormTrigger,
  useFormContext: () => useFormContext
});
module.exports = __toCommonJS(Form_exports);
var import_jsx_runtime = __webpack_require__(52322);
var import_core = __webpack_require__(44996);
var import_create_context = __webpack_require__(71913);
var import_react = __webpack_require__(2784);
const FORM_NAME = "Form";
const FormFrame = (0, import_core.styled)(import_core.Stack, {
  name: FORM_NAME,
  tag: "form"
});
const [createFormContext] = (0, import_create_context.createContextScope)(FORM_NAME);
const [FormProvider, useFormContext] = createFormContext(FORM_NAME);
const TRIGGER_NAME = "FormTrigger";
const FormTriggerFrame = (0, import_core.styled)(import_core.Stack, {
  name: TRIGGER_NAME
});
const FormTrigger = FormTriggerFrame.extractable(
  (0, import_react.forwardRef)(
    (props, forwardedRef) => {
      const { __scopeForm, children, ...triggerProps } = props;
      const context = useFormContext(TRIGGER_NAME, __scopeForm);
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
        FormTriggerFrame,
        {
          tag: "button",
          ...triggerProps,
          children: triggerProps.asChild ? (0, import_react.cloneElement)(children, { disabled: triggerProps.disabled }) : children,
          ref: forwardedRef,
          onPress: (0, import_core.composeEventHandlers)(props.onPress, context.onSubmit)
        }
      );
    }
  )
);
function FormComponent({
  onSubmit,
  ...props
}) {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FormProvider, { scope: props.__scopeForm, onSubmit, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FormFrame, { ...props, onSubmit: (e) => e.preventDefault() }) });
}
const Form = (0, import_core.withStaticProperties)(FormFrame.extractable(FormComponent), {
  Trigger: FormTrigger
});
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=Form.js.map


/***/ }),

/***/ 73322:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var src_exports = {};
module.exports = __toCommonJS(src_exports);
__reExport(src_exports, __webpack_require__(3560), module.exports);
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 56701:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "getButtonSized": function() { return /* binding */ getButtonSized; }
/* harmony export */ });
/* harmony import */ var _tamagui_get_size__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20157);

const getButtonSized = (val, { tokens }) => {
  if (typeof val === "number") {
    return {
      paddingHorizontal: val * 0.25,
      height: val,
      borderRadius: val * 0.2
    };
  }
  const ySize = (0,_tamagui_get_size__WEBPACK_IMPORTED_MODULE_0__.getSize)(val, 0);
  const xSize = (0,_tamagui_get_size__WEBPACK_IMPORTED_MODULE_0__.stepTokenUpOrDown)("space", val);
  const radiusToken = tokens.radius[val] ?? tokens.radius["$true"];
  return {
    paddingHorizontal: xSize,
    height: ySize,
    borderRadius: radiusToken
  };
};

//# sourceMappingURL=index.js.map


/***/ }),

/***/ 66754:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "getFontSized": function() { return /* binding */ getFontSized; }
/* harmony export */ });
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13209);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47269);

const getFontSized = (sizeTokenIn = "$true", { fonts, props }) => {
  var _a, _b, _c;
  const family = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_0__/* .getVariableValue */ .Ve)(props.fontFamily) || "$body";
  const font = fonts[family] || fonts["$body"];
  if (!font) {
    if (false) {}
    return {};
  }
  const fontFamily = font.family;
  const sizeToken = sizeTokenIn === "$true" ? getDefaultSizeToken(font) : sizeTokenIn;
  const fontSize = props.fontSize || font.size[sizeToken];
  const lineHeight = props.lineHeight || font.lineHeight[sizeToken];
  const fontWeight = props.fontWeight || font.weight[sizeToken];
  const letterSpacing = props.letterSpacing || font.letterSpacing[sizeToken];
  const fontStyle = props.fontStyle || ((_a = font.style) == null ? void 0 : _a[sizeToken]);
  const textTransform = props.textTransform || ((_b = font.transform) == null ? void 0 : _b[sizeToken]);
  const color = props.color || ((_c = font.color) == null ? void 0 : _c[sizeToken]);
  const style = {
    color,
    fontStyle,
    textTransform,
    fontFamily,
    fontWeight,
    letterSpacing,
    fontSize,
    lineHeight
  };
  if (false) {}
  return style;
};
const cache = /* @__PURE__ */ new WeakMap();
function getDefaultSizeToken(font) {
  if (typeof font === "object" && cache.has(font)) {
    return cache.get(font);
  }
  const sizeTokens = "$true" in font.size ? font.size : (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_1__/* .getTokens */ .lz)().size;
  const sizeDefault = sizeTokens["$true"];
  const sizeDefaultSpecific = sizeDefault ? Object.keys(sizeTokens).find(
    (x) => x !== "$true" && sizeTokens[x]["val"] === sizeDefault["val"]
  ) : null;
  if (!sizeDefault || !sizeDefaultSpecific) {
    if (false) {}
    return Object.keys(font.size)[3];
  }
  cache.set(font, sizeDefaultSpecific);
  return sizeDefaultSpecific;
}

//# sourceMappingURL=index.js.map


/***/ }),

/***/ 20157:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "getSize": function() { return /* binding */ getSize; },
/* harmony export */   "stepTokenUpOrDown": function() { return /* binding */ stepTokenUpOrDown; }
/* harmony export */ });
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47269);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61298);

const getSize = (size, shift = 0, bounds = [0]) => {
  return stepTokenUpOrDown("size", size, shift, bounds);
};
const stepTokenUpOrDown = (type, name = "$true", shift = 0, bounds = [0]) => {
  const tokens = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_0__/* .getTokens */ .lz)({ prefixed: true })[type];
  const keysOrdered = _tamagui_core__WEBPACK_IMPORTED_MODULE_1__/* .tokensKeysOrdered.get */ .O.get(tokens) || Object.keys(tokens);
  const min = bounds[0] ?? 0;
  const max = bounds[1] ?? keysOrdered.length - 1;
  const currentIndex = keysOrdered.indexOf(name);
  if (name === "$true") {
    shift += shift === 0 ? 0 : shift > 0 ? 1 : -1;
  }
  const index = Math.min(max, Math.max(min, currentIndex + shift));
  const key = keysOrdered[index];
  return tokens[key] || tokens["$true"];
};

//# sourceMappingURL=index.js.map


/***/ }),

/***/ 25688:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ getSpace; }
/* harmony export */ });
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47269);

const getSpace = (token, sizeUpOrDownBy = 0) => {
  const spaces = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_0__/* .getTokens */ .lz)().space;
  const spaceNames = Object.keys(spaces);
  const key = spaceNames[Math.max(0, spaceNames.indexOf(String(token || "$true")) + sizeUpOrDownBy)];
  return spaces[key] || spaces["$true"];
};

//# sourceMappingURL=getSpace.js.map


/***/ }),

/***/ 28920:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "getSpace": function() { return /* reexport safe */ _getSpace__WEBPACK_IMPORTED_MODULE_2__.P; },
/* harmony export */   "prevent": function() { return /* reexport safe */ _prevent__WEBPACK_IMPORTED_MODULE_1__.X; },
/* harmony export */   "useCurrentColor": function() { return /* reexport safe */ _useCurrentColor__WEBPACK_IMPORTED_MODULE_3__.$; },
/* harmony export */   "useGetThemedIcon": function() { return /* reexport safe */ _useGetThemedIcon__WEBPACK_IMPORTED_MODULE_4__.Z; }
/* harmony export */ });
/* harmony import */ var _tamagui_helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99677);
/* harmony reexport (unknown) */ var __WEBPACK_REEXPORT_OBJECT__ = {};
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _tamagui_helpers__WEBPACK_IMPORTED_MODULE_0__) if(__WEBPACK_IMPORT_KEY__ !== "default") __WEBPACK_REEXPORT_OBJECT__[__WEBPACK_IMPORT_KEY__] = function(key) { return _tamagui_helpers__WEBPACK_IMPORTED_MODULE_0__[key]; }.bind(0, __WEBPACK_IMPORT_KEY__)
/* harmony reexport (unknown) */ __webpack_require__.d(__webpack_exports__, __WEBPACK_REEXPORT_OBJECT__);
/* harmony import */ var _prevent__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43438);
/* harmony import */ var _getSpace__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25688);
/* harmony import */ var _useCurrentColor__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34000);
/* harmony import */ var _useGetThemedIcon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71129);





//# sourceMappingURL=index.js.map


/***/ }),

/***/ 43438:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ prevent; }
/* harmony export */ });
const prevent = (e) => [e.preventDefault(), e.stopPropagation()];

//# sourceMappingURL=prevent.js.map


/***/ }),

/***/ 34000:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ useCurrentColor; }
/* harmony export */ });
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39107);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13209);

const useCurrentColor = (colorProp) => {
  const theme = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_0__/* .useTheme */ .Fg)();
  return (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_1__/* .variableToString */ .lk)(theme[colorProp] || colorProp || theme.color);
};

//# sourceMappingURL=useCurrentColor.js.map


/***/ }),

/***/ 71129:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useGetThemedIcon; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _useCurrentColor__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34000);


const useGetThemedIcon = (props) => {
  const color = (0,_useCurrentColor__WEBPACK_IMPORTED_MODULE_1__/* .useCurrentColor */ .$)(props.color);
  return (el) => {
    if (!el)
      return el;
    if ((0,react__WEBPACK_IMPORTED_MODULE_0__.isValidElement)(el)) {
      return (0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(el, {
        ...props,
        // @ts-expect-error
        ...el.props
      });
    }
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(el, props);
  };
};

//# sourceMappingURL=useGetThemedIcon.js.map


/***/ }),

/***/ 70941:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var clamp_exports = {};
__export(clamp_exports, {
  clamp: () => clamp
});
module.exports = __toCommonJS(clamp_exports);
function clamp(value, [min, max]) {
  return Math.min(max, Math.max(min, value));
}
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=clamp.js.map


/***/ }),

/***/ 99422:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var composeEventHandlers_exports = {};
__export(composeEventHandlers_exports, {
  composeEventHandlers: () => composeEventHandlers
});
module.exports = __toCommonJS(composeEventHandlers_exports);
function composeEventHandlers(og, next, { checkDefaultPrevented = true } = {}) {
  if (!og || !next) {
    return next || og;
  }
  return function composedEventHandler(event) {
    og == null ? void 0 : og(event);
    if (!event || !(checkDefaultPrevented && "defaultPrevented" in event) || // @ts-ignore
    "defaultPrevented" in event && !event.defaultPrevented) {
      return next == null ? void 0 : next(event);
    }
  };
}
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=composeEventHandlers.js.map


/***/ }),

/***/ 93016:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var concatClassName_exports = {};
__export(concatClassName_exports, {
  concatClassName: () => concatClassName
});
module.exports = __toCommonJS(concatClassName_exports);
function concatClassName(_cn) {
  const args = arguments;
  const usedPrefixes = [];
  let final = "";
  const len = args.length;
  let propObjects = null;
  for (let x = len; x >= 0; x--) {
    const cns = args[x];
    if (!cns)
      continue;
    if (!Array.isArray(cns) && typeof cns !== "string") {
      propObjects = propObjects || [];
      propObjects.push(cns);
      continue;
    }
    const names = Array.isArray(cns) ? cns : cns.split(" ");
    const numNames = names.length;
    for (let i = numNames - 1; i >= 0; i--) {
      const name = names[i];
      if (!name || name === " ")
        continue;
      if (name[0] !== "_") {
        final = name + " " + final;
        continue;
      }
      const splitIndex = name.indexOf("-");
      if (splitIndex < 1) {
        final = name + " " + final;
        continue;
      }
      const nextChar = name[splitIndex + 1];
      const isMediaQuery = nextChar === "_";
      const styleKey = name.slice(1, name.lastIndexOf("-"));
      const mediaKey = isMediaQuery ? name.slice(splitIndex + 2, splitIndex + 7) : null;
      const uid = mediaKey ? styleKey + mediaKey : styleKey;
      if (usedPrefixes.indexOf(uid) > -1) {
        continue;
      }
      usedPrefixes.push(uid);
      const propName = styleKey;
      if (propName && propObjects) {
        if (propObjects.some((po) => {
          if (mediaKey) {
            const propKey = pseudoInvert[mediaKey];
            return po && po[propKey] && propName in po[propKey] && po[propKey] !== null;
          }
          const res = po && propName in po && po[propName] !== null;
          return res;
        })) {
          continue;
        }
      }
      final = name + " " + final;
    }
  }
  return final;
}
const pseudoInvert = {
  hover: "hoverStyle",
  focus: "focusStyle",
  press: "pressStyle"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=concatClassName.js.map


/***/ }),

/***/ 19047:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var src_exports = {};
module.exports = __toCommonJS(src_exports);
__reExport(src_exports, __webpack_require__(70941), module.exports);
__reExport(src_exports, __webpack_require__(99422), module.exports);
__reExport(src_exports, __webpack_require__(93016), module.exports);
__reExport(src_exports, __webpack_require__(97972), module.exports);
__reExport(src_exports, __webpack_require__(67591), module.exports);
__reExport(src_exports, __webpack_require__(69949), module.exports);
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 67591:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var types_exports = {};
module.exports = __toCommonJS(types_exports);
//# sourceMappingURL=types.js.map


/***/ }),

/***/ 97972:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var validStyleProps_exports = {};
__export(validStyleProps_exports, {
  stylePropsAll: () => stylePropsAll,
  stylePropsText: () => stylePropsText,
  stylePropsTextOnly: () => stylePropsTextOnly,
  stylePropsTransform: () => stylePropsTransform,
  stylePropsView: () => stylePropsView,
  validPseudoKeys: () => validPseudoKeys,
  validStyles: () => validStyles,
  validStylesOnBaseProps: () => validStylesOnBaseProps
});
module.exports = __toCommonJS(validStyleProps_exports);
const stylePropsTransform = Object.freeze({
  x: true,
  y: true,
  scale: true,
  perspective: true,
  scaleX: true,
  scaleY: true,
  skewX: true,
  skewY: true,
  matrix: true,
  rotate: true,
  rotateY: true,
  rotateX: true,
  rotateZ: true
});
const validStylesOnBaseProps = Object.freeze({
  placeholderTextColor: true
});
const stylePropsView = Object.freeze({
  backfaceVisibility: true,
  backgroundColor: true,
  borderBottomColor: true,
  borderBottomEndRadius: true,
  borderBottomLeftRadius: true,
  borderBottomRightRadius: true,
  borderBottomStartRadius: true,
  borderBottomWidth: true,
  borderColor: true,
  borderEndColor: true,
  borderLeftColor: true,
  borderLeftWidth: true,
  borderRadius: true,
  borderRightColor: true,
  borderRightWidth: true,
  borderStartColor: true,
  borderStyle: true,
  borderTopColor: true,
  borderTopEndRadius: true,
  borderTopLeftRadius: true,
  borderTopRightRadius: true,
  borderTopStartRadius: true,
  borderTopWidth: true,
  borderWidth: true,
  opacity: true,
  transform: true,
  alignContent: true,
  alignItems: true,
  alignSelf: true,
  aspectRatio: true,
  borderEndWidth: true,
  borderStartWidth: true,
  bottom: true,
  display: true,
  end: true,
  flex: true,
  flexBasis: true,
  flexDirection: true,
  flexGrow: true,
  flexShrink: true,
  flexWrap: true,
  gap: true,
  gapColumn: true,
  gapRow: true,
  height: true,
  justifyContent: true,
  left: true,
  margin: true,
  marginBottom: true,
  marginEnd: true,
  marginHorizontal: true,
  marginLeft: true,
  marginRight: true,
  marginStart: true,
  marginTop: true,
  marginVertical: true,
  maxHeight: true,
  maxWidth: true,
  minHeight: true,
  minWidth: true,
  overflow: true,
  padding: true,
  paddingBottom: true,
  paddingEnd: true,
  paddingHorizontal: true,
  paddingLeft: true,
  paddingRight: true,
  paddingStart: true,
  paddingTop: true,
  paddingVertical: true,
  position: true,
  right: true,
  start: true,
  top: true,
  width: true,
  zIndex: true,
  direction: true,
  shadowColor: true,
  shadowOffset: true,
  shadowOpacity: true,
  shadowRadius: true,
  ...validStylesOnBaseProps,
  ...stylePropsTransform,
  // allow a few web only ones
  ... true && {
    // RN doesn't support specific border styles per-edge
    borderBottomStyle: true,
    borderTopStyle: true,
    borderLeftStyle: true,
    borderRightStyle: true,
    overflowX: true,
    overflowY: true,
    userSelect: true,
    cursor: true,
    contain: true,
    pointerEvents: true,
    boxSizing: true,
    boxShadow: true,
    outlineColor: true,
    outlineStyle: true,
    outlineOffset: true,
    outlineWidth: true
  }
});
const stylePropsTextOnly = Object.freeze({
  color: true,
  fontFamily: true,
  fontSize: true,
  fontStyle: true,
  fontWeight: true,
  letterSpacing: true,
  lineHeight: true,
  textAlign: true,
  textDecorationLine: true,
  textDecorationStyle: true,
  textDecorationColor: true,
  textShadowColor: true,
  textShadowOffset: true,
  textShadowRadius: true,
  textTransform: true,
  // allow some web only ones
  ... true && {
    whiteSpace: true,
    wordWrap: true,
    textOverflow: true,
    textDecorationDistance: true,
    userSelect: true,
    selectable: true,
    cursor: true,
    WebkitLineClamp: true,
    WebkitBoxOrient: true
  }
});
const stylePropsText = Object.freeze({
  ...stylePropsView,
  ...stylePropsTextOnly
});
const stylePropsAll = stylePropsText;
const validPseudoKeys = Object.freeze({
  enterStyle: true,
  exitStyle: true,
  hoverStyle: true,
  pressStyle: true,
  focusStyle: true
});
const validStyles = Object.freeze({
  ...validPseudoKeys,
  ...stylePropsView
});
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=validStyleProps.js.map


/***/ }),

/***/ 58829:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ clamp; }
/* harmony export */ });
function clamp(value, [min, max]) {
  return Math.min(max, Math.max(min, value));
}

//# sourceMappingURL=clamp.js.map


/***/ }),

/***/ 53998:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ composeEventHandlers; }
/* harmony export */ });
function composeEventHandlers(og, next, { checkDefaultPrevented = true } = {}) {
  if (!og || !next) {
    return next || og;
  }
  return function composedEventHandler(event) {
    og == null ? void 0 : og(event);
    if (!event || !(checkDefaultPrevented && "defaultPrevented" in event) || // @ts-ignore
    "defaultPrevented" in event && !event.defaultPrevented) {
      return next == null ? void 0 : next(event);
    }
  };
}

//# sourceMappingURL=composeEventHandlers.js.map


/***/ }),

/***/ 72539:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ concatClassName; }
/* harmony export */ });
function concatClassName(_cn) {
  const args = arguments;
  const usedPrefixes = [];
  let final = "";
  const len = args.length;
  let propObjects = null;
  for (let x = len; x >= 0; x--) {
    const cns = args[x];
    if (!cns)
      continue;
    if (!Array.isArray(cns) && typeof cns !== "string") {
      propObjects = propObjects || [];
      propObjects.push(cns);
      continue;
    }
    const names = Array.isArray(cns) ? cns : cns.split(" ");
    const numNames = names.length;
    for (let i = numNames - 1; i >= 0; i--) {
      const name = names[i];
      if (!name || name === " ")
        continue;
      if (name[0] !== "_") {
        final = name + " " + final;
        continue;
      }
      const splitIndex = name.indexOf("-");
      if (splitIndex < 1) {
        final = name + " " + final;
        continue;
      }
      const nextChar = name[splitIndex + 1];
      const isMediaQuery = nextChar === "_";
      const styleKey = name.slice(1, name.lastIndexOf("-"));
      const mediaKey = isMediaQuery ? name.slice(splitIndex + 2, splitIndex + 7) : null;
      const uid = mediaKey ? styleKey + mediaKey : styleKey;
      if (usedPrefixes.indexOf(uid) > -1) {
        continue;
      }
      usedPrefixes.push(uid);
      const propName = styleKey;
      if (propName && propObjects) {
        if (propObjects.some((po) => {
          if (mediaKey) {
            const propKey = pseudoInvert[mediaKey];
            return po && po[propKey] && propName in po[propKey] && po[propKey] !== null;
          }
          const res = po && propName in po && po[propName] !== null;
          return res;
        })) {
          continue;
        }
      }
      final = name + " " + final;
    }
  }
  return final;
}
const pseudoInvert = {
  hover: "hoverStyle",
  focus: "focusStyle",
  press: "pressStyle"
};

//# sourceMappingURL=concatClassName.js.map


/***/ }),

/***/ 92263:
/***/ (function() {

//# sourceMappingURL=types.js.map


/***/ }),

/***/ 99058:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dc": function() { return /* binding */ stylePropsTransform; },
/* harmony export */   "FB": function() { return /* binding */ stylePropsText; },
/* harmony export */   "Ji": function() { return /* binding */ stylePropsView; },
/* harmony export */   "M6": function() { return /* binding */ validPseudoKeys; },
/* harmony export */   "Qn": function() { return /* binding */ validStyles; },
/* harmony export */   "bX": function() { return /* binding */ validStylesOnBaseProps; },
/* harmony export */   "cC": function() { return /* binding */ stylePropsAll; },
/* harmony export */   "hT": function() { return /* binding */ stylePropsTextOnly; }
/* harmony export */ });
const stylePropsTransform = Object.freeze({
  x: true,
  y: true,
  scale: true,
  perspective: true,
  scaleX: true,
  scaleY: true,
  skewX: true,
  skewY: true,
  matrix: true,
  rotate: true,
  rotateY: true,
  rotateX: true,
  rotateZ: true
});
const validStylesOnBaseProps = Object.freeze({
  placeholderTextColor: true
});
const stylePropsView = Object.freeze({
  backfaceVisibility: true,
  backgroundColor: true,
  borderBottomColor: true,
  borderBottomEndRadius: true,
  borderBottomLeftRadius: true,
  borderBottomRightRadius: true,
  borderBottomStartRadius: true,
  borderBottomWidth: true,
  borderColor: true,
  borderEndColor: true,
  borderLeftColor: true,
  borderLeftWidth: true,
  borderRadius: true,
  borderRightColor: true,
  borderRightWidth: true,
  borderStartColor: true,
  borderStyle: true,
  borderTopColor: true,
  borderTopEndRadius: true,
  borderTopLeftRadius: true,
  borderTopRightRadius: true,
  borderTopStartRadius: true,
  borderTopWidth: true,
  borderWidth: true,
  opacity: true,
  transform: true,
  alignContent: true,
  alignItems: true,
  alignSelf: true,
  aspectRatio: true,
  borderEndWidth: true,
  borderStartWidth: true,
  bottom: true,
  display: true,
  end: true,
  flex: true,
  flexBasis: true,
  flexDirection: true,
  flexGrow: true,
  flexShrink: true,
  flexWrap: true,
  gap: true,
  gapColumn: true,
  gapRow: true,
  height: true,
  justifyContent: true,
  left: true,
  margin: true,
  marginBottom: true,
  marginEnd: true,
  marginHorizontal: true,
  marginLeft: true,
  marginRight: true,
  marginStart: true,
  marginTop: true,
  marginVertical: true,
  maxHeight: true,
  maxWidth: true,
  minHeight: true,
  minWidth: true,
  overflow: true,
  padding: true,
  paddingBottom: true,
  paddingEnd: true,
  paddingHorizontal: true,
  paddingLeft: true,
  paddingRight: true,
  paddingStart: true,
  paddingTop: true,
  paddingVertical: true,
  position: true,
  right: true,
  start: true,
  top: true,
  width: true,
  zIndex: true,
  direction: true,
  shadowColor: true,
  shadowOffset: true,
  shadowOpacity: true,
  shadowRadius: true,
  ...validStylesOnBaseProps,
  ...stylePropsTransform,
  // allow a few web only ones
  ... true && {
    // RN doesn't support specific border styles per-edge
    borderBottomStyle: true,
    borderTopStyle: true,
    borderLeftStyle: true,
    borderRightStyle: true,
    overflowX: true,
    overflowY: true,
    userSelect: true,
    cursor: true,
    contain: true,
    pointerEvents: true,
    boxSizing: true,
    boxShadow: true,
    outlineColor: true,
    outlineStyle: true,
    outlineOffset: true,
    outlineWidth: true
  }
});
const stylePropsTextOnly = Object.freeze({
  color: true,
  fontFamily: true,
  fontSize: true,
  fontStyle: true,
  fontWeight: true,
  letterSpacing: true,
  lineHeight: true,
  textAlign: true,
  textDecorationLine: true,
  textDecorationStyle: true,
  textDecorationColor: true,
  textShadowColor: true,
  textShadowOffset: true,
  textShadowRadius: true,
  textTransform: true,
  // allow some web only ones
  ... true && {
    whiteSpace: true,
    wordWrap: true,
    textOverflow: true,
    textDecorationDistance: true,
    userSelect: true,
    selectable: true,
    cursor: true,
    WebkitLineClamp: true,
    WebkitBoxOrient: true
  }
});
const stylePropsText = Object.freeze({
  ...stylePropsView,
  ...stylePropsTextOnly
});
const stylePropsAll = stylePropsText;
const validPseudoKeys = Object.freeze({
  enterStyle: true,
  exitStyle: true,
  hoverStyle: true,
  pressStyle: true,
  focusStyle: true
});
const validStyles = Object.freeze({
  ...validPseudoKeys,
  ...stylePropsView
});

//# sourceMappingURL=validStyleProps.js.map


/***/ }),

/***/ 70695:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Label_exports = {};
__export(Label_exports, {
  Label: () => Label,
  LabelFrame: () => LabelFrame,
  useLabelContext: () => useLabelContext
});
module.exports = __toCommonJS(Label_exports);
var import_jsx_runtime = __webpack_require__(52322);
var import_compose_refs = __webpack_require__(7199);
var import_create_context = __webpack_require__(71913);
var import_focusable = __webpack_require__(31390);
var import_get_button_sized = __webpack_require__(56701);
var import_get_font_sized = __webpack_require__(66754);
var import_text = __webpack_require__(48175);
var import_web = __webpack_require__(44571);
var React = __toESM(__webpack_require__(2784));
const NAME = "Label";
const [LabelProvider, useLabelContextImpl] = (0, import_create_context.createContext)(NAME, {
  id: void 0,
  controlRef: { current: null }
});
const LabelFrame = (0, import_web.styled)(import_text.SizableText, {
  name: "Label",
  tag: "label",
  variants: {
    unstyled: {
      false: {
        size: "$true",
        color: "$color",
        backgroundColor: "transparent",
        display: "flex",
        alignItems: "center",
        userSelect: "none",
        cursor: "default",
        pressStyle: {
          color: "$colorPress"
        }
      }
    },
    size: {
      "...size": (val, extras) => {
        const buttonStyle = (0, import_get_button_sized.getButtonSized)(val, extras);
        return {
          ...(0, import_get_font_sized.getFontSized)(val, extras),
          height: buttonStyle.height,
          lineHeight: buttonStyle.height
        };
      }
    }
  },
  defaultVariants: {
    unstyled: false
  }
});
const LabelComponent = React.forwardRef(
  (props, forwardedRef) => {
    const { htmlFor, id: idProp, ...labelProps } = props;
    const controlRef = React.useRef(null);
    const ref = React.useRef(null);
    const composedRefs = (0, import_compose_refs.useComposedRefs)(forwardedRef, ref);
    const backupId = (0, import_web.useId)();
    const id = idProp ?? backupId;
    if (import_web.isWeb) {
      React.useEffect(() => {
        if (htmlFor) {
          const element = document.getElementById(htmlFor);
          const label = ref.current;
          if (label && element) {
            const getAriaLabel = () => element.getAttribute("aria-labelledby");
            const ariaLabelledBy = [id, getAriaLabel()].filter(Boolean).join(" ");
            element.setAttribute("aria-labelledby", ariaLabelledBy);
            controlRef.current = element;
            return () => {
              var _a;
              if (!id)
                return;
              const ariaLabelledBy2 = (_a = getAriaLabel()) == null ? void 0 : _a.replace(id, "");
              if (ariaLabelledBy2 === "") {
                element.removeAttribute("aria-labelledby");
              } else if (ariaLabelledBy2) {
                element.setAttribute("aria-labelledby", ariaLabelledBy2);
              }
            };
          }
        }
      }, [id, htmlFor]);
    }
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(LabelProvider, { id, controlRef, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
      LabelFrame,
      {
        role: "heading",
        id,
        htmlFor,
        ...labelProps,
        ref: composedRefs,
        onMouseDown: (event) => {
          var _a;
          (_a = props.onMouseDown) == null ? void 0 : _a.call(props, event);
          if (!event.defaultPrevented && event.detail > 1) {
            event.preventDefault();
          }
        },
        onPress: (event) => {
          var _a;
          (_a = props.onPress) == null ? void 0 : _a.call(props, event);
          if (import_web.isWeb) {
            if (htmlFor || !controlRef.current || event.defaultPrevented)
              return;
            const isClickingControl = controlRef.current.contains(
              event.target
            );
            const isUserClick = event.isTrusted === true;
            if (!isClickingControl && isUserClick) {
              controlRef.current.click();
              controlRef.current.focus();
            }
          } else {
            if (props.htmlFor) {
              (0, import_focusable.focusFocusable)(props.htmlFor);
            }
          }
        }
      }
    ) });
  }
);
LabelComponent.displayName = NAME;
const Label = LabelFrame.extractable((0, import_web.themeable)(LabelComponent), {
  neverFlatten: true
});
const useLabelContext = (element) => {
  const context = useLabelContextImpl("LabelConsumer");
  const { controlRef } = context;
  React.useEffect(() => {
    if (element)
      controlRef.current = element;
  }, [element, controlRef]);
  return context.id;
};
const Root = (/* unused pure expression or super */ null && (Label));
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=Label.js.map


/***/ }),

/***/ 28339:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var src_exports = {};
module.exports = __toCommonJS(src_exports);
__reExport(src_exports, __webpack_require__(70695), module.exports);
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 85360:
/***/ (function() {

if (typeof globalThis['__DEV__'] === 'undefined') {
  globalThis['__DEV__'] = "production" === 'development'
}


/***/ }),

/***/ 97287:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Popover_exports = {};
__export(Popover_exports, {
  Popover: () => Popover,
  PopoverAnchor: () => PopoverAnchor,
  PopoverArrow: () => PopoverArrow,
  PopoverClose: () => PopoverClose,
  PopoverContent: () => PopoverContent,
  PopoverTrigger: () => PopoverTrigger,
  __PopoverProviderInternal: () => __PopoverProviderInternal,
  createPopoverScope: () => createPopoverScope,
  usePopoverScope: () => usePopoverScope
});
module.exports = __toCommonJS(Popover_exports);
var import_jsx_runtime = __webpack_require__(52322);
var import_polyfill_dev = __webpack_require__(85360);
var import_adapt = __webpack_require__(8242);
var import_animate_presence = __webpack_require__(90625);
var import_aria_hidden = __webpack_require__(95613);
var import_compose_refs = __webpack_require__(7199);
var import_core = __webpack_require__(44996);
var import_create_context = __webpack_require__(71913);
var import_floating = __webpack_require__(80159);
var import_focus_scope = __webpack_require__(50807);
var import_popper = __webpack_require__(48920);
var import_portal = __webpack_require__(69564);
var import_remove_scroll = __webpack_require__(85293);
var import_sheet = __webpack_require__(24226);
var import_stacks = __webpack_require__(84432);
var import_use_controllable_state = __webpack_require__(12113);
var React = __toESM(__webpack_require__(2784));
var import_react_native = __webpack_require__(22164);
var import_useFloatingContext = __webpack_require__(86376);
const POPOVER_NAME = "Popover";
const [createPopoverContext, createPopoverScopeInternal] = (0, import_create_context.createContextScope)(
  POPOVER_NAME,
  [import_popper.createPopperScope]
);
const usePopoverScope = (0, import_popper.createPopperScope)();
const createPopoverScope = createPopoverScopeInternal;
const [PopoverProviderInternal, usePopoverInternalContext] = createPopoverContext(POPOVER_NAME);
const __PopoverProviderInternal = PopoverProviderInternal;
const ANCHOR_NAME = "PopoverAnchor";
const PopoverAnchor = React.forwardRef(
  (props, forwardedRef) => {
    const { __scopePopover, ...anchorProps } = props;
    const context = usePopoverInternalContext(ANCHOR_NAME, __scopePopover);
    const popperScope = usePopoverScope(__scopePopover);
    const { onCustomAnchorAdd, onCustomAnchorRemove } = context;
    React.useEffect(() => {
      onCustomAnchorAdd();
      return () => onCustomAnchorRemove();
    }, [onCustomAnchorAdd, onCustomAnchorRemove]);
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_popper.PopperAnchor, { ...popperScope, ...anchorProps, ref: forwardedRef });
  }
);
PopoverAnchor.displayName = ANCHOR_NAME;
const TRIGGER_NAME = "PopoverTrigger";
const PopoverTrigger = React.forwardRef((props, forwardedRef) => {
  const { __scopePopover, ...triggerProps } = props;
  const context = usePopoverInternalContext(TRIGGER_NAME, __scopePopover);
  const popperScope = usePopoverScope(__scopePopover);
  const composedTriggerRef = (0, import_compose_refs.useComposedRefs)(forwardedRef, context.triggerRef);
  const trigger = /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
    import_stacks.YStack,
    {
      "aria-haspopup": "dialog",
      "aria-expanded": context.open,
      "data-state": getState(context.open),
      ...triggerProps,
      ref: composedTriggerRef,
      onPress: (0, import_core.composeEventHandlers)(props.onPress, context.onOpenToggle)
    }
  );
  return context.hasCustomAnchor ? trigger : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_popper.PopperAnchor, { asChild: true, ...popperScope, children: trigger });
});
PopoverTrigger.displayName = TRIGGER_NAME;
const CONTENT_NAME = "PopoverContent";
const PopoverContent = import_popper.PopperContentFrame.extractable(
  React.forwardRef(
    function PopoverContent2(props, forwardedRef) {
      const {
        allowPinchZoom,
        trapFocus,
        disableRemoveScroll = true,
        zIndex,
        ...contentImplProps
      } = props;
      const context = usePopoverInternalContext(CONTENT_NAME, props.__scopePopover);
      const contentRef = React.useRef(null);
      const composedRefs = (0, import_compose_refs.useComposedRefs)(forwardedRef, contentRef);
      const isRightClickOutsideRef = React.useRef(false);
      React.useEffect(() => {
        if (!context.open)
          return;
        const content = contentRef.current;
        if (content)
          return (0, import_aria_hidden.hideOthers)(content);
      }, [context.open]);
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(PopoverContentPortal, { zIndex, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
        PopoverContentImpl,
        {
          ...contentImplProps,
          disableRemoveScroll,
          ref: composedRefs,
          trapFocus: trapFocus ?? context.open,
          disableOutsidePointerEvents: true,
          onCloseAutoFocus: (0, import_core.composeEventHandlers)(props.onCloseAutoFocus, (event) => {
            var _a;
            event.preventDefault();
            if (!isRightClickOutsideRef.current)
              (_a = context.triggerRef.current) == null ? void 0 : _a.focus();
          }),
          onPointerDownOutside: (0, import_core.composeEventHandlers)(
            props.onPointerDownOutside,
            (event) => {
              const originalEvent = event.detail.originalEvent;
              const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
              const isRightClick = originalEvent.button === 2 || ctrlLeftClick;
              isRightClickOutsideRef.current = isRightClick;
            },
            { checkDefaultPrevented: false }
          ),
          onFocusOutside: (0, import_core.composeEventHandlers)(
            props.onFocusOutside,
            (event) => event.preventDefault(),
            { checkDefaultPrevented: false }
          )
        }
      ) });
    }
  )
);
function PopoverContentPortal(props) {
  const themeName = (0, import_core.useThemeName)();
  const context = usePopoverInternalContext(CONTENT_NAME, props.__scopePopover);
  let contents = props.children;
  if (import_react_native.Platform.OS === "android") {
    const popperContext = (0, import_popper.usePopperContext)(CONTENT_NAME, context.popperScope);
    contents = /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_popper.PopperProvider, { ...popperContext, scope: context.popperScope, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(PopoverProviderInternal, { scope: props.__scopePopover, ...context, children: props.children }) });
  }
  const zIndex = props.zIndex ?? 1e3;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_portal.Portal, { zIndex, children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_core.Theme, { forceClassName: true, name: themeName, children: [
    !!context.open && !context.breakpointActive && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
      import_stacks.YStack,
      {
        fullscreen: true,
        onPress: (0, import_core.composeEventHandlers)(props.onPress, context.onOpenToggle)
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_core.Stack, { zIndex: zIndex + 1, children: contents })
  ] }) });
}
const PopoverContentImpl = React.forwardRef((props, forwardedRef) => {
  const {
    __scopePopover,
    trapFocus,
    onOpenAutoFocus,
    onCloseAutoFocus,
    disableOutsidePointerEvents,
    onEscapeKeyDown,
    onPointerDownOutside,
    onFocusOutside,
    onInteractOutside,
    children,
    disableRemoveScroll,
    ...contentProps
  } = props;
  const popperScope = usePopoverScope(__scopePopover);
  const context = usePopoverInternalContext(CONTENT_NAME, popperScope.__scopePopover);
  if (context.breakpointActive) {
    const childrenWithoutScrollView = React.Children.toArray(children).map((child) => {
      if (React.isValidElement(child)) {
        if (child.type === PopoverScrollView) {
          return child.props.children;
        }
      }
      return child;
    });
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_portal.PortalItem, { hostName: `${context.scopeKey}PopoverContents`, children: childrenWithoutScrollView });
  }
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_animate_presence.AnimatePresence, { children: !!context.open && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
    import_popper.PopperContent,
    {
      "data-state": getState(context.open),
      id: context.contentId,
      pointerEvents: "auto",
      ref: forwardedRef,
      ...popperScope,
      ...contentProps,
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
        import_remove_scroll.RemoveScroll,
        {
          enabled: disableRemoveScroll ? false : context.open,
          allowPinchZoom: true,
          removeScrollBar: false,
          style: {
            display: "contents"
          },
          children: trapFocus === false ? children : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
            import_focus_scope.FocusScope,
            {
              loop: true,
              trapped: trapFocus ?? context.open,
              onMountAutoFocus: onOpenAutoFocus,
              onUnmountAutoFocus: onCloseAutoFocus,
              children: import_core.isWeb ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", { style: { display: "contents" }, children }) : children
            }
          )
        }
      )
    },
    context.contentId
  ) });
});
const CLOSE_NAME = "PopoverClose";
const PopoverClose = React.forwardRef(
  (props, forwardedRef) => {
    const { __scopePopover, ...closeProps } = props;
    const context = usePopoverInternalContext(CLOSE_NAME, __scopePopover);
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
      import_stacks.YStack,
      {
        ...closeProps,
        ref: forwardedRef,
        onPress: (0, import_core.composeEventHandlers)(
          props.onPress,
          () => context.onOpenChange(false)
        )
      }
    );
  }
);
PopoverClose.displayName = CLOSE_NAME;
const ARROW_NAME = "PopoverArrow";
const PopoverArrow = React.forwardRef(
  (props, forwardedRef) => {
    const { __scopePopover, ...arrowProps } = props;
    const popperScope = usePopoverScope(__scopePopover);
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_popper.PopperArrow, { ...popperScope, ...arrowProps, ref: forwardedRef });
  }
);
PopoverArrow.displayName = ARROW_NAME;
const PopoverScrollView = React.forwardRef((props, ref) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_native.ScrollView, { ref, ...props });
});
const Popover = (0, import_core.withStaticProperties)(
  function Popover2(props) {
    const {
      __scopePopover,
      children,
      open: openProp,
      defaultOpen,
      onOpenChange,
      ...restProps
    } = props;
    const internalId = (0, import_core.useId)();
    const id = __scopePopover ? Object.keys(__scopePopover)[0] : internalId;
    const { when, AdaptProvider } = (0, import_adapt.useAdaptParent)({
      Contents: React.useCallback(() => {
        return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_portal.PortalHost, { name: `${id}PopoverContents` });
      }, [])
    });
    const sheetBreakpoint = when;
    const popperScope = usePopoverScope(__scopePopover);
    const triggerRef = React.useRef(null);
    const [hasCustomAnchor, setHasCustomAnchor] = React.useState(false);
    const [open, setOpen] = (0, import_use_controllable_state.useControllableState)({
      prop: openProp,
      defaultProp: defaultOpen || false,
      onChange: onOpenChange,
      transition: true
    });
    const breakpointActive = useSheetBreakpointActive(sheetBreakpoint);
    const floatingContext = (0, import_useFloatingContext.useFloatingContext)({ open, setOpen, breakpointActive });
    const popoverContext = {
      scope: __scopePopover,
      scopeKey: id,
      popperScope: popperScope.__scopePopper,
      sheetBreakpoint,
      contentId: (0, import_core.useId)(),
      triggerRef,
      open,
      breakpointActive,
      onOpenChange: setOpen,
      onOpenToggle: (0, import_core.useEvent)(() => {
        if (open && breakpointActive) {
          return;
        }
        setOpen(!open);
      }),
      hasCustomAnchor,
      onCustomAnchorAdd: React.useCallback(() => setHasCustomAnchor(true), []),
      onCustomAnchorRemove: React.useCallback(() => setHasCustomAnchor(false), [])
    };
    const contents = /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_popper.Popper, { ...popperScope, stayInFrame: true, ...restProps, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(PopoverProviderInternal, { ...popoverContext, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(PopoverSheetController, { onOpenChange: setOpen, __scopePopover, children }) }) });
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AdaptProvider, { children: import_core.isWeb ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_floating.FloatingOverrideContext.Provider, { value: floatingContext, children: contents }) : contents });
  },
  {
    Anchor: PopoverAnchor,
    Arrow: PopoverArrow,
    Trigger: PopoverTrigger,
    Content: PopoverContent,
    Close: PopoverClose,
    Adapt: import_adapt.Adapt,
    ScrollView: PopoverScrollView,
    Sheet: import_sheet.ControlledSheet
  }
);
function getState(open) {
  return open ? "open" : "closed";
}
const PopoverSheetController = (props) => {
  const context = usePopoverInternalContext(
    "PopoverSheetController",
    props.__scopePopover
  );
  const showSheet = useShowPopoverSheet(context);
  const breakpointActive = context.breakpointActive;
  const getShowSheet = (0, import_core.useGet)(showSheet);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
    import_sheet.SheetController,
    {
      onOpenChange: (val) => {
        if (getShowSheet()) {
          props.onOpenChange(val);
        }
      },
      open: context.open,
      hidden: breakpointActive === false,
      children: props.children
    }
  );
};
const useSheetBreakpointActive = (breakpoint) => {
  const media = (0, import_core.useMedia)();
  if (typeof breakpoint === "boolean" || !breakpoint) {
    return !!breakpoint;
  }
  return media[breakpoint];
};
const useShowPopoverSheet = (context) => {
  const breakpointActive = useSheetBreakpointActive(context.sheetBreakpoint);
  return context.open === false ? false : breakpointActive;
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=Popover.js.map


/***/ }),

/***/ 17272:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var src_exports = {};
module.exports = __toCommonJS(src_exports);
__reExport(src_exports, __webpack_require__(97287), module.exports);
__reExport(src_exports, __webpack_require__(86376), module.exports);
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 86376:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var useFloatingContext_exports = {};
__export(useFloatingContext_exports, {
  useFloatingContext: () => useFloatingContext
});
module.exports = __toCommonJS(useFloatingContext_exports);
var import_react = __webpack_require__(67777);
var import_react2 = __webpack_require__(2784);
const useFloatingContext = ({ open, setOpen, breakpointActive }) => (0, import_react2.useCallback)(
  (props) => {
    const floating = (0, import_react.useFloating)({
      ...props,
      open,
      onOpenChange: setOpen
    });
    const { getReferenceProps, getFloatingProps } = (0, import_react.useInteractions)([
      // useFocus(floating.context, {
      //   enabled: !breakpointActive,
      //   keyboardOnly: true,
      // }),
      (0, import_react.useRole)(floating.context, { role: "dialog" }),
      (0, import_react.useDismiss)(floating.context, {
        enabled: !breakpointActive
      })
    ]);
    return {
      ...floating,
      getReferenceProps,
      getFloatingProps
    };
  },
  [open, setOpen, breakpointActive]
);
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=useFloatingContext.js.map


/***/ }),

/***/ 67242:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Popper_exports = {};
__export(Popper_exports, {
  Popper: () => Popper,
  PopperAnchor: () => PopperAnchor,
  PopperArrow: () => PopperArrow,
  PopperContent: () => PopperContent,
  PopperContentFrame: () => PopperContentFrame,
  PopperProvider: () => PopperProvider,
  createPopperScope: () => createPopperScope,
  usePopperContext: () => usePopperContext
});
module.exports = __toCommonJS(Popper_exports);
var import_jsx_runtime = __webpack_require__(52322);
var import_compose_refs = __webpack_require__(7199);
var import_core = __webpack_require__(44996);
var import_create_context = __webpack_require__(71913);
var import_floating = __webpack_require__(80159);
var import_get_size = __webpack_require__(20157);
var import_stacks = __webpack_require__(84432);
var React = __toESM(__webpack_require__(2784));
var import_react_native = __webpack_require__(22164);
const POPPER_NAME = "Popper";
const [createPopperContext, createScope] = (0, import_create_context.createContextScope)(POPPER_NAME);
const createPopperScope = createScope;
const [PopperProvider, usePopperContext] = createPopperContext(POPPER_NAME);
function Popper(props) {
  const {
    __scopePopper,
    children,
    size,
    strategy = "absolute",
    placement = "bottom",
    stayInFrame,
    allowFlip
  } = props;
  const [isMounted, setIsMounted] = React.useState(false);
  (0, import_core.useIsomorphicLayoutEffect)(() => {
    setIsMounted(true);
  }, []);
  const anchorRef = React.useRef();
  const [arrowEl, setArrow] = React.useState(null);
  const [arrowSize, setArrowSize] = React.useState(0);
  const arrowRef = React.useRef();
  const floating = (0, import_floating.useFloating)({
    strategy,
    placement,
    sameScrollView: false,
    // this only takes effect on native
    middleware: [
      stayInFrame ? (0, import_floating.shift)(typeof stayInFrame === "boolean" ? {} : stayInFrame) : null,
      allowFlip ? (0, import_floating.flip)(typeof allowFlip === "boolean" ? {} : allowFlip) : null,
      arrowEl ? (0, import_floating.arrow)({ element: arrowEl }) : null,
      arrowSize ? (0, import_floating.offset)(arrowSize) : null
    ].filter(Boolean)
  });
  const { refs, middlewareData } = floating;
  const composedArrowRefs = (0, import_compose_refs.useComposedRefs)(arrowRef, setArrow);
  (0, import_core.useIsomorphicLayoutEffect)(() => {
    floating.reference(anchorRef.current);
  }, [anchorRef]);
  if (import_core.isWeb) {
    React.useEffect(() => {
      if (!(refs.reference.current && refs.floating.current)) {
        return;
      }
      return (0, import_floating.autoUpdate)(refs.reference.current, refs.floating.current, floating.update);
    }, [floating.update, refs.floating, refs.reference]);
  } else {
    const dimensions = (0, import_react_native.useWindowDimensions)();
    const [keyboardOpen, setKeyboardOpen] = React.useState(false);
    React.useEffect(() => {
      const showSubscription = import_react_native.Keyboard.addListener("keyboardDidShow", () => {
        setKeyboardOpen(true);
      });
      const hideSubscription = import_react_native.Keyboard.addListener("keyboardDidHide", () => {
        setKeyboardOpen(false);
      });
      return () => {
        showSubscription.remove();
        hideSubscription.remove();
      };
    }, []);
    (0, import_core.useIsomorphicLayoutEffect)(() => {
      floating.update();
    }, [dimensions, keyboardOpen]);
  }
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
    PopperProvider,
    {
      scope: __scopePopper,
      anchorRef,
      size,
      arrowRef: composedArrowRefs,
      arrowStyle: middlewareData.arrow,
      onArrowSize: setArrowSize,
      isMounted,
      ...floating,
      children
    }
  );
}
const ANCHOR_NAME = "PopperAnchor";
const PopperAnchor = import_stacks.YStack.extractable(
  React.forwardRef(function PopperAnchor2(props, forwardedRef) {
    const { __scopePopper, virtualRef, ...anchorProps } = props;
    const { anchorRef, getReferenceProps } = usePopperContext(ANCHOR_NAME, __scopePopper);
    const ref = React.useRef(null);
    const composedRefs = (0, import_compose_refs.useComposedRefs)(forwardedRef, ref, anchorRef);
    if (virtualRef) {
      return null;
    }
    const stackProps = {
      ref: composedRefs,
      ...anchorProps
    };
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_stacks.YStack, { ...getReferenceProps ? getReferenceProps(stackProps) : stackProps });
  })
);
const CONTENT_NAME = "PopperContent";
const PopperContentFrame = (0, import_core.styled)(import_stacks.ThemeableStack, {
  name: "PopperContent",
  variants: {
    unstyled: {
      false: {
        size: "$true",
        backgroundColor: "$background",
        alignItems: "center",
        radiused: true
      }
    },
    size: {
      "...size": (val, { tokens }) => {
        return {
          padding: tokens.space[val],
          borderRadius: tokens.radius[val]
        };
      }
    }
  },
  defaultVariants: {
    unstyled: false
  }
});
const PopperContent = React.forwardRef(
  function PopperContent2(props, forwardedRef) {
    const { __scopePopper, ...contentProps } = props;
    const { strategy, placement, floating, x, y, getFloatingProps, size, isMounted } = usePopperContext(CONTENT_NAME, __scopePopper);
    const contentRefs = (0, import_compose_refs.useComposedRefs)(floating, forwardedRef);
    const contents = React.useMemo(() => {
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
        PopperContentFrame,
        {
          "data-placement": placement,
          "data-strategy": strategy,
          size: contentProps.size || size,
          ...contentProps
        },
        "popper-content-frame"
      );
    }, [placement, strategy, props]);
    if (!isMounted) {
      return null;
    }
    const frameProps = {
      ref: contentRefs,
      x: x || 0,
      y: y || 0,
      position: strategy
    };
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
      import_stacks.YStack,
      {
        animateOnly: ["transform"],
        ...getFloatingProps ? getFloatingProps(frameProps) : frameProps,
        children: contents
      }
    );
  }
);
const ARROW_NAME = "PopperArrow";
const PopperArrowFrame = (0, import_core.styled)(import_stacks.YStack, {
  name: "PopperArrow",
  variants: {
    unstyled: {
      false: {
        borderColor: "$borderColor",
        backgroundColor: "$background",
        position: "relative"
      }
    }
  },
  defaultVariants: {
    unstyled: false
  }
});
const PopperArrowOuterFrame = (0, import_core.styled)(import_stacks.YStack, {
  name: "PopperArrowOuter",
  variants: {
    unstyled: {
      false: {
        position: "absolute",
        zIndex: -1,
        pointerEvents: "none",
        overflow: "hidden",
        alignItems: "center",
        justifyContent: "center"
      }
    }
  },
  defaultVariants: {
    unstyled: false
  }
});
const opposites = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
};
const PopperArrow = PopperArrowFrame.extractable(
  React.forwardRef(function PopperArrow2(props, forwardedRef) {
    var _a, _b;
    const {
      __scopePopper,
      offset: offset2,
      size: sizeProp,
      borderWidth = 0,
      ...arrowProps
    } = props;
    const context = usePopperContext(ARROW_NAME, __scopePopper);
    const sizeVal = sizeProp ?? context.size;
    const sizeValResolved = (0, import_core.getVariableValue)((0, import_get_size.stepTokenUpOrDown)("space", sizeVal, -2, [2]));
    const size = +sizeValResolved;
    const { placement } = context;
    const refs = (0, import_compose_refs.useComposedRefs)(context.arrowRef, forwardedRef);
    const x = ((_a = context.arrowStyle) == null ? void 0 : _a.x) || 0;
    const y = ((_b = context.arrowStyle) == null ? void 0 : _b.y) || 0;
    const primaryPlacement = placement ? placement.split("-")[0] : "top";
    const arrowStyle = { x, y, width: size, height: size };
    const innerArrowStyle = {};
    const isVertical = primaryPlacement === "bottom" || primaryPlacement === "top";
    if (primaryPlacement) {
      arrowStyle[isVertical ? "width" : "height"] = size * 2;
      const oppSide = opposites[primaryPlacement];
      if (oppSide) {
        arrowStyle[oppSide] = -size;
        innerArrowStyle[oppSide] = size / 2;
      }
      if (oppSide === "top" || oppSide === "bottom") {
        arrowStyle.left = 0;
      }
      if (oppSide === "left" || oppSide === "right") {
        arrowStyle.top = 0;
      }
    }
    (0, import_core.useIsomorphicLayoutEffect)(() => {
      var _a2;
      (_a2 = context.onArrowSize) == null ? void 0 : _a2.call(context, size);
    }, [size, context.onArrowSize]);
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(PopperArrowOuterFrame, { ref: refs, ...arrowStyle, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
      PopperArrowFrame,
      {
        width: size,
        height: size,
        ...arrowProps,
        ...innerArrowStyle,
        rotate: "45deg",
        ...primaryPlacement === "bottom" && {
          borderBottomWidth: borderWidth,
          borderRightWidth: borderWidth
        },
        ...primaryPlacement === "top" && {
          borderTopWidth: borderWidth,
          borderLeftWidth: borderWidth
        },
        ...primaryPlacement === "right" && {
          borderTopWidth: borderWidth,
          borderRightWidth: borderWidth
        },
        ...primaryPlacement === "left" && {
          borderBottomWidth: borderWidth,
          borderLeftWidth: borderWidth
        }
      }
    ) });
  })
);
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=Popper.js.map


/***/ }),

/***/ 48920:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var src_exports = {};
module.exports = __toCommonJS(src_exports);
__reExport(src_exports, __webpack_require__(67242), module.exports);
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 22504:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var GorhomPortal_exports = {};
__export(GorhomPortal_exports, {
  ACTIONS: () => ACTIONS,
  INITIAL_STATE: () => INITIAL_STATE,
  PortalHost: () => PortalHost,
  PortalItem: () => PortalItem,
  PortalProvider: () => PortalProvider,
  usePortal: () => usePortal
});
module.exports = __toCommonJS(GorhomPortal_exports);
var import_jsx_runtime = __webpack_require__(52322);
var import_core = __webpack_require__(44996);
var import_react = __toESM(__webpack_require__(2784));
var ACTIONS = /* @__PURE__ */ ((ACTIONS2) => {
  ACTIONS2[ACTIONS2["REGISTER_HOST"] = 0] = "REGISTER_HOST";
  ACTIONS2[ACTIONS2["DEREGISTER_HOST"] = 1] = "DEREGISTER_HOST";
  ACTIONS2[ACTIONS2["ADD_UPDATE_PORTAL"] = 2] = "ADD_UPDATE_PORTAL";
  ACTIONS2[ACTIONS2["REMOVE_PORTAL"] = 3] = "REMOVE_PORTAL";
  return ACTIONS2;
})(ACTIONS || {});
const INITIAL_STATE = {};
const registerHost = (state, hostName) => {
  if (!(hostName in state)) {
    state[hostName] = [];
  }
  return state;
};
const deregisterHost = (state, hostName) => {
  delete state[hostName];
  return state;
};
const addUpdatePortal = (state, hostName, portalName, node) => {
  if (!(hostName in state)) {
    state = registerHost(state, hostName);
  }
  const index = state[hostName].findIndex((item) => item.name === portalName);
  if (index !== -1) {
    state[hostName][index].node = node;
  } else {
    state[hostName].push({
      name: portalName,
      node
    });
  }
  return state;
};
const removePortal = (state, hostName, portalName) => {
  if (!(hostName in state)) {
    console.log(
      `Failed to remove portal '${portalName}', '${hostName}' was not registered!`
    );
    return state;
  }
  const index = state[hostName].findIndex((item) => item.name === portalName);
  if (index !== -1)
    state[hostName].splice(index, 1);
  return state;
};
const reducer = (state, action) => {
  const { type } = action;
  switch (type) {
    case 0 /* REGISTER_HOST */:
      return registerHost({ ...state }, action.hostName);
    case 1 /* DEREGISTER_HOST */:
      return deregisterHost({ ...state }, action.hostName);
    case 2 /* ADD_UPDATE_PORTAL */:
      return addUpdatePortal(
        { ...state },
        action.hostName,
        action.portalName,
        action.node
      );
    case 3 /* REMOVE_PORTAL */:
      return removePortal(
        { ...state },
        action.hostName,
        action.portalName
      );
    default:
      return state;
  }
};
const PortalStateContext = (0, import_react.createContext)(null);
const PortalDispatchContext = (0, import_react.createContext)(null);
const usePortalState = (hostName) => {
  const state = (0, import_react.useContext)(PortalStateContext);
  if (state === null) {
    throw new Error(
      "'PortalStateContext' cannot be null, please add 'PortalProvider' to the root component."
    );
  }
  return state[hostName] || [];
};
const usePortal = (hostName = "root") => {
  const dispatch = (0, import_react.useContext)(PortalDispatchContext);
  if (dispatch === null) {
    throw new Error(
      "'PortalDispatchContext' cannot be null, please add 'PortalProvider' to the root component."
    );
  }
  const registerHost2 = (0, import_react.useCallback)(() => {
    dispatch({
      type: 0 /* REGISTER_HOST */,
      hostName
    });
  }, []);
  const deregisterHost2 = (0, import_react.useCallback)(() => {
    dispatch({
      type: 1 /* DEREGISTER_HOST */,
      hostName
    });
  }, []);
  const addUpdatePortal2 = (0, import_react.useCallback)((name, node) => {
    dispatch({
      type: 2 /* ADD_UPDATE_PORTAL */,
      hostName,
      portalName: name,
      node
    });
  }, []);
  const removePortal2 = (0, import_react.useCallback)((name) => {
    dispatch({
      type: 3 /* REMOVE_PORTAL */,
      hostName,
      portalName: name
    });
  }, []);
  return {
    registerHost: registerHost2,
    deregisterHost: deregisterHost2,
    addPortal: addUpdatePortal2,
    updatePortal: addUpdatePortal2,
    removePortal: removePortal2
  };
};
const PortalProviderComponent = ({
  rootHostName = "root",
  shouldAddRootHost = true,
  children
}) => {
  const [state, dispatch] = (0, import_react.useReducer)(reducer, INITIAL_STATE);
  const transitionDispatch = (0, import_react.useMemo)(() => {
    const next = (value) => {
      (0, import_react.startTransition)(() => {
        dispatch(value);
      });
    };
    return next;
  }, [dispatch]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(PortalDispatchContext.Provider, { value: transitionDispatch, children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(PortalStateContext.Provider, { value: state, children: [
    children,
    shouldAddRootHost && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(PortalHost, { name: rootHostName })
  ] }) });
};
const PortalProvider = (0, import_react.memo)(PortalProviderComponent);
PortalProvider.displayName = "PortalProvider";
const PortalHostComponent = (props) => {
  const { name, forwardProps } = props;
  const isServer = !(0, import_core.useDidFinishSSR)();
  const state = usePortalState(name);
  const { registerHost: registerHost2, deregisterHost: deregisterHost2 } = usePortal(props.name);
  (0, import_react.useEffect)(() => {
    if (isServer)
      return;
    registerHost2();
    return () => {
      deregisterHost2();
    };
  }, [isServer]);
  if (forwardProps) {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, { children: state.map((item) => {
      let next = item.node;
      if (forwardProps) {
        return import_react.default.Children.map(next, (child) => {
          return import_react.default.isValidElement(child) ? import_react.default.cloneElement(child, { key: child.key, ...forwardProps }) : child;
        });
      }
      return next;
    }) });
  }
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, { children: state.map((item) => item.node) });
};
const PortalHost = (0, import_react.memo)(PortalHostComponent);
PortalHost.displayName = "PortalHost";
const PortalComponent = (props) => {
  const {
    name: _providedName,
    hostName,
    handleOnMount: _providedHandleOnMount,
    handleOnUnmount: _providedHandleOnUnmount,
    handleOnUpdate: _providedHandleOnUpdate,
    children
  } = props;
  const { addPortal: addUpdatePortal2, removePortal: removePortal2 } = usePortal(hostName);
  const id = (0, import_react.useId)();
  const name = _providedName || id;
  const handleOnMount = (0, import_core.useEvent)(() => {
    if (_providedHandleOnMount) {
      _providedHandleOnMount(() => addUpdatePortal2(name, children));
    } else {
      addUpdatePortal2(name, children);
    }
  });
  const handleOnUnmount = (0, import_core.useEvent)(() => {
    if (_providedHandleOnUnmount) {
      _providedHandleOnUnmount(() => removePortal2(name));
    } else {
      removePortal2(name);
    }
  });
  const handleOnUpdate = (0, import_core.useEvent)(() => {
    if (_providedHandleOnUpdate) {
      _providedHandleOnUpdate(() => addUpdatePortal2(name, children));
    } else {
      addUpdatePortal2(name, children);
    }
  });
  (0, import_core.useIsomorphicLayoutEffect)(() => {
    handleOnMount();
    return () => {
      handleOnUnmount();
    };
  }, []);
  (0, import_react.useEffect)(() => {
    handleOnUpdate();
  }, [children]);
  return null;
};
const PortalItem = (0, import_react.memo)(PortalComponent);
PortalItem.displayName = "Portal";
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=GorhomPortal.js.map


/***/ }),

/***/ 20045:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Portal_exports = {};
__export(Portal_exports, {
  Portal: () => Portal
});
module.exports = __toCommonJS(Portal_exports);
var import_jsx_runtime = __webpack_require__(52322);
var import_polyfill_dev = __webpack_require__(85360);
var import_core = __webpack_require__(44996);
var import_stacks = __webpack_require__(84432);
var React = __toESM(__webpack_require__(2784));
var import_react_dom = __webpack_require__(28316);
const Portal = ({ host = ((_a) => (_a = globalThis.document) == null ? void 0 : _a.body)(), ...props }) => {
  const contents = /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
    import_stacks.YStack,
    {
      contain: "strict",
      fullscreen: true,
      position: import_core.isWeb ? "fixed" : "absolute",
      maxWidth: import_core.isWeb ? "100vw" : "100%",
      maxHeight: import_core.isWeb ? "100vh" : "100%",
      pointerEvents: "none",
      ...props
    }
  );
  const [hostElement, setHostElement] = React.useState(null);
  (0, import_core.useIsomorphicLayoutEffect)(() => {
    setHostElement(host);
  }, [host]);
  if (hostElement) {
    return (0, import_react_dom.createPortal)(contents, hostElement);
  }
  return null;
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=Portal.js.map


/***/ }),

/***/ 29680:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var PortalProps_exports = {};
module.exports = __toCommonJS(PortalProps_exports);
//# sourceMappingURL=PortalProps.js.map


/***/ }),

/***/ 69564:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var src_exports = {};
module.exports = __toCommonJS(src_exports);
__reExport(src_exports, __webpack_require__(20045), module.exports);
__reExport(src_exports, __webpack_require__(29680), module.exports);
__reExport(src_exports, __webpack_require__(22504), module.exports);
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 76919:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$2": function() { return /* binding */ PortalHost; },
/* harmony export */   "Xp": function() { return /* binding */ PortalProvider; },
/* harmony export */   "b5": function() { return /* binding */ PortalItem; }
/* harmony export */ });
/* unused harmony exports ACTIONS, INITIAL_STATE, usePortal */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43635);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4751);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11649);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);



var ACTIONS = /* @__PURE__ */ ((ACTIONS2) => {
  ACTIONS2[ACTIONS2["REGISTER_HOST"] = 0] = "REGISTER_HOST";
  ACTIONS2[ACTIONS2["DEREGISTER_HOST"] = 1] = "DEREGISTER_HOST";
  ACTIONS2[ACTIONS2["ADD_UPDATE_PORTAL"] = 2] = "ADD_UPDATE_PORTAL";
  ACTIONS2[ACTIONS2["REMOVE_PORTAL"] = 3] = "REMOVE_PORTAL";
  return ACTIONS2;
})(ACTIONS || {});
const INITIAL_STATE = {};
const registerHost = (state, hostName) => {
  if (!(hostName in state)) {
    state[hostName] = [];
  }
  return state;
};
const deregisterHost = (state, hostName) => {
  delete state[hostName];
  return state;
};
const addUpdatePortal = (state, hostName, portalName, node) => {
  if (!(hostName in state)) {
    state = registerHost(state, hostName);
  }
  const index = state[hostName].findIndex((item) => item.name === portalName);
  if (index !== -1) {
    state[hostName][index].node = node;
  } else {
    state[hostName].push({
      name: portalName,
      node
    });
  }
  return state;
};
const removePortal = (state, hostName, portalName) => {
  if (!(hostName in state)) {
    console.log(
      `Failed to remove portal '${portalName}', '${hostName}' was not registered!`
    );
    return state;
  }
  const index = state[hostName].findIndex((item) => item.name === portalName);
  if (index !== -1)
    state[hostName].splice(index, 1);
  return state;
};
const reducer = (state, action) => {
  const { type } = action;
  switch (type) {
    case 0 /* REGISTER_HOST */:
      return registerHost({ ...state }, action.hostName);
    case 1 /* DEREGISTER_HOST */:
      return deregisterHost({ ...state }, action.hostName);
    case 2 /* ADD_UPDATE_PORTAL */:
      return addUpdatePortal(
        { ...state },
        action.hostName,
        action.portalName,
        action.node
      );
    case 3 /* REMOVE_PORTAL */:
      return removePortal(
        { ...state },
        action.hostName,
        action.portalName
      );
    default:
      return state;
  }
};
const PortalStateContext = (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(null);
const PortalDispatchContext = (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(null);
const usePortalState = (hostName) => {
  const state = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(PortalStateContext);
  if (state === null) {
    throw new Error(
      "'PortalStateContext' cannot be null, please add 'PortalProvider' to the root component."
    );
  }
  return state[hostName] || [];
};
const usePortal = (hostName = "root") => {
  const dispatch = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(PortalDispatchContext);
  if (dispatch === null) {
    throw new Error(
      "'PortalDispatchContext' cannot be null, please add 'PortalProvider' to the root component."
    );
  }
  const registerHost2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(() => {
    dispatch({
      type: 0 /* REGISTER_HOST */,
      hostName
    });
  }, []);
  const deregisterHost2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(() => {
    dispatch({
      type: 1 /* DEREGISTER_HOST */,
      hostName
    });
  }, []);
  const addUpdatePortal2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((name, node) => {
    dispatch({
      type: 2 /* ADD_UPDATE_PORTAL */,
      hostName,
      portalName: name,
      node
    });
  }, []);
  const removePortal2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((name) => {
    dispatch({
      type: 3 /* REMOVE_PORTAL */,
      hostName,
      portalName: name
    });
  }, []);
  return {
    registerHost: registerHost2,
    deregisterHost: deregisterHost2,
    addPortal: addUpdatePortal2,
    updatePortal: addUpdatePortal2,
    removePortal: removePortal2
  };
};
const PortalProviderComponent = ({
  rootHostName = "root",
  shouldAddRootHost = true,
  children
}) => {
  const [state, dispatch] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useReducer)(reducer, INITIAL_STATE);
  const transitionDispatch = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(() => {
    const next = (value) => {
      (0,react__WEBPACK_IMPORTED_MODULE_1__.startTransition)(() => {
        dispatch(value);
      });
    };
    return next;
  }, [dispatch]);
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PortalDispatchContext.Provider, { value: transitionDispatch, children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(PortalStateContext.Provider, { value: state, children: [
    children,
    shouldAddRootHost && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PortalHost, { name: rootHostName })
  ] }) });
};
const PortalProvider = (0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(PortalProviderComponent);
PortalProvider.displayName = "PortalProvider";
const PortalHostComponent = (props) => {
  const { name, forwardProps } = props;
  const isServer = !(0,_tamagui_core__WEBPACK_IMPORTED_MODULE_2__/* .useDidFinishSSR */ .S)();
  const state = usePortalState(name);
  const { registerHost: registerHost2, deregisterHost: deregisterHost2 } = usePortal(props.name);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    if (isServer)
      return;
    registerHost2();
    return () => {
      deregisterHost2();
    };
  }, [isServer]);
  if (forwardProps) {
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: state.map((item) => {
      let next = item.node;
      if (forwardProps) {
        return react__WEBPACK_IMPORTED_MODULE_1__.Children.map(next, (child) => {
          return react__WEBPACK_IMPORTED_MODULE_1__.isValidElement(child) ? react__WEBPACK_IMPORTED_MODULE_1__.cloneElement(child, { key: child.key, ...forwardProps }) : child;
        });
      }
      return next;
    }) });
  }
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: state.map((item) => item.node) });
};
const PortalHost = (0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(PortalHostComponent);
PortalHost.displayName = "PortalHost";
const PortalComponent = (props) => {
  const {
    name: _providedName,
    hostName,
    handleOnMount: _providedHandleOnMount,
    handleOnUnmount: _providedHandleOnUnmount,
    handleOnUpdate: _providedHandleOnUpdate,
    children
  } = props;
  const { addPortal: addUpdatePortal2, removePortal: removePortal2 } = usePortal(hostName);
  const id = (0,react__WEBPACK_IMPORTED_MODULE_1__.useId)();
  const name = _providedName || id;
  const handleOnMount = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_3__/* .useEvent */ .z)(() => {
    if (_providedHandleOnMount) {
      _providedHandleOnMount(() => addUpdatePortal2(name, children));
    } else {
      addUpdatePortal2(name, children);
    }
  });
  const handleOnUnmount = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_3__/* .useEvent */ .z)(() => {
    if (_providedHandleOnUnmount) {
      _providedHandleOnUnmount(() => removePortal2(name));
    } else {
      removePortal2(name);
    }
  });
  const handleOnUpdate = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_3__/* .useEvent */ .z)(() => {
    if (_providedHandleOnUpdate) {
      _providedHandleOnUpdate(() => addUpdatePortal2(name, children));
    } else {
      addUpdatePortal2(name, children);
    }
  });
  (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_4__/* .useIsomorphicLayoutEffect */ .LI)(() => {
    handleOnMount();
    return () => {
      handleOnUnmount();
    };
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    handleOnUpdate();
  }, [children]);
  return null;
};
const PortalItem = (0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(PortalComponent);
PortalItem.displayName = "Portal";

//# sourceMappingURL=GorhomPortal.js.map


/***/ }),

/***/ 42048:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ Portal; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _tamagui_polyfill_dev__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85360);
/* harmony import */ var _tamagui_polyfill_dev__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_tamagui_polyfill_dev__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11649);
/* harmony import */ var _tamagui_stacks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8939);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28316);






const Portal = ({ host = ((_a) => (_a = globalThis.document) == null ? void 0 : _a.body)(), ...props }) => {
  const contents = /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
    _tamagui_stacks__WEBPACK_IMPORTED_MODULE_4__/* .YStack */ .FA,
    {
      contain: "strict",
      fullscreen: true,
      position: _tamagui_core__WEBPACK_IMPORTED_MODULE_5__/* .isWeb */ .$L ? "fixed" : "absolute",
      maxWidth: _tamagui_core__WEBPACK_IMPORTED_MODULE_5__/* .isWeb */ .$L ? "100vw" : "100%",
      maxHeight: _tamagui_core__WEBPACK_IMPORTED_MODULE_5__/* .isWeb */ .$L ? "100vh" : "100%",
      pointerEvents: "none",
      ...props
    }
  );
  const [hostElement, setHostElement] = react__WEBPACK_IMPORTED_MODULE_2__.useState(null);
  (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_5__/* .useIsomorphicLayoutEffect */ .LI)(() => {
    setHostElement(host);
  }, [host]);
  if (hostElement) {
    return (0,react_dom__WEBPACK_IMPORTED_MODULE_3__.createPortal)(contents, hostElement);
  }
  return null;
};

//# sourceMappingURL=Portal.js.map


/***/ }),

/***/ 67360:
/***/ (function() {

//# sourceMappingURL=PortalProps.js.map


/***/ }),

/***/ 57303:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Progress_exports = {};
__export(Progress_exports, {
  Progress: () => Progress,
  ProgressFrame: () => ProgressFrame,
  ProgressIndicator: () => ProgressIndicator,
  ProgressIndicatorFrame: () => ProgressIndicatorFrame,
  createProgressScope: () => createProgressScope
});
module.exports = __toCommonJS(Progress_exports);
var import_jsx_runtime = __webpack_require__(52322);
var import_core = __webpack_require__(44996);
var import_create_context = __webpack_require__(71913);
var import_get_size = __webpack_require__(20157);
var import_stacks = __webpack_require__(84432);
var React = __toESM(__webpack_require__(2784));
const PROGRESS_NAME = "Progress";
const [createProgressContext, createProgressScope] = (0, import_create_context.createContextScope)(PROGRESS_NAME);
const [ProgressProvider, useProgressContext] = createProgressContext(PROGRESS_NAME);
const INDICATOR_NAME = "ProgressIndicator";
const ProgressIndicatorFrame = (0, import_core.styled)(import_stacks.ThemeableStack, {
  name: INDICATOR_NAME,
  height: "100%",
  width: "100%",
  backgrounded: true
});
const ProgressIndicator = ProgressIndicatorFrame.extractable(
  React.forwardRef(
    (props, forwardedRef) => {
      const { __scopeProgress, ...indicatorProps } = props;
      const context = useProgressContext(INDICATOR_NAME, __scopeProgress);
      const pct = context.max - (context.value ?? 0);
      const x = -context.width * (pct / 100);
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
        ProgressIndicatorFrame,
        {
          "data-state": getProgressState(context.value, context.max),
          "data-value": context.value ?? void 0,
          "data-max": context.max,
          x,
          width: context.width,
          ...indicatorProps,
          ref: forwardedRef
        }
      );
    }
  )
);
ProgressIndicator.displayName = INDICATOR_NAME;
function defaultGetValueLabel(value, max) {
  return `${Math.round(value / max * 100)}%`;
}
function getProgressState(value, maxValue) {
  return value == null ? "indeterminate" : value === maxValue ? "complete" : "loading";
}
function isNumber(value) {
  return typeof value === "number";
}
function isValidMaxNumber(max) {
  return isNumber(max) && !isNaN(max) && max > 0;
}
function isValidValueNumber(value, max) {
  return isNumber(value) && !isNaN(value) && value <= max && value >= 0;
}
function getInvalidMaxError(propValue, componentName) {
  return `Invalid prop \`max\` of value \`${propValue}\` supplied to \`${componentName}\`. Only numbers greater than 0 are valid max values. Defaulting to \`${DEFAULT_MAX}\`.`;
}
function getInvalidValueError(propValue, componentName) {
  return `Invalid prop \`value\` of value \`${propValue}\` supplied to \`${componentName}\`. The \`value\` prop must be:
  - a positive number
  - less than the value passed to \`max\` (or ${DEFAULT_MAX} if no \`max\` prop is set)
  - \`null\` if the progress is indeterminate.

Defaulting to \`null\`.`;
}
const DEFAULT_MAX = 100;
const ProgressFrame = (0, import_core.styled)(import_stacks.ThemeableStack, {
  name: PROGRESS_NAME,
  borderRadius: 1e5,
  overflow: "hidden",
  backgrounded: true,
  variants: {
    size: {
      "...size": (val) => {
        const size = Math.round((0, import_core.getVariableValue)((0, import_get_size.getSize)(val)) * 0.25);
        return {
          height: size,
          minWidth: (0, import_core.getVariableValue)(size) * 20,
          width: "100%"
        };
      }
    }
  }
});
const Progress = (0, import_core.withStaticProperties)(
  ProgressFrame.extractable(
    React.forwardRef(
      (props, forwardedRef) => {
        const {
          __scopeProgress,
          value: valueProp,
          max: maxProp,
          getValueLabel = defaultGetValueLabel,
          size = "$true",
          ...progressProps
        } = props;
        const max = isValidMaxNumber(maxProp) ? maxProp : DEFAULT_MAX;
        const value = isValidValueNumber(valueProp, max) ? valueProp : null;
        const valueLabel = isNumber(value) ? getValueLabel(value, max) : void 0;
        const [width, setWidth] = React.useState(0);
        return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ProgressProvider, { scope: __scopeProgress, value, max, width, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
          ProgressFrame,
          {
            size,
            "aria-valuemax": max,
            "aria-valuemin": 0,
            "aria-valuenow": isNumber(value) ? value : void 0,
            "aria-valuetext": valueLabel,
            role: "progressbar",
            "data-state": getProgressState(value, max),
            "data-value": value ?? void 0,
            "data-max": max,
            ...progressProps,
            onLayout: (e) => {
              var _a;
              setWidth(e.nativeEvent.layout.width);
              (_a = progressProps.onLayout) == null ? void 0 : _a.call(progressProps, e);
            },
            ref: forwardedRef
          }
        ) });
      }
    )
  ),
  {
    Indicator: ProgressIndicator
  }
);
Progress.displayName = PROGRESS_NAME;
Progress.propTypes = {
  max(props, propName, componentName) {
    const propValue = props[propName];
    const strVal = String(propValue);
    if (propValue && !isValidMaxNumber(propValue)) {
      return new Error(getInvalidMaxError(strVal, componentName));
    }
    return null;
  },
  value(props, propName, componentName) {
    const valueProp = props[propName];
    const strVal = String(valueProp);
    const max = isValidMaxNumber(props.max) ? props.max : DEFAULT_MAX;
    if (valueProp != null && !isValidValueNumber(valueProp, max)) {
      return new Error(getInvalidValueError(strVal, componentName));
    }
    return null;
  }
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=Progress.js.map


/***/ }),

/***/ 45451:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var src_exports = {};
module.exports = __toCommonJS(src_exports);
__reExport(src_exports, __webpack_require__(57303), module.exports);
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 54726:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var RadioGroup_exports = {};
__export(RadioGroup_exports, {
  RadioGroup: () => RadioGroup,
  createRadioGroupScope: () => createRadioGroupScope
});
module.exports = __toCommonJS(RadioGroup_exports);
var import_jsx_runtime = __webpack_require__(52322);
var import_react_use_previous = __webpack_require__(69586);
var import_core = __webpack_require__(44996);
var import_create_context = __webpack_require__(71913);
var import_focusable = __webpack_require__(31390);
var import_get_size = __webpack_require__(20157);
var import_label = __webpack_require__(28339);
var import_stacks = __webpack_require__(84432);
var import_use_controllable_state = __webpack_require__(12113);
var React = __toESM(__webpack_require__(2784));
const RADIO_GROUP_NAME = "RadioGroup";
const ARROW_KEYS = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"];
const [createRadioGroupContext, createRadioGroupScope] = (0, import_create_context.createContextScope)(RADIO_GROUP_NAME);
const [RadioGroupProvider, useRadioGroupContext] = createRadioGroupContext(RADIO_GROUP_NAME);
const getState = (checked) => {
  return checked ? "checked" : "unchecked";
};
const RADIO_GROUP_INDICATOR_NAME = "RadioGroupIndicator";
const RadioIndicatorFrame = (0, import_core.styled)(import_stacks.ThemeableStack, {
  name: RADIO_GROUP_INDICATOR_NAME,
  pointerEvents: "none",
  variants: {
    unstyled: {
      false: {
        w: "40%",
        h: "40%",
        br: 1e3,
        backgroundColor: "$color"
      }
    }
  },
  defaultVariants: {
    unstyled: false
  }
});
const RadioIndicator = RadioIndicatorFrame.extractable(
  React.forwardRef(
    (props, forwardedRef) => {
      const { __scopeRadioGroupItem, forceMount, disabled, ...indicatorProps } = props;
      const { checked } = useRadioGroupItemContext(
        RADIO_GROUP_INDICATOR_NAME,
        __scopeRadioGroupItem
      );
      if (forceMount || checked) {
        return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
          RadioIndicatorFrame,
          {
            theme: "active",
            "data-state": getState(checked),
            "data-disabled": disabled ? "" : void 0,
            ...indicatorProps,
            ref: forwardedRef
          }
        );
      }
      return null;
    }
  )
);
RadioIndicator.displayName = RADIO_GROUP_INDICATOR_NAME;
const RADIO_GROUP_ITEM_NAME = "RadioGroupItem";
const [RadioGroupItemProvider, useRadioGroupItemContext] = createRadioGroupContext(RADIO_GROUP_NAME);
const RadioGroupItemFrame = (0, import_core.styled)(import_stacks.ThemeableStack, {
  name: RADIO_GROUP_ITEM_NAME,
  tag: "button",
  variants: {
    unstyled: {
      false: {
        size: "$true",
        borderRadius: 1e3,
        backgroundColor: "$background",
        alignItems: "center",
        justifyContent: "center",
        borderWidth: 1,
        borderColor: "$borderColor",
        padding: 0,
        hoverStyle: {
          borderColor: "$borderColorHover"
        },
        focusStyle: {
          borderColor: "$borderColorFocus"
        }
      }
    },
    size: {
      "...size": (value, { props }) => {
        const size = Math.floor(
          (0, import_core.getVariableValue)((0, import_get_size.getSize)(value)) * (props["scaleSize"] ?? 0.5)
        );
        return {
          width: size,
          height: size
        };
      }
    }
  },
  defaultVariants: {
    unstyled: false
  }
});
const RadioGroupItem = RadioGroupItemFrame.extractable(
  React.forwardRef(
    (props, forwardedRef) => {
      const {
        __scopeRadioGroup,
        value,
        labelledBy: ariaLabelledby,
        disabled: itemDisabled,
        ...itemProps
      } = props;
      const {
        value: groupValue,
        disabled,
        required,
        onChange,
        name,
        native,
        accentColor
      } = useRadioGroupContext(RADIO_GROUP_ITEM_NAME, __scopeRadioGroup);
      const [button, setButton] = React.useState(null);
      const hasConsumerStoppedPropagationRef = React.useRef(false);
      const ref = React.useRef(null);
      const composedRefs = (0, import_core.useComposedRefs)(forwardedRef, (node) => setButton(node), ref);
      const isArrowKeyPressedRef = React.useRef(false);
      const isFormControl = import_core.isWeb ? button ? Boolean(button.closest("form")) : true : false;
      const checked = groupValue === value;
      const labelId = (0, import_label.useLabelContext)(button);
      const labelledBy = ariaLabelledby || labelId;
      React.useEffect(() => {
        if (import_core.isWeb) {
          const handleKeyDown = (event) => {
            if (ARROW_KEYS.includes(event.key)) {
              isArrowKeyPressedRef.current = true;
            }
          };
          const handleKeyUp = () => isArrowKeyPressedRef.current = false;
          document.addEventListener("keydown", handleKeyDown);
          document.addEventListener("keyup", handleKeyUp);
          return () => {
            document.removeEventListener("keydown", handleKeyDown);
            document.removeEventListener("keyup", handleKeyUp);
          };
        }
      }, []);
      if (false) {}
      const isDisabled = disabled || itemDisabled;
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(RadioGroupItemProvider, { checked, scope: __scopeRadioGroup, children: import_core.isWeb && native ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
        BubbleInput,
        {
          control: button,
          bubbles: !hasConsumerStoppedPropagationRef.current,
          name,
          value,
          checked,
          required,
          disabled: isDisabled,
          id: props.id,
          accentColor
        }
      ) : /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, { children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
          RadioGroupItemFrame,
          {
            "data-state": getState(checked),
            "data-disabled": isDisabled ? "" : void 0,
            role: "radio",
            "aria-labelledby": labelledBy,
            "aria-checked": checked,
            "aria-required": required,
            disabled: isDisabled,
            ref: composedRefs,
            ...import_core.isWeb && {
              type: "button",
              value
            },
            ...itemProps,
            onPress: (0, import_core.composeEventHandlers)(props.onPress, (event) => {
              if (!checked) {
                onChange == null ? void 0 : onChange(value);
              }
              if (isFormControl) {
                hasConsumerStoppedPropagationRef.current = event.isPropagationStopped();
                if (!hasConsumerStoppedPropagationRef.current)
                  event.stopPropagation();
              }
            }),
            ...import_core.isWeb && {
              onKeyDown: (0, import_core.composeEventHandlers)(
                props.onKeyDown,
                (event) => {
                  if (event.key === "Enter")
                    event.preventDefault();
                }
              ),
              onFocus: (0, import_core.composeEventHandlers)(itemProps.onFocus, () => {
                var _a;
                if (isArrowKeyPressedRef.current)
                  (_a = ref.current) == null ? void 0 : _a.click();
              })
            }
          }
        ),
        isFormControl && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
          BubbleInput,
          {
            isHidden: true,
            control: button,
            bubbles: !hasConsumerStoppedPropagationRef.current,
            name,
            value,
            checked,
            required,
            disabled: isDisabled
          }
        )
      ] }) });
    }
  )
);
const BubbleInput = (props) => {
  const { checked, bubbles = true, control, isHidden, accentColor, ...inputProps } = props;
  const ref = React.useRef(null);
  const prevChecked = (0, import_react_use_previous.usePrevious)(checked);
  React.useEffect(() => {
    const input = ref.current;
    const inputProto = window.HTMLInputElement.prototype;
    const descriptor = Object.getOwnPropertyDescriptor(
      inputProto,
      "checked"
    );
    const setChecked = descriptor.set;
    if (prevChecked !== checked && setChecked) {
      const event = new Event("click", { bubbles });
      setChecked.call(input, checked);
      input.dispatchEvent(event);
    }
  }, [prevChecked, checked, bubbles]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
    "input",
    {
      type: "radio",
      defaultChecked: checked,
      ...inputProps,
      tabIndex: -1,
      ref,
      "aria-hidden": isHidden,
      style: {
        ...isHidden ? {
          // ...controlSize,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0
        } : {
          appearance: "auto",
          accentColor
        },
        ...props.style
      }
    }
  );
};
const RadioGroupFrame = (0, import_core.styled)(import_stacks.ThemeableStack, {
  name: RADIO_GROUP_NAME,
  variants: {
    orientation: {
      horizontal: {
        flexDirection: "row",
        spaceDirection: "horizontal"
      },
      vertical: {
        flexDirection: "column",
        spaceDirection: "vertical"
      }
    }
  }
});
const RadioGroup = (0, import_core.withStaticProperties)(
  RadioGroupFrame.extractable(
    React.forwardRef(
      (props, forwardedRef) => {
        const {
          __scopeRadioGroup,
          value: valueProp,
          defaultValue,
          onValueChange,
          disabled = false,
          required = false,
          name,
          orientation,
          native,
          accentColor,
          ...radioGroupProps
        } = props;
        const [value, setValue] = (0, import_use_controllable_state.useControllableState)({
          prop: valueProp,
          defaultProp: defaultValue,
          onChange: onValueChange
        });
        return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
          RadioGroupProvider,
          {
            scope: __scopeRadioGroup,
            value,
            required,
            onChange: setValue,
            disabled,
            name,
            native,
            accentColor,
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
              RadioGroupFrame,
              {
                "aria-valuetext": value,
                role: "radiogroup",
                "aria-orientation": orientation,
                ref: forwardedRef,
                orientation,
                "data-disabled": disabled ? "" : void 0,
                ...radioGroupProps
              }
            )
          }
        );
      }
    )
  ),
  {
    Indicator: RadioIndicator,
    Item: RadioGroupItem
  }
);
RadioGroup.displayName = RADIO_GROUP_NAME;
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=RadioGroup.js.map


/***/ }),

/***/ 97922:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var src_exports = {};
module.exports = __toCommonJS(src_exports);
__reExport(src_exports, __webpack_require__(54726), module.exports);
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 85845:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "createMedia": function() { return /* reexport */ createMedia; },
  "matchMedia": function() { return /* reexport */ matchMedia_matchMedia; }
});

// EXTERNAL MODULE: ./node_modules/@tamagui/web/dist/esm/helpers/matchMedia.js
var matchMedia = __webpack_require__(80906);
;// CONCATENATED MODULE: ../../node_modules/@tamagui/react-native-media-driver/dist/esm/matchMedia.js
const matchMedia_matchMedia = globalThis["matchMedia"];

//# sourceMappingURL=matchMedia.js.map

;// CONCATENATED MODULE: ../../node_modules/@tamagui/react-native-media-driver/dist/esm/createMedia.js


function createMedia(media) {
  (0,matchMedia/* setupMatchMedia */.D)(matchMedia_matchMedia);
  return media;
}

//# sourceMappingURL=createMedia.js.map

;// CONCATENATED MODULE: ../../node_modules/@tamagui/react-native-media-driver/dist/esm/index.js


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 77870:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var RemoveScroll_exports = {};
__export(RemoveScroll_exports, {
  RemoveScroll: () => RemoveScroll
});
module.exports = __toCommonJS(RemoveScroll_exports);
var import_jsx_runtime = __webpack_require__(52322);
var import_react_remove_scroll = __webpack_require__(99271);
const RemoveScroll = (props) => {
  if (!props.children)
    return null;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_remove_scroll.RemoveScroll, { ...props });
};
RemoveScroll.classNames = import_react_remove_scroll.RemoveScroll.classNames;
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=RemoveScroll.js.map


/***/ }),

/***/ 85293:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var src_exports = {};
module.exports = __toCommonJS(src_exports);
__reExport(src_exports, __webpack_require__(77870), module.exports);
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 44099:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var RovingFocusGroup_exports = {};
__export(RovingFocusGroup_exports, {
  RovingFocusGroup: () => RovingFocusGroup,
  createRovingFocusGroupScope: () => createRovingFocusGroupScope
});
module.exports = __toCommonJS(RovingFocusGroup_exports);
var import_jsx_runtime = __webpack_require__(52322);
var import_collection = __webpack_require__(38987);
var import_compose_refs = __webpack_require__(7199);
var import_core = __webpack_require__(44996);
var import_core2 = __webpack_require__(44996);
var import_create_context = __webpack_require__(71913);
var import_use_controllable_state = __webpack_require__(12113);
var import_use_direction = __webpack_require__(10498);
var React = __toESM(__webpack_require__(2784));
const ENTRY_FOCUS = "rovingFocusGroup.onEntryFocus";
const EVENT_OPTIONS = { bubbles: false, cancelable: true };
const RovingFocusGroupImpl = React.forwardRef((props, forwardedRef) => {
  const {
    __scopeRovingFocusGroup,
    orientation,
    loop = false,
    dir,
    currentTabStopId: currentTabStopIdProp,
    defaultCurrentTabStopId,
    onCurrentTabStopIdChange,
    onEntryFocus,
    ...groupProps
  } = props;
  const ref = React.useRef(null);
  const composedRefs = (0, import_compose_refs.useComposedRefs)(forwardedRef, ref);
  const direction = (0, import_use_direction.useDirection)(dir);
  const [currentTabStopId = null, setCurrentTabStopId] = (0, import_use_controllable_state.useControllableState)({
    prop: currentTabStopIdProp,
    defaultProp: defaultCurrentTabStopId ?? null,
    onChange: onCurrentTabStopIdChange
  });
  const [isTabbingBackOut, setIsTabbingBackOut] = React.useState(false);
  const handleEntryFocus = (0, import_core.useEvent)(onEntryFocus);
  const getItems = useCollection(__scopeRovingFocusGroup);
  const isClickFocusRef = React.useRef(false);
  const [focusableItemsCount, setFocusableItemsCount] = React.useState(0);
  React.useEffect(() => {
    const node = ref.current;
    if (node) {
      node.addEventListener(ENTRY_FOCUS, handleEntryFocus);
      return () => node.removeEventListener(ENTRY_FOCUS, handleEntryFocus);
    }
  }, [handleEntryFocus]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
    RovingFocusProvider,
    {
      scope: __scopeRovingFocusGroup,
      orientation,
      dir: direction,
      loop,
      currentTabStopId,
      onItemFocus: React.useCallback(
        (tabStopId) => setCurrentTabStopId(tabStopId),
        [setCurrentTabStopId]
      ),
      onItemShiftTab: React.useCallback(() => setIsTabbingBackOut(true), []),
      onFocusableItemAdd: React.useCallback(
        () => setFocusableItemsCount((prevCount) => prevCount + 1),
        []
      ),
      onFocusableItemRemove: React.useCallback(
        () => setFocusableItemsCount((prevCount) => prevCount - 1),
        []
      ),
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
        import_core.Stack,
        {
          tabIndex: isTabbingBackOut || focusableItemsCount === 0 ? -1 : 0,
          "data-orientation": orientation,
          ...groupProps,
          ref: composedRefs,
          style: [{ outline: "none" }, props.style],
          onMouseDown: (0, import_core.composeEventHandlers)(props.onMouseDown, () => {
            isClickFocusRef.current = true;
          }),
          onFocus: (0, import_core.composeEventHandlers)(props.onFocus, (event) => {
            const isKeyboardFocus = !isClickFocusRef.current;
            if (event.target === event.currentTarget && isKeyboardFocus && !isTabbingBackOut) {
              const entryFocusEvent = new CustomEvent(ENTRY_FOCUS, EVENT_OPTIONS);
              event.currentTarget.dispatchEvent(entryFocusEvent);
              if (!entryFocusEvent.defaultPrevented) {
                const items = getItems().filter((item) => item.focusable);
                const activeItem = items.find((item) => item.active);
                const currentItem = items.find((item) => item.id === currentTabStopId);
                const candidateItems = [activeItem, currentItem, ...items].filter(
                  Boolean
                );
                const candidateNodes = candidateItems.map((item) => item.ref.current);
                focusFirst(candidateNodes);
              }
            }
            isClickFocusRef.current = false;
          }),
          onBlur: (0, import_core.composeEventHandlers)(props.onBlur, () => setIsTabbingBackOut(false))
        }
      )
    }
  );
});
const ITEM_NAME = "RovingFocusGroupItem";
const RovingFocusGroupItem = React.forwardRef((props, forwardedRef) => {
  const {
    __scopeRovingFocusGroup,
    focusable = true,
    active = false,
    tabStopId,
    ...itemProps
  } = props;
  const autoId = (0, import_core2.useId)();
  const id = tabStopId || autoId;
  const context = useRovingFocusContext(ITEM_NAME, __scopeRovingFocusGroup);
  const isCurrentTabStop = context.currentTabStopId === id;
  const getItems = useCollection(__scopeRovingFocusGroup);
  const { onFocusableItemAdd, onFocusableItemRemove } = context;
  React.useEffect(() => {
    if (focusable) {
      onFocusableItemAdd();
      return () => onFocusableItemRemove();
    }
  }, [focusable, onFocusableItemAdd, onFocusableItemRemove]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
    Collection.ItemSlot,
    {
      scope: __scopeRovingFocusGroup,
      id,
      focusable,
      active,
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
        import_core.Stack,
        {
          tabIndex: isCurrentTabStop ? 0 : -1,
          "data-orientation": context.orientation,
          ...itemProps,
          ref: forwardedRef,
          onMouseDown: (0, import_core.composeEventHandlers)(props.onMouseDown, (event) => {
            if (!focusable)
              event.preventDefault();
            else
              context.onItemFocus(id);
          }),
          onFocus: (0, import_core.composeEventHandlers)(props.onFocus, () => context.onItemFocus(id)),
          ...import_core.isWeb && {
            onKeyDown: (0, import_core.composeEventHandlers)(
              props.onKeyDown,
              (event) => {
                if (event.key === "Tab" && event.shiftKey) {
                  context.onItemShiftTab();
                  return;
                }
                if (event.target !== event.currentTarget)
                  return;
                const focusIntent = getFocusIntent(event, context.orientation, context.dir);
                if (focusIntent !== void 0) {
                  event.preventDefault();
                  const items = getItems().filter((item) => item.focusable);
                  let candidateNodes = items.map((item) => item.ref.current);
                  if (focusIntent === "last")
                    candidateNodes.reverse();
                  else if (focusIntent === "prev" || focusIntent === "next") {
                    if (focusIntent === "prev")
                      candidateNodes.reverse();
                    const currentIndex = candidateNodes.indexOf(event.currentTarget);
                    candidateNodes = context.loop ? wrapArray(candidateNodes, currentIndex + 1) : candidateNodes.slice(currentIndex + 1);
                  }
                  setTimeout(() => focusFirst(candidateNodes));
                }
              }
            )
          }
        }
      )
    }
  );
});
RovingFocusGroupItem.displayName = ITEM_NAME;
const GROUP_NAME = "RovingFocusGroup";
const [Collection, useCollection, createCollectionScope] = (0, import_collection.createCollection)(GROUP_NAME);
const [createRovingFocusGroupContext, createRovingFocusGroupScope] = (0, import_create_context.createContextScope)(
  GROUP_NAME,
  [createCollectionScope]
);
const [RovingFocusProvider, useRovingFocusContext] = createRovingFocusGroupContext(GROUP_NAME);
const RovingFocusGroup = (0, import_core.withStaticProperties)(
  React.forwardRef(
    (props, forwardedRef) => {
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Collection.Provider, { scope: props.__scopeRovingFocusGroup, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Collection.Slot, { scope: props.__scopeRovingFocusGroup, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(RovingFocusGroupImpl, { ...props, ref: forwardedRef }) }) });
    }
  ),
  {
    Item: RovingFocusGroupItem
  }
);
RovingFocusGroup.displayName = GROUP_NAME;
const MAP_KEY_TO_FOCUS_INTENT = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function getDirectionAwareKey(key, dir) {
  if (dir !== "rtl")
    return key;
  return key === "ArrowLeft" ? "ArrowRight" : key === "ArrowRight" ? "ArrowLeft" : key;
}
function getFocusIntent(event, orientation, dir) {
  const key = getDirectionAwareKey(event.key, dir);
  if (orientation === "vertical" && ["ArrowLeft", "ArrowRight"].includes(key))
    return void 0;
  if (orientation === "horizontal" && ["ArrowUp", "ArrowDown"].includes(key))
    return void 0;
  return MAP_KEY_TO_FOCUS_INTENT[key];
}
function focusFirst(candidates) {
  const PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
  for (const candidate of candidates) {
    if (candidate === PREVIOUSLY_FOCUSED_ELEMENT)
      return;
    candidate.focus();
    if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT)
      return;
  }
}
function wrapArray(array, startIndex) {
  return array.map((_, index) => array[(startIndex + index) % array.length]);
}
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=RovingFocusGroup.js.map


/***/ }),

/***/ 26394:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var src_exports = {};
module.exports = __toCommonJS(src_exports);
__reExport(src_exports, __webpack_require__(44099), module.exports);
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 46598:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var ScrollView_exports = {};
__export(ScrollView_exports, {
  ScrollView: () => ScrollView
});
module.exports = __toCommonJS(ScrollView_exports);
var import_stacks = __webpack_require__(84432);
var import_web = __webpack_require__(44571);
var import_react_native = __webpack_require__(22164);
(0, import_web.setupReactNative)({
  ScrollView: import_react_native.ScrollView
});
const ScrollView = (0, import_web.styled)(
  import_react_native.ScrollView,
  {
    name: "ScrollView",
    scrollEnabled: true,
    variants: {
      fullscreen: {
        true: import_stacks.fullscreenStyle
      }
    }
  },
  {
    // this maybe not necesssary since setupReactNative is called?
    isReactNative: true
  }
);
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=ScrollView.js.map


/***/ }),

/***/ 81822:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var src_exports = {};
module.exports = __toCommonJS(src_exports);
__reExport(src_exports, __webpack_require__(46598), module.exports);
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 63312:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Select_exports = {};
__export(Select_exports, {
  Select: () => Select,
  SelectGroupFrame: () => SelectGroupFrame,
  SelectIcon: () => SelectIcon,
  SelectItem: () => SelectItem,
  SelectItemTextFrame: () => SelectItemTextFrame,
  SelectSeparator: () => SelectSeparator,
  SelectTrigger: () => SelectTrigger
});
module.exports = __toCommonJS(Select_exports);
var import_jsx_runtime = __webpack_require__(52322);
var import_adapt = __webpack_require__(8242);
var import_compose_refs = __webpack_require__(7199);
var import_core = __webpack_require__(44996);
var import_list_item = __webpack_require__(95692);
var import_portal = __webpack_require__(69564);
var import_separator = __webpack_require__(55990);
var import_sheet = __webpack_require__(24226);
var import_stacks = __webpack_require__(84432);
var import_text = __webpack_require__(48175);
var import_use_controllable_state = __webpack_require__(12113);
var React = __toESM(__webpack_require__(2784));
var import_constants = __webpack_require__(30529);
var import_context = __webpack_require__(81629);
var import_SelectContent = __webpack_require__(69950);
var import_SelectImpl = __webpack_require__(1363);
var import_SelectScrollButton = __webpack_require__(38037);
var import_SelectViewport = __webpack_require__(81743);
var import_useSelectBreakpointActive = __webpack_require__(71031);
const TRIGGER_NAME = "SelectTrigger";
const SelectTrigger = React.forwardRef(
  (props, forwardedRef) => {
    const {
      __scopeSelect,
      disabled = false,
      // @ts-ignore
      "aria-labelledby": ariaLabelledby,
      ...triggerProps
    } = props;
    const context = (0, import_context.useSelectContext)(TRIGGER_NAME, __scopeSelect);
    const labelledBy = ariaLabelledby;
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
      import_list_item.ListItem,
      {
        componentName: TRIGGER_NAME,
        backgrounded: true,
        radiused: true,
        hoverTheme: true,
        pressTheme: true,
        focusTheme: true,
        focusable: true,
        borderWidth: 1,
        size: context.size,
        "aria-expanded": context.open,
        "aria-autocomplete": "none",
        "aria-labelledby": labelledBy,
        dir: context.dir,
        disabled,
        "data-disabled": disabled ? "" : void 0,
        ...triggerProps,
        ref: forwardedRef,
        ... true && context.interactions ? context.interactions.getReferenceProps() : {
          onPress() {
            context.setOpen(!context.open);
          }
        }
      }
    );
  }
);
SelectTrigger.displayName = TRIGGER_NAME;
const VALUE_NAME = "SelectValue";
const SelectValueFrame = (0, import_core.styled)(import_text.Paragraph, {
  name: VALUE_NAME,
  userSelect: "none"
});
const SelectValue = SelectValueFrame.extractable(
  React.forwardRef(
    ({
      __scopeSelect,
      children: childrenProp,
      placeholder
    }, forwardedRef) => {
      const context = (0, import_context.useSelectContext)(VALUE_NAME, __scopeSelect);
      const { onValueNodeHasChildrenChange } = context;
      const composedRefs = (0, import_compose_refs.useComposedRefs)(forwardedRef, context.onValueNodeChange);
      const children = childrenProp ?? context.selectedItem;
      const hasChildren = !!children;
      const isEmptyValue = context.value == null || context.value === "";
      const selectValueChildren = isEmptyValue ? placeholder ?? children : children;
      (0, import_core.useIsomorphicLayoutEffect)(() => {
        onValueNodeHasChildrenChange(hasChildren);
      }, [onValueNodeHasChildrenChange, hasChildren]);
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
        SelectValueFrame,
        {
          size: context.size,
          ref: composedRefs,
          pointerEvents: "none",
          children: selectValueChildren
        }
      );
    }
  )
);
SelectValue.displayName = VALUE_NAME;
const SelectIcon = (0, import_core.styled)(import_stacks.XStack, {
  name: "SelectIcon",
  // @ts-ignore
  "aria-hidden": true,
  children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_text.Paragraph, { children: "\u25BC" })
});
const ITEM_NAME = "SelectItem";
const [SelectItemContextProvider, useSelectItemContext] = (0, import_context.createSelectContext)(ITEM_NAME);
const SelectItem = React.forwardRef(
  (props, forwardedRef) => {
    const {
      __scopeSelect,
      value,
      disabled = false,
      textValue: textValueProp,
      index,
      ...itemProps
    } = props;
    const context = (0, import_context.useSelectContext)(ITEM_NAME, __scopeSelect);
    const isSelected = context.value === value;
    const textId = (0, import_core.useId)();
    const {
      selectedIndex,
      setSelectedIndex,
      listRef,
      open,
      setOpen,
      onChange,
      setActiveIndex,
      allowMouseUpRef,
      allowSelectRef,
      setValueAtIndex,
      selectTimeoutRef,
      dataRef
    } = context;
    const composedRefs = (0, import_compose_refs.useComposedRefs)(forwardedRef, (node) => {
      if (!import_core.isWeb)
        return;
      if (node instanceof HTMLElement) {
        if (listRef) {
          listRef.current[index] = node;
        }
      }
    });
    React.useEffect(() => {
      setValueAtIndex(index, value);
    }, [index, setValueAtIndex, value]);
    function handleSelect() {
      setSelectedIndex(index);
      onChange(value);
      setOpen(false);
    }
    const selectItemProps = context.interactions ? context.interactions.getItemProps({
      onTouchStart() {
        allowSelectRef.current = true;
        allowMouseUpRef.current = false;
      },
      onKeyDown(event) {
        if (event.key === "Enter" || event.key === " " && !(dataRef == null ? void 0 : dataRef.current.typing)) {
          event.preventDefault();
          handleSelect();
        } else {
          allowSelectRef.current = true;
        }
      },
      onClick() {
        if (allowSelectRef.current) {
          setSelectedIndex(index);
          setOpen(false);
        }
      },
      onMouseUp() {
        if (!allowMouseUpRef.current) {
          return;
        }
        if (allowSelectRef.current) {
          handleSelect();
        }
        clearTimeout(selectTimeoutRef.current);
        selectTimeoutRef.current = setTimeout(() => {
          allowSelectRef.current = true;
        });
      }
    }) : {
      onPress: handleSelect
    };
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
      SelectItemContextProvider,
      {
        scope: __scopeSelect,
        value,
        textId: textId || "",
        isSelected,
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
          import_list_item.ListItem,
          {
            tag: "div",
            backgrounded: true,
            pressTheme: true,
            hoverTheme: true,
            cursor: "default",
            outlineWidth: 0,
            componentName: ITEM_NAME,
            ref: composedRefs,
            "aria-labelledby": textId,
            "aria-selected": isSelected,
            "data-state": isSelected ? "active" : "inactive",
            "aria-disabled": disabled || void 0,
            "data-disabled": disabled ? "" : void 0,
            tabIndex: disabled ? void 0 : -1,
            size: context.size,
            focusStyle: {
              backgroundColor: "$backgroundHover"
            },
            ...itemProps,
            ...selectItemProps
          }
        )
      }
    );
  }
);
SelectItem.displayName = ITEM_NAME;
const ITEM_TEXT_NAME = "SelectItemText";
const SelectItemTextFrame = (0, import_core.styled)(import_text.SizableText, {
  name: ITEM_TEXT_NAME,
  userSelect: "none"
});
const SelectItemText = React.forwardRef(
  (props, forwardedRef) => {
    const { __scopeSelect, className, ...itemTextProps } = props;
    const context = (0, import_context.useSelectContext)(ITEM_TEXT_NAME, __scopeSelect);
    const itemContext = useSelectItemContext(ITEM_TEXT_NAME, __scopeSelect);
    const ref = React.useRef(null);
    const composedRefs = (0, import_compose_refs.useComposedRefs)(forwardedRef, ref);
    const isSelected = Boolean(itemContext.isSelected && context.valueNode);
    const contents = React.useMemo(
      () => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
        SelectItemTextFrame,
        {
          className,
          size: context.size,
          id: itemContext.textId,
          ...itemTextProps,
          ref: composedRefs
        }
      ),
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [props, context.size, className, itemContext.textId]
    );
    (0, import_core.useIsomorphicLayoutEffect)(() => {
      if (isSelected) {
        context.setSelectedItem(contents);
      }
    }, [isSelected, contents]);
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, { children: contents });
  }
);
SelectItemText.displayName = ITEM_TEXT_NAME;
const ITEM_INDICATOR_NAME = "SelectItemIndicator";
const SelectItemIndicatorFrame = (0, import_core.styled)(import_stacks.XStack, {
  name: ITEM_TEXT_NAME
});
const SelectItemIndicator = React.forwardRef(
  (props, forwardedRef) => {
    const { __scopeSelect, ...itemIndicatorProps } = props;
    const itemContext = useSelectItemContext(ITEM_INDICATOR_NAME, __scopeSelect);
    return itemContext.isSelected ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(SelectItemIndicatorFrame, { "aria-hidden": true, ...itemIndicatorProps, ref: forwardedRef }) : null;
  }
);
SelectItemIndicator.displayName = ITEM_INDICATOR_NAME;
const GROUP_NAME = "SelectGroup";
const [SelectGroupContextProvider, useSelectGroupContext] = (0, import_context.createSelectContext)(GROUP_NAME);
const SelectGroupFrame = (0, import_core.styled)(import_stacks.YStack, {
  name: GROUP_NAME,
  width: "100%"
});
const SelectGroup = React.forwardRef(
  (props, forwardedRef) => {
    const { __scopeSelect, ...groupProps } = props;
    const groupId = (0, import_core.useId)();
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(SelectGroupContextProvider, { scope: __scopeSelect, id: groupId || "", children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
      SelectGroupFrame,
      {
        role: "group",
        "aria-labelledby": groupId,
        ...groupProps,
        ref: forwardedRef
      }
    ) });
  }
);
SelectGroup.displayName = GROUP_NAME;
const LABEL_NAME = "SelectLabel";
const SelectLabel = React.forwardRef(
  (props, forwardedRef) => {
    const { __scopeSelect, ...labelProps } = props;
    const context = (0, import_context.useSelectContext)(LABEL_NAME, __scopeSelect);
    const groupContext = useSelectGroupContext(LABEL_NAME, __scopeSelect);
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
      import_list_item.ListItem,
      {
        tag: "div",
        componentName: LABEL_NAME,
        fontWeight: "800",
        id: groupContext.id,
        size: context.size,
        ...labelProps,
        ref: forwardedRef
      }
    );
  }
);
SelectLabel.displayName = LABEL_NAME;
const SelectSeparator = (0, import_core.styled)(import_separator.Separator, {
  name: "SelectSeparator"
});
const SelectSheetController = (props) => {
  const context = (0, import_context.useSelectContext)("SelectSheetController", props.__scopeSelect);
  const showSheet = (0, import_useSelectBreakpointActive.useShowSelectSheet)(context);
  const breakpointActive = (0, import_useSelectBreakpointActive.useSelectBreakpointActive)(context.sheetBreakpoint);
  const getShowSheet = (0, import_core.useGet)(showSheet);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
    import_sheet.SheetController,
    {
      onOpenChange: (val) => {
        if (getShowSheet()) {
          props.onOpenChange(val);
        }
      },
      open: context.open,
      hidden: breakpointActive === false,
      children: props.children
    }
  );
};
const SelectSheetImpl = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, { children: props.children });
};
const Select = (0, import_core.withStaticProperties)(
  (props) => {
    const {
      __scopeSelect,
      children,
      open: openProp,
      defaultOpen,
      onOpenChange,
      value: valueProp,
      defaultValue,
      onValueChange,
      size: sizeProp = "$true",
      dir
    } = props;
    const id = (0, import_core.useId)();
    const scopeKey = __scopeSelect ? Object.keys(__scopeSelect)[0] ?? id : id;
    const { when, AdaptProvider } = (0, import_adapt.useAdaptParent)({
      Contents: React.useCallback(
        () => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_portal.PortalHost, { name: `${scopeKey}SheetContents` }),
        [scopeKey]
      )
    });
    const sheetBreakpoint = when;
    const isSheet = (0, import_useSelectBreakpointActive.useSelectBreakpointActive)(sheetBreakpoint);
    const SelectImpl = isSheet || !import_core.isWeb ? SelectSheetImpl : import_SelectImpl.SelectInlineImpl;
    const forceUpdate = React.useReducer(() => ({}), {})[1];
    const [selectedItem, setSelectedItem] = React.useState(null);
    const [open, setOpen] = (0, import_use_controllable_state.useControllableState)({
      prop: openProp,
      defaultProp: defaultOpen || false,
      onChange: onOpenChange
    });
    const [value, setValue] = (0, import_use_controllable_state.useControllableState)({
      prop: valueProp,
      defaultProp: defaultValue || "",
      onChange: onValueChange,
      transition: true
    });
    const [activeIndex, setActiveIndex] = React.useState(0);
    const selectedIndexRef = React.useRef(null);
    const activeIndexRef = React.useRef(null);
    const listContentRef = React.useRef([]);
    const [selectedIndex, setSelectedIndex] = React.useState(0);
    const [valueNode, setValueNode] = React.useState(null);
    const [valueNodeHasChildren, setValueNodeHasChildren] = React.useState(false);
    (0, import_core.useIsomorphicLayoutEffect)(() => {
      selectedIndexRef.current = selectedIndex;
      activeIndexRef.current = activeIndex;
    });
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AdaptProvider, { children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
      import_context.SelectProvider,
      {
        dir,
        blockSelection: false,
        size: sizeProp,
        fallback: false,
        selectedItem,
        setSelectedItem,
        forceUpdate,
        valueNode,
        onValueNodeChange: setValueNode,
        onValueNodeHasChildrenChange: setValueNodeHasChildren,
        valueNodeHasChildren,
        scopeKey,
        sheetBreakpoint,
        scope: __scopeSelect,
        setValueAtIndex: (index, value2) => {
          listContentRef.current[index] = value2;
        },
        activeIndex,
        onChange: setValue,
        selectedIndex,
        setActiveIndex,
        setOpen,
        setSelectedIndex,
        value,
        open,
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(SelectSheetController, { onOpenChange: setOpen, __scopeSelect, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
          SelectImpl,
          {
            activeIndexRef,
            listContentRef,
            selectedIndexRef,
            ...props,
            open,
            value,
            children
          }
        ) })
      }
    ) });
  },
  {
    Adapt: import_adapt.Adapt,
    Content: import_SelectContent.SelectContent,
    Group: SelectGroup,
    Icon: SelectIcon,
    Item: SelectItem,
    ItemIndicator: SelectItemIndicator,
    ItemText: SelectItemText,
    Label: SelectLabel,
    ScrollDownButton: import_SelectScrollButton.SelectScrollDownButton,
    ScrollUpButton: import_SelectScrollButton.SelectScrollUpButton,
    Trigger: SelectTrigger,
    Value: SelectValue,
    Viewport: import_SelectViewport.SelectViewport,
    Sheet: import_sheet.ControlledSheet
  }
);
Select.displayName = import_constants.SELECT_NAME;
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=Select.js.map


/***/ }),

/***/ 69950:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var SelectContent_exports = {};
__export(SelectContent_exports, {
  SelectContent: () => SelectContent
});
module.exports = __toCommonJS(SelectContent_exports);
var import_jsx_runtime = __webpack_require__(52322);
var import_react = __webpack_require__(67777);
var import_core = __webpack_require__(44996);
var import_dismissable = __webpack_require__(51818);
var import_focus_scope = __webpack_require__(50807);
var import_context = __webpack_require__(81629);
var import_useSelectBreakpointActive = __webpack_require__(71031);
const CONTENT_NAME = "SelectContent";
const SelectContent = ({
  children,
  __scopeSelect,
  zIndex = 1e3,
  ...focusScopeProps
}) => {
  const context = (0, import_context.useSelectContext)(CONTENT_NAME, __scopeSelect);
  const themeName = (0, import_core.useThemeName)();
  const showSheet = (0, import_useSelectBreakpointActive.useShowSelectSheet)(context);
  const contents = /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_core.Theme, { forceClassName: true, name: themeName, children });
  const touch = (0, import_core.useIsTouchDevice)();
  if (showSheet) {
    if (!context.open) {
      return null;
    }
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, { children: contents });
  }
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react.FloatingPortal, { children: context.open ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react.FloatingOverlay, { style: { zIndex }, lockScroll: !touch, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_focus_scope.FocusScope, { loop: true, trapped: true, ...focusScopeProps, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_dismissable.Dismissable, { children: contents }) }) }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", { style: { display: "none" }, children: contents }) });
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=SelectContent.js.map


/***/ }),

/***/ 1363:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var SelectImpl_exports = {};
__export(SelectImpl_exports, {
  SelectInlineImpl: () => SelectInlineImpl
});
module.exports = __toCommonJS(SelectImpl_exports);
var import_jsx_runtime = __webpack_require__(52322);
var import_react = __webpack_require__(67777);
var import_core = __webpack_require__(44996);
var React = __toESM(__webpack_require__(2784));
var import_react_dom = __webpack_require__(28316);
var import_constants = __webpack_require__(30529);
var import_context = __webpack_require__(81629);
const SelectInlineImpl = (props) => {
  const {
    __scopeSelect,
    children,
    open = false,
    selectedIndexRef,
    listContentRef
  } = props;
  const selectContext = (0, import_context.useSelectContext)("SelectSheetImpl", __scopeSelect);
  const {
    setActiveIndex,
    setOpen,
    setSelectedIndex,
    selectedIndex,
    activeIndex,
    forceUpdate
  } = selectContext;
  const [scrollTop, setScrollTop] = React.useState(0);
  const touch = (0, import_core.useIsTouchDevice)();
  const listItemsRef = React.useRef([]);
  const overflowRef = React.useRef(null);
  const upArrowRef = React.useRef(null);
  const downArrowRef = React.useRef(null);
  const allowSelectRef = React.useRef(false);
  const allowMouseUpRef = React.useRef(true);
  const selectTimeoutRef = React.useRef();
  const state = React.useRef({
    isMouseOutside: false
  });
  const [controlledScrolling, setControlledScrolling] = React.useState(false);
  const [fallback, setFallback] = React.useState(false);
  const [innerOffset, setInnerOffset] = React.useState(0);
  const [blockSelection, setBlockSelection] = React.useState(false);
  const floatingStyle = React.useRef({});
  React.useEffect(() => {
    const frame = requestAnimationFrame(() => {
      if (!open) {
        setScrollTop(0);
        setFallback(false);
        setActiveIndex(null);
        setControlledScrolling(false);
      }
    });
    return () => {
      cancelAnimationFrame(frame);
    };
  }, [open, setActiveIndex]);
  if (import_core.isWeb && import_core.isClient) {
    React.useEffect(() => {
      if (!open)
        return;
      const mouseUp = (e) => {
        if (state.current.isMouseOutside) {
          setOpen(false);
        }
      };
      document.addEventListener("mouseup", mouseUp);
      return () => {
        document.removeEventListener("mouseup", mouseUp);
      };
    }, [open]);
  }
  const updateFloatingSize = (0, import_react.size)({
    apply({
      availableHeight,
      rects: {
        reference: { width }
      }
    }) {
      floatingStyle.current = {
        width,
        maxHeight: availableHeight
      };
    },
    padding: import_constants.WINDOW_PADDING
  });
  const { x, y, reference, floating, strategy, context, refs } = (0, import_react.useFloating)({
    open,
    onOpenChange: setOpen,
    whileElementsMounted: import_react.autoUpdate,
    placement: "bottom-start",
    middleware: fallback ? [
      (0, import_react.offset)(5),
      ...[
        touch ? (0, import_react.shift)({ crossAxis: true, padding: import_constants.WINDOW_PADDING }) : (0, import_react.flip)({ padding: import_constants.WINDOW_PADDING })
      ],
      updateFloatingSize
    ] : [
      (0, import_react.inner)({
        listRef: listItemsRef,
        overflowRef,
        index: selectedIndex,
        offset: innerOffset,
        onFallbackChange: setFallback,
        padding: 10,
        minItemsVisible: touch ? 10 : 4,
        referenceOverflowThreshold: 20
      }),
      updateFloatingSize
    ]
  });
  const floatingRef = refs.floating;
  const showUpArrow = open && scrollTop > import_constants.SCROLL_ARROW_THRESHOLD;
  const showDownArrow = open && floatingRef.current && scrollTop < floatingRef.current.scrollHeight - floatingRef.current.clientHeight - import_constants.SCROLL_ARROW_THRESHOLD;
  const interactions = (0, import_react.useInteractions)([
    (0, import_react.useClick)(context, { event: "mousedown" }),
    (0, import_react.useDismiss)(context, { outsidePress: true }),
    (0, import_react.useRole)(context, { role: "listbox" }),
    (0, import_react.useInnerOffset)(context, {
      enabled: !fallback,
      onChange: setInnerOffset,
      overflowRef
    }),
    (0, import_react.useListNavigation)(context, {
      listRef: listItemsRef,
      activeIndex,
      selectedIndex,
      onNavigate: setActiveIndex
    }),
    (0, import_react.useTypeahead)(context, {
      listRef: listContentRef,
      onMatch: open ? setActiveIndex : setSelectedIndex,
      selectedIndex,
      activeIndex
    })
  ]);
  const interactionsContext = React.useMemo(() => {
    return {
      ...interactions,
      getReferenceProps() {
        return interactions.getReferenceProps({
          ref: reference,
          className: "SelectTrigger",
          onKeyDown(event) {
            if (event.key === "Enter" || event.key === " " && !context.dataRef.current.typing) {
              event.preventDefault();
              setOpen(true);
            }
          }
        });
      },
      getFloatingProps(props2) {
        return interactions.getFloatingProps({
          ref: floating,
          className: "Select",
          ...props2,
          style: {
            position: strategy,
            top: y ?? "",
            left: x ?? "",
            outline: 0,
            scrollbarWidth: "none",
            ...floatingStyle.current,
            ...props2 == null ? void 0 : props2.style
          },
          onPointerEnter() {
            setControlledScrolling(false);
            state.current.isMouseOutside = false;
          },
          onPointerLeave() {
            state.current.isMouseOutside = true;
          },
          onPointerMove() {
            state.current.isMouseOutside = false;
            setControlledScrolling(false);
          },
          onKeyDown() {
            setControlledScrolling(true);
          },
          onContextMenu(e) {
            e.preventDefault();
          },
          onScroll(event) {
            (0, import_react_dom.flushSync)(() => setScrollTop(event.currentTarget.scrollTop));
          }
        });
      }
    };
  }, [floating, y, x, interactions]);
  (0, import_core.useIsomorphicLayoutEffect)(() => {
    if (open) {
      selectTimeoutRef.current = setTimeout(() => {
        allowSelectRef.current = true;
      }, 300);
      return () => {
        clearTimeout(selectTimeoutRef.current);
      };
    } else {
      allowSelectRef.current = false;
      allowMouseUpRef.current = true;
      setInnerOffset(0);
      setFallback(false);
      setBlockSelection(false);
    }
  }, [open]);
  (0, import_core.useIsomorphicLayoutEffect)(() => {
    function onPointerDown(e) {
      var _a, _b, _c;
      const target = e.target;
      if (!(((_a = refs.floating.current) == null ? void 0 : _a.contains(target)) || ((_b = upArrowRef.current) == null ? void 0 : _b.contains(target)) || ((_c = downArrowRef.current) == null ? void 0 : _c.contains(target)))) {
        setOpen(false);
        setControlledScrolling(false);
      }
    }
    if (open) {
      document.addEventListener("pointerdown", onPointerDown);
      return () => {
        document.removeEventListener("pointerdown", onPointerDown);
      };
    }
  }, [open, refs, setOpen]);
  (0, import_core.useIsomorphicLayoutEffect)(() => {
    var _a, _b;
    if (open && controlledScrolling) {
      if (activeIndex != null) {
        (_a = listItemsRef.current[activeIndex]) == null ? void 0 : _a.scrollIntoView({ block: "nearest" });
      }
    }
    setScrollTop(((_b = refs.floating.current) == null ? void 0 : _b.scrollTop) ?? 0);
  }, [open, refs, controlledScrolling, activeIndex]);
  (0, import_core.useIsomorphicLayoutEffect)(() => {
    var _a;
    if (open && fallback) {
      if (selectedIndex != null) {
        (_a = listItemsRef.current[selectedIndex]) == null ? void 0 : _a.scrollIntoView({ block: "nearest" });
      }
    }
  }, [open, fallback, selectedIndex]);
  (0, import_core.useIsomorphicLayoutEffect)(() => {
    if (refs.floating.current && fallback) {
      refs.floating.current.style.maxHeight = "";
    }
  }, [refs, fallback]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
    import_context.SelectProvider,
    {
      scope: __scopeSelect,
      ...selectContext,
      setScrollTop,
      setInnerOffset,
      floatingRef,
      setValueAtIndex: (index, value) => {
        listContentRef.current[index] = value;
      },
      fallback,
      interactions: interactionsContext,
      floatingContext: context,
      activeIndex,
      canScrollDown: !!showDownArrow,
      canScrollUp: !!showUpArrow,
      controlledScrolling,
      dataRef: context.dataRef,
      listRef: listItemsRef,
      blockSelection,
      allowMouseUpRef,
      upArrowRef,
      downArrowRef,
      selectTimeoutRef,
      allowSelectRef,
      children
    }
  );
};
const userAgent = typeof navigator !== "undefined" && navigator.userAgent || "";
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=SelectImpl.js.map


/***/ }),

/***/ 38037:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var SelectScrollButton_exports = {};
__export(SelectScrollButton_exports, {
  SelectScrollDownButton: () => SelectScrollDownButton,
  SelectScrollUpButton: () => SelectScrollUpButton
});
module.exports = __toCommonJS(SelectScrollButton_exports);
var import_jsx_runtime = __webpack_require__(52322);
var import_react = __webpack_require__(67777);
var import_compose_refs = __webpack_require__(7199);
var import_core = __webpack_require__(44996);
var import_stacks = __webpack_require__(84432);
var React = __toESM(__webpack_require__(2784));
var import_react_dom = __webpack_require__(28316);
var import_context = __webpack_require__(81629);
const SCROLL_UP_BUTTON_NAME = "SelectScrollUpButton";
const SelectScrollUpButton = React.forwardRef((props, forwardedRef) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
    SelectScrollButtonImpl,
    {
      componentName: SCROLL_UP_BUTTON_NAME,
      ...props,
      dir: "up",
      ref: forwardedRef
    }
  );
});
SelectScrollUpButton.displayName = SCROLL_UP_BUTTON_NAME;
const SCROLL_DOWN_BUTTON_NAME = "SelectScrollDownButton";
const SelectScrollDownButton = React.forwardRef((props, forwardedRef) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
    SelectScrollButtonImpl,
    {
      componentName: SCROLL_DOWN_BUTTON_NAME,
      ...props,
      dir: "down",
      ref: forwardedRef
    }
  );
});
SelectScrollDownButton.displayName = SCROLL_DOWN_BUTTON_NAME;
const SelectScrollButtonImpl = React.memo(
  React.forwardRef(
    (props, forwardedRef) => {
      var _a;
      const { __scopeSelect, dir, componentName, ...scrollIndicatorProps } = props;
      const {
        floatingRef,
        forceUpdate,
        open,
        fallback,
        setScrollTop,
        setInnerOffset,
        ...context
      } = (0, import_context.useSelectContext)(componentName, __scopeSelect);
      const [element, setElement] = React.useState(null);
      const statusRef = React.useRef("idle");
      const isVisible = context[dir === "down" ? "canScrollDown" : "canScrollUp"];
      const frameRef = React.useRef();
      const { x, y, reference, floating, strategy, update, refs } = (0, import_react.useFloating)({
        open: open && isVisible,
        strategy: "fixed",
        placement: dir === "up" ? "top" : "bottom",
        middleware: [(0, import_react.offset)(({ rects }) => -rects.floating.height)],
        whileElementsMounted: (...args) => (0, import_react.autoUpdate)(...args, { animationFrame: true })
      });
      const composedRef = (0, import_compose_refs.useComposedRefs)(forwardedRef, floating);
      if (floatingRef) {
        if (open) {
          if (element !== floatingRef.current) {
            setElement(floatingRef.current);
            reference(floatingRef.current);
            requestAnimationFrame(update);
          }
        } else {
          cancelAnimationFrame(frameRef.current);
        }
      }
      (0, import_core.useIsomorphicLayoutEffect)(() => {
        return () => {
          cancelAnimationFrame(frameRef.current);
        };
      }, []);
      if (!(isVisible && floatingRef)) {
        return null;
      }
      const onScroll = (amount) => {
        console.log("on scroll?");
        if (fallback) {
          if (refs.floating.current) {
            refs.floating.current.scrollTop -= amount;
            (0, import_react_dom.flushSync)(() => {
              var _a2;
              return setScrollTop(((_a2 = refs.floating.current) == null ? void 0 : _a2.scrollTop) ?? 0);
            });
          }
        } else {
          (0, import_react_dom.flushSync)(() => setInnerOffset((value) => value - amount));
        }
      };
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
        import_stacks.YStack,
        {
          ref: composedRef,
          componentName,
          "aria-hidden": true,
          ...scrollIndicatorProps,
          zIndex: 1e3,
          position: strategy,
          left: x || 0,
          top: y || 0,
          width: `calc(${(((_a = floatingRef == null ? void 0 : floatingRef.current) == null ? void 0 : _a.offsetWidth) ?? 0) - 2}px)`,
          onPointerEnter: () => {
            statusRef.current = "active";
            let prevNow = Date.now();
            function frame() {
              if (element) {
                const currentNow = Date.now();
                const msElapsed = currentNow - prevNow;
                prevNow = currentNow;
                const pixelsToScroll = msElapsed / 2;
                const remainingPixels = dir === "up" ? element.scrollTop : element.scrollHeight - element.clientHeight - element.scrollTop;
                const scrollRemaining = dir === "up" ? element.scrollTop - pixelsToScroll > 0 : element.scrollTop + pixelsToScroll < element.scrollHeight - element.clientHeight;
                onScroll(
                  dir === "up" ? Math.min(pixelsToScroll, remainingPixels) : Math.max(-pixelsToScroll, -remainingPixels)
                );
                if (scrollRemaining) {
                  frameRef.current = requestAnimationFrame(frame);
                }
              }
            }
            cancelAnimationFrame(frameRef.current);
            frameRef.current = requestAnimationFrame(frame);
          },
          onPointerLeave: () => {
            statusRef.current = "idle";
            cancelAnimationFrame(frameRef.current);
          }
        }
      );
    }
  )
);
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=SelectScrollButton.js.map


/***/ }),

/***/ 81743:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var SelectViewport_exports = {};
__export(SelectViewport_exports, {
  SelectViewport: () => SelectViewport,
  SelectViewportFrame: () => SelectViewportFrame
});
module.exports = __toCommonJS(SelectViewport_exports);
var import_jsx_runtime = __webpack_require__(52322);
var import_react = __webpack_require__(67777);
var import_core = __webpack_require__(44996);
var import_core2 = __webpack_require__(44996);
var import_portal = __webpack_require__(69564);
var import_stacks = __webpack_require__(84432);
var React = __toESM(__webpack_require__(2784));
var import_constants = __webpack_require__(30529);
var import_context = __webpack_require__(81629);
var import_useSelectBreakpointActive = __webpack_require__(71031);
const SelectViewportFrame = (0, import_core2.styled)(import_stacks.ThemeableStack, {
  name: import_constants.VIEWPORT_NAME,
  backgroundColor: "$background",
  elevate: true,
  bordered: true,
  userSelect: "none",
  outlineWidth: 0,
  variants: {
    size: {
      "...size": (val, { tokens }) => {
        return {
          borderRadius: tokens.radius[val] ?? val
        };
      }
    }
  },
  defaultVariants: {
    size: "$2"
  }
});
const SelectViewport = React.forwardRef(
  (props, forwardedRef) => {
    const { __scopeSelect, children, disableScroll, ...viewportProps } = props;
    const context = (0, import_context.useSelectContext)(import_constants.VIEWPORT_NAME, __scopeSelect);
    const breakpointActive = (0, import_useSelectBreakpointActive.useSelectBreakpointActive)(context.sheetBreakpoint);
    if (breakpointActive || !import_core.isWeb) {
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_portal.PortalItem, { hostName: `${context.scopeKey}SheetContents`, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_context.ForwardSelectContext, { context, children }) });
    }
    if (!context.floatingContext) {
      return null;
    }
    if (!context.open) {
      return children;
    }
    const {
      style: { scrollbarWidth, listStyleType, overflow, ...restStyle },
      ...floatingProps
    } = context.interactions.getFloatingProps();
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, { children: [
      !disableScroll && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: selectViewportCSS
          }
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react.FloatingFocusManager, { context: context.floatingContext, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
        SelectViewportFrame,
        {
          size: context.size,
          role: "presentation",
          ...viewportProps,
          ref: forwardedRef,
          ...floatingProps,
          ...restStyle,
          overflow: disableScroll ? void 0 : overflow ?? "scroll",
          children
        }
      ) })
    ] });
  }
);
SelectViewport.displayName = import_constants.VIEWPORT_NAME;
const selectViewportCSS = `
.is_SelectViewport {
  scrollbar-width: none;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
}

.is_SelectViewport::-webkit-scrollbar{
  display:none
}
`;
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=SelectViewport.js.map


/***/ }),

/***/ 30529:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var constants_exports = {};
__export(constants_exports, {
  FALLBACK_THRESHOLD: () => FALLBACK_THRESHOLD,
  MIN_HEIGHT: () => MIN_HEIGHT,
  SCROLL_ARROW_THRESHOLD: () => SCROLL_ARROW_THRESHOLD,
  SCROLL_ARROW_VELOCITY: () => SCROLL_ARROW_VELOCITY,
  SELECT_NAME: () => SELECT_NAME,
  VIEWPORT_NAME: () => VIEWPORT_NAME,
  WINDOW_PADDING: () => WINDOW_PADDING
});
module.exports = __toCommonJS(constants_exports);
const SELECT_NAME = "Select";
const WINDOW_PADDING = 8;
const SCROLL_ARROW_VELOCITY = 8;
const SCROLL_ARROW_THRESHOLD = 8;
const MIN_HEIGHT = 80;
const FALLBACK_THRESHOLD = 16;
const VIEWPORT_NAME = "SelectViewport";
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=constants.js.map


/***/ }),

/***/ 81629:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var context_exports = {};
__export(context_exports, {
  ForwardSelectContext: () => ForwardSelectContext,
  SelectProvider: () => SelectProvider,
  createSelectContext: () => createSelectContext,
  createSelectScope: () => createSelectScope,
  useSelectContext: () => useSelectContext
});
module.exports = __toCommonJS(context_exports);
var import_jsx_runtime = __webpack_require__(52322);
var import_create_context = __webpack_require__(71913);
var import_constants = __webpack_require__(30529);
const [createSelectContext, createSelectScope] = (0, import_create_context.createContextScope)(import_constants.SELECT_NAME);
const [SelectProvider, useSelectContext] = createSelectContext(import_constants.SELECT_NAME);
const ForwardSelectContext = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(SelectProvider, { isInSheet: true, scope: props.__scopeSelect, ...props.context, children: props.children });
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=context.js.map


/***/ }),

/***/ 86515:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var src_exports = {};
module.exports = __toCommonJS(src_exports);
__reExport(src_exports, __webpack_require__(63312), module.exports);
__reExport(src_exports, __webpack_require__(81629), module.exports);
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 71031:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var useSelectBreakpointActive_exports = {};
__export(useSelectBreakpointActive_exports, {
  useSelectBreakpointActive: () => useSelectBreakpointActive,
  useShowSelectSheet: () => useShowSelectSheet
});
module.exports = __toCommonJS(useSelectBreakpointActive_exports);
var import_core = __webpack_require__(44996);
const useSelectBreakpointActive = (sheetBreakpoint) => {
  const media = (0, import_core.useMedia)();
  if (!sheetBreakpoint)
    return false;
  if (sheetBreakpoint === true)
    return true;
  return sheetBreakpoint ? media[sheetBreakpoint] : false;
};
const useShowSelectSheet = (context) => {
  const breakpointActive = useSelectBreakpointActive(context.sheetBreakpoint);
  return context.open === false ? false : breakpointActive;
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=useSelectBreakpointActive.js.map


/***/ }),

/***/ 27515:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Separator_exports = {};
__export(Separator_exports, {
  Separator: () => Separator
});
module.exports = __toCommonJS(Separator_exports);
var import_core = __webpack_require__(44996);
const Separator = (0, import_core.styled)(import_core.Stack, {
  name: "Separator",
  borderColor: "$borderColor",
  flexShrink: 0,
  borderWidth: 0,
  flex: 1,
  height: 0,
  maxHeight: 0,
  borderBottomWidth: 1,
  y: -0.5,
  variants: {
    vertical: {
      true: {
        y: 0,
        x: -0.5,
        height: import_core.isWeb ? "initial" : "auto",
        // maxHeight auto WILL BE passed to style attribute, but for some reason not used?
        // almost seems like a react or browser bug, but for now `initial` works
        // also, it doesn't happen for `height`, but for consistency using the same values
        maxHeight: import_core.isWeb ? "initial" : "auto",
        width: 0,
        maxWidth: 0,
        borderBottomWidth: 0,
        borderRightWidth: 1
      }
    }
  }
});
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=Separator.js.map


/***/ }),

/***/ 55990:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var src_exports = {};
module.exports = __toCommonJS(src_exports);
__reExport(src_exports, __webpack_require__(27515), module.exports);
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 84011:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Circle_exports = {};
__export(Circle_exports, {
  Circle: () => Circle
});
module.exports = __toCommonJS(Circle_exports);
var import_web = __webpack_require__(44571);
var import_Square = __webpack_require__(60140);
const Circle = (0, import_web.styled)(import_Square.Square, {
  name: "Circle",
  circular: true
});
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=Circle.js.map


/***/ }),

/***/ 60140:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Square_exports = {};
__export(Square_exports, {
  Square: () => Square
});
module.exports = __toCommonJS(Square_exports);
var import_stacks = __webpack_require__(84432);
var import_web = __webpack_require__(44571);
var import_getShapeSize = __webpack_require__(19165);
const Square = (0, import_web.styled)(import_stacks.ThemeableStack, {
  name: "Square",
  alignItems: "center",
  justifyContent: "center",
  variants: {
    circular: {
      true: {
        borderRadius: 1e5
      }
    },
    size: {
      "...size": import_getShapeSize.getShapeSize
    }
  }
});
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=Square.js.map


/***/ }),

/***/ 19165:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var getShapeSize_exports = {};
__export(getShapeSize_exports, {
  getShapeSize: () => getShapeSize
});
module.exports = __toCommonJS(getShapeSize_exports);
const getShapeSize = (size, { tokens }) => {
  const width = tokens.size[size] ?? size;
  const height = tokens.size[size] ?? size;
  return {
    width,
    height,
    minWidth: width,
    maxWidth: width,
    maxHeight: height,
    minHeight: height
  };
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=getShapeSize.js.map


/***/ }),

/***/ 68534:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var src_exports = {};
module.exports = __toCommonJS(src_exports);
__reExport(src_exports, __webpack_require__(60140), module.exports);
__reExport(src_exports, __webpack_require__(84011), module.exports);
__reExport(src_exports, __webpack_require__(19165), module.exports);
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 19375:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Sheet_exports = {};
__export(Sheet_exports, {
  ControlledSheet: () => ControlledSheet,
  Sheet: () => Sheet,
  SheetController: () => SheetController,
  SheetFrame: () => SheetFrame,
  SheetFrameFrame: () => SheetFrameFrame,
  SheetHandle: () => SheetHandle,
  SheetHandleFrame: () => SheetHandleFrame,
  SheetOverlay: () => SheetOverlay,
  SheetOverlayFrame: () => SheetOverlayFrame,
  createSheetScope: () => import_SheetContext2.createSheetScope
});
module.exports = __toCommonJS(Sheet_exports);
var import_jsx_runtime = __webpack_require__(52322);
var import_adapt = __webpack_require__(8242);
var import_compose_refs = __webpack_require__(7199);
var import_core = __webpack_require__(44996);
var import_portal = __webpack_require__(69564);
var import_remove_scroll = __webpack_require__(85293);
var import_stacks = __webpack_require__(84432);
var import_use_constant = __webpack_require__(48600);
var import_use_controllable_state = __webpack_require__(12113);
var import_use_keyboard_visible = __webpack_require__(8897);
var import_react = __toESM(__webpack_require__(2784));
var import_react_native = __webpack_require__(22164);
var import_constants = __webpack_require__(47385);
var import_SheetContext = __webpack_require__(70102);
var import_SheetScrollView = __webpack_require__(7231);
var import_SheetContext2 = __webpack_require__(70102);
const SheetHandleFrame = (0, import_core.styled)(import_stacks.XStack, {
  name: import_constants.SHEET_HANDLE_NAME,
  height: 10,
  borderRadius: 100,
  backgroundColor: "$background",
  zIndex: 10,
  marginHorizontal: "35%",
  marginBottom: "$2",
  opacity: 0.5,
  hoverStyle: {
    opacity: 0.7
  },
  variants: {
    open: {
      true: {
        pointerEvents: "auto"
      },
      false: {
        opacity: 0,
        pointerEvents: "none"
      }
    }
  }
});
const SheetHandle = SheetHandleFrame.extractable(
  ({ __scopeSheet, ...props }) => {
    const context = (0, import_SheetContext.useSheetContext)(import_constants.SHEET_HANDLE_NAME, __scopeSheet);
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
      SheetHandleFrame,
      {
        onPress: () => {
          const max = context.snapPoints.length + (context.dismissOnSnapToBottom ? -1 : 0);
          const nextPos = (context.position + 1) % max;
          context.setPosition(nextPos);
        },
        open: context.open,
        ...props
      }
    );
  }
);
const SHEET_OVERLAY_NAME = "SheetOverlay";
const SheetOverlayFrame = (0, import_core.styled)(import_stacks.YStack, {
  name: SHEET_OVERLAY_NAME,
  backgroundColor: "$color10",
  fullscreen: true,
  opacity: 0.5,
  zIndex: 0,
  variants: {
    closed: {
      true: {
        opacity: 0,
        pointerEvents: "none"
      },
      false: {
        pointerEvents: "auto"
      }
    }
  }
});
const SheetOverlay = SheetOverlayFrame.extractable(
  ({ __scopeSheet, ...props }) => {
    const context = (0, import_SheetContext.useSheetContext)(SHEET_OVERLAY_NAME, __scopeSheet);
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
      SheetOverlayFrame,
      {
        closed: !context.open || context.hidden,
        ...props,
        onPress: (0, import_core.mergeEvent)(
          props.onPress,
          context.dismissOnOverlayPress ? () => {
            context.setOpen(false);
          } : void 0
        )
      }
    );
  }
);
const selectionStyleSheet = import_core.isClient ? document.createElement("style") : null;
if (selectionStyleSheet) {
  document.head.appendChild(selectionStyleSheet);
}
const SheetFrameFrame = (0, import_core.styled)(import_stacks.YStack, {
  name: import_constants.SHEET_NAME,
  flex: 1,
  backgroundColor: "$background",
  borderTopLeftRadius: "$true",
  borderTopRightRadius: "$true",
  width: "100%",
  maxHeight: "100%",
  overflow: "hidden",
  pointerEvents: "auto"
});
const SheetFrame = SheetFrameFrame.extractable(
  (0, import_react.forwardRef)(
    ({ __scopeSheet, ...props }, forwardedRef) => {
      const context = (0, import_SheetContext.useSheetContext)(import_constants.SHEET_NAME, __scopeSheet);
      const composedContentRef = (0, import_compose_refs.useComposedRefs)(forwardedRef, context.contentRef);
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(SheetFrameFrame, { ref: composedContentRef, ...props });
    }
  )
);
const HIDDEN_SIZE = 1e4;
const sheetComponents = {
  Handle: SheetHandle,
  Frame: SheetFrame,
  Overlay: SheetOverlay,
  ScrollView: import_SheetScrollView.SheetScrollView
};
const ParentSheetContext = (0, import_react.createContext)({
  zIndex: 40
});
const useSheetContoller = () => {
  const controller = (0, import_react.useContext)(SheetControllerContext);
  const isHidden = controller == null ? void 0 : controller.hidden;
  const isShowingNonSheet = isHidden && (controller == null ? void 0 : controller.open);
  return {
    controller,
    isHidden,
    isShowingNonSheet
  };
};
const Sheet = (0, import_core.withStaticProperties)(
  (0, import_react.forwardRef)(function Sheet2(props, ref) {
    const hydrated = (0, import_core.useDidFinishSSR)();
    const { isShowingNonSheet } = useSheetContoller();
    if (isShowingNonSheet || !hydrated) {
      return null;
    }
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(SheetImplementation, { ref, ...props });
  }),
  sheetComponents
);
const SheetImplementation = (0, import_core.themeable)(
  (0, import_react.forwardRef)(function SheetImplementation2(props, ref) {
    const parentSheet = (0, import_react.useContext)(ParentSheetContext);
    const { isHidden, controller } = useSheetContoller();
    const {
      __scopeSheet,
      snapPoints: snapPointsProp = [80],
      open: openProp,
      defaultOpen,
      children: childrenProp,
      position: positionProp,
      onPositionChange,
      onOpenChange,
      defaultPosition,
      dismissOnOverlayPress = true,
      animationConfig,
      dismissOnSnapToBottom = false,
      forceRemoveScrollEnabled = null,
      disableDrag: disableDragProp,
      modal = false,
      zIndex = parentSheet.zIndex + 1,
      portalProps
    } = props;
    if (false) {}
    const driver = (0, import_core.getAnimationDriver)();
    if (!driver) {
      throw new Error("Must set animations in tamagui.config.ts");
    }
    const disableDrag = disableDragProp ?? (controller == null ? void 0 : controller.disableDrag);
    const keyboardIsVisible = (0, import_use_keyboard_visible.useKeyboardVisible)();
    const themeName = (0, import_core.useThemeName)();
    const contentRef = import_react.default.useRef(null);
    const scrollBridge = (0, import_use_constant.useConstant)(() => ({
      enabled: false,
      y: 0,
      paneY: 0,
      paneMinY: 0,
      scrollStartY: -1,
      drag: () => {
      },
      release: () => {
      },
      scrollLock: false
    }));
    const onOpenChangeInternal = (val) => {
      var _a;
      (_a = controller == null ? void 0 : controller.onOpenChange) == null ? void 0 : _a.call(controller, val);
      onOpenChange == null ? void 0 : onOpenChange(val);
    };
    const [open, setOpen] = (0, import_use_controllable_state.useControllableState)({
      prop: (controller == null ? void 0 : controller.open) ?? openProp,
      defaultProp: true,
      onChange: onOpenChangeInternal,
      strategy: "most-recent-wins",
      transition: true
    });
    const [frameSize, setFrameSize] = (0, import_react.useState)(0);
    const snapPoints = (0, import_react.useMemo)(
      () => dismissOnSnapToBottom ? [...snapPointsProp, 0] : snapPointsProp,
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [JSON.stringify(snapPointsProp), dismissOnSnapToBottom]
    );
    const [position_, setPosition_] = (0, import_use_controllable_state.useControllableState)({
      prop: positionProp,
      defaultProp: defaultPosition || (open ? 0 : -1),
      onChange: onPositionChange,
      strategy: "most-recent-wins",
      transition: true
    });
    const position = open === false ? -1 : position_;
    if (open && dismissOnSnapToBottom && position === snapPoints.length - 1) {
      setPosition_(0);
    }
    const setPosition = (0, import_react.useCallback)(
      (next) => {
        if (dismissOnSnapToBottom && next === snapPoints.length - 1) {
          setOpen(false);
        } else {
          setPosition_(next);
        }
      },
      [dismissOnSnapToBottom, snapPoints.length, setPosition_, setOpen]
    );
    const { useAnimatedNumber, useAnimatedNumberReaction, useAnimatedNumberStyle } = driver;
    const animatedNumber = useAnimatedNumber(HIDDEN_SIZE);
    const at = (0, import_react.useRef)(0);
    useAnimatedNumberReaction(animatedNumber, (value) => {
      at.current = value;
      scrollBridge.paneY = value;
    });
    const [isResizing, setIsResizing] = (0, import_react.useState)(true);
    (0, import_core.useIsomorphicLayoutEffect)(() => {
      if (!isResizing) {
        setIsResizing(true);
      }
    }, [modal]);
    function stopSpring() {
      animatedNumber.stop();
      if (scrollBridge.onFinishAnimate) {
        scrollBridge.onFinishAnimate();
        scrollBridge.onFinishAnimate = void 0;
      }
    }
    const shouldSetPositionOpen = open && position < 0;
    (0, import_react.useEffect)(() => {
      if (shouldSetPositionOpen) {
        setPosition(0);
      }
    }, [setPosition, shouldSetPositionOpen]);
    const positions = (0, import_react.useMemo)(
      () => snapPoints.map((point) => getPercentSize(point, frameSize)),
      [frameSize, snapPoints]
    );
    const [opacity, setOpacity] = (0, import_react.useState)(open ? 1 : 0);
    if (open && opacity === 0) {
      setOpacity(1);
    }
    (0, import_react.useEffect)(() => {
      if (!open) {
        const tm = setTimeout(() => {
          setOpacity(0);
        }, 400);
        return () => {
          clearTimeout(tm);
        };
      }
    }, [open]);
    const animateTo = (0, import_core.useEvent)((position2) => {
      const current = animatedNumber.getValue();
      if (isHidden && open)
        return;
      if (!current)
        return;
      if (frameSize === 0)
        return;
      const hiddenValue = frameSize === 0 ? HIDDEN_SIZE : frameSize;
      const toValue = isHidden || position2 === -1 ? hiddenValue : positions[position2];
      if (at.current === toValue)
        return;
      stopSpring();
      if (isHidden || isResizing) {
        if (isResizing) {
          setIsResizing(false);
        }
        animatedNumber.setValue(toValue, {
          type: "timing",
          duration: 0
        });
        at.current = toValue;
        return;
      }
      const overshootClamping = at.current === HIDDEN_SIZE;
      animatedNumber.setValue(toValue, {
        ...animationConfig,
        type: "spring",
        overshootClamping
      });
    });
    (0, import_core.useIsomorphicLayoutEffect)(() => {
      animateTo(position);
    }, [isHidden, frameSize, position, animateTo]);
    const [isShowingInnerSheet, setIsShowingInnerSheet] = (0, import_react.useState)(false);
    const shouldHideParentSheet = !import_core.isWeb && modal && isShowingInnerSheet;
    const parentSheetContext = (0, import_react.useContext)(SheetInsideSheetContext);
    const onInnerSheet = (0, import_react.useCallback)((hasChild) => {
      setIsShowingInnerSheet(hasChild);
    }, []);
    const panResponder = (0, import_react.useMemo)(
      () => {
        if (disableDrag)
          return;
        if (!frameSize)
          return;
        if (isShowingInnerSheet)
          return;
        const minY = positions[0];
        scrollBridge.paneMinY = minY;
        let startY = at.current;
        function makeUnselectable(val) {
          if (!selectionStyleSheet)
            return;
          if (!val) {
            selectionStyleSheet.innerText = "";
          } else {
            selectionStyleSheet.innerText = ":root * { user-select: none !important; -webkit-user-select: none !important; }";
          }
        }
        const release = ({ vy, dragAt }) => {
          isExternalDrag = false;
          previouslyScrolling = false;
          makeUnselectable(false);
          const at2 = dragAt + startY;
          const end = at2 + frameSize * vy * 0.2;
          let closestPoint = 0;
          let dist = Infinity;
          for (let i = 0; i < positions.length; i++) {
            const position2 = positions[i];
            const curDist = end > position2 ? end - position2 : position2 - end;
            if (curDist < dist) {
              dist = curDist;
              closestPoint = i;
            }
          }
          setPosition(closestPoint);
          animateTo(closestPoint);
        };
        const finish = (_e, state) => {
          release({
            vy: state.vy,
            dragAt: state.dy
          });
        };
        let previouslyScrolling = false;
        const onMoveShouldSet = (_e, { dy }) => {
          const isScrolled = scrollBridge.y !== 0;
          const isDraggingUp = dy < 0;
          const isNearTop = scrollBridge.paneY - 5 <= scrollBridge.paneMinY;
          if (isScrolled) {
            previouslyScrolling = true;
            return false;
          }
          if (isNearTop) {
            if (!isScrolled && isDraggingUp) {
              return false;
            }
          }
          return Math.abs(dy) > 5;
        };
        const grant = () => {
          makeUnselectable(true);
          stopSpring();
          startY = at.current;
        };
        let isExternalDrag = false;
        scrollBridge.drag = (dy) => {
          if (!isExternalDrag) {
            isExternalDrag = true;
            grant();
          }
          const to = dy + startY;
          animatedNumber.setValue(resisted(to, minY), { type: "direct" });
        };
        scrollBridge.release = release;
        return import_react_native.PanResponder.create({
          onMoveShouldSetPanResponder: onMoveShouldSet,
          onPanResponderGrant: grant,
          onPanResponderMove: (_e, { dy }) => {
            const toFull = dy + startY;
            const to = resisted(toFull, minY);
            animatedNumber.setValue(to, { type: "direct" });
          },
          onPanResponderEnd: finish,
          onPanResponderTerminate: finish,
          onPanResponderRelease: finish
        });
      },
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [disableDrag, isShowingInnerSheet, animateTo, frameSize, positions, setPosition]
    );
    let handleComponent = null;
    let overlayComponent = null;
    let frameComponent = null;
    import_react.default.Children.forEach(childrenProp, (child) => {
      var _a, _b;
      if ((0, import_react.isValidElement)(child)) {
        const name = (_b = (_a = child.type) == null ? void 0 : _a["staticConfig"]) == null ? void 0 : _b.componentName;
        switch (name) {
          case "SheetHandle":
            handleComponent = child;
            break;
          case "Sheet":
            frameComponent = child;
            break;
          case "SheetOverlay":
            overlayComponent = child;
            break;
          default:
            console.warn("Warning: passed invalid child to Sheet", child);
        }
      }
    });
    const animatedStyle = useAnimatedNumberStyle(animatedNumber, (val) => {
      const translateY = frameSize === 0 ? HIDDEN_SIZE : val;
      return {
        transform: [{ translateY }]
      };
    });
    const AnimatedView = driver["NumberView"] ?? driver.View;
    (0, import_core.useIsomorphicLayoutEffect)(() => {
      if (!(parentSheetContext && open))
        return;
      parentSheetContext(true);
      return () => {
        parentSheetContext(false);
      };
    }, [parentSheetContext, open]);
    const nextParentContext = (0, import_react.useMemo)(
      () => ({
        zIndex
      }),
      [zIndex]
    );
    const handleLayout = (0, import_react.useCallback)((e) => {
      var _a;
      let next = (_a = e.nativeEvent) == null ? void 0 : _a.layout.height;
      if (import_core.isWeb && import_core.isTouchable && !open) {
        next += 100;
      }
      if (!next)
        return;
      setFrameSize((prev) => {
        const isBigChange = Math.abs(prev - next) > 20;
        if (!keyboardIsVisible) {
          setIsResizing(isBigChange);
        }
        return next;
      });
    }, [keyboardIsVisible]);
    const removeScrollEnabled = forceRemoveScrollEnabled ?? (open && modal);
    const contents = /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ParentSheetContext.Provider, { value: nextParentContext, children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(
      import_SheetContext.SheetProvider,
      {
        modal,
        contentRef,
        frameSize,
        dismissOnOverlayPress,
        dismissOnSnapToBottom,
        open,
        hidden: !!isHidden,
        scope: __scopeSheet,
        position,
        snapPoints,
        setPosition,
        setOpen,
        scrollBridge,
        children: [
          isResizing || shouldHideParentSheet ? null : overlayComponent,
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(
            AnimatedView,
            {
              ref,
              ...panResponder == null ? void 0 : panResponder.panHandlers,
              onLayout: handleLayout,
              pointerEvents: open && !shouldHideParentSheet ? "auto" : "none",
              style: [
                {
                  position: "absolute",
                  zIndex,
                  width: "100%",
                  height: "100%",
                  opacity
                },
                animatedStyle
              ],
              children: [
                handleComponent,
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
                  import_remove_scroll.RemoveScroll,
                  {
                    forwardProps: true,
                    enabled: removeScrollEnabled,
                    allowPinchZoom: true,
                    shards: [contentRef],
                    removeScrollBar: false,
                    children: isResizing ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, {}) : frameComponent
                  }
                )
              ]
            }
          )
        ]
      }
    ) });
    const adaptContext = (0, import_react.useContext)(import_adapt.AdaptParentContext);
    if (modal) {
      const modalContents = /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_portal.Portal, { zIndex, ...portalProps, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_core.Theme, { forceClassName: true, name: themeName, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_adapt.AdaptParentContext.Provider, { value: adaptContext, children: contents }) }) });
      if (import_core.isWeb) {
        return modalContents;
      }
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(SheetInsideSheetContext.Provider, { value: onInnerSheet, children: modalContents });
    }
    return contents;
  }),
  { componentName: "Sheet" }
);
const SheetInsideSheetContext = (0, import_react.createContext)(null);
const ControlledSheet = Sheet;
function getPercentSize(point, frameSize) {
  if (!frameSize)
    return 0;
  if (point === void 0) {
    console.warn("No snapPoint");
    return 0;
  }
  const pct = point / 100;
  const next = Math.round(frameSize - pct * frameSize);
  return next;
}
function resisted(y, minY, maxOverflow = 25) {
  if (y < minY) {
    const past = minY - y;
    const pctPast = Math.min(maxOverflow, past) / maxOverflow;
    const diminishBy = 1.1 - Math.pow(0.1, pctPast);
    const extra = -diminishBy * maxOverflow;
    return minY + extra;
  }
  return y;
}
const SheetControllerContext = (0, import_react.createContext)(null);
const SheetController = ({
  children,
  onOpenChange: onOpenChangeProp,
  ...value
}) => {
  const onOpenChange = (0, import_core.useEvent)(onOpenChangeProp);
  const memoValue = (0, import_react.useMemo)(
    () => ({
      open: value.open,
      hidden: value.hidden,
      disableDrag: value.disableDrag,
      onOpenChange
    }),
    [onOpenChange, value.open, value.hidden, value.disableDrag]
  );
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(SheetControllerContext.Provider, { value: memoValue, children });
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=Sheet.js.map


/***/ }),

/***/ 70102:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var SheetContext_exports = {};
__export(SheetContext_exports, {
  SheetProvider: () => SheetProvider,
  createSheetContext: () => createSheetContext,
  createSheetScope: () => createSheetScope,
  useSheetContext: () => useSheetContext
});
module.exports = __toCommonJS(SheetContext_exports);
var import_create_context = __webpack_require__(71913);
var import_constants = __webpack_require__(47385);
const [createSheetContext, createSheetScope] = (0, import_create_context.createContextScope)(import_constants.SHEET_NAME);
const [SheetProvider, useSheetContext] = createSheetContext(
  import_constants.SHEET_NAME,
  {}
);
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=SheetContext.js.map


/***/ }),

/***/ 7231:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var SheetScrollView_exports = {};
__export(SheetScrollView_exports, {
  SheetScrollView: () => SheetScrollView
});
module.exports = __toCommonJS(SheetScrollView_exports);
var import_jsx_runtime = __webpack_require__(52322);
var import_core = __webpack_require__(44996);
var import_scroll_view = __webpack_require__(81822);
var import_react = __webpack_require__(2784);
var import_SheetContext = __webpack_require__(70102);
const SHEET_SCROLL_VIEW_NAME = "SheetScrollView";
const SheetScrollView = (0, import_react.forwardRef)(
  ({ __scopeSheet, children, ...props }, ref) => {
    const { scrollBridge, position, snapPoints, frameSize, open } = (0, import_SheetContext.useSheetContext)(
      SHEET_SCROLL_VIEW_NAME,
      __scopeSheet
    );
    const scrollRef = (0, import_react.useRef)(null);
    const percentOpened = snapPoints[position] ?? 0;
    const [percentToPadBottom, setPercentToPadBottom] = (0, import_react.useState)(0);
    const next = 100 - percentOpened;
    if (open && next !== percentToPadBottom) {
      setPercentToPadBottom(next);
    }
    const state = (0, import_react.useRef)({
      lastPageY: 0,
      dragAt: 0,
      dys: [],
      // store a few recent dys to get velocity on release
      isScrolling: false,
      isDragging: false
    });
    const release = () => {
      if (!state.current.isDragging) {
        return;
      }
      state.current.isDragging = false;
      scrollBridge.scrollStartY = -1;
      state.current.isScrolling = false;
      let vy = 0;
      if (state.current.dys.length) {
        const recentDys = state.current.dys.slice(-10);
        const dist = recentDys.length ? recentDys.reduce((a, b) => a + b, 0) : 0;
        const avgDy = dist / recentDys.length;
        vy = avgDy * 0.04;
      }
      state.current.dys = [];
      scrollBridge.release({
        dragAt: state.current.dragAt,
        vy
      });
    };
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(
      import_scroll_view.ScrollView,
      {
        ref: (0, import_core.composeRefs)(scrollRef, ref),
        flex: 1,
        scrollEventThrottle: 8,
        onScroll: (e) => {
          const { y } = e.nativeEvent.contentOffset;
          scrollBridge.y = y;
          if (y > 0) {
            scrollBridge.scrollStartY = -1;
          }
        },
        onStartShouldSetResponder: () => {
          scrollBridge.scrollStartY = -1;
          state.current.isDragging = true;
          return true;
        },
        onMoveShouldSetResponder: () => false,
        onResponderRelease: release,
        className: "_ovs-contain",
        ...props,
        children: [
          (0, import_react.useMemo)(() => children, [children]),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_core.Stack, { height: percentToPadBottom / 100 * frameSize, width: 0 })
        ]
      }
    );
  }
);
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=SheetScrollView.js.map


/***/ }),

/***/ 47385:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var constants_exports = {};
__export(constants_exports, {
  SHEET_HANDLE_NAME: () => SHEET_HANDLE_NAME,
  SHEET_NAME: () => SHEET_NAME,
  constants: () => constants
});
module.exports = __toCommonJS(constants_exports);
const constants = {};
const SHEET_NAME = "Sheet";
const SHEET_HANDLE_NAME = "SheetHandle";
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=constants.js.map


/***/ }),

/***/ 24226:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var src_exports = {};
module.exports = __toCommonJS(src_exports);
__reExport(src_exports, __webpack_require__(19375), module.exports);
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 63595:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var src_exports = {};
__export(src_exports, {
  shorthands: () => shorthands
});
module.exports = __toCommonJS(src_exports);
const shorthands = {
  // web-only
  ussel: "userSelect",
  cur: "cursor",
  // tamagui
  pe: "pointerEvents",
  // text
  col: "color",
  ff: "fontFamily",
  fos: "fontSize",
  fost: "fontStyle",
  fow: "fontWeight",
  ls: "letterSpacing",
  lh: "lineHeight",
  ta: "textAlign",
  tt: "textTransform",
  ww: "wordWrap",
  // view
  ac: "alignContent",
  ai: "alignItems",
  als: "alignSelf",
  b: "bottom",
  bc: "backgroundColor",
  bg: "backgroundColor",
  bbc: "borderBottomColor",
  bblr: "borderBottomLeftRadius",
  bbrr: "borderBottomRightRadius",
  bbw: "borderBottomWidth",
  blc: "borderLeftColor",
  blw: "borderLeftWidth",
  boc: "borderColor",
  br: "borderRadius",
  bs: "borderStyle",
  brw: "borderRightWidth",
  brc: "borderRightColor",
  btc: "borderTopColor",
  btlr: "borderTopLeftRadius",
  btrr: "borderTopRightRadius",
  btw: "borderTopWidth",
  bw: "borderWidth",
  dsp: "display",
  f: "flex",
  fb: "flexBasis",
  fd: "flexDirection",
  fg: "flexGrow",
  fs: "flexShrink",
  fw: "flexWrap",
  h: "height",
  jc: "justifyContent",
  l: "left",
  m: "margin",
  mah: "maxHeight",
  maw: "maxWidth",
  mb: "marginBottom",
  mih: "minHeight",
  miw: "minWidth",
  ml: "marginLeft",
  mr: "marginRight",
  mt: "marginTop",
  mx: "marginHorizontal",
  my: "marginVertical",
  o: "opacity",
  ov: "overflow",
  p: "padding",
  pb: "paddingBottom",
  pl: "paddingLeft",
  pos: "position",
  pr: "paddingRight",
  pt: "paddingTop",
  px: "paddingHorizontal",
  py: "paddingVertical",
  r: "right",
  shac: "shadowColor",
  shar: "shadowRadius",
  shof: "shadowOffset",
  shop: "shadowOpacity",
  t: "top",
  w: "width",
  zi: "zIndex"
};
shorthands["bls"] = "borderLeftStyle";
shorthands["brs"] = "borderRightStyle";
shorthands["bts"] = "borderTopStyle";
shorthands["bbs"] = "borderBottomStyle";
shorthands["bxs"] = "boxSizing";
shorthands["bxsh"] = "boxShadow";
shorthands["ox"] = "overflowX";
shorthands["oy"] = "overflowY";
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 69949:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var src_exports = {};
__export(src_exports, {
  isValidCSSCharCode: () => isValidCSSCharCode,
  simpleHash: () => simpleHash
});
module.exports = __toCommonJS(src_exports);
const simpleHash = (str, hashMin = 10) => {
  let hash = 0;
  let valids = "";
  const len = str.length;
  for (let i = 0; i < len; i++) {
    const char = str.charCodeAt(i);
    if (char === 46) {
      valids += "d0t";
    }
    if (isValidCSSCharCode(char) && len <= hashMin) {
      valids += str[i];
    } else {
      hash = (hash << 5) - hash + char;
      hash &= hash;
    }
  }
  return valids + (hash ? new Uint32Array([hash])[0].toString(36) : "");
};
function isValidCSSCharCode(code) {
  return (
    // A-Z
    code >= 65 && code <= 90 || // a-z
    code >= 97 && code <= 122 || // _
    code === 95 || // -
    code === 45 || // 0-9
    code >= 48 && code <= 57
  );
}
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 38853:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Slider_exports = {};
__export(Slider_exports, {
  Range: () => Range,
  Slider: () => Slider,
  SliderThumb: () => SliderThumb,
  SliderThumbFrame: () => SliderThumbFrame,
  SliderTrack: () => SliderTrack,
  SliderTrackActive: () => SliderTrackActive,
  SliderTrackActiveFrame: () => SliderTrackActiveFrame,
  SliderTrackFrame: () => SliderTrackFrame,
  Thumb: () => Thumb,
  Track: () => Track
});
module.exports = __toCommonJS(Slider_exports);
var import_jsx_runtime = __webpack_require__(52322);
var import_compose_refs = __webpack_require__(7199);
var import_core = __webpack_require__(44996);
var import_get_size = __webpack_require__(20157);
var import_helpers = __webpack_require__(19047);
var import_stacks = __webpack_require__(84432);
var import_use_controllable_state = __webpack_require__(12113);
var import_use_direction = __webpack_require__(10498);
var React = __toESM(__webpack_require__(2784));
var import_constants = __webpack_require__(55466);
var import_helpers2 = __webpack_require__(98672);
var import_SliderImpl = __webpack_require__(35037);
const SliderHorizontal = React.forwardRef(
  (props, forwardedRef) => {
    const { min, max, dir, onSlideStart, onSlideMove, onStepKeyDown, ...sliderProps } = props;
    const direction = (0, import_use_direction.useDirection)(dir);
    const isDirectionLTR = direction === "ltr";
    const sliderRef = React.useRef(null);
    const [state, setState] = React.useState(() => ({ size: 0, offset: 0 }));
    function getValueFromPointer(pointerPosition) {
      const input = [0, state.size];
      const output = isDirectionLTR ? [min, max] : [max, min];
      const value = (0, import_helpers2.linearScale)(input, output);
      return value(pointerPosition);
    }
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
      import_constants.SliderOrientationProvider,
      {
        scope: props.__scopeSlider,
        startEdge: isDirectionLTR ? "left" : "right",
        endEdge: isDirectionLTR ? "right" : "left",
        direction: isDirectionLTR ? 1 : -1,
        sizeProp: "width",
        size: state.size,
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
          import_SliderImpl.SliderImpl,
          {
            ref: (0, import_compose_refs.composeRefs)(forwardedRef, sliderRef),
            dir: direction,
            ...sliderProps,
            orientation: "horizontal",
            onLayout: () => {
              var _a;
              (_a = sliderRef.current) == null ? void 0 : _a.measure((_x, _y, width, _height, pageX, _pageY) => {
                setState({
                  size: width,
                  offset: pageX
                });
              });
            },
            onSlideStart: (event, target) => {
              const value = getValueFromPointer(event.nativeEvent.locationX);
              if (value) {
                onSlideStart == null ? void 0 : onSlideStart(value, target);
              }
            },
            onSlideMove: (event) => {
              const value = getValueFromPointer(event.nativeEvent.pageX - state.offset);
              if (value) {
                onSlideMove == null ? void 0 : onSlideMove(value);
              }
            },
            onSlideEnd: () => {
            },
            onStepKeyDown: (event) => {
              const isBackKey = import_constants.BACK_KEYS[direction].includes(event.key);
              onStepKeyDown == null ? void 0 : onStepKeyDown({ event, direction: isBackKey ? -1 : 1 });
            }
          }
        )
      }
    );
  }
);
const SliderVertical = React.forwardRef(
  (props, forwardedRef) => {
    const { min, max, onSlideStart, onSlideMove, onStepKeyDown, ...sliderProps } = props;
    const [state, setState] = React.useState(() => ({ size: 0, offset: 0 }));
    const sliderRef = React.useRef(null);
    function getValueFromPointer(pointerPosition) {
      const input = [0, state.size];
      const output = [max, min];
      const value = (0, import_helpers2.linearScale)(input, output);
      return value(pointerPosition);
    }
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
      import_constants.SliderOrientationProvider,
      {
        scope: props.__scopeSlider,
        startEdge: "bottom",
        endEdge: "top",
        sizeProp: "height",
        size: state.size,
        direction: 1,
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
          import_SliderImpl.SliderImpl,
          {
            ref: (0, import_compose_refs.composeRefs)(forwardedRef, sliderRef),
            ...sliderProps,
            orientation: "vertical",
            onLayout: ({ nativeEvent: { layout } }) => {
              var _a;
              (_a = sliderRef.current) == null ? void 0 : _a.measure((_x, _y, _width, height, _pageX, pageY) => {
                setState({
                  size: height,
                  offset: pageY
                });
              });
            },
            onSlideStart: (event, target) => {
              const value = getValueFromPointer(event.nativeEvent.locationY);
              if (value) {
                onSlideStart == null ? void 0 : onSlideStart(value, target);
              }
            },
            onSlideMove: (event) => {
              const value = getValueFromPointer(event.nativeEvent.pageY - state.offset);
              if (value) {
                onSlideMove == null ? void 0 : onSlideMove(value);
              }
            },
            onSlideEnd: () => {
            },
            onStepKeyDown: (event) => {
              const isBackKey = import_constants.BACK_KEYS.ltr.includes(event.key);
              onStepKeyDown == null ? void 0 : onStepKeyDown({ event, direction: isBackKey ? -1 : 1 });
            }
          }
        )
      }
    );
  }
);
const TRACK_NAME = "SliderTrack";
const SliderTrackFrame = (0, import_core.styled)(import_SliderImpl.SliderFrame, {
  name: "SliderTrack",
  height: "100%",
  width: "100%",
  backgroundColor: "$background",
  position: "relative",
  borderRadius: 1e5,
  overflow: "hidden"
});
const SliderTrack = React.forwardRef(
  (props, forwardedRef) => {
    const { __scopeSlider, ...trackProps } = props;
    const context = (0, import_constants.useSliderContext)(TRACK_NAME, __scopeSlider);
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
      SliderTrackFrame,
      {
        "data-disabled": context.disabled ? "" : void 0,
        "data-orientation": context.orientation,
        orientation: context.orientation,
        size: context.size,
        ...trackProps,
        ref: forwardedRef
      }
    );
  }
);
SliderTrack.displayName = TRACK_NAME;
const RANGE_NAME = "SliderTrackActive";
const SliderTrackActiveFrame = (0, import_core.styled)(import_SliderImpl.SliderFrame, {
  name: "SliderTrackActive",
  backgroundColor: "$background",
  position: "absolute"
});
const SliderTrackActive = React.forwardRef(
  (props, forwardedRef) => {
    const { __scopeSlider, ...rangeProps } = props;
    const context = (0, import_constants.useSliderContext)(RANGE_NAME, __scopeSlider);
    const orientation = (0, import_constants.useSliderOrientationContext)(RANGE_NAME, __scopeSlider);
    const ref = React.useRef(null);
    const composedRefs = (0, import_compose_refs.useComposedRefs)(forwardedRef, ref);
    const valuesCount = context.values.length;
    const percentages = context.values.map(
      (value) => (0, import_helpers2.convertValueToPercentage)(value, context.min, context.max)
    );
    const offsetStart = valuesCount > 1 ? Math.min(...percentages) : 0;
    const offsetEnd = 100 - Math.max(...percentages);
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
      SliderTrackActiveFrame,
      {
        orientation: context.orientation,
        "data-orientation": context.orientation,
        "data-disabled": context.disabled ? "" : void 0,
        size: context.size,
        ...rangeProps,
        ref: composedRefs,
        ...{
          [orientation.startEdge]: `${offsetStart}%`,
          [orientation.endEdge]: `${offsetEnd}%`
        },
        ...orientation.sizeProp === "width" ? {
          height: "100%"
        } : {
          left: 0,
          right: 0
        }
      }
    );
  }
);
SliderTrackActive.displayName = RANGE_NAME;
const THUMB_NAME = "SliderThumb";
const getThumbSize = (val) => {
  const size = typeof val === "number" ? val : (0, import_get_size.getSize)(val, -1);
  return {
    width: size,
    height: size,
    minWidth: size,
    minHeight: size
  };
};
const SliderThumbFrame = (0, import_core.styled)(import_stacks.ThemeableStack, {
  name: "SliderThumb",
  position: "absolute",
  bordered: 2,
  borderWidth: 2,
  backgrounded: true,
  pressTheme: import_core.isWeb,
  focusTheme: import_core.isWeb,
  hoverTheme: import_core.isWeb,
  variants: {
    size: {
      "...size": getThumbSize
    }
  }
});
const SliderThumb = React.forwardRef(
  (props, forwardedRef) => {
    const { __scopeSlider, index, size: sizeProp, ...thumbProps } = props;
    const context = (0, import_constants.useSliderContext)(THUMB_NAME, __scopeSlider);
    const orientation = (0, import_constants.useSliderOrientationContext)(THUMB_NAME, __scopeSlider);
    const [thumb, setThumb] = React.useState(null);
    const composedRefs = (0, import_compose_refs.useComposedRefs)(forwardedRef, (node) => setThumb(node));
    const value = context.values[index];
    const percent = value === void 0 ? 0 : (0, import_helpers2.convertValueToPercentage)(value, context.min, context.max);
    const label = (0, import_helpers2.getLabel)(index, context.values.length);
    const sizeIn = sizeProp ?? context.size ?? "$true";
    const [size, setSize] = React.useState(() => {
      const estimatedSize = (0, import_core.getVariableValue)(getThumbSize(sizeIn).width);
      return estimatedSize;
    });
    const thumbInBoundsOffset = size ? (0, import_helpers2.getThumbInBoundsOffset)(size, percent, orientation.direction) : 0;
    React.useEffect(() => {
      if (thumb) {
        context.thumbs.add(thumb);
        return () => {
          context.thumbs.delete(thumb);
        };
      }
    }, [thumb, context.thumbs]);
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
      SliderThumbFrame,
      {
        ref: composedRefs,
        role: "slider",
        "aria-label": props["aria-label"] || label,
        "aria-valuemin": context.min,
        "aria-valuenow": value,
        "aria-valuemax": context.max,
        "aria-orientation": context.orientation,
        "data-orientation": context.orientation,
        "data-disabled": context.disabled ? "" : void 0,
        tabIndex: context.disabled ? void 0 : 0,
        animateOnly: ["transform", "left", "right", "top", "bottom"],
        ...thumbProps,
        ...context.orientation === "horizontal" ? {
          x: thumbInBoundsOffset - size / 2,
          y: -size / 2,
          top: "50%",
          ...size === 0 && {
            top: "auto",
            bottom: "auto"
          }
        } : {
          x: -size / 2,
          y: size / 2,
          left: "50%",
          ...size === 0 && {
            left: "auto",
            right: "auto"
          }
        },
        ...{
          [orientation.startEdge]: `${percent}%`
        },
        size: sizeIn,
        onLayout: (e) => {
          setSize(e.nativeEvent.layout[orientation.sizeProp]);
        },
        onFocus: (0, import_helpers.composeEventHandlers)(props.onFocus, () => {
          context.valueIndexToChangeRef.current = index;
        })
      }
    );
  }
);
SliderThumb.displayName = THUMB_NAME;
const Slider = (0, import_core.withStaticProperties)(
  React.forwardRef((props, forwardedRef) => {
    const {
      name,
      min = 0,
      max = 100,
      step = 1,
      orientation = "horizontal",
      disabled = false,
      minStepsBetweenThumbs = 0,
      defaultValue = [min],
      value,
      onValueChange = () => {
      },
      size: sizeProp,
      ...sliderProps
    } = props;
    const sliderRef = React.useRef(null);
    const composedRefs = (0, import_compose_refs.useComposedRefs)(sliderRef, forwardedRef);
    const thumbRefs = React.useRef(/* @__PURE__ */ new Set());
    const valueIndexToChangeRef = React.useRef(0);
    const isHorizontal = orientation === "horizontal";
    const [values = [], setValues] = (0, import_use_controllable_state.useControllableState)({
      prop: value,
      defaultProp: defaultValue,
      transition: true,
      onChange: (value2) => {
        var _a;
        if (import_core.isWeb) {
          const thumbs = [...thumbRefs.current];
          (_a = thumbs[valueIndexToChangeRef.current]) == null ? void 0 : _a.focus();
        }
        onValueChange(value2);
      }
    });
    if (import_core.isWeb) {
      React.useEffect(() => {
        const node = sliderRef.current;
        if (!node)
          return;
        const preventDefault = (e) => {
          e.preventDefault();
        };
        node.addEventListener("touchstart", preventDefault);
        return () => {
          node.removeEventListener("touchstart", preventDefault);
        };
      }, []);
    }
    function handleSlideMove(value2) {
      updateValues(value2, valueIndexToChangeRef.current);
    }
    function updateValues(value2, atIndex) {
      const decimalCount = (0, import_helpers2.getDecimalCount)(step);
      const snapToStep = (0, import_helpers2.roundValue)(
        Math.round((value2 - min) / step) * step + min,
        decimalCount
      );
      const nextValue = (0, import_helpers.clamp)(snapToStep, [min, max]);
      setValues((prevValues = []) => {
        const nextValues = (0, import_helpers2.getNextSortedValues)(prevValues, nextValue, atIndex);
        if ((0, import_helpers2.hasMinStepsBetweenValues)(nextValues, minStepsBetweenThumbs * step)) {
          valueIndexToChangeRef.current = nextValues.indexOf(nextValue);
          return String(nextValues) === String(prevValues) ? prevValues : nextValues;
        } else {
          return prevValues;
        }
      });
    }
    const SliderOriented = isHorizontal ? SliderHorizontal : SliderVertical;
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
      import_constants.SliderProvider,
      {
        scope: props.__scopeSlider,
        disabled,
        min,
        max,
        valueIndexToChangeRef,
        thumbs: thumbRefs.current,
        values,
        orientation,
        size: sizeProp,
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
          SliderOriented,
          {
            "aria-disabled": disabled,
            "data-disabled": disabled ? "" : void 0,
            ...sliderProps,
            ref: composedRefs,
            min,
            max,
            onSlideStart: disabled ? void 0 : (value2, target) => {
              if (target !== "thumb") {
                const closestIndex = (0, import_helpers2.getClosestValueIndex)(values, value2);
                updateValues(value2, closestIndex);
              }
            },
            onSlideMove: disabled ? void 0 : handleSlideMove,
            onHomeKeyDown: () => !disabled && updateValues(min, 0),
            onEndKeyDown: () => !disabled && updateValues(max, values.length - 1),
            onStepKeyDown: ({ event, direction: stepDirection }) => {
              if (!disabled) {
                const isPageKey = import_constants.PAGE_KEYS.includes(event.key);
                const isSkipKey = isPageKey || event.shiftKey && import_constants.ARROW_KEYS.includes(event.key);
                const multiplier = isSkipKey ? 10 : 1;
                const atIndex = valueIndexToChangeRef.current;
                const value2 = values[atIndex];
                const stepInDirection = step * multiplier * stepDirection;
                updateValues(value2 + stepInDirection, atIndex);
              }
            }
          }
        )
      }
    );
  }),
  {
    Track: SliderTrack,
    TrackActive: SliderTrackActive,
    Thumb: SliderThumb
  }
);
Slider.displayName = import_constants.SLIDER_NAME;
const Track = SliderTrack;
const Range = SliderTrackActive;
const Thumb = SliderThumb;
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=Slider.js.map


/***/ }),

/***/ 35037:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var SliderImpl_exports = {};
__export(SliderImpl_exports, {
  DirectionalYStack: () => DirectionalYStack,
  SliderFrame: () => SliderFrame,
  SliderImpl: () => SliderImpl
});
module.exports = __toCommonJS(SliderImpl_exports);
var import_jsx_runtime = __webpack_require__(52322);
var import_core = __webpack_require__(44996);
var import_get_size = __webpack_require__(20157);
var import_stacks = __webpack_require__(84432);
var React = __toESM(__webpack_require__(2784));
var import_constants = __webpack_require__(55466);
const DirectionalYStack = (0, import_core.styled)(import_stacks.YStack, {
  variants: {
    orientation: {
      horizontal: {},
      vertical: {}
    }
  }
});
const SliderFrame = (0, import_core.styled)(DirectionalYStack, {
  position: "relative",
  variants: {
    size: (val, extras) => {
      const orientation = extras.props.orientation;
      const size = Math.round((0, import_core.getVariableValue)((0, import_get_size.getSize)(val)) / 6);
      if (orientation === "horizontal") {
        return {
          height: size,
          borderRadius: size,
          justifyContent: "center"
        };
      }
      return {
        width: size,
        borderRadius: size,
        alignItems: "center"
      };
    }
  }
});
const SliderImpl = React.forwardRef(
  (props, forwardedRef) => {
    const {
      __scopeSlider,
      onSlideStart,
      onSlideMove,
      onSlideEnd,
      onHomeKeyDown,
      onEndKeyDown,
      onStepKeyDown,
      ...sliderProps
    } = props;
    const context = (0, import_constants.useSliderContext)(import_constants.SLIDER_NAME, __scopeSlider);
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
      SliderFrame,
      {
        size: "$4",
        ...sliderProps,
        "data-orientation": sliderProps.orientation,
        ref: forwardedRef,
        ...import_core.isWeb && {
          onKeyDown: (event) => {
            if (event.key === "Home") {
              onHomeKeyDown(event);
              event.preventDefault();
            } else if (event.key === "End") {
              onEndKeyDown(event);
              event.preventDefault();
            } else if (import_constants.PAGE_KEYS.concat(import_constants.ARROW_KEYS).includes(event.key)) {
              onStepKeyDown(event);
              event.preventDefault();
            }
          }
        },
        onMoveShouldSetResponderCapture: () => true,
        onScrollShouldSetResponder: () => true,
        onScrollShouldSetResponderCapture: () => true,
        onMoveShouldSetResponder: () => true,
        onStartShouldSetResponder: () => true,
        onResponderTerminationRequest: () => {
          return false;
        },
        onResponderGrant: (0, import_core.composeEventHandlers)(props.onResponderGrant, (event) => {
          const target = event.target;
          const isStartingOnThumb = context.thumbs.has(target);
          if (import_core.isWeb && target instanceof HTMLElement) {
            if (context.thumbs.has(target)) {
              target.focus();
            }
          }
          onSlideStart(event, isStartingOnThumb ? "thumb" : "track");
        }),
        onResponderMove: (0, import_core.composeEventHandlers)(props.onResponderMove, (event) => {
          event.stopPropagation();
          onSlideMove(event);
        }),
        onResponderRelease: (0, import_core.composeEventHandlers)(props.onResponderRelease, (event) => {
          onSlideEnd(event);
        })
      }
    );
  }
);
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=SliderImpl.js.map


/***/ }),

/***/ 55466:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var constants_exports = {};
__export(constants_exports, {
  ARROW_KEYS: () => ARROW_KEYS,
  BACK_KEYS: () => BACK_KEYS,
  PAGE_KEYS: () => PAGE_KEYS,
  SLIDER_NAME: () => SLIDER_NAME,
  SliderOrientationProvider: () => SliderOrientationProvider,
  SliderProvider: () => SliderProvider,
  createSliderContext: () => createSliderContext,
  createSliderScope: () => createSliderScope,
  useSliderContext: () => useSliderContext,
  useSliderOrientationContext: () => useSliderOrientationContext
});
module.exports = __toCommonJS(constants_exports);
var import_create_context = __webpack_require__(71913);
const SLIDER_NAME = "Slider";
const [createSliderContext, createSliderScope] = (0, import_create_context.createContextScope)(SLIDER_NAME);
const [SliderProvider, useSliderContext] = createSliderContext(SLIDER_NAME);
const [SliderOrientationProvider, useSliderOrientationContext] = createSliderContext(SLIDER_NAME, {
  startEdge: "left",
  endEdge: "right",
  sizeProp: "width",
  size: 0,
  direction: 1
});
const PAGE_KEYS = ["PageUp", "PageDown"];
const ARROW_KEYS = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"];
const BACK_KEYS = {
  ltr: ["ArrowDown", "Home", "ArrowLeft", "PageDown"],
  rtl: ["ArrowDown", "Home", "ArrowRight", "PageDown"]
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=constants.js.map


/***/ }),

/***/ 98672:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var helpers_exports = {};
__export(helpers_exports, {
  convertValueToPercentage: () => convertValueToPercentage,
  getClosestValueIndex: () => getClosestValueIndex,
  getDecimalCount: () => getDecimalCount,
  getLabel: () => getLabel,
  getNextSortedValues: () => getNextSortedValues,
  getThumbInBoundsOffset: () => getThumbInBoundsOffset,
  hasMinStepsBetweenValues: () => hasMinStepsBetweenValues,
  linearScale: () => linearScale,
  roundValue: () => roundValue
});
module.exports = __toCommonJS(helpers_exports);
function getNextSortedValues(prevValues = [], nextValue, atIndex) {
  const nextValues = [...prevValues];
  nextValues[atIndex] = nextValue;
  return nextValues.sort((a, b) => a - b);
}
function convertValueToPercentage(value, min, max) {
  const maxSteps = max - min;
  const percentPerStep = 100 / maxSteps;
  return percentPerStep * (value - min);
}
function getLabel(index, totalValues) {
  if (totalValues > 2) {
    return `Value ${index + 1} of ${totalValues}`;
  } else if (totalValues === 2) {
    return ["Minimum", "Maximum"][index];
  } else {
    return void 0;
  }
}
function getClosestValueIndex(values, nextValue) {
  if (values.length === 1)
    return 0;
  const distances = values.map((value) => Math.abs(value - nextValue));
  const closestDistance = Math.min(...distances);
  return distances.indexOf(closestDistance);
}
function getThumbInBoundsOffset(width, left, direction) {
  const halfWidth = width / 2;
  const halfPercent = 50;
  const offset = linearScale([0, halfPercent], [0, halfWidth]);
  return (halfWidth - offset(left) * direction) * direction;
}
function getStepsBetweenValues(values) {
  return values.slice(0, -1).map((value, index) => values[index + 1] - value);
}
function hasMinStepsBetweenValues(values, minStepsBetweenValues) {
  if (minStepsBetweenValues > 0) {
    const stepsBetweenValues = getStepsBetweenValues(values);
    const actualMinStepsBetweenValues = Math.min(...stepsBetweenValues);
    return actualMinStepsBetweenValues >= minStepsBetweenValues;
  }
  return true;
}
function linearScale(input, output) {
  return (value) => {
    if (input[0] === input[1] || output[0] === output[1])
      return output[0];
    const ratio = (output[1] - output[0]) / (input[1] - input[0]);
    return output[0] + ratio * (value - input[0]);
  };
}
function getDecimalCount(value) {
  return (String(value).split(".")[1] || "").length;
}
function roundValue(value, decimalCount) {
  const rounder = Math.pow(10, decimalCount);
  return Math.round(value * rounder) / rounder;
}
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=helpers.js.map


/***/ }),

/***/ 52526:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var src_exports = {};
__export(src_exports, {
  DirectionalYStack: () => import_SliderImpl.DirectionalYStack,
  SliderFrame: () => import_SliderImpl.SliderFrame
});
module.exports = __toCommonJS(src_exports);
__reExport(src_exports, __webpack_require__(38853), module.exports);
var import_SliderImpl = __webpack_require__(35037);
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 26254:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var SizableStack_exports = {};
__export(SizableStack_exports, {
  SizableStack: () => SizableStack
});
module.exports = __toCommonJS(SizableStack_exports);
var import_core = __webpack_require__(44996);
var import_get_button_sized = __webpack_require__(56701);
var import_Stacks = __webpack_require__(70225);
var import_variants = __webpack_require__(91032);
const SizableStack = (0, import_core.styled)(import_Stacks.XStack, {
  name: "SizableStack",
  variants: {
    unstyled: {
      true: {
        hoverTheme: false,
        pressTheme: false,
        focusTheme: false,
        elevate: false,
        bordered: false
      },
      false: {
        backgroundColor: "$background",
        flexShrink: 1
      }
    },
    hoverTheme: import_variants.hoverTheme,
    pressTheme: import_variants.pressTheme,
    focusTheme: import_variants.focusTheme,
    circular: import_variants.circular,
    elevate: import_variants.elevate,
    bordered: import_variants.bordered,
    size: {
      "...size": import_get_button_sized.getButtonSized
    }
  }
});
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=SizableStack.js.map


/***/ }),

/***/ 70225:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Stacks_exports = {};
__export(Stacks_exports, {
  XStack: () => XStack,
  YStack: () => YStack,
  ZStack: () => ZStack,
  fullscreenStyle: () => fullscreenStyle
});
module.exports = __toCommonJS(Stacks_exports);
var import_core = __webpack_require__(44996);
var import_getElevation = __webpack_require__(57036);
const fullscreenStyle = {
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0
};
const variants = {
  fullscreen: {
    true: fullscreenStyle
  },
  elevation: {
    "...size": import_getElevation.getElevation
  }
};
const YStack = (0, import_core.styled)(import_core.Stack, {
  flexDirection: "column",
  name: "YStack",
  variants
});
const XStack = (0, import_core.styled)(import_core.Stack, {
  flexDirection: "row",
  name: "XStack",
  variants
});
const ZStack = (0, import_core.styled)(
  YStack,
  {
    name: "ZStack",
    position: "relative"
  },
  {
    neverFlatten: true,
    isZStack: true
  }
);
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=Stacks.js.map


/***/ }),

/***/ 78685:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var ThemeableStack_exports = {};
__export(ThemeableStack_exports, {
  ThemeableStack: () => ThemeableStack
});
module.exports = __toCommonJS(ThemeableStack_exports);
var import_core = __webpack_require__(44996);
var import_Stacks = __webpack_require__(70225);
var import_variants = __webpack_require__(91032);
const chromelessStyle = {
  backgroundColor: "transparent",
  borderColor: "transparent",
  shadowColor: "transparent"
};
const ThemeableStack = (0, import_core.styled)(import_Stacks.YStack, {
  name: "SizableStack",
  variants: {
    backgrounded: {
      true: {
        backgroundColor: "$background"
      }
    },
    radiused: import_variants.radiused,
    hoverTheme: import_variants.hoverTheme,
    pressTheme: import_variants.pressTheme,
    focusTheme: import_variants.focusTheme,
    circular: import_variants.circular,
    padded: import_variants.padded,
    elevate: import_variants.elevate,
    bordered: import_variants.bordered,
    transparent: {
      true: {
        backgroundColor: "transparent"
      }
    },
    chromeless: {
      true: chromelessStyle,
      all: {
        ...chromelessStyle,
        hoverStyle: chromelessStyle,
        pressStyle: chromelessStyle,
        focusStyle: chromelessStyle
      }
    }
  }
});
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=ThemeableStack.js.map


/***/ }),

/***/ 57036:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var getElevation_exports = {};
__export(getElevation_exports, {
  getElevation: () => getElevation,
  getSizedElevation: () => getSizedElevation
});
module.exports = __toCommonJS(getElevation_exports);
var import_core = __webpack_require__(44996);
const getElevation = (size, extras) => {
  if (!size)
    return;
  const { tokens } = extras;
  const token = tokens.size[size];
  const sizeNum = (0, import_core.isVariable)(token) ? +token.val : size;
  return getSizedElevation(sizeNum, extras);
};
const getSizedElevation = (val, { theme, tokens }) => {
  let num = 0;
  if (val === true) {
    const val2 = (0, import_core.getVariableValue)(tokens.size["true"]);
    if (typeof val2 === "number") {
      num = val2;
    } else {
      num = 10;
    }
  } else {
    num = +val;
  }
  if (false) {}
  const [height, shadowRadius] = [Math.round(num / 4 + 1), Math.round(num / 2 + 2)];
  const shadow = {
    shadowColor: theme.shadowColor,
    shadowRadius,
    shadowOffset: { height, width: 0 }
  };
  return shadow;
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=getElevation.js.map


/***/ }),

/***/ 84432:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var src_exports = {};
module.exports = __toCommonJS(src_exports);
__reExport(src_exports, __webpack_require__(70225), module.exports);
__reExport(src_exports, __webpack_require__(26254), module.exports);
__reExport(src_exports, __webpack_require__(78685), module.exports);
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 91032:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var variants_exports = {};
__export(variants_exports, {
  bordered: () => bordered,
  circular: () => circular,
  elevate: () => elevate,
  focusTheme: () => focusTheme,
  hoverTheme: () => hoverTheme,
  padded: () => padded,
  pressTheme: () => pressTheme,
  radiused: () => radiused
});
module.exports = __toCommonJS(variants_exports);
var import_getElevation = __webpack_require__(57036);
const elevate = {
  true: (_, extras) => {
    return (0, import_getElevation.getElevation)(extras.props["size"], extras);
  }
};
const bordered = (val, { props }) => {
  return {
    // TODO size it with size in '...size'
    borderWidth: typeof val === "number" ? val : 1,
    borderColor: "$borderColor",
    ...props.hoverTheme && {
      hoverStyle: {
        borderColor: "$borderColorHover"
      }
    },
    ...props.pressTheme && {
      pressStyle: {
        borderColor: "$borderColorPress"
      }
    },
    ...props.focusTheme && {
      focusStyle: {
        borderColor: "$borderColorFocus"
      }
    }
  };
};
const padded = {
  true: (_, extras) => {
    const { tokens, props } = extras;
    return {
      padding: tokens.space[props.size] || tokens.space["$true"]
    };
  }
};
const radiused = {
  true: (_, extras) => {
    const { tokens, props } = extras;
    return {
      borderRadius: tokens.radius[props.size] || tokens.radius["$true"]
    };
  }
};
const circular = {
  true: (_, { props, tokens }) => {
    const size = tokens.size[props.size];
    return {
      width: size,
      height: size,
      maxWidth: size,
      maxHeight: size,
      minWidth: size,
      minHeight: size,
      borderRadius: 1e5,
      padding: 0
    };
  }
};
const hoverTheme = {
  true: {
    hoverStyle: {
      backgroundColor: "$backgroundHover",
      borderColor: "$borderColorHover"
    }
  },
  false: {}
};
const pressTheme = {
  true: {
    cursor: "pointer",
    pressStyle: {
      backgroundColor: "$backgroundPress",
      borderColor: "$borderColorPress"
    }
  },
  false: {}
};
const focusTheme = {
  true: {
    focusStyle: {
      backgroundColor: "$backgroundFocus",
      borderColor: "$borderColorFocus"
    }
  },
  false: {}
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=variants.js.map


/***/ }),

/***/ 8939:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FA": function() { return /* binding */ YStack; },
/* harmony export */   "Xu": function() { return /* binding */ fullscreenStyle; },
/* harmony export */   "sL": function() { return /* binding */ XStack; }
/* harmony export */ });
/* unused harmony export ZStack */
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90662);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44996);
/* harmony import */ var _getElevation_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5371);


const fullscreenStyle = {
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0
};
const variants = {
  fullscreen: {
    true: fullscreenStyle
  },
  elevation: {
    "...size": _getElevation_js__WEBPACK_IMPORTED_MODULE_0__/* .getElevation */ .y
  }
};
const YStack = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .z)(_tamagui_core__WEBPACK_IMPORTED_MODULE_2__.Stack, {
  flexDirection: "column",
  name: "YStack",
  variants
});
const XStack = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .z)(_tamagui_core__WEBPACK_IMPORTED_MODULE_2__.Stack, {
  flexDirection: "row",
  name: "XStack",
  variants
});
const ZStack = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .z)(
  YStack,
  {
    name: "ZStack",
    position: "relative"
  },
  {
    neverFlatten: true,
    isZStack: true
  }
);

//# sourceMappingURL=Stacks.js.map


/***/ }),

/***/ 50733:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "K": function() { return /* binding */ ThemeableStack; }
});

// EXTERNAL MODULE: ./node_modules/@tamagui/web/dist/esm/styled.js
var styled = __webpack_require__(90662);
// EXTERNAL MODULE: ../../node_modules/@tamagui/stacks/dist/esm/Stacks.js
var Stacks = __webpack_require__(8939);
// EXTERNAL MODULE: ../../node_modules/@tamagui/stacks/dist/esm/getElevation.js
var getElevation = __webpack_require__(5371);
;// CONCATENATED MODULE: ../../node_modules/@tamagui/stacks/dist/esm/variants.js

const elevate = {
  true: (_, extras) => {
    return (0,getElevation/* getElevation */.y)(extras.props["size"], extras);
  }
};
const bordered = (val, { props }) => {
  return {
    // TODO size it with size in '...size'
    borderWidth: typeof val === "number" ? val : 1,
    borderColor: "$borderColor",
    ...props.hoverTheme && {
      hoverStyle: {
        borderColor: "$borderColorHover"
      }
    },
    ...props.pressTheme && {
      pressStyle: {
        borderColor: "$borderColorPress"
      }
    },
    ...props.focusTheme && {
      focusStyle: {
        borderColor: "$borderColorFocus"
      }
    }
  };
};
const padded = {
  true: (_, extras) => {
    const { tokens, props } = extras;
    return {
      padding: tokens.space[props.size] || tokens.space["$true"]
    };
  }
};
const radiused = {
  true: (_, extras) => {
    const { tokens, props } = extras;
    return {
      borderRadius: tokens.radius[props.size] || tokens.radius["$true"]
    };
  }
};
const circular = {
  true: (_, { props, tokens }) => {
    const size = tokens.size[props.size];
    return {
      width: size,
      height: size,
      maxWidth: size,
      maxHeight: size,
      minWidth: size,
      minHeight: size,
      borderRadius: 1e5,
      padding: 0
    };
  }
};
const hoverTheme = {
  true: {
    hoverStyle: {
      backgroundColor: "$backgroundHover",
      borderColor: "$borderColorHover"
    }
  },
  false: {}
};
const pressTheme = {
  true: {
    cursor: "pointer",
    pressStyle: {
      backgroundColor: "$backgroundPress",
      borderColor: "$borderColorPress"
    }
  },
  false: {}
};
const focusTheme = {
  true: {
    focusStyle: {
      backgroundColor: "$backgroundFocus",
      borderColor: "$borderColorFocus"
    }
  },
  false: {}
};

//# sourceMappingURL=variants.js.map

;// CONCATENATED MODULE: ../../node_modules/@tamagui/stacks/dist/esm/ThemeableStack.js



const chromelessStyle = {
  backgroundColor: "transparent",
  borderColor: "transparent",
  shadowColor: "transparent"
};
const ThemeableStack = (0,styled/* styled */.z)(Stacks/* YStack */.FA, {
  name: "SizableStack",
  variants: {
    backgrounded: {
      true: {
        backgroundColor: "$background"
      }
    },
    radiused: radiused,
    hoverTheme: hoverTheme,
    pressTheme: pressTheme,
    focusTheme: focusTheme,
    circular: circular,
    padded: padded,
    elevate: elevate,
    bordered: bordered,
    transparent: {
      true: {
        backgroundColor: "transparent"
      }
    },
    chromeless: {
      true: chromelessStyle,
      all: {
        ...chromelessStyle,
        hoverStyle: chromelessStyle,
        pressStyle: chromelessStyle,
        focusStyle: chromelessStyle
      }
    }
  }
});

//# sourceMappingURL=ThemeableStack.js.map


/***/ }),

/***/ 5371:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ getElevation; }
/* harmony export */ });
/* unused harmony export getSizedElevation */
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13209);

const getElevation = (size, extras) => {
  if (!size)
    return;
  const { tokens } = extras;
  const token = tokens.size[size];
  const sizeNum = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_0__/* .isVariable */ .cG)(token) ? +token.val : size;
  return getSizedElevation(sizeNum, extras);
};
const getSizedElevation = (val, { theme, tokens }) => {
  let num = 0;
  if (val === true) {
    const val2 = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_0__/* .getVariableValue */ .Ve)(tokens.size["true"]);
    if (typeof val2 === "number") {
      num = val2;
    } else {
      num = 10;
    }
  } else {
    num = +val;
  }
  if (false) {}
  const [height, shadowRadius] = [Math.round(num / 4 + 1), Math.round(num / 2 + 2)];
  const shadow = {
    shadowColor: theme.shadowColor,
    shadowRadius,
    shadowOffset: { height, width: 0 }
  };
  return shadow;
};

//# sourceMappingURL=getElevation.js.map


/***/ }),

/***/ 73373:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Switch_exports = {};
__export(Switch_exports, {
  Switch: () => Switch,
  SwitchFrame: () => SwitchFrame,
  SwitchThumb: () => SwitchThumb,
  SwitchThumbFrame: () => SwitchThumbFrame,
  createSwitchScope: () => createSwitchScope
});
module.exports = __toCommonJS(Switch_exports);
var import_jsx_runtime = __webpack_require__(52322);
var import_react_use_previous = __webpack_require__(69586);
var import_compose_refs = __webpack_require__(7199);
var import_core = __webpack_require__(44996);
var import_create_context = __webpack_require__(71913);
var import_focusable = __webpack_require__(31390);
var import_get_size = __webpack_require__(20157);
var import_label = __webpack_require__(28339);
var import_stacks = __webpack_require__(84432);
var import_use_controllable_state = __webpack_require__(12113);
var React = __toESM(__webpack_require__(2784));
const SWITCH_NAME = "Switch";
const getSwitchHeight = (val) => Math.round((0, import_core.getVariableValue)((0, import_get_size.getSize)(val)) * 0.65);
const getSwitchWidth = (val) => getSwitchHeight(val) * 2;
const scopeContexts = (0, import_create_context.createContextScope)(SWITCH_NAME);
const [createSwitchContext] = scopeContexts;
const createSwitchScope = scopeContexts[1];
const [SwitchProvider, useSwitchContext] = createSwitchContext(SWITCH_NAME);
const THUMB_NAME = "SwitchThumb";
const SwitchThumbFrame = (0, import_core.styled)(import_stacks.ThemeableStack, {
  name: "SwitchThumb",
  variants: {
    unstyled: {
      false: {
        size: "$true",
        backgroundColor: "$background",
        borderRadius: 1e3
      }
    },
    size: {
      "...size": (val) => {
        const size = getSwitchHeight(val);
        return {
          height: size,
          width: size
        };
      }
    }
  },
  defaultVariants: {
    unstyled: false
  }
});
const SwitchThumb = SwitchThumbFrame.extractable(
  React.forwardRef(
    (props, forwardedRef) => {
      const { __scopeSwitch, size: sizeProp, ...thumbProps } = props;
      const {
        size: sizeContext,
        disabled,
        checked,
        unstyled
      } = useSwitchContext(THUMB_NAME, __scopeSwitch);
      const size = sizeProp ?? sizeContext;
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
        SwitchThumbFrame,
        {
          unstyled,
          size,
          theme: checked ? "active" : null,
          "data-state": getState(checked),
          "data-disabled": disabled ? "" : void 0,
          ...thumbProps,
          x: checked ? (0, import_core.getVariableValue)(getSwitchWidth(size)) - (0, import_core.getVariableValue)(getSwitchHeight(size)) : 0,
          ref: forwardedRef
        }
      );
    }
  )
);
SwitchThumb.displayName = THUMB_NAME;
const SwitchFrame = (0, import_core.styled)(import_stacks.XStack, {
  name: SWITCH_NAME,
  tag: "button",
  variants: {
    unstyled: {
      false: {
        size: "$true",
        borderRadius: 1e3,
        borderWidth: 2,
        borderColor: "transparent",
        backgroundColor: "$background",
        focusStyle: {
          borderColor: "$borderColorFocus"
        }
      }
    },
    size: {
      "...size": (val) => {
        const height = getSwitchHeight(val) + 4;
        const width = getSwitchWidth(val) + 4;
        return {
          height,
          minHeight: height,
          width
        };
      }
    }
  },
  defaultVariants: {
    unstyled: false
  }
});
const Switch = (0, import_core.withStaticProperties)(
  SwitchFrame.extractable(
    React.forwardRef(
      (props, forwardedRef) => {
        const {
          __scopeSwitch,
          labeledBy: ariaLabelledby,
          name,
          checked: checkedProp,
          defaultChecked,
          required,
          disabled,
          value = "on",
          onCheckedChange,
          size = "$true",
          unstyled = false,
          ...switchProps
        } = props;
        const [button, setButton] = React.useState(null);
        const composedRefs = (0, import_compose_refs.useComposedRefs)(
          forwardedRef,
          (node) => setButton(node)
        );
        const labelId = (0, import_label.useLabelContext)(button);
        const labelledBy = ariaLabelledby || labelId;
        const hasConsumerStoppedPropagationRef = React.useRef(false);
        const isFormControl = import_core.isWeb ? button ? Boolean(button.closest("form")) : true : false;
        const [checked = false, setChecked] = (0, import_use_controllable_state.useControllableState)({
          prop: checkedProp,
          defaultProp: defaultChecked || false,
          onChange: onCheckedChange,
          transition: true
        });
        if (!import_core.isWeb) {
          React.useEffect(() => {
            if (!props.id)
              return;
            return (0, import_focusable.registerFocusable)(props.id, {
              focus: () => {
                setChecked((x) => !x);
              }
            });
          }, [props.id, setChecked]);
        }
        return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(
          SwitchProvider,
          {
            scope: __scopeSwitch,
            checked,
            disabled,
            size,
            unstyled,
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
                SwitchFrame,
                {
                  unstyled,
                  size,
                  role: "switch",
                  "aria-checked": checked,
                  "aria-labelledby": labelledBy,
                  "aria-required": required,
                  "data-state": getState(checked),
                  "data-disabled": disabled ? "" : void 0,
                  disabled,
                  theme: checked ? "active" : null,
                  themeShallow: true,
                  tabIndex: disabled ? void 0 : 0,
                  value,
                  ...switchProps,
                  ref: composedRefs,
                  onPress: (event) => {
                    var _a;
                    (_a = props.onPress) == null ? void 0 : _a.call(props, event);
                    setChecked((prevChecked) => !prevChecked);
                    if (import_core.isWeb && isFormControl) {
                      hasConsumerStoppedPropagationRef.current = event.isPropagationStopped();
                      if (!hasConsumerStoppedPropagationRef.current)
                        event.stopPropagation();
                    }
                  }
                }
              ),
              import_core.isWeb && isFormControl && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
                BubbleInput,
                {
                  control: button,
                  bubbles: !hasConsumerStoppedPropagationRef.current,
                  name,
                  value,
                  checked,
                  required,
                  disabled,
                  style: { transform: "translateX(-100%)" }
                }
              )
            ]
          }
        );
      }
    )
  ),
  {
    Thumb: SwitchThumb
  }
);
const BubbleInput = (props) => {
  const { control, checked, bubbles = true, ...inputProps } = props;
  const ref = React.useRef(null);
  const prevChecked = (0, import_react_use_previous.usePrevious)(checked);
  React.useEffect(() => {
    const input = ref.current;
    const inputProto = window.HTMLInputElement.prototype;
    const descriptor = Object.getOwnPropertyDescriptor(
      inputProto,
      "checked"
    );
    const setChecked = descriptor.set;
    if (prevChecked !== checked && setChecked) {
      const event = new Event("click", { bubbles });
      setChecked.call(input, checked);
      input.dispatchEvent(event);
    }
  }, [prevChecked, checked, bubbles]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
    "input",
    {
      type: "checkbox",
      "aria-hidden": true,
      defaultChecked: checked,
      ...inputProps,
      tabIndex: -1,
      ref,
      style: {
        ...props.style,
        // ...controlSize,
        position: "absolute",
        pointerEvents: "none",
        opacity: 0,
        margin: 0
      }
    }
  );
};
function getState(checked) {
  return checked ? "checked" : "unchecked";
}
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=Switch.js.map


/***/ }),

/***/ 54348:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var src_exports = {};
module.exports = __toCommonJS(src_exports);
__reExport(src_exports, __webpack_require__(73373), module.exports);
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 81758:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Tabs_exports = {};
__export(Tabs_exports, {
  Tabs: () => Tabs
});
module.exports = __toCommonJS(Tabs_exports);
var import_jsx_runtime = __webpack_require__(52322);
var import_create_context = __webpack_require__(71913);
var import_get_button_sized = __webpack_require__(56701);
var import_group = __webpack_require__(60082);
var import_roving_focus = __webpack_require__(26394);
var import_stacks = __webpack_require__(84432);
var import_use_controllable_state = __webpack_require__(12113);
var import_use_direction = __webpack_require__(10498);
var import_web = __webpack_require__(44571);
var React = __toESM(__webpack_require__(2784));
const TAB_LIST_NAME = "TabsList";
const TabsListFrame = (0, import_web.styled)(import_group.Group, {
  name: TAB_LIST_NAME,
  focusable: true
  // defaultVariants: {
  //   flexGrow: 0,
  // },
});
const TabsList = React.forwardRef(
  (props, forwardedRef) => {
    const { __scopeTabs, loop = true, children, ...listProps } = props;
    const context = useTabsContext(TAB_LIST_NAME, __scopeTabs);
    const rovingFocusGroupScope = useRovingFocusGroupScope(__scopeTabs);
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
      import_roving_focus.RovingFocusGroup,
      {
        asChild: true,
        orientation: context.orientation,
        dir: context.dir,
        loop,
        ...rovingFocusGroupScope,
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
          TabsListFrame,
          {
            role: "tablist",
            "aria-orientation": context.orientation,
            ref: forwardedRef,
            axis: context.orientation,
            ...listProps,
            children
          }
        )
      }
    );
  }
);
TabsList.displayName = TAB_LIST_NAME;
const TRIGGER_NAME = "TabsTrigger";
const TabsTriggerFrame = (0, import_web.styled)(import_stacks.ThemeableStack, {
  name: TRIGGER_NAME,
  justifyContent: "center",
  alignItems: "center",
  flexWrap: "nowrap",
  flexDirection: "row",
  cursor: "pointer",
  variants: {
    size: {
      "...size": import_get_button_sized.getButtonSized
    },
    disabled: {
      true: {
        pointerEvents: "none"
      }
    },
    theme: {
      Button: {
        focusable: true,
        hoverTheme: true,
        pressTheme: true,
        backgrounded: true,
        borderWidth: 1,
        borderColor: "transparent",
        pressStyle: {
          borderColor: "transparent"
        },
        hoverStyle: {
          borderColor: "transparent"
        },
        focusStyle: {
          borderColor: "$borderColorFocus"
        }
      }
    }
  }
});
const TabsTrigger = TabsTriggerFrame.extractable(
  React.forwardRef(
    (props, forwardedRef) => {
      const {
        __scopeTabs,
        value,
        disabled = false,
        onInteraction,
        ...triggerProps
      } = props;
      const context = useTabsContext(TRIGGER_NAME, __scopeTabs);
      const rovingFocusGroupScope = useRovingFocusGroupScope(__scopeTabs);
      const triggerId = makeTriggerId(context.baseId, value);
      const contentId = makeContentId(context.baseId, value);
      const isSelected = value === context.value;
      const [layout, setLayout] = React.useState(null);
      const triggerRef = React.useRef(null);
      const groupItemProps = (0, import_group.useGroupItem)({ disabled });
      React.useEffect(() => {
        context.registerTrigger();
        return () => context.unregisterTrigger();
      }, []);
      React.useEffect(() => {
        if (!triggerRef.current || !import_web.isWeb)
          return;
        function getTriggerSize() {
          if (!triggerRef.current)
            return;
          setLayout({
            width: triggerRef.current.offsetWidth,
            height: triggerRef.current.offsetHeight,
            x: triggerRef.current.offsetLeft,
            y: triggerRef.current.offsetTop
          });
        }
        getTriggerSize();
        const observer = new ResizeObserver(getTriggerSize);
        observer.observe(triggerRef.current);
        return () => {
          if (!triggerRef.current)
            return;
          observer.unobserve(triggerRef.current);
        };
      }, [context.triggersCount]);
      React.useEffect(() => {
        if (isSelected && layout) {
          onInteraction == null ? void 0 : onInteraction("select", layout);
        }
      }, [isSelected, value, layout]);
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_web.Theme, { forceClassName: true, name: isSelected ? "active" : null, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
        import_roving_focus.RovingFocusGroup.Item,
        {
          asChild: true,
          ...rovingFocusGroupScope,
          focusable: !disabled,
          active: isSelected,
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
            TabsTriggerFrame,
            {
              onLayout: (event) => {
                if (!import_web.isWeb) {
                  setLayout(event.nativeEvent.layout);
                }
              },
              onHoverIn: (0, import_web.composeEventHandlers)(props.onHoverIn, () => {
                if (layout) {
                  onInteraction == null ? void 0 : onInteraction("hover", layout);
                }
              }),
              onHoverOut: (0, import_web.composeEventHandlers)(props.onHoverOut, () => {
                onInteraction == null ? void 0 : onInteraction("hover", null);
              }),
              role: "tab",
              "aria-selected": isSelected,
              "aria-controls": contentId,
              "data-state": isSelected ? "active" : "inactive",
              "data-disabled": disabled ? "" : void 0,
              disabled,
              id: triggerId,
              size: context.size,
              ...triggerProps,
              ref: (0, import_web.composeRefs)(forwardedRef, triggerRef),
              onPress: (0, import_web.composeEventHandlers)(props.onPress ?? void 0, (event) => {
                const webChecks = !import_web.isWeb || event.button === 0 && event.ctrlKey === false;
                if (!disabled && !isSelected && webChecks) {
                  context.onChange(value);
                } else {
                  event.preventDefault();
                }
              }),
              ...import_web.isWeb && {
                type: "button",
                onKeyDown: (0, import_web.composeEventHandlers)(
                  props.onKeyDown,
                  (event) => {
                    if ([" ", "Enter"].includes(event.key)) {
                      context.onChange(value);
                    }
                  }
                ),
                onFocus: (0, import_web.composeEventHandlers)(props.onFocus, (event) => {
                  if (layout) {
                    onInteraction == null ? void 0 : onInteraction("focus", layout);
                  }
                  const isAutomaticActivation = context.activationMode !== "manual";
                  if (!isSelected && !disabled && isAutomaticActivation) {
                    context.onChange(value);
                  }
                }),
                onBlur: (0, import_web.composeEventHandlers)(props.onFocus, () => {
                  onInteraction == null ? void 0 : onInteraction("focus", null);
                })
              },
              ...groupItemProps
            }
          )
        }
      ) });
    }
  )
);
TabsTrigger.displayName = TRIGGER_NAME;
const CONTENT_NAME = "TabsContent";
const TabsContentFrame = (0, import_web.styled)(import_stacks.ThemeableStack, {
  name: CONTENT_NAME
});
const TabsContent = React.forwardRef(
  (props, forwardedRef) => {
    const { __scopeTabs, value, forceMount, children, ...contentProps } = props;
    const context = useTabsContext(CONTENT_NAME, __scopeTabs);
    const isSelected = value === context.value;
    const show = forceMount || isSelected;
    const triggerId = makeTriggerId(context.baseId, value);
    const contentId = makeContentId(context.baseId, value);
    if (!show)
      return null;
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
      TabsContentFrame,
      {
        "data-state": isSelected ? "active" : "inactive",
        "data-orientation": context.orientation,
        role: "tabpanel",
        "aria-labelledby": triggerId,
        hidden: !show,
        id: contentId,
        tabIndex: 0,
        ...contentProps,
        ref: forwardedRef,
        children
      },
      value
    );
  }
);
TabsContent.displayName = CONTENT_NAME;
const TABS_NAME = "Tabs";
const [createTabsContext, createTabsScope] = (0, import_create_context.createContextScope)(TABS_NAME, [
  import_roving_focus.createRovingFocusGroupScope
]);
const useRovingFocusGroupScope = (0, import_roving_focus.createRovingFocusGroupScope)();
const [TabsProvider, useTabsContext] = createTabsContext(TABS_NAME);
const TabsFrame = (0, import_web.styled)(import_stacks.SizableStack, {
  name: TABS_NAME
});
const Tabs = (0, import_web.withStaticProperties)(
  React.forwardRef(
    (props, forwardedRef) => {
      const {
        __scopeTabs,
        value: valueProp,
        onValueChange,
        defaultValue,
        orientation = "horizontal",
        dir,
        activationMode = "automatic",
        size = "$true",
        ...tabsProps
      } = props;
      const direction = (0, import_use_direction.useDirection)(dir);
      const [value, setValue] = (0, import_use_controllable_state.useControllableState)({
        prop: valueProp,
        onChange: onValueChange,
        defaultProp: defaultValue ?? ""
      });
      const [triggersCount, setTriggersCount] = React.useState(0);
      const registerTrigger = (0, import_web.useEvent)(() => setTriggersCount((v) => v + 1));
      const unregisterTrigger = (0, import_web.useEvent)(() => setTriggersCount((v) => v - 1));
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
        TabsProvider,
        {
          scope: __scopeTabs,
          baseId: (0, import_web.useId)(),
          value,
          onChange: setValue,
          orientation,
          dir: direction,
          activationMode,
          size,
          registerTrigger,
          triggersCount,
          unregisterTrigger,
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
            TabsFrame,
            {
              direction,
              "data-orientation": orientation,
              ...tabsProps,
              ref: forwardedRef
            }
          )
        }
      );
    }
  ),
  {
    List: TabsList,
    Trigger: TabsTrigger,
    Content: TabsContent
  }
);
Tabs.displayName = TABS_NAME;
function makeTriggerId(baseId, value) {
  return `${baseId}-trigger-${value}`;
}
function makeContentId(baseId, value) {
  return `${baseId}-content-${value}`;
}
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=Tabs.js.map


/***/ }),

/***/ 29727:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var src_exports = {};
module.exports = __toCommonJS(src_exports);
__reExport(src_exports, __webpack_require__(81758), module.exports);
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 39645:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Headings_exports = {};
__export(Headings_exports, {
  H1: () => H1,
  H2: () => H2,
  H3: () => H3,
  H4: () => H4,
  H5: () => H5,
  H6: () => H6,
  Heading: () => Heading
});
module.exports = __toCommonJS(Headings_exports);
var import_web = __webpack_require__(44571);
var import_Paragraph = __webpack_require__(9471);
const Heading = (0, import_web.styled)(import_Paragraph.Paragraph, {
  tag: "span",
  name: "Heading",
  accessibilityRole: "header",
  fontFamily: "$heading",
  size: "$8",
  margin: 0
});
const H1 = (0, import_web.styled)(Heading, {
  name: "H1",
  tag: "h1",
  size: "$10"
});
const H2 = (0, import_web.styled)(Heading, {
  name: "H2",
  tag: "h2",
  size: "$9"
});
const H3 = (0, import_web.styled)(Heading, {
  name: "H3",
  tag: "h3",
  size: "$8"
});
const H4 = (0, import_web.styled)(Heading, {
  name: "H4",
  tag: "h4",
  size: "$7"
});
const H5 = (0, import_web.styled)(Heading, {
  name: "H5",
  tag: "h5",
  size: "$6"
});
const H6 = (0, import_web.styled)(Heading, {
  name: "H6",
  tag: "h6",
  size: "$5"
});
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=Headings.js.map


/***/ }),

/***/ 9471:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Paragraph_exports = {};
__export(Paragraph_exports, {
  Paragraph: () => Paragraph
});
module.exports = __toCommonJS(Paragraph_exports);
var import_web = __webpack_require__(44571);
var import_SizableText = __webpack_require__(69076);
const Paragraph = (0, import_web.styled)(import_SizableText.SizableText, {
  name: "Paragraph",
  tag: "p",
  userSelect: "auto",
  color: "$color",
  size: "$true"
});
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=Paragraph.js.map


/***/ }),

/***/ 69076:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var SizableText_exports = {};
__export(SizableText_exports, {
  SizableText: () => SizableText
});
module.exports = __toCommonJS(SizableText_exports);
var import_get_font_sized = __webpack_require__(66754);
var import_web = __webpack_require__(44571);
const SizableText = (0, import_web.styled)(import_web.Text, {
  name: "SizableText",
  fontFamily: "$body",
  variants: {
    size: import_get_font_sized.getFontSized
  },
  defaultVariants: {
    size: "$true"
  }
});
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=SizableText.js.map


/***/ }),

/***/ 48175:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var src_exports = {};
module.exports = __toCommonJS(src_exports);
__reExport(src_exports, __webpack_require__(69076), module.exports);
__reExport(src_exports, __webpack_require__(9471), module.exports);
__reExport(src_exports, __webpack_require__(39645), module.exports);
__reExport(src_exports, __webpack_require__(64919), module.exports);
__reExport(src_exports, __webpack_require__(4306), module.exports);
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 4306:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var types_exports = {};
module.exports = __toCommonJS(types_exports);
//# sourceMappingURL=types.js.map


/***/ }),

/***/ 64919:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var wrapChildrenInText_exports = {};
__export(wrapChildrenInText_exports, {
  wrapChildrenInText: () => wrapChildrenInText
});
module.exports = __toCommonJS(wrapChildrenInText_exports);
var import_jsx_runtime = __webpack_require__(52322);
var import_react = __toESM(__webpack_require__(2784));
function wrapChildrenInText(TextComponent, propsIn, extraProps) {
  const {
    children,
    textProps,
    size,
    noTextWrap,
    color,
    fontFamily,
    fontSize,
    fontWeight,
    letterSpacing,
    textAlign
  } = propsIn;
  if (noTextWrap || !children) {
    return [children];
  }
  const allChildren = import_react.default.Children.toArray(children);
  const nextChildren = [];
  let lastIsString = false;
  const props = {
    ...extraProps
  };
  if (color)
    props.color = color;
  if (fontFamily)
    props.fontFamily = fontFamily;
  if (fontSize)
    props.fontSize = fontSize;
  if (fontWeight)
    props.fontWeight = fontWeight;
  if (letterSpacing)
    props.letterSpacing = letterSpacing;
  if (textAlign)
    props.textAlign = textAlign;
  if (size)
    props.size = size;
  function concatStringChildren() {
    if (!lastIsString)
      return;
    const index = nextChildren.length - 1;
    const childrenStrings = nextChildren[index];
    nextChildren[index] = /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TextComponent, { ...props, ...textProps, children: childrenStrings }, index);
  }
  for (const child of allChildren) {
    const last = nextChildren[nextChildren.length - 1];
    const isString = typeof child === "string";
    if (isString) {
      if (lastIsString) {
        last.push(child);
      } else {
        nextChildren.push([child]);
      }
    } else {
      concatStringChildren();
      nextChildren.push(child);
    }
    lastIsString = isString;
  }
  concatStringChildren();
  return nextChildren;
}
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=wrapChildrenInText.js.map


/***/ }),

/***/ 46003:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ SizableText; }
/* harmony export */ });
/* harmony import */ var _tamagui_get_font_sized__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66754);
/* harmony import */ var _tamagui_web__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90662);
/* harmony import */ var _tamagui_web__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8669);


const SizableText = (0,_tamagui_web__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .z)(_tamagui_web__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .x, {
  name: "SizableText",
  fontFamily: "$body",
  variants: {
    size: _tamagui_get_font_sized__WEBPACK_IMPORTED_MODULE_0__.getFontSized
  },
  defaultVariants: {
    size: "$true"
  }
});

//# sourceMappingURL=SizableText.js.map


/***/ }),

/***/ 31230:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ wrapChildrenInText; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);


function wrapChildrenInText(TextComponent, propsIn, extraProps) {
  const {
    children,
    textProps,
    size,
    noTextWrap,
    color,
    fontFamily,
    fontSize,
    fontWeight,
    letterSpacing,
    textAlign
  } = propsIn;
  if (noTextWrap || !children) {
    return [children];
  }
  const allChildren = react__WEBPACK_IMPORTED_MODULE_1__.Children.toArray(children);
  const nextChildren = [];
  let lastIsString = false;
  const props = {
    ...extraProps
  };
  if (color)
    props.color = color;
  if (fontFamily)
    props.fontFamily = fontFamily;
  if (fontSize)
    props.fontSize = fontSize;
  if (fontWeight)
    props.fontWeight = fontWeight;
  if (letterSpacing)
    props.letterSpacing = letterSpacing;
  if (textAlign)
    props.textAlign = textAlign;
  if (size)
    props.size = size;
  function concatStringChildren() {
    if (!lastIsString)
      return;
    const index = nextChildren.length - 1;
    const childrenStrings = nextChildren[index];
    nextChildren[index] = /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TextComponent, { ...props, ...textProps, children: childrenStrings }, index);
  }
  for (const child of allChildren) {
    const last = nextChildren[nextChildren.length - 1];
    const isString = typeof child === "string";
    if (isString) {
      if (lastIsString) {
        last.push(child);
      } else {
        nextChildren.push([child]);
      }
    } else {
      concatStringChildren();
      nextChildren.push(child);
    }
    lastIsString = isString;
  }
  concatStringChildren();
  return nextChildren;
}

//# sourceMappingURL=wrapChildrenInText.js.map


/***/ }),

/***/ 8158:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var src_exports = {};
module.exports = __toCommonJS(src_exports);
__reExport(src_exports, __webpack_require__(98212), module.exports);
__reExport(src_exports, __webpack_require__(5594), module.exports);
__reExport(src_exports, __webpack_require__(22643), module.exports);
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 98212:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var themes_exports = {};
__export(themes_exports, {
  themes: () => themes
});
module.exports = __toCommonJS(themes_exports);
var import_create_theme = __webpack_require__(5774);
var import_tokens = __webpack_require__(5594);
const lightTransparent = "rgba(255,255,255,0)";
const darkTransparent = "rgba(10,10,10,0)";
const palettes = {
  dark: [
    darkTransparent,
    "#050505",
    "#151515",
    "#191919",
    "#232323",
    "#282828",
    "#323232",
    "#424242",
    "#494949",
    "#545454",
    "#626262",
    "#a5a5a5",
    "#fff",
    lightTransparent
  ],
  light: [
    lightTransparent,
    "#fff",
    "#f9f9f9",
    "hsl(0, 0%, 97.3%)",
    "hsl(0, 0%, 95.1%)",
    "hsl(0, 0%, 94.0%)",
    "hsl(0, 0%, 92.0%)",
    "hsl(0, 0%, 89.5%)",
    "hsl(0, 0%, 81.0%)",
    "hsl(0, 0%, 56.1%)",
    "hsl(0, 0%, 50.3%)",
    "hsl(0, 0%, 42.5%)",
    "hsl(0, 0%, 9.0%)",
    darkTransparent
  ]
};
const templateColors = {
  color1: 1,
  color2: 2,
  color3: 3,
  color4: 4,
  color5: 5,
  color6: 6,
  color7: 7,
  color8: 8,
  color9: 9,
  color10: 10,
  color11: 11,
  color12: 12
};
const templateShadows = {
  shadowColor: 1,
  shadowColorHover: 1,
  shadowColorPress: 2,
  shadowColorFocus: 2
};
const skip = {
  ...templateColors,
  ...templateShadows
};
const template = {
  ...skip,
  // the background, color, etc keys here work like generics - they make it so you
  // can publish components for others to use without mandating a specific color scale
  // the @tamagui/button Button component looks for `$background`, so you set the
  // dark_red_Button theme to have a stronger background than the dark_red theme.
  background: 2,
  backgroundHover: 3,
  backgroundPress: 1,
  backgroundFocus: 2,
  backgroundStrong: 1,
  backgroundTransparent: 0,
  color: -1,
  colorHover: -2,
  colorPress: -1,
  colorFocus: -2,
  colorTransparent: -0,
  borderColor: 4,
  borderColorHover: 5,
  borderColorPress: 3,
  borderColorFocus: 4,
  placeholderColor: -4
};
const lightShadowColor = "rgba(0,0,0,0.02)";
const lightShadowColorStrong = "rgba(0,0,0,0.066)";
const darkShadowColor = "rgba(0,0,0,0.2)";
const darkShadowColorStrong = "rgba(0,0,0,0.3)";
const lightShadows = {
  shadowColor: lightShadowColorStrong,
  shadowColorHover: lightShadowColorStrong,
  shadowColorPress: lightShadowColor,
  shadowColorFocus: lightShadowColor
};
const darkShadows = {
  shadowColor: darkShadowColorStrong,
  shadowColorHover: darkShadowColorStrong,
  shadowColorPress: darkShadowColor,
  shadowColorFocus: darkShadowColor
};
const lightTemplate = {
  ...template,
  // our light color palette is... a bit unique
  borderColor: 6,
  borderColorHover: 7,
  borderColorFocus: 5,
  borderColorPress: 6,
  ...lightShadows
};
const darkTemplate = { ...template, ...darkShadows };
const light = (0, import_create_theme.createTheme)(palettes.light, lightTemplate);
const dark = (0, import_create_theme.createTheme)(palettes.dark, darkTemplate);
const baseThemes = {
  light,
  dark
};
const masks = {
  weaker: (0, import_create_theme.createWeakenMask)(),
  stronger: (0, import_create_theme.createStrengthenMask)()
};
const maskOptions = {
  skip,
  // avoids the transparent ends
  max: palettes.light.length - 2,
  min: 1
};
const allThemes = (0, import_create_theme.addChildren)(baseThemes, (name, theme) => {
  const isLight = name === "light";
  const inverseName = isLight ? "dark" : "light";
  const inverseTheme = baseThemes[inverseName];
  const transparent = (hsl, opacity = 0) => hsl.replace(`%)`, `%, ${opacity})`).replace(`hsl(`, `hsla(`);
  const [colorThemes, inverseColorThemes] = [
    import_tokens.colorTokens[name],
    import_tokens.colorTokens[inverseName]
  ].map((colorSet) => {
    return Object.fromEntries(
      Object.keys(colorSet).map((color) => {
        const colorPalette = Object.values(colorSet[color]);
        const [head, tail] = [
          colorPalette.slice(0, 6),
          colorPalette.slice(colorPalette.length - 5)
        ];
        const palette = [
          transparent(colorPalette[0]),
          ...head,
          ...tail,
          theme.color,
          transparent(colorPalette[colorPalette.length - 1])
        ];
        const colorTheme = (0, import_create_theme.createTheme)(
          palette,
          isLight ? {
            ...lightTemplate,
            // light color themes are a bit less sensitive
            borderColor: 4,
            borderColorHover: 5,
            borderColorFocus: 4,
            borderColorPress: 4
          } : darkTemplate
        );
        return [color, colorTheme];
      })
    );
  });
  const allColorThemes = (0, import_create_theme.addChildren)(colorThemes, (colorName, colorTheme) => {
    const inverse = inverseColorThemes[colorName];
    return {
      ...getAltThemes(colorTheme, inverse),
      ...getComponentThemes(colorTheme, inverse)
    };
  });
  const baseActiveTheme = (0, import_create_theme.applyMask)(colorThemes.blue, masks.weaker, {
    ...maskOptions,
    strength: 4
  });
  const baseSubThemes = {
    ...getAltThemes(theme, inverseTheme, baseActiveTheme),
    ...getComponentThemes(theme, inverseTheme)
  };
  return {
    ...baseSubThemes,
    ...allColorThemes
  };
  function getAltThemes(theme2, inverse, activeTheme) {
    const maskOptionsAlt = {
      ...maskOptions,
      skip: templateShadows
    };
    const alt1 = (0, import_create_theme.applyMask)(theme2, masks.weaker, maskOptionsAlt);
    const alt2 = (0, import_create_theme.applyMask)(alt1, masks.weaker, maskOptionsAlt);
    const active = activeTheme ?? (0, import_create_theme.applyMask)(theme2, masks.weaker, {
      ...maskOptions,
      strength: 4
    });
    return (0, import_create_theme.addChildren)({ alt1, alt2, active }, (_, subTheme) => {
      return getComponentThemes(subTheme, subTheme === inverse ? theme2 : inverse);
    });
  }
  function getComponentThemes(theme2, inverse) {
    const weaker1 = (0, import_create_theme.applyMask)(theme2, masks.weaker, maskOptions);
    const weaker2 = (0, import_create_theme.applyMask)(weaker1, masks.weaker, maskOptions);
    const stronger1 = (0, import_create_theme.applyMask)(theme2, masks.stronger, maskOptions);
    const inverse1 = (0, import_create_theme.applyMask)(inverse, masks.weaker, maskOptions);
    const inverse2 = (0, import_create_theme.applyMask)(inverse1, masks.weaker, maskOptions);
    const strongerBorderLighterBackground = isLight ? {
      ...stronger1,
      borderColor: weaker1.borderColor,
      borderColorHover: weaker1.borderColorHover,
      borderColorPress: weaker1.borderColorPress,
      borderColorFocus: weaker1.borderColorFocus
    } : {
      ...theme2,
      borderColor: weaker1.borderColor,
      borderColorHover: weaker1.borderColorHover,
      borderColorPress: weaker1.borderColorPress,
      borderColorFocus: weaker1.borderColorFocus
    };
    return {
      Card: weaker1,
      Button: weaker2,
      Checkbox: weaker2,
      DrawerFrame: weaker1,
      SliderTrack: stronger1,
      SliderTrackActive: weaker2,
      SliderThumb: inverse1,
      Progress: weaker1,
      ProgressIndicator: inverse,
      Switch: weaker2,
      SwitchThumb: inverse2,
      TooltipArrow: weaker1,
      TooltipContent: weaker2,
      Input: strongerBorderLighterBackground,
      TextArea: strongerBorderLighterBackground,
      Tooltip: inverse1
    };
  }
});
const themes = {
  ...allThemes,
  // bring back the full type, the rest use a subset to avoid clogging up ts,
  // tamagui will be smart and use the top level themes as the type for useTheme() etc
  light: (0, import_create_theme.createTheme)(palettes.light, lightTemplate, { nonInheritedValues: import_tokens.lightColors }),
  dark: (0, import_create_theme.createTheme)(palettes.dark, darkTemplate, { nonInheritedValues: import_tokens.darkColors })
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=themes.js.map


/***/ }),

/***/ 5594:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var tokens_exports = {};
__export(tokens_exports, {
  color: () => color,
  colorTokens: () => colorTokens,
  darkColors: () => darkColors,
  lightColors: () => lightColors,
  radius: () => radius,
  size: () => size,
  space: () => space,
  tokens: () => tokens,
  zIndex: () => zIndex
});
module.exports = __toCommonJS(tokens_exports);
var import_colors = __webpack_require__(22643);
var import_web = __webpack_require__(44571);
const size = {
  $0: 0,
  "$0.25": 2,
  "$0.5": 4,
  "$0.75": 8,
  $1: 20,
  "$1.5": 24,
  $2: 28,
  "$2.5": 32,
  $3: 36,
  "$3.5": 40,
  $4: 44,
  $true: 44,
  "$4.5": 48,
  $5: 52,
  $6: 64,
  $7: 74,
  $8: 84,
  $9: 94,
  $10: 104,
  $11: 124,
  $12: 144,
  $13: 164,
  $14: 184,
  $15: 204,
  $16: 224,
  $17: 224,
  $18: 244,
  $19: 264,
  $20: 284
};
const spaces = Object.entries(size).map(([k, v]) => {
  return [k, sizeToSpace(v)];
});
function sizeToSpace(v) {
  if (v === 0)
    return 0;
  if (v === 2)
    return 0.5;
  if (v === 4)
    return 1;
  if (v === 8)
    return 1.5;
  if (v <= 16)
    return Math.round(v * 0.333);
  return Math.floor(v * 0.7 - 12);
}
const spacesNegative = spaces.slice(1).map(([k, v]) => [`-${k.slice(1)}`, -v]);
const space = {
  ...Object.fromEntries(spaces),
  ...Object.fromEntries(spacesNegative)
};
const zIndex = {
  0: 0,
  1: 100,
  2: 200,
  3: 300,
  4: 400,
  5: 500
};
const colorTokens = {
  light: {
    blue: import_colors.blue,
    gray: import_colors.gray,
    green: import_colors.green,
    orange: import_colors.orange,
    pink: import_colors.pink,
    purple: import_colors.purple,
    red: import_colors.red,
    yellow: import_colors.yellow
  },
  dark: {
    blue: import_colors.blueDark,
    gray: import_colors.grayDark,
    green: import_colors.greenDark,
    orange: import_colors.orangeDark,
    pink: import_colors.pinkDark,
    purple: import_colors.purpleDark,
    red: import_colors.redDark,
    yellow: import_colors.yellowDark
  }
};
const darkColors = {
  ...colorTokens.dark.blue,
  ...colorTokens.dark.gray,
  ...colorTokens.dark.green,
  ...colorTokens.dark.orange,
  ...colorTokens.dark.pink,
  ...colorTokens.dark.purple,
  ...colorTokens.dark.red,
  ...colorTokens.dark.yellow
};
const lightColors = {
  ...colorTokens.light.blue,
  ...colorTokens.light.gray,
  ...colorTokens.light.green,
  ...colorTokens.light.orange,
  ...colorTokens.light.pink,
  ...colorTokens.light.purple,
  ...colorTokens.light.red,
  ...colorTokens.light.yellow
};
const color = {
  ...postfixObjKeys(lightColors, "Light"),
  ...postfixObjKeys(darkColors, "Dark")
};
function postfixObjKeys(obj, postfix) {
  return Object.fromEntries(
    Object.entries(obj).map(([k, v]) => [`${k}${postfix}`, v])
  );
}
const radius = {
  0: 0,
  1: 3,
  2: 5,
  3: 7,
  4: 9,
  true: 9,
  5: 10,
  6: 16,
  7: 19,
  8: 22,
  9: 26,
  10: 34,
  11: 42,
  12: 50
};
const tokens = (0, import_web.createTokens)({
  color,
  radius,
  zIndex,
  space,
  size
});
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=tokens.js.map


/***/ }),

/***/ 24037:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Tooltip_exports = {};
__export(Tooltip_exports, {
  Tooltip: () => Tooltip2,
  TooltipGroup: () => TooltipGroup
});
module.exports = __toCommonJS(Tooltip_exports);
var import_jsx_runtime = __webpack_require__(52322);
var import_polyfill_dev = __webpack_require__(85360);
var import_react = __webpack_require__(67777);
var import_core = __webpack_require__(44996);
var import_floating = __webpack_require__(80159);
var import_get_size = __webpack_require__(20157);
var import_popover = __webpack_require__(17272);
var import_popper = __webpack_require__(48920);
var React = __toESM(__webpack_require__(2784));
const TooltipContent = import_popper.PopperContentFrame.extractable(
  React.forwardRef(
    ({ __scopePopover, ...props }, ref) => {
      const popperScope = (0, import_popover.usePopoverScope)(__scopePopover);
      const popper = (0, import_popper.usePopperContext)("PopperContent", popperScope["__scopePopper"]);
      const padding = props.size || popper.size || (0, import_get_size.stepTokenUpOrDown)("size", "$true", -2);
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
        import_popover.PopoverContent,
        {
          componentName: "Tooltip",
          disableRemoveScroll: true,
          trapFocus: false,
          padding,
          pointerEvents: "none",
          ref,
          ...props
        }
      );
    }
  )
);
const TooltipArrow = React.forwardRef((props, ref) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_popover.PopoverArrow, { componentName: "Tooltip", ref, ...props });
});
const TooltipGroup = ({ children, delay }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react.FloatingDelayGroup, { delay: React.useMemo(() => delay, [JSON.stringify(delay)]), children });
};
const TooltipComponent = React.forwardRef(function Tooltip(props, ref) {
  const {
    __scopePopover,
    children,
    delay: delayProp,
    restMs = typeof delayProp === "undefined" ? 500 : typeof delayProp === "number" ? delayProp : 0,
    onOpenChange: onOpenChangeProp,
    focus,
    ...restProps
  } = props;
  const popperScope = (0, import_popover.usePopoverScope)(__scopePopover);
  const triggerRef = React.useRef(null);
  const [hasCustomAnchor, setHasCustomAnchor] = React.useState(false);
  const { delay: delayGroup, setCurrentId } = (0, import_react.useDelayGroupContext)();
  const delay = delayProp ?? delayGroup;
  const [open, setOpen] = React.useState(false);
  const id = props.groupId;
  const onOpenChange = (0, import_core.useEvent)((open2) => {
    setOpen(open2);
    if (open2) {
      setCurrentId(id);
    }
    onOpenChangeProp == null ? void 0 : onOpenChangeProp(open2);
  });
  const useFloatingFn = (props2) => {
    const floating = (0, import_react.useFloating)({
      ...props2,
      open,
      onOpenChange
    });
    const { getReferenceProps, getFloatingProps } = (0, import_react.useInteractions)([
      (0, import_react.useHover)(floating.context, { delay, restMs }),
      (0, import_react.useFocus)(floating.context, focus),
      (0, import_react.useRole)(floating.context, { role: "tooltip" }),
      (0, import_react.useDismiss)(floating.context),
      (0, import_react.useDelayGroup)(floating.context, { id })
    ]);
    return {
      ...floating,
      getReferenceProps,
      getFloatingProps
    };
  };
  const useFloatingContext = React.useCallback(useFloatingFn, [id, delay, open]);
  const onCustomAnchorAdd = React.useCallback(() => setHasCustomAnchor(true), []);
  const onCustomAnchorRemove = React.useCallback(() => setHasCustomAnchor(false), []);
  const contentId = (0, import_core.useId)();
  const twoSmallerKey = (0, import_get_size.stepTokenUpOrDown)("size", "$true", -2).key;
  const size = `$${twoSmallerKey}`;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_floating.FloatingOverrideContext.Provider, { value: useFloatingContext, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_popper.Popper, { size, ...popperScope, ...restProps, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
    import_popover.__PopoverProviderInternal,
    {
      scope: __scopePopover,
      popperScope: popperScope.__scopePopper,
      contentId,
      triggerRef,
      sheetBreakpoint: false,
      scopeKey: "",
      open,
      onOpenChange: setOpen,
      onOpenToggle: voidFn,
      hasCustomAnchor,
      onCustomAnchorAdd,
      onCustomAnchorRemove,
      children
    }
  ) }) });
});
const Tooltip2 = (0, import_core.withStaticProperties)(TooltipComponent, {
  Anchor: import_popover.PopoverAnchor,
  Arrow: TooltipArrow,
  Content: TooltipContent,
  Trigger: import_popover.PopoverTrigger
});
const voidFn = () => {
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=Tooltip.js.map


/***/ }),

/***/ 11803:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var TooltipSimple_exports = {};
__export(TooltipSimple_exports, {
  TooltipSimple: () => TooltipSimple
});
module.exports = __toCommonJS(TooltipSimple_exports);
var import_jsx_runtime = __webpack_require__(52322);
var import_react = __webpack_require__(67777);
var import_text = __webpack_require__(48175);
var import_Tooltip = __webpack_require__(24037);
const TooltipSimple = ({
  label,
  children,
  contentProps,
  ...tooltipProps
}) => {
  let context;
  try {
    context = (0, import_react.useDelayGroupContext)();
  } catch {
  }
  const contents = /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_Tooltip.Tooltip, { ...tooltipProps, children: [
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_Tooltip.Tooltip.Trigger, { asChild: true, children }),
    /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(
      import_Tooltip.Tooltip.Content,
      {
        zIndex: 1e6,
        enterStyle: { x: 0, y: -8, opacity: 0, scale: 0.93 },
        exitStyle: { x: 0, y: -8, opacity: 0, scale: 0.93 },
        x: 0,
        scale: 1,
        y: 0,
        elevation: "$1",
        opacity: 1,
        animation: [
          "quick",
          {
            opacity: {
              overshootClamping: true
            }
          }
        ],
        ...contentProps,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_Tooltip.Tooltip.Arrow, {}),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_text.Paragraph, { size: "$2", lineHeight: "$0", children: label })
        ]
      }
    )
  ] });
  if (!context) {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_Tooltip.TooltipGroup, { delay: defaultTooltipDelay, children: contents });
  }
  return contents;
};
const defaultTooltipDelay = { open: 3e3, close: 100 };
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=TooltipSimple.js.map


/***/ }),

/***/ 35187:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var src_exports = {};
module.exports = __toCommonJS(src_exports);
__reExport(src_exports, __webpack_require__(24037), module.exports);
__reExport(src_exports, __webpack_require__(11803), module.exports);
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 48600:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var src_exports = {};
__export(src_exports, {
  useConstant: () => useConstant
});
module.exports = __toCommonJS(src_exports);
var import_react = __webpack_require__(2784);
function useConstant(fn) {
  if (typeof document === "undefined") {
    return (0, import_react.useMemo)(() => fn(), []);
  }
  const ref = (0, import_react.useRef)();
  if (!ref.current) {
    ref.current = { v: fn() };
  }
  return ref.current.v;
}
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 12113:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var src_exports = {};
module.exports = __toCommonJS(src_exports);
__reExport(src_exports, __webpack_require__(40500), module.exports);
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 40500:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var useControllableState_exports = {};
__export(useControllableState_exports, {
  useControllableState: () => useControllableState
});
module.exports = __toCommonJS(useControllableState_exports);
var import_use_event = __webpack_require__(36552);
var import_react = __webpack_require__(2784);
const emptyCallbackFn = (_) => _();
function useControllableState({
  prop,
  defaultProp,
  onChange,
  strategy = "prop-wins",
  preventUpdate,
  transition
}) {
  const [state, setState] = (0, import_react.useState)(prop ?? defaultProp);
  const previous = (0, import_react.useRef)(state);
  const propWins = strategy === "prop-wins" && prop !== void 0;
  const value = propWins ? prop : state;
  const onChangeCb = (0, import_use_event.useEvent)(onChange || idFn);
  const transitionFn = transition ? import_react.startTransition : emptyCallbackFn;
  (0, import_react.useEffect)(() => {
    if (prop === void 0)
      return;
    previous.current = prop;
    transitionFn(() => {
      setState(prop);
    });
  }, [prop]);
  (0, import_react.useEffect)(() => {
    if (propWins)
      return;
    if (state !== previous.current) {
      previous.current = state;
      onChangeCb(state);
    }
  }, [onChangeCb, state, propWins]);
  const setter = (0, import_use_event.useEvent)((next) => {
    if (preventUpdate)
      return;
    if (propWins) {
      const nextValue = typeof next === "function" ? next(previous.current) : next;
      onChangeCb(nextValue);
    } else {
      transitionFn(() => {
        setState(next);
      });
    }
  });
  return [value, setter];
}
const idFn = () => {
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=useControllableState.js.map


/***/ }),

/***/ 41439:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ useControllableState; }
/* harmony export */ });
/* harmony import */ var _tamagui_use_event__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41277);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);


const emptyCallbackFn = (_) => _();
function useControllableState({
  prop,
  defaultProp,
  onChange,
  strategy = "prop-wins",
  preventUpdate,
  transition
}) {
  const [state, setState] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(prop ?? defaultProp);
  const previous = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(state);
  const propWins = strategy === "prop-wins" && prop !== void 0;
  const value = propWins ? prop : state;
  const onChangeCb = (0,_tamagui_use_event__WEBPACK_IMPORTED_MODULE_0__/* .useEvent */ .z)(onChange || idFn);
  const transitionFn = transition ? react__WEBPACK_IMPORTED_MODULE_1__.startTransition : emptyCallbackFn;
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    if (prop === void 0)
      return;
    previous.current = prop;
    transitionFn(() => {
      setState(prop);
    });
  }, [prop]);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    if (propWins)
      return;
    if (state !== previous.current) {
      previous.current = state;
      onChangeCb(state);
    }
  }, [onChangeCb, state, propWins]);
  const setter = (0,_tamagui_use_event__WEBPACK_IMPORTED_MODULE_0__/* .useEvent */ .z)((next) => {
    if (preventUpdate)
      return;
    if (propWins) {
      const nextValue = typeof next === "function" ? next(previous.current) : next;
      onChangeCb(nextValue);
    } else {
      transitionFn(() => {
        setState(next);
      });
    }
  });
  return [value, setter];
}
const idFn = () => {
};

//# sourceMappingURL=useControllableState.js.map


/***/ }),

/***/ 29657:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var src_exports = {};
__export(src_exports, {
  debounce: () => debounce,
  useDebounce: () => useDebounce,
  useDebounceValue: () => useDebounceValue
});
module.exports = __toCommonJS(src_exports);
var import_react = __webpack_require__(2784);
function debounce(func, wait, leading) {
  let timeout;
  let isCancelled = false;
  function debounced() {
    isCancelled = false;
    const context = this;
    const args = arguments;
    if (leading && !timeout) {
      func.apply(context, args);
    }
    clearTimeout(timeout);
    timeout = setTimeout(function() {
      timeout = null;
      if (!(leading || isCancelled)) {
        func.apply(context, args);
      }
      isCancelled = false;
    }, wait);
  }
  debounced.cancel = () => {
    isCancelled = true;
  };
  return debounced;
}
const defaultOpts = { leading: false };
function useDebounce(fn, wait, options = defaultOpts, mountArgs = []) {
  const dbEffect = (0, import_react.useRef)(null);
  (0, import_react.useEffect)(() => {
    return () => {
      var _a;
      (_a = dbEffect.current) == null ? void 0 : _a.cancel();
    };
  }, []);
  return (0, import_react.useMemo)(() => {
    dbEffect.current = debounce(fn, wait, options.leading);
    return dbEffect.current;
  }, [options.leading, ...mountArgs]);
}
function useDebounceValue(val, amt = 0) {
  const [state, setState] = (0, import_react.useState)(val);
  (0, import_react.useEffect)(() => {
    const tm = setTimeout(() => {
      setState((prev) => {
        if (prev === val)
          return prev;
        return val;
      });
    }, amt);
    return () => {
      clearTimeout(tm);
    };
  }, [val]);
  return state;
}
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 10498:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var src_exports = {};
module.exports = __toCommonJS(src_exports);
__reExport(src_exports, __webpack_require__(27902), module.exports);
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 27902:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var useDirection_exports = {};
__export(useDirection_exports, {
  DirectionProvider: () => DirectionProvider,
  Provider: () => Provider,
  useDirection: () => useDirection
});
module.exports = __toCommonJS(useDirection_exports);
var import_jsx_runtime = __webpack_require__(52322);
var React = __toESM(__webpack_require__(2784));
const DirectionContext = React.createContext(void 0);
const DirectionProvider = (props) => {
  const { dir, children } = props;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(DirectionContext.Provider, { value: dir, children });
};
function useDirection(localDir) {
  const globalDir = React.useContext(DirectionContext);
  return localDir || globalDir || "ltr";
}
const Provider = DirectionProvider;
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=useDirection.js.map


/***/ }),

/***/ 36552:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var src_exports = {};
module.exports = __toCommonJS(src_exports);
__reExport(src_exports, __webpack_require__(58981), module.exports);
__reExport(src_exports, __webpack_require__(97975), module.exports);
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 58981:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var useEvent_exports = {};
__export(useEvent_exports, {
  useEvent: () => useEvent
});
module.exports = __toCommonJS(useEvent_exports);
var import_useGet = __webpack_require__(97975);
function useEvent(callback) {
  return (0, import_useGet.useGet)(callback, defaultValue, true);
}
const defaultValue = () => {
  throw new Error("Cannot call an event handler while rendering.");
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=useEvent.js.map


/***/ }),

/***/ 97975:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var useGet_exports = {};
__export(useGet_exports, {
  useGet: () => useGet
});
module.exports = __toCommonJS(useGet_exports);
var import_react = __webpack_require__(2784);
const isWeb = "web" === "web";
const isClient = typeof window !== "undefined";
const useIsomorphicLayoutEffect = !isWeb || isClient ? import_react.useLayoutEffect : import_react.useEffect;
function useGet(currentValue, initialValue, forwardToFunction) {
  const curRef = (0, import_react.useRef)(initialValue ?? currentValue);
  useIsomorphicLayoutEffect(() => {
    curRef.current = currentValue;
  });
  return (0, import_react.useCallback)(
    forwardToFunction ? (...args) => {
      var _a;
      return (_a = curRef.current) == null ? void 0 : _a.apply(null, args);
    } : () => curRef.current,
    []
  );
}
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=useGet.js.map


/***/ }),

/***/ 62391:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var src_exports = {};
__export(src_exports, {
  isServerSide: () => isServerSide,
  useForceUpdate: () => useForceUpdate
});
module.exports = __toCommonJS(src_exports);
var import_react = __webpack_require__(2784);
const isServerSide =  true && typeof window === "undefined";
const idFn = () => {
};
function useForceUpdate() {
  return isServerSide ? idFn : (0, import_react.useReducer)((x) => x + 1, 0)[1];
}
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 8897:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var src_exports = {};
__export(src_exports, {
  useKeyboardVisible: () => import_useKeyboardVisible.useKeyboardVisible
});
module.exports = __toCommonJS(src_exports);
var import_useKeyboardVisible = __webpack_require__(57100);
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 57100:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var useKeyboardVisible_exports = {};
__export(useKeyboardVisible_exports, {
  useKeyboardVisible: () => useKeyboardVisible
});
module.exports = __toCommonJS(useKeyboardVisible_exports);
var import_react = __webpack_require__(2784);
var import_react_native = __webpack_require__(22164);
const useKeyboardVisible = () => {
  const [isKeyboardVisible, setKeyboardVisible] = (0, import_react.useState)(false);
  (0, import_react.useEffect)(() => {
    const keyboardDidShowListener = import_react_native.Keyboard.addListener("keyboardDidShow", () => {
      setKeyboardVisible(true);
    });
    const keyboardDidHideListener = import_react_native.Keyboard.addListener("keyboardDidHide", () => {
      setKeyboardVisible(false);
    });
    return () => {
      keyboardDidHideListener.remove();
      keyboardDidShowListener.remove();
    };
  }, []);
  return isKeyboardVisible;
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=useKeyboardVisible.js.map


/***/ }),

/***/ 67409:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var PresenceContext_exports = {};
__export(PresenceContext_exports, {
  PresenceContext: () => PresenceContext
});
module.exports = __toCommonJS(PresenceContext_exports);
var import_react = __webpack_require__(2784);
const PresenceContext = (0, import_react.createContext)(null);
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=PresenceContext.js.map


/***/ }),

/***/ 6185:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var src_exports = {};
module.exports = __toCommonJS(src_exports);
__reExport(src_exports, __webpack_require__(67409), module.exports);
__reExport(src_exports, __webpack_require__(90498), module.exports);
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 90498:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var usePresence_exports = {};
__export(usePresence_exports, {
  isPresent: () => isPresent,
  useIsPresent: () => useIsPresent,
  usePresence: () => usePresence
});
module.exports = __toCommonJS(usePresence_exports);
var import_react = __webpack_require__(2784);
var import_PresenceContext = __webpack_require__(67409);
function usePresence() {
  const context = (0, import_react.useContext)(import_PresenceContext.PresenceContext);
  if (!context) {
    return [true, null, context];
  }
  const { isPresent: isPresent2, onExitComplete, register } = context;
  const id = (0, import_react.useId)() || "";
  (0, import_react.useEffect)(() => register(id), [id, register]);
  const safeToRemove = () => onExitComplete == null ? void 0 : onExitComplete(id);
  return !isPresent2 && onExitComplete ? [false, safeToRemove, context] : [true, void 0, context];
}
function useIsPresent() {
  return isPresent((0, import_react.useContext)(import_PresenceContext.PresenceContext));
}
function isPresent(context) {
  return context === null ? true : context.isPresent;
}
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=usePresence.js.map


/***/ }),

/***/ 88471:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var src_exports = {};
__export(src_exports, {
  useWindowDimensions: () => useWindowDimensions
});
module.exports = __toCommonJS(src_exports);
var import_constants = __webpack_require__(35213);
var import_react = __webpack_require__(2784);
var import_react_native = __webpack_require__(22164);
const initialValue = {
  fontScale: 1,
  height: 800,
  width: 600,
  scale: 1
};
function useWindowDimensions() {
  const current = (0, import_react_native.useWindowDimensions)();
  if (false)
    {}
  const [state, setState] = (0, import_react.useState)(initialValue);
  (0, import_constants.useIsomorphicLayoutEffect)(() => {
    setState(current);
  }, [current.height, current.width, current.fontScale, current.scale]);
  return state;
}
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 14009:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var VisuallyHidden_exports = {};
__export(VisuallyHidden_exports, {
  VisuallyHidden: () => VisuallyHidden
});
module.exports = __toCommonJS(VisuallyHidden_exports);
var import_web = __webpack_require__(44571);
const VisuallyHidden = (0, import_web.styled)(import_web.Stack, {
  position: "absolute",
  width: 1,
  height: 1,
  margin: -1,
  zIndex: -1e4,
  overflow: "hidden",
  opacity: 1e-8,
  pointerEvents: "none",
  variants: {
    preserveDimensions: {
      true: {
        position: "relative",
        width: "auto",
        height: "auto"
      }
    },
    visible: {
      true: {
        position: "relative",
        width: "auto",
        height: "auto",
        margin: 0,
        zIndex: 1,
        overflow: "visible",
        opacity: 1,
        pointerEvents: "auto"
      }
    }
  }
});
VisuallyHidden["isVisuallyHidden"] = true;
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=VisuallyHidden.js.map


/***/ }),

/***/ 87130:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var src_exports = {};
module.exports = __toCommonJS(src_exports);
__reExport(src_exports, __webpack_require__(14009), module.exports);
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 49732:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ry": function() { return /* binding */ hideOthers; }
/* harmony export */ });
/* unused harmony exports inertOthers, supportsInert, suppressOthers */
var getDefaultParent = function (originalTarget) {
    if (typeof document === 'undefined') {
        return null;
    }
    var sampleTarget = Array.isArray(originalTarget) ? originalTarget[0] : originalTarget;
    return sampleTarget.ownerDocument.body;
};
var counterMap = new WeakMap();
var uncontrolledNodes = new WeakMap();
var markerMap = {};
var lockCount = 0;
var unwrapHost = function (node) {
    return node && (node.host || unwrapHost(node.parentNode));
};
var correctTargets = function (parent, targets) {
    return targets
        .map(function (target) {
        if (parent.contains(target)) {
            return target;
        }
        var correctedTarget = unwrapHost(target);
        if (correctedTarget && parent.contains(correctedTarget)) {
            return correctedTarget;
        }
        console.error('aria-hidden', target, 'in not contained inside', parent, '. Doing nothing');
        return null;
    })
        .filter(function (x) { return Boolean(x); });
};
/**
 * Marks everything except given node(or nodes) as aria-hidden
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @param {String} [controlAttribute] - html Attribute to control
 * @return {Undo} undo command
 */
var applyAttributeToOthers = function (originalTarget, parentNode, markerName, controlAttribute) {
    var targets = correctTargets(parentNode, Array.isArray(originalTarget) ? originalTarget : [originalTarget]);
    if (!markerMap[markerName]) {
        markerMap[markerName] = new WeakMap();
    }
    var markerCounter = markerMap[markerName];
    var hiddenNodes = [];
    var elementsToKeep = new Set();
    var elementsToStop = new Set(targets);
    var keep = function (el) {
        if (!el || elementsToKeep.has(el)) {
            return;
        }
        elementsToKeep.add(el);
        keep(el.parentNode);
    };
    targets.forEach(keep);
    var deep = function (parent) {
        if (!parent || elementsToStop.has(parent)) {
            return;
        }
        Array.prototype.forEach.call(parent.children, function (node) {
            if (elementsToKeep.has(node)) {
                deep(node);
            }
            else {
                var attr = node.getAttribute(controlAttribute);
                var alreadyHidden = attr !== null && attr !== 'false';
                var counterValue = (counterMap.get(node) || 0) + 1;
                var markerValue = (markerCounter.get(node) || 0) + 1;
                counterMap.set(node, counterValue);
                markerCounter.set(node, markerValue);
                hiddenNodes.push(node);
                if (counterValue === 1 && alreadyHidden) {
                    uncontrolledNodes.set(node, true);
                }
                if (markerValue === 1) {
                    node.setAttribute(markerName, 'true');
                }
                if (!alreadyHidden) {
                    node.setAttribute(controlAttribute, 'true');
                }
            }
        });
    };
    deep(parentNode);
    elementsToKeep.clear();
    lockCount++;
    return function () {
        hiddenNodes.forEach(function (node) {
            var counterValue = counterMap.get(node) - 1;
            var markerValue = markerCounter.get(node) - 1;
            counterMap.set(node, counterValue);
            markerCounter.set(node, markerValue);
            if (!counterValue) {
                if (!uncontrolledNodes.has(node)) {
                    node.removeAttribute(controlAttribute);
                }
                uncontrolledNodes.delete(node);
            }
            if (!markerValue) {
                node.removeAttribute(markerName);
            }
        });
        lockCount--;
        if (!lockCount) {
            // clear
            counterMap = new WeakMap();
            counterMap = new WeakMap();
            uncontrolledNodes = new WeakMap();
            markerMap = {};
        }
    };
};
/**
 * Marks everything except given node(or nodes) as aria-hidden
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @return {Undo} undo command
 */
var hideOthers = function (originalTarget, parentNode, markerName) {
    if (markerName === void 0) { markerName = 'data-aria-hidden'; }
    var targets = Array.from(Array.isArray(originalTarget) ? originalTarget : [originalTarget]);
    var activeParentNode = parentNode || getDefaultParent(originalTarget);
    if (!activeParentNode) {
        return function () { return null; };
    }
    // we should not hide ariaLive elements - https://github.com/theKashey/aria-hidden/issues/10
    targets.push.apply(targets, Array.from(activeParentNode.querySelectorAll('[aria-live]')));
    return applyAttributeToOthers(targets, activeParentNode, markerName, 'aria-hidden');
};
/**
 * Marks everything except given node(or nodes) as inert
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @return {Undo} undo command
 */
var inertOthers = function (originalTarget, parentNode, markerName) {
    if (markerName === void 0) { markerName = 'data-inert-ed'; }
    var activeParentNode = parentNode || getDefaultParent(originalTarget);
    if (!activeParentNode) {
        return function () { return null; };
    }
    return applyAttributeToOthers(originalTarget, activeParentNode, markerName, 'inert');
};
/**
 * @returns if current browser supports inert
 */
var supportsInert = function () {
    return typeof HTMLElement !== 'undefined' && HTMLElement.prototype.hasOwnProperty('inert');
};
/**
 * Automatic function to "suppress" DOM elements - _hide_ or _inert_ in the best possible way
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @return {Undo} undo command
 */
var suppressOthers = function (originalTarget, parentNode, markerName) {
    if (markerName === void 0) { markerName = 'data-suppressed'; }
    return (supportsInert() ? inertOthers : hideOthers)(originalTarget, parentNode, markerName);
};


/***/ }),

/***/ 15592:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(4079);

// -- Inlined from fbjs --

var emptyObject = {};

if (false) {}

var validateFormat = function validateFormat(format) {};

if (false) {}

function _invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

var warning = function(){};

if (false) { var printWarning; }

// /-- Inlined from fbjs --

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillMount`.
     *
     * @optional
     */
    UNSAFE_componentWillMount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillReceiveProps`.
     *
     * @optional
     */
    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillUpdate`.
     *
     * @optional
     */
    UNSAFE_componentWillUpdate: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Similar to ReactClassInterface but for static methods.
   */
  var ReactClassStaticInterface = {
    /**
     * This method is invoked after a component is instantiated and when it
     * receives new props. Return an object to update state in response to
     * prop changes. Return null to indicate no change to state.
     *
     * If an object is returned, its keys will be merged into the existing state.
     *
     * @return {object || null}
     * @optional
     */
    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {}
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {}
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {}
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {}
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) { var isMixinValid, typeofSpec; }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {}
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }

    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isAlreadyDefined = name in Constructor;
      if (isAlreadyDefined) {
        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
          ? ReactClassStaticInterface[name]
          : null;

        _invariant(
          specPolicy === 'DEFINE_MANY_MERGED',
          'ReactClass: You are attempting to define ' +
            '`%s` on your component more than once. This conflict may be ' +
            'due to a mixin.',
          name
        );

        Constructor[name] = createMergedResultFunction(Constructor[name], property);

        return;
      }

      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) { var _bind, componentName; }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {}
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {}

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {}
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {}

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {}

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),

/***/ 58335:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var React = __webpack_require__(2784);
var factory = __webpack_require__(15592);

if (typeof React === 'undefined') {
  throw Error(
    'create-react-class could not find the React object. If you are using script tags, ' +
      'make sure that React is being loaded before create-react-class.'
  );
}

// Hack to grab NoopUpdateQueue from isomorphic React
var ReactNoopUpdateQueue = new React.Component().updater;

module.exports = factory(
  React.Component,
  React.isValidElement,
  ReactNoopUpdateQueue
);


/***/ }),

/***/ 38076:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "assignStyle": function() { return /* reexport */ assignStyle; },
  "camelCaseProperty": function() { return /* reexport */ camelCaseProperty; },
  "cssifyDeclaration": function() { return /* reexport */ cssifyDeclaration; },
  "cssifyObject": function() { return /* reexport */ cssifyObject; },
  "hyphenateProperty": function() { return /* reexport */ hyphenateProperty; },
  "isPrefixedProperty": function() { return /* reexport */ isPrefixedProperty; },
  "isPrefixedValue": function() { return /* reexport */ isPrefixedValue; },
  "isUnitlessProperty": function() { return /* reexport */ isUnitlessProperty; },
  "normalizeProperty": function() { return /* reexport */ normalizeProperty; },
  "resolveArrayValue": function() { return /* reexport */ resolveArrayValue; },
  "unprefixProperty": function() { return /* reexport */ unprefixProperty; },
  "unprefixValue": function() { return /* reexport */ unprefixValue; }
});

;// CONCATENATED MODULE: ../../node_modules/css-in-js-utils/es/assignStyle.js
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function filterUniqueArray(arr) {
  return arr.filter(function (val, index) {
    return arr.lastIndexOf(val) === index;
  });
}

function assignStyle(base) {
  for (var i = 0, len = arguments.length <= 1 ? 0 : arguments.length - 1; i < len; ++i) {
    var style = i + 1 < 1 || arguments.length <= i + 1 ? undefined : arguments[i + 1];

    for (var property in style) {
      var value = style[property];
      var baseValue = base[property];

      if (baseValue && value) {
        if (Array.isArray(baseValue)) {
          base[property] = filterUniqueArray(baseValue.concat(value));
          continue;
        }

        if (Array.isArray(value)) {
          base[property] = filterUniqueArray([baseValue].concat(_toConsumableArray(value)));
          continue;
        }

        if (_typeof(value) === 'object') {
          base[property] = assignStyle({}, baseValue, value);
          continue;
        }
      }

      base[property] = value;
    }
  }

  return base;
}
;// CONCATENATED MODULE: ../../node_modules/css-in-js-utils/es/camelCaseProperty.js
var DASH = /-([a-z])/g;
var MS = /^Ms/g;
var cache = {};

function toUpper(match) {
  return match[1].toUpperCase();
}

function camelCaseProperty(property) {
  if (cache.hasOwnProperty(property)) {
    return cache[property];
  }

  var camelProp = property.replace(DASH, toUpper).replace(MS, 'ms');
  cache[property] = camelProp;
  return camelProp;
}
// EXTERNAL MODULE: ../../node_modules/hyphenate-style-name/index.js
var hyphenate_style_name = __webpack_require__(23603);
;// CONCATENATED MODULE: ../../node_modules/css-in-js-utils/es/hyphenateProperty.js

function hyphenateProperty(property) {
  return (0,hyphenate_style_name["default"])(property);
}
;// CONCATENATED MODULE: ../../node_modules/css-in-js-utils/es/cssifyDeclaration.js

function cssifyDeclaration(property, value) {
  return hyphenateProperty(property) + ':' + value;
}
;// CONCATENATED MODULE: ../../node_modules/css-in-js-utils/es/cssifyObject.js

function cssifyObject(style) {
  var css = '';

  for (var property in style) {
    var value = style[property];

    if (typeof value !== 'string' && typeof value !== 'number') {
      continue;
    } // prevents the semicolon after
    // the last rule declaration


    if (css) {
      css += ';';
    }

    css += cssifyDeclaration(property, value);
  }

  return css;
}
;// CONCATENATED MODULE: ../../node_modules/css-in-js-utils/es/isPrefixedProperty.js
var RE = /^(Webkit|Moz|O|ms)/;
function isPrefixedProperty(property) {
  return RE.test(property);
}
;// CONCATENATED MODULE: ../../node_modules/css-in-js-utils/es/isPrefixedValue.js
var isPrefixedValue_RE = /-webkit-|-moz-|-ms-/;
function isPrefixedValue(value) {
  return typeof value === 'string' && isPrefixedValue_RE.test(value);
}
;// CONCATENATED MODULE: ../../node_modules/css-in-js-utils/es/isUnitlessProperty.js

var unitlessProperties = {
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  fontWeight: true,
  lineHeight: true,
  opacity: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,
  // SVG-related properties
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true
};
var prefixedUnitlessProperties = ['animationIterationCount', 'boxFlex', 'boxFlexGroup', 'boxOrdinalGroup', 'columnCount', 'flex', 'flexGrow', 'flexPositive', 'flexShrink', 'flexNegative', 'flexOrder', 'gridColumn', 'gridColumnEnd', 'gridColumnStart', 'gridRow', 'gridRowEnd', 'gridRowStart', 'lineClamp', 'order'];
var prefixes = ['Webkit', 'ms', 'Moz', 'O'];

function getPrefixedProperty(prefix, property) {
  return prefix + property.charAt(0).toUpperCase() + property.slice(1);
} // add all prefixed properties to the unitless properties


for (var i = 0, len = prefixedUnitlessProperties.length; i < len; ++i) {
  var property = prefixedUnitlessProperties[i];
  unitlessProperties[property] = true;

  for (var j = 0, jLen = prefixes.length; j < jLen; ++j) {
    unitlessProperties[getPrefixedProperty(prefixes[j], property)] = true;
  }
} // add all hypenated properties as well


for (var _property in unitlessProperties) {
  unitlessProperties[hyphenateProperty(_property)] = true;
}

function isUnitlessProperty(property) {
  return unitlessProperties.hasOwnProperty(property);
}
;// CONCATENATED MODULE: ../../node_modules/css-in-js-utils/es/unprefixProperty.js
var unprefixProperty_RE = /^(ms|Webkit|Moz|O)/;
function unprefixProperty(property) {
  var propertyWithoutPrefix = property.replace(unprefixProperty_RE, '');
  return propertyWithoutPrefix.charAt(0).toLowerCase() + propertyWithoutPrefix.slice(1);
}
;// CONCATENATED MODULE: ../../node_modules/css-in-js-utils/es/normalizeProperty.js


function normalizeProperty(property) {
  return unprefixProperty(camelCaseProperty(property));
}
;// CONCATENATED MODULE: ../../node_modules/css-in-js-utils/es/resolveArrayValue.js

function resolveArrayValue(property, value) {
  return value.join(';' + hyphenateProperty(property) + ':');
}
;// CONCATENATED MODULE: ../../node_modules/css-in-js-utils/es/unprefixValue.js
var unprefixValue_RE = /(-ms-|-webkit-|-moz-|-o-)/g;
function unprefixValue(value) {
  if (typeof value === 'string') {
    return value.replace(unprefixValue_RE, '');
  }

  return value;
}
;// CONCATENATED MODULE: ../../node_modules/css-in-js-utils/es/index.js














/***/ }),

/***/ 39977:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = hyphenateProperty;

var _hyphenateStyleName = __webpack_require__(23603);

var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function hyphenateProperty(property) {
  return (0, _hyphenateStyleName2["default"])(property);
}

/***/ }),

/***/ 36793:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isPrefixedValue;
var RE = /-webkit-|-moz-|-ms-/;

function isPrefixedValue(value) {
  return typeof value === 'string' && RE.test(value);
}

/***/ }),

/***/ 87201:
/***/ (function(module) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */
function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}
/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */


var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);

emptyFunction.thatReturnsThis = function () {
  return this;
};

emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),

/***/ 14983:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


var validateFormat =  false ? 0 : function (format) {};
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments to provide
 * information about what broke and what you were expecting.
 *
 * The invariant message will be stripped in production, but the invariant will
 * remain to ensure logic does not differ in production.
 */

function invariant(condition, format) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  validateFormat(format);

  if (!condition) {
    var error;

    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return String(args[argIndex++]);
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // Skip invariant's own stack frame.

    throw error;
  }
}

module.exports = invariant;

/***/ }),

/***/ 26590:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */


var emptyFunction = __webpack_require__(87201);
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */


function printWarning(format) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  var argIndex = 0;
  var message = 'Warning: ' + format.replace(/%s/g, function () {
    return args[argIndex++];
  });

  if (typeof console !== 'undefined') {
    console.error(message);
  }

  try {
    // --- Welcome to debugging React ---
    // This error was thrown as a convenience so that you can use this stack
    // to find the callsite that caused this warning to fire.
    throw new Error(message);
  } catch (x) {}
}

var warning =  false ? 0 : emptyFunction;
module.exports = warning;

/***/ }),

/***/ 23603:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* eslint-disable no-var, prefer-template */
var uppercasePattern = /[A-Z]/g
var msPattern = /^ms-/
var cache = {}

function toHyphenLower(match) {
  return '-' + match.toLowerCase()
}

function hyphenateStyleName(name) {
  if (cache.hasOwnProperty(name)) {
    return cache[name]
  }

  var hName = name.replace(uppercasePattern, toHyphenLower)
  return (cache[name] = msPattern.test(hName) ? '-' + hName : hName)
}

/* harmony default export */ __webpack_exports__["default"] = (hyphenateStyleName);


/***/ }),

/***/ 35970:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
exports.Z = createPrefixer;

var _prefixProperty = __webpack_require__(28030);

var _prefixProperty2 = _interopRequireDefault(_prefixProperty);

var _prefixValue = __webpack_require__(30288);

var _prefixValue2 = _interopRequireDefault(_prefixValue);

var _addNewValuesOnly = __webpack_require__(69584);

var _addNewValuesOnly2 = _interopRequireDefault(_addNewValuesOnly);

var _isObject = __webpack_require__(799);

var _isObject2 = _interopRequireDefault(_isObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createPrefixer(_ref) {
  var prefixMap = _ref.prefixMap,
      plugins = _ref.plugins;

  return function prefix(style) {
    for (var property in style) {
      var value = style[property];

      // handle nested objects
      if ((0, _isObject2.default)(value)) {
        style[property] = prefix(value);
        // handle array values
      } else if (Array.isArray(value)) {
        var combinedValue = [];

        for (var i = 0, len = value.length; i < len; ++i) {
          var processedValue = (0, _prefixValue2.default)(plugins, property, value[i], style, prefixMap);

          (0, _addNewValuesOnly2.default)(combinedValue, processedValue || value[i]);
        }

        // only modify the value if it was touched
        // by any plugin to prevent unnecessary mutations
        if (combinedValue.length > 0) {
          style[property] = combinedValue;
        }
      } else {
        var _processedValue = (0, _prefixValue2.default)(plugins, property, value, style, prefixMap);

        // only modify the value if it was touched
        // by any plugin to prevent unnecessary mutations
        if (_processedValue) {
          style[property] = _processedValue;
        }

        style = (0, _prefixProperty2.default)(prefixMap, property, style);
      }
    }

    return style;
  };
}

/***/ }),

/***/ 62204:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
exports.Z = backgroundClip;
function backgroundClip() {
  return null;
}

/***/ }),

/***/ 19629:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
exports.Z = crossFade;

var _cssInJsUtils = __webpack_require__(38076);

var CROSS_FADE_REGEX = /cross-fade\(/g;
// http://caniuse.com/#search=cross-fade
var prefixes = ['-webkit-', ''];

function crossFade(property, value) {
  if (typeof value === 'string' && !(0, _cssInJsUtils.isPrefixedValue)(value) && value.indexOf('cross-fade(') !== -1) {
    return prefixes.map(function (prefix) {
      return value.replace(CROSS_FADE_REGEX, prefix + 'cross-fade(');
    });
  }
}

/***/ }),

/***/ 9270:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
exports.Z = cursor;
var prefixes = ['-webkit-', '-moz-', ''];

var values = {
  'zoom-in': true,
  'zoom-out': true,
  grab: true,
  grabbing: true
};

function cursor(property, value) {
  if (property === 'cursor' && values.hasOwnProperty(value)) {
    return prefixes.map(function (prefix) {
      return prefix + value;
    });
  }
}

/***/ }),

/***/ 69528:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
exports.Z = filter;

var _cssInJsUtils = __webpack_require__(38076);

var FILTER_REGEX = /filter\(/g;
// http://caniuse.com/#feat=css-filter-function
var prefixes = ['-webkit-', ''];

function filter(property, value) {
  if (typeof value === 'string' && !(0, _cssInJsUtils.isPrefixedValue)(value) && value.indexOf('filter(') !== -1) {
    return prefixes.map(function (prefix) {
      return value.replace(FILTER_REGEX, prefix + 'filter(');
    });
  }
}

/***/ }),

/***/ 10876:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
exports.Z = imageSet;

var _isPrefixedValue = __webpack_require__(36793);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// http://caniuse.com/#feat=css-image-set
var prefixes = ['-webkit-', ''];

function imageSet(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('image-set(') > -1) {
    return prefixes.map(function (prefix) {
      return value.replace(/image-set\(/g, prefix + 'image-set(');
    });
  }
}

/***/ }),

/***/ 14819:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
exports.Z = logical;
var alternativeProps = {
  marginBlockStart: ['WebkitMarginBefore'],
  marginBlockEnd: ['WebkitMarginAfter'],
  marginInlineStart: ['WebkitMarginStart', 'MozMarginStart'],
  marginInlineEnd: ['WebkitMarginEnd', 'MozMarginEnd'],
  paddingBlockStart: ['WebkitPaddingBefore'],
  paddingBlockEnd: ['WebkitPaddingAfter'],
  paddingInlineStart: ['WebkitPaddingStart', 'MozPaddingStart'],
  paddingInlineEnd: ['WebkitPaddingEnd', 'MozPaddingEnd'],
  borderBlockStart: ['WebkitBorderBefore'],
  borderBlockStartColor: ['WebkitBorderBeforeColor'],
  borderBlockStartStyle: ['WebkitBorderBeforeStyle'],
  borderBlockStartWidth: ['WebkitBorderBeforeWidth'],
  borderBlockEnd: ['WebkitBorderAfter'],
  borderBlockEndColor: ['WebkitBorderAfterColor'],
  borderBlockEndStyle: ['WebkitBorderAfterStyle'],
  borderBlockEndWidth: ['WebkitBorderAfterWidth'],
  borderInlineStart: ['WebkitBorderStart', 'MozBorderStart'],
  borderInlineStartColor: ['WebkitBorderStartColor', 'MozBorderStartColor'],
  borderInlineStartStyle: ['WebkitBorderStartStyle', 'MozBorderStartStyle'],
  borderInlineStartWidth: ['WebkitBorderStartWidth', 'MozBorderStartWidth'],
  borderInlineEnd: ['WebkitBorderEnd', 'MozBorderEnd'],
  borderInlineEndColor: ['WebkitBorderEndColor', 'MozBorderEndColor'],
  borderInlineEndStyle: ['WebkitBorderEndStyle', 'MozBorderEndStyle'],
  borderInlineEndWidth: ['WebkitBorderEndWidth', 'MozBorderEndWidth']
};

function logical(property, value, style) {
  if (Object.prototype.hasOwnProperty.call(alternativeProps, property)) {
    var alternativePropList = alternativeProps[property];
    for (var i = 0, len = alternativePropList.length; i < len; ++i) {
      style[alternativePropList[i]] = value;
    }
  }
}

/***/ }),

/***/ 38572:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
exports.Z = position;
function position(property, value) {
  if (property === 'position' && value === 'sticky') {
    return ['-webkit-sticky', 'sticky'];
  }
}

/***/ }),

/***/ 70300:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
exports.Z = sizing;
var prefixes = ['-webkit-', '-moz-', ''];

var properties = {
  maxHeight: true,
  maxWidth: true,
  width: true,
  height: true,
  columnWidth: true,
  minWidth: true,
  minHeight: true
};
var values = {
  'min-content': true,
  'max-content': true,
  'fill-available': true,
  'fit-content': true,
  'contain-floats': true
};

function sizing(property, value) {
  if (properties.hasOwnProperty(property) && values.hasOwnProperty(value)) {
    return prefixes.map(function (prefix) {
      return prefix + value;
    });
  }
}

/***/ }),

/***/ 63132:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
exports.Z = transition;

var _hyphenateProperty = __webpack_require__(39977);

var _hyphenateProperty2 = _interopRequireDefault(_hyphenateProperty);

var _isPrefixedValue = __webpack_require__(36793);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

var _capitalizeString = __webpack_require__(16135);

var _capitalizeString2 = _interopRequireDefault(_capitalizeString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var properties = {
  transition: true,
  transitionProperty: true,
  WebkitTransition: true,
  WebkitTransitionProperty: true,
  MozTransition: true,
  MozTransitionProperty: true
};

var prefixMapping = {
  Webkit: '-webkit-',
  Moz: '-moz-',
  ms: '-ms-'
};

function prefixValue(value, propertyPrefixMap) {
  if ((0, _isPrefixedValue2.default)(value)) {
    return value;
  }

  // only split multi values, not cubic beziers
  var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);

  for (var i = 0, len = multipleValues.length; i < len; ++i) {
    var singleValue = multipleValues[i];
    var values = [singleValue];
    for (var property in propertyPrefixMap) {
      var dashCaseProperty = (0, _hyphenateProperty2.default)(property);

      if (singleValue.indexOf(dashCaseProperty) > -1 && dashCaseProperty !== 'order') {
        var prefixes = propertyPrefixMap[property];
        for (var j = 0, pLen = prefixes.length; j < pLen; ++j) {
          // join all prefixes and create a new value
          values.unshift(singleValue.replace(dashCaseProperty, prefixMapping[prefixes[j]] + dashCaseProperty));
        }
      }
    }

    multipleValues[i] = values.join(',');
  }

  return multipleValues.join(',');
}

function transition(property, value, style, propertyPrefixMap) {
  // also check for already prefixed transitions
  if (typeof value === 'string' && properties.hasOwnProperty(property)) {
    var outputValue = prefixValue(value, propertyPrefixMap);
    // if the property is already prefixed
    var webkitOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
      return !/-moz-|-ms-/.test(val);
    }).join(',');

    if (property.indexOf('Webkit') > -1) {
      return webkitOutput;
    }

    var mozOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
      return !/-webkit-|-ms-/.test(val);
    }).join(',');

    if (property.indexOf('Moz') > -1) {
      return mozOutput;
    }

    style['Webkit' + (0, _capitalizeString2.default)(property)] = webkitOutput;
    style['Moz' + (0, _capitalizeString2.default)(property)] = mozOutput;
    return outputValue;
  }
}

/***/ }),

/***/ 69584:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = addNewValuesOnly;
function addIfNew(list, value) {
  if (list.indexOf(value) === -1) {
    list.push(value);
  }
}

function addNewValuesOnly(list, values) {
  if (Array.isArray(values)) {
    for (var i = 0, len = values.length; i < len; ++i) {
      addIfNew(list, values[i]);
    }
  } else {
    addIfNew(list, values);
  }
}

/***/ }),

/***/ 16135:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = capitalizeString;
function capitalizeString(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

/***/ }),

/***/ 799:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isObject;
function isObject(value) {
  return value instanceof Object && !Array.isArray(value);
}

/***/ }),

/***/ 28030:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = prefixProperty;

var _capitalizeString = __webpack_require__(16135);

var _capitalizeString2 = _interopRequireDefault(_capitalizeString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function prefixProperty(prefixProperties, property, style) {
  var requiredPrefixes = prefixProperties[property];

  if (requiredPrefixes && style.hasOwnProperty(property)) {
    var capitalizedProperty = (0, _capitalizeString2.default)(property);

    for (var i = 0; i < requiredPrefixes.length; ++i) {
      var prefixedProperty = requiredPrefixes[i] + capitalizedProperty;

      if (!style[prefixedProperty]) {
        style[prefixedProperty] = style[property];
      }
    }
  }

  return style;
}

/***/ }),

/***/ 30288:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = prefixValue;
function prefixValue(plugins, property, value, style, metaData) {
  for (var i = 0, len = plugins.length; i < len; ++i) {
    var processedValue = plugins[i](property, value, style, metaData);

    // we can stop processing if a value is returned
    // as all plugin criteria are unique
    if (processedValue) {
      return processedValue;
    }
  }
}

/***/ }),

/***/ 4079:
/***/ (function(module) {

"use strict";

var assign = Object.assign.bind(Object);
module.exports = assign;
module.exports["default"] = module.exports;

//# sourceMappingURL=object-assign.js.map

/***/ }),

/***/ 86570:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(812);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 812:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _app; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./node_modules/@tamagui/core/reset.css
var core_reset = __webpack_require__(34852);
// EXTERNAL MODULE: ../../node_modules/@tamagui/font-fira-mono/css/400.css
var _400 = __webpack_require__(50433);
// EXTERNAL MODULE: ../../node_modules/@tamagui/font-fira-mono/css/800.css
var _800 = __webpack_require__(21772);
// EXTERNAL MODULE: ../../node_modules/raf/polyfill.js
var polyfill = __webpack_require__(98728);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ./node_modules/@tamagui/next-theme/dist/esm/useRootTheme.js


const useRootTheme = () => {
  const [val, setVal] = (0,react.useState)("light");
  if (typeof document !== "undefined") {
    (0,react.useLayoutEffect)(() => {
      const classes = [...document.documentElement.classList];
      const isDark = classes.includes("t_dark");
      react.startTransition(() => {
        setVal(isDark ? "dark" : "light");
      });
    }, []);
  }
  return [val, setVal];
};

//# sourceMappingURL=useRootTheme.js.map

// EXTERNAL MODULE: ./node_modules/@tamagui/use-event/dist/esm/index.mjs + 2 modules
var esm = __webpack_require__(4751);
// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(97729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./node_modules/@tamagui/next-theme/dist/esm/constants.js
const constants = {};
const colorSchemes = ["light", "dark"];
const MEDIA = "(prefers-color-scheme: dark)";

//# sourceMappingURL=constants.js.map

;// CONCATENATED MODULE: ./node_modules/@tamagui/next-theme/dist/esm/helpers.js

const helpers = {};
const getTheme = (key, fallback) => {
  if (typeof window === "undefined")
    return void 0;
  let theme;
  try {
    theme = localStorage.getItem(key) || void 0;
  } catch (e) {
  }
  return theme || fallback;
};
const getSystemTheme = (e) => {
  if (!e) {
    e = window.matchMedia(MEDIA);
  }
  const isDark = e.matches;
  const systemTheme = isDark ? "dark" : "light";
  return systemTheme;
};

//# sourceMappingURL=helpers.js.map

;// CONCATENATED MODULE: ./node_modules/@tamagui/next-theme/dist/esm/ThemeSettingContext.js

const ThemeSettingContext = (0,react.createContext)({
  toggle: () => {
  },
  set: (_) => {
  },
  themes: []
});

//# sourceMappingURL=ThemeSettingContext.js.map

;// CONCATENATED MODULE: ./node_modules/@tamagui/next-theme/dist/esm/useIsomorphicLayoutEffect.js

const useIsomorphicLayoutEffect = typeof window !== "undefined" ? react.useLayoutEffect : react.useEffect;

//# sourceMappingURL=useIsomorphicLayoutEffect.js.map

;// CONCATENATED MODULE: ./node_modules/@tamagui/next-theme/dist/esm/NextThemeProvider.js









const NextThemeProvider = ({
  forcedTheme,
  disableTransitionOnChange = true,
  enableSystem = true,
  enableColorScheme = true,
  storageKey = "theme",
  themes = colorSchemes,
  defaultTheme = enableSystem ? "system" : "light",
  attribute = "class",
  skipNextHead,
  onChangeTheme,
  value = {
    dark: "t_dark",
    light: "t_light"
  },
  children
}) => {
  const [theme, setThemeState] = (0,react.useState)(() => getTheme(storageKey, defaultTheme));
  const [resolvedTheme, setResolvedTheme] = (0,react.useState)(() => getTheme(storageKey));
  const attrs = !value ? themes : Object.values(value);
  const handleMediaQuery = (0,esm/* useEvent */.z)((e) => {
    const systemTheme2 = getSystemTheme(e);
    react.startTransition(() => {
      setResolvedTheme(systemTheme2);
    });
    if (theme === "system" && !forcedTheme) {
      handleChangeTheme(systemTheme2, false);
    }
  });
  const mediaListener = (0,react.useRef)(handleMediaQuery);
  mediaListener.current = handleMediaQuery;
  const handleChangeTheme = (0,esm/* useEvent */.z)((theme2, updateStorage = true, updateDOM = true) => {
    let name = (value == null ? void 0 : value[theme2]) || theme2;
    if (updateStorage) {
      try {
        localStorage.setItem(storageKey, theme2);
      } catch (e) {
      }
    }
    if (theme2 === "system" && enableSystem) {
      const resolved = getSystemTheme();
      name = (value == null ? void 0 : value[resolved]) || resolved;
    }
    onChangeTheme == null ? void 0 : onChangeTheme(name.replace("t_", ""));
    if (updateDOM) {
      const d = document.documentElement;
      if (attribute === "class") {
        d.classList.remove(...attrs);
        d.classList.add(name);
      } else {
        d.setAttribute(attribute, name);
      }
    }
  });
  useIsomorphicLayoutEffect(() => {
    const handler = (...args) => mediaListener.current(...args);
    const media = window.matchMedia(MEDIA);
    media.addListener(handler);
    handler(media);
    return () => {
      media.removeListener(handler);
    };
  }, []);
  const set = (0,esm/* useEvent */.z)((newTheme) => {
    if (forcedTheme) {
      handleChangeTheme(newTheme, true, false);
    } else {
      handleChangeTheme(newTheme);
    }
    setThemeState(newTheme);
  });
  (0,react.useEffect)(() => {
    const handleStorage = (e) => {
      if (e.key !== storageKey) {
        return;
      }
      const theme2 = e.newValue || defaultTheme;
      set(theme2);
    };
    window.addEventListener("storage", handleStorage);
    return () => {
      window.removeEventListener("storage", handleStorage);
    };
  }, [defaultTheme, set, storageKey]);
  useIsomorphicLayoutEffect(() => {
    if (!enableColorScheme)
      return;
    const colorScheme = (
      // If theme is forced to light or dark, use that
      forcedTheme && colorSchemes.includes(forcedTheme) ? forcedTheme : (
        // If regular theme is light or dark
        theme && colorSchemes.includes(theme) ? theme : (
          // If theme is system, use the resolved version
          theme === "system" ? resolvedTheme || null : null
        )
      )
    );
    const userPrefers = typeof window !== "undefined" && window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
    const wePrefer = colorScheme || "light";
    if (userPrefers !== wePrefer || wePrefer === "dark") {
      document.documentElement.style.setProperty("color-scheme", colorScheme);
    }
  }, [enableColorScheme, theme, resolvedTheme, forcedTheme]);
  const toggle = (0,esm/* useEvent */.z)(() => {
    const order = resolvedTheme === "dark" ? ["system", "light", "dark"] : ["system", "dark", "light"];
    const next = order[(order.indexOf(theme) + 1) % order.length];
    set(next);
  });
  const contextResolvedTheme = theme === "system" ? resolvedTheme : theme;
  const systemTheme = enableSystem ? resolvedTheme : void 0;
  const contextValue = (0,react.useMemo)(() => {
    const value2 = {
      theme,
      current: theme,
      set,
      toggle,
      forcedTheme,
      resolvedTheme: contextResolvedTheme,
      themes: enableSystem ? [...themes, "system"] : themes,
      systemTheme
    };
    return value2;
  }, [
    theme,
    set,
    toggle,
    forcedTheme,
    contextResolvedTheme,
    enableSystem,
    themes,
    systemTheme
  ]);
  return /* @__PURE__ */ (0,jsx_runtime.jsxs)(ThemeSettingContext.Provider, { value: contextValue, children: [
    /* @__PURE__ */ (0,jsx_runtime.jsx)(
      ThemeScript,
      {
        ...{
          forcedTheme,
          storageKey,
          systemTheme: resolvedTheme,
          attribute,
          value,
          enableSystem,
          defaultTheme,
          attrs,
          skipNextHead
        }
      }
    ),
    (0,react.useMemo)(() => children, [children])
  ] });
};
const ThemeScript = (0,react.memo)(
  ({
    forcedTheme,
    storageKey,
    attribute,
    enableSystem,
    defaultTheme,
    value,
    attrs,
    skipNextHead
  }) => {
    const optimization = (() => {
      if (attribute === "class") {
        const removeClasses = attrs.map((t) => `d.remove('${t}')`).join(";");
        return `var d=document.documentElement.classList;${removeClasses};`;
      } else {
        return `var d=document.documentElement;`;
      }
    })();
    const updateDOM = (name, literal) => {
      name = (value == null ? void 0 : value[name]) || name;
      const val = literal ? name : `'${name}'`;
      if (attribute === "class") {
        return `d.add(${val})`;
      }
      return `d.setAttribute('${attribute}', ${val})`;
    };
    const defaultSystem = defaultTheme === "system";
    const contents = /* @__PURE__ */ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, { children: forcedTheme ? /* @__PURE__ */ (0,jsx_runtime.jsx)(
      "script",
      {
        dangerouslySetInnerHTML: {
          // These are minified via Terser and then updated by hand, don't recommend
          __html: `!function(){${optimization}${updateDOM(forcedTheme)}}()`
        }
      },
      "next-themes-script"
    ) : enableSystem ? /* @__PURE__ */ (0,jsx_runtime.jsx)(
      "script",
      {
        dangerouslySetInnerHTML: {
          __html: `!function(){try {${optimization}var e=localStorage.getItem('${storageKey}');${!defaultSystem ? updateDOM(defaultTheme) + ";" : ""}if("system"===e||(!e&&${defaultSystem})){var t="${MEDIA}",m=window.matchMedia(t);m.media!==t||m.matches?${updateDOM(
            "dark"
          )}:${updateDOM("light")}}else if(e) ${value ? `var x=${JSON.stringify(value)};` : ""}${updateDOM(value ? "x[e]" : "e", true)}}catch(e){}}()`
        }
      },
      "next-themes-script"
    ) : /* @__PURE__ */ (0,jsx_runtime.jsx)(
      "script",
      {
        dangerouslySetInnerHTML: {
          __html: `!function(){try{${optimization}var e=localStorage.getItem("${storageKey}");if(e){${value ? `var x=${JSON.stringify(value)};` : ""}${updateDOM(value ? "x[e]" : "e", true)}}else{${updateDOM(
            defaultTheme
          )};}}catch(t){}}();`
        }
      },
      "next-themes-script"
    ) });
    if (skipNextHead)
      return contents;
    return /* @__PURE__ */ (0,jsx_runtime.jsx)((head_default()), { children: contents });
  },
  (prevProps, nextProps) => {
    if (prevProps.forcedTheme !== nextProps.forcedTheme)
      return false;
    return true;
  }
);

//# sourceMappingURL=NextThemeProvider.js.map

;// CONCATENATED MODULE: ../../node_modules/next-seo/lib/next-seo.module.js



function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

var _excluded$x = ["keyOverride"];
var defaults = {
  templateTitle: '',
  noindex: false,
  nofollow: false,
  defaultOpenGraphImageWidth: 0,
  defaultOpenGraphImageHeight: 0,
  defaultOpenGraphVideoWidth: 0,
  defaultOpenGraphVideoHeight: 0
};
var buildOpenGraphMediaTags = function buildOpenGraphMediaTags(mediaType, media, _temp) {
  if (media === void 0) {
    media = [];
  }
  var _ref = _temp === void 0 ? {} : _temp,
    defaultWidth = _ref.defaultWidth,
    defaultHeight = _ref.defaultHeight;
  return media.reduce(function (tags, medium, index) {
    tags.push( /*#__PURE__*/react.createElement("meta", {
      key: "og:" + mediaType + ":0" + index,
      property: "og:" + mediaType,
      content: medium.url
    }));
    if (medium.alt) {
      tags.push( /*#__PURE__*/react.createElement("meta", {
        key: "og:" + mediaType + ":alt0" + index,
        property: "og:" + mediaType + ":alt",
        content: medium.alt
      }));
    }
    if (medium.secureUrl) {
      tags.push( /*#__PURE__*/react.createElement("meta", {
        key: "og:" + mediaType + ":secure_url0" + index,
        property: "og:" + mediaType + ":secure_url",
        content: medium.secureUrl.toString()
      }));
    }
    if (medium.type) {
      tags.push( /*#__PURE__*/react.createElement("meta", {
        key: "og:" + mediaType + ":type0" + index,
        property: "og:" + mediaType + ":type",
        content: medium.type.toString()
      }));
    }
    if (medium.width) {
      tags.push( /*#__PURE__*/react.createElement("meta", {
        key: "og:" + mediaType + ":width0" + index,
        property: "og:" + mediaType + ":width",
        content: medium.width.toString()
      }));
    } else if (defaultWidth) {
      tags.push( /*#__PURE__*/react.createElement("meta", {
        key: "og:" + mediaType + ":width0" + index,
        property: "og:" + mediaType + ":width",
        content: defaultWidth.toString()
      }));
    }
    if (medium.height) {
      tags.push( /*#__PURE__*/react.createElement("meta", {
        key: "og:" + mediaType + ":height" + index,
        property: "og:" + mediaType + ":height",
        content: medium.height.toString()
      }));
    } else if (defaultHeight) {
      tags.push( /*#__PURE__*/react.createElement("meta", {
        key: "og:" + mediaType + ":height" + index,
        property: "og:" + mediaType + ":height",
        content: defaultHeight.toString()
      }));
    }
    return tags;
  }, []);
};
var buildTags = function buildTags(config) {
  var _config$openGraph, _config$openGraph3, _config$additionalLin;
  var tagsToRender = [];
  if (config.titleTemplate) {
    defaults.templateTitle = config.titleTemplate;
  }
  var updatedTitle = '';
  if (config.title) {
    updatedTitle = config.title;
    if (defaults.templateTitle) {
      updatedTitle = defaults.templateTitle.replace(/%s/g, function () {
        return updatedTitle;
      });
    }
  } else if (config.defaultTitle) {
    updatedTitle = config.defaultTitle;
  }
  if (updatedTitle) {
    tagsToRender.push( /*#__PURE__*/react.createElement("title", {
      key: "title"
    }, updatedTitle));
  }
  var noindex = config.noindex || defaults.noindex || config.dangerouslySetAllPagesToNoIndex;
  var nofollow = config.nofollow || defaults.nofollow || config.dangerouslySetAllPagesToNoFollow;
  var robotsParams = '';
  if (config.robotsProps) {
    var _config$robotsProps = config.robotsProps,
      nosnippet = _config$robotsProps.nosnippet,
      maxSnippet = _config$robotsProps.maxSnippet,
      maxImagePreview = _config$robotsProps.maxImagePreview,
      maxVideoPreview = _config$robotsProps.maxVideoPreview,
      noarchive = _config$robotsProps.noarchive,
      noimageindex = _config$robotsProps.noimageindex,
      notranslate = _config$robotsProps.notranslate,
      unavailableAfter = _config$robotsProps.unavailableAfter;
    robotsParams = "" + (nosnippet ? ',nosnippet' : '') + (maxSnippet ? ",max-snippet:" + maxSnippet : '') + (maxImagePreview ? ",max-image-preview:" + maxImagePreview : '') + (noarchive ? ',noarchive' : '') + (unavailableAfter ? ",unavailable_after:" + unavailableAfter : '') + (noimageindex ? ',noimageindex' : '') + (maxVideoPreview ? ",max-video-preview:" + maxVideoPreview : '') + (notranslate ? ',notranslate' : '');
  }
  if (noindex || nofollow) {
    if (config.dangerouslySetAllPagesToNoIndex) {
      defaults.noindex = true;
    }
    if (config.dangerouslySetAllPagesToNoFollow) {
      defaults.nofollow = true;
    }
    tagsToRender.push( /*#__PURE__*/react.createElement("meta", {
      key: "robots",
      name: "robots",
      content: (noindex ? 'noindex' : 'index') + "," + (nofollow ? 'nofollow' : 'follow') + robotsParams
    }));
  } else {
    tagsToRender.push( /*#__PURE__*/react.createElement("meta", {
      key: "robots",
      name: "robots",
      content: "index,follow" + robotsParams
    }));
  }
  if (config.description) {
    tagsToRender.push( /*#__PURE__*/react.createElement("meta", {
      key: "description",
      name: "description",
      content: config.description
    }));
  }
  if (config.themeColor) {
    tagsToRender.push( /*#__PURE__*/react.createElement("meta", {
      key: "theme-color",
      name: "theme-color",
      content: config.themeColor
    }));
  }
  if (config.mobileAlternate) {
    tagsToRender.push( /*#__PURE__*/react.createElement("link", {
      rel: "alternate",
      key: "mobileAlternate",
      media: config.mobileAlternate.media,
      href: config.mobileAlternate.href
    }));
  }
  if (config.languageAlternates && config.languageAlternates.length > 0) {
    config.languageAlternates.forEach(function (languageAlternate) {
      tagsToRender.push( /*#__PURE__*/react.createElement("link", {
        rel: "alternate",
        key: "languageAlternate-" + languageAlternate.hrefLang,
        hrefLang: languageAlternate.hrefLang,
        href: languageAlternate.href
      }));
    });
  }
  if (config.twitter) {
    if (config.twitter.cardType) {
      tagsToRender.push( /*#__PURE__*/react.createElement("meta", {
        key: "twitter:card",
        name: "twitter:card",
        content: config.twitter.cardType
      }));
    }
    if (config.twitter.site) {
      tagsToRender.push( /*#__PURE__*/react.createElement("meta", {
        key: "twitter:site",
        name: "twitter:site",
        content: config.twitter.site
      }));
    }
    if (config.twitter.handle) {
      tagsToRender.push( /*#__PURE__*/react.createElement("meta", {
        key: "twitter:creator",
        name: "twitter:creator",
        content: config.twitter.handle
      }));
    }
  }
  if (config.facebook) {
    if (config.facebook.appId) {
      tagsToRender.push( /*#__PURE__*/react.createElement("meta", {
        key: "fb:app_id",
        property: "fb:app_id",
        content: config.facebook.appId
      }));
    }
  }
  if ((_config$openGraph = config.openGraph) != null && _config$openGraph.title || updatedTitle) {
    var _config$openGraph2;
    tagsToRender.push( /*#__PURE__*/react.createElement("meta", {
      key: "og:title",
      property: "og:title",
      content: ((_config$openGraph2 = config.openGraph) == null ? void 0 : _config$openGraph2.title) || updatedTitle
    }));
  }
  if ((_config$openGraph3 = config.openGraph) != null && _config$openGraph3.description || config.description) {
    var _config$openGraph4;
    tagsToRender.push( /*#__PURE__*/react.createElement("meta", {
      key: "og:description",
      property: "og:description",
      content: ((_config$openGraph4 = config.openGraph) == null ? void 0 : _config$openGraph4.description) || config.description
    }));
  }
  if (config.openGraph) {
    if (config.openGraph.url || config.canonical) {
      tagsToRender.push( /*#__PURE__*/react.createElement("meta", {
        key: "og:url",
        property: "og:url",
        content: config.openGraph.url || config.canonical
      }));
    }
    if (config.openGraph.type) {
      var type = config.openGraph.type.toLowerCase();
      tagsToRender.push( /*#__PURE__*/react.createElement("meta", {
        key: "og:type",
        property: "og:type",
        content: type
      }));
      if (type === 'profile' && config.openGraph.profile) {
        if (config.openGraph.profile.firstName) {
          tagsToRender.push( /*#__PURE__*/react.createElement("meta", {
            key: "profile:first_name",
            property: "profile:first_name",
            content: config.openGraph.profile.firstName
          }));
        }
        if (config.openGraph.profile.lastName) {
          tagsToRender.push( /*#__PURE__*/react.createElement("meta", {
            key: "profile:last_name",
            property: "profile:last_name",
            content: config.openGraph.profile.lastName
          }));
        }
        if (config.openGraph.profile.username) {
          tagsToRender.push( /*#__PURE__*/react.createElement("meta", {
            key: "profile:username",
            property: "profile:username",
            content: config.openGraph.profile.username
          }));
        }
        if (config.openGraph.profile.gender) {
          tagsToRender.push( /*#__PURE__*/react.createElement("meta", {
            key: "profile:gender",
            property: "profile:gender",
            content: config.openGraph.profile.gender
          }));
        }
      } else if (type === 'book' && config.openGraph.book) {
        if (config.openGraph.book.authors && config.openGraph.book.authors.length) {
          config.openGraph.book.authors.forEach(function (author, index) {
            tagsToRender.push( /*#__PURE__*/react.createElement("meta", {
              key: "book:author:0" + index,
              property: "book:author",
              content: author
            }));
          });
        }
        if (config.openGraph.book.isbn) {
          tagsToRender.push( /*#__PURE__*/react.createElement("meta", {
            key: "book:isbn",
            property: "book:isbn",
            content: config.openGraph.book.isbn
          }));
        }
        if (config.openGraph.book.releaseDate) {
          tagsToRender.push( /*#__PURE__*/react.createElement("meta", {
            key: "book:release_date",
            property: "book:release_date",
            content: config.openGraph.book.releaseDate
          }));
        }
        if (config.openGraph.book.tags && config.openGraph.book.tags.length) {
          config.openGraph.book.tags.forEach(function (tag, index) {
            tagsToRender.push( /*#__PURE__*/react.createElement("meta", {
              key: "book:tag:0" + index,
              property: "book:tag",
              content: tag
            }));
          });
        }
      } else if (type === 'article' && config.openGraph.article) {
        if (config.openGraph.article.publishedTime) {
          tagsToRender.push( /*#__PURE__*/react.createElement("meta", {
            key: "article:published_time",
            property: "article:published_time",
            content: config.openGraph.article.publishedTime
          }));
        }
        if (config.openGraph.article.modifiedTime) {
          tagsToRender.push( /*#__PURE__*/react.createElement("meta", {
            key: "article:modified_time",
            property: "article:modified_time",
            content: config.openGraph.article.modifiedTime
          }));
        }
        if (config.openGraph.article.expirationTime) {
          tagsToRender.push( /*#__PURE__*/react.createElement("meta", {
            key: "article:expiration_time",
            property: "article:expiration_time",
            content: config.openGraph.article.expirationTime
          }));
        }
        if (config.openGraph.article.authors && config.openGraph.article.authors.length) {
          config.openGraph.article.authors.forEach(function (author, index) {
            tagsToRender.push( /*#__PURE__*/react.createElement("meta", {
              key: "article:author:0" + index,
              property: "article:author",
              content: author
            }));
          });
        }
        if (config.openGraph.article.section) {
          tagsToRender.push( /*#__PURE__*/react.createElement("meta", {
            key: "article:section",
            property: "article:section",
            content: config.openGraph.article.section
          }));
        }
        if (config.openGraph.article.tags && config.openGraph.article.tags.length) {
          config.openGraph.article.tags.forEach(function (tag, index) {
            tagsToRender.push( /*#__PURE__*/react.createElement("meta", {
              key: "article:tag:0" + index,
              property: "article:tag",
              content: tag
            }));
          });
        }
      } else if ((type === 'video.movie' || type === 'video.episode' || type === 'video.tv_show' || type === 'video.other') && config.openGraph.video) {
        if (config.openGraph.video.actors && config.openGraph.video.actors.length) {
          config.openGraph.video.actors.forEach(function (actor, index) {
            if (actor.profile) {
              tagsToRender.push( /*#__PURE__*/react.createElement("meta", {
                key: "video:actor:0" + index,
                property: "video:actor",
                content: actor.profile
              }));
            }
            if (actor.role) {
              tagsToRender.push( /*#__PURE__*/react.createElement("meta", {
                key: "video:actor:role:0" + index,
                property: "video:actor:role",
                content: actor.role
              }));
            }
          });
        }
        if (config.openGraph.video.directors && config.openGraph.video.directors.length) {
          config.openGraph.video.directors.forEach(function (director, index) {
            tagsToRender.push( /*#__PURE__*/react.createElement("meta", {
              key: "video:director:0" + index,
              property: "video:director",
              content: director
            }));
          });
        }
        if (config.openGraph.video.writers && config.openGraph.video.writers.length) {
          config.openGraph.video.writers.forEach(function (writer, index) {
            tagsToRender.push( /*#__PURE__*/react.createElement("meta", {
              key: "video:writer:0" + index,
              property: "video:writer",
              content: writer
            }));
          });
        }
        if (config.openGraph.video.duration) {
          tagsToRender.push( /*#__PURE__*/react.createElement("meta", {
            key: "video:duration",
            property: "video:duration",
            content: config.openGraph.video.duration.toString()
          }));
        }
        if (config.openGraph.video.releaseDate) {
          tagsToRender.push( /*#__PURE__*/react.createElement("meta", {
            key: "video:release_date",
            property: "video:release_date",
            content: config.openGraph.video.releaseDate
          }));
        }
        if (config.openGraph.video.tags && config.openGraph.video.tags.length) {
          config.openGraph.video.tags.forEach(function (tag, index) {
            tagsToRender.push( /*#__PURE__*/react.createElement("meta", {
              key: "video:tag:0" + index,
              property: "video:tag",
              content: tag
            }));
          });
        }
        if (config.openGraph.video.series) {
          tagsToRender.push( /*#__PURE__*/react.createElement("meta", {
            key: "video:series",
            property: "video:series",
            content: config.openGraph.video.series
          }));
        }
      }
    }
    // images
    if (config.defaultOpenGraphImageWidth) {
      defaults.defaultOpenGraphImageWidth = config.defaultOpenGraphImageWidth;
    }
    if (config.defaultOpenGraphImageHeight) {
      defaults.defaultOpenGraphImageHeight = config.defaultOpenGraphImageHeight;
    }
    if (config.openGraph.images && config.openGraph.images.length) {
      tagsToRender.push.apply(tagsToRender, buildOpenGraphMediaTags('image', config.openGraph.images, {
        defaultWidth: defaults.defaultOpenGraphImageWidth,
        defaultHeight: defaults.defaultOpenGraphImageHeight
      }));
    }
    // videos
    if (config.defaultOpenGraphVideoWidth) {
      defaults.defaultOpenGraphVideoWidth = config.defaultOpenGraphVideoWidth;
    }
    if (config.defaultOpenGraphVideoHeight) {
      defaults.defaultOpenGraphVideoHeight = config.defaultOpenGraphVideoHeight;
    }
    if (config.openGraph.videos && config.openGraph.videos.length) {
      tagsToRender.push.apply(tagsToRender, buildOpenGraphMediaTags('video', config.openGraph.videos, {
        defaultWidth: defaults.defaultOpenGraphVideoWidth,
        defaultHeight: defaults.defaultOpenGraphVideoHeight
      }));
    }
    // audio
    if (config.openGraph.audio) {
      tagsToRender.push.apply(tagsToRender, buildOpenGraphMediaTags('audio', config.openGraph.audio));
    }
    if (config.openGraph.locale) {
      tagsToRender.push( /*#__PURE__*/react.createElement("meta", {
        key: "og:locale",
        property: "og:locale",
        content: config.openGraph.locale
      }));
    }
    if (config.openGraph.siteName || config.openGraph.site_name) {
      tagsToRender.push( /*#__PURE__*/react.createElement("meta", {
        key: "og:site_name",
        property: "og:site_name",
        content: config.openGraph.siteName || config.openGraph.site_name
      }));
    }
  }
  if (config.canonical) {
    tagsToRender.push( /*#__PURE__*/react.createElement("link", {
      rel: "canonical",
      href: config.canonical,
      key: "canonical"
    }));
  }
  if (config.additionalMetaTags && config.additionalMetaTags.length > 0) {
    config.additionalMetaTags.forEach(function (_ref2) {
      var _ref3, _ref4;
      var keyOverride = _ref2.keyOverride,
        tag = _objectWithoutPropertiesLoose(_ref2, _excluded$x);
      tagsToRender.push( /*#__PURE__*/react.createElement("meta", _extends({
        key: "meta:" + ((_ref3 = (_ref4 = keyOverride != null ? keyOverride : tag.name) != null ? _ref4 : tag.property) != null ? _ref3 : tag.httpEquiv)
      }, tag)));
    });
  }
  if ((_config$additionalLin = config.additionalLinkTags) != null && _config$additionalLin.length) {
    config.additionalLinkTags.forEach(function (tag) {
      var _tag$keyOverride;
      tagsToRender.push( /*#__PURE__*/react.createElement("link", _extends({
        key: "link" + ((_tag$keyOverride = tag.keyOverride) != null ? _tag$keyOverride : tag.href) + tag.rel
      }, tag)));
    });
  }
  return tagsToRender;
};

var WithHead = function WithHead(props) {
  return /*#__PURE__*/react.createElement((head_default()), null, buildTags(props));
};

var DefaultSeo = function DefaultSeo(_ref) {
  var title = _ref.title,
    titleTemplate = _ref.titleTemplate,
    defaultTitle = _ref.defaultTitle,
    themeColor = _ref.themeColor,
    _ref$dangerouslySetAl = _ref.dangerouslySetAllPagesToNoIndex,
    dangerouslySetAllPagesToNoIndex = _ref$dangerouslySetAl === void 0 ? false : _ref$dangerouslySetAl,
    _ref$dangerouslySetAl2 = _ref.dangerouslySetAllPagesToNoFollow,
    dangerouslySetAllPagesToNoFollow = _ref$dangerouslySetAl2 === void 0 ? false : _ref$dangerouslySetAl2,
    description = _ref.description,
    canonical = _ref.canonical,
    facebook = _ref.facebook,
    openGraph = _ref.openGraph,
    additionalMetaTags = _ref.additionalMetaTags,
    twitter = _ref.twitter,
    defaultOpenGraphImageWidth = _ref.defaultOpenGraphImageWidth,
    defaultOpenGraphImageHeight = _ref.defaultOpenGraphImageHeight,
    defaultOpenGraphVideoWidth = _ref.defaultOpenGraphVideoWidth,
    defaultOpenGraphVideoHeight = _ref.defaultOpenGraphVideoHeight,
    mobileAlternate = _ref.mobileAlternate,
    languageAlternates = _ref.languageAlternates,
    additionalLinkTags = _ref.additionalLinkTags,
    robotsProps = _ref.robotsProps;
  return /*#__PURE__*/React.createElement(WithHead, {
    title: title,
    titleTemplate: titleTemplate,
    defaultTitle: defaultTitle,
    themeColor: themeColor,
    dangerouslySetAllPagesToNoIndex: dangerouslySetAllPagesToNoIndex,
    dangerouslySetAllPagesToNoFollow: dangerouslySetAllPagesToNoFollow,
    description: description,
    canonical: canonical,
    facebook: facebook,
    openGraph: openGraph,
    additionalMetaTags: additionalMetaTags,
    twitter: twitter,
    defaultOpenGraphImageWidth: defaultOpenGraphImageWidth,
    defaultOpenGraphImageHeight: defaultOpenGraphImageHeight,
    defaultOpenGraphVideoWidth: defaultOpenGraphVideoWidth,
    defaultOpenGraphVideoHeight: defaultOpenGraphVideoHeight,
    mobileAlternate: mobileAlternate,
    languageAlternates: languageAlternates,
    additionalLinkTags: additionalLinkTags,
    robotsProps: robotsProps
  });
};

var NextSeo = function NextSeo(_ref) {
  var title = _ref.title,
    themeColor = _ref.themeColor,
    _ref$noindex = _ref.noindex,
    noindex = _ref$noindex === void 0 ? false : _ref$noindex,
    nofollow = _ref.nofollow,
    robotsProps = _ref.robotsProps,
    description = _ref.description,
    canonical = _ref.canonical,
    openGraph = _ref.openGraph,
    facebook = _ref.facebook,
    twitter = _ref.twitter,
    additionalMetaTags = _ref.additionalMetaTags,
    titleTemplate = _ref.titleTemplate,
    defaultTitle = _ref.defaultTitle,
    mobileAlternate = _ref.mobileAlternate,
    languageAlternates = _ref.languageAlternates,
    additionalLinkTags = _ref.additionalLinkTags,
    _ref$useAppDir = _ref.useAppDir,
    useAppDir = _ref$useAppDir === void 0 ? false : _ref$useAppDir;
  return /*#__PURE__*/react.createElement(react.Fragment, null, useAppDir ? buildTags({
    title: title,
    themeColor: themeColor,
    noindex: noindex,
    nofollow: nofollow,
    robotsProps: robotsProps,
    description: description,
    canonical: canonical,
    facebook: facebook,
    openGraph: openGraph,
    additionalMetaTags: additionalMetaTags,
    twitter: twitter,
    titleTemplate: titleTemplate,
    defaultTitle: defaultTitle,
    mobileAlternate: mobileAlternate,
    languageAlternates: languageAlternates,
    additionalLinkTags: additionalLinkTags
  }) : /*#__PURE__*/react.createElement(WithHead, {
    title: title,
    themeColor: themeColor,
    noindex: noindex,
    nofollow: nofollow,
    robotsProps: robotsProps,
    description: description,
    canonical: canonical,
    facebook: facebook,
    openGraph: openGraph,
    additionalMetaTags: additionalMetaTags,
    twitter: twitter,
    titleTemplate: titleTemplate,
    defaultTitle: defaultTitle,
    mobileAlternate: mobileAlternate,
    languageAlternates: languageAlternates,
    additionalLinkTags: additionalLinkTags
  }));
};

var toJson = function toJson(type, jsonld) {
  var data = jsonld;
  if (Array.isArray(data) && data.length === 1) {
    data = _extends({}, jsonld[0]);
  }
  var jsonLdObject = Array.isArray(data) ? data.map(function (item) {
    return formatObjectForSchema(type, item);
  }) : formatObjectForSchema(type, data);
  return {
    __html: JSON.stringify(jsonLdObject, safeJsonLdReplacer)
  };
};
var formatObjectForSchema = function formatObjectForSchema(type, jsonld) {
  var _jsonld$id = jsonld.id,
    id = _jsonld$id === void 0 ? undefined : _jsonld$id;
  var updated = _extends({}, id ? {
    '@id': jsonld.id
  } : {}, jsonld);
  delete updated.id;
  return _extends({
    '@context': 'https://schema.org',
    '@type': type
  }, updated);
};
var ESCAPE_ENTITIES = Object.freeze({
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&apos;'
});
var ESCAPE_REGEX = new RegExp("[" + Object.keys(ESCAPE_ENTITIES).join('') + "]", 'g');
var ESCAPE_REPLACER = function ESCAPE_REPLACER(t) {
  return ESCAPE_ENTITIES[t];
};
/**
 * A replacer for JSON.stringify to strip JSON-LD of illegal HTML entities
 * per https://www.w3.org/TR/json-ld11/#restrictions-for-contents-of-json-ld-script-elements
 */
var safeJsonLdReplacer = function () {
  // Replace per https://www.w3.org/TR/json-ld11/#restrictions-for-contents-of-json-ld-script-elements
  // Solution from https://stackoverflow.com/a/5499821/864313
  return function (_, value) {
    switch (typeof value) {
      case 'object':
        // Omit null values.
        if (value === null) {
          return undefined;
        }
        return value;
      // JSON.stringify will recursively call replacer.
      case 'number':
      case 'boolean':
      case 'bigint':
        return value;
      // These values are not risky.
      case 'string':
        return value.replace(ESCAPE_REGEX, ESCAPE_REPLACER);
      default:
        {
          // JSON.stringify will remove this element.
          return undefined;
        }
    }
  };
}();

var _excluded$w = ["type", "keyOverride", "scriptKey", "scriptId", "dataArray", "useAppDir"];
function JsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'Thing' : _ref$type,
    keyOverride = _ref.keyOverride,
    scriptKey = _ref.scriptKey,
    _ref$scriptId = _ref.scriptId,
    scriptId = _ref$scriptId === void 0 ? undefined : _ref$scriptId,
    dataArray = _ref.dataArray,
    _ref$useAppDir = _ref.useAppDir,
    useAppDir = _ref$useAppDir === void 0 ? false : _ref$useAppDir,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$w);
  var JsonLdScript = function JsonLdScript() {
    return /*#__PURE__*/react.createElement("script", {
      type: "application/ld+json",
      id: scriptId,
      "data-testid": scriptId,
      dangerouslySetInnerHTML: toJson(type, dataArray === undefined ? _extends({}, rest) : dataArray),
      key: "jsonld-" + scriptKey + (keyOverride ? "-" + keyOverride : '')
    });
  };
  if (useAppDir) {
    return /*#__PURE__*/react.createElement(JsonLdScript, null);
  }
  return /*#__PURE__*/react.createElement((head_default()), null, JsonLdScript());
}

/**
 * Generate author information
 * @param author
 * @returns
 */
function generateAuthorInfo(author) {
  if (typeof author === 'string') {
    return {
      '@type': 'Person',
      name: author
    };
  } else if (!!author.name) {
    var _author$type;
    return {
      '@type': (_author$type = author == null ? void 0 : author.type) != null ? _author$type : 'Person',
      name: author.name,
      url: author == null ? void 0 : author.url
    };
  }
  return;
}
function setAuthor(author) {
  if (Array.isArray(author)) {
    return author.map(function (item) {
      return generateAuthorInfo(item);
    }).filter(function (item) {
      return !!item;
    });
  } else if (author) {
    return generateAuthorInfo(author);
  }
  return;
}

function setImage(image) {
  if (image) {
    return {
      '@type': 'ImageObject',
      url: image
    };
  }
  return undefined;
}

function setPublisher(publisherName, publisherLogo) {
  if (!publisherName) {
    return undefined;
  }
  return {
    '@type': 'Organization',
    name: publisherName,
    logo: setImage(publisherLogo)
  };
}

function setReviewRating(rating) {
  if (rating) {
    return _extends({}, rating, {
      '@type': 'Rating'
    });
  }
  return undefined;
}

var _excluded$v = (/* unused pure expression or super */ null && (["reviewRating", "author", "publisher"]));
function setReviews(reviews) {
  function mapReview(_ref) {
    var reviewRating = _ref.reviewRating,
      author = _ref.author,
      publisher = _ref.publisher,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$v);
    return _extends({}, rest, {
      '@type': 'Review'
    }, author && {
      author: setAuthor(author)
    }, reviewRating && {
      reviewRating: setReviewRating(reviewRating)
    }, publisher && {
      publisher: setPublisher(publisher.name)
    });
  }
  if (Array.isArray(reviews)) {
    return reviews.map(mapReview);
  } else if (reviews) {
    return mapReview(reviews);
  }
  return undefined;
}

function setNutrition(calories) {
  if (calories) {
    return {
      '@type': 'NutritionInformation',
      calories: calories + " calories"
    };
  }
  return undefined;
}

function setAggregateRating(aggregateRating) {
  if (aggregateRating) {
    return {
      '@type': 'AggregateRating',
      ratingCount: aggregateRating.ratingCount,
      reviewCount: aggregateRating.reviewCount,
      bestRating: aggregateRating.bestRating,
      ratingValue: aggregateRating.ratingValue
    };
  }
  return undefined;
}

function setClip(clips) {
  function mapClip(clip) {
    return _extends({}, clip, {
      '@type': 'Clip'
    });
  }
  if (Array.isArray(clips)) {
    return clips.map(mapClip);
  } else if (clips) {
    return mapClip(clips);
  }
  return undefined;
}

function setInteractionStatistic(watchCount) {
  if (watchCount) {
    return {
      '@type': 'InteractionCounter',
      interactionType: 'https://schema.org/WatchAction',
      userInteractionCount: watchCount
    };
  }
  return undefined;
}

function setBroadcastEvent(publication) {
  function mapBroadcastEvent(publication) {
    return _extends({}, publication, {
      '@type': 'BroadcastEvent'
    });
  }
  if (publication) {
    if (Array.isArray(publication)) {
      return publication.map(mapBroadcastEvent);
    }
    return mapBroadcastEvent(publication);
  }
  return undefined;
}

var _excluded$u = (/* unused pure expression or super */ null && (["thumbnailUrls", "hasPart", "watchCount", "publication"]));
function setVideo(video, setContext) {
  if (setContext === void 0) {
    setContext = false;
  }
  function mapVideo(_ref, context) {
    var thumbnailUrls = _ref.thumbnailUrls,
      hasPart = _ref.hasPart,
      watchCount = _ref.watchCount,
      publication = _ref.publication,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$u);
    return _extends({}, rest, {
      '@type': 'VideoObject'
    }, context && {
      '@context': 'https://schema.org'
    }, {
      thumbnailUrl: thumbnailUrls,
      hasPart: setClip(hasPart),
      interactionStatistic: setInteractionStatistic(watchCount),
      publication: setBroadcastEvent(publication)
    });
  }
  if (video) {
    return mapVideo(video, setContext);
  }
  return undefined;
}

function setInstruction(instruction) {
  if (instruction) {
    return _extends({}, instruction, {
      '@type': 'HowToStep'
    });
  }
  return undefined;
}

var _excluded$t = (/* unused pure expression or super */ null && (["type", "keyOverride", "ofType", "data"])),
  _excluded2$1 = (/* unused pure expression or super */ null && (["authorName", "images", "yields", "category", "calories", "aggregateRating", "video", "ingredients", "instructions", "cuisine"]));
function CarouselJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'Carousel' : _ref$type,
    keyOverride = _ref.keyOverride,
    ofType = _ref.ofType,
    data = _ref.data,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$t);
  function generateList(data, ofType) {
    switch (ofType) {
      case 'default':
        return data.map(function (item, index) {
          return {
            '@type': 'ListItem',
            position: "" + (index + 1),
            url: item.url
          };
        });
      case 'course':
        return data.map(function (item, index) {
          return {
            '@type': 'ListItem',
            position: "" + (index + 1),
            item: {
              '@context': 'https://schema.org',
              '@type': 'Course',
              url: item.url,
              name: item.courseName,
              description: item.description,
              provider: {
                '@type': 'Organization',
                name: item.providerName,
                sameAs: item.providerUrl
              }
            }
          };
        });
      case 'movie':
        return data.map(function (item, index) {
          return {
            '@type': 'ListItem',
            position: "" + (index + 1),
            item: {
              '@context': 'https://schema.org',
              '@type': 'Movie',
              name: item.name,
              url: item.url,
              image: item.image,
              dateCreated: item.dateCreated,
              director: item.director ? Array.isArray(item.director) ? item.director.map(function (director) {
                return {
                  '@type': 'Person',
                  name: director.name
                };
              }) : {
                '@type': 'Person',
                name: item.director.name
              } : undefined,
              review: setReviews(item.review)
            }
          };
        });
      case 'recipe':
        return data.map(function (_ref2, index) {
          var authorName = _ref2.authorName,
            images = _ref2.images,
            yields = _ref2.yields,
            category = _ref2.category,
            calories = _ref2.calories,
            aggregateRating = _ref2.aggregateRating,
            video = _ref2.video,
            ingredients = _ref2.ingredients,
            instructions = _ref2.instructions,
            cuisine = _ref2.cuisine,
            rest = _objectWithoutPropertiesLoose(_ref2, _excluded2$1);
          return {
            '@type': 'ListItem',
            position: "" + (index + 1),
            item: _extends({
              '@context': 'https://schema.org',
              '@type': 'Recipe'
            }, rest, {
              author: setAuthor(authorName),
              image: images,
              recipeYield: yields,
              recipeCategory: category,
              recipeCuisine: cuisine,
              nutrition: setNutrition(calories),
              aggregateRating: setAggregateRating(aggregateRating),
              video: setVideo(video),
              recipeIngredient: ingredients,
              recipeInstructions: instructions.map(setInstruction)
            })
          };
        });
    }
  }
  var jsonLdData = _extends({
    '@type': 'ItemList',
    itemListElement: generateList(data, ofType)
  }, rest);
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, jsonLdData, {
    scriptKey: "Carousel"
  }));
}

var _excluded$s = (/* unused pure expression or super */ null && (["type", "keyOverride", "url", "title", "images", "section", "dateCreated", "datePublished", "dateModified", "authorName", "authorType", "publisherName", "publisherLogo", "body", "isAccessibleForFree"]));
function NewsArticleJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'NewsArticle' : _ref$type,
    keyOverride = _ref.keyOverride,
    url = _ref.url,
    title = _ref.title,
    images = _ref.images,
    section = _ref.section,
    dateCreated = _ref.dateCreated,
    datePublished = _ref.datePublished,
    dateModified = _ref.dateModified,
    authorName = _ref.authorName,
    publisherName = _ref.publisherName,
    publisherLogo = _ref.publisherLogo,
    body = _ref.body,
    isAccessibleForFree = _ref.isAccessibleForFree,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$s);
  var data = _extends({}, rest, {
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': url
    },
    headline: title,
    image: images,
    articleSection: section,
    dateCreated: dateCreated || datePublished,
    datePublished: datePublished,
    dateModified: dateModified || datePublished,
    author: setAuthor(authorName),
    publisher: setPublisher(publisherName, publisherLogo),
    articleBody: body,
    isAccessibleForFree: isAccessibleForFree
  });
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "NewsArticle"
  }));
}

var _excluded$r = (/* unused pure expression or super */ null && (["type", "keyOverride", "baseSalary", "hiringOrganization", "applicantLocationRequirements", "experienceRequirements", "jobLocation"]));
function JobPostingJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'JobPosting' : _ref$type,
    keyOverride = _ref.keyOverride,
    baseSalary = _ref.baseSalary,
    hiringOrganization = _ref.hiringOrganization,
    applicantLocationRequirements = _ref.applicantLocationRequirements,
    experienceRequirements = _ref.experienceRequirements,
    jobLocation = _ref.jobLocation,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$r);
  function setBaseSalary(baseSalary) {
    if (baseSalary) {
      return {
        '@type': 'MonetaryAmount',
        currency: baseSalary.currency,
        value: _extends({
          '@type': 'QuantitativeValue',
          unitText: baseSalary.unitText
        }, Array.isArray(baseSalary.value) ? {
          minValue: baseSalary.value[0],
          maxValue: baseSalary.value[1]
        } : {
          value: baseSalary.value
        })
      };
    }
    return undefined;
  }
  function setHiringOrganization(org) {
    return {
      '@type': 'Organization',
      name: org.name,
      sameAs: org.sameAs,
      logo: org.logo
    };
  }
  function setJobLocation(location) {
    if (location) {
      return {
        '@type': 'Place',
        address: {
          '@type': 'PostalAddress',
          addressCountry: location.addressCountry,
          addressLocality: location.addressLocality,
          addressRegion: location.addressRegion,
          postalCode: location.postalCode,
          streetAddress: location.streetAddress
        }
      };
    }
    return undefined;
  }
  function setApplicantLocationRequirements(requirements) {
    if (requirements) {
      return {
        '@type': 'Country',
        name: requirements
      };
    }
    return undefined;
  }
  function setOccupationalExperienceRequirements(requirements) {
    if (requirements) {
      return {
        '@type': requirements['@type'] ? requirements['@type'] : 'OccupationalExperienceRequirements',
        monthsOfExperience: requirements.minimumMonthsOfExperience
      };
    }
    return undefined;
  }
  function setEducationalOccupationalCredential(requirements) {
    if (requirements) {
      return {
        '@type': requirements['@type'] ? requirements['@type'] : 'EducationalOccupationalCredential',
        credentialCategory: requirements.credentialCategory
      };
    }
    return undefined;
  }
  var data = _extends({}, rest, {
    baseSalary: setBaseSalary(baseSalary),
    hiringOrganization: setHiringOrganization(hiringOrganization),
    jobLocation: setJobLocation(jobLocation),
    applicantLocationRequirements: setApplicantLocationRequirements(applicantLocationRequirements),
    experienceRequirements: setOccupationalExperienceRequirements(experienceRequirements == null ? void 0 : experienceRequirements.occupational),
    educationRequirements: setEducationalOccupationalCredential(experienceRequirements == null ? void 0 : experienceRequirements.educational),
    experienceInPlaceOfEducation: experienceRequirements == null ? void 0 : experienceRequirements.experienceInPlaceOfEducation
  });
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "JobPosting"
  }));
}

function setAddress(address) {
  if (!address) return undefined;
  if (!Array.isArray(address)) return toPostalAddress(address);
  // If array of one address, replace with single address
  if (address.length === 1) return toPostalAddress(address[0]);
  // If array, return mapped array of PostalAddresses
  return address.map(toPostalAddress);
}
function toPostalAddress(address) {
  if (typeof address === 'string') return address;
  return _extends({
    '@type': 'PostalAddress'
  }, address);
}

function setGeo(geo) {
  if (geo) {
    return _extends({}, geo, {
      '@type': 'GeoCoordinates'
    });
  }
  return undefined;
}

function setAction(action) {
  if (action) {
    return {
      '@type': action.actionType,
      name: action.actionName,
      target: action.target
    };
  }
  return undefined;
}

function setGeoCircle(geoCircle) {
  if (geoCircle) {
    return {
      '@type': 'GeoCircle',
      geoMidpoint: {
        '@type': 'GeoCoordinates',
        latitude: geoCircle.geoMidpoint.latitude,
        longitude: geoCircle.geoMidpoint.longitude
      },
      geoRadius: geoCircle.geoRadius
    };
  }
  return undefined;
}

function setOffer(offer) {
  function setPriceSpecification(priceSpecification) {
    if (priceSpecification) {
      return {
        '@type': priceSpecification.type,
        priceCurrency: priceSpecification.priceCurrency,
        price: priceSpecification.price
      };
    }
    return undefined;
  }
  function setItemOffered(itemOffered) {
    if (itemOffered) {
      return _extends({}, itemOffered, {
        '@type': 'Service'
      });
    }
    return undefined;
  }
  if (offer) {
    return _extends({}, offer, {
      '@type': 'Offer',
      priceSpecification: setPriceSpecification(offer.priceSpecification),
      itemOffered: setItemOffered(offer.itemOffered)
    });
  }
  return undefined;
}

function setOpeningHours(openingHours) {
  if (openingHours) {
    return _extends({}, openingHours, {
      '@type': 'OpeningHoursSpecification'
    });
  }
  return undefined;
}

var _excluded$q = (/* unused pure expression or super */ null && (["type", "keyOverride", "address", "geo", "rating", "review", "action", "areaServed", "makesOffer", "openingHours", "images"]));
function LocalBusinessJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'LocalBusiness' : _ref$type,
    keyOverride = _ref.keyOverride,
    address = _ref.address,
    geo = _ref.geo,
    rating = _ref.rating,
    review = _ref.review,
    action = _ref.action,
    areaServed = _ref.areaServed,
    makesOffer = _ref.makesOffer,
    openingHours = _ref.openingHours,
    images = _ref.images,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$q);
  var data = _extends({}, rest, {
    image: images,
    address: setAddress(address),
    geo: setGeo(geo),
    aggregateRating: setAggregateRating(rating),
    review: setReviews(review),
    potentialAction: setAction(action),
    areaServed: areaServed && areaServed.map(setGeoCircle),
    makesOffer: makesOffer == null ? void 0 : makesOffer.map(setOffer),
    openingHoursSpecification: Array.isArray(openingHours) ? openingHours.map(setOpeningHours) : setOpeningHours(openingHours)
  });
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "LocalBusiness"
  }));
}

var _excluded$p = (/* unused pure expression or super */ null && (["type", "keyOverride", "mainEntity"])),
  _excluded2 = (/* unused pure expression or super */ null && (["upvoteCount"]));
function QAPageJsonLd(_ref) {
  var _mainEntity$author, _mainEntity$acceptedA, _mainEntity$acceptedA2;
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'QAPage' : _ref$type,
    keyOverride = _ref.keyOverride,
    mainEntity = _ref.mainEntity,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$p);
  var data = _extends({}, rest, {
    mainEntity: _extends({}, mainEntity, {
      '@type': 'Question',
      author: setAuthor((_mainEntity$author = mainEntity.author) == null ? void 0 : _mainEntity$author.name)
    }, mainEntity.acceptedAnswer && {
      acceptedAnswer: _extends({}, mainEntity.acceptedAnswer, {
        '@type': 'Answer',
        author: setAuthor((_mainEntity$acceptedA = mainEntity.acceptedAnswer) == null ? void 0 : (_mainEntity$acceptedA2 = _mainEntity$acceptedA.author) == null ? void 0 : _mainEntity$acceptedA2.name)
      })
    }, mainEntity.suggestedAnswer && {
      suggestedAnswer: mainEntity.suggestedAnswer.map(function (_ref2) {
        var _rest$author;
        var upvoteCount = _ref2.upvoteCount,
          rest = _objectWithoutPropertiesLoose(_ref2, _excluded2);
        return _extends({}, rest, {
          '@type': 'Answer',
          upvoteCount: upvoteCount || 0,
          author: setAuthor((_rest$author = rest.author) == null ? void 0 : _rest$author.name)
        });
      })
    })
  });
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "QAPage"
  }));
}

function setItemListElements(items) {
  if (items && items.length) {
    return items.map(function (item) {
      return {
        '@type': 'ListItem',
        position: item.position,
        item: {
          '@id': item.item,
          name: item.name
        }
      };
    });
  }
  return undefined;
}

var _excluded$o = (/* unused pure expression or super */ null && (["type", "keyOverride", "breadcrumb"]));
function ProfilePageJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'ProfilePage' : _ref$type,
    keyOverride = _ref.keyOverride,
    breadcrumb = _ref.breadcrumb,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$o);
  var data = _extends({}, rest, {
    breadcrumb: Array.isArray(breadcrumb) ? {
      '@type': 'BreadcrumbList',
      itemListElement: setItemListElements(breadcrumb)
    } : breadcrumb
  });
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "ProfilePage"
  }));
}

var _excluded$n = (/* unused pure expression or super */ null && (["type", "keyOverride", "potentialActions"]));
function SiteLinksSearchBoxJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'WebSite' : _ref$type,
    keyOverride = _ref.keyOverride,
    potentialActions = _ref.potentialActions,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$n);
  function setPotentialAction(action) {
    if (action) {
      var target = action.target,
        queryInput = action.queryInput;
      return {
        '@type': 'SearchAction',
        target: target + "={" + queryInput + "}",
        'query-input': "required name=" + queryInput
      };
    }
    return undefined;
  }
  var data = _extends({}, rest, {
    potentialAction: potentialActions.map(setPotentialAction)
  });
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "jsonld-siteLinksSearchBox"
  }));
}

var _excluded$m = (/* unused pure expression or super */ null && (["type", "keyOverride", "authorName", "images", "yields", "category", "cuisine", "calories", "aggregateRating", "video", "ingredients", "instructions"]));
function RecipeJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'Recipe' : _ref$type,
    keyOverride = _ref.keyOverride,
    authorName = _ref.authorName,
    images = _ref.images,
    yields = _ref.yields,
    category = _ref.category,
    cuisine = _ref.cuisine,
    calories = _ref.calories,
    aggregateRating = _ref.aggregateRating,
    video = _ref.video,
    ingredients = _ref.ingredients,
    instructions = _ref.instructions,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$m);
  var data = _extends({}, rest, {
    author: setAuthor(authorName),
    image: images,
    recipeYield: yields,
    recipeCategory: category,
    recipeCuisine: cuisine,
    nutrition: setNutrition(calories),
    aggregateRating: setAggregateRating(aggregateRating),
    video: setVideo(video),
    recipeIngredient: ingredients,
    recipeInstructions: instructions ? instructions.map(setInstruction) : undefined
  });
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "recipe"
  }));
}

function setLocation(location) {
  if (!location) {
    return undefined;
  }
  if (typeof location === 'string') {
    return location;
  }
  if ('url' in location) {
    return setVirtualLocation(location);
  } else {
    return setPlace(location);
  }
}
function setVirtualLocation(location) {
  return _extends({}, location, {
    '@type': 'VirtualLocation'
  });
}
function setPlace(location) {
  return _extends({}, location, {
    address: setAddress(location.address),
    '@type': 'Place'
  });
}

var _excluded$l = (/* unused pure expression or super */ null && (["type"]));
function setPerformer(performer) {
  if (performer) {
    var type = performer.type,
      restPerformer = _objectWithoutPropertiesLoose(performer, _excluded$l);
    return _extends({}, restPerformer, {
      '@type': type || 'PerformingGroup'
    });
  }
  return undefined;
}

var _excluded$k = (/* unused pure expression or super */ null && (["seller"]));
function setOffers(offers) {
  function mapOffer(_ref) {
    var seller = _ref.seller,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$k);
    return _extends({}, rest, {
      '@type': 'Offer'
    }, seller && {
      seller: {
        '@type': 'Organization',
        name: seller.name
      }
    });
  }
  if (Array.isArray(offers)) {
    return offers.map(mapOffer);
  } else if (offers) {
    return mapOffer(offers);
  }
  return undefined;
}

function setAggregateOffer(aggregateOffer) {
  if (aggregateOffer) {
    return {
      '@type': 'AggregateOffer',
      priceCurrency: aggregateOffer.priceCurrency,
      highPrice: aggregateOffer.highPrice,
      lowPrice: aggregateOffer.lowPrice,
      offerCount: aggregateOffer.offerCount,
      offers: setOffers(aggregateOffer.offers)
    };
  }
  return undefined;
}

var _excluded$j = (/* unused pure expression or super */ null && (["type"]));
function setOrganizer(organizer) {
  if (organizer) {
    var type = organizer.type,
      restOrganizer = _objectWithoutPropertiesLoose(organizer, _excluded$j);
    return _extends({}, restOrganizer, {
      '@type': type || 'Person'
    });
  }
  return undefined;
}

var _excluded$i = (/* unused pure expression or super */ null && (["type", "keyOverride", "location", "images", "offers", "aggregateOffer", "performers", "organizer", "eventStatus", "eventAttendanceMode"]));
function EventJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'Event' : _ref$type,
    keyOverride = _ref.keyOverride,
    location = _ref.location,
    images = _ref.images,
    offers = _ref.offers,
    aggregateOffer = _ref.aggregateOffer,
    performers = _ref.performers,
    organizer = _ref.organizer,
    eventStatus = _ref.eventStatus,
    eventAttendanceMode = _ref.eventAttendanceMode,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$i);
  var data = _extends({}, rest, {
    location: setLocation(location),
    image: images,
    offers: offers ? setOffers(offers) : setAggregateOffer(aggregateOffer),
    performer: Array.isArray(performers) ? performers.map(setPerformer) : setPerformer(performers),
    organizer: Array.isArray(organizer) ? organizer.map(setOrganizer) : setOrganizer(organizer),
    eventStatus: eventStatus ? "https://schema.org/" + eventStatus : undefined,
    eventAttendanceMode: eventAttendanceMode ? "https://schema.org/" + eventAttendanceMode : undefined
  });
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "Event"
  }));
}

function setContactPoint(contactPoint) {
  if (contactPoint) {
    return _extends({}, contactPoint, {
      '@type': 'ContactPoint'
    });
  }
  return undefined;
}

var _excluded$h = (/* unused pure expression or super */ null && (["type", "keyOverride", "contactPoint"]));
function CorporateContactJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'Organization' : _ref$type,
    keyOverride = _ref.keyOverride,
    contactPoint = _ref.contactPoint,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$h);
  var data = _extends({}, rest, {
    contactPoint: contactPoint.map(setContactPoint)
  });
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "CorporateContact"
  }));
}

function setCreativeWork(creativeWork) {
  if (creativeWork) {
    return _extends({}, creativeWork, {
      '@type': 'CreativeWork'
    });
  }
  return undefined;
}

var _excluded$g = (/* unused pure expression or super */ null && (["type", "keyOverride", "hasPart"]));
function CollectionPageJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'CollectionPage' : _ref$type,
    keyOverride = _ref.keyOverride,
    hasPart = _ref.hasPart,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$g);
  var data = _extends({}, rest, {
    hasPart: hasPart.map(setCreativeWork)
  });
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "CollectionPage"
  }));
}

function setManufacturer(manufacturer) {
  if (manufacturer && (manufacturer.manufacturerName || manufacturer.manufacturerLogo)) {
    return {
      '@type': 'Organization',
      name: manufacturer.manufacturerName,
      logo: setImage(manufacturer.manufacturerLogo)
    };
  }
  return undefined;
}

function setBrand(brand) {
  if (brand) {
    return {
      '@type': 'Brand',
      name: brand
    };
  }
  return undefined;
}

var _excluded$f = (/* unused pure expression or super */ null && (["type", "keyOverride", "images", "brand", "reviews", "aggregateRating", "manufacturerLogo", "manufacturerName", "offers", "aggregateOffer", "productName"]));
function ProductJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'Product' : _ref$type,
    keyOverride = _ref.keyOverride,
    images = _ref.images,
    brand = _ref.brand,
    reviews = _ref.reviews,
    aggregateRating = _ref.aggregateRating,
    manufacturerLogo = _ref.manufacturerLogo,
    manufacturerName = _ref.manufacturerName,
    offers = _ref.offers,
    aggregateOffer = _ref.aggregateOffer,
    productName = _ref.productName,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$f);
  var data = _extends({}, rest, {
    image: images,
    brand: setBrand(brand),
    review: setReviews(reviews),
    aggregateRating: setAggregateRating(aggregateRating),
    manufacturer: setManufacturer({
      manufacturerLogo: manufacturerLogo,
      manufacturerName: manufacturerName
    }),
    offers: offers ? setOffers(offers) : setAggregateOffer(aggregateOffer),
    name: productName
  });
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "Product"
  }));
}

var _excluded$e = (/* unused pure expression or super */ null && (["type", "keyOverride", "priceCurrency", "price", "aggregateRating", "review"]));
function SoftwareAppJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'SoftwareApplication' : _ref$type,
    keyOverride = _ref.keyOverride,
    priceCurrency = _ref.priceCurrency,
    price = _ref.price,
    aggregateRating = _ref.aggregateRating,
    review = _ref.review,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$e);
  var data = _extends({}, rest, {
    offers: {
      '@type': 'Offer',
      price: price,
      priceCurrency: priceCurrency
    },
    aggregateRating: setAggregateRating(aggregateRating),
    review: setReviews(review)
  });
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "SoftwareApp"
  }));
}

var _excluded$d = (/* unused pure expression or super */ null && (["type", "keyOverride"]));
function VideoJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'Video' : _ref$type,
    keyOverride = _ref.keyOverride,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$d);
  var data = setVideo(rest, true);
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "Video"
  }));
}

function setProducer(producer) {
  if (producer) {
    return {
      '@type': 'Organization',
      sameAs: producer.url,
      name: producer.name
    };
  }
  return undefined;
}

function setProvider(provider) {
  if (provider) {
    return {
      '@type': provider.type || 'Organization',
      name: provider.name,
      sameAs: provider.url
    };
  }
  return undefined;
}

var _excluded$c = (/* unused pure expression or super */ null && (["type", "keyOverride", "aggregateRating", "trailer", "reviews", "image", "authorName", "provider", "producerName", "producerUrl", "offers", "operatingSystemName", "platformName", "translatorName", "languageName", "genreName", "publisherName"]));
function VideoGameJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'VideoGame' : _ref$type,
    keyOverride = _ref.keyOverride,
    aggregateRating = _ref.aggregateRating,
    trailer = _ref.trailer,
    reviews = _ref.reviews,
    image = _ref.image,
    authorName = _ref.authorName,
    provider = _ref.provider,
    producerName = _ref.producerName,
    producerUrl = _ref.producerUrl,
    offers = _ref.offers,
    operatingSystemName = _ref.operatingSystemName,
    platformName = _ref.platformName,
    translatorName = _ref.translatorName,
    languageName = _ref.languageName,
    genreName = _ref.genreName,
    publisherName = _ref.publisherName,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$c);
  var data = _extends({}, rest, {
    aggregateRating: setAggregateRating(aggregateRating),
    trailer: setVideo(trailer),
    review: setReviews(reviews),
    image: setImage(image),
    author: setAuthor(authorName),
    provider: setProvider(provider),
    producer: setProducer({
      name: producerName,
      url: producerUrl
    }),
    offers: setOffers(offers),
    operatingSystem: operatingSystemName,
    gamePlatform: platformName,
    translator: translatorName,
    inLanguage: languageName,
    genre: genreName,
    publisher: publisherName
  });
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "VideoGame"
  }));
}

function setContactPoints(contactPoint) {
  if (contactPoint && contactPoint.length) {
    return contactPoint.map(function (contactPoint) {
      return _extends({
        '@type': 'ContactPoint'
      }, contactPoint);
    });
  }
  return undefined;
}

var _excluded$b = ["type", "keyOverride", "address", "contactPoints", "contactPoint"];
function OrganizationJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'Organization' : _ref$type,
    keyOverride = _ref.keyOverride,
    address = _ref.address,
    contactPoints = _ref.contactPoints,
    contactPoint = _ref.contactPoint,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$b);
  var data = _extends({}, rest, {
    address: setAddress(address),
    contactPoint: setContactPoints(contactPoint || contactPoints)
  });
  return /*#__PURE__*/react.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "organization"
  }));
}

function setQuestions(questions) {
  if (questions && questions.length) {
    return questions.map(function (question) {
      return {
        '@type': 'Question',
        name: question.questionName,
        acceptedAnswer: {
          '@type': 'Answer',
          text: question.acceptedAnswerText
        }
      };
    });
  }
  return undefined;
}

var _excluded$a = (/* unused pure expression or super */ null && (["type", "keyOverride", "mainEntity"]));
function FAQPageJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'FAQPage' : _ref$type,
    keyOverride = _ref.keyOverride,
    mainEntity = _ref.mainEntity,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$a);
  var data = _extends({}, rest, {
    mainEntity: setQuestions(mainEntity)
  });
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "faq-page"
  }));
}

var _excluded$9 = (/* unused pure expression or super */ null && (["type", "keyOverride"]));
function LogoJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'Organization' : _ref$type,
    keyOverride = _ref.keyOverride,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$9);
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, rest, {
    scriptKey: "Logo"
  }));
}

var _excluded$8 = (/* unused pure expression or super */ null && (["type", "keyOverride"]));
function DatasetJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'Dataset' : _ref$type,
    keyOverride = _ref.keyOverride,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$8);
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, rest, {
    scriptKey: "dataset"
  }));
}

var _excluded$7 = (/* unused pure expression or super */ null && (["type", "keyOverride", "courseName", "provider"]));
function CourseJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'Course' : _ref$type,
    keyOverride = _ref.keyOverride,
    courseName = _ref.courseName,
    provider = _ref.provider,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$7);
  var data = _extends({
    name: courseName
  }, rest, {
    provider: setProvider(provider)
  });
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "course"
  }));
}

var _excluded$6 = (/* unused pure expression or super */ null && (["type", "keyOverride", "itemListElements"]));
function BreadCrumbJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'BreadcrumbList' : _ref$type,
    keyOverride = _ref.keyOverride,
    itemListElements = _ref.itemListElements,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$6);
  var data = _extends({}, rest, {
    itemListElement: setItemListElements(itemListElements)
  });
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "breadcrumb"
  }));
}

var _excluded$5 = (/* unused pure expression or super */ null && (["type", "id", "keyOverride", "aggregateRating"]));
function BrandJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'Brand' : _ref$type,
    id = _ref.id,
    keyOverride = _ref.keyOverride,
    aggregateRating = _ref.aggregateRating,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$5);
  var data = _extends({
    aggregateRating: setAggregateRating(aggregateRating),
    '@id': id
  }, rest);
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "brand"
  }));
}

var _excluded$4 = (/* unused pure expression or super */ null && (["type", "keyOverride", "url", "title", "images", "datePublished", "dateModified", "authorName", "publisherName", "publisherLogo", "description", "isAccessibleForFree"]));
function ArticleJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'Article' : _ref$type,
    keyOverride = _ref.keyOverride,
    url = _ref.url,
    title = _ref.title,
    images = _ref.images,
    datePublished = _ref.datePublished,
    dateModified = _ref.dateModified,
    authorName = _ref.authorName,
    _ref$publisherName = _ref.publisherName,
    publisherName = _ref$publisherName === void 0 ? undefined : _ref$publisherName,
    _ref$publisherLogo = _ref.publisherLogo,
    publisherLogo = _ref$publisherLogo === void 0 ? undefined : _ref$publisherLogo,
    description = _ref.description,
    isAccessibleForFree = _ref.isAccessibleForFree,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$4);
  var data = _extends({
    datePublished: datePublished,
    description: description,
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': url
    },
    headline: title,
    image: images,
    dateModified: dateModified || datePublished,
    author: setAuthor(authorName),
    publisher: setPublisher(publisherName, publisherLogo),
    isAccessibleForFree: isAccessibleForFree
  }, rest);
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "article"
  }));
}

function setReviewedBy(reviewedBy) {
  if (reviewedBy) {
    return _extends({
      '@type': (reviewedBy == null ? void 0 : reviewedBy.type) || 'Organization'
    }, reviewedBy);
  }
  return undefined;
}

var _excluded$3 = (/* unused pure expression or super */ null && (["keyOverride", "reviewedBy"]));
function WebPageJsonLd(_ref) {
  var keyOverride = _ref.keyOverride,
    reviewedBy = _ref.reviewedBy,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$3);
  var data = _extends({}, rest, {
    reviewedBy: setReviewedBy(reviewedBy)
  });
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    keyOverride: keyOverride
  }, data, {
    type: "WebPage",
    scriptKey: "WebPage"
  }));
}

var _excluded$2 = (/* unused pure expression or super */ null && (["type", "keyOverride"]));
function SocialProfileJsonLd(_ref) {
  var type = _ref.type,
    keyOverride = _ref.keyOverride,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$2);
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, rest, {
    scriptKey: "social"
  }));
}

function setCost(cost) {
  if (cost) {
    return _extends({}, cost, {
      '@type': 'MonetaryAmount'
    });
  }
  return undefined;
}

function setSupply(supply) {
  if (supply) {
    return supply.map(function (supplyItem) {
      return {
        '@type': 'HowToSupply',
        name: supplyItem
      };
    });
  }
  return undefined;
}

function setTool(tool) {
  if (tool) {
    return tool.map(function (toolItem) {
      return {
        '@type': 'HowToTool',
        name: toolItem
      };
    });
  }
  return undefined;
}

function setStep(step) {
  if (step) {
    return step.map(function (stepElement) {
      var itemListElement = stepElement.itemListElement,
        image = stepElement.image;
      var currentListElements = itemListElement == null ? void 0 : itemListElement.map(function (_ref) {
        var type = _ref.type,
          text = _ref.text;
        return {
          '@type': type,
          text: text
        };
      });
      return _extends({}, stepElement, {
        '@type': 'HowToStep',
        itemListElement: currentListElements,
        image: setImage(image)
      });
    });
  }
  return undefined;
}

var _excluded$1 = (/* unused pure expression or super */ null && (["type", "keyOverride", "image", "estimatedCost", "supply", "tool", "step"]));
function howToJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'HowTo' : _ref$type,
    keyOverride = _ref.keyOverride,
    image = _ref.image,
    estimatedCost = _ref.estimatedCost,
    supply = _ref.supply,
    tool = _ref.tool,
    step = _ref.step,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$1);
  var data = _extends({}, rest, {
    image: setImage(image),
    estimatedCost: setCost(estimatedCost),
    supply: setSupply(supply),
    tool: setTool(tool),
    step: setStep(step)
  });
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "howTo"
  }));
}

var _excluded = (/* unused pure expression or super */ null && (["keyOverride", "images"]));
function ImageJsonLd(_ref) {
  var keyOverride = _ref.keyOverride,
    images = _ref.images,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/React.createElement(JsonLd, _extends({}, rest, {
    type: "ImageObject",
    keyOverride: keyOverride,
    dataArray: images,
    scriptKey: "image"
  }));
}



// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/exports/StatusBar/index.js
var StatusBar = __webpack_require__(44776);
// EXTERNAL MODULE: ./node_modules/@tamagui/constants/dist/esm/index.mjs
var dist_esm = __webpack_require__(11649);
// EXTERNAL MODULE: ./node_modules/@tamagui/web/dist/esm/views/TamaguiProvider.js
var TamaguiProvider = __webpack_require__(57450);
// EXTERNAL MODULE: ../../node_modules/@tamagui/portal/dist/esm/index.mjs
var portal_dist_esm = __webpack_require__(82276);
;// CONCATENATED MODULE: ../../node_modules/tamagui/dist/esm/views/TamaguiProvider.js



const TamaguiProvider_TamaguiProvider = dist_esm/* isRSC */.PS ? TamaguiProvider/* TamaguiProvider */.r : (param)=>{
    let { children , ...props } = param;
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(TamaguiProvider/* TamaguiProvider */.r, {
        ...props,
        children: /* @__PURE__ */ (0,jsx_runtime.jsx)(portal_dist_esm.PortalProvider, {
            shouldAddRootHost: true,
            children
        })
    });
};
 //# sourceMappingURL=TamaguiProvider.js.map

// EXTERNAL MODULE: ../../design-systems/vellapps/dist/index.js
var dist = __webpack_require__(78799);
;// CONCATENATED MODULE: ../../apps/vellapps/tamagui.config.ts

/* harmony default export */ var tamagui_config = (dist.config);

;// CONCATENATED MODULE: ../../apps/vellapps/components/Wrapper.tsx





const Wrapper = (param)=>{
    let { children , ...rest } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TamaguiProvider_TamaguiProvider, {
        config: tamagui_config,
        disableInjectCSS: true,
        defaultTheme: "dark",
        ...rest,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StatusBar/* default */.Z, {
                barStyle: "default"
            }),
            children
        ]
    });
};
/* harmony default export */ var components_Wrapper = (Wrapper);

;// CONCATENATED MODULE: ../../apps/vellapps/components/DynamicFavicon.tsx

const Favicon = (param)=>{
    let { theme  } = param;
    const href = react.useMemo(()=>theme === "dark" ? "/favicon-light.ico" : "/favicon-dark.ico", [
        theme
    ]);
    react.useEffect(()=>{
        let link = document.querySelector("link[rel~='icon']");
        if (!link) {
            var ref, ref1;
            link = document.createElement("link");
            link.rel = "icon";
            (ref = document === null || document === void 0 ? void 0 : document.getElementsByTagName("head")) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.appendChild(link);
        }
        link.href = href;
    }, [
        href
    ]);
    return null;
};
/* harmony default export */ var DynamicFavicon = (Favicon);

// EXTERNAL MODULE: ../../node_modules/next/script.js
var script = __webpack_require__(45847);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
;// CONCATENATED MODULE: ./pages/_app.tsx












// eslint-disable-next-line @typescript-eslint/no-unused-vars
const App = (param)=>{
    let { Component , pageProps: { session , isSsrMobile , ...pageProps }  } = param;
    const [theme, setTheme] = useRootTheme();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Vellapps LLC"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        href: "/favicon.ico"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        httpEquiv: "X-UA-Compatible",
                        content: "IE=edge"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                src: "/theme.js",
                strategy: "beforeInteractive"
            }),
            pageProps.seo && /*#__PURE__*/ (0,jsx_runtime.jsx)(NextSeo, {
                ...pageProps.seo
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicFavicon, {
                theme: theme
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OrganizationJsonLd, {
                type: "LLC",
                id: "https://www.vellapps.com",
                logo: "https://www.vellapps.com/logo.png",
                legalName: "Vellapps LLC",
                name: "Vellapps",
                contactPoint: [
                    {
                        telephone: "+1-302-993-6460",
                        contactType: "customer service",
                        areaServed: "US",
                        availableLanguage: [
                            "English"
                        ]
                    }
                ],
                url: "https://www.vellapps.com"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NextThemeProvider, {
                onChangeTheme: setTheme,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Wrapper, {
                    isSsrMobile: isSsrMobile,
                    defaultTheme: theme,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, {
                        ...pageProps
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var _app = (App);


/***/ }),

/***/ 86137:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all)=>{
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var __copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of __getOwnPropNames(from))if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var __toCommonJS = (mod)=>__copyProps(__defProp({}, "__esModule", {
        value: true
    }), mod);
var animations_exports = {};
__export(animations_exports, {
    animations: ()=>animations
});
module.exports = __toCommonJS(animations_exports);
var import_animations_react_native = __webpack_require__(37898);
const animations = (0, import_animations_react_native.createAnimations)({
    bouncy: {
        type: "spring",
        damping: 10,
        mass: 0.9,
        stiffness: 100
    },
    lazy: {
        type: "spring",
        damping: 20,
        stiffness: 60
    },
    quick: {
        type: "spring",
        damping: 20,
        mass: 1.2,
        stiffness: 250
    }
});
// Annotate the CommonJS export names for ESM import in node:
0 && (0); //# sourceMappingURL=animations.js.map


/***/ }),

/***/ 78799:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all)=>{
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var __copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of __getOwnPropNames(from))if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var __reExport = (target, mod, secondTarget)=>(__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toESM = (mod, isNodeMode, target)=>(target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(// If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
        value: mod,
        enumerable: true
    }) : target, mod));
var __toCommonJS = (mod)=>__copyProps(__defProp({}, "__esModule", {
        value: true
    }), mod);
var src_exports = {};
__export(src_exports, {
    AppConfig: ()=>import_tamagui.AppConfig,
    config: ()=>import_tamagui.default
});
module.exports = __toCommonJS(src_exports);
__reExport(src_exports, __webpack_require__(72520), module.exports);
__reExport(src_exports, __webpack_require__(86137), module.exports);
var import_tamagui = __toESM(__webpack_require__(49754));
// Annotate the CommonJS export names for ESM import in node:
0 && (0); //# sourceMappingURL=index.js.map


/***/ }),

/***/ 49754:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all)=>{
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var __copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of __getOwnPropNames(from))if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var __toCommonJS = (mod)=>__copyProps(__defProp({}, "__esModule", {
        value: true
    }), mod);
var tamagui_config_exports = {};
__export(tamagui_config_exports, {
    default: ()=>tamagui_config_default
});
module.exports = __toCommonJS(tamagui_config_exports);
var import_core = __webpack_require__(44996);
var import_font_fira_mono = __webpack_require__(69449);
var import_shorthands = __webpack_require__(63595);
var import_themes = __webpack_require__(8158);
var import_react_native_media_driver = __webpack_require__(85845);
var import_animations = __webpack_require__(86137);
const tokens = (0, import_core.createTokens)({
    ...import_themes.tokens,
    color: {
        ...import_themes.tokens.color,
        light: "#eeeeee",
        lightSecondary: "#d8d8d8",
        dark: "#0c0e11",
        darkSecondary: "#181c21"
    },
    size: {
        ...import_themes.tokens.size,
        xs: 660,
        sm: 800,
        md: 1020,
        lg: 1280,
        xl: 1420,
        xxl: 1600,
        gtXs: 660 + 1,
        gtSm: 800 + 1,
        gtMd: 1020 + 1,
        gtLg: 1280 + 1,
        short: 820,
        tall: 820
    }
});
const dark = (0, import_core.createTheme)({
    accent: "#2fcc76",
    primaryLight: "#77CED2",
    primary: "#00ADB5",
    primaryDark: "#18737B",
    primaryDarkest: "#24565E",
    text: "#eeeeee",
    textSecondary: "#d8d8d8",
    textAlt: "#0c0e11",
    textAltSecondary: "#181c21",
    background: "#262D34",
    light: tokens.color.light,
    lightSecondary: tokens.color.lightSecondary,
    dark: tokens.color.dark,
    darkSecondary: tokens.color.darkSecondary
});
const light = (0, import_core.createTheme)({
    ...dark,
    background: "#d8d8d8",
    text: "#0c0e11",
    textSecondary: "#181c21",
    textAlt: "#eeeeee",
    textAltSecondary: "#d8d8d8"
});
const headingFont = (0, import_font_fira_mono.createFiraMonoFont)({
    transform: {
        6: "uppercase",
        7: "none"
    },
    weight: {
        6: "400",
        7: "700"
    },
    color: {
        6: "$colorFocus",
        7: "$color"
    },
    letterSpacing: {
        5: 2,
        6: 1,
        7: 0,
        8: -1,
        9: -2,
        10: -3,
        12: -4,
        14: -5,
        15: -6
    },
    face: {
        700: {
            normal: "FiraMonoBold"
        }
    }
});
const bodyFont = (0, import_font_fira_mono.createFiraMonoFont)({
    face: {
        700: {
            normal: "FiraMonoBold"
        }
    }
});
const media = (0, import_react_native_media_driver.createMedia)({
    xs: {
        maxWidth: tokens.size.xs.val
    },
    sm: {
        maxWidth: tokens.size.sm.val
    },
    md: {
        maxWidth: tokens.size.md.val
    },
    lg: {
        maxWidth: tokens.size.lg.val
    },
    xl: {
        maxWidth: tokens.size.xl.val
    },
    xxl: {
        maxWidth: tokens.size.xxl.val
    },
    gtXs: {
        minWidth: tokens.size.gtXs.val
    },
    gtSm: {
        minWidth: tokens.size.gtSm.val
    },
    gtMd: {
        minWidth: tokens.size.gtMd.val
    },
    gtLg: {
        minWidth: tokens.size.gtLg.val
    },
    short: {
        maxHeight: tokens.size.short.val
    },
    tall: {
        minHeight: tokens.size.tall.val
    },
    hoverNone: {
        hover: "none"
    },
    pointerCoarse: {
        pointer: "coarse"
    }
});
const config = (0, import_core.createTamagui)({
    animations: import_animations.animations,
    shouldAddPrefersColorThemes: true,
    themeClassNameOnRoot: true,
    shorthands: import_shorthands.shorthands,
    fonts: {
        heading: headingFont,
        body: bodyFont
    },
    themes: {
        dark,
        light
    },
    tokens,
    media
});
var tamagui_config_default = config;
// Annotate the CommonJS export names for ESM import in node:
0 && (0); //# sourceMappingURL=tamagui.config.js.map


/***/ }),

/***/ 95613:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "hideOthers": function() { return /* reexport */ es2015/* hideOthers */.Ry; }
});

// EXTERNAL MODULE: ../../node_modules/aria-hidden/dist/es2015/index.js
var es2015 = __webpack_require__(49732);
;// CONCATENATED MODULE: ../../node_modules/@tamagui/aria-hidden/dist/jsx/AriaHidden.js

 //# sourceMappingURL=AriaHidden.js.map

;// CONCATENATED MODULE: ../../node_modules/@tamagui/aria-hidden/dist/jsx/index.js
 //# sourceMappingURL=index.js.map


/***/ }),

/***/ 50807:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "FocusScope": function() { return /* reexport */ FocusScope; }
});

// EXTERNAL MODULE: ../../node_modules/@tamagui/compose-refs/dist/esm/compose-refs.js
var compose_refs = __webpack_require__(14598);
// EXTERNAL MODULE: ../../node_modules/@tamagui/use-event/dist/esm/index.mjs + 2 modules
var esm = __webpack_require__(41277);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../node_modules/@tamagui/focus-scope/dist/jsx/FocusScope.js



const AUTOFOCUS_ON_MOUNT = "focusScope.autoFocusOnMount";
const AUTOFOCUS_ON_UNMOUNT = "focusScope.autoFocusOnUnmount";
const EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
const FOCUS_SCOPE_NAME = "FocusScope";
const FocusScope = /*#__PURE__*/ react.forwardRef((props, forwardedRef)=>{
    const { loop =false , trapped =false , onMountAutoFocus: onMountAutoFocusProp , onUnmountAutoFocus: onUnmountAutoFocusProp , children , forceUnmount , ...scopeProps } = props;
    const [container, setContainer] = react.useState(null);
    const onMountAutoFocus = (0,esm/* useEvent */.z)(onMountAutoFocusProp);
    const onUnmountAutoFocus = (0,esm/* useEvent */.z)(onUnmountAutoFocusProp);
    const lastFocusedElementRef = react.useRef(null);
    const composedRefs = (0,compose_refs/* useComposedRefs */.e)(forwardedRef, (node)=>setContainer(node));
    const focusScope = react.useRef({
        paused: false,
        pause () {
            this.paused = true;
        },
        resume () {
            this.paused = false;
        }
    }).current;
    react.useEffect(()=>{
        if (!trapped) return;
        function handleFocusIn(event) {
            if (focusScope.paused || !container) return;
            const target = event.target;
            if (container.contains(target)) {
                lastFocusedElementRef.current = target;
            } else {
                FocusScope_focus(lastFocusedElementRef.current, {
                    select: true
                });
            }
        }
        function handleFocusOut(event) {
            if (focusScope.paused || !container) return;
            if (!container.contains(event.relatedTarget)) {
                FocusScope_focus(lastFocusedElementRef.current, {
                    select: true
                });
            }
        }
        document.addEventListener("focusin", handleFocusIn);
        document.addEventListener("focusout", handleFocusOut);
        return ()=>{
            document.removeEventListener("focusin", handleFocusIn);
            document.removeEventListener("focusout", handleFocusOut);
        };
    }, [
        trapped,
        forceUnmount,
        container,
        focusScope.paused
    ]);
    react.useEffect(()=>{
        if (!container) return;
        if (forceUnmount) return;
        focusScopesStack.add(focusScope);
        const previouslyFocusedElement = document.activeElement;
        const hasFocusedCandidate = container.contains(previouslyFocusedElement);
        if (!hasFocusedCandidate) {
            const mountEvent = new CustomEvent(AUTOFOCUS_ON_MOUNT, EVENT_OPTIONS);
            container.addEventListener(AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
            container.dispatchEvent(mountEvent);
            if (!mountEvent.defaultPrevented) {
                focusFirst(removeLinks(getTabbableCandidates(container)), {
                    select: true
                });
                if (document.activeElement === previouslyFocusedElement) {
                    FocusScope_focus(container);
                }
            }
        }
        return ()=>{
            container.removeEventListener(AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
            const unmountEvent = new CustomEvent(AUTOFOCUS_ON_UNMOUNT, EVENT_OPTIONS);
            container.addEventListener(AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
            container.dispatchEvent(unmountEvent);
            if (!unmountEvent.defaultPrevented) {
                FocusScope_focus(previouslyFocusedElement !== null && previouslyFocusedElement !== void 0 ? previouslyFocusedElement : document.body, {
                    select: true
                });
            }
            container.removeEventListener(AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
            focusScopesStack.remove(focusScope);
        };
    }, [
        container,
        forceUnmount,
        onMountAutoFocus,
        onUnmountAutoFocus,
        focusScope
    ]);
    const handleKeyDown = react.useCallback((event)=>{
        if (!(loop || trapped)) return;
        if (focusScope.paused) return;
        const isTabKey = event.key === "Tab" && !event.altKey && !event.ctrlKey && !event.metaKey;
        const focusedElement = document.activeElement;
        if (isTabKey && focusedElement) {
            const container2 = event.currentTarget;
            const [first, last] = getTabbableEdges(container2);
            const hasTabbableElementsInside = first && last;
            if (!hasTabbableElementsInside) {
                if (focusedElement === container2) event.preventDefault();
            } else {
                if (!event.shiftKey && focusedElement === last) {
                    event.preventDefault();
                    if (loop) FocusScope_focus(first, {
                        select: true
                    });
                } else if (event.shiftKey && focusedElement === first) {
                    event.preventDefault();
                    if (loop) FocusScope_focus(last, {
                        select: true
                    });
                }
            }
        }
    }, [
        loop,
        trapped,
        focusScope.paused
    ]);
    const child = react.Children.only(children);
    return /*#__PURE__*/ react.cloneElement(child, {
        tabIndex: -1,
        ...scopeProps,
        ref: composedRefs,
        onKeyDown: handleKeyDown
    });
});
FocusScope.displayName = FOCUS_SCOPE_NAME;
function focusFirst(candidates) {
    let { select =false  } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const previouslyFocusedElement = document.activeElement;
    for (const candidate of candidates){
        FocusScope_focus(candidate, {
            select
        });
        if (document.activeElement !== previouslyFocusedElement) return;
    }
}
function getTabbableEdges(container) {
    const candidates = getTabbableCandidates(container);
    const first = findVisible(candidates, container);
    const last = findVisible(candidates.reverse(), container);
    return [
        first,
        last
    ];
}
function getTabbableCandidates(container) {
    const nodes = [];
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
        acceptNode: (node)=>{
            const isHiddenInput = node.tagName === "INPUT" && node.type === "hidden";
            if (node.disabled || node.hidden || isHiddenInput) return NodeFilter.FILTER_SKIP;
            return node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
    });
    while(walker.nextNode())nodes.push(walker.currentNode);
    return nodes;
}
function findVisible(elements, container) {
    for (const element of elements){
        if (!isHidden(element, {
            upTo: container
        })) return element;
    }
}
function isHidden(node, param) {
    let { upTo  } = param;
    if (getComputedStyle(node).visibility === "hidden") return true;
    while(node){
        if (upTo !== void 0 && node === upTo) return false;
        if (getComputedStyle(node).display === "none") return true;
        node = node.parentElement;
    }
    return false;
}
function isSelectableInput(element) {
    return element instanceof HTMLInputElement && "select" in element;
}
function FocusScope_focus(element) {
    let { select =false  } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (element === null || element === void 0 ? void 0 : element.focus) {
        const previouslyFocusedElement = document.activeElement;
        element.focus({
            preventScroll: true
        });
        if (element !== previouslyFocusedElement && isSelectableInput(element) && select) element.select();
    }
}
const focusScopesStack = createFocusScopesStack();
function createFocusScopesStack() {
    let stack = [];
    return {
        add (focusScope) {
            const activeFocusScope = stack[0];
            if (focusScope !== activeFocusScope) {
                activeFocusScope === null || activeFocusScope === void 0 ? void 0 : activeFocusScope.pause();
            }
            stack = arrayRemove(stack, focusScope);
            stack.unshift(focusScope);
        },
        remove (focusScope) {
            var ref;
            stack = arrayRemove(stack, focusScope);
            (ref = stack[0]) === null || ref === void 0 ? void 0 : ref.resume();
        }
    };
}
function arrayRemove(array, item) {
    const updatedArray = [
        ...array
    ];
    const index = updatedArray.indexOf(item);
    if (index !== -1) {
        updatedArray.splice(index, 1);
    }
    return updatedArray;
}
function removeLinks(items) {
    return items.filter((item)=>item.tagName !== "A");
}
 //# sourceMappingURL=FocusScope.js.map

;// CONCATENATED MODULE: ../../node_modules/@tamagui/focus-scope/dist/jsx/index.js
 //# sourceMappingURL=index.js.map


/***/ }),

/***/ 63463:
/***/ (function() {

//# sourceMappingURL=focusable.js.map


/***/ }),

/***/ 57622:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ focusableInputHOC; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _tamagui_compose_refs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14598);
/* harmony import */ var _tamagui_web__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85120);
/* harmony import */ var _tamagui_web__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4751);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _registerFocusable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20523);





function focusableInputHOC(Component) {
    const component = Component.extractable(/*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)((props, ref)=>{
        const isInput = (0,_tamagui_web__WEBPACK_IMPORTED_MODULE_2__/* .isTamaguiComponent */ .R)(Component) && Component.staticConfig.isInput;
        const inputValue = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(props.value || props.defaultValue || "");
        const unregisterFocusable = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
        const inputRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((input)=>{
            var ref;
            if (!props.id) return;
            if (!input) return;
            (ref = unregisterFocusable.current) === null || ref === void 0 ? void 0 : ref.call(unregisterFocusable);
            unregisterFocusable.current = (0,_registerFocusable__WEBPACK_IMPORTED_MODULE_3__/* .registerFocusable */ .QS)(props.id, {
                focus: input.focus,
                ...isInput && {
                    // react-native doesn't support programmatic .select()
                    focusAndSelect () {
                        input.focus();
                        if (input.setSelection && typeof inputValue.current === "string") {
                            input.setSelection(0, inputValue.current.length);
                        }
                    }
                }
            });
        }, [
            isInput,
            props.id
        ]);
        const combinedRefs = (0,_tamagui_compose_refs__WEBPACK_IMPORTED_MODULE_4__/* .composeRefs */ .F)(ref, inputRef);
        (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
            return ()=>{
                var ref;
                (ref = unregisterFocusable.current) === null || ref === void 0 ? void 0 : ref.call(unregisterFocusable);
            };
        }, []);
        const onChangeText = (0,_tamagui_web__WEBPACK_IMPORTED_MODULE_5__/* .useEvent */ .z)((value)=>{
            var ref;
            inputValue.current = value;
            (ref = props.onChangeText) === null || ref === void 0 ? void 0 : ref.call(props, value);
        });
        const finalProps = isInput ? {
            ...props,
            onChangeText
        } : props;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, {
            ref: combinedRefs,
            ...finalProps
        });
    }));
    return component;
}
 //# sourceMappingURL=focusableInputHOC.js.map


/***/ }),

/***/ 31390:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "focusFocusable": function() { return /* reexport safe */ _registerFocusable__WEBPACK_IMPORTED_MODULE_0__.Q8; },
/* harmony export */   "focusableInputHOC": function() { return /* reexport safe */ _focusableInputHOC__WEBPACK_IMPORTED_MODULE_1__.B; },
/* harmony export */   "registerFocusable": function() { return /* reexport safe */ _registerFocusable__WEBPACK_IMPORTED_MODULE_0__.QS; },
/* harmony export */   "unregisterFocusable": function() { return /* reexport safe */ _registerFocusable__WEBPACK_IMPORTED_MODULE_0__.Xe; }
/* harmony export */ });
/* harmony import */ var _registerFocusable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20523);
/* harmony import */ var _focusableInputHOC__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57622);
/* harmony import */ var _focusable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63463);
/* harmony import */ var _focusable__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_focusable__WEBPACK_IMPORTED_MODULE_2__);
/* harmony reexport (unknown) */ var __WEBPACK_REEXPORT_OBJECT__ = {};
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _focusable__WEBPACK_IMPORTED_MODULE_2__) if(["default","focusFocusable","registerFocusable","unregisterFocusable","focusableInputHOC"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) __WEBPACK_REEXPORT_OBJECT__[__WEBPACK_IMPORT_KEY__] = function(key) { return _focusable__WEBPACK_IMPORTED_MODULE_2__[key]; }.bind(0, __WEBPACK_IMPORT_KEY__)
/* harmony reexport (unknown) */ __webpack_require__.d(__webpack_exports__, __WEBPACK_REEXPORT_OBJECT__);


 //# sourceMappingURL=index.js.map


/***/ }),

/***/ 20523:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q8": function() { return /* binding */ focusFocusable; },
/* harmony export */   "QS": function() { return /* binding */ registerFocusable; },
/* harmony export */   "Xe": function() { return /* binding */ unregisterFocusable; }
/* harmony export */ });
const registerFocusable = (id, input)=>()=>{};
const unregisterFocusable = (id)=>{};
const focusFocusable = (id)=>{};
 //# sourceMappingURL=registerFocusable.js.map


/***/ }),

/***/ 69449:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "createFiraMonoFont": function() { return /* binding */ createFiraMonoFont; }
/* harmony export */ });
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47727);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11649);

const createFiraMonoFont = function() {
    let font = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_0__/* .createFont */ .v)({
        family: _tamagui_core__WEBPACK_IMPORTED_MODULE_1__/* .isWeb */ .$L ? "Fira Code, Monaco, Consolas, Ubuntu Mono, monospace" : "Fira",
        size,
        lineHeight: Object.fromEntries(Object.entries(size).map((param)=>{
            let [k, v] = param;
            return [
                k,
                v * 1.3
            ];
        })),
        weight: {
            4: "300",
            6: "700"
        },
        letterSpacing: {
            4: -0.25
        },
        ...font
    });
};
const size = {
    1: 10,
    2: 11,
    3: 12,
    4: 14,
    5: 15,
    6: 16,
    7: 20,
    8: 22,
    9: 30,
    10: 42,
    11: 52,
    12: 62,
    13: 72,
    14: 92,
    15: 114,
    16: 124
};
 //# sourceMappingURL=index.js.map


/***/ }),

/***/ 26296:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CW": function() { return /* binding */ getFontSizeVariable; },
/* harmony export */   "s_": function() { return /* binding */ getFontSizeToken; },
/* harmony export */   "yv": function() { return /* binding */ getFontSize; }
/* harmony export */ });
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13209);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47269);

const getFontSize = (inSize, opts)=>{
    const res = getFontSizeVariable(inSize, opts);
    if ((0,_tamagui_core__WEBPACK_IMPORTED_MODULE_0__/* .isVariable */ .cG)(res)) {
        return +res.val;
    }
    return res ? +res : 16;
};
const getFontSizeVariable = (inSize, opts)=>{
    const token = getFontSizeToken(inSize, opts);
    if (!token) {
        return inSize;
    }
    const conf = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_1__/* .getConfig */ .iE)();
    return conf.fontsParsed[(opts === null || opts === void 0 ? void 0 : opts.font) || "$body"].size[token];
};
const getFontSizeToken = (inSize, opts)=>{
    if (typeof inSize === "number") {
        return null;
    }
    const relativeSize = (opts === null || opts === void 0 ? void 0 : opts.relativeSize) || 0;
    const conf = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_1__/* .getConfig */ .iE)();
    const fontSize = conf.fontsParsed[(opts === null || opts === void 0 ? void 0 : opts.font) || "$body"].size;
    const size = inSize || ("$true" in fontSize ? "$true" : "$4");
    const sizeTokens = Object.keys(fontSize);
    let foundIndex = sizeTokens.indexOf(size);
    if (foundIndex === -1) {
        if (size.endsWith(".5")) {
            foundIndex = sizeTokens.indexOf(size.replace(".5", ""));
        }
    }
    if (false) {}
    const tokenIndex = Math.min(Math.max(0, foundIndex + relativeSize), sizeTokens.length - 1);
    var _tokenIndex;
    return (_tokenIndex = sizeTokens[tokenIndex]) !== null && _tokenIndex !== void 0 ? _tokenIndex : size;
};
 //# sourceMappingURL=getFontSize.js.map


/***/ }),

/***/ 99140:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "getFontSize": function() { return /* reexport safe */ _getFontSize__WEBPACK_IMPORTED_MODULE_0__.yv; },
/* harmony export */   "getFontSizeToken": function() { return /* reexport safe */ _getFontSize__WEBPACK_IMPORTED_MODULE_0__.s_; },
/* harmony export */   "getFontSizeVariable": function() { return /* reexport safe */ _getFontSize__WEBPACK_IMPORTED_MODULE_0__.CW; }
/* harmony export */ });
/* harmony import */ var _getFontSize__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26296);
 //# sourceMappingURL=index.js.map


/***/ }),

/***/ 60082:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Group": function() { return /* reexport */ Group; },
  "GroupFrame": function() { return /* reexport */ GroupFrame; },
  "XGroup": function() { return /* reexport */ XGroup; },
  "YGroup": function() { return /* reexport */ YGroup; },
  "useGroupItem": function() { return /* reexport */ useGroupItem; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./node_modules/@tamagui/web/dist/esm/styled.js
var styled = __webpack_require__(90662);
// EXTERNAL MODULE: ./node_modules/@tamagui/web/dist/esm/helpers/withStaticProperties.js
var withStaticProperties = __webpack_require__(74387);
// EXTERNAL MODULE: ./node_modules/@tamagui/web/dist/esm/hooks/useMedia.js
var useMedia = __webpack_require__(5755);
// EXTERNAL MODULE: ./node_modules/@tamagui/web/dist/esm/helpers/getExpandedShorthands.js
var getExpandedShorthands = __webpack_require__(57248);
// EXTERNAL MODULE: ./node_modules/@tamagui/web/dist/esm/createVariable.js
var createVariable = __webpack_require__(13209);
// EXTERNAL MODULE: ./node_modules/@tamagui/web/dist/esm/config.js
var config = __webpack_require__(47269);
// EXTERNAL MODULE: ./node_modules/@tamagui/web/dist/esm/helpers/isTamaguiElement.js
var isTamaguiElement = __webpack_require__(67423);
// EXTERNAL MODULE: ./node_modules/@tamagui/web/dist/esm/createComponent.js + 1 modules
var createComponent = __webpack_require__(6905);
// EXTERNAL MODULE: ./node_modules/@tamagui/web/dist/esm/helpers/mergeProps.js
var mergeProps = __webpack_require__(88410);
// EXTERNAL MODULE: ../../node_modules/@tamagui/create-context/dist/esm/create-context.js
var create_context = __webpack_require__(57846);
// EXTERNAL MODULE: ../../node_modules/@tamagui/stacks/dist/esm/ThemeableStack.js + 1 modules
var ThemeableStack = __webpack_require__(50733);
// EXTERNAL MODULE: ../../node_modules/@tamagui/use-controllable-state/dist/esm/useControllableState.js
var useControllableState = __webpack_require__(41439);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/exports/ScrollView/index.js + 2 modules
var ScrollView = __webpack_require__(79450);
// EXTERNAL MODULE: ../../node_modules/performant-array-to-tree/build/arrayToTree.min.js
var arrayToTree_min = __webpack_require__(17070);
;// CONCATENATED MODULE: ../../node_modules/reforest/dist/esm/index.js
// src/use-indexed-children.tsx


// src/contexts.ts

var PrerenderContext = react.createContext(false);
PrerenderContext.displayName = "PrerenderContext";
var MaxIndexContext = react.createContext([]);
MaxIndexContext.displayName = "MaxIndexContext";
var IndexContext = react.createContext(null);
IndexContext.displayName = "IndexContext";
var TreeStateContext = react.createContext(null);
TreeStateContext.displayName = "TreeStateContext";

// src/utils.ts


var isServer = typeof window === "undefined";
var useIsomorphicLayoutEffect = isServer ? react.useEffect : react.useLayoutEffect;
function parseIndexPath(indexPathString) {
  return indexPathString.split(".").map((index) => parseInt(index, 10));
}
function compareIndexPaths(a = "", b = "") {
  var _a, _b;
  let aArray = a.split(".").map(Number);
  let bArray = b.split(".").map(Number);
  if (aArray.includes(NaN) || bArray.includes(NaN)) {
    throw new Error("Version contains parts that are not numbers");
  }
  const maxLength = Math.max(a.length, b.length);
  for (let index = 0; index < maxLength; index++) {
    const difference = ((_a = aArray[index]) != null ? _a : 0) - ((_b = bArray[index]) != null ? _b : 0);
    if (difference === 0) {
      continue;
    }
    return difference > 0 ? 1 : -1;
  }
  return 0;
}
function cleanAndSortTree(tree) {
  var _a;
  if (((_a = tree.children) == null ? void 0 : _a.length) > 0) {
    tree.children.sort((a, b) => compareIndexPaths(a.indexPathString, b.indexPathString));
    return {
      ...tree.data,
      children: tree.children.map(cleanAndSortTree)
    };
  }
  return tree.data;
}
function mapToChildren(dataMap) {
  const parsedValues = Array.from(dataMap.entries()).map(([indexPathString, data]) => {
    const parentIndexPathString = parseIndexPath(indexPathString).slice(0, -1).join(".");
    return {
      data,
      parentId: parentIndexPathString,
      id: indexPathString
    };
  });
  const tree = arrayToTree(parsedValues, { dataField: null });
  const cleanedTree = cleanAndSortTree({ children: tree });
  return cleanedTree ? cleanedTree.children : [];
}
function sortMapByIndexPath(treeMap) {
  const sortedEntries = Array.from(treeMap.entries()).sort((a, b) => compareIndexPaths(a[0], b[0]));
  return new Map(sortedEntries);
}
function flattenChildren(children) {
  const flatChildren = children.flatMap(
    (child) => child.children ? flattenChildren(child.children) : [child]
  );
  return flatChildren;
}

// src/use-indexed-children.tsx
function useIndex() {
  const maxIndexPath = react.useContext(MaxIndexContext);
  const indexPathString = react.useContext(IndexContext);
  return react.useMemo(() => {
    if (indexPathString === null) {
      return null;
    }
    const indexPath = parseIndexPath(indexPathString);
    const maxIndex = maxIndexPath[maxIndexPath.length - 1];
    const index = indexPath[indexPath.length - 1];
    return {
      maxIndex,
      maxIndexPath,
      index,
      indexPath,
      indexPathString,
      isFirst: index === 0,
      isLast: index === maxIndex,
      isEven: index % 2 === 0,
      isOdd: Math.abs(index % 2) === 1
    };
  }, [maxIndexPath, indexPathString]);
}
function useIndexedChildren(children) {
  const parentMaxIndexPath = react.useContext(MaxIndexContext);
  const indexPathString = react.useContext(IndexContext);
  const childrenCount = react.Children.count(children);
  const maxIndexPath = react.useMemo(
    () => parentMaxIndexPath.concat(childrenCount - 1),
    [childrenCount]
  );
  return /* @__PURE__ */ react.createElement(MaxIndexContext.Provider, { value: maxIndexPath }, react.Children.map(
    children,
    (child, index) => react.isValidElement(child) ? /* @__PURE__ */ react.createElement(
      IndexContext.Provider,
      {
        key: child.key,
        value: indexPathString ? `${indexPathString}.${index.toString()}` : index.toString()
      },
      child
    ) : child
  ));
}

// src/use-roving-index.ts

function useRovingIndex({
  contain = true,
  defaultIndex = 0,
  maxIndex = Infinity,
  wrap = false
}) {
  const [activeIndex, setLocalActiveIndex] = React4.useState(defaultIndex);
  const getNextIndex = React4.useCallback(
    (nextIndex) => {
      if (wrap) {
        return (nextIndex % maxIndex + maxIndex) % maxIndex;
      }
      if (contain) {
        return nextIndex > maxIndex ? maxIndex : nextIndex < 0 ? 0 : nextIndex;
      }
      return nextIndex;
    },
    [maxIndex, wrap]
  );
  const moveActiveIndex = React4.useCallback(
    (amountToMove) => {
      setLocalActiveIndex((currentIndex) => getNextIndex(currentIndex + amountToMove));
    },
    [getNextIndex]
  );
  const setActiveIndex = React4.useCallback(
    (nextIndex) => {
      setLocalActiveIndex(getNextIndex(nextIndex));
    },
    [getNextIndex]
  );
  const moveBackward = React4.useCallback(() => moveActiveIndex(-1), [moveActiveIndex]);
  const moveForward = React4.useCallback(() => moveActiveIndex(1), [moveActiveIndex]);
  return {
    activeIndex,
    moveActiveIndex,
    setActiveIndex,
    moveBackward,
    moveForward,
    moveBackwardDisabled: activeIndex <= 0,
    moveForwardDisabled: activeIndex >= maxIndex
  };
}

// src/use-tree.tsx


function useTreeState(selector) {
  const treeStateContext = React5.useContext(TreeStateContext);
  const [treeState] = React5.useState(
    () => treeStateContext || create((set, get) => ({
      treeMap: /* @__PURE__ */ new Map(),
      prerenderedTreeIds: /* @__PURE__ */ new Map(),
      shouldPrerender: true,
      setTreeData: (id, data) => {
        const { treeMap } = get();
        treeMap.set(id, data);
        set({ treeMap: sortMapByIndexPath(treeMap) });
      },
      deleteTreeData: (id) => {
        const { treeMap } = get();
        treeMap.delete(id);
        set({ treeMap: sortMapByIndexPath(treeMap) });
      }
    }))
  );
  return selector ? treeState(selector) : treeState;
}
function PrerenderTree({ children }) {
  const treeState = useTreeState();
  const shouldPrerender = treeState((state) => state.shouldPrerender);
  useIsomorphicLayoutEffect(() => {
    treeState.setState({
      prerenderedTreeIds: /* @__PURE__ */ new Map(),
      shouldPrerender: false
    });
  }, []);
  return shouldPrerender ? /* @__PURE__ */ React5.createElement(PrerenderContext.Provider, { value: true }, children) : null;
}
function useTree(children, treeState) {
  const treeStateContext = React5.useContext(TreeStateContext);
  const treeStateLocal = useTreeState();
  const parsedTreeState = treeStateContext || treeState || treeStateLocal;
  const isPrerender = React5.useContext(PrerenderContext);
  const isRoot = treeStateContext === null;
  const indexedChildren = useIndexedChildren(children);
  const childrenToRender = isRoot ? /* @__PURE__ */ React5.createElement(TreeStateContext.Provider, { value: parsedTreeState }, /* @__PURE__ */ React5.createElement(PrerenderTree, null, indexedChildren), indexedChildren) : indexedChildren;
  return {
    children: childrenToRender,
    useStore: parsedTreeState,
    isPrerender,
    isRoot
  };
}
function useTreeNode(getData, dependencies = []) {
  const isPrerender = React5.useContext(PrerenderContext);
  const treeStateContext = React5.useContext(TreeStateContext);
  if (treeStateContext === null) {
    throw new Error("useTreeNode must be used in a descendant component of useTree.");
  }
  const { deleteTreeData, prerenderedTreeIds, setTreeData, treeMap } = treeStateContext.getState();
  const { indexPathString } = useIndex();
  const generatedId = React5.useId().slice(1, -1);
  const treeId = prerenderedTreeIds.get(indexPathString) || generatedId;
  const treeData = React5.useMemo(
    () => Object.assign({ treeId }, getData()),
    dependencies.concat(treeId)
  );
  if (isPrerender) {
    treeMap.set(indexPathString, treeData);
    prerenderedTreeIds.set(indexPathString, treeId);
  } else {
    React5.useEffect(() => {
      setTreeData(indexPathString, treeData);
      return () => {
        deleteTreeData(indexPathString);
      };
    }, [indexPathString, treeData]);
  }
  return {
    id: treeId,
    data: treeData,
    indexPathString,
    isPrerender
  };
}


;// CONCATENATED MODULE: ../../node_modules/@tamagui/group/dist/jsx/Group.js








const GROUP_NAME = "Group";
const [createGroupContext, createGroupScope] = (0,create_context/* createContextScope */.b)(GROUP_NAME);
const [GroupProvider, useGroupContext] = createGroupContext(GROUP_NAME);
const GroupFrame = (0,styled/* styled */.z)(ThemeableStack/* ThemeableStack */.K, {
    name: "GroupFrame",
    variants: {
        unstyled: {
            false: {
                size: "$true",
                y: 0,
                backgroundColor: "$background"
            }
        },
        size: (val, param)=>{
            let { tokens  } = param;
            var _val, ref;
            const borderRadius = (ref = (_val = tokens.radius[val]) !== null && _val !== void 0 ? _val : val) !== null && ref !== void 0 ? ref : tokens.radius["$true"];
            return {
                borderRadius
            };
        }
    },
    defaultVariants: {
        unstyled: false
    }
});
function createGroup(verticalDefault) {
    return (0,withStaticProperties/* withStaticProperties */.$)(/*#__PURE__*/ (0,react.forwardRef)((props, ref)=>{
        const activeProps = (0,useMedia/* useMediaPropsActive */.lA)(props);
        const { __scopeGroup , children: childrenProp , space , size ="$true" , spaceDirection , separator , scrollable , axis =verticalDefault ? "vertical" : "horizontal" , disabled: disabledProp , disablePassBorderRadius: disablePassBorderRadiusProp , borderRadius , forceUseItem , ...restProps } = (0,getExpandedShorthands/* getExpandedShorthands */.p)(activeProps);
        const vertical = axis === "vertical";
        const [itemChildrenCount, setItemChildrenCount] = (0,useControllableState/* useControllableState */.T)({
            defaultProp: forceUseItem ? 1 : 0
        });
        const isUsingItems = true;
        const radius = borderRadius !== null && borderRadius !== void 0 ? borderRadius : size ? (0,createVariable/* getVariableValue */.Ve)((0,config/* getTokens */.lz)().radius[size]) - 1 : void 0;
        const hasRadius = radius !== void 0;
        const disablePassBorderRadius = disablePassBorderRadiusProp !== null && disablePassBorderRadiusProp !== void 0 ? disablePassBorderRadiusProp : !hasRadius;
        if (!isUsingItems) console.log("screw up!");
        const childrenArray = react.Children.toArray(childrenProp);
        const children = isUsingItems ? childrenProp : childrenArray.map((child, i)=>{
            if (!/*#__PURE__*/ (0,react.isValidElement)(child)) {
                return child;
            }
            var _disabled;
            const disabled = (_disabled = child.props.disabled) !== null && _disabled !== void 0 ? _disabled : disabledProp;
            const isFirst = i === 0;
            const isLast = i === childrenArray.length - 1;
            const radiusStyles = disablePassBorderRadius === true ? null : getBorderRadius({
                isFirst,
                isLast,
                radius,
                vertical,
                disable: disablePassBorderRadius
            });
            const props2 = {
                disabled,
                ...(0,isTamaguiElement/* isTamaguiElement */.y)(child) ? radiusStyles : {
                    style: radiusStyles
                }
            };
            return cloneElementWithPropOrder(child, props2);
        });
        const indexedChildren = useIndexedChildren((0,createComponent/* spacedChildren */.P9)({
            direction: spaceDirection,
            separator,
            space,
            children
        }));
        const onItemMount = react.useCallback(()=>setItemChildrenCount((prev)=>prev + 1), []);
        const onItemUnmount = react.useCallback(()=>setItemChildrenCount((prev)=>prev - 1), []);
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(GroupProvider, {
            disablePassBorderRadius: disablePassBorderRadius,
            vertical: axis === "vertical",
            radius: radius,
            disabled: disabledProp,
            onItemMount: onItemMount,
            onItemUnmount: onItemUnmount,
            scope: __scopeGroup,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GroupFrame, {
                ref: ref,
                size: size,
                flexDirection: axis === "horizontal" ? "row" : "column",
                borderRadius: borderRadius,
                ...restProps,
                children: wrapScroll({
                    ...activeProps,
                    axis
                }, indexedChildren)
            })
        });
    }), {
        Item: GroupItem
    });
}
const GroupItem = (props)=>{
    var ref;
    const { __scopeGroup , children  } = props;
    const groupItemProps = useGroupItem({
        disabled: /*#__PURE__*/ (0,react.isValidElement)(children) ? children.props.disabled : void 0
    }, __scopeGroup);
    if (!/*#__PURE__*/ (0,react.isValidElement)(children)) {
        return children;
    }
    if ((0,isTamaguiElement/* isTamaguiElement */.y)(children)) {
        return /*#__PURE__*/ react.cloneElement(children, groupItemProps);
    }
    return /*#__PURE__*/ react.cloneElement(children, {
        style: {
            ...(ref = children.props) === null || ref === void 0 ? void 0 : ref["style"],
            ...groupItemProps
        }
    });
};
const useGroupItem = (childrenProps, __scopeGroup)=>{
    const treeIndex = useIndex();
    const context = useGroupContext("GroupItem", __scopeGroup);
    react.useEffect(()=>{
        context.onItemMount();
        return ()=>{
            context.onItemUnmount();
        };
    }, []);
    if (!treeIndex) {
        throw Error("<Group.Item/> should only be used within a <Group/>");
    }
    const isFirst = treeIndex.index === 0;
    const isLast = treeIndex.index === treeIndex.maxIndex;
    var _disabled;
    const disabled = (_disabled = childrenProps.disabled) !== null && _disabled !== void 0 ? _disabled : context.disabled;
    let propsToPass = {
        disabled
    };
    if (context.disablePassBorderRadius !== true) {
        const borderRadius = getBorderRadius({
            radius: context.radius,
            isFirst,
            isLast,
            vertical: context.vertical,
            disable: context.disablePassBorderRadius
        });
        return {
            ...propsToPass,
            ...borderRadius
        };
    }
    return propsToPass;
};
const Group = createGroup(true);
const YGroup = Group;
const XGroup = createGroup(false);
const wrapScroll = (param, children)=>{
    let { scrollable , axis , showScrollIndicator =false  } = param;
    if (scrollable) return /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollView/* default */.Z, {
        ...axis === "vertical" && {
            showsVerticalScrollIndicator: showScrollIndicator
        },
        ...axis === "horizontal" && {
            horizontal: true,
            showsHorizontalScrollIndicator: showScrollIndicator
        },
        children: children
    });
    return children;
};
const getBorderRadius = (param)=>{
    let { isFirst , isLast , radius , vertical , disable  } = param;
    return {
        borderTopLeftRadius: isFirst && disable !== "top" && disable !== "start" ? radius : 0,
        borderTopRightRadius: disable !== "top" && disable !== "end" && (vertical && isFirst || !vertical && isLast) ? radius : 0,
        borderBottomLeftRadius: disable !== "bottom" && disable !== "start" && (vertical && isLast || !vertical && isFirst) ? radius : 0,
        borderBottomRightRadius: isLast && disable !== "bottom" && disable !== "end" ? radius : 0
    };
};
const cloneElementWithPropOrder = (child, props)=>{
    const next = (0,mergeProps/* mergeProps */.d)(child.props, props, false, (0,config/* getConfig */.iE)().shorthands)[0];
    return /*#__PURE__*/ react.cloneElement({
        ...child,
        props: null
    }, next);
};
 //# sourceMappingURL=Group.js.map

;// CONCATENATED MODULE: ../../node_modules/@tamagui/group/dist/jsx/index.js
 //# sourceMappingURL=index.js.map


/***/ }),

/***/ 11335:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Image": function() { return /* reexport */ Image_Image; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./node_modules/@tamagui/web/dist/esm/setupReactNative.js
var setupReactNative = __webpack_require__(26575);
// EXTERNAL MODULE: ./node_modules/@tamagui/web/dist/esm/styled.js
var styled = __webpack_require__(90662);
// EXTERNAL MODULE: ./node_modules/@tamagui/web/dist/esm/hooks/useMedia.js
var useMedia = __webpack_require__(5755);
// EXTERNAL MODULE: ./node_modules/@tamagui/constants/dist/esm/index.mjs
var esm = __webpack_require__(11649);
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/exports/Image/index.js + 2 modules
var Image = __webpack_require__(79470);
;// CONCATENATED MODULE: ../../node_modules/@tamagui/image/dist/jsx/Image.js



(0,setupReactNative/* setupReactNative */.Gy)({
    Image: Image/* default */.Z
});
const StyledImage = (0,styled/* styled */.z)(Image/* default */.Z, {
    name: "Image",
    position: "relative",
    source: {
        uri: ""
    },
    zIndex: 1
});
const Image_Image = StyledImage.extractable((inProps)=>{
    const props = (0,useMedia/* useMediaPropsActive */.lA)(inProps);
    const { src , ...rest } = props;
    const source = typeof src === "string" ? {
        uri: src,
        ...esm/* isWeb */.$L && {
            width: props.width,
            height: props.height
        }
    } : src;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledImage, {
        source: source,
        ...rest
    });
});
 //# sourceMappingURL=Image.js.map

;// CONCATENATED MODULE: ../../node_modules/@tamagui/image/dist/jsx/index.js
 //# sourceMappingURL=index.js.map


/***/ }),

/***/ 49188:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F_": function() { return /* binding */ ListItemText; },
/* harmony export */   "HC": function() { return /* binding */ ListItem; },
/* harmony export */   "JA": function() { return /* binding */ useListItem; },
/* harmony export */   "cp": function() { return /* binding */ ListItemFrame; },
/* harmony export */   "ht": function() { return /* binding */ ListItemTitle; },
/* harmony export */   "jE": function() { return /* binding */ ListItemSubtitle; },
/* harmony export */   "zi": function() { return /* binding */ listItemStaticConfig; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90662);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5755);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(13209);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(47269);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(6905);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(74387);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(8573);
/* harmony import */ var _tamagui_font_size__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26296);
/* harmony import */ var _tamagui_helpers_tamagui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28920);
/* harmony import */ var _tamagui_stacks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50733);
/* harmony import */ var _tamagui_stacks__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(8939);
/* harmony import */ var _tamagui_text__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46003);
/* harmony import */ var _tamagui_text__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(31230);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);







const NAME = "ListItem";
const ListItemFrame = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .z)(_tamagui_stacks__WEBPACK_IMPORTED_MODULE_4__/* .ThemeableStack */ .K, {
    name: NAME,
    tag: "li",
    variants: {
        unstyled: {
            false: {
                size: "$true",
                alignItems: "center",
                flexWrap: "nowrap",
                width: "100%",
                borderColor: "$borderColor",
                maxWidth: "100%",
                overflow: "hidden",
                flexDirection: "row",
                backgroundColor: "$backgroundStrong"
            }
        },
        size: {
            "...size": (val, param)=>{
                let { tokens  } = param;
                return {
                    minHeight: tokens.size[val],
                    paddingHorizontal: tokens.space[val],
                    paddingVertical: (0,_tamagui_helpers_tamagui__WEBPACK_IMPORTED_MODULE_1__.getSpace)(val, -2)
                };
            }
        },
        active: {
            true: {
                hoverStyle: {
                    backgroundColor: "$background"
                }
            }
        },
        disabled: {
            true: {
                opacity: 0.5,
                // TODO breaking types
                pointerEvents: "none"
            }
        }
    },
    defaultVariants: {
        unstyled: false
    }
});
const ListItemText = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .z)(_tamagui_text__WEBPACK_IMPORTED_MODULE_5__/* .SizableText */ .J, {
    name: "ListItemText",
    variants: {
        unstyled: {
            false: {
                color: "$color",
                userSelect: "none",
                flexGrow: 1,
                flexShrink: 1,
                ellipse: true,
                cursor: "default"
            }
        }
    },
    defaultVariants: {
        unstyled: false
    }
});
const ListItemSubtitle = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .z)(ListItemText, {
    name: "ListItemSubtitle",
    variants: {
        unstyled: {
            false: {
                opacity: 0.6,
                maxWidth: "100%",
                size: "$3",
                color: "$color"
            }
        }
    },
    defaultVariants: {
        unstyled: false
    }
});
const ListItemTitle = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .z)(ListItemText, {
    name: "ListItemTitle"
});
const useListItem = function(props) {
    let { Text =ListItemText , Subtitle =ListItemSubtitle , Title =ListItemTitle  } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        Text: ListItemText,
        Subtitle: ListItemSubtitle,
        Title: ListItemTitle
    };
    const { children , icon , iconAfter , noTextWrap , theme: themeName , space , spaceFlex , scaleIcon =1 , scaleSpace =1 , subTitle , // text props
    color , fontWeight , letterSpacing , fontSize , fontFamily , textAlign , textProps , title , ...rest } = props;
    const mediaActiveProps = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_6__/* .useMediaPropsActive */ .lA)(props);
    const size = mediaActiveProps.size || "$true";
    const subtitleSize = "$".concat(+String(size).replace("$", "") - 1);
    const iconSize = (0,_tamagui_font_size__WEBPACK_IMPORTED_MODULE_7__/* .getFontSize */ .yv)(size) * scaleIcon;
    const getThemedIcon = (0,_tamagui_helpers_tamagui__WEBPACK_IMPORTED_MODULE_1__.useGetThemedIcon)({
        size: iconSize,
        color
    });
    const [themedIcon, themedIconAfter] = [
        icon,
        iconAfter
    ].map(getThemedIcon);
    var _space;
    const spaceSize = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_8__/* .getVariableValue */ .Ve)((_space = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_9__/* .getTokens */ .lz)().space[mediaActiveProps.space]) !== null && _space !== void 0 ? _space : iconSize) * scaleSpace;
    const contents = (0,_tamagui_text__WEBPACK_IMPORTED_MODULE_10__/* .wrapChildrenInText */ .k)(Text, mediaActiveProps);
    return {
        props: {
            fontFamily,
            ...rest,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    themedIcon ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            themedIcon,
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_tamagui_core__WEBPACK_IMPORTED_MODULE_11__/* .Spacer */ .LZ, {
                                size: spaceSize
                            })
                        ]
                    }) : null,
                    title || subTitle ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_tamagui_stacks__WEBPACK_IMPORTED_MODULE_12__/* .YStack */ .FA, {
                        flex: 1,
                        children: [
                            noTextWrap === "all" ? title : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Title, {
                                size: size,
                                children: title
                            }),
                            subTitle ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: typeof subTitle === "string" && noTextWrap !== "all" ? // TODO can use theme but we need to standardize to alt themes
                                // or standardize on subtle colors in themes
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Subtitle, {
                                    size: subtitleSize,
                                    children: subTitle
                                }) : subTitle
                            }) : null,
                            contents
                        ]
                    }) : contents,
                    themedIconAfter ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_tamagui_core__WEBPACK_IMPORTED_MODULE_11__/* .Spacer */ .LZ, {
                                size: spaceSize
                            }),
                            themedIconAfter
                        ]
                    }) : null
                ]
            })
        }
    };
};
const ListItemComponent = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)((props, ref)=>{
    const { props: listItemProps  } = useListItem(props);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ListItemFrame, {
        ref: ref,
        justifyContent: "space-between",
        ...listItemProps
    });
});
const listItemStaticConfig = {
    inlineProps: /* @__PURE__ */ new Set([
        // text props go here (can't really optimize them, but we never fully extract listItem anyway)
        "color",
        "fontWeight",
        "fontSize",
        "fontFamily",
        "letterSpacing",
        "textAlign"
    ])
};
const ListItem = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_13__/* .withStaticProperties */ .$)(ListItemFrame.extractable((0,_tamagui_core__WEBPACK_IMPORTED_MODULE_14__/* .themeable */ .Y)(ListItemComponent, {
    componentName: NAME
}), listItemStaticConfig), {
    Text: ListItemText,
    Subtitle: ListItemSubtitle
});
 //# sourceMappingURL=ListItem.js.map


/***/ }),

/***/ 95692:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ListItem": function() { return /* reexport safe */ _ListItem__WEBPACK_IMPORTED_MODULE_0__.HC; },
/* harmony export */   "ListItemFrame": function() { return /* reexport safe */ _ListItem__WEBPACK_IMPORTED_MODULE_0__.cp; },
/* harmony export */   "ListItemSubtitle": function() { return /* reexport safe */ _ListItem__WEBPACK_IMPORTED_MODULE_0__.jE; },
/* harmony export */   "ListItemText": function() { return /* reexport safe */ _ListItem__WEBPACK_IMPORTED_MODULE_0__.F_; },
/* harmony export */   "ListItemTitle": function() { return /* reexport safe */ _ListItem__WEBPACK_IMPORTED_MODULE_0__.ht; },
/* harmony export */   "listItemStaticConfig": function() { return /* reexport safe */ _ListItem__WEBPACK_IMPORTED_MODULE_0__.zi; },
/* harmony export */   "useListItem": function() { return /* reexport safe */ _ListItem__WEBPACK_IMPORTED_MODULE_0__.JA; }
/* harmony export */ });
/* harmony import */ var _ListItem__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49188);
 //# sourceMappingURL=index.js.map


/***/ }),

/***/ 18443:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all)=>{
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var __copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of __getOwnPropNames(from))if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var __toCommonJS = (mod)=>__copyProps(__defProp({}, "__esModule", {
        value: true
    }), mod);
var createTamagui_exports = {};
__export(createTamagui_exports, {
    createTamagui: ()=>createTamagui
});
module.exports = __toCommonJS(createTamagui_exports);
var import_core = __webpack_require__(44996);
const createTamagui =  true ? import_core.createTamagui : 0;
// Annotate the CommonJS export names for ESM import in node:
0 && (0); //# sourceMappingURL=createTamagui.js.map


/***/ }),

/***/ 70369:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all)=>{
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var __copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of __getOwnPropNames(from))if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var __toCommonJS = (mod)=>__copyProps(__defProp({}, "__esModule", {
        value: true
    }), mod);
var inputHelpers_exports = {};
__export(inputHelpers_exports, {
    inputSizeVariant: ()=>inputSizeVariant,
    textAreaSizeVariant: ()=>textAreaSizeVariant
});
module.exports = __toCommonJS(inputHelpers_exports);
var import_core = __webpack_require__(44996);
var import_get_button_sized = __webpack_require__(56701);
var import_get_font_sized = __webpack_require__(66754);
var import_get_size = __webpack_require__(20157);
const inputSizeVariant = function() {
    let val = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "$true", extras = arguments.length > 1 ? arguments[1] : void 0;
    if (extras.props.multiline || extras.props.numberOfLines > 1) {
        return textAreaSizeVariant(val, extras);
    }
    const buttonStyles = (0, import_get_button_sized.getButtonSized)(val, extras);
    const paddingHorizontal = (0, import_get_size.stepTokenUpOrDown)("space", val, -1, [
        2
    ]);
    const fontStyle = (0, import_get_font_sized.getFontSized)(val, extras);
    if (!import_core.isWeb && fontStyle) {
        delete fontStyle["lineHeight"];
    }
    return {
        ...fontStyle,
        ...buttonStyles,
        paddingHorizontal
    };
};
const textAreaSizeVariant = function() {
    let val = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "$true", extras = arguments.length > 1 ? arguments[1] : void 0;
    const { props  } = extras;
    const buttonStyles = (0, import_get_button_sized.getButtonSized)(val, extras);
    const fontStyle = (0, import_get_font_sized.getFontSized)(val, extras);
    const height = props.numberOfLines ? (props.numberOfLines || 1) * (0, import_core.getVariableValue)(fontStyle.lineHeight) : "auto";
    const paddingVertical = (0, import_get_size.stepTokenUpOrDown)("space", val, -2, [
        2
    ]);
    const paddingHorizontal = (0, import_get_size.stepTokenUpOrDown)("space", val, -1, [
        2
    ]);
    return {
        ...buttonStyles,
        ...fontStyle,
        paddingVertical,
        paddingHorizontal,
        height
    };
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0); //# sourceMappingURL=inputHelpers.js.map


/***/ }),

/***/ 72520:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all)=>{
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var __copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of __getOwnPropNames(from))if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var __reExport = (target, mod, secondTarget)=>(__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toCommonJS = (mod)=>__copyProps(__defProp({}, "__esModule", {
        value: true
    }), mod);
var src_exports = {};
__export(src_exports, {
    FontLanguage: ()=>import_core.FontLanguage,
    LinearGradient: ()=>LinearGradient,
    Spacer: ()=>import_core.Spacer,
    Stack: ()=>import_core.Stack,
    Text: ()=>import_core.Text,
    TextAncestorContext: ()=>import_core.TextAncestorContext,
    Theme: ()=>import_core.Theme,
    Unspaced: ()=>import_core.Unspaced,
    addTheme: ()=>import_core.addTheme,
    createComponent: ()=>import_core.createComponent,
    createFont: ()=>import_core.createFont,
    createShorthands: ()=>import_core.createShorthands,
    createTheme: ()=>import_core.createTheme,
    createTokens: ()=>import_core.createTokens,
    createVariable: ()=>import_core.createVariable,
    getAnimationDriver: ()=>import_core.getAnimationDriver,
    getConfig: ()=>import_core.getConfig,
    getMedia: ()=>import_core.getMedia,
    getStylesAtomic: ()=>import_core.getStylesAtomic,
    getThemes: ()=>import_core.getThemes,
    getTokens: ()=>import_core.getTokens,
    getVariable: ()=>import_core.getVariable,
    getVariableName: ()=>import_core.getVariableName,
    getVariableValue: ()=>import_core.getVariableValue,
    insertFont: ()=>import_core.insertFont,
    isChrome: ()=>import_core.isChrome,
    isClient: ()=>import_core.isClient,
    isServer: ()=>import_core.isServer,
    isTamaguiComponent: ()=>import_core.isTamaguiComponent,
    isTamaguiElement: ()=>import_core.isTamaguiElement,
    isTouchable: ()=>import_core.isTouchable,
    isVariable: ()=>import_core.isVariable,
    isWeb: ()=>import_core.isWeb,
    isWebTouchable: ()=>import_core.isWebTouchable,
    matchMedia: ()=>import_core.matchMedia,
    mediaObjectToString: ()=>import_core.mediaObjectToString,
    mediaQueryConfig: ()=>import_core.mediaQueryConfig,
    mediaState: ()=>import_core.mediaState,
    spacedChildren: ()=>import_core.spacedChildren,
    styled: ()=>import_core.styled,
    themeable: ()=>import_core.themeable,
    updateTheme: ()=>import_core.updateTheme,
    useDidFinishSSR: ()=>import_core.useDidFinishSSR,
    useEvent: ()=>import_core.useEvent,
    useGet: ()=>import_core.useGet,
    useIsTouchDevice: ()=>import_core.useIsTouchDevice,
    useIsomorphicLayoutEffect: ()=>import_core.useIsomorphicLayoutEffect,
    useMedia: ()=>import_core.useMedia,
    useSafeRef: ()=>import_core.useSafeRef,
    useStyle: ()=>import_core.useStyle,
    useTheme: ()=>import_core.useTheme,
    useThemeName: ()=>import_core.useThemeName,
    variableToString: ()=>import_core.variableToString,
    withStaticProperties: ()=>import_core.withStaticProperties
});
module.exports = __toCommonJS(src_exports);
__reExport(src_exports, __webpack_require__(72336), module.exports);
__reExport(src_exports, __webpack_require__(8242), module.exports);
__reExport(src_exports, __webpack_require__(85217), module.exports);
__reExport(src_exports, __webpack_require__(90625), module.exports);
__reExport(src_exports, __webpack_require__(92434), module.exports);
__reExport(src_exports, __webpack_require__(45517), module.exports);
__reExport(src_exports, __webpack_require__(65936), module.exports);
__reExport(src_exports, __webpack_require__(7199), module.exports);
__reExport(src_exports, __webpack_require__(71913), module.exports);
__reExport(src_exports, __webpack_require__(5339), module.exports);
__reExport(src_exports, __webpack_require__(99140), module.exports);
__reExport(src_exports, __webpack_require__(73322), module.exports);
__reExport(src_exports, __webpack_require__(60082), module.exports);
__reExport(src_exports, __webpack_require__(28920), module.exports);
__reExport(src_exports, __webpack_require__(11335), module.exports);
__reExport(src_exports, __webpack_require__(28339), module.exports);
__reExport(src_exports, __webpack_require__(95692), module.exports);
__reExport(src_exports, __webpack_require__(17272), module.exports);
__reExport(src_exports, __webpack_require__(48920), module.exports);
__reExport(src_exports, __webpack_require__(69564), module.exports);
__reExport(src_exports, __webpack_require__(45451), module.exports);
__reExport(src_exports, __webpack_require__(97922), module.exports);
__reExport(src_exports, __webpack_require__(81822), module.exports);
__reExport(src_exports, __webpack_require__(86515), module.exports);
__reExport(src_exports, __webpack_require__(55990), module.exports);
__reExport(src_exports, __webpack_require__(68534), module.exports);
__reExport(src_exports, __webpack_require__(24226), module.exports);
__reExport(src_exports, __webpack_require__(52526), module.exports);
__reExport(src_exports, __webpack_require__(84432), module.exports);
__reExport(src_exports, __webpack_require__(54348), module.exports);
__reExport(src_exports, __webpack_require__(48175), module.exports);
__reExport(src_exports, __webpack_require__(29727), module.exports);
__reExport(src_exports, __webpack_require__(35187), module.exports);
__reExport(src_exports, __webpack_require__(12113), module.exports);
__reExport(src_exports, __webpack_require__(29657), module.exports);
__reExport(src_exports, __webpack_require__(62391), module.exports);
__reExport(src_exports, __webpack_require__(88471), module.exports);
__reExport(src_exports, __webpack_require__(87130), module.exports);
__reExport(src_exports, __webpack_require__(24117), module.exports);
__reExport(src_exports, __webpack_require__(18443), module.exports);
__reExport(src_exports, __webpack_require__(27618), module.exports);
__reExport(src_exports, __webpack_require__(22863), module.exports);
__reExport(src_exports, __webpack_require__(91802), module.exports);
__reExport(src_exports, __webpack_require__(13739), module.exports);
__reExport(src_exports, __webpack_require__(48785), module.exports);
__reExport(src_exports, __webpack_require__(50331), module.exports);
__reExport(src_exports, __webpack_require__(64412), module.exports);
__reExport(src_exports, __webpack_require__(61337), module.exports);
__reExport(src_exports, __webpack_require__(43601), module.exports);
__reExport(src_exports, __webpack_require__(18554), module.exports);
var import_core = __webpack_require__(44996);
function LinearGradient(props) {
    if (false) {}
    return null;
}
// Annotate the CommonJS export names for ESM import in node:
0 && (0); //# sourceMappingURL=index.js.map


/***/ }),

/***/ 72336:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all)=>{
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var __copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of __getOwnPropNames(from))if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var __toESM = (mod, isNodeMode, target)=>(target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(// If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
        value: mod,
        enumerable: true
    }) : target, mod));
var __toCommonJS = (mod)=>__copyProps(__defProp({}, "__esModule", {
        value: true
    }), mod);
var setup_exports = {};
__export(setup_exports, {
    idFn: ()=>idFn
});
module.exports = __toCommonJS(setup_exports);
var import_core = __webpack_require__(44996);
var React = __toESM(__webpack_require__(2784));
var import_react_native = __webpack_require__(22164);
globalThis.React = React;
(0, import_core.setupReactNative)({
    View: import_react_native.View,
    Text: import_react_native.Text
});
if (typeof requestAnimationFrame === "undefined") {
    globalThis["requestAnimationFrame"] = setImmediate;
}
const cancelAnimationFrame = globalThis.cancelAnimationFrame;
__webpack_require__.g.cancelAnimationFrame = (x)=>{
    try {
        cancelAnimationFrame(x);
    } catch (e) {}
};
const idFn = ()=>{};
// Annotate the CommonJS export names for ESM import in node:
0 && (0); //# sourceMappingURL=setup.js.map


/***/ }),

/***/ 22863:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of __getOwnPropNames(from))if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var __toCommonJS = (mod)=>__copyProps(__defProp({}, "__esModule", {
        value: true
    }), mod);
var viewTypes_exports = {};
module.exports = __toCommonJS(viewTypes_exports); //# sourceMappingURL=viewTypes.js.map


/***/ }),

/***/ 91802:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all)=>{
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var __copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of __getOwnPropNames(from))if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var __toCommonJS = (mod)=>__copyProps(__defProp({}, "__esModule", {
        value: true
    }), mod);
var Anchor_exports = {};
__export(Anchor_exports, {
    Anchor: ()=>Anchor
});
module.exports = __toCommonJS(Anchor_exports);
var import_jsx_runtime = __webpack_require__(52322);
var import_core = __webpack_require__(44996);
var import_text = __webpack_require__(48175);
var import_react = __webpack_require__(2784);
var import_react_native = __webpack_require__(22164);
const AnchorFrame = (0, import_core.styled)(import_text.SizableText, {
    name: "Anchor",
    tag: "a",
    accessibilityRole: "link"
});
const Anchor = AnchorFrame.extractable((0, import_react.forwardRef)((param, ref)=>{
    let { href , target , ...props } = param;
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AnchorFrame, {
        ...props,
        ...import_core.isWeb ? {
            href,
            target
        } : {
            onPress: (event)=>{
                var _a;
                (_a = props.onPress) == null ? void 0 : _a.call(props, event);
                if (href !== void 0) {
                    import_react_native.Linking.openURL(href);
                }
            }
        },
        ref
    });
}));
// Annotate the CommonJS export names for ESM import in node:
0 && (0); //# sourceMappingURL=Anchor.js.map


/***/ }),

/***/ 13739:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all)=>{
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var __copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of __getOwnPropNames(from))if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var __toCommonJS = (mod)=>__copyProps(__defProp({}, "__esModule", {
        value: true
    }), mod);
var EnsureFlexed_exports = {};
__export(EnsureFlexed_exports, {
    EnsureFlexed: ()=>EnsureFlexed
});
module.exports = __toCommonJS(EnsureFlexed_exports);
var import_core = __webpack_require__(44996);
const EnsureFlexed = (0, import_core.styled)(import_core.Text, {
    opacity: 0,
    lineHeight: 0,
    height: 0,
    display: "flex",
    fontSize: 200,
    children: "wwwwwwwwwwwwwwwwwww",
    hoverStyle: {
        backgroundColor: "red"
    },
    pointerEvents: "none"
});
EnsureFlexed["isVisuallyHidden"] = true;
// Annotate the CommonJS export names for ESM import in node:
0 && (0); //# sourceMappingURL=EnsureFlexed.js.map


/***/ }),

/***/ 48785:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all)=>{
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var __copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of __getOwnPropNames(from))if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var __toCommonJS = (mod)=>__copyProps(__defProp({}, "__esModule", {
        value: true
    }), mod);
var Fieldset_exports = {};
__export(Fieldset_exports, {
    Fieldset: ()=>Fieldset
});
module.exports = __toCommonJS(Fieldset_exports);
var import_core = __webpack_require__(44996);
var import_stacks = __webpack_require__(84432);
const Fieldset = (0, import_core.styled)(import_stacks.YStack, {
    name: "Fieldset",
    tag: "fieldset",
    variants: {
        horizontal: {
            true: {
                flexDirection: "row",
                alignItems: "center"
            }
        }
    }
});
// Annotate the CommonJS export names for ESM import in node:
0 && (0); //# sourceMappingURL=Fieldset.js.map


/***/ }),

/***/ 50331:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all)=>{
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var __copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of __getOwnPropNames(from))if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var __toESM = (mod, isNodeMode, target)=>(target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(// If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
        value: mod,
        enumerable: true
    }) : target, mod));
var __toCommonJS = (mod)=>__copyProps(__defProp({}, "__esModule", {
        value: true
    }), mod);
var Grid_exports = {};
__export(Grid_exports, {
    Grid: ()=>Grid
});
module.exports = __toCommonJS(Grid_exports);
var import_jsx_runtime = __webpack_require__(52322);
var import_core = __webpack_require__(44996);
var import_stacks = __webpack_require__(84432);
var import_react = __toESM(__webpack_require__(2784));
function Grid(param) {
    let { children , columns , itemMinWidth =200 , gap  } = param;
    if (import_core.isWeb) {
        return /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", {
            style: {
                gap,
                display: "grid",
                justifyContent: "stretch",
                // gridTemplateRows: 'repeat(4, 1fr)',
                gridTemplateColumns: "repeat( auto-fit, minmax(".concat(itemMinWidth, "px, 1fr) )")
            },
            children
        });
    }
    const childrenList = import_react.default.Children.toArray(children);
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_stacks.XStack, {
        alignItems: "center",
        justifyContent: "center",
        flexWrap: "wrap",
        children: childrenList.map((child, i)=>{
            if (!child) {
                return null;
            }
            return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_stacks.XStack, {
                flex: 1,
                minWidth: itemMinWidth,
                marginRight: gap,
                marginBottom: gap,
                children: child
            }, i);
        })
    });
}
// Annotate the CommonJS export names for ESM import in node:
0 && (0); //# sourceMappingURL=Grid.js.map


/***/ }),

/***/ 64412:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all)=>{
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var __copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of __getOwnPropNames(from))if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var __toCommonJS = (mod)=>__copyProps(__defProp({}, "__esModule", {
        value: true
    }), mod);
var Input_exports = {};
__export(Input_exports, {
    Input: ()=>Input,
    InputFrame: ()=>InputFrame,
    defaultStyles: ()=>defaultStyles
});
module.exports = __toCommonJS(Input_exports);
var import_core = __webpack_require__(44996);
var import_focusable = __webpack_require__(31390);
var import_react_native = __webpack_require__(22164);
var import_inputHelpers = __webpack_require__(70369);
(0, import_core.setupReactNative)({
    TextInput: import_react_native.TextInput
});
const defaultStyles = {
    size: "$true",
    fontFamily: "$body",
    borderWidth: 1,
    outlineWidth: 0,
    color: "$color",
    focusable: true,
    borderColor: "$borderColor",
    backgroundColor: "$background",
    placeholderTextColor: "$placeholderColor",
    // this fixes a flex bug where it overflows container
    minWidth: 0,
    hoverStyle: {
        borderColor: "$borderColorHover"
    },
    focusStyle: {
        borderColor: "$borderColorFocus",
        borderWidth: 2,
        marginHorizontal: -1
    }
};
const InputFrame = (0, import_core.styled)(import_react_native.TextInput, {
    name: "Input",
    variants: {
        unstyled: {
            false: defaultStyles
        },
        size: {
            "...size": import_inputHelpers.inputSizeVariant
        }
    },
    defaultVariants: {
        unstyled: false
    }
}, {
    isInput: true
});
const Input = (0, import_focusable.focusableInputHOC)(InputFrame);
// Annotate the CommonJS export names for ESM import in node:
0 && (0); //# sourceMappingURL=Input.js.map


/***/ }),

/***/ 61337:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all)=>{
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var __copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of __getOwnPropNames(from))if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var __toCommonJS = (mod)=>__copyProps(__defProp({}, "__esModule", {
        value: true
    }), mod);
var Layouts_exports = {};
__export(Layouts_exports, {
    Article: ()=>Article,
    Aside: ()=>Aside,
    Footer: ()=>Footer,
    Header: ()=>Header,
    Main: ()=>Main,
    Nav: ()=>Nav,
    Section: ()=>Section
});
module.exports = __toCommonJS(Layouts_exports);
var import_core = __webpack_require__(44996);
const Section = (0, import_core.styled)(import_core.Stack, {
    name: "Section",
    tag: "section",
    flexDirection: "column",
    accessibilityRole: "summary"
});
const Article = (0, import_core.styled)(import_core.Stack, {
    name: "Article",
    tag: "article",
    flexDirection: "column"
});
const Main = (0, import_core.styled)(import_core.Stack, {
    name: "Main",
    tag: "main",
    flexDirection: "column"
});
const Header = (0, import_core.styled)(import_core.Stack, {
    name: "Header",
    tag: "header",
    accessibilityRole: "header",
    flexDirection: "column"
});
const Aside = (0, import_core.styled)(import_core.Stack, {
    name: "Aside",
    tag: "aside",
    flexDirection: "column"
});
const Footer = (0, import_core.styled)(import_core.Stack, {
    name: "Footer",
    tag: "footer",
    flexDirection: "column"
});
const Nav = (0, import_core.styled)(import_core.Stack, {
    name: "Nav",
    tag: "nav",
    flexDirection: "column"
});
// Annotate the CommonJS export names for ESM import in node:
0 && (0); //# sourceMappingURL=Layouts.js.map


/***/ }),

/***/ 43601:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all)=>{
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var __copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of __getOwnPropNames(from))if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var __toESM = (mod, isNodeMode, target)=>(target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(// If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
        value: mod,
        enumerable: true
    }) : target, mod));
var __toCommonJS = (mod)=>__copyProps(__defProp({}, "__esModule", {
        value: true
    }), mod);
var Spinner_exports = {};
__export(Spinner_exports, {
    Spinner: ()=>Spinner
});
module.exports = __toCommonJS(Spinner_exports);
var import_jsx_runtime = __webpack_require__(52322);
var import_core = __webpack_require__(44996);
var import_stacks = __webpack_require__(84432);
var React = __toESM(__webpack_require__(2784));
var import_react_native = __webpack_require__(22164);
const Spinner = import_stacks.YStack.extractable((0, import_core.themeable)(React.forwardRef((props, ref)=>{
    const { size , color: colorProp , ...stackProps } = props;
    const theme = (0, import_core.useTheme)();
    let color = colorProp;
    if (color && color[0] === "$") {
        color = (0, import_core.variableToString)(theme[color]);
    }
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_stacks.YStack, {
        ref,
        ...stackProps,
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_native.ActivityIndicator, {
            size,
            color
        })
    });
}), {
    componentName: "Spinner"
}));
// Annotate the CommonJS export names for ESM import in node:
0 && (0); //# sourceMappingURL=Spinner.js.map


/***/ }),

/***/ 27618:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all)=>{
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var __copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of __getOwnPropNames(from))if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var __toCommonJS = (mod)=>__copyProps(__defProp({}, "__esModule", {
        value: true
    }), mod);
var TamaguiProvider_exports = {};
__export(TamaguiProvider_exports, {
    TamaguiProvider: ()=>TamaguiProvider
});
module.exports = __toCommonJS(TamaguiProvider_exports);
var import_jsx_runtime = __webpack_require__(52322);
var import_core = __webpack_require__(44996);
var import_portal = __webpack_require__(69564);
const TamaguiProvider = import_core.isRSC ? import_core.TamaguiProvider : (param)=>{
    let { children , ...props } = param;
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_core.TamaguiProvider, {
        ...props,
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_portal.PortalProvider, {
            shouldAddRootHost: true,
            children
        })
    });
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0); //# sourceMappingURL=TamaguiProvider.js.map


/***/ }),

/***/ 18554:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all)=>{
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var __copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of __getOwnPropNames(from))if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var __toCommonJS = (mod)=>__copyProps(__defProp({}, "__esModule", {
        value: true
    }), mod);
var TextArea_exports = {};
__export(TextArea_exports, {
    TextArea: ()=>TextArea,
    TextAreaFrame: ()=>TextAreaFrame
});
module.exports = __toCommonJS(TextArea_exports);
var import_core = __webpack_require__(44996);
var import_focusable = __webpack_require__(31390);
var import_inputHelpers = __webpack_require__(70369);
var import_Input = __webpack_require__(64412);
const TextAreaFrame = (0, import_core.styled)(import_Input.InputFrame, {
    name: "TextArea",
    multiline: true,
    variants: {
        unstyled: {
            false: {
                ...import_Input.defaultStyles,
                height: "auto",
                numberOfLines: 4
            }
        },
        size: {
            "...size": import_inputHelpers.textAreaSizeVariant
        }
    },
    defaultVariants: {
        unstyled: false
    }
});
const TextArea = (0, import_focusable.focusableInputHOC)(TextAreaFrame);
// Annotate the CommonJS export names for ESM import in node:
0 && (0); //# sourceMappingURL=TextArea.js.map


/***/ }),

/***/ 34852:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 50433:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 21772:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 97729:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(35126)


/***/ }),

/***/ 45847:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports =
   false
    ? 0
    : __webpack_require__(9664)


/***/ }),

/***/ 89817:
/***/ (function(module) {

/*
 * Copyright (c) 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

function normalizeColor(color) {
  var match;

  if (typeof color === 'number') {
    if (color >>> 0 === color && color >= 0 && color <= 0xffffffff) {
      return color;
    }
    return null;
  }

  // Ordered based on occurrences on Facebook codebase
  if ((match = matchers.hex6.exec(color))) {
    return parseInt(match[1] + 'ff', 16) >>> 0;
  }

  if (names.hasOwnProperty(color)) {
    return names[color];
  }

  if ((match = matchers.rgb.exec(color))) {
    return (
        parse255(match[1]) << 24 | // r
        parse255(match[2]) << 16 | // g
        parse255(match[3]) << 8 | // b
        0x000000ff // a
      ) >>> 0;
  }

  if ((match = matchers.rgba.exec(color))) {
    return (
        parse255(match[1]) << 24 | // r
        parse255(match[2]) << 16 | // g
        parse255(match[3]) << 8 | // b
        parse1(match[4]) // a
      ) >>> 0;
  }

  if ((match = matchers.hex3.exec(color))) {
    return parseInt(
        match[1] + match[1] + // r
        match[2] + match[2] + // g
        match[3] + match[3] + // b
        'ff', // a
        16
      ) >>> 0;
  }

  // https://drafts.csswg.org/css-color-4/#hex-notation
  if ((match = matchers.hex8.exec(color))) {
    return parseInt(match[1], 16) >>> 0;
  }

  if ((match = matchers.hex4.exec(color))) {
    return parseInt(
        match[1] + match[1] + // r
        match[2] + match[2] + // g
        match[3] + match[3] + // b
        match[4] + match[4], // a
        16
      ) >>> 0;
  }

  if ((match = matchers.hsl.exec(color))) {
    return (
        hslToRgb(
          parse360(match[1]), // h
          parsePercentage(match[2]), // s
          parsePercentage(match[3]) // l
        ) |
        0x000000ff // a
      ) >>> 0;
  }

  if ((match = matchers.hsla.exec(color))) {
    return (
        hslToRgb(
          parse360(match[1]), // h
          parsePercentage(match[2]), // s
          parsePercentage(match[3]) // l
        ) |
        parse1(match[4]) // a
      ) >>> 0;
  }

  return null;
}

function hue2rgb(p, q, t) {
  if (t < 0) {
    t += 1;
  }
  if (t > 1) {
    t -= 1;
  }
  if (t < 1 / 6) {
    return p + (q - p) * 6 * t;
  }
  if (t < 1 / 2) {
    return q;
  }
  if (t < 2 / 3) {
    return p + (q - p) * (2 / 3 - t) * 6;
  }
  return p;
}

function hslToRgb(h, s, l) {
  var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
  var p = 2 * l - q;
  var r = hue2rgb(p, q, h + 1 / 3);
  var g = hue2rgb(p, q, h);
  var b = hue2rgb(p, q, h - 1 / 3);

  return (
    Math.round(r * 255) << 24 |
    Math.round(g * 255) << 16 |
    Math.round(b * 255) << 8
  );
}

// var INTEGER = '[-+]?\\d+';
var NUMBER = '[-+]?\\d*\\.?\\d+';
var PERCENTAGE = NUMBER + '%';

function toArray(arrayLike) {
  return Array.prototype.slice.call(arrayLike, 0);
}

function call() {
  return '\\(\\s*(' + toArray(arguments).join(')\\s*,\\s*(') + ')\\s*\\)';
}

var matchers = {
  rgb: new RegExp('rgb' + call(NUMBER, NUMBER, NUMBER)),
  rgba: new RegExp('rgba' + call(NUMBER, NUMBER, NUMBER, NUMBER)),
  hsl: new RegExp('hsl' + call(NUMBER, PERCENTAGE, PERCENTAGE)),
  hsla: new RegExp('hsla' + call(NUMBER, PERCENTAGE, PERCENTAGE, NUMBER)),
  hex3: /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex4: /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex6: /^#([0-9a-fA-F]{6})$/,
  hex8: /^#([0-9a-fA-F]{8})$/,
};

function parse255(str) {
  var int = parseInt(str, 10);
  if (int < 0) {
    return 0;
  }
  if (int > 255) {
    return 255;
  }
  return int;
}

function parse360(str) {
  var int = parseFloat(str);
  return (((int % 360) + 360) % 360) / 360;
}

function parse1(str) {
  var num = parseFloat(str);
  if (num < 0) {
    return 0;
  }
  if (num > 1) {
    return 255;
  }
  return Math.round(num * 255);
}

function parsePercentage(str) {
  // parseFloat conveniently ignores the final %
  var int = parseFloat(str, 10);
  if (int < 0) {
    return 0;
  }
  if (int > 100) {
    return 1;
  }
  return int / 100;
}

var names = {
  transparent: 0x00000000,

  // http://www.w3.org/TR/css3-color/#svg-color
  aliceblue: 0xf0f8ffff,
  antiquewhite: 0xfaebd7ff,
  aqua: 0x00ffffff,
  aquamarine: 0x7fffd4ff,
  azure: 0xf0ffffff,
  beige: 0xf5f5dcff,
  bisque: 0xffe4c4ff,
  black: 0x000000ff,
  blanchedalmond: 0xffebcdff,
  blue: 0x0000ffff,
  blueviolet: 0x8a2be2ff,
  brown: 0xa52a2aff,
  burlywood: 0xdeb887ff,
  burntsienna: 0xea7e5dff,
  cadetblue: 0x5f9ea0ff,
  chartreuse: 0x7fff00ff,
  chocolate: 0xd2691eff,
  coral: 0xff7f50ff,
  cornflowerblue: 0x6495edff,
  cornsilk: 0xfff8dcff,
  crimson: 0xdc143cff,
  cyan: 0x00ffffff,
  darkblue: 0x00008bff,
  darkcyan: 0x008b8bff,
  darkgoldenrod: 0xb8860bff,
  darkgray: 0xa9a9a9ff,
  darkgreen: 0x006400ff,
  darkgrey: 0xa9a9a9ff,
  darkkhaki: 0xbdb76bff,
  darkmagenta: 0x8b008bff,
  darkolivegreen: 0x556b2fff,
  darkorange: 0xff8c00ff,
  darkorchid: 0x9932ccff,
  darkred: 0x8b0000ff,
  darksalmon: 0xe9967aff,
  darkseagreen: 0x8fbc8fff,
  darkslateblue: 0x483d8bff,
  darkslategray: 0x2f4f4fff,
  darkslategrey: 0x2f4f4fff,
  darkturquoise: 0x00ced1ff,
  darkviolet: 0x9400d3ff,
  deeppink: 0xff1493ff,
  deepskyblue: 0x00bfffff,
  dimgray: 0x696969ff,
  dimgrey: 0x696969ff,
  dodgerblue: 0x1e90ffff,
  firebrick: 0xb22222ff,
  floralwhite: 0xfffaf0ff,
  forestgreen: 0x228b22ff,
  fuchsia: 0xff00ffff,
  gainsboro: 0xdcdcdcff,
  ghostwhite: 0xf8f8ffff,
  gold: 0xffd700ff,
  goldenrod: 0xdaa520ff,
  gray: 0x808080ff,
  green: 0x008000ff,
  greenyellow: 0xadff2fff,
  grey: 0x808080ff,
  honeydew: 0xf0fff0ff,
  hotpink: 0xff69b4ff,
  indianred: 0xcd5c5cff,
  indigo: 0x4b0082ff,
  ivory: 0xfffff0ff,
  khaki: 0xf0e68cff,
  lavender: 0xe6e6faff,
  lavenderblush: 0xfff0f5ff,
  lawngreen: 0x7cfc00ff,
  lemonchiffon: 0xfffacdff,
  lightblue: 0xadd8e6ff,
  lightcoral: 0xf08080ff,
  lightcyan: 0xe0ffffff,
  lightgoldenrodyellow: 0xfafad2ff,
  lightgray: 0xd3d3d3ff,
  lightgreen: 0x90ee90ff,
  lightgrey: 0xd3d3d3ff,
  lightpink: 0xffb6c1ff,
  lightsalmon: 0xffa07aff,
  lightseagreen: 0x20b2aaff,
  lightskyblue: 0x87cefaff,
  lightslategray: 0x778899ff,
  lightslategrey: 0x778899ff,
  lightsteelblue: 0xb0c4deff,
  lightyellow: 0xffffe0ff,
  lime: 0x00ff00ff,
  limegreen: 0x32cd32ff,
  linen: 0xfaf0e6ff,
  magenta: 0xff00ffff,
  maroon: 0x800000ff,
  mediumaquamarine: 0x66cdaaff,
  mediumblue: 0x0000cdff,
  mediumorchid: 0xba55d3ff,
  mediumpurple: 0x9370dbff,
  mediumseagreen: 0x3cb371ff,
  mediumslateblue: 0x7b68eeff,
  mediumspringgreen: 0x00fa9aff,
  mediumturquoise: 0x48d1ccff,
  mediumvioletred: 0xc71585ff,
  midnightblue: 0x191970ff,
  mintcream: 0xf5fffaff,
  mistyrose: 0xffe4e1ff,
  moccasin: 0xffe4b5ff,
  navajowhite: 0xffdeadff,
  navy: 0x000080ff,
  oldlace: 0xfdf5e6ff,
  olive: 0x808000ff,
  olivedrab: 0x6b8e23ff,
  orange: 0xffa500ff,
  orangered: 0xff4500ff,
  orchid: 0xda70d6ff,
  palegoldenrod: 0xeee8aaff,
  palegreen: 0x98fb98ff,
  paleturquoise: 0xafeeeeff,
  palevioletred: 0xdb7093ff,
  papayawhip: 0xffefd5ff,
  peachpuff: 0xffdab9ff,
  peru: 0xcd853fff,
  pink: 0xffc0cbff,
  plum: 0xdda0ddff,
  powderblue: 0xb0e0e6ff,
  purple: 0x800080ff,
  rebeccapurple: 0x663399ff,
  red: 0xff0000ff,
  rosybrown: 0xbc8f8fff,
  royalblue: 0x4169e1ff,
  saddlebrown: 0x8b4513ff,
  salmon: 0xfa8072ff,
  sandybrown: 0xf4a460ff,
  seagreen: 0x2e8b57ff,
  seashell: 0xfff5eeff,
  sienna: 0xa0522dff,
  silver: 0xc0c0c0ff,
  skyblue: 0x87ceebff,
  slateblue: 0x6a5acdff,
  slategray: 0x708090ff,
  slategrey: 0x708090ff,
  snow: 0xfffafaff,
  springgreen: 0x00ff7fff,
  steelblue: 0x4682b4ff,
  tan: 0xd2b48cff,
  teal: 0x008080ff,
  thistle: 0xd8bfd8ff,
  tomato: 0xff6347ff,
  turquoise: 0x40e0d0ff,
  violet: 0xee82eeff,
  wheat: 0xf5deb3ff,
  white: 0xffffffff,
  whitesmoke: 0xf5f5f5ff,
  yellow: 0xffff00ff,
  yellowgreen: 0x9acd32ff,
};

function rgba(colorInt) {
  var r = Math.round(((colorInt & 0xff000000) >>> 24));
  var g = Math.round(((colorInt & 0x00ff0000) >>> 16));
  var b = Math.round(((colorInt & 0x0000ff00) >>> 8));
  var a = ((colorInt & 0x000000ff) >>> 0) / 255;
  return {
    r: r,
    g: g,
    b: b,
    a: a,
  };
};

normalizeColor.rgba = rgba;

module.exports = normalizeColor;


/***/ }),

/***/ 9057:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var process = __webpack_require__(34406);
// Generated by CoffeeScript 1.12.2
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

//# sourceMappingURL=performance-now.js.map


/***/ }),

/***/ 17070:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __assign=this&&this.__assign||function(){return(__assign=Object.assign||function(e){for(var r,t=1,n=arguments.length;t<n;t++)for(var o in r=arguments[t])Object.prototype.hasOwnProperty.call(r,o)&&(e[o]=r[o]);return e}).apply(this,arguments)},defaultConfig=(Object.defineProperty(exports,"__esModule",{value:!0}),{id:"id",parentId:"parentId",dataField:"data",childrenField:"children",throwIfOrphans:!1,rootParentIds:{"":!(exports.countNodes=exports.arrayToTree=void 0)},nestedIds:!0,assign:!1});function arrayToTree(c,e){void 0===e&&(e={});for(var r,t=__assign(__assign({},defaultConfig),e),n=[],o={},a=t.throwIfOrphans?new Set:null,s=0,h=c;s<h.length;s++){var i=h[s],d=t.nestedIds?getNestedProperty(i,t.id):i[t.id],l=t.nestedIds?getNestedProperty(i,t.parentId):i[t.parentId];if(t.rootParentIds[d])throw new Error("The item array contains a node whose parentId both exists in another node and is in "+'`rootParentIds` (`itemId`: "'.concat(d,'", `rootParentIds`: ').concat(Object.keys(t.rootParentIds).map(function(e){return'"'.concat(e,'"')}).join(", "),")."));Object.prototype.hasOwnProperty.call(o,d)||(o[d]=((r={})[t.childrenField]=[],r)),a&&a.delete(d),t.dataField?o[d][t.dataField]=i:t.assign?o[d]=Object.assign(i,((r={})[t.childrenField]=o[d][t.childrenField],r)):o[d]=__assign(__assign({},i),((i={})[t.childrenField]=o[d][t.childrenField],i));i=o[d];null==l||t.rootParentIds[l]?n.push(i):(Object.prototype.hasOwnProperty.call(o,l)||(o[l]=((d={})[t.childrenField]=[],d),a&&a.add(l)),o[l][t.childrenField].push(i))}if(null!=a&&a.size)throw new Error("The items array contains orphans that point to the following parentIds: "+"[".concat(Array.from(a),"]. These parentIds do not exist in the items array. Hint: prevent orphans to result ")+"in an error by passing the following option: { throwIfOrphans: false }");if(t.throwIfOrphans&&countNodes(n,t.childrenField)<Object.keys(o).length)throw new Error("The items array contains nodes with a circular parent/child relationship.");return n}function countNodes(e,t){return e.reduce(function(e,r){return e+1+(r[t]&&countNodes(r[t],t))},0)}function getNestedProperty(e,r){return r.split(".").reduce(function(e,r){return e&&e[r]},e)}exports.arrayToTree=arrayToTree,exports.countNodes=countNodes;

/***/ }),

/***/ 34406:
/***/ (function(module) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ 23493:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var now = __webpack_require__(9057)
  , root = typeof window === 'undefined' ? __webpack_require__.g : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function(object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf
  object.cancelAnimationFrame = caf
}


/***/ }),

/***/ 98728:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

(__webpack_require__(23493).polyfill)()


/***/ }),

/***/ 25825:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7896);
/* harmony import */ var _babel_runtime_helpers_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31461);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _StyleSheet__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66068);
/* harmony import */ var _View__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25686);


var _excluded = ["animating", "color", "hidesWhenStopped", "size", "style"];

/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */




var createSvgCircle = style => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", {
  cx: "16",
  cy: "16",
  fill: "none",
  r: "14",
  strokeWidth: "4",
  style: style
});

var ActivityIndicator = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((props, forwardedRef) => {
  var _props$animating = props.animating,
      animating = _props$animating === void 0 ? true : _props$animating,
      _props$color = props.color,
      color = _props$color === void 0 ? '#1976D2' : _props$color,
      _props$hidesWhenStopp = props.hidesWhenStopped,
      hidesWhenStopped = _props$hidesWhenStopp === void 0 ? true : _props$hidesWhenStopp,
      _props$size = props.size,
      size = _props$size === void 0 ? 'small' : _props$size,
      style = props.style,
      other = (0,_babel_runtime_helpers_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(props, _excluded);

  var svg = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
    height: "100%",
    viewBox: "0 0 32 32",
    width: "100%"
  }, createSvgCircle({
    stroke: color,
    opacity: 0.2
  }), createSvgCircle({
    stroke: color,
    strokeDasharray: 80,
    strokeDashoffset: 60
  }));
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_View__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, other, {
    accessibilityRole: "progressbar",
    accessibilityValueMax: 1,
    accessibilityValueMin: 0,
    ref: forwardedRef,
    style: [styles.container, style]
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_View__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    children: svg,
    style: [typeof size === 'number' ? {
      height: size,
      width: size
    } : indicatorSizes[size], styles.animation, !animating && styles.animationPause, !animating && hidesWhenStopped && styles.hidesWhenStopped]
  }));
});
ActivityIndicator.displayName = 'ActivityIndicator';
var styles = _StyleSheet__WEBPACK_IMPORTED_MODULE_4__/* ["default"].create */ .Z.create({
  container: {
    alignItems: 'center',
    justifyContent: 'center'
  },
  hidesWhenStopped: {
    visibility: 'hidden'
  },
  animation: {
    animationDuration: '0.75s',
    animationKeyframes: [{
      '0%': {
        transform: [{
          rotate: '0deg'
        }]
      },
      '100%': {
        transform: [{
          rotate: '360deg'
        }]
      }
    }],
    animationTimingFunction: 'linear',
    animationIterationCount: 'infinite'
  },
  animationPause: {
    animationPlayState: 'paused'
  }
});
var indicatorSizes = _StyleSheet__WEBPACK_IMPORTED_MODULE_4__/* ["default"].create */ .Z.create({
  small: {
    width: 20,
    height: 20
  },
  large: {
    width: 36,
    height: 36
  }
});
/* harmony default export */ __webpack_exports__["Z"] = (ActivityIndicator);

/***/ }),

/***/ 48923:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ exports_Animated; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectSpread2.js + 4 modules
var objectSpread2 = __webpack_require__(29405);
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/exports/Platform/index.js
var Platform = __webpack_require__(33229);
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/vendor/react-native/Animated/components/AnimatedFlatList.js
var AnimatedFlatList = __webpack_require__(53615);
var AnimatedFlatList_default = /*#__PURE__*/__webpack_require__.n(AnimatedFlatList);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/exports/Image/index.js + 2 modules
var Image = __webpack_require__(79470);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelperLoose.js

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);
  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
// EXTERNAL MODULE: ../../node_modules/fbjs/lib/invariant.js
var lib_invariant = __webpack_require__(14983);
var invariant_default = /*#__PURE__*/__webpack_require__.n(lib_invariant);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/vendor/react-native/TurboModule/TurboModuleRegistry.js
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */



function get(name) {
  return null;
}
function getEnforcing(name) {
  var module = get(name);
  invariant(module != null, "TurboModuleRegistry.getEnforcing(...): '" + name + "' could not be found. " + 'Verify that a module by this name is registered in the native binary.');
  return module;
}
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/vendor/react-native/Animated/NativeAnimatedModule.js
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */

/* harmony default export */ var NativeAnimatedModule = (get('NativeAnimatedModule'));
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/vendor/react-native/Animated/NativeAnimatedTurboModule.js
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */

/* harmony default export */ var NativeAnimatedTurboModule = (get('NativeAnimatedTurboModule'));
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/vendor/react-native/NativeEventEmitter/index.js
var NativeEventEmitter = __webpack_require__(2643);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/vendor/react-native/Animated/NativeAnimatedHelper.js
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */




 // TODO T69437152 @petetheheat - Delete this fork when Fabric ships to 100%.

var NativeAnimatedHelper_NativeAnimatedModule = Platform/* default.OS */.Z.OS === 'ios' && __webpack_require__.g.RN$Bridgeless ? NativeAnimatedTurboModule : NativeAnimatedModule;
var __nativeAnimatedNodeTagCount = 1;
/* used for animated nodes */

var __nativeAnimationIdCount = 1;
/* used for started animations */

var nativeEventEmitter;
var waitingForQueuedOperations = new Set();
var queueOperations = false;
var queue = [];
/**
 * Simple wrappers around NativeAnimatedModule to provide flow and autocomplete support for
 * the native module methods
 */

var API = {
  getValue: function getValue(tag, saveValueCallback) {
    invariant_default()(NativeAnimatedHelper_NativeAnimatedModule, 'Native animated module is not available');

    if (NativeAnimatedHelper_NativeAnimatedModule.getValue) {
      NativeAnimatedHelper_NativeAnimatedModule.getValue(tag, saveValueCallback);
    }
  },
  setWaitingForIdentifier: function setWaitingForIdentifier(id) {
    waitingForQueuedOperations.add(id);
    queueOperations = true;
  },
  unsetWaitingForIdentifier: function unsetWaitingForIdentifier(id) {
    waitingForQueuedOperations.delete(id);

    if (waitingForQueuedOperations.size === 0) {
      queueOperations = false;
      API.disableQueue();
    }
  },
  disableQueue: function disableQueue() {
    invariant_default()(NativeAnimatedHelper_NativeAnimatedModule, 'Native animated module is not available');

    if (Platform/* default.OS */.Z.OS === 'android') {
      NativeAnimatedHelper_NativeAnimatedModule.startOperationBatch();
    }

    for (var q = 0, l = queue.length; q < l; q++) {
      queue[q]();
    }

    queue.length = 0;

    if (Platform/* default.OS */.Z.OS === 'android') {
      NativeAnimatedHelper_NativeAnimatedModule.finishOperationBatch();
    }
  },
  queueOperation: fn => {
    if (queueOperations) {
      queue.push(fn);
    } else {
      fn();
    }
  },
  createAnimatedNode: function createAnimatedNode(tag, config) {
    invariant_default()(NativeAnimatedHelper_NativeAnimatedModule, 'Native animated module is not available');
    API.queueOperation(() => NativeAnimatedHelper_NativeAnimatedModule.createAnimatedNode(tag, config));
  },
  startListeningToAnimatedNodeValue: function startListeningToAnimatedNodeValue(tag) {
    invariant_default()(NativeAnimatedHelper_NativeAnimatedModule, 'Native animated module is not available');
    API.queueOperation(() => NativeAnimatedHelper_NativeAnimatedModule.startListeningToAnimatedNodeValue(tag));
  },
  stopListeningToAnimatedNodeValue: function stopListeningToAnimatedNodeValue(tag) {
    invariant_default()(NativeAnimatedHelper_NativeAnimatedModule, 'Native animated module is not available');
    API.queueOperation(() => NativeAnimatedHelper_NativeAnimatedModule.stopListeningToAnimatedNodeValue(tag));
  },
  connectAnimatedNodes: function connectAnimatedNodes(parentTag, childTag) {
    invariant_default()(NativeAnimatedHelper_NativeAnimatedModule, 'Native animated module is not available');
    API.queueOperation(() => NativeAnimatedHelper_NativeAnimatedModule.connectAnimatedNodes(parentTag, childTag));
  },
  disconnectAnimatedNodes: function disconnectAnimatedNodes(parentTag, childTag) {
    invariant_default()(NativeAnimatedHelper_NativeAnimatedModule, 'Native animated module is not available');
    API.queueOperation(() => NativeAnimatedHelper_NativeAnimatedModule.disconnectAnimatedNodes(parentTag, childTag));
  },
  startAnimatingNode: function startAnimatingNode(animationId, nodeTag, config, endCallback) {
    invariant_default()(NativeAnimatedHelper_NativeAnimatedModule, 'Native animated module is not available');
    API.queueOperation(() => NativeAnimatedHelper_NativeAnimatedModule.startAnimatingNode(animationId, nodeTag, config, endCallback));
  },
  stopAnimation: function stopAnimation(animationId) {
    invariant_default()(NativeAnimatedHelper_NativeAnimatedModule, 'Native animated module is not available');
    API.queueOperation(() => NativeAnimatedHelper_NativeAnimatedModule.stopAnimation(animationId));
  },
  setAnimatedNodeValue: function setAnimatedNodeValue(nodeTag, value) {
    invariant_default()(NativeAnimatedHelper_NativeAnimatedModule, 'Native animated module is not available');
    API.queueOperation(() => NativeAnimatedHelper_NativeAnimatedModule.setAnimatedNodeValue(nodeTag, value));
  },
  setAnimatedNodeOffset: function setAnimatedNodeOffset(nodeTag, offset) {
    invariant_default()(NativeAnimatedHelper_NativeAnimatedModule, 'Native animated module is not available');
    API.queueOperation(() => NativeAnimatedHelper_NativeAnimatedModule.setAnimatedNodeOffset(nodeTag, offset));
  },
  flattenAnimatedNodeOffset: function flattenAnimatedNodeOffset(nodeTag) {
    invariant_default()(NativeAnimatedHelper_NativeAnimatedModule, 'Native animated module is not available');
    API.queueOperation(() => NativeAnimatedHelper_NativeAnimatedModule.flattenAnimatedNodeOffset(nodeTag));
  },
  extractAnimatedNodeOffset: function extractAnimatedNodeOffset(nodeTag) {
    invariant_default()(NativeAnimatedHelper_NativeAnimatedModule, 'Native animated module is not available');
    API.queueOperation(() => NativeAnimatedHelper_NativeAnimatedModule.extractAnimatedNodeOffset(nodeTag));
  },
  connectAnimatedNodeToView: function connectAnimatedNodeToView(nodeTag, viewTag) {
    invariant_default()(NativeAnimatedHelper_NativeAnimatedModule, 'Native animated module is not available');
    API.queueOperation(() => NativeAnimatedHelper_NativeAnimatedModule.connectAnimatedNodeToView(nodeTag, viewTag));
  },
  disconnectAnimatedNodeFromView: function disconnectAnimatedNodeFromView(nodeTag, viewTag) {
    invariant_default()(NativeAnimatedHelper_NativeAnimatedModule, 'Native animated module is not available');
    API.queueOperation(() => NativeAnimatedHelper_NativeAnimatedModule.disconnectAnimatedNodeFromView(nodeTag, viewTag));
  },
  restoreDefaultValues: function restoreDefaultValues(nodeTag) {
    invariant_default()(NativeAnimatedHelper_NativeAnimatedModule, 'Native animated module is not available'); // Backwards compat with older native runtimes, can be removed later.

    if (NativeAnimatedHelper_NativeAnimatedModule.restoreDefaultValues != null) {
      API.queueOperation(() => NativeAnimatedHelper_NativeAnimatedModule.restoreDefaultValues(nodeTag));
    }
  },
  dropAnimatedNode: function dropAnimatedNode(tag) {
    invariant_default()(NativeAnimatedHelper_NativeAnimatedModule, 'Native animated module is not available');
    API.queueOperation(() => NativeAnimatedHelper_NativeAnimatedModule.dropAnimatedNode(tag));
  },
  addAnimatedEventToView: function addAnimatedEventToView(viewTag, eventName, eventMapping) {
    invariant_default()(NativeAnimatedHelper_NativeAnimatedModule, 'Native animated module is not available');
    API.queueOperation(() => NativeAnimatedHelper_NativeAnimatedModule.addAnimatedEventToView(viewTag, eventName, eventMapping));
  },

  removeAnimatedEventFromView(viewTag, eventName, animatedNodeTag) {
    invariant_default()(NativeAnimatedHelper_NativeAnimatedModule, 'Native animated module is not available');
    API.queueOperation(() => NativeAnimatedHelper_NativeAnimatedModule.removeAnimatedEventFromView(viewTag, eventName, animatedNodeTag));
  }

};
/**
 * Styles allowed by the native animated implementation.
 *
 * In general native animated implementation should support any numeric property that doesn't need
 * to be updated through the shadow view hierarchy (all non-layout properties).
 */

var SUPPORTED_STYLES = {
  opacity: true,
  transform: true,
  borderRadius: true,
  borderBottomEndRadius: true,
  borderBottomLeftRadius: true,
  borderBottomRightRadius: true,
  borderBottomStartRadius: true,
  borderTopEndRadius: true,
  borderTopLeftRadius: true,
  borderTopRightRadius: true,
  borderTopStartRadius: true,
  elevation: true,
  zIndex: true,

  /* ios styles */
  shadowOpacity: true,
  shadowRadius: true,

  /* legacy android transform properties */
  scaleX: true,
  scaleY: true,
  translateX: true,
  translateY: true
};
var SUPPORTED_TRANSFORMS = {
  translateX: true,
  translateY: true,
  scale: true,
  scaleX: true,
  scaleY: true,
  rotate: true,
  rotateX: true,
  rotateY: true,
  rotateZ: true,
  perspective: true
};
var SUPPORTED_INTERPOLATION_PARAMS = {
  inputRange: true,
  outputRange: true,
  extrapolate: true,
  extrapolateRight: true,
  extrapolateLeft: true
};

function addWhitelistedStyleProp(prop) {
  SUPPORTED_STYLES[prop] = true;
}

function addWhitelistedTransformProp(prop) {
  SUPPORTED_TRANSFORMS[prop] = true;
}

function addWhitelistedInterpolationParam(param) {
  SUPPORTED_INTERPOLATION_PARAMS[param] = true;
}

function validateTransform(configs) {
  configs.forEach(config => {
    if (!SUPPORTED_TRANSFORMS.hasOwnProperty(config.property)) {
      throw new Error("Property '" + config.property + "' is not supported by native animated module");
    }
  });
}

function validateStyles(styles) {
  for (var _key in styles) {
    if (!SUPPORTED_STYLES.hasOwnProperty(_key)) {
      throw new Error("Style property '" + _key + "' is not supported by native animated module");
    }
  }
}

function validateInterpolation(config) {
  for (var _key2 in config) {
    if (!SUPPORTED_INTERPOLATION_PARAMS.hasOwnProperty(_key2)) {
      throw new Error("Interpolation property '" + _key2 + "' is not supported by native animated module");
    }
  }
}

function generateNewNodeTag() {
  return __nativeAnimatedNodeTagCount++;
}

function generateNewAnimationId() {
  return __nativeAnimationIdCount++;
}

function assertNativeAnimatedModule() {
  invariant_default()(NativeAnimatedHelper_NativeAnimatedModule, 'Native animated module is not available');
}

var _warnedMissingNativeAnimated = false;
function shouldUseNativeDriver(config) {
  if (config.useNativeDriver == null) {
    console.warn('Animated: `useNativeDriver` was not specified. This is a required ' + 'option and must be explicitly set to `true` or `false`');
  }

  if (config.useNativeDriver === true && !NativeAnimatedHelper_NativeAnimatedModule) {
    if (!_warnedMissingNativeAnimated) {
      console.warn('Animated: `useNativeDriver` is not supported because the native ' + 'animated module is missing. Falling back to JS-based animation. To ' + 'resolve this, add `RCTAnimation` module to this app, or remove ' + '`useNativeDriver`. ' + 'Make sure to run `pod install` first. Read more about autolinking: https://github.com/react-native-community/cli/blob/master/docs/autolinking.md');
      _warnedMissingNativeAnimated = true;
    }

    return false;
  }

  return config.useNativeDriver || false;
}

function transformDataType(value) {
  // Change the string type to number type so we can reuse the same logic in
  // iOS and Android platform
  if (typeof value !== 'string') {
    return value;
  }

  if (/deg$/.test(value)) {
    var degrees = parseFloat(value) || 0;
    var radians = degrees * Math.PI / 180.0;
    return radians;
  } else {
    return value;
  }
}

/* harmony default export */ var NativeAnimatedHelper = ({
  API,
  addWhitelistedStyleProp,
  addWhitelistedTransformProp,
  addWhitelistedInterpolationParam,
  validateStyles,
  validateTransform,
  validateInterpolation,
  generateNewNodeTag,
  generateNewAnimationId,
  assertNativeAnimatedModule,
  shouldUseNativeDriver,
  transformDataType,

  // $FlowExpectedError - unsafe getter lint suppresion
  get nativeEventEmitter() {
    if (!nativeEventEmitter) {
      nativeEventEmitter = new NativeEventEmitter/* default */.Z(NativeAnimatedHelper_NativeAnimatedModule);
    }

    return nativeEventEmitter;
  }

});
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/vendor/react-native/Animated/nodes/AnimatedNode.js
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */



var NativeAnimatedAPI = NativeAnimatedHelper.API;

var _uniqueId = 1; // Note(vjeux): this would be better as an interface but flow doesn't
// support them yet

class AnimatedNode {
  __attach() {}

  __detach() {
    if (this.__isNative && this.__nativeTag != null) {
      NativeAnimatedHelper.API.dropAnimatedNode(this.__nativeTag);
      this.__nativeTag = undefined;
    }
  }

  __getValue() {}

  __getAnimatedValue() {
    return this.__getValue();
  }

  __addChild(child) {}

  __removeChild(child) {}

  __getChildren() {
    return [];
  }
  /* Methods and props used by native Animated impl */


  constructor() {
    this._listeners = {};
  }

  __makeNative() {
    if (!this.__isNative) {
      throw new Error('This node cannot be made a "native" animated node');
    }

    if (this.hasListeners()) {
      this._startListeningToNativeValueUpdates();
    }
  }
  /**
   * Adds an asynchronous listener to the value so you can observe updates from
   * animations.  This is useful because there is no way to
   * synchronously read the value because it might be driven natively.
   *
   * See https://reactnative.dev/docs/animatedvalue.html#addlistener
   */


  addListener(callback) {
    var id = String(_uniqueId++);
    this._listeners[id] = callback;

    if (this.__isNative) {
      this._startListeningToNativeValueUpdates();
    }

    return id;
  }
  /**
   * Unregister a listener. The `id` param shall match the identifier
   * previously returned by `addListener()`.
   *
   * See https://reactnative.dev/docs/animatedvalue.html#removelistener
   */


  removeListener(id) {
    delete this._listeners[id];

    if (this.__isNative && !this.hasListeners()) {
      this._stopListeningForNativeValueUpdates();
    }
  }
  /**
   * Remove all registered listeners.
   *
   * See https://reactnative.dev/docs/animatedvalue.html#removealllisteners
   */


  removeAllListeners() {
    this._listeners = {};

    if (this.__isNative) {
      this._stopListeningForNativeValueUpdates();
    }
  }

  hasListeners() {
    return !!Object.keys(this._listeners).length;
  }

  _startListeningToNativeValueUpdates() {
    if (this.__nativeAnimatedValueListener && !this.__shouldUpdateListenersForNewNativeTag) {
      return;
    }

    if (this.__shouldUpdateListenersForNewNativeTag) {
      this.__shouldUpdateListenersForNewNativeTag = false;

      this._stopListeningForNativeValueUpdates();
    }

    NativeAnimatedAPI.startListeningToAnimatedNodeValue(this.__getNativeTag());
    this.__nativeAnimatedValueListener = NativeAnimatedHelper.nativeEventEmitter.addListener('onAnimatedValueUpdate', data => {
      if (data.tag !== this.__getNativeTag()) {
        return;
      }

      this._onAnimatedValueUpdateReceived(data.value);
    });
  }

  _onAnimatedValueUpdateReceived(value) {
    this.__callListeners(value);
  }

  __callListeners(value) {
    for (var _key in this._listeners) {
      this._listeners[_key]({
        value
      });
    }
  }

  _stopListeningForNativeValueUpdates() {
    if (!this.__nativeAnimatedValueListener) {
      return;
    }

    this.__nativeAnimatedValueListener.remove();

    this.__nativeAnimatedValueListener = null;
    NativeAnimatedAPI.stopListeningToAnimatedNodeValue(this.__getNativeTag());
  }

  __getNativeTag() {
    var _this$__nativeTag;

    NativeAnimatedHelper.assertNativeAnimatedModule();
    invariant_default()(this.__isNative, 'Attempt to get native tag from node not marked as "native"');
    var nativeTag = (_this$__nativeTag = this.__nativeTag) !== null && _this$__nativeTag !== void 0 ? _this$__nativeTag : NativeAnimatedHelper.generateNewNodeTag();

    if (this.__nativeTag == null) {
      this.__nativeTag = nativeTag;
      NativeAnimatedHelper.API.createAnimatedNode(nativeTag, this.__getNativeConfig());
      this.__shouldUpdateListenersForNewNativeTag = true;
    }

    return nativeTag;
  }

  __getNativeConfig() {
    throw new Error('This JS animated node type cannot be used as native animated node');
  }

  toJSON() {
    return this.__getValue();
  }

}

/* harmony default export */ var nodes_AnimatedNode = (AnimatedNode);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/vendor/react-native/Animated/nodes/AnimatedWithChildren.js
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */






class AnimatedWithChildren extends nodes_AnimatedNode {
  constructor() {
    super();
    this._children = [];
  }

  __makeNative() {
    if (!this.__isNative) {
      this.__isNative = true;

      for (var _iterator = _createForOfIteratorHelperLoose(this._children), _step; !(_step = _iterator()).done;) {
        var child = _step.value;

        child.__makeNative();

        NativeAnimatedHelper.API.connectAnimatedNodes(this.__getNativeTag(), child.__getNativeTag());
      }
    }

    super.__makeNative();
  }

  __addChild(child) {
    if (this._children.length === 0) {
      this.__attach();
    }

    this._children.push(child);

    if (this.__isNative) {
      // Only accept "native" animated nodes as children
      child.__makeNative();

      NativeAnimatedHelper.API.connectAnimatedNodes(this.__getNativeTag(), child.__getNativeTag());
    }
  }

  __removeChild(child) {
    var index = this._children.indexOf(child);

    if (index === -1) {
      console.warn("Trying to remove a child that doesn't exist");
      return;
    }

    if (this.__isNative && child.__isNative) {
      NativeAnimatedHelper.API.disconnectAnimatedNodes(this.__getNativeTag(), child.__getNativeTag());
    }

    this._children.splice(index, 1);

    if (this._children.length === 0) {
      this.__detach();
    }
  }

  __getChildren() {
    return this._children;
  }

  __callListeners(value) {
    super.__callListeners(value);

    if (!this.__isNative) {
      for (var _iterator2 = _createForOfIteratorHelperLoose(this._children), _step2; !(_step2 = _iterator2()).done;) {
        var child = _step2.value;

        if (child.__getValue) {
          child.__callListeners(child.__getValue());
        }
      }
    }
  }

}

/* harmony default export */ var nodes_AnimatedWithChildren = (AnimatedWithChildren);
// EXTERNAL MODULE: ../../node_modules/normalize-css-color/index.js
var normalize_css_color = __webpack_require__(89817);
var normalize_css_color_default = /*#__PURE__*/__webpack_require__.n(normalize_css_color);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/vendor/react-native/Animated/nodes/AnimatedInterpolation.js
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */

/* eslint no-bitwise: 0 */









var __DEV__ = "production" !== 'production';

var linear = t => t;
/**
 * Very handy helper to map input ranges to output ranges with an easing
 * function and custom behavior outside of the ranges.
 */


function createInterpolation(config) {
  if (config.outputRange && typeof config.outputRange[0] === 'string') {
    return createInterpolationFromStringOutputRange(config);
  }

  var outputRange = config.outputRange;
  checkInfiniteRange('outputRange', outputRange);
  var inputRange = config.inputRange;
  checkInfiniteRange('inputRange', inputRange);
  checkValidInputRange(inputRange);
  invariant_default()(inputRange.length === outputRange.length, 'inputRange (' + inputRange.length + ') and outputRange (' + outputRange.length + ') must have the same length');
  var easing = config.easing || linear;
  var extrapolateLeft = 'extend';

  if (config.extrapolateLeft !== undefined) {
    extrapolateLeft = config.extrapolateLeft;
  } else if (config.extrapolate !== undefined) {
    extrapolateLeft = config.extrapolate;
  }

  var extrapolateRight = 'extend';

  if (config.extrapolateRight !== undefined) {
    extrapolateRight = config.extrapolateRight;
  } else if (config.extrapolate !== undefined) {
    extrapolateRight = config.extrapolate;
  }

  return input => {
    invariant_default()(typeof input === 'number', 'Cannot interpolation an input which is not a number');
    var range = findRange(input, inputRange);
    return interpolate(input, inputRange[range], inputRange[range + 1], outputRange[range], outputRange[range + 1], easing, extrapolateLeft, extrapolateRight);
  };
}

function interpolate(input, inputMin, inputMax, outputMin, outputMax, easing, extrapolateLeft, extrapolateRight) {
  var result = input; // Extrapolate

  if (result < inputMin) {
    if (extrapolateLeft === 'identity') {
      return result;
    } else if (extrapolateLeft === 'clamp') {
      result = inputMin;
    } else if (extrapolateLeft === 'extend') {// noop
    }
  }

  if (result > inputMax) {
    if (extrapolateRight === 'identity') {
      return result;
    } else if (extrapolateRight === 'clamp') {
      result = inputMax;
    } else if (extrapolateRight === 'extend') {// noop
    }
  }

  if (outputMin === outputMax) {
    return outputMin;
  }

  if (inputMin === inputMax) {
    if (input <= inputMin) {
      return outputMin;
    }

    return outputMax;
  } // Input Range


  if (inputMin === -Infinity) {
    result = -result;
  } else if (inputMax === Infinity) {
    result = result - inputMin;
  } else {
    result = (result - inputMin) / (inputMax - inputMin);
  } // Easing


  result = easing(result); // Output Range

  if (outputMin === -Infinity) {
    result = -result;
  } else if (outputMax === Infinity) {
    result = result + outputMin;
  } else {
    result = result * (outputMax - outputMin) + outputMin;
  }

  return result;
}

function colorToRgba(input) {
  var normalizedColor = normalize_css_color_default()(input);

  if (normalizedColor === null || typeof normalizedColor !== 'number') {
    return input;
  }

  normalizedColor = normalizedColor || 0;
  var r = (normalizedColor & 0xff000000) >>> 24;
  var g = (normalizedColor & 0x00ff0000) >>> 16;
  var b = (normalizedColor & 0x0000ff00) >>> 8;
  var a = (normalizedColor & 0x000000ff) / 255;
  return "rgba(" + r + ", " + g + ", " + b + ", " + a + ")";
}

var stringShapeRegex = /[+-]?(?:\d+\.?\d*|\.\d+)(?:[eE][+-]?\d+)?/g;
/**
 * Supports string shapes by extracting numbers so new values can be computed,
 * and recombines those values into new strings of the same shape.  Supports
 * things like:
 *
 *   rgba(123, 42, 99, 0.36) // colors
 *   -45deg                  // values with units
 */

function createInterpolationFromStringOutputRange(config) {
  var outputRange = config.outputRange;
  invariant_default()(outputRange.length >= 2, 'Bad output range');
  outputRange = outputRange.map(colorToRgba);
  checkPattern(outputRange); // ['rgba(0, 100, 200, 0)', 'rgba(50, 150, 250, 0.5)']
  // ->
  // [
  //   [0, 50],
  //   [100, 150],
  //   [200, 250],
  //   [0, 0.5],
  // ]

  /* $FlowFixMe(>=0.18.0): `outputRange[0].match()` can return `null`. Need to
   * guard against this possibility.
   */

  var outputRanges = outputRange[0].match(stringShapeRegex).map(() => []);
  outputRange.forEach(value => {
    /* $FlowFixMe(>=0.18.0): `value.match()` can return `null`. Need to guard
     * against this possibility.
     */
    value.match(stringShapeRegex).forEach((number, i) => {
      outputRanges[i].push(+number);
    });
  });
  var interpolations = outputRange[0].match(stringShapeRegex)
  /* $FlowFixMe(>=0.18.0): `outputRange[0].match()` can return `null`. Need
   * to guard against this possibility. */
  .map((value, i) => {
    return createInterpolation((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, config), {}, {
      outputRange: outputRanges[i]
    }));
  }); // rgba requires that the r,g,b are integers.... so we want to round them, but we *dont* want to
  // round the opacity (4th column).

  var shouldRound = isRgbOrRgba(outputRange[0]);
  return input => {
    var i = 0; // 'rgba(0, 100, 200, 0)'
    // ->
    // 'rgba(${interpolations[0](input)}, ${interpolations[1](input)}, ...'

    return outputRange[0].replace(stringShapeRegex, () => {
      var val = +interpolations[i++](input);

      if (shouldRound) {
        val = i < 4 ? Math.round(val) : Math.round(val * 1000) / 1000;
      }

      return String(val);
    });
  };
}

function isRgbOrRgba(range) {
  return typeof range === 'string' && range.startsWith('rgb');
}

function checkPattern(arr) {
  var pattern = arr[0].replace(stringShapeRegex, '');

  for (var i = 1; i < arr.length; ++i) {
    invariant_default()(pattern === arr[i].replace(stringShapeRegex, ''), 'invalid pattern ' + arr[0] + ' and ' + arr[i]);
  }
}

function findRange(input, inputRange) {
  var i;

  for (i = 1; i < inputRange.length - 1; ++i) {
    if (inputRange[i] >= input) {
      break;
    }
  }

  return i - 1;
}

function checkValidInputRange(arr) {
  invariant_default()(arr.length >= 2, 'inputRange must have at least 2 elements');

  for (var i = 1; i < arr.length; ++i) {
    invariant_default()(arr[i] >= arr[i - 1],
    /* $FlowFixMe(>=0.13.0) - In the addition expression below this comment,
     * one or both of the operands may be something that doesn't cleanly
     * convert to a string, like undefined, null, and object, etc. If you really
     * mean this implicit string conversion, you can do something like
     * String(myThing)
     */
    'inputRange must be monotonically non-decreasing ' + arr);
  }
}

function checkInfiniteRange(name, arr) {
  invariant_default()(arr.length >= 2, name + ' must have at least 2 elements');
  invariant_default()(arr.length !== 2 || arr[0] !== -Infinity || arr[1] !== Infinity,
  /* $FlowFixMe(>=0.13.0) - In the addition expression below this comment,
   * one or both of the operands may be something that doesn't cleanly convert
   * to a string, like undefined, null, and object, etc. If you really mean
   * this implicit string conversion, you can do something like
   * String(myThing)
   */
  name + 'cannot be ]-infinity;+infinity[ ' + arr);
}

class AnimatedInterpolation extends nodes_AnimatedWithChildren {
  // Export for testing.
  constructor(parent, config) {
    super();
    this._parent = parent;
    this._config = config;
    this._interpolation = createInterpolation(config);
  }

  __makeNative() {
    this._parent.__makeNative();

    super.__makeNative();
  }

  __getValue() {
    var parentValue = this._parent.__getValue();

    invariant_default()(typeof parentValue === 'number', 'Cannot interpolate an input which is not a number.');
    return this._interpolation(parentValue);
  }

  interpolate(config) {
    return new AnimatedInterpolation(this, config);
  }

  __attach() {
    this._parent.__addChild(this);
  }

  __detach() {
    this._parent.__removeChild(this);

    super.__detach();
  }

  __transformDataType(range) {
    return range.map(NativeAnimatedHelper.transformDataType);
  }

  __getNativeConfig() {
    if (__DEV__) {
      NativeAnimatedHelper.validateInterpolation(this._config);
    }

    return {
      inputRange: this._config.inputRange,
      // Only the `outputRange` can contain strings so we don't need to transform `inputRange` here

      /* $FlowFixMe(>=0.38.0) - Flow error detected during the deployment of
       * v0.38.0. To see the error, remove this comment and run flow */
      outputRange: this.__transformDataType(this._config.outputRange),
      extrapolateLeft: this._config.extrapolateLeft || this._config.extrapolate || 'extend',
      extrapolateRight: this._config.extrapolateRight || this._config.extrapolate || 'extend',
      type: 'interpolation'
    };
  }

}

AnimatedInterpolation.__createInterpolation = createInterpolation;
/* harmony default export */ var nodes_AnimatedInterpolation = (AnimatedInterpolation);
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/exports/InteractionManager/index.js + 1 modules
var InteractionManager = __webpack_require__(74984);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/vendor/react-native/Animated/nodes/AnimatedValue.js
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */






var AnimatedValue_NativeAnimatedAPI = NativeAnimatedHelper.API;
/**
 * Animated works by building a directed acyclic graph of dependencies
 * transparently when you render your Animated components.
 *
 *               new Animated.Value(0)
 *     .interpolate()        .interpolate()    new Animated.Value(1)
 *         opacity               translateY      scale
 *          style                         transform
 *         View#234                         style
 *                                         View#123
 *
 * A) Top Down phase
 * When an Animated.Value is updated, we recursively go down through this
 * graph in order to find leaf nodes: the views that we flag as needing
 * an update.
 *
 * B) Bottom Up phase
 * When a view is flagged as needing an update, we recursively go back up
 * in order to build the new value that it needs. The reason why we need
 * this two-phases process is to deal with composite props such as
 * transform which can receive values from multiple parents.
 */

function _flush(rootNode) {
  var animatedStyles = new Set();

  function findAnimatedStyles(node) {
    /* $FlowFixMe(>=0.68.0 site=react_native_fb) This comment suppresses an
     * error found when Flow v0.68 was deployed. To see the error delete this
     * comment and run Flow. */
    if (typeof node.update === 'function') {
      animatedStyles.add(node);
    } else {
      node.__getChildren().forEach(findAnimatedStyles);
    }
  }

  findAnimatedStyles(rootNode);
  /* $FlowFixMe */

  animatedStyles.forEach(animatedStyle => animatedStyle.update());
}
/**
 * Standard value for driving animations.  One `Animated.Value` can drive
 * multiple properties in a synchronized fashion, but can only be driven by one
 * mechanism at a time.  Using a new mechanism (e.g. starting a new animation,
 * or calling `setValue`) will stop any previous ones.
 *
 * See https://reactnative.dev/docs/animatedvalue.html
 */


class AnimatedValue extends nodes_AnimatedWithChildren {
  constructor(value) {
    super();

    if (typeof value !== 'number') {
      throw new Error('AnimatedValue: Attempting to set value to undefined');
    }

    this._startingValue = this._value = value;
    this._offset = 0;
    this._animation = null;
  }

  __detach() {
    if (this.__isNative) {
      AnimatedValue_NativeAnimatedAPI.getValue(this.__getNativeTag(), value => {
        this._value = value;
      });
    }

    this.stopAnimation();

    super.__detach();
  }

  __getValue() {
    return this._value + this._offset;
  }
  /**
   * Directly set the value.  This will stop any animations running on the value
   * and update all the bound properties.
   *
   * See https://reactnative.dev/docs/animatedvalue.html#setvalue
   */


  setValue(value) {
    if (this._animation) {
      this._animation.stop();

      this._animation = null;
    }

    this._updateValue(value, !this.__isNative
    /* don't perform a flush for natively driven values */
    );

    if (this.__isNative) {
      AnimatedValue_NativeAnimatedAPI.setAnimatedNodeValue(this.__getNativeTag(), value);
    }
  }
  /**
   * Sets an offset that is applied on top of whatever value is set, whether via
   * `setValue`, an animation, or `Animated.event`.  Useful for compensating
   * things like the start of a pan gesture.
   *
   * See https://reactnative.dev/docs/animatedvalue.html#setoffset
   */


  setOffset(offset) {
    this._offset = offset;

    if (this.__isNative) {
      AnimatedValue_NativeAnimatedAPI.setAnimatedNodeOffset(this.__getNativeTag(), offset);
    }
  }
  /**
   * Merges the offset value into the base value and resets the offset to zero.
   * The final output of the value is unchanged.
   *
   * See https://reactnative.dev/docs/animatedvalue.html#flattenoffset
   */


  flattenOffset() {
    this._value += this._offset;
    this._offset = 0;

    if (this.__isNative) {
      AnimatedValue_NativeAnimatedAPI.flattenAnimatedNodeOffset(this.__getNativeTag());
    }
  }
  /**
   * Sets the offset value to the base value, and resets the base value to zero.
   * The final output of the value is unchanged.
   *
   * See https://reactnative.dev/docs/animatedvalue.html#extractoffset
   */


  extractOffset() {
    this._offset += this._value;
    this._value = 0;

    if (this.__isNative) {
      AnimatedValue_NativeAnimatedAPI.extractAnimatedNodeOffset(this.__getNativeTag());
    }
  }
  /**
   * Stops any running animation or tracking. `callback` is invoked with the
   * final value after stopping the animation, which is useful for updating
   * state to match the animation position with layout.
   *
   * See https://reactnative.dev/docs/animatedvalue.html#stopanimation
   */


  stopAnimation(callback) {
    this.stopTracking();
    this._animation && this._animation.stop();
    this._animation = null;
    callback && callback(this.__getValue());
  }
  /**
   * Stops any animation and resets the value to its original.
   *
   * See https://reactnative.dev/docs/animatedvalue.html#resetanimation
   */


  resetAnimation(callback) {
    this.stopAnimation(callback);
    this._value = this._startingValue;
  }

  _onAnimatedValueUpdateReceived(value) {
    this._updateValue(value, false
    /*flush*/
    );
  }
  /**
   * Interpolates the value before updating the property, e.g. mapping 0-1 to
   * 0-10.
   */


  interpolate(config) {
    return new nodes_AnimatedInterpolation(this, config);
  }
  /**
   * Typically only used internally, but could be used by a custom Animation
   * class.
   *
   * See https://reactnative.dev/docs/animatedvalue.html#animate
   */


  animate(animation, callback) {
    var handle = null;

    if (animation.__isInteraction) {
      handle = InteractionManager/* default.createInteractionHandle */.Z.createInteractionHandle();
    }

    var previousAnimation = this._animation;
    this._animation && this._animation.stop();
    this._animation = animation;
    animation.start(this._value, value => {
      // Natively driven animations will never call into that callback, therefore we can always
      // pass flush = true to allow the updated value to propagate to native with setNativeProps
      this._updateValue(value, true
      /* flush */
      );
    }, result => {
      this._animation = null;

      if (handle !== null) {
        InteractionManager/* default.clearInteractionHandle */.Z.clearInteractionHandle(handle);
      }

      callback && callback(result);
    }, previousAnimation, this);
  }
  /**
   * Typically only used internally.
   */


  stopTracking() {
    this._tracking && this._tracking.__detach();
    this._tracking = null;
  }
  /**
   * Typically only used internally.
   */


  track(tracking) {
    this.stopTracking();
    this._tracking = tracking;
  }

  _updateValue(value, flush) {
    if (value === undefined) {
      throw new Error('AnimatedValue: Attempting to set value to undefined');
    }

    this._value = value;

    if (flush) {
      _flush(this);
    }

    super.__callListeners(this.__getValue());
  }

  __getNativeConfig() {
    return {
      type: 'value',
      value: this._value,
      offset: this._offset
    };
  }

}

/* harmony default export */ var nodes_AnimatedValue = (AnimatedValue);
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/exports/findNodeHandle/index.js
var findNodeHandle = __webpack_require__(69150);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/vendor/react-native/Animated/AnimatedEvent.js
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */








var AnimatedEvent_DEV_ = "production" !== 'production';

function attachNativeEvent(viewRef, eventName, argMapping) {
  // Find animated values in `argMapping` and create an array representing their
  // key path inside the `nativeEvent` object. Ex.: ['contentOffset', 'x'].
  var eventMappings = [];

  var traverse = (value, path) => {
    if (value instanceof nodes_AnimatedValue) {
      value.__makeNative();

      eventMappings.push({
        nativeEventPath: path,
        animatedValueTag: value.__getNativeTag()
      });
    } else if (typeof value === 'object') {
      for (var _key in value) {
        traverse(value[_key], path.concat(_key));
      }
    }
  };

  invariant_default()(argMapping[0] && argMapping[0].nativeEvent, 'Native driven events only support animated values contained inside `nativeEvent`.'); // Assume that the event containing `nativeEvent` is always the first argument.

  traverse(argMapping[0].nativeEvent, []);
  var viewTag = (0,findNodeHandle/* default */.Z)(viewRef);

  if (viewTag != null) {
    eventMappings.forEach(mapping => {
      NativeAnimatedHelper.API.addAnimatedEventToView(viewTag, eventName, mapping);
    });
  }

  return {
    detach() {
      if (viewTag != null) {
        eventMappings.forEach(mapping => {
          NativeAnimatedHelper.API.removeAnimatedEventFromView(viewTag, eventName, // $FlowFixMe[incompatible-call]
          mapping.animatedValueTag);
        });
      }
    }

  };
}

function validateMapping(argMapping, args) {
  var validate = (recMapping, recEvt, key) => {
    if (recMapping instanceof nodes_AnimatedValue) {
      invariant_default()(typeof recEvt === 'number', 'Bad mapping of event key ' + key + ', should be number but got ' + typeof recEvt);
      return;
    }

    if (typeof recEvt === 'number') {
      invariant_default()(recMapping instanceof nodes_AnimatedValue, 'Bad mapping of type ' + typeof recMapping + ' for key ' + key + ', event value must map to AnimatedValue');
      return;
    }

    invariant_default()(typeof recMapping === 'object', 'Bad mapping of type ' + typeof recMapping + ' for key ' + key);
    invariant_default()(typeof recEvt === 'object', 'Bad event of type ' + typeof recEvt + ' for key ' + key);

    for (var mappingKey in recMapping) {
      validate(recMapping[mappingKey], recEvt[mappingKey], mappingKey);
    }
  };

  invariant_default()(args.length >= argMapping.length, 'Event has less arguments than mapping');
  argMapping.forEach((mapping, idx) => {
    validate(mapping, args[idx], 'arg' + idx);
  });
}

class AnimatedEvent {
  constructor(argMapping, config) {
    this._listeners = [];
    this._argMapping = argMapping;

    if (config == null) {
      console.warn('Animated.event now requires a second argument for options');
      config = {
        useNativeDriver: false
      };
    }

    if (config.listener) {
      this.__addListener(config.listener);
    }

    this._callListeners = this._callListeners.bind(this);
    this._attachedEvent = null;
    this.__isNative = shouldUseNativeDriver(config);
  }

  __addListener(callback) {
    this._listeners.push(callback);
  }

  __removeListener(callback) {
    this._listeners = this._listeners.filter(listener => listener !== callback);
  }

  __attach(viewRef, eventName) {
    invariant_default()(this.__isNative, 'Only native driven events need to be attached.');
    this._attachedEvent = attachNativeEvent(viewRef, eventName, this._argMapping);
  }

  __detach(viewTag, eventName) {
    invariant_default()(this.__isNative, 'Only native driven events need to be detached.');
    this._attachedEvent && this._attachedEvent.detach();
  }

  __getHandler() {
    var _this = this;

    if (this.__isNative) {
      if (AnimatedEvent_DEV_) {
        var _validatedMapping = false;
        return function () {
          for (var _len = arguments.length, args = new Array(_len), _key2 = 0; _key2 < _len; _key2++) {
            args[_key2] = arguments[_key2];
          }

          if (!_validatedMapping) {
            validateMapping(_this._argMapping, args);
            _validatedMapping = true;
          }

          _this._callListeners(...args);
        };
      } else {
        return this._callListeners;
      }
    }

    var validatedMapping = false;
    return function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key3 = 0; _key3 < _len2; _key3++) {
        args[_key3] = arguments[_key3];
      }

      if (AnimatedEvent_DEV_ && !validatedMapping) {
        validateMapping(_this._argMapping, args);
        validatedMapping = true;
      }

      var traverse = (recMapping, recEvt, key) => {
        if (recMapping instanceof nodes_AnimatedValue) {
          if (typeof recEvt === 'number') {
            recMapping.setValue(recEvt);
          }
        } else if (typeof recMapping === 'object') {
          for (var mappingKey in recMapping) {
            /* $FlowFixMe(>=0.120.0) This comment suppresses an error found
             * when Flow v0.120 was deployed. To see the error, delete this
             * comment and run Flow. */
            traverse(recMapping[mappingKey], recEvt[mappingKey], mappingKey);
          }
        }
      };

      _this._argMapping.forEach((mapping, idx) => {
        traverse(mapping, args[idx], 'arg' + idx);
      });

      _this._callListeners(...args);
    };
  }

  _callListeners() {
    for (var _len3 = arguments.length, args = new Array(_len3), _key4 = 0; _key4 < _len3; _key4++) {
      args[_key4] = arguments[_key4];
    }

    this._listeners.forEach(listener => listener(...args));
  }

}
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/vendor/react-native/Animated/nodes/AnimatedTransform.js
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */






class AnimatedTransform extends nodes_AnimatedWithChildren {
  constructor(transforms) {
    super();
    this._transforms = transforms;
  }

  __makeNative() {
    this._transforms.forEach(transform => {
      for (var key in transform) {
        var value = transform[key];

        if (value instanceof nodes_AnimatedNode) {
          value.__makeNative();
        }
      }
    });

    super.__makeNative();
  }

  __getValue() {
    return this._transforms.map(transform => {
      var result = {};

      for (var key in transform) {
        var value = transform[key];

        if (value instanceof nodes_AnimatedNode) {
          result[key] = value.__getValue();
        } else {
          result[key] = value;
        }
      }

      return result;
    });
  }

  __getAnimatedValue() {
    return this._transforms.map(transform => {
      var result = {};

      for (var key in transform) {
        var value = transform[key];

        if (value instanceof nodes_AnimatedNode) {
          result[key] = value.__getAnimatedValue();
        } else {
          // All transform components needed to recompose matrix
          result[key] = value;
        }
      }

      return result;
    });
  }

  __attach() {
    this._transforms.forEach(transform => {
      for (var key in transform) {
        var value = transform[key];

        if (value instanceof nodes_AnimatedNode) {
          value.__addChild(this);
        }
      }
    });
  }

  __detach() {
    this._transforms.forEach(transform => {
      for (var key in transform) {
        var value = transform[key];

        if (value instanceof nodes_AnimatedNode) {
          value.__removeChild(this);
        }
      }
    });

    super.__detach();
  }

  __getNativeConfig() {
    var transConfigs = [];

    this._transforms.forEach(transform => {
      for (var key in transform) {
        var value = transform[key];

        if (value instanceof nodes_AnimatedNode) {
          transConfigs.push({
            type: 'animated',
            property: key,
            nodeTag: value.__getNativeTag()
          });
        } else {
          transConfigs.push({
            type: 'static',
            property: key,
            value: NativeAnimatedHelper.transformDataType(value)
          });
        }
      }
    });

    NativeAnimatedHelper.validateTransform(transConfigs);
    return {
      type: 'transform',
      transforms: transConfigs
    };
  }

}

/* harmony default export */ var nodes_AnimatedTransform = (AnimatedTransform);
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/exports/StyleSheet/index.js + 6 modules
var StyleSheet = __webpack_require__(66068);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/vendor/react-native/Animated/nodes/AnimatedStyle.js
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */








var flattenStyle = StyleSheet/* default.flatten */.Z.flatten;

class AnimatedStyle extends nodes_AnimatedWithChildren {
  constructor(style) {
    super();
    style = flattenStyle(style) || {};

    if (style.transform) {
      style = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, style), {}, {
        transform: new nodes_AnimatedTransform(style.transform)
      });
    }

    this._style = style;
  } // Recursively get values for nested styles (like iOS's shadowOffset)


  _walkStyleAndGetValues(style) {
    var updatedStyle = {};

    for (var key in style) {
      var value = style[key];

      if (value instanceof nodes_AnimatedNode) {
        if (!value.__isNative) {
          // We cannot use value of natively driven nodes this way as the value we have access from
          // JS may not be up to date.
          updatedStyle[key] = value.__getValue();
        }
      } else if (value && !Array.isArray(value) && typeof value === 'object') {
        // Support animating nested values (for example: shadowOffset.height)
        updatedStyle[key] = this._walkStyleAndGetValues(value);
      } else {
        updatedStyle[key] = value;
      }
    }

    return updatedStyle;
  }

  __getValue() {
    return this._walkStyleAndGetValues(this._style);
  } // Recursively get animated values for nested styles (like iOS's shadowOffset)


  _walkStyleAndGetAnimatedValues(style) {
    var updatedStyle = {};

    for (var key in style) {
      var value = style[key];

      if (value instanceof nodes_AnimatedNode) {
        updatedStyle[key] = value.__getAnimatedValue();
      } else if (value && !Array.isArray(value) && typeof value === 'object') {
        // Support animating nested values (for example: shadowOffset.height)
        updatedStyle[key] = this._walkStyleAndGetAnimatedValues(value);
      }
    }

    return updatedStyle;
  }

  __getAnimatedValue() {
    return this._walkStyleAndGetAnimatedValues(this._style);
  }

  __attach() {
    for (var key in this._style) {
      var value = this._style[key];

      if (value instanceof nodes_AnimatedNode) {
        value.__addChild(this);
      }
    }
  }

  __detach() {
    for (var key in this._style) {
      var value = this._style[key];

      if (value instanceof nodes_AnimatedNode) {
        value.__removeChild(this);
      }
    }

    super.__detach();
  }

  __makeNative() {
    for (var key in this._style) {
      var value = this._style[key];

      if (value instanceof nodes_AnimatedNode) {
        value.__makeNative();
      }
    }

    super.__makeNative();
  }

  __getNativeConfig() {
    var styleConfig = {};

    for (var styleKey in this._style) {
      if (this._style[styleKey] instanceof nodes_AnimatedNode) {
        var style = this._style[styleKey];

        style.__makeNative();

        styleConfig[styleKey] = style.__getNativeTag();
      } // Non-animated styles are set using `setNativeProps`, no need
      // to pass those as a part of the node config

    }

    NativeAnimatedHelper.validateStyles(styleConfig);
    return {
      type: 'style',
      style: styleConfig
    };
  }

}

/* harmony default export */ var nodes_AnimatedStyle = (AnimatedStyle);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/vendor/react-native/Animated/nodes/AnimatedProps.js
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */










class AnimatedProps extends nodes_AnimatedNode {
  constructor(props, callback) {
    super();

    if (props.style) {
      props = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, props), {}, {
        style: new nodes_AnimatedStyle(props.style)
      });
    }

    this._props = props;
    this._callback = callback;

    this.__attach();
  }

  __getValue() {
    var props = {};

    for (var key in this._props) {
      var value = this._props[key];

      if (value instanceof nodes_AnimatedNode) {
        if (!value.__isNative || value instanceof nodes_AnimatedStyle) {
          // We cannot use value of natively driven nodes this way as the value we have access from
          // JS may not be up to date.
          props[key] = value.__getValue();
        }
      } else if (value instanceof AnimatedEvent) {
        props[key] = value.__getHandler();
      } else {
        props[key] = value;
      }
    }

    return props;
  }

  __getAnimatedValue() {
    var props = {};

    for (var key in this._props) {
      var value = this._props[key];

      if (value instanceof nodes_AnimatedNode) {
        props[key] = value.__getAnimatedValue();
      }
    }

    return props;
  }

  __attach() {
    for (var key in this._props) {
      var value = this._props[key];

      if (value instanceof nodes_AnimatedNode) {
        value.__addChild(this);
      }
    }
  }

  __detach() {
    if (this.__isNative && this._animatedView) {
      this.__disconnectAnimatedView();
    }

    for (var key in this._props) {
      var value = this._props[key];

      if (value instanceof nodes_AnimatedNode) {
        value.__removeChild(this);
      }
    }

    super.__detach();
  }

  update() {
    this._callback();
  }

  __makeNative() {
    if (!this.__isNative) {
      this.__isNative = true;

      for (var key in this._props) {
        var value = this._props[key];

        if (value instanceof nodes_AnimatedNode) {
          value.__makeNative();
        }
      }

      if (this._animatedView) {
        this.__connectAnimatedView();
      }
    }
  }

  setNativeView(animatedView) {
    if (this._animatedView === animatedView) {
      return;
    }

    this._animatedView = animatedView;

    if (this.__isNative) {
      this.__connectAnimatedView();
    }
  }

  __connectAnimatedView() {
    invariant_default()(this.__isNative, 'Expected node to be marked as "native"');
    var nativeViewTag = (0,findNodeHandle/* default */.Z)(this._animatedView);
    invariant_default()(nativeViewTag != null, 'Unable to locate attached view in the native tree');
    NativeAnimatedHelper.API.connectAnimatedNodeToView(this.__getNativeTag(), nativeViewTag);
  }

  __disconnectAnimatedView() {
    invariant_default()(this.__isNative, 'Expected node to be marked as "native"');
    var nativeViewTag = (0,findNodeHandle/* default */.Z)(this._animatedView);
    invariant_default()(nativeViewTag != null, 'Unable to locate attached view in the native tree');
    NativeAnimatedHelper.API.disconnectAnimatedNodeFromView(this.__getNativeTag(), nativeViewTag);
  }

  __restoreDefaultValues() {
    // When using the native driver, view properties need to be restored to
    // their default values manually since react no longer tracks them. This
    // is needed to handle cases where a prop driven by native animated is removed
    // after having been changed natively by an animation.
    if (this.__isNative) {
      NativeAnimatedHelper.API.restoreDefaultValues(this.__getNativeTag());
    }
  }

  __getNativeConfig() {
    var propsConfig = {};

    for (var propKey in this._props) {
      var value = this._props[propKey];

      if (value instanceof nodes_AnimatedNode) {
        value.__makeNative();

        propsConfig[propKey] = value.__getNativeTag();
      }
    }

    return {
      type: 'props',
      props: propsConfig
    };
  }

}

/* harmony default export */ var nodes_AnimatedProps = (AnimatedProps);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/vendor/react-native/Utilities/setAndForwardRef.js
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 */


/**
 * This is a helper function for when a component needs to be able to forward a ref
 * to a child component, but still needs to have access to that component as part of
 * its implementation.
 *
 * Its main use case is in wrappers for native components.
 *
 * Usage:
 *
 *   class MyView extends React.Component {
 *     _nativeRef = null;
 *
 *     _setNativeRef = setAndForwardRef({
 *       getForwardedRef: () => this.props.forwardedRef,
 *       setLocalRef: ref => {
 *         this._nativeRef = ref;
 *       },
 *     });
 *
 *     render() {
 *       return <View ref={this._setNativeRef} />;
 *     }
 *   }
 *
 *   const MyViewWithRef = React.forwardRef((props, ref) => (
 *     <MyView {...props} forwardedRef={ref} />
 *   ));
 *
 *   module.exports = MyViewWithRef;
 */
function setAndForwardRef(_ref) {
  var getForwardedRef = _ref.getForwardedRef,
      setLocalRef = _ref.setLocalRef;
  return function forwardRef(ref) {
    var forwardedRef = getForwardedRef();
    setLocalRef(ref); // Forward to user ref prop (if one has been specified)

    if (typeof forwardedRef === 'function') {
      // Handle function-based refs. String-based refs are handled as functions.
      forwardedRef(ref);
    } else if (typeof forwardedRef === 'object' && forwardedRef != null) {
      // Handle createRef-based refs
      forwardedRef.current = ref;
    }
  };
}

/* harmony default export */ var Utilities_setAndForwardRef = (setAndForwardRef);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/vendor/react-native/Animated/createAnimatedComponent.js
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */





var _excluded = ["style"],
    _excluded2 = ["style"];







var animatedComponentNextId = 1;

function createAnimatedComponent(Component, options) {
  invariant_default()(typeof Component !== 'function' || Component.prototype && Component.prototype.isReactComponent, '`createAnimatedComponent` does not support stateless functional components; ' + 'use a class component instead.');

  class AnimatedComponent extends react.Component {
    constructor() {
      super(...arguments);
      this._invokeAnimatedPropsCallbackOnMount = false;
      this._eventDetachers = [];
      this._animatedComponentId = animatedComponentNextId++ + ":animatedComponent";

      this._isFabric = () => {
        var _this$_component$_int, _this$_component$_int2, _this$_component$getN, _this$_component$getN2, _this$_component$getS, _this$_component$getS2;

        // When called during the first render, `_component` is always null.
        // Therefore, even if a component is rendered in Fabric, we can't detect
        // that until ref is set, which happens sometime after the first render.
        // In cases where this value switching between "false" and "true" on Fabric
        // causes issues, add an additional check for _component nullity.
        if (this._component == null) {
          return false;
        }

        return (// eslint-disable-next-line dot-notation
          ((_this$_component$_int = this._component['_internalInstanceHandle']) == null ? void 0 : (_this$_component$_int2 = _this$_component$_int.stateNode) == null ? void 0 : _this$_component$_int2.canonical) != null || // Some components have a setNativeProps function but aren't a host component
          // such as lists like FlatList and SectionList. These should also use
          // forceUpdate in Fabric since setNativeProps doesn't exist on the underlying
          // host component. This crazy hack is essentially special casing those lists and
          // ScrollView itself to use forceUpdate in Fabric.
          // If these components end up using forwardRef then these hacks can go away
          // as this._component would actually be the underlying host component and the above check
          // would be sufficient.
          this._component.getNativeScrollRef != null && this._component.getNativeScrollRef() != null && // eslint-disable-next-line dot-notation
          ((_this$_component$getN = this._component.getNativeScrollRef()['_internalInstanceHandle']) == null ? void 0 : (_this$_component$getN2 = _this$_component$getN.stateNode) == null ? void 0 : _this$_component$getN2.canonical) != null || this._component.getScrollResponder != null && this._component.getScrollResponder() != null && this._component.getScrollResponder().getNativeScrollRef != null && this._component.getScrollResponder().getNativeScrollRef() != null && ((_this$_component$getS = this._component.getScrollResponder().getNativeScrollRef()[// eslint-disable-next-line dot-notation
          '_internalInstanceHandle']) == null ? void 0 : (_this$_component$getS2 = _this$_component$getS.stateNode) == null ? void 0 : _this$_component$getS2.canonical) != null
        );
      };

      this._waitForUpdate = () => {
        if (this._isFabric()) {
          NativeAnimatedHelper.API.setWaitingForIdentifier(this._animatedComponentId);
        }
      };

      this._markUpdateComplete = () => {
        if (this._isFabric()) {
          NativeAnimatedHelper.API.unsetWaitingForIdentifier(this._animatedComponentId);
        }
      };

      this._animatedPropsCallback = () => {
        if (this._component == null) {
          // AnimatedProps is created in will-mount because it's used in render.
          // But this callback may be invoked before mount in async mode,
          // In which case we should defer the setNativeProps() call.
          // React may throw away uncommitted work in async mode,
          // So a deferred call won't always be invoked.
          this._invokeAnimatedPropsCallbackOnMount = true;
        } else if ( false || // For animating properties of non-leaf/non-native components
        typeof this._component.setNativeProps !== 'function' || // In Fabric, force animations to go through forceUpdate and skip setNativeProps
        this._isFabric()) {
          this.forceUpdate();
        } else if (!this._propsAnimated.__isNative) {
          this._component.setNativeProps(this._propsAnimated.__getAnimatedValue());
        } else {
          throw new Error('Attempting to run JS driven animation on animated ' + 'node that has been moved to "native" earlier by starting an ' + 'animation with `useNativeDriver: true`');
        }
      };

      this._setComponentRef = Utilities_setAndForwardRef({
        getForwardedRef: () => this.props.forwardedRef,
        setLocalRef: ref => {
          this._prevComponent = this._component;
          this._component = ref; // TODO: Delete this in a future release.

          if (ref != null && ref.getNode == null) {
            ref.getNode = () => {
              var _ref$constructor$name;

              console.warn('%s: Calling `getNode()` on the ref of an Animated component ' + 'is no longer necessary. You can now directly use the ref ' + 'instead. This method will be removed in a future release.', (_ref$constructor$name = ref.constructor.name) !== null && _ref$constructor$name !== void 0 ? _ref$constructor$name : '<<anonymous>>');
              return ref;
            };
          }
        }
      });
    }

    _attachNativeEvents() {
      var _this$_component,
          _this = this;

      // Make sure to get the scrollable node for components that implement
      // `ScrollResponder.Mixin`.
      var scrollableNode = (_this$_component = this._component) != null && _this$_component.getScrollableNode ? this._component.getScrollableNode() : this._component;

      var _loop = function _loop(key) {
        var prop = _this.props[key];

        if (prop instanceof AnimatedEvent && prop.__isNative) {
          prop.__attach(scrollableNode, key);

          _this._eventDetachers.push(() => prop.__detach(scrollableNode, key));
        }
      };

      for (var key in this.props) {
        _loop(key);
      }
    }

    _detachNativeEvents() {
      this._eventDetachers.forEach(remove => remove());

      this._eventDetachers = [];
    }

    _attachProps(nextProps) {
      var oldPropsAnimated = this._propsAnimated;

      if (nextProps === oldPropsAnimated) {
        return;
      }

      this._propsAnimated = new nodes_AnimatedProps(nextProps, this._animatedPropsCallback); // When you call detach, it removes the element from the parent list
      // of children. If it goes to 0, then the parent also detaches itself
      // and so on.
      // An optimization is to attach the new elements and THEN detach the old
      // ones instead of detaching and THEN attaching.
      // This way the intermediate state isn't to go to 0 and trigger
      // this expensive recursive detaching to then re-attach everything on
      // the very next operation.

      if (oldPropsAnimated) {
        oldPropsAnimated.__restoreDefaultValues();

        oldPropsAnimated.__detach();
      }
    }

    render() {
      var _ref = this._propsAnimated.__getValue() || {},
          _ref$style = _ref.style,
          style = _ref$style === void 0 ? {} : _ref$style,
          props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, _excluded);

      var _ref2 = this.props.passthroughAnimatedPropExplicitValues || {},
          _ref2$style = _ref2.style,
          passthruStyle = _ref2$style === void 0 ? {} : _ref2$style,
          passthruProps = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref2, _excluded2);

      var mergedStyle = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, style), passthruStyle);

      return /*#__PURE__*/react.createElement(Component, (0,esm_extends/* default */.Z)({}, props, passthruProps, {
        style: mergedStyle,
        ref: this._setComponentRef
      }));
    }

    UNSAFE_componentWillMount() {
      this._waitForUpdate();

      this._attachProps(this.props);
    }

    componentDidMount() {
      if (this._invokeAnimatedPropsCallbackOnMount) {
        this._invokeAnimatedPropsCallbackOnMount = false;

        this._animatedPropsCallback();
      }

      this._propsAnimated.setNativeView(this._component);

      this._attachNativeEvents();

      this._markUpdateComplete();
    }

    UNSAFE_componentWillReceiveProps(newProps) {
      this._waitForUpdate();

      this._attachProps(newProps);
    }

    componentDidUpdate(prevProps) {
      if (this._component !== this._prevComponent) {
        this._propsAnimated.setNativeView(this._component);
      }

      if (this._component !== this._prevComponent || prevProps !== this.props) {
        this._detachNativeEvents();

        this._attachNativeEvents();
      }

      this._markUpdateComplete();
    }

    componentWillUnmount() {
      this._propsAnimated && this._propsAnimated.__detach();

      this._detachNativeEvents();

      this._markUpdateComplete();

      this._component = null;
      this._prevComponent = null;
    }

  }

  return /*#__PURE__*/react.forwardRef(function AnimatedComponentWrapper(props, ref) {
    return /*#__PURE__*/react.createElement(AnimatedComponent, (0,esm_extends/* default */.Z)({}, props, ref == null ? null : {
      forwardedRef: ref
    }));
  });
}

/* harmony default export */ var Animated_createAnimatedComponent = (createAnimatedComponent);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/vendor/react-native/Animated/components/AnimatedImage.js
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */



/* harmony default export */ var AnimatedImage = (Animated_createAnimatedComponent(Image/* default */.Z, {
  collapsable: false
}));
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/exports/ScrollView/index.js + 2 modules
var ScrollView = __webpack_require__(79450);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/vendor/react-native/Animated/components/AnimatedScrollView.js


/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */




/**
 * @see https://github.com/facebook/react-native/commit/b8c8562
 */
var ScrollViewWithEventThrottle = /*#__PURE__*/react.forwardRef((props, ref) => /*#__PURE__*/react.createElement(ScrollView/* default */.Z, (0,esm_extends/* default */.Z)({
  scrollEventThrottle: 0.0001
}, props, {
  ref: ref
})));
/* harmony default export */ var AnimatedScrollView = (Animated_createAnimatedComponent(ScrollViewWithEventThrottle, {
  collapsable: false
}));
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/vendor/react-native/Animated/components/AnimatedSectionList.js
var AnimatedSectionList = __webpack_require__(49887);
var AnimatedSectionList_default = /*#__PURE__*/__webpack_require__.n(AnimatedSectionList);
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/exports/Text/index.js
var Text = __webpack_require__(66999);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/vendor/react-native/Animated/components/AnimatedText.js
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */



/* harmony default export */ var AnimatedText = (Animated_createAnimatedComponent(Text/* default */.Z, {
  collapsable: false
}));
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/exports/View/index.js
var View = __webpack_require__(25686);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/vendor/react-native/Animated/components/AnimatedView.js
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */



/* harmony default export */ var AnimatedView = (Animated_createAnimatedComponent(View/* default */.Z, {
  collapsable: true
}));
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/vendor/react-native/Animated/nodes/AnimatedAddition.js
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */







class AnimatedAddition extends nodes_AnimatedWithChildren {
  constructor(a, b) {
    super();
    this._a = typeof a === 'number' ? new nodes_AnimatedValue(a) : a;
    this._b = typeof b === 'number' ? new nodes_AnimatedValue(b) : b;
  }

  __makeNative() {
    this._a.__makeNative();

    this._b.__makeNative();

    super.__makeNative();
  }

  __getValue() {
    return this._a.__getValue() + this._b.__getValue();
  }

  interpolate(config) {
    return new nodes_AnimatedInterpolation(this, config);
  }

  __attach() {
    this._a.__addChild(this);

    this._b.__addChild(this);
  }

  __detach() {
    this._a.__removeChild(this);

    this._b.__removeChild(this);

    super.__detach();
  }

  __getNativeConfig() {
    return {
      type: 'addition',
      input: [this._a.__getNativeTag(), this._b.__getNativeTag()]
    };
  }

}

/* harmony default export */ var nodes_AnimatedAddition = (AnimatedAddition);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/vendor/react-native/Animated/nodes/AnimatedDiffClamp.js
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */






class AnimatedDiffClamp extends nodes_AnimatedWithChildren {
  constructor(a, min, max) {
    super();
    this._a = a;
    this._min = min;
    this._max = max;
    this._value = this._lastValue = this._a.__getValue();
  }

  __makeNative() {
    this._a.__makeNative();

    super.__makeNative();
  }

  interpolate(config) {
    return new nodes_AnimatedInterpolation(this, config);
  }

  __getValue() {
    var value = this._a.__getValue();

    var diff = value - this._lastValue;
    this._lastValue = value;
    this._value = Math.min(Math.max(this._value + diff, this._min), this._max);
    return this._value;
  }

  __attach() {
    this._a.__addChild(this);
  }

  __detach() {
    this._a.__removeChild(this);

    super.__detach();
  }

  __getNativeConfig() {
    return {
      type: 'diffclamp',
      input: this._a.__getNativeTag(),
      min: this._min,
      max: this._max
    };
  }

}

/* harmony default export */ var nodes_AnimatedDiffClamp = (AnimatedDiffClamp);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/vendor/react-native/Animated/nodes/AnimatedDivision.js
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */







class AnimatedDivision extends nodes_AnimatedWithChildren {
  constructor(a, b) {
    super();
    this._warnedAboutDivideByZero = false;

    if (b === 0 || b instanceof nodes_AnimatedNode && b.__getValue() === 0) {
      console.error('Detected potential division by zero in AnimatedDivision');
    }

    this._a = typeof a === 'number' ? new nodes_AnimatedValue(a) : a;
    this._b = typeof b === 'number' ? new nodes_AnimatedValue(b) : b;
  }

  __makeNative() {
    this._a.__makeNative();

    this._b.__makeNative();

    super.__makeNative();
  }

  __getValue() {
    var a = this._a.__getValue();

    var b = this._b.__getValue();

    if (b === 0) {
      // Prevent spamming the console/LogBox
      if (!this._warnedAboutDivideByZero) {
        console.error('Detected division by zero in AnimatedDivision');
        this._warnedAboutDivideByZero = true;
      } // Passing infinity/NaN to Fabric will cause a native crash


      return 0;
    }

    this._warnedAboutDivideByZero = false;
    return a / b;
  }

  interpolate(config) {
    return new nodes_AnimatedInterpolation(this, config);
  }

  __attach() {
    this._a.__addChild(this);

    this._b.__addChild(this);
  }

  __detach() {
    this._a.__removeChild(this);

    this._b.__removeChild(this);

    super.__detach();
  }

  __getNativeConfig() {
    return {
      type: 'division',
      input: [this._a.__getNativeTag(), this._b.__getNativeTag()]
    };
  }

}

/* harmony default export */ var nodes_AnimatedDivision = (AnimatedDivision);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/vendor/react-native/Animated/nodes/AnimatedModulo.js
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */






class AnimatedModulo extends nodes_AnimatedWithChildren {
  constructor(a, modulus) {
    super();
    this._a = a;
    this._modulus = modulus;
  }

  __makeNative() {
    this._a.__makeNative();

    super.__makeNative();
  }

  __getValue() {
    return (this._a.__getValue() % this._modulus + this._modulus) % this._modulus;
  }

  interpolate(config) {
    return new nodes_AnimatedInterpolation(this, config);
  }

  __attach() {
    this._a.__addChild(this);
  }

  __detach() {
    this._a.__removeChild(this);

    super.__detach();
  }

  __getNativeConfig() {
    return {
      type: 'modulus',
      input: this._a.__getNativeTag(),
      modulus: this._modulus
    };
  }

}

/* harmony default export */ var nodes_AnimatedModulo = (AnimatedModulo);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/vendor/react-native/Animated/nodes/AnimatedMultiplication.js
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */







class AnimatedMultiplication extends nodes_AnimatedWithChildren {
  constructor(a, b) {
    super();
    this._a = typeof a === 'number' ? new nodes_AnimatedValue(a) : a;
    this._b = typeof b === 'number' ? new nodes_AnimatedValue(b) : b;
  }

  __makeNative() {
    this._a.__makeNative();

    this._b.__makeNative();

    super.__makeNative();
  }

  __getValue() {
    return this._a.__getValue() * this._b.__getValue();
  }

  interpolate(config) {
    return new nodes_AnimatedInterpolation(this, config);
  }

  __attach() {
    this._a.__addChild(this);

    this._b.__addChild(this);
  }

  __detach() {
    this._a.__removeChild(this);

    this._b.__removeChild(this);

    super.__detach();
  }

  __getNativeConfig() {
    return {
      type: 'multiplication',
      input: [this._a.__getNativeTag(), this._b.__getNativeTag()]
    };
  }

}

/* harmony default export */ var nodes_AnimatedMultiplication = (AnimatedMultiplication);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/vendor/react-native/Animated/nodes/AnimatedSubtraction.js
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */







class AnimatedSubtraction extends nodes_AnimatedWithChildren {
  constructor(a, b) {
    super();
    this._a = typeof a === 'number' ? new nodes_AnimatedValue(a) : a;
    this._b = typeof b === 'number' ? new nodes_AnimatedValue(b) : b;
  }

  __makeNative() {
    this._a.__makeNative();

    this._b.__makeNative();

    super.__makeNative();
  }

  __getValue() {
    return this._a.__getValue() - this._b.__getValue();
  }

  interpolate(config) {
    return new nodes_AnimatedInterpolation(this, config);
  }

  __attach() {
    this._a.__addChild(this);

    this._b.__addChild(this);
  }

  __detach() {
    this._a.__removeChild(this);

    this._b.__removeChild(this);

    super.__detach();
  }

  __getNativeConfig() {
    return {
      type: 'subtraction',
      input: [this._a.__getNativeTag(), this._b.__getNativeTag()]
    };
  }

}

/* harmony default export */ var nodes_AnimatedSubtraction = (AnimatedSubtraction);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/vendor/react-native/Animated/nodes/AnimatedTracking.js
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */







class AnimatedTracking extends nodes_AnimatedNode {
  constructor(value, parent, animationClass, animationConfig, callback) {
    super();
    this._value = value;
    this._parent = parent;
    this._animationClass = animationClass;
    this._animationConfig = animationConfig;
    this._useNativeDriver = shouldUseNativeDriver(animationConfig);
    this._callback = callback;

    this.__attach();
  }

  __makeNative() {
    this.__isNative = true;

    this._parent.__makeNative();

    super.__makeNative();

    this._value.__makeNative();
  }

  __getValue() {
    return this._parent.__getValue();
  }

  __attach() {
    this._parent.__addChild(this);

    if (this._useNativeDriver) {
      // when the tracking starts we need to convert this node to a "native node"
      // so that the parent node will be made "native" too. This is necessary as
      // if we don't do this `update` method will get called. At that point it
      // may be too late as it would mean the JS driver has already started
      // updating node values
      this.__makeNative();
    }
  }

  __detach() {
    this._parent.__removeChild(this);

    super.__detach();
  }

  update() {
    this._value.animate(new this._animationClass((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, this._animationConfig), {}, {
      toValue: this._animationConfig.toValue.__getValue()
    })), this._callback);
  }

  __getNativeConfig() {
    var animation = new this._animationClass((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, this._animationConfig), {}, {
      // remove toValue from the config as it's a ref to Animated.Value
      toValue: undefined
    }));

    var animationConfig = animation.__getNativeAnimationConfig();

    return {
      type: 'tracking',
      animationId: generateNewAnimationId(),
      animationConfig,
      toValue: this._parent.__getNativeTag(),
      value: this._value.__getNativeTag()
    };
  }

}

/* harmony default export */ var nodes_AnimatedTracking = (AnimatedTracking);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/vendor/react-native/Animated/nodes/AnimatedValueXY.js
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */





var AnimatedValueXY_uniqueId = 1;
/**
 * 2D Value for driving 2D animations, such as pan gestures. Almost identical
 * API to normal `Animated.Value`, but multiplexed.
 *
 * See https://reactnative.dev/docs/animatedvaluexy.html
 */

class AnimatedValueXY extends nodes_AnimatedWithChildren {
  constructor(valueIn) {
    super();
    var value = valueIn || {
      x: 0,
      y: 0
    }; // fixme: shouldn't need `: any`

    if (typeof value.x === 'number' && typeof value.y === 'number') {
      this.x = new nodes_AnimatedValue(value.x);
      this.y = new nodes_AnimatedValue(value.y);
    } else {
      invariant_default()(value.x instanceof nodes_AnimatedValue && value.y instanceof nodes_AnimatedValue, 'AnimatedValueXY must be initialized with an object of numbers or ' + 'AnimatedValues.');
      this.x = value.x;
      this.y = value.y;
    }

    this._listeners = {};
  }
  /**
   * Directly set the value. This will stop any animations running on the value
   * and update all the bound properties.
   *
   * See https://reactnative.dev/docs/animatedvaluexy.html#setvalue
   */


  setValue(value) {
    this.x.setValue(value.x);
    this.y.setValue(value.y);
  }
  /**
   * Sets an offset that is applied on top of whatever value is set, whether
   * via `setValue`, an animation, or `Animated.event`. Useful for compensating
   * things like the start of a pan gesture.
   *
   * See https://reactnative.dev/docs/animatedvaluexy.html#setoffset
   */


  setOffset(offset) {
    this.x.setOffset(offset.x);
    this.y.setOffset(offset.y);
  }
  /**
   * Merges the offset value into the base value and resets the offset to zero.
   * The final output of the value is unchanged.
   *
   * See https://reactnative.dev/docs/animatedvaluexy.html#flattenoffset
   */


  flattenOffset() {
    this.x.flattenOffset();
    this.y.flattenOffset();
  }
  /**
   * Sets the offset value to the base value, and resets the base value to
   * zero. The final output of the value is unchanged.
   *
   * See https://reactnative.dev/docs/animatedvaluexy.html#extractoffset
   */


  extractOffset() {
    this.x.extractOffset();
    this.y.extractOffset();
  }

  __getValue() {
    return {
      x: this.x.__getValue(),
      y: this.y.__getValue()
    };
  }
  /**
   * Stops any animation and resets the value to its original.
   *
   * See https://reactnative.dev/docs/animatedvaluexy.html#resetanimation
   */


  resetAnimation(callback) {
    this.x.resetAnimation();
    this.y.resetAnimation();
    callback && callback(this.__getValue());
  }
  /**
   * Stops any running animation or tracking. `callback` is invoked with the
   * final value after stopping the animation, which is useful for updating
   * state to match the animation position with layout.
   *
   * See https://reactnative.dev/docs/animatedvaluexy.html#stopanimation
   */


  stopAnimation(callback) {
    this.x.stopAnimation();
    this.y.stopAnimation();
    callback && callback(this.__getValue());
  }
  /**
   * Adds an asynchronous listener to the value so you can observe updates from
   * animations.  This is useful because there is no way to synchronously read
   * the value because it might be driven natively.
   *
   * Returns a string that serves as an identifier for the listener.
   *
   * See https://reactnative.dev/docs/animatedvaluexy.html#addlistener
   */


  addListener(callback) {
    var id = String(AnimatedValueXY_uniqueId++);

    var jointCallback = _ref => {
      var number = _ref.value;
      callback(this.__getValue());
    };

    this._listeners[id] = {
      x: this.x.addListener(jointCallback),
      y: this.y.addListener(jointCallback)
    };
    return id;
  }
  /**
   * Unregister a listener. The `id` param shall match the identifier
   * previously returned by `addListener()`.
   *
   * See https://reactnative.dev/docs/animatedvaluexy.html#removelistener
   */


  removeListener(id) {
    this.x.removeListener(this._listeners[id].x);
    this.y.removeListener(this._listeners[id].y);
    delete this._listeners[id];
  }
  /**
   * Remove all registered listeners.
   *
   * See https://reactnative.dev/docs/animatedvaluexy.html#removealllisteners
   */


  removeAllListeners() {
    this.x.removeAllListeners();
    this.y.removeAllListeners();
    this._listeners = {};
  }
  /**
   * Converts `{x, y}` into `{left, top}` for use in style.
   *
   * See https://reactnative.dev/docs/animatedvaluexy.html#getlayout
   */


  getLayout() {
    return {
      left: this.x,
      top: this.y
    };
  }
  /**
   * Converts `{x, y}` into a useable translation transform.
   *
   * See https://reactnative.dev/docs/animatedvaluexy.html#gettranslatetransform
   */


  getTranslateTransform() {
    return [{
      translateX: this.x
    }, {
      translateY: this.y
    }];
  }

}

/* harmony default export */ var nodes_AnimatedValueXY = (AnimatedValueXY);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/vendor/react-native/Animated/animations/Animation.js
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */



var startNativeAnimationNextId = 1; // Important note: start() and stop() will only be called at most once.
// Once an animation has been stopped or finished its course, it will
// not be reused.

class Animation {
  start(fromValue, onUpdate, onEnd, previousAnimation, animatedValue) {}

  stop() {
    if (this.__nativeId) {
      NativeAnimatedHelper.API.stopAnimation(this.__nativeId);
    }
  }

  __getNativeAnimationConfig() {
    // Subclasses that have corresponding animation implementation done in native
    // should override this method
    throw new Error('This animation type cannot be offloaded to native');
  } // Helper function for subclasses to make sure onEnd is only called once.


  __debouncedOnEnd(result) {
    var onEnd = this.__onEnd;
    this.__onEnd = null;
    onEnd && onEnd(result);
  }

  __startNativeAnimation(animatedValue) {
    var startNativeAnimationWaitId = startNativeAnimationNextId + ":startAnimation";
    startNativeAnimationNextId += 1;
    NativeAnimatedHelper.API.setWaitingForIdentifier(startNativeAnimationWaitId);

    try {
      animatedValue.__makeNative();

      this.__nativeId = NativeAnimatedHelper.generateNewAnimationId();
      NativeAnimatedHelper.API.startAnimatingNode(this.__nativeId, animatedValue.__getNativeTag(), this.__getNativeAnimationConfig(), this.__debouncedOnEnd.bind(this));
    } catch (e) {
      throw e;
    } finally {
      NativeAnimatedHelper.API.unsetWaitingForIdentifier(startNativeAnimationWaitId);
    }
  }

}

/* harmony default export */ var animations_Animation = (Animation);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/vendor/react-native/Animated/animations/DecayAnimation.js
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */





class DecayAnimation extends animations_Animation {
  constructor(config) {
    var _config$deceleration, _config$isInteraction, _config$iterations;

    super();
    this._deceleration = (_config$deceleration = config.deceleration) !== null && _config$deceleration !== void 0 ? _config$deceleration : 0.998;
    this._velocity = config.velocity;
    this._useNativeDriver = shouldUseNativeDriver(config);
    this.__isInteraction = (_config$isInteraction = config.isInteraction) !== null && _config$isInteraction !== void 0 ? _config$isInteraction : !this._useNativeDriver;
    this.__iterations = (_config$iterations = config.iterations) !== null && _config$iterations !== void 0 ? _config$iterations : 1;
  }

  __getNativeAnimationConfig() {
    return {
      type: 'decay',
      deceleration: this._deceleration,
      velocity: this._velocity,
      iterations: this.__iterations
    };
  }

  start(fromValue, onUpdate, onEnd, previousAnimation, animatedValue) {
    this.__active = true;
    this._lastValue = fromValue;
    this._fromValue = fromValue;
    this._onUpdate = onUpdate;
    this.__onEnd = onEnd;
    this._startTime = Date.now();

    if (this._useNativeDriver) {
      this.__startNativeAnimation(animatedValue);
    } else {
      this._animationFrame = requestAnimationFrame(this.onUpdate.bind(this));
    }
  }

  onUpdate() {
    var now = Date.now();
    var value = this._fromValue + this._velocity / (1 - this._deceleration) * (1 - Math.exp(-(1 - this._deceleration) * (now - this._startTime)));

    this._onUpdate(value);

    if (Math.abs(this._lastValue - value) < 0.1) {
      this.__debouncedOnEnd({
        finished: true
      });

      return;
    }

    this._lastValue = value;

    if (this.__active) {
      this._animationFrame = requestAnimationFrame(this.onUpdate.bind(this));
    }
  }

  stop() {
    super.stop();
    this.__active = false;
    __webpack_require__.g.cancelAnimationFrame(this._animationFrame);

    this.__debouncedOnEnd({
      finished: false
    });
  }

}

/* harmony default export */ var animations_DecayAnimation = (DecayAnimation);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/vendor/react-native/Animated/SpringConfig.js
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 */


function stiffnessFromOrigamiValue(oValue) {
  return (oValue - 30) * 3.62 + 194;
}

function dampingFromOrigamiValue(oValue) {
  return (oValue - 8) * 3 + 25;
}

function fromOrigamiTensionAndFriction(tension, friction) {
  return {
    stiffness: stiffnessFromOrigamiValue(tension),
    damping: dampingFromOrigamiValue(friction)
  };
}

function fromBouncinessAndSpeed(bounciness, speed) {
  function normalize(value, startValue, endValue) {
    return (value - startValue) / (endValue - startValue);
  }

  function projectNormal(n, start, end) {
    return start + n * (end - start);
  }

  function linearInterpolation(t, start, end) {
    return t * end + (1 - t) * start;
  }

  function quadraticOutInterpolation(t, start, end) {
    return linearInterpolation(2 * t - t * t, start, end);
  }

  function b3Friction1(x) {
    return 0.0007 * Math.pow(x, 3) - 0.031 * Math.pow(x, 2) + 0.64 * x + 1.28;
  }

  function b3Friction2(x) {
    return 0.000044 * Math.pow(x, 3) - 0.006 * Math.pow(x, 2) + 0.36 * x + 2;
  }

  function b3Friction3(x) {
    return 0.00000045 * Math.pow(x, 3) - 0.000332 * Math.pow(x, 2) + 0.1078 * x + 5.84;
  }

  function b3Nobounce(tension) {
    if (tension <= 18) {
      return b3Friction1(tension);
    } else if (tension > 18 && tension <= 44) {
      return b3Friction2(tension);
    } else {
      return b3Friction3(tension);
    }
  }

  var b = normalize(bounciness / 1.7, 0, 20);
  b = projectNormal(b, 0, 0.8);
  var s = normalize(speed / 1.7, 0, 20);
  var bouncyTension = projectNormal(s, 0.5, 200);
  var bouncyFriction = quadraticOutInterpolation(b, b3Nobounce(bouncyTension), 0.01);
  return {
    stiffness: stiffnessFromOrigamiValue(bouncyTension),
    damping: dampingFromOrigamiValue(bouncyFriction)
  };
}

/* harmony default export */ var SpringConfig = ({
  fromOrigamiTensionAndFriction,
  fromBouncinessAndSpeed
});
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/vendor/react-native/Animated/animations/SpringAnimation.js
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */










class SpringAnimation extends animations_Animation {
  constructor(config) {
    var _config$overshootClam, _config$restDisplacem, _config$restSpeedThre, _config$velocity, _config$velocity2, _config$delay, _config$isInteraction, _config$iterations;

    super();
    this._overshootClamping = (_config$overshootClam = config.overshootClamping) !== null && _config$overshootClam !== void 0 ? _config$overshootClam : false;
    this._restDisplacementThreshold = (_config$restDisplacem = config.restDisplacementThreshold) !== null && _config$restDisplacem !== void 0 ? _config$restDisplacem : 0.001;
    this._restSpeedThreshold = (_config$restSpeedThre = config.restSpeedThreshold) !== null && _config$restSpeedThre !== void 0 ? _config$restSpeedThre : 0.001;
    this._initialVelocity = (_config$velocity = config.velocity) !== null && _config$velocity !== void 0 ? _config$velocity : 0;
    this._lastVelocity = (_config$velocity2 = config.velocity) !== null && _config$velocity2 !== void 0 ? _config$velocity2 : 0;
    this._toValue = config.toValue;
    this._delay = (_config$delay = config.delay) !== null && _config$delay !== void 0 ? _config$delay : 0;
    this._useNativeDriver = shouldUseNativeDriver(config);
    this.__isInteraction = (_config$isInteraction = config.isInteraction) !== null && _config$isInteraction !== void 0 ? _config$isInteraction : !this._useNativeDriver;
    this.__iterations = (_config$iterations = config.iterations) !== null && _config$iterations !== void 0 ? _config$iterations : 1;

    if (config.stiffness !== undefined || config.damping !== undefined || config.mass !== undefined) {
      var _config$stiffness, _config$damping, _config$mass;

      invariant_default()(config.bounciness === undefined && config.speed === undefined && config.tension === undefined && config.friction === undefined, 'You can define one of bounciness/speed, tension/friction, or stiffness/damping/mass, but not more than one');
      this._stiffness = (_config$stiffness = config.stiffness) !== null && _config$stiffness !== void 0 ? _config$stiffness : 100;
      this._damping = (_config$damping = config.damping) !== null && _config$damping !== void 0 ? _config$damping : 10;
      this._mass = (_config$mass = config.mass) !== null && _config$mass !== void 0 ? _config$mass : 1;
    } else if (config.bounciness !== undefined || config.speed !== undefined) {
      var _config$bounciness, _config$speed;

      // Convert the origami bounciness/speed values to stiffness/damping
      // We assume mass is 1.
      invariant_default()(config.tension === undefined && config.friction === undefined && config.stiffness === undefined && config.damping === undefined && config.mass === undefined, 'You can define one of bounciness/speed, tension/friction, or stiffness/damping/mass, but not more than one');
      var springConfig = SpringConfig.fromBouncinessAndSpeed((_config$bounciness = config.bounciness) !== null && _config$bounciness !== void 0 ? _config$bounciness : 8, (_config$speed = config.speed) !== null && _config$speed !== void 0 ? _config$speed : 12);
      this._stiffness = springConfig.stiffness;
      this._damping = springConfig.damping;
      this._mass = 1;
    } else {
      var _config$tension, _config$friction;

      // Convert the origami tension/friction values to stiffness/damping
      // We assume mass is 1.
      var _springConfig = SpringConfig.fromOrigamiTensionAndFriction((_config$tension = config.tension) !== null && _config$tension !== void 0 ? _config$tension : 40, (_config$friction = config.friction) !== null && _config$friction !== void 0 ? _config$friction : 7);

      this._stiffness = _springConfig.stiffness;
      this._damping = _springConfig.damping;
      this._mass = 1;
    }

    invariant_default()(this._stiffness > 0, 'Stiffness value must be greater than 0');
    invariant_default()(this._damping > 0, 'Damping value must be greater than 0');
    invariant_default()(this._mass > 0, 'Mass value must be greater than 0');
  }

  __getNativeAnimationConfig() {
    var _this$_initialVelocit;

    return {
      type: 'spring',
      overshootClamping: this._overshootClamping,
      restDisplacementThreshold: this._restDisplacementThreshold,
      restSpeedThreshold: this._restSpeedThreshold,
      stiffness: this._stiffness,
      damping: this._damping,
      mass: this._mass,
      initialVelocity: (_this$_initialVelocit = this._initialVelocity) !== null && _this$_initialVelocit !== void 0 ? _this$_initialVelocit : this._lastVelocity,
      toValue: this._toValue,
      iterations: this.__iterations
    };
  }

  start(fromValue, onUpdate, onEnd, previousAnimation, animatedValue) {
    this.__active = true;
    this._startPosition = fromValue;
    this._lastPosition = this._startPosition;
    this._onUpdate = onUpdate;
    this.__onEnd = onEnd;
    this._lastTime = Date.now();
    this._frameTime = 0.0;

    if (previousAnimation instanceof SpringAnimation) {
      var internalState = previousAnimation.getInternalState();
      this._lastPosition = internalState.lastPosition;
      this._lastVelocity = internalState.lastVelocity; // Set the initial velocity to the last velocity

      this._initialVelocity = this._lastVelocity;
      this._lastTime = internalState.lastTime;
    }

    var start = () => {
      if (this._useNativeDriver) {
        this.__startNativeAnimation(animatedValue);
      } else {
        this.onUpdate();
      }
    }; //  If this._delay is more than 0, we start after the timeout.


    if (this._delay) {
      this._timeout = setTimeout(start, this._delay);
    } else {
      start();
    }
  }

  getInternalState() {
    return {
      lastPosition: this._lastPosition,
      lastVelocity: this._lastVelocity,
      lastTime: this._lastTime
    };
  }
  /**
   * This spring model is based off of a damped harmonic oscillator
   * (https://en.wikipedia.org/wiki/Harmonic_oscillator#Damped_harmonic_oscillator).
   *
   * We use the closed form of the second order differential equation:
   *
   * x'' + (2ζ⍵_0)x' + ⍵^2x = 0
   *
   * where
   *    ⍵_0 = √(k / m) (undamped angular frequency of the oscillator),
   *    ζ = c / 2√mk (damping ratio),
   *    c = damping constant
   *    k = stiffness
   *    m = mass
   *
   * The derivation of the closed form is described in detail here:
   * http://planetmath.org/sites/default/files/texpdf/39745.pdf
   *
   * This algorithm happens to match the algorithm used by CASpringAnimation,
   * a QuartzCore (iOS) API that creates spring animations.
   */


  onUpdate() {
    // If for some reason we lost a lot of frames (e.g. process large payload or
    // stopped in the debugger), we only advance by 4 frames worth of
    // computation and will continue on the next frame. It's better to have it
    // running at faster speed than jumping to the end.
    var MAX_STEPS = 64;
    var now = Date.now();

    if (now > this._lastTime + MAX_STEPS) {
      now = this._lastTime + MAX_STEPS;
    }

    var deltaTime = (now - this._lastTime) / 1000;
    this._frameTime += deltaTime;
    var c = this._damping;
    var m = this._mass;
    var k = this._stiffness;
    var v0 = -this._initialVelocity;
    var zeta = c / (2 * Math.sqrt(k * m)); // damping ratio

    var omega0 = Math.sqrt(k / m); // undamped angular frequency of the oscillator (rad/ms)

    var omega1 = omega0 * Math.sqrt(1.0 - zeta * zeta); // exponential decay

    var x0 = this._toValue - this._startPosition; // calculate the oscillation from x0 = 1 to x = 0

    var position = 0.0;
    var velocity = 0.0;
    var t = this._frameTime;

    if (zeta < 1) {
      // Under damped
      var envelope = Math.exp(-zeta * omega0 * t);
      position = this._toValue - envelope * ((v0 + zeta * omega0 * x0) / omega1 * Math.sin(omega1 * t) + x0 * Math.cos(omega1 * t)); // This looks crazy -- it's actually just the derivative of the
      // oscillation function

      velocity = zeta * omega0 * envelope * (Math.sin(omega1 * t) * (v0 + zeta * omega0 * x0) / omega1 + x0 * Math.cos(omega1 * t)) - envelope * (Math.cos(omega1 * t) * (v0 + zeta * omega0 * x0) - omega1 * x0 * Math.sin(omega1 * t));
    } else {
      // Critically damped
      var _envelope = Math.exp(-omega0 * t);

      position = this._toValue - _envelope * (x0 + (v0 + omega0 * x0) * t);
      velocity = _envelope * (v0 * (t * omega0 - 1) + t * x0 * (omega0 * omega0));
    }

    this._lastTime = now;
    this._lastPosition = position;
    this._lastVelocity = velocity;

    this._onUpdate(position);

    if (!this.__active) {
      // a listener might have stopped us in _onUpdate
      return;
    } // Conditions for stopping the spring animation


    var isOvershooting = false;

    if (this._overshootClamping && this._stiffness !== 0) {
      if (this._startPosition < this._toValue) {
        isOvershooting = position > this._toValue;
      } else {
        isOvershooting = position < this._toValue;
      }
    }

    var isVelocity = Math.abs(velocity) <= this._restSpeedThreshold;

    var isDisplacement = true;

    if (this._stiffness !== 0) {
      isDisplacement = Math.abs(this._toValue - position) <= this._restDisplacementThreshold;
    }

    if (isOvershooting || isVelocity && isDisplacement) {
      if (this._stiffness !== 0) {
        // Ensure that we end up with a round value
        this._lastPosition = this._toValue;
        this._lastVelocity = 0;

        this._onUpdate(this._toValue);
      }

      this.__debouncedOnEnd({
        finished: true
      });

      return;
    }

    this._animationFrame = requestAnimationFrame(this.onUpdate.bind(this));
  }

  stop() {
    super.stop();
    this.__active = false;
    clearTimeout(this._timeout);
    __webpack_require__.g.cancelAnimationFrame(this._animationFrame);

    this.__debouncedOnEnd({
      finished: false
    });
  }

}

/* harmony default export */ var animations_SpringAnimation = (SpringAnimation);
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/exports/Easing/index.js + 2 modules
var Easing = __webpack_require__(25166);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/vendor/react-native/Animated/animations/TimingAnimation.js
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */









var _easeInOut;

function easeInOut() {
  if (!_easeInOut) {
    _easeInOut = Easing/* default.inOut */.Z.inOut(Easing/* default.ease */.Z.ease);
  }

  return _easeInOut;
}

class TimingAnimation extends animations_Animation {
  constructor(config) {
    var _config$easing, _config$duration, _config$delay, _config$iterations, _config$isInteraction;

    super();
    this._toValue = config.toValue;
    this._easing = (_config$easing = config.easing) !== null && _config$easing !== void 0 ? _config$easing : easeInOut();
    this._duration = (_config$duration = config.duration) !== null && _config$duration !== void 0 ? _config$duration : 500;
    this._delay = (_config$delay = config.delay) !== null && _config$delay !== void 0 ? _config$delay : 0;
    this.__iterations = (_config$iterations = config.iterations) !== null && _config$iterations !== void 0 ? _config$iterations : 1;
    this._useNativeDriver = shouldUseNativeDriver(config);
    this.__isInteraction = (_config$isInteraction = config.isInteraction) !== null && _config$isInteraction !== void 0 ? _config$isInteraction : !this._useNativeDriver;
  }

  __getNativeAnimationConfig() {
    var frameDuration = 1000.0 / 60.0;
    var frames = [];
    var numFrames = Math.round(this._duration / frameDuration);

    for (var frame = 0; frame < numFrames; frame++) {
      frames.push(this._easing(frame / numFrames));
    }

    frames.push(this._easing(1));
    return {
      type: 'frames',
      frames,
      toValue: this._toValue,
      iterations: this.__iterations
    };
  }

  start(fromValue, onUpdate, onEnd, previousAnimation, animatedValue) {
    this.__active = true;
    this._fromValue = fromValue;
    this._onUpdate = onUpdate;
    this.__onEnd = onEnd;

    var start = () => {
      // Animations that sometimes have 0 duration and sometimes do not
      // still need to use the native driver when duration is 0 so as to
      // not cause intermixed JS and native animations.
      if (this._duration === 0 && !this._useNativeDriver) {
        this._onUpdate(this._toValue);

        this.__debouncedOnEnd({
          finished: true
        });
      } else {
        this._startTime = Date.now();

        if (this._useNativeDriver) {
          this.__startNativeAnimation(animatedValue);
        } else {
          this._animationFrame = requestAnimationFrame(this.onUpdate.bind(this));
        }
      }
    };

    if (this._delay) {
      this._timeout = setTimeout(start, this._delay);
    } else {
      start();
    }
  }

  onUpdate() {
    var now = Date.now();

    if (now >= this._startTime + this._duration) {
      if (this._duration === 0) {
        this._onUpdate(this._toValue);
      } else {
        this._onUpdate(this._fromValue + this._easing(1) * (this._toValue - this._fromValue));
      }

      this.__debouncedOnEnd({
        finished: true
      });

      return;
    }

    this._onUpdate(this._fromValue + this._easing((now - this._startTime) / this._duration) * (this._toValue - this._fromValue));

    if (this.__active) {
      this._animationFrame = requestAnimationFrame(this.onUpdate.bind(this));
    }
  }

  stop() {
    super.stop();
    this.__active = false;
    clearTimeout(this._timeout);
    __webpack_require__.g.cancelAnimationFrame(this._animationFrame);

    this.__debouncedOnEnd({
      finished: false
    });
  }

}

/* harmony default export */ var animations_TimingAnimation = (TimingAnimation);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/vendor/react-native/Animated/AnimatedImplementation.js
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */





















var add = function add(a, b) {
  return new nodes_AnimatedAddition(a, b);
};

var subtract = function subtract(a, b) {
  return new nodes_AnimatedSubtraction(a, b);
};

var divide = function divide(a, b) {
  return new nodes_AnimatedDivision(a, b);
};

var multiply = function multiply(a, b) {
  return new nodes_AnimatedMultiplication(a, b);
};

var modulo = function modulo(a, modulus) {
  return new nodes_AnimatedModulo(a, modulus);
};

var diffClamp = function diffClamp(a, min, max) {
  return new nodes_AnimatedDiffClamp(a, min, max);
};

var _combineCallbacks = function _combineCallbacks(callback, config) {
  if (callback && config.onComplete) {
    return function () {
      config.onComplete && config.onComplete(...arguments);
      callback && callback(...arguments);
    };
  } else {
    return callback || config.onComplete;
  }
};

var maybeVectorAnim = function maybeVectorAnim(value, config, anim) {
  if (value instanceof nodes_AnimatedValueXY) {
    var configX = (0,objectSpread2/* default */.Z)({}, config);

    var configY = (0,objectSpread2/* default */.Z)({}, config);

    for (var key in config) {
      var _config$key = config[key],
          x = _config$key.x,
          y = _config$key.y;

      if (x !== undefined && y !== undefined) {
        configX[key] = x;
        configY[key] = y;
      }
    }

    var aX = anim(value.x, configX);
    var aY = anim(value.y, configY); // We use `stopTogether: false` here because otherwise tracking will break
    // because the second animation will get stopped before it can update.

    return parallel([aX, aY], {
      stopTogether: false
    });
  }

  return null;
};

var spring = function spring(value, config) {
  var _start = function start(animatedValue, configuration, callback) {
    callback = _combineCallbacks(callback, configuration);
    var singleValue = animatedValue;
    var singleConfig = configuration;
    singleValue.stopTracking();

    if (configuration.toValue instanceof nodes_AnimatedNode) {
      singleValue.track(new nodes_AnimatedTracking(singleValue, configuration.toValue, animations_SpringAnimation, singleConfig, callback));
    } else {
      singleValue.animate(new animations_SpringAnimation(singleConfig), callback);
    }
  };

  return maybeVectorAnim(value, config, spring) || {
    start: function start(callback) {
      _start(value, config, callback);
    },
    stop: function stop() {
      value.stopAnimation();
    },
    reset: function reset() {
      value.resetAnimation();
    },
    _startNativeLoop: function _startNativeLoop(iterations) {
      var singleConfig = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, config), {}, {
        iterations
      });

      _start(value, singleConfig);
    },
    _isUsingNativeDriver: function _isUsingNativeDriver() {
      return config.useNativeDriver || false;
    }
  };
};

var timing = function timing(value, config) {
  var _start2 = function start(animatedValue, configuration, callback) {
    callback = _combineCallbacks(callback, configuration);
    var singleValue = animatedValue;
    var singleConfig = configuration;
    singleValue.stopTracking();

    if (configuration.toValue instanceof nodes_AnimatedNode) {
      singleValue.track(new nodes_AnimatedTracking(singleValue, configuration.toValue, animations_TimingAnimation, singleConfig, callback));
    } else {
      singleValue.animate(new animations_TimingAnimation(singleConfig), callback);
    }
  };

  return maybeVectorAnim(value, config, timing) || {
    start: function start(callback) {
      _start2(value, config, callback);
    },
    stop: function stop() {
      value.stopAnimation();
    },
    reset: function reset() {
      value.resetAnimation();
    },
    _startNativeLoop: function _startNativeLoop(iterations) {
      var singleConfig = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, config), {}, {
        iterations
      });

      _start2(value, singleConfig);
    },
    _isUsingNativeDriver: function _isUsingNativeDriver() {
      return config.useNativeDriver || false;
    }
  };
};

var decay = function decay(value, config) {
  var _start3 = function start(animatedValue, configuration, callback) {
    callback = _combineCallbacks(callback, configuration);
    var singleValue = animatedValue;
    var singleConfig = configuration;
    singleValue.stopTracking();
    singleValue.animate(new animations_DecayAnimation(singleConfig), callback);
  };

  return maybeVectorAnim(value, config, decay) || {
    start: function start(callback) {
      _start3(value, config, callback);
    },
    stop: function stop() {
      value.stopAnimation();
    },
    reset: function reset() {
      value.resetAnimation();
    },
    _startNativeLoop: function _startNativeLoop(iterations) {
      var singleConfig = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, config), {}, {
        iterations
      });

      _start3(value, singleConfig);
    },
    _isUsingNativeDriver: function _isUsingNativeDriver() {
      return config.useNativeDriver || false;
    }
  };
};

var sequence = function sequence(animations) {
  var current = 0;
  return {
    start: function start(callback) {
      var onComplete = function onComplete(result) {
        if (!result.finished) {
          callback && callback(result);
          return;
        }

        current++;

        if (current === animations.length) {
          callback && callback(result);
          return;
        }

        animations[current].start(onComplete);
      };

      if (animations.length === 0) {
        callback && callback({
          finished: true
        });
      } else {
        animations[current].start(onComplete);
      }
    },
    stop: function stop() {
      if (current < animations.length) {
        animations[current].stop();
      }
    },
    reset: function reset() {
      animations.forEach((animation, idx) => {
        if (idx <= current) {
          animation.reset();
        }
      });
      current = 0;
    },
    _startNativeLoop: function _startNativeLoop() {
      throw new Error('Loops run using the native driver cannot contain Animated.sequence animations');
    },
    _isUsingNativeDriver: function _isUsingNativeDriver() {
      return false;
    }
  };
};

var parallel = function parallel(animations, config) {
  var doneCount = 0; // Make sure we only call stop() at most once for each animation

  var hasEnded = {};
  var stopTogether = !(config && config.stopTogether === false);
  var result = {
    start: function start(callback) {
      if (doneCount === animations.length) {
        callback && callback({
          finished: true
        });
        return;
      }

      animations.forEach((animation, idx) => {
        var cb = function cb(endResult) {
          hasEnded[idx] = true;
          doneCount++;

          if (doneCount === animations.length) {
            doneCount = 0;
            callback && callback(endResult);
            return;
          }

          if (!endResult.finished && stopTogether) {
            result.stop();
          }
        };

        if (!animation) {
          cb({
            finished: true
          });
        } else {
          animation.start(cb);
        }
      });
    },
    stop: function stop() {
      animations.forEach((animation, idx) => {
        !hasEnded[idx] && animation.stop();
        hasEnded[idx] = true;
      });
    },
    reset: function reset() {
      animations.forEach((animation, idx) => {
        animation.reset();
        hasEnded[idx] = false;
        doneCount = 0;
      });
    },
    _startNativeLoop: function _startNativeLoop() {
      throw new Error('Loops run using the native driver cannot contain Animated.parallel animations');
    },
    _isUsingNativeDriver: function _isUsingNativeDriver() {
      return false;
    }
  };
  return result;
};

var delay = function delay(time) {
  // Would be nice to make a specialized implementation
  return timing(new nodes_AnimatedValue(0), {
    toValue: 0,
    delay: time,
    duration: 0,
    useNativeDriver: false
  });
};

var stagger = function stagger(time, animations) {
  return parallel(animations.map((animation, i) => {
    return sequence([delay(time * i), animation]);
  }));
};

var loop = function loop(animation, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$iterations = _ref.iterations,
      iterations = _ref$iterations === void 0 ? -1 : _ref$iterations,
      _ref$resetBeforeItera = _ref.resetBeforeIteration,
      resetBeforeIteration = _ref$resetBeforeItera === void 0 ? true : _ref$resetBeforeItera;

  var isFinished = false;
  var iterationsSoFar = 0;
  return {
    start: function start(callback) {
      var restart = function restart(result) {
        if (result === void 0) {
          result = {
            finished: true
          };
        }

        if (isFinished || iterationsSoFar === iterations || result.finished === false) {
          callback && callback(result);
        } else {
          iterationsSoFar++;
          resetBeforeIteration && animation.reset();
          animation.start(restart);
        }
      };

      if (!animation || iterations === 0) {
        callback && callback({
          finished: true
        });
      } else {
        if (animation._isUsingNativeDriver()) {
          animation._startNativeLoop(iterations);
        } else {
          restart(); // Start looping recursively on the js thread
        }
      }
    },
    stop: function stop() {
      isFinished = true;
      animation.stop();
    },
    reset: function reset() {
      iterationsSoFar = 0;
      isFinished = false;
      animation.reset();
    },
    _startNativeLoop: function _startNativeLoop() {
      throw new Error('Loops run using the native driver cannot contain Animated.loop animations');
    },
    _isUsingNativeDriver: function _isUsingNativeDriver() {
      return animation._isUsingNativeDriver();
    }
  };
};

function forkEvent(event, listener) {
  if (!event) {
    return listener;
  } else if (event instanceof AnimatedEvent) {
    event.__addListener(listener);

    return event;
  } else {
    return function () {
      typeof event === 'function' && event(...arguments);
      listener(...arguments);
    };
  }
}

function unforkEvent(event, listener) {
  if (event && event instanceof AnimatedEvent) {
    event.__removeListener(listener);
  }
}

var AnimatedImplementation_event = function event(argMapping, config) {
  var animatedEvent = new AnimatedEvent(argMapping, config);

  if (animatedEvent.__isNative) {
    return animatedEvent;
  } else {
    return animatedEvent.__getHandler();
  }
};
/**
 * The `Animated` library is designed to make animations fluid, powerful, and
 * easy to build and maintain. `Animated` focuses on declarative relationships
 * between inputs and outputs, with configurable transforms in between, and
 * simple `start`/`stop` methods to control time-based animation execution.
 * If additional transforms are added, be sure to include them in
 * AnimatedMock.js as well.
 *
 * See https://reactnative.dev/docs/animated.html
 */


/* harmony default export */ var AnimatedImplementation = ({
  /**
   * Standard value class for driving animations.  Typically initialized with
   * `new Animated.Value(0);`
   *
   * See https://reactnative.dev/docs/animated.html#value
   */
  Value: nodes_AnimatedValue,

  /**
   * 2D value class for driving 2D animations, such as pan gestures.
   *
   * See https://reactnative.dev/docs/animatedvaluexy.html
   */
  ValueXY: nodes_AnimatedValueXY,

  /**
   * Exported to use the Interpolation type in flow.
   *
   * See https://reactnative.dev/docs/animated.html#interpolation
   */
  Interpolation: nodes_AnimatedInterpolation,

  /**
   * Exported for ease of type checking. All animated values derive from this
   * class.
   *
   * See https://reactnative.dev/docs/animated.html#node
   */
  Node: nodes_AnimatedNode,

  /**
   * Animates a value from an initial velocity to zero based on a decay
   * coefficient.
   *
   * See https://reactnative.dev/docs/animated.html#decay
   */
  decay,

  /**
   * Animates a value along a timed easing curve. The Easing module has tons of
   * predefined curves, or you can use your own function.
   *
   * See https://reactnative.dev/docs/animated.html#timing
   */
  timing,

  /**
   * Animates a value according to an analytical spring model based on
   * damped harmonic oscillation.
   *
   * See https://reactnative.dev/docs/animated.html#spring
   */
  spring,

  /**
   * Creates a new Animated value composed from two Animated values added
   * together.
   *
   * See https://reactnative.dev/docs/animated.html#add
   */
  add,

  /**
   * Creates a new Animated value composed by subtracting the second Animated
   * value from the first Animated value.
   *
   * See https://reactnative.dev/docs/animated.html#subtract
   */
  subtract,

  /**
   * Creates a new Animated value composed by dividing the first Animated value
   * by the second Animated value.
   *
   * See https://reactnative.dev/docs/animated.html#divide
   */
  divide,

  /**
   * Creates a new Animated value composed from two Animated values multiplied
   * together.
   *
   * See https://reactnative.dev/docs/animated.html#multiply
   */
  multiply,

  /**
   * Creates a new Animated value that is the (non-negative) modulo of the
   * provided Animated value.
   *
   * See https://reactnative.dev/docs/animated.html#modulo
   */
  modulo,

  /**
   * Create a new Animated value that is limited between 2 values. It uses the
   * difference between the last value so even if the value is far from the
   * bounds it will start changing when the value starts getting closer again.
   *
   * See https://reactnative.dev/docs/animated.html#diffclamp
   */
  diffClamp,

  /**
   * Starts an animation after the given delay.
   *
   * See https://reactnative.dev/docs/animated.html#delay
   */
  delay,

  /**
   * Starts an array of animations in order, waiting for each to complete
   * before starting the next. If the current running animation is stopped, no
   * following animations will be started.
   *
   * See https://reactnative.dev/docs/animated.html#sequence
   */
  sequence,

  /**
   * Starts an array of animations all at the same time. By default, if one
   * of the animations is stopped, they will all be stopped. You can override
   * this with the `stopTogether` flag.
   *
   * See https://reactnative.dev/docs/animated.html#parallel
   */
  parallel,

  /**
   * Array of animations may run in parallel (overlap), but are started in
   * sequence with successive delays.  Nice for doing trailing effects.
   *
   * See https://reactnative.dev/docs/animated.html#stagger
   */
  stagger,

  /**
   * Loops a given animation continuously, so that each time it reaches the
   * end, it resets and begins again from the start.
   *
   * See https://reactnative.dev/docs/animated.html#loop
   */
  loop,

  /**
   * Takes an array of mappings and extracts values from each arg accordingly,
   * then calls `setValue` on the mapped outputs.
   *
   * See https://reactnative.dev/docs/animated.html#event
   */
  event: AnimatedImplementation_event,

  /**
   * Make any React component Animatable.  Used to create `Animated.View`, etc.
   *
   * See https://reactnative.dev/docs/animated.html#createanimatedcomponent
   */
  createAnimatedComponent: Animated_createAnimatedComponent,

  /**
   * Imperative API to attach an animated value to an event on a view. Prefer
   * using `Animated.event` with `useNativeDrive: true` if possible.
   *
   * See https://reactnative.dev/docs/animated.html#attachnativeevent
   */
  attachNativeEvent: attachNativeEvent,

  /**
   * Advanced imperative API for snooping on animated events that are passed in
   * through props. Use values directly where possible.
   *
   * See https://reactnative.dev/docs/animated.html#forkevent
   */
  forkEvent,
  unforkEvent,

  /**
   * Expose Event class, so it can be used as a type for type checkers.
   */
  Event: AnimatedEvent,
  __PropsOnlyForTests: nodes_AnimatedProps
});
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/vendor/react-native/Animated/AnimatedMock.js
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */











var emptyAnimation = {
  start: () => {},
  stop: () => {},
  reset: () => {},
  _startNativeLoop: () => {},
  _isUsingNativeDriver: () => {
    return false;
  }
};

var AnimatedMock_spring = function spring(value, config) {
  var anyValue = value;
  return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, emptyAnimation), {}, {
    start: callback => {
      anyValue.setValue(config.toValue);
      callback && callback({
        finished: true
      });
    }
  });
};

var AnimatedMock_timing = function timing(value, config) {
  var anyValue = value;
  return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, emptyAnimation), {}, {
    start: callback => {
      anyValue.setValue(config.toValue);
      callback && callback({
        finished: true
      });
    }
  });
};

var AnimatedMock_decay = function decay(value, config) {
  return emptyAnimation;
};

var AnimatedMock_sequence = function sequence(animations) {
  return emptyAnimation;
};

var AnimatedMock_parallel = function parallel(animations, config) {
  return emptyAnimation;
};

var AnimatedMock_delay = function delay(time) {
  return emptyAnimation;
};

var AnimatedMock_stagger = function stagger(time, animations) {
  return emptyAnimation;
};

var AnimatedMock_loop = function loop(animation, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$iterations = _ref.iterations,
      iterations = _ref$iterations === void 0 ? -1 : _ref$iterations;

  return emptyAnimation;
};

var AnimatedMock_event = function event(argMapping, config) {
  return null;
};

/* harmony default export */ var AnimatedMock = ({
  Value: nodes_AnimatedValue,
  ValueXY: nodes_AnimatedValueXY,
  Interpolation: nodes_AnimatedInterpolation,
  Node: nodes_AnimatedNode,
  decay: AnimatedMock_decay,
  timing: AnimatedMock_timing,
  spring: AnimatedMock_spring,
  add: AnimatedImplementation.add,
  subtract: AnimatedImplementation.subtract,
  divide: AnimatedImplementation.divide,
  multiply: AnimatedImplementation.multiply,
  modulo: AnimatedImplementation.modulo,
  diffClamp: AnimatedImplementation.diffClamp,
  delay: AnimatedMock_delay,
  sequence: AnimatedMock_sequence,
  parallel: AnimatedMock_parallel,
  stagger: AnimatedMock_stagger,
  loop: AnimatedMock_loop,
  event: AnimatedMock_event,
  createAnimatedComponent: Animated_createAnimatedComponent,
  attachNativeEvent: attachNativeEvent,
  forkEvent: AnimatedImplementation.forkEvent,
  unforkEvent: AnimatedImplementation.unforkEvent,
  Event: AnimatedEvent,
  __PropsOnlyForTests: nodes_AnimatedProps
});
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/vendor/react-native/Animated/Animated.js


/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */









var Animated = Platform/* default.isTesting */.Z.isTesting ? AnimatedMock : AnimatedImplementation;
/* harmony default export */ var Animated_Animated = ((0,objectSpread2/* default */.Z)({
  FlatList: (AnimatedFlatList_default()),
  Image: AnimatedImage,
  ScrollView: AnimatedScrollView,
  SectionList: (AnimatedSectionList_default()),
  Text: AnimatedText,
  View: AnimatedView
}, Animated));
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/exports/Animated/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

/* harmony default export */ var exports_Animated = (Animated_Animated);

/***/ }),

/***/ 44345:
/***/ (function(module) {

module.exports = worm(true)

function worm(root = false) {
  const obj = root
    ? {
        get default() {
          return worm()
        },
      }
    : function () {
        //  dev warning in debug mode
        if (false) {}

        return worm()
      }

  obj.displayName = `ProxyWorm - Check excludeReactNativeWebExports`
  obj._isProxyWorm = true

  return new Proxy(obj, {
    get(_, key) {
      if (Reflect.has(obj, key)) return Reflect.get(obj, key)
      return worm()
    },
    apply() {
      return worm()
    },
  })
}


/***/ }),

/***/ 78052:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Dimensions; }
/* harmony export */ });
/* harmony import */ var fbjs_lib_invariant__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14983);
/* harmony import */ var fbjs_lib_invariant__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(fbjs_lib_invariant__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _modules_canUseDom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19017);
/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


var dimensions = {
  window: {
    fontScale: 1,
    height: 0,
    scale: 1,
    width: 0
  },
  screen: {
    fontScale: 1,
    height: 0,
    scale: 1,
    width: 0
  }
};
var listeners = {};
var shouldInit = _modules_canUseDom__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z;

function update() {
  if (!_modules_canUseDom__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z) {
    return;
  }

  var win = window;
  var height;
  var width;
  /**
   * iOS does not update viewport dimensions on keyboard open/close.
   * window.visualViewport(https://developer.mozilla.org/en-US/docs/Web/API/VisualViewport)
   * is used instead of document.documentElement.clientHeight (which remains as a fallback)
   */

  if (win.visualViewport) {
    var visualViewport = win.visualViewport;
    height = Math.round(visualViewport.height);
    width = Math.round(visualViewport.width);
  } else {
    var docEl = win.document.documentElement;
    height = docEl.clientHeight;
    width = docEl.clientWidth;
  }

  dimensions.window = {
    fontScale: 1,
    height,
    scale: win.devicePixelRatio || 1,
    width
  };
  dimensions.screen = {
    fontScale: 1,
    height: win.screen.height,
    scale: win.devicePixelRatio || 1,
    width: win.screen.width
  };
}

function handleResize() {
  update();

  if (Array.isArray(listeners['change'])) {
    listeners['change'].forEach(handler => handler(dimensions));
  }
}

class Dimensions {
  static get(dimension) {
    if (shouldInit) {
      shouldInit = false;
      update();
    }

    fbjs_lib_invariant__WEBPACK_IMPORTED_MODULE_0___default()(dimensions[dimension], "No dimension set for key " + dimension);
    return dimensions[dimension];
  }

  static set(initialDimensions) {
    if (initialDimensions) {
      if (_modules_canUseDom__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z) {
        fbjs_lib_invariant__WEBPACK_IMPORTED_MODULE_0___default()(false, 'Dimensions cannot be set in the browser');
      } else {
        if (initialDimensions.screen != null) {
          dimensions.screen = initialDimensions.screen;
        }

        if (initialDimensions.window != null) {
          dimensions.window = initialDimensions.window;
        }
      }
    }
  }

  static addEventListener(type, handler) {
    listeners[type] = listeners[type] || [];
    listeners[type].push(handler);
    return {
      remove: () => {
        this.removeEventListener(type, handler);
      }
    };
  }

  static removeEventListener(type, handler) {
    if (Array.isArray(listeners[type])) {
      listeners[type] = listeners[type].filter(_handler => _handler !== handler);
    }
  }

}

if (_modules_canUseDom__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z) {
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', handleResize, false);
  } else {
    window.addEventListener('resize', handleResize, false);
  }
}

/***/ }),

/***/ 25166:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ exports_Easing; }
});

;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/vendor/react-native/Animated/bezier.js
/**
 * Portions Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */

/**
 * BezierEasing - use bezier curve for transition easing function
 * https://github.com/gre/bezier-easing
 * @copyright 2014-2015 Gaëtan Renaudeau. MIT License.
 */
 // These values are established by empiricism with tests (tradeoff: performance VS precision)

var NEWTON_ITERATIONS = 4;
var NEWTON_MIN_SLOPE = 0.001;
var SUBDIVISION_PRECISION = 0.0000001;
var SUBDIVISION_MAX_ITERATIONS = 10;
var kSplineTableSize = 11;
var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);
var float32ArraySupported = typeof Float32Array === 'function';

function A(aA1, aA2) {
  return 1.0 - 3.0 * aA2 + 3.0 * aA1;
}

function B(aA1, aA2) {
  return 3.0 * aA2 - 6.0 * aA1;
}

function C(aA1) {
  return 3.0 * aA1;
} // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.


function calcBezier(aT, aA1, aA2) {
  return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT;
} // Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.


function getSlope(aT, aA1, aA2) {
  return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1);
}

function binarySubdivide(aX, _aA, _aB, mX1, mX2) {
  var currentX,
      currentT,
      i = 0,
      aA = _aA,
      aB = _aB;

  do {
    currentT = aA + (aB - aA) / 2.0;
    currentX = calcBezier(currentT, mX1, mX2) - aX;

    if (currentX > 0.0) {
      aB = currentT;
    } else {
      aA = currentT;
    }
  } while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);

  return currentT;
}

function newtonRaphsonIterate(aX, _aGuessT, mX1, mX2) {
  var aGuessT = _aGuessT;

  for (var i = 0; i < NEWTON_ITERATIONS; ++i) {
    var currentSlope = getSlope(aGuessT, mX1, mX2);

    if (currentSlope === 0.0) {
      return aGuessT;
    }

    var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
    aGuessT -= currentX / currentSlope;
  }

  return aGuessT;
}

function bezier(mX1, mY1, mX2, mY2) {
  if (!(mX1 >= 0 && mX1 <= 1 && mX2 >= 0 && mX2 <= 1)) {
    throw new Error('bezier x values must be in [0, 1] range');
  } // Precompute samples table


  var sampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);

  if (mX1 !== mY1 || mX2 !== mY2) {
    for (var i = 0; i < kSplineTableSize; ++i) {
      sampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
    }
  }

  function getTForX(aX) {
    var intervalStart = 0.0;
    var currentSample = 1;
    var lastSample = kSplineTableSize - 1;

    for (; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample) {
      intervalStart += kSampleStepSize;
    }

    --currentSample; // Interpolate to provide an initial guess for t

    var dist = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample]);
    var guessForT = intervalStart + dist * kSampleStepSize;
    var initialSlope = getSlope(guessForT, mX1, mX2);

    if (initialSlope >= NEWTON_MIN_SLOPE) {
      return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
    } else if (initialSlope === 0.0) {
      return guessForT;
    } else {
      return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
    }
  }

  return function BezierEasing(x) {
    if (mX1 === mY1 && mX2 === mY2) {
      return x; // linear
    } // Because JavaScript number are imprecise, we should guarantee the extremes are right.


    if (x === 0) {
      return 0;
    }

    if (x === 1) {
      return 1;
    }

    return calcBezier(getTForX(x), mY1, mY2);
  };
}
;
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/vendor/react-native/Animated/Easing.js
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 */



var ease;
/**
 * The `Easing` module implements common easing functions. This module is used
 * by [Animate.timing()](docs/animate.html#timing) to convey physically
 * believable motion in animations.
 *
 * You can find a visualization of some common easing functions at
 * http://easings.net/
 *
 * ### Predefined animations
 *
 * The `Easing` module provides several predefined animations through the
 * following methods:
 *
 * - [`back`](docs/easing.html#back) provides a simple animation where the
 *   object goes slightly back before moving forward
 * - [`bounce`](docs/easing.html#bounce) provides a bouncing animation
 * - [`ease`](docs/easing.html#ease) provides a simple inertial animation
 * - [`elastic`](docs/easing.html#elastic) provides a simple spring interaction
 *
 * ### Standard functions
 *
 * Three standard easing functions are provided:
 *
 * - [`linear`](docs/easing.html#linear)
 * - [`quad`](docs/easing.html#quad)
 * - [`cubic`](docs/easing.html#cubic)
 *
 * The [`poly`](docs/easing.html#poly) function can be used to implement
 * quartic, quintic, and other higher power functions.
 *
 * ### Additional functions
 *
 * Additional mathematical functions are provided by the following methods:
 *
 * - [`bezier`](docs/easing.html#bezier) provides a cubic bezier curve
 * - [`circle`](docs/easing.html#circle) provides a circular function
 * - [`sin`](docs/easing.html#sin) provides a sinusoidal function
 * - [`exp`](docs/easing.html#exp) provides an exponential function
 *
 * The following helpers are used to modify other easing functions.
 *
 * - [`in`](docs/easing.html#in) runs an easing function forwards
 * - [`inOut`](docs/easing.html#inout) makes any easing function symmetrical
 * - [`out`](docs/easing.html#out) runs an easing function backwards
 */

class Easing {
  /**
   * A stepping function, returns 1 for any positive value of `n`.
   */
  static step0(n) {
    return n > 0 ? 1 : 0;
  }
  /**
   * A stepping function, returns 1 if `n` is greater than or equal to 1.
   */


  static step1(n) {
    return n >= 1 ? 1 : 0;
  }
  /**
   * A linear function, `f(t) = t`. Position correlates to elapsed time one to
   * one.
   *
   * http://cubic-bezier.com/#0,0,1,1
   */


  static linear(t) {
    return t;
  }
  /**
   * A simple inertial interaction, similar to an object slowly accelerating to
   * speed.
   *
   * http://cubic-bezier.com/#.42,0,1,1
   */


  static ease(t) {
    if (!ease) {
      ease = Easing.bezier(0.42, 0, 1, 1);
    }

    return ease(t);
  }
  /**
   * A quadratic function, `f(t) = t * t`. Position equals the square of elapsed
   * time.
   *
   * http://easings.net/#easeInQuad
   */


  static quad(t) {
    return t * t;
  }
  /**
   * A cubic function, `f(t) = t * t * t`. Position equals the cube of elapsed
   * time.
   *
   * http://easings.net/#easeInCubic
   */


  static cubic(t) {
    return t * t * t;
  }
  /**
   * A power function. Position is equal to the Nth power of elapsed time.
   *
   * n = 4: http://easings.net/#easeInQuart
   * n = 5: http://easings.net/#easeInQuint
   */


  static poly(n) {
    return t => Math.pow(t, n);
  }
  /**
   * A sinusoidal function.
   *
   * http://easings.net/#easeInSine
   */


  static sin(t) {
    return 1 - Math.cos(t * Math.PI / 2);
  }
  /**
   * A circular function.
   *
   * http://easings.net/#easeInCirc
   */


  static circle(t) {
    return 1 - Math.sqrt(1 - t * t);
  }
  /**
   * An exponential function.
   *
   * http://easings.net/#easeInExpo
   */


  static exp(t) {
    return Math.pow(2, 10 * (t - 1));
  }
  /**
   * A simple elastic interaction, similar to a spring oscillating back and
   * forth.
   *
   * Default bounciness is 1, which overshoots a little bit once. 0 bounciness
   * doesn't overshoot at all, and bounciness of N > 1 will overshoot about N
   * times.
   *
   * http://easings.net/#easeInElastic
   */


  static elastic(bounciness) {
    if (bounciness === void 0) {
      bounciness = 1;
    }

    var p = bounciness * Math.PI;
    return t => 1 - Math.pow(Math.cos(t * Math.PI / 2), 3) * Math.cos(t * p);
  }
  /**
   * Use with `Animated.parallel()` to create a simple effect where the object
   * animates back slightly as the animation starts.
   *
   * Wolfram Plot:
   *
   * - http://tiny.cc/back_default (s = 1.70158, default)
   */


  static back(s) {
    if (s === void 0) {
      s = 1.70158;
    }

    return t => t * t * ((s + 1) * t - s);
  }
  /**
   * Provides a simple bouncing effect.
   *
   * http://easings.net/#easeInBounce
   */


  static bounce(t) {
    if (t < 1 / 2.75) {
      return 7.5625 * t * t;
    }

    if (t < 2 / 2.75) {
      var _t = t - 1.5 / 2.75;

      return 7.5625 * _t * _t + 0.75;
    }

    if (t < 2.5 / 2.75) {
      var _t2 = t - 2.25 / 2.75;

      return 7.5625 * _t2 * _t2 + 0.9375;
    }

    var t2 = t - 2.625 / 2.75;
    return 7.5625 * t2 * t2 + 0.984375;
  }
  /**
   * Provides a cubic bezier curve, equivalent to CSS Transitions'
   * `transition-timing-function`.
   *
   * A useful tool to visualize cubic bezier curves can be found at
   * http://cubic-bezier.com/
   */


  static bezier(x1, y1, x2, y2) {
    return bezier(x1, y1, x2, y2);
  }
  /**
   * Runs an easing function forwards.
   */


  static in(easing) {
    return easing;
  }
  /**
   * Runs an easing function backwards.
   */


  static out(easing) {
    return t => 1 - easing(1 - t);
  }
  /**
   * Makes any easing function symmetrical. The easing function will run
   * forwards for half of the duration, then backwards for the rest of the
   * duration.
   */


  static inOut(easing) {
    return t => {
      if (t < 0.5) {
        return easing(t * 2) / 2;
      }

      return 1 - easing((1 - t) * 2) / 2;
    };
  }

}

/* harmony default export */ var Animated_Easing = (Easing);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/exports/Easing/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

/* harmony default export */ var exports_Easing = (Animated_Easing);

/***/ }),

/***/ 55874:
/***/ (function(module) {

module.exports = worm(true)

function worm(root = false) {
  const obj = root
    ? {
        get default() {
          return worm()
        },
      }
    : function () {
        //  dev warning in debug mode
        if (false) {}

        return worm()
      }

  obj.displayName = `ProxyWorm - Check excludeReactNativeWebExports`
  obj._isProxyWorm = true

  return new Proxy(obj, {
    get(_, key) {
      if (Reflect.has(obj, key)) return Reflect.get(obj, key)
      return worm()
    },
    apply() {
      return worm()
    },
  })
}


/***/ }),

/***/ 79470:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ exports_Image; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectSpread2.js + 4 modules
var objectSpread2 = __webpack_require__(29405);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/exports/createElement/index.js
var createElement = __webpack_require__(90601);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/modules/AssetRegistry/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */
var assets = [];
function registerAsset(asset) {
  // `push` returns new array length, so the first asset will
  // get id 1 (not 0) to make the value truthy
  return assets.push(asset);
}
function getAssetByID(assetId) {
  return assets[assetId - 1];
}
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/exports/StyleSheet/preprocess.js
var preprocess = __webpack_require__(49609);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/modules/ImageLoader/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */
var dataUriPattern = /^data:/;
class ImageUriCache {
  static has(uri) {
    var entries = ImageUriCache._entries;
    var isDataUri = dataUriPattern.test(uri);
    return isDataUri || Boolean(entries[uri]);
  }

  static add(uri) {
    var entries = ImageUriCache._entries;
    var lastUsedTimestamp = Date.now();

    if (entries[uri]) {
      entries[uri].lastUsedTimestamp = lastUsedTimestamp;
      entries[uri].refCount += 1;
    } else {
      entries[uri] = {
        lastUsedTimestamp,
        refCount: 1
      };
    }
  }

  static remove(uri) {
    var entries = ImageUriCache._entries;

    if (entries[uri]) {
      entries[uri].refCount -= 1;
    } // Free up entries when the cache is "full"


    ImageUriCache._cleanUpIfNeeded();
  }

  static _cleanUpIfNeeded() {
    var entries = ImageUriCache._entries;
    var imageUris = Object.keys(entries);

    if (imageUris.length + 1 > ImageUriCache._maximumEntries) {
      var leastRecentlyUsedKey;
      var leastRecentlyUsedEntry;
      imageUris.forEach(uri => {
        var entry = entries[uri];

        if ((!leastRecentlyUsedEntry || entry.lastUsedTimestamp < leastRecentlyUsedEntry.lastUsedTimestamp) && entry.refCount === 0) {
          leastRecentlyUsedKey = uri;
          leastRecentlyUsedEntry = entry;
        }
      });

      if (leastRecentlyUsedKey) {
        delete entries[leastRecentlyUsedKey];
      }
    }
  }

}
ImageUriCache._maximumEntries = 256;
ImageUriCache._entries = {};
var id = 0;
var requests = {};
var ImageLoader = {
  abort(requestId) {
    var image = requests["" + requestId];

    if (image) {
      image.onerror = null;
      image.onload = null;
      image = null;
      delete requests["" + requestId];
    }
  },

  getSize(uri, success, failure) {
    var complete = false;
    var interval = setInterval(callback, 16);
    var requestId = ImageLoader.load(uri, callback, errorCallback);

    function callback() {
      var image = requests["" + requestId];

      if (image) {
        var naturalHeight = image.naturalHeight,
            naturalWidth = image.naturalWidth;

        if (naturalHeight && naturalWidth) {
          success(naturalWidth, naturalHeight);
          complete = true;
        }
      }

      if (complete) {
        ImageLoader.abort(requestId);
        clearInterval(interval);
      }
    }

    function errorCallback() {
      if (typeof failure === 'function') {
        failure();
      }

      ImageLoader.abort(requestId);
      clearInterval(interval);
    }
  },

  has(uri) {
    return ImageUriCache.has(uri);
  },

  load(uri, onLoad, onError) {
    id += 1;
    var image = new window.Image();
    image.onerror = onError;

    image.onload = e => {
      // avoid blocking the main thread
      var onDecode = () => onLoad({
        nativeEvent: e
      });

      if (typeof image.decode === 'function') {
        // Safari currently throws exceptions when decoding svgs.
        // We want to catch that error and allow the load handler
        // to be forwarded to the onLoad handler in this case
        image.decode().then(onDecode, onDecode);
      } else {
        setTimeout(onDecode, 0);
      }
    };

    image.src = uri;
    requests["" + id] = image;
    return id;
  },

  prefetch(uri) {
    return new Promise((resolve, reject) => {
      ImageLoader.load(uri, () => {
        // Add the uri to the cache so it can be immediately displayed when used
        // but also immediately remove it to correctly reflect that it has no active references
        ImageUriCache.add(uri);
        ImageUriCache.remove(uri);
        resolve();
      }, reject);
    });
  },

  queryCache(uris) {
    var result = {};
    uris.forEach(u => {
      if (ImageUriCache.has(u)) {
        result[u] = 'disk/memory';
      }
    });
    return Promise.resolve(result);
  }

};
/* harmony default export */ var modules_ImageLoader = (ImageLoader);
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/exports/PixelRatio/index.js
var PixelRatio = __webpack_require__(72016);
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/exports/StyleSheet/index.js + 6 modules
var StyleSheet = __webpack_require__(66068);
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/exports/Text/TextAncestorContext.js
var TextAncestorContext = __webpack_require__(94210);
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/exports/View/index.js
var View = __webpack_require__(25686);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/exports/Image/index.js



var _excluded = ["accessibilityLabel", "blurRadius", "defaultSource", "draggable", "onError", "onLayout", "onLoad", "onLoadEnd", "onLoadStart", "pointerEvents", "source", "style"];

/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */









var ERRORED = 'ERRORED';
var LOADED = 'LOADED';
var LOADING = 'LOADING';
var IDLE = 'IDLE';
var _filterId = 0;
var svgDataUriPattern = /^(data:image\/svg\+xml;utf8,)(.*)/;

function createTintColorSVG(tintColor, id) {
  return tintColor && id != null ? /*#__PURE__*/react.createElement("svg", {
    style: {
      position: 'absolute',
      height: 0,
      visibility: 'hidden',
      width: 0
    }
  }, /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("filter", {
    id: "tint-" + id,
    suppressHydrationWarning: true
  }, /*#__PURE__*/react.createElement("feFlood", {
    floodColor: "" + tintColor,
    key: tintColor
  }), /*#__PURE__*/react.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "atop"
  })))) : null;
}

function getFlatStyle(style, blurRadius, filterId) {
  var flatStyle = StyleSheet/* default.flatten */.Z.flatten(style);
  var filter = flatStyle.filter,
      resizeMode = flatStyle.resizeMode,
      shadowOffset = flatStyle.shadowOffset,
      tintColor = flatStyle.tintColor; // Add CSS filters
  // React Native exposes these features as props and proprietary styles

  var filters = [];
  var _filter = null;

  if (filter) {
    filters.push(filter);
  }

  if (blurRadius) {
    filters.push("blur(" + blurRadius + "px)");
  }

  if (shadowOffset) {
    var shadowString = (0,preprocess/* createBoxShadowValue */.Lm)(flatStyle);

    if (shadowString) {
      filters.push("drop-shadow(" + shadowString + ")");
    }
  }

  if (tintColor && filterId != null) {
    filters.push("url(#tint-" + filterId + ")");
  }

  if (filters.length > 0) {
    _filter = filters.join(' ');
  } // These styles are converted to CSS filters applied to the
  // element displaying the background image.


  delete flatStyle.blurRadius;
  delete flatStyle.shadowColor;
  delete flatStyle.shadowOpacity;
  delete flatStyle.shadowOffset;
  delete flatStyle.shadowRadius;
  delete flatStyle.tintColor; // These styles are not supported on View

  delete flatStyle.overlayColor;
  delete flatStyle.resizeMode;
  return [flatStyle, resizeMode, _filter, tintColor];
}

function resolveAssetDimensions(source) {
  if (typeof source === 'number') {
    var _getAssetByID = getAssetByID(source),
        _height = _getAssetByID.height,
        _width = _getAssetByID.width;

    return {
      height: _height,
      width: _width
    };
  } else if (source != null && !Array.isArray(source) && typeof source === 'object') {
    var _height2 = source.height,
        _width2 = source.width;
    return {
      height: _height2,
      width: _width2
    };
  }
}

function resolveAssetUri(source) {
  var uri = null;

  if (typeof source === 'number') {
    // get the URI from the packager
    var asset = getAssetByID(source);

    if (asset == null) {
      throw new Error("Image: asset with ID \"" + source + "\" could not be found. Please check the image source or packager.");
    }

    var scale = asset.scales[0];

    if (asset.scales.length > 1) {
      var preferredScale = PixelRatio/* default.get */.Z.get(); // Get the scale which is closest to the preferred scale

      scale = asset.scales.reduce((prev, curr) => Math.abs(curr - preferredScale) < Math.abs(prev - preferredScale) ? curr : prev);
    }

    var scaleSuffix = scale !== 1 ? "@" + scale + "x" : '';
    uri = asset ? asset.httpServerLocation + "/" + asset.name + scaleSuffix + "." + asset.type : '';
  } else if (typeof source === 'string') {
    uri = source;
  } else if (source && typeof source.uri === 'string') {
    uri = source.uri;
  }

  if (uri) {
    var match = uri.match(svgDataUriPattern); // inline SVG markup may contain characters (e.g., #, ") that need to be escaped

    if (match) {
      var prefix = match[1],
          svg = match[2];
      var encodedSvg = encodeURIComponent(svg);
      return "" + prefix + encodedSvg;
    }
  }

  return uri;
}

var Image = /*#__PURE__*/react.forwardRef((props, ref) => {
  var accessibilityLabel = props.accessibilityLabel,
      blurRadius = props.blurRadius,
      defaultSource = props.defaultSource,
      draggable = props.draggable,
      onError = props.onError,
      onLayout = props.onLayout,
      onLoad = props.onLoad,
      onLoadEnd = props.onLoadEnd,
      onLoadStart = props.onLoadStart,
      pointerEvents = props.pointerEvents,
      source = props.source,
      style = props.style,
      rest = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);

  if (false) {}

  var _React$useState = react.useState(() => {
    var uri = resolveAssetUri(source);

    if (uri != null) {
      var isLoaded = modules_ImageLoader.has(uri);

      if (isLoaded) {
        return LOADED;
      }
    }

    return IDLE;
  }),
      state = _React$useState[0],
      updateState = _React$useState[1];

  var _React$useState2 = react.useState({}),
      layout = _React$useState2[0],
      updateLayout = _React$useState2[1];

  var hasTextAncestor = react.useContext(TextAncestorContext/* default */.Z);
  var hiddenImageRef = react.useRef(null);
  var filterRef = react.useRef(_filterId++);
  var requestRef = react.useRef(null);
  var shouldDisplaySource = state === LOADED || state === LOADING && defaultSource == null;

  var _getFlatStyle = getFlatStyle(style, blurRadius, filterRef.current),
      flatStyle = _getFlatStyle[0],
      _resizeMode = _getFlatStyle[1],
      filter = _getFlatStyle[2],
      tintColor = _getFlatStyle[3];

  var resizeMode = props.resizeMode || _resizeMode || 'cover';
  var selectedSource = shouldDisplaySource ? source : defaultSource;
  var displayImageUri = resolveAssetUri(selectedSource);
  var imageSizeStyle = resolveAssetDimensions(selectedSource);
  var backgroundImage = displayImageUri ? "url(\"" + displayImageUri + "\")" : null;
  var backgroundSize = getBackgroundSize(); // Accessibility image allows users to trigger the browser's image context menu

  var hiddenImage = displayImageUri ? (0,createElement/* default */.Z)('img', {
    alt: accessibilityLabel || '',
    style: styles.accessibilityImage$raw,
    draggable: draggable || false,
    ref: hiddenImageRef,
    src: displayImageUri
  }) : null;

  function getBackgroundSize() {
    if (hiddenImageRef.current != null && (resizeMode === 'center' || resizeMode === 'repeat')) {
      var _hiddenImageRef$curre = hiddenImageRef.current,
          naturalHeight = _hiddenImageRef$curre.naturalHeight,
          naturalWidth = _hiddenImageRef$curre.naturalWidth;
      var _height3 = layout.height,
          _width3 = layout.width;

      if (naturalHeight && naturalWidth && _height3 && _width3) {
        var scaleFactor = Math.min(1, _width3 / naturalWidth, _height3 / naturalHeight);
        var x = Math.ceil(scaleFactor * naturalWidth);
        var y = Math.ceil(scaleFactor * naturalHeight);
        return x + "px " + y + "px";
      }
    }
  }

  function handleLayout(e) {
    if (resizeMode === 'center' || resizeMode === 'repeat' || onLayout) {
      var _layout = e.nativeEvent.layout;
      onLayout && onLayout(e);
      updateLayout(_layout);
    }
  } // Image loading


  var uri = resolveAssetUri(source);
  react.useEffect(() => {
    abortPendingRequest();

    if (uri != null) {
      updateState(LOADING);

      if (onLoadStart) {
        onLoadStart();
      }

      requestRef.current = modules_ImageLoader.load(uri, function load(e) {
        updateState(LOADED);

        if (onLoad) {
          onLoad(e);
        }

        if (onLoadEnd) {
          onLoadEnd();
        }
      }, function error() {
        updateState(ERRORED);

        if (onError) {
          onError({
            nativeEvent: {
              error: "Failed to load resource " + uri + " (404)"
            }
          });
        }

        if (onLoadEnd) {
          onLoadEnd();
        }
      });
    }

    function abortPendingRequest() {
      if (requestRef.current != null) {
        modules_ImageLoader.abort(requestRef.current);
        requestRef.current = null;
      }
    }

    return abortPendingRequest;
  }, [uri, requestRef, updateState, onError, onLoad, onLoadEnd, onLoadStart]);
  return /*#__PURE__*/react.createElement(View/* default */.Z, (0,esm_extends/* default */.Z)({}, rest, {
    accessibilityLabel: accessibilityLabel,
    onLayout: handleLayout,
    pointerEvents: pointerEvents,
    ref: ref,
    style: [styles.root, hasTextAncestor && styles.inline, imageSizeStyle, flatStyle]
  }), /*#__PURE__*/react.createElement(View/* default */.Z, {
    style: [styles.image, resizeModeStyles[resizeMode], {
      backgroundImage,
      filter
    }, backgroundSize != null && {
      backgroundSize
    }],
    suppressHydrationWarning: true
  }), hiddenImage, createTintColorSVG(tintColor, filterRef.current));
});
Image.displayName = 'Image'; // $FlowIgnore: This is the correct type, but casting makes it unhappy since the variables aren't defined yet

var ImageWithStatics = Image;

ImageWithStatics.getSize = function (uri, success, failure) {
  modules_ImageLoader.getSize(uri, success, failure);
};

ImageWithStatics.prefetch = function (uri) {
  return modules_ImageLoader.prefetch(uri);
};

ImageWithStatics.queryCache = function (uris) {
  return modules_ImageLoader.queryCache(uris);
};

var styles = StyleSheet/* default.create */.Z.create({
  root: {
    flexBasis: 'auto',
    overflow: 'hidden',
    zIndex: 0
  },
  inline: {
    display: 'inline-flex'
  },
  image: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, StyleSheet/* default.absoluteFillObject */.Z.absoluteFillObject), {}, {
    backgroundColor: 'transparent',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    height: '100%',
    width: '100%',
    zIndex: -1
  }),
  accessibilityImage$raw: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, StyleSheet/* default.absoluteFillObject */.Z.absoluteFillObject), {}, {
    height: '100%',
    opacity: 0,
    width: '100%',
    zIndex: -1
  })
});
var resizeModeStyles = StyleSheet/* default.create */.Z.create({
  center: {
    backgroundSize: 'auto'
  },
  contain: {
    backgroundSize: 'contain'
  },
  cover: {
    backgroundSize: 'cover'
  },
  none: {
    backgroundPosition: '0',
    backgroundSize: 'auto'
  },
  repeat: {
    backgroundPosition: '0',
    backgroundRepeat: 'repeat',
    backgroundSize: 'auto'
  },
  stretch: {
    backgroundSize: '100% 100%'
  }
});
/* harmony default export */ var exports_Image = (ImageWithStatics);

/***/ }),

/***/ 74984:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ exports_InteractionManager; }
});

// EXTERNAL MODULE: ../../node_modules/fbjs/lib/invariant.js
var invariant = __webpack_require__(14983);
var invariant_default = /*#__PURE__*/__webpack_require__.n(invariant);
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/modules/canUseDom/index.js
var canUseDom = __webpack_require__(19017);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/modules/requestIdleCallback/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


var _requestIdleCallback = function _requestIdleCallback(cb, options) {
  return setTimeout(() => {
    var start = Date.now();
    cb({
      didTimeout: false,

      timeRemaining() {
        return Math.max(0, 50 - (Date.now() - start));
      }

    });
  }, 1);
};

var _cancelIdleCallback = function _cancelIdleCallback(id) {
  clearTimeout(id);
};

var isSupported = canUseDom/* default */.Z && typeof window.requestIdleCallback !== 'undefined';
var requestIdleCallback = isSupported ? window.requestIdleCallback : _requestIdleCallback;
var cancelIdleCallback = isSupported ? window.cancelIdleCallback : _cancelIdleCallback;
/* harmony default export */ var modules_requestIdleCallback = (requestIdleCallback);

;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/exports/InteractionManager/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


var InteractionManager = {
  Events: {
    interactionStart: 'interactionStart',
    interactionComplete: 'interactionComplete'
  },

  /**
   * Schedule a function to run after all interactions have completed.
   */
  runAfterInteractions(task) {
    var handle;
    var promise = new Promise(resolve => {
      handle = modules_requestIdleCallback(() => {
        if (task) {
          resolve(task());
        } else {
          resolve();
        }
      });
    });
    return {
      then: promise.then.bind(promise),
      done: promise.then.bind(promise),
      cancel: () => {
        cancelIdleCallback(handle);
      }
    };
  },

  /**
   * Notify manager that an interaction has started.
   */
  createInteractionHandle() {
    return 1;
  },

  /**
   * Notify manager that an interaction has completed.
   */
  clearInteractionHandle(handle) {
    invariant_default()(!!handle, 'Must provide a handle to clear.');
  },

  addListener: () => {}
};
/* harmony default export */ var exports_InteractionManager = (InteractionManager);

/***/ }),

/***/ 30024:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _modules_dismissKeyboard__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9198);
/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var Keyboard = {
  addListener() {
    return {
      remove: () => {}
    };
  },

  dismiss() {
    (0,_modules_dismissKeyboard__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
  },

  removeAllListeners() {},

  removeListener() {}

};
/* harmony default export */ __webpack_exports__["Z"] = (Keyboard);

/***/ }),

/***/ 62460:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var fbjs_lib_invariant__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14983);
/* harmony import */ var fbjs_lib_invariant__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(fbjs_lib_invariant__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _modules_canUseDom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19017);
/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


var initialURL = _modules_canUseDom__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z ? window.location.href : '';

class Linking {
  constructor() {
    this._eventCallbacks = {};

    this.addEventListener = (event, callback) => {
      if (!this._eventCallbacks[event]) {
        this._eventCallbacks[event] = [callback];
        return;
      }

      this._eventCallbacks[event].push(callback);
    };

    this.removeEventListener = (event, callback) => {
      var callbacks = this._eventCallbacks[event];
      var filteredCallbacks = callbacks.filter(c => c.toString() !== callback.toString());
      this._eventCallbacks[event] = filteredCallbacks;
    };
  }

  _dispatchEvent(event) {
    for (var _len = arguments.length, data = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      data[_key - 1] = arguments[_key];
    }

    var listeners = this._eventCallbacks[event];

    if (listeners != null && Array.isArray(listeners)) {
      listeners.map(listener => {
        listener(...data);
      });
    }
  }
  /**
   * Adds a event listener for the specified event. The callback will be called when the
   * said event is dispatched.
   */


  canOpenURL() {
    return Promise.resolve(true);
  }

  getInitialURL() {
    return Promise.resolve(initialURL);
  }
  /**
   * Try to open the given url in a secure fashion. The method returns a Promise object.
   * If a target is passed (including undefined) that target will be used, otherwise '_blank'.
   * If the url opens, the promise is resolved. If not, the promise is rejected.
   * Dispatches the `onOpen` event if `url` is opened successfully.
   */


  openURL(url, target) {
    if (arguments.length === 1) {
      target = '_blank';
    }

    try {
      open(url, target);

      this._dispatchEvent('onOpen', url);

      return Promise.resolve();
    } catch (e) {
      return Promise.reject(e);
    }
  }

  _validateURL(url) {
    fbjs_lib_invariant__WEBPACK_IMPORTED_MODULE_0___default()(typeof url === 'string', 'Invalid URL: should be a string. Was: ' + url);
    fbjs_lib_invariant__WEBPACK_IMPORTED_MODULE_0___default()(url, 'Invalid URL: cannot be empty');
  }

}

var open = (url, target) => {
  if (_modules_canUseDom__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z) {
    var urlToOpen = new URL(url, window.location).toString();

    if (urlToOpen.indexOf('tel:') === 0) {
      window.location = urlToOpen;
    } else {
      window.open(urlToOpen, target, 'noopener');
    }
  }
};

/* harmony default export */ __webpack_exports__["Z"] = (new Linking());

/***/ }),

/***/ 56149:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ exports_PanResponder; }
});

// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/exports/InteractionManager/index.js + 1 modules
var InteractionManager = __webpack_require__(74984);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/vendor/react-native/TouchHistoryMath/index.js
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 */
var TouchHistoryMath = {
  /**
   * This code is optimized and not intended to look beautiful. This allows
   * computing of touch centroids that have moved after `touchesChangedAfter`
   * timeStamp. You can compute the current centroid involving all touches
   * moves after `touchesChangedAfter`, or you can compute the previous
   * centroid of all touches that were moved after `touchesChangedAfter`.
   *
   * @param {TouchHistoryMath} touchHistory Standard Responder touch track
   * data.
   * @param {number} touchesChangedAfter timeStamp after which moved touches
   * are considered "actively moving" - not just "active".
   * @param {boolean} isXAxis Consider `x` dimension vs. `y` dimension.
   * @param {boolean} ofCurrent Compute current centroid for actively moving
   * touches vs. previous centroid of now actively moving touches.
   * @return {number} value of centroid in specified dimension.
   */
  centroidDimension: function centroidDimension(touchHistory, touchesChangedAfter, isXAxis, ofCurrent) {
    var touchBank = touchHistory.touchBank;
    var total = 0;
    var count = 0;
    var oneTouchData = touchHistory.numberActiveTouches === 1 ? touchHistory.touchBank[touchHistory.indexOfSingleActiveTouch] : null;

    if (oneTouchData !== null) {
      if (oneTouchData.touchActive && oneTouchData.currentTimeStamp > touchesChangedAfter) {
        total += ofCurrent && isXAxis ? oneTouchData.currentPageX : ofCurrent && !isXAxis ? oneTouchData.currentPageY : !ofCurrent && isXAxis ? oneTouchData.previousPageX : oneTouchData.previousPageY;
        count = 1;
      }
    } else {
      for (var i = 0; i < touchBank.length; i++) {
        var touchTrack = touchBank[i];

        if (touchTrack !== null && touchTrack !== undefined && touchTrack.touchActive && touchTrack.currentTimeStamp >= touchesChangedAfter) {
          var toAdd = void 0; // Yuck, program temporarily in invalid state.

          if (ofCurrent && isXAxis) {
            toAdd = touchTrack.currentPageX;
          } else if (ofCurrent && !isXAxis) {
            toAdd = touchTrack.currentPageY;
          } else if (!ofCurrent && isXAxis) {
            toAdd = touchTrack.previousPageX;
          } else {
            toAdd = touchTrack.previousPageY;
          }

          total += toAdd;
          count++;
        }
      }
    }

    return count > 0 ? total / count : TouchHistoryMath.noCentroid;
  },
  currentCentroidXOfTouchesChangedAfter: function currentCentroidXOfTouchesChangedAfter(touchHistory, touchesChangedAfter) {
    return TouchHistoryMath.centroidDimension(touchHistory, touchesChangedAfter, true, // isXAxis
    true // ofCurrent
    );
  },
  currentCentroidYOfTouchesChangedAfter: function currentCentroidYOfTouchesChangedAfter(touchHistory, touchesChangedAfter) {
    return TouchHistoryMath.centroidDimension(touchHistory, touchesChangedAfter, false, // isXAxis
    true // ofCurrent
    );
  },
  previousCentroidXOfTouchesChangedAfter: function previousCentroidXOfTouchesChangedAfter(touchHistory, touchesChangedAfter) {
    return TouchHistoryMath.centroidDimension(touchHistory, touchesChangedAfter, true, // isXAxis
    false // ofCurrent
    );
  },
  previousCentroidYOfTouchesChangedAfter: function previousCentroidYOfTouchesChangedAfter(touchHistory, touchesChangedAfter) {
    return TouchHistoryMath.centroidDimension(touchHistory, touchesChangedAfter, false, // isXAxis
    false // ofCurrent
    );
  },
  currentCentroidX: function currentCentroidX(touchHistory) {
    return TouchHistoryMath.centroidDimension(touchHistory, 0, // touchesChangedAfter
    true, // isXAxis
    true // ofCurrent
    );
  },
  currentCentroidY: function currentCentroidY(touchHistory) {
    return TouchHistoryMath.centroidDimension(touchHistory, 0, // touchesChangedAfter
    false, // isXAxis
    true // ofCurrent
    );
  },
  noCentroid: -1
};
/* harmony default export */ var react_native_TouchHistoryMath = (TouchHistoryMath);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/vendor/react-native/PanResponder/index.js
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */




var currentCentroidXOfTouchesChangedAfter = react_native_TouchHistoryMath.currentCentroidXOfTouchesChangedAfter;
var currentCentroidYOfTouchesChangedAfter = react_native_TouchHistoryMath.currentCentroidYOfTouchesChangedAfter;
var previousCentroidXOfTouchesChangedAfter = react_native_TouchHistoryMath.previousCentroidXOfTouchesChangedAfter;
var previousCentroidYOfTouchesChangedAfter = react_native_TouchHistoryMath.previousCentroidYOfTouchesChangedAfter;
var currentCentroidX = react_native_TouchHistoryMath.currentCentroidX;
var currentCentroidY = react_native_TouchHistoryMath.currentCentroidY;
/**
 * `PanResponder` reconciles several touches into a single gesture. It makes
 * single-touch gestures resilient to extra touches, and can be used to
 * recognize simple multi-touch gestures.
 *
 * By default, `PanResponder` holds an `InteractionManager` handle to block
 * long-running JS events from interrupting active gestures.
 *
 * It provides a predictable wrapper of the responder handlers provided by the
 * [gesture responder system](docs/gesture-responder-system.html).
 * For each handler, it provides a new `gestureState` object alongside the
 * native event object:
 *
 * ```
 * onPanResponderMove: (event, gestureState) => {}
 * ```
 *
 * A native event is a synthetic touch event with the following form:
 *
 *  - `nativeEvent`
 *      + `changedTouches` - Array of all touch events that have changed since the last event
 *      + `identifier` - The ID of the touch
 *      + `locationX` - The X position of the touch, relative to the element
 *      + `locationY` - The Y position of the touch, relative to the element
 *      + `pageX` - The X position of the touch, relative to the root element
 *      + `pageY` - The Y position of the touch, relative to the root element
 *      + `target` - The node id of the element receiving the touch event
 *      + `timestamp` - A time identifier for the touch, useful for velocity calculation
 *      + `touches` - Array of all current touches on the screen
 *
 * A `gestureState` object has the following:
 *
 *  - `stateID` - ID of the gestureState- persisted as long as there at least
 *     one touch on screen
 *  - `moveX` - the latest screen coordinates of the recently-moved touch
 *  - `moveY` - the latest screen coordinates of the recently-moved touch
 *  - `x0` - the screen coordinates of the responder grant
 *  - `y0` - the screen coordinates of the responder grant
 *  - `dx` - accumulated distance of the gesture since the touch started
 *  - `dy` - accumulated distance of the gesture since the touch started
 *  - `vx` - current velocity of the gesture
 *  - `vy` - current velocity of the gesture
 *  - `numberActiveTouches` - Number of touches currently on screen
 *
 * ### Basic Usage
 *
 * ```
 *   componentWillMount: function() {
 *     this._panResponder = PanResponder.create({
 *       // Ask to be the responder:
 *       onStartShouldSetPanResponder: (evt, gestureState) => true,
 *       onStartShouldSetPanResponderCapture: (evt, gestureState) => true,
 *       onMoveShouldSetPanResponder: (evt, gestureState) => true,
 *       onMoveShouldSetPanResponderCapture: (evt, gestureState) => true,
 *
 *       onPanResponderGrant: (evt, gestureState) => {
 *         // The gesture has started. Show visual feedback so the user knows
 *         // what is happening!
 *
 *         // gestureState.d{x,y} will be set to zero now
 *       },
 *       onPanResponderMove: (evt, gestureState) => {
 *         // The most recent move distance is gestureState.move{X,Y}
 *
 *         // The accumulated gesture distance since becoming responder is
 *         // gestureState.d{x,y}
 *       },
 *       onPanResponderTerminationRequest: (evt, gestureState) => true,
 *       onPanResponderRelease: (evt, gestureState) => {
 *         // The user has released all touches while this view is the
 *         // responder. This typically means a gesture has succeeded
 *       },
 *       onPanResponderTerminate: (evt, gestureState) => {
 *         // Another component has become the responder, so this gesture
 *         // should be cancelled
 *       },
 *       onShouldBlockNativeResponder: (evt, gestureState) => {
 *         // Returns whether this component should block native components from becoming the JS
 *         // responder. Returns true by default. Is currently only supported on android.
 *         return true;
 *       },
 *     });
 *   },
 *
 *   render: function() {
 *     return (
 *       <View {...this._panResponder.panHandlers} />
 *     );
 *   },
 *
 * ```
 *
 * ### Working Example
 *
 * To see it in action, try the
 * [PanResponder example in RNTester](https://github.com/facebook/react-native/blob/master/RNTester/js/PanResponderExample.js)
 */

var PanResponder = {
  /**
   *
   * A graphical explanation of the touch data flow:
   *
   * +----------------------------+             +--------------------------------+
   * | ResponderTouchHistoryStore |             |TouchHistoryMath                |
   * +----------------------------+             +----------+---------------------+
   * |Global store of touchHistory|             |Allocation-less math util       |
   * |including activeness, start |             |on touch history (centroids     |
   * |position, prev/cur position.|             |and multitouch movement etc)    |
   * |                            |             |                                |
   * +----^-----------------------+             +----^---------------------------+
   *      |                                          |
   *      | (records relevant history                |
   *      |  of touches relevant for                 |
   *      |  implementing higher level               |
   *      |  gestures)                               |
   *      |                                          |
   * +----+-----------------------+             +----|---------------------------+
   * | ResponderEventPlugin       |             |    |   Your App/Component      |
   * +----------------------------+             +----|---------------------------+
   * |Negotiates which view gets  | Low level   |    |             High level    |
   * |onResponderMove events.     | events w/   |  +-+-------+     events w/     |
   * |Also records history into   | touchHistory|  |   Pan   |     multitouch +  |
   * |ResponderTouchHistoryStore. +---------------->Responder+-----> accumulative|
   * +----------------------------+ attached to |  |         |     distance and  |
   *                                 each event |  +---------+     velocity.     |
   *                                            |                                |
   *                                            |                                |
   *                                            +--------------------------------+
   *
   *
   *
   * Gesture that calculates cumulative movement over time in a way that just
   * "does the right thing" for multiple touches. The "right thing" is very
   * nuanced. When moving two touches in opposite directions, the cumulative
   * distance is zero in each dimension. When two touches move in parallel five
   * pixels in the same direction, the cumulative distance is five, not ten. If
   * two touches start, one moves five in a direction, then stops and the other
   * touch moves fives in the same direction, the cumulative distance is ten.
   *
   * This logic requires a kind of processing of time "clusters" of touch events
   * so that two touch moves that essentially occur in parallel but move every
   * other frame respectively, are considered part of the same movement.
   *
   * Explanation of some of the non-obvious fields:
   *
   * - moveX/moveY: If no move event has been observed, then `(moveX, moveY)` is
   *   invalid. If a move event has been observed, `(moveX, moveY)` is the
   *   centroid of the most recently moved "cluster" of active touches.
   *   (Currently all move have the same timeStamp, but later we should add some
   *   threshold for what is considered to be "moving"). If a palm is
   *   accidentally counted as a touch, but a finger is moving greatly, the palm
   *   will move slightly, but we only want to count the single moving touch.
   * - x0/y0: Centroid location (non-cumulative) at the time of becoming
   *   responder.
   * - dx/dy: Cumulative touch distance - not the same thing as sum of each touch
   *   distance. Accounts for touch moves that are clustered together in time,
   *   moving the same direction. Only valid when currently responder (otherwise,
   *   it only represents the drag distance below the threshold).
   * - vx/vy: Velocity.
   */
  _initializeGestureState(gestureState) {
    gestureState.moveX = 0;
    gestureState.moveY = 0;
    gestureState.x0 = 0;
    gestureState.y0 = 0;
    gestureState.dx = 0;
    gestureState.dy = 0;
    gestureState.vx = 0;
    gestureState.vy = 0;
    gestureState.numberActiveTouches = 0; // All `gestureState` accounts for timeStamps up until:

    gestureState._accountsForMovesUpTo = 0;
  },

  /**
   * This is nuanced and is necessary. It is incorrect to continuously take all
   * active *and* recently moved touches, find the centroid, and track how that
   * result changes over time. Instead, we must take all recently moved
   * touches, and calculate how the centroid has changed just for those
   * recently moved touches, and append that change to an accumulator. This is
   * to (at least) handle the case where the user is moving three fingers, and
   * then one of the fingers stops but the other two continue.
   *
   * This is very different than taking all of the recently moved touches and
   * storing their centroid as `dx/dy`. For correctness, we must *accumulate
   * changes* in the centroid of recently moved touches.
   *
   * There is also some nuance with how we handle multiple moved touches in a
   * single event. With the way `ReactNativeEventEmitter` dispatches touches as
   * individual events, multiple touches generate two 'move' events, each of
   * them triggering `onResponderMove`. But with the way `PanResponder` works,
   * all of the gesture inference is performed on the first dispatch, since it
   * looks at all of the touches (even the ones for which there hasn't been a
   * native dispatch yet). Therefore, `PanResponder` does not call
   * `onResponderMove` passed the first dispatch. This diverges from the
   * typical responder callback pattern (without using `PanResponder`), but
   * avoids more dispatches than necessary.
   */
  _updateGestureStateOnMove(gestureState, touchHistory) {
    gestureState.numberActiveTouches = touchHistory.numberActiveTouches;
    gestureState.moveX = currentCentroidXOfTouchesChangedAfter(touchHistory, gestureState._accountsForMovesUpTo);
    gestureState.moveY = currentCentroidYOfTouchesChangedAfter(touchHistory, gestureState._accountsForMovesUpTo);
    var movedAfter = gestureState._accountsForMovesUpTo;
    var prevX = previousCentroidXOfTouchesChangedAfter(touchHistory, movedAfter);
    var x = currentCentroidXOfTouchesChangedAfter(touchHistory, movedAfter);
    var prevY = previousCentroidYOfTouchesChangedAfter(touchHistory, movedAfter);
    var y = currentCentroidYOfTouchesChangedAfter(touchHistory, movedAfter);
    var nextDX = gestureState.dx + (x - prevX);
    var nextDY = gestureState.dy + (y - prevY); // TODO: This must be filtered intelligently.

    var dt = touchHistory.mostRecentTimeStamp - gestureState._accountsForMovesUpTo;
    gestureState.vx = (nextDX - gestureState.dx) / dt;
    gestureState.vy = (nextDY - gestureState.dy) / dt;
    gestureState.dx = nextDX;
    gestureState.dy = nextDY;
    gestureState._accountsForMovesUpTo = touchHistory.mostRecentTimeStamp;
  },

  /**
   * @param {object} config Enhanced versions of all of the responder callbacks
   * that provide not only the typical `ResponderSyntheticEvent`, but also the
   * `PanResponder` gesture state.  Simply replace the word `Responder` with
   * `PanResponder` in each of the typical `onResponder*` callbacks. For
   * example, the `config` object would look like:
   *
   *  - `onMoveShouldSetPanResponder: (e, gestureState) => {...}`
   *  - `onMoveShouldSetPanResponderCapture: (e, gestureState) => {...}`
   *  - `onStartShouldSetPanResponder: (e, gestureState) => {...}`
   *  - `onStartShouldSetPanResponderCapture: (e, gestureState) => {...}`
   *  - `onPanResponderReject: (e, gestureState) => {...}`
   *  - `onPanResponderGrant: (e, gestureState) => {...}`
   *  - `onPanResponderStart: (e, gestureState) => {...}`
   *  - `onPanResponderEnd: (e, gestureState) => {...}`
   *  - `onPanResponderRelease: (e, gestureState) => {...}`
   *  - `onPanResponderMove: (e, gestureState) => {...}`
   *  - `onPanResponderTerminate: (e, gestureState) => {...}`
   *  - `onPanResponderTerminationRequest: (e, gestureState) => {...}`
   *  - `onShouldBlockNativeResponder: (e, gestureState) => {...}`
   *
   *  In general, for events that have capture equivalents, we update the
   *  gestureState once in the capture phase and can use it in the bubble phase
   *  as well.
   *
   *  Be careful with onStartShould* callbacks. They only reflect updated
   *  `gestureState` for start/end events that bubble/capture to the Node.
   *  Once the node is the responder, you can rely on every start/end event
   *  being processed by the gesture and `gestureState` being updated
   *  accordingly. (numberActiveTouches) may not be totally accurate unless you
   *  are the responder.
   */
  create(config) {
    var interactionState = {
      handle: null,
      shouldCancelClick: false,
      timeout: null
    };
    var gestureState = {
      // Useful for debugging
      stateID: Math.random(),
      moveX: 0,
      moveY: 0,
      x0: 0,
      y0: 0,
      dx: 0,
      dy: 0,
      vx: 0,
      vy: 0,
      numberActiveTouches: 0,
      _accountsForMovesUpTo: 0
    };
    var panHandlers = {
      onStartShouldSetResponder(event) {
        return config.onStartShouldSetPanResponder == null ? false : config.onStartShouldSetPanResponder(event, gestureState);
      },

      onMoveShouldSetResponder(event) {
        return config.onMoveShouldSetPanResponder == null ? false : config.onMoveShouldSetPanResponder(event, gestureState);
      },

      onStartShouldSetResponderCapture(event) {
        // TODO: Actually, we should reinitialize the state any time
        // touches.length increases from 0 active to > 0 active.
        if (event.nativeEvent.touches.length === 1) {
          PanResponder._initializeGestureState(gestureState);
        }

        gestureState.numberActiveTouches = event.touchHistory.numberActiveTouches;
        return config.onStartShouldSetPanResponderCapture != null ? config.onStartShouldSetPanResponderCapture(event, gestureState) : false;
      },

      onMoveShouldSetResponderCapture(event) {
        var touchHistory = event.touchHistory; // Responder system incorrectly dispatches should* to current responder
        // Filter out any touch moves past the first one - we would have
        // already processed multi-touch geometry during the first event.

        if (gestureState._accountsForMovesUpTo === touchHistory.mostRecentTimeStamp) {
          return false;
        }

        PanResponder._updateGestureStateOnMove(gestureState, touchHistory);

        return config.onMoveShouldSetPanResponderCapture ? config.onMoveShouldSetPanResponderCapture(event, gestureState) : false;
      },

      onResponderGrant(event) {
        if (!interactionState.handle) {
          interactionState.handle = InteractionManager/* default.createInteractionHandle */.Z.createInteractionHandle();
        }

        if (interactionState.timeout) {
          clearInteractionTimeout(interactionState);
        }

        interactionState.shouldCancelClick = true;
        gestureState.x0 = currentCentroidX(event.touchHistory);
        gestureState.y0 = currentCentroidY(event.touchHistory);
        gestureState.dx = 0;
        gestureState.dy = 0;

        if (config.onPanResponderGrant) {
          config.onPanResponderGrant(event, gestureState);
        } // TODO: t7467124 investigate if this can be removed


        return config.onShouldBlockNativeResponder == null ? true : config.onShouldBlockNativeResponder(event, gestureState);
      },

      onResponderReject(event) {
        clearInteractionHandle(interactionState, config.onPanResponderReject, event, gestureState);
      },

      onResponderRelease(event) {
        clearInteractionHandle(interactionState, config.onPanResponderRelease, event, gestureState);
        setInteractionTimeout(interactionState);

        PanResponder._initializeGestureState(gestureState);
      },

      onResponderStart(event) {
        var touchHistory = event.touchHistory;
        gestureState.numberActiveTouches = touchHistory.numberActiveTouches;

        if (config.onPanResponderStart) {
          config.onPanResponderStart(event, gestureState);
        }
      },

      onResponderMove(event) {
        var touchHistory = event.touchHistory; // Guard against the dispatch of two touch moves when there are two
        // simultaneously changed touches.

        if (gestureState._accountsForMovesUpTo === touchHistory.mostRecentTimeStamp) {
          return;
        } // Filter out any touch moves past the first one - we would have
        // already processed multi-touch geometry during the first event.


        PanResponder._updateGestureStateOnMove(gestureState, touchHistory);

        if (config.onPanResponderMove) {
          config.onPanResponderMove(event, gestureState);
        }
      },

      onResponderEnd(event) {
        var touchHistory = event.touchHistory;
        gestureState.numberActiveTouches = touchHistory.numberActiveTouches;
        clearInteractionHandle(interactionState, config.onPanResponderEnd, event, gestureState);
      },

      onResponderTerminate(event) {
        clearInteractionHandle(interactionState, config.onPanResponderTerminate, event, gestureState);
        setInteractionTimeout(interactionState);

        PanResponder._initializeGestureState(gestureState);
      },

      onResponderTerminationRequest(event) {
        return config.onPanResponderTerminationRequest == null ? true : config.onPanResponderTerminationRequest(event, gestureState);
      },

      // We do not want to trigger 'click' activated gestures or native behaviors
      // on any pan target that is under a mouse cursor when it is released.
      // Browsers will natively cancel 'click' events on a target if a non-mouse
      // active pointer moves.
      onClickCapture: event => {
        if (interactionState.shouldCancelClick === true) {
          event.stopPropagation();
          event.preventDefault();
        }
      }
    };
    return {
      panHandlers,

      getInteractionHandle() {
        return interactionState.handle;
      }

    };
  }

};

function clearInteractionHandle(interactionState, callback, event, gestureState) {
  if (interactionState.handle) {
    InteractionManager/* default.clearInteractionHandle */.Z.clearInteractionHandle(interactionState.handle);
    interactionState.handle = null;
  }

  if (callback) {
    callback(event, gestureState);
  }
}

function clearInteractionTimeout(interactionState) {
  clearTimeout(interactionState.timeout);
}

function setInteractionTimeout(interactionState) {
  interactionState.timeout = setTimeout(() => {
    interactionState.shouldCancelClick = false;
  }, 250);
}

/* harmony default export */ var react_native_PanResponder = (PanResponder);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/exports/PanResponder/index.js

/* harmony default export */ var exports_PanResponder = (react_native_PanResponder);

/***/ }),

/***/ 92045:
/***/ (function(module) {

module.exports = worm(true)

function worm(root = false) {
  const obj = root
    ? {
        get default() {
          return worm()
        },
      }
    : function () {
        //  dev warning in debug mode
        if (false) {}

        return worm()
      }

  obj.displayName = `ProxyWorm - Check excludeReactNativeWebExports`
  obj._isProxyWorm = true

  return new Proxy(obj, {
    get(_, key) {
      if (Reflect.has(obj, key)) return Reflect.get(obj, key)
      return worm()
    },
    apply() {
      return worm()
    },
  })
}


/***/ }),

/***/ 72016:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PixelRatio; }
/* harmony export */ });
/* harmony import */ var _Dimensions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78052);
/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

/**
 * PixelRatio gives access to the device pixel density.
 */

class PixelRatio {
  /**
   * Returns the device pixel density.
   */
  static get() {
    return _Dimensions__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get('window').scale;
  }
  /**
   * No equivalent for Web
   */


  static getFontScale() {
    return _Dimensions__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get('window').fontScale || PixelRatio.get();
  }
  /**
   * Converts a layout size (dp) to pixel size (px).
   * Guaranteed to return an integer number.
   */


  static getPixelSizeForLayoutSize(layoutSize) {
    return Math.round(layoutSize * PixelRatio.get());
  }
  /**
   * Rounds a layout size (dp) to the nearest layout size that corresponds to
   * an integer number of pixels. For example, on a device with a PixelRatio
   * of 3, `PixelRatio.roundToNearestPixel(8.4) = 8.33`, which corresponds to
   * exactly (8.33 * 3) = 25 pixels.
   */


  static roundToNearestPixel(layoutSize) {
    var ratio = PixelRatio.get();
    return Math.round(layoutSize * ratio) / ratio;
  }

}

/***/ }),

/***/ 33229:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */
var Platform = {
  OS: 'web',
  select: obj => 'web' in obj ? obj.web : obj.default,

  get isTesting() {
    if (false) {}

    return false;
  }

};
/* harmony default export */ __webpack_exports__["Z"] = (Platform);

/***/ }),

/***/ 40228:
/***/ (function(module) {

module.exports = worm(true)

function worm(root = false) {
  const obj = root
    ? {
        get default() {
          return worm()
        },
      }
    : function () {
        //  dev warning in debug mode
        if (false) {}

        return worm()
      }

  obj.displayName = `ProxyWorm - Check excludeReactNativeWebExports`
  obj._isProxyWorm = true

  return new Proxy(obj, {
    get(_, key) {
      if (Reflect.has(obj, key)) return Reflect.get(obj, key)
      return worm()
    },
    apply() {
      return worm()
    },
  })
}


/***/ }),

/***/ 79450:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ exports_ScrollView; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectSpread2.js + 4 modules
var objectSpread2 = __webpack_require__(29405);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/create-react-class/index.js
var create_react_class = __webpack_require__(58335);
var create_react_class_default = /*#__PURE__*/__webpack_require__.n(create_react_class);
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/modules/dismissKeyboard/index.js
var dismissKeyboard = __webpack_require__(9198);
// EXTERNAL MODULE: ../../node_modules/fbjs/lib/invariant.js
var invariant = __webpack_require__(14983);
var invariant_default = /*#__PURE__*/__webpack_require__.n(invariant);
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/modules/mergeRefs/index.js
var mergeRefs = __webpack_require__(88212);
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/exports/Dimensions/index.js
var Dimensions = __webpack_require__(78052);
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/exports/findNodeHandle/index.js
var findNodeHandle = __webpack_require__(69150);
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/exports/Platform/index.js
var Platform = __webpack_require__(33229);
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/modules/TextInputState/index.js
var TextInputState = __webpack_require__(1736);
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/exports/UIManager/index.js + 3 modules
var UIManager = __webpack_require__(96187);
// EXTERNAL MODULE: ../../node_modules/fbjs/lib/warning.js
var warning = __webpack_require__(26590);
var warning_default = /*#__PURE__*/__webpack_require__.n(warning);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/modules/ScrollResponder/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */







/**
 * Mixin that can be integrated in order to handle scrolling that plays well
 * with `ResponderEventPlugin`. Integrate with your platform specific scroll
 * views, or even your custom built (every-frame animating) scroll views so that
 * all of these systems play well with the `ResponderEventPlugin`.
 *
 * iOS scroll event timing nuances:
 * ===============================
 *
 *
 * Scrolling without bouncing, if you touch down:
 * -------------------------------
 *
 * 1. `onMomentumScrollBegin` (when animation begins after letting up)
 *    ... physical touch starts ...
 * 2. `onTouchStartCapture`   (when you press down to stop the scroll)
 * 3. `onTouchStart`          (same, but bubble phase)
 * 4. `onResponderRelease`    (when lifting up - you could pause forever before * lifting)
 * 5. `onMomentumScrollEnd`
 *
 *
 * Scrolling with bouncing, if you touch down:
 * -------------------------------
 *
 * 1. `onMomentumScrollBegin` (when animation begins after letting up)
 *    ... bounce begins ...
 *    ... some time elapses ...
 *    ... physical touch during bounce ...
 * 2. `onMomentumScrollEnd`   (Makes no sense why this occurs first during bounce)
 * 3. `onTouchStartCapture`   (immediately after `onMomentumScrollEnd`)
 * 4. `onTouchStart`          (same, but bubble phase)
 * 5. `onTouchEnd`            (You could hold the touch start for a long time)
 * 6. `onMomentumScrollBegin` (When releasing the view starts bouncing back)
 *
 * So when we receive an `onTouchStart`, how can we tell if we are touching
 * *during* an animation (which then causes the animation to stop)? The only way
 * to tell is if the `touchStart` occurred immediately after the
 * `onMomentumScrollEnd`.
 *
 * This is abstracted out for you, so you can just call this.scrollResponderIsAnimating() if
 * necessary
 *
 * `ScrollResponder` also includes logic for blurring a currently focused input
 * if one is focused while scrolling. The `ScrollResponder` is a natural place
 * to put this logic since it can support not dismissing the keyboard while
 * scrolling, unless a recognized "tap"-like gesture has occurred.
 *
 * The public lifecycle API includes events for keyboard interaction, responder
 * interaction, and scrolling (among others). The keyboard callbacks
 * `onKeyboardWill/Did/*` are *global* events, but are invoked on scroll
 * responder's props so that you can guarantee that the scroll responder's
 * internal state has been updated accordingly (and deterministically) by
 * the time the props callbacks are invoke. Otherwise, you would always wonder
 * if the scroll responder is currently in a state where it recognizes new
 * keyboard positions etc. If coordinating scrolling with keyboard movement,
 * *always* use these hooks instead of listening to your own global keyboard
 * events.
 *
 * Public keyboard lifecycle API: (props callbacks)
 *
 * Standard Keyboard Appearance Sequence:
 *
 *   this.props.onKeyboardWillShow
 *   this.props.onKeyboardDidShow
 *
 * `onScrollResponderKeyboardDismissed` will be invoked if an appropriate
 * tap inside the scroll responder's scrollable region was responsible
 * for the dismissal of the keyboard. There are other reasons why the
 * keyboard could be dismissed.
 *
 *   this.props.onScrollResponderKeyboardDismissed
 *
 * Standard Keyboard Hide Sequence:
 *
 *   this.props.onKeyboardWillHide
 *   this.props.onKeyboardDidHide
 */

var emptyObject = {};
var IS_ANIMATING_TOUCH_START_THRESHOLD_MS = 16;
var ScrollResponderMixin = {
  // mixins: [Subscribable.Mixin],
  scrollResponderMixinGetInitialState: function scrollResponderMixinGetInitialState() {
    return {
      isTouching: false,
      lastMomentumScrollBeginTime: 0,
      lastMomentumScrollEndTime: 0,
      // Reset to false every time becomes responder. This is used to:
      // - Determine if the scroll view has been scrolled and therefore should
      // refuse to give up its responder lock.
      // - Determine if releasing should dismiss the keyboard when we are in
      // tap-to-dismiss mode (!this.props.keyboardShouldPersistTaps).
      observedScrollSinceBecomingResponder: false,
      becameResponderWhileAnimating: false
    };
  },

  /**
   * Invoke this from an `onScroll` event.
   */
  scrollResponderHandleScrollShouldSetResponder: function scrollResponderHandleScrollShouldSetResponder() {
    return this.state.isTouching;
  },

  /**
   * Merely touch starting is not sufficient for a scroll view to become the
   * responder. Being the "responder" means that the very next touch move/end
   * event will result in an action/movement.
   *
   * Invoke this from an `onStartShouldSetResponder` event.
   *
   * `onStartShouldSetResponder` is used when the next move/end will trigger
   * some UI movement/action, but when you want to yield priority to views
   * nested inside of the view.
   *
   * There may be some cases where scroll views actually should return `true`
   * from `onStartShouldSetResponder`: Any time we are detecting a standard tap
   * that gives priority to nested views.
   *
   * - If a single tap on the scroll view triggers an action such as
   *   recentering a map style view yet wants to give priority to interaction
   *   views inside (such as dropped pins or labels), then we would return true
   *   from this method when there is a single touch.
   *
   * - Similar to the previous case, if a two finger "tap" should trigger a
   *   zoom, we would check the `touches` count, and if `>= 2`, we would return
   *   true.
   *
   */
  scrollResponderHandleStartShouldSetResponder: function scrollResponderHandleStartShouldSetResponder() {
    return false;
  },

  /**
   * There are times when the scroll view wants to become the responder
   * (meaning respond to the next immediate `touchStart/touchEnd`), in a way
   * that *doesn't* give priority to nested views (hence the capture phase):
   *
   * - Currently animating.
   * - Tapping anywhere that is not the focused input, while the keyboard is
   *   up (which should dismiss the keyboard).
   *
   * Invoke this from an `onStartShouldSetResponderCapture` event.
   */
  scrollResponderHandleStartShouldSetResponderCapture: function scrollResponderHandleStartShouldSetResponderCapture(e) {
    // First see if we want to eat taps while the keyboard is up
    // var currentlyFocusedTextInput = TextInputState.currentlyFocusedField();
    // if (!this.props.keyboardShouldPersistTaps &&
    //   currentlyFocusedTextInput != null &&
    //   e.target !== currentlyFocusedTextInput) {
    //   return true;
    // }
    return this.scrollResponderIsAnimating();
  },

  /**
   * Invoke this from an `onResponderReject` event.
   *
   * Some other element is not yielding its role as responder. Normally, we'd
   * just disable the `UIScrollView`, but a touch has already began on it, the
   * `UIScrollView` will not accept being disabled after that. The easiest
   * solution for now is to accept the limitation of disallowing this
   * altogether. To improve this, find a way to disable the `UIScrollView` after
   * a touch has already started.
   */
  scrollResponderHandleResponderReject: function scrollResponderHandleResponderReject() {
    warning_default()(false, "ScrollView doesn't take rejection well - scrolls anyway");
  },

  /**
   * We will allow the scroll view to give up its lock iff it acquired the lock
   * during an animation. This is a very useful default that happens to satisfy
   * many common user experiences.
   *
   * - Stop a scroll on the left edge, then turn that into an outer view's
   *   backswipe.
   * - Stop a scroll mid-bounce at the top, continue pulling to have the outer
   *   view dismiss.
   * - However, without catching the scroll view mid-bounce (while it is
   *   motionless), if you drag far enough for the scroll view to become
   *   responder (and therefore drag the scroll view a bit), any backswipe
   *   navigation of a swipe gesture higher in the view hierarchy, should be
   *   rejected.
   */
  scrollResponderHandleTerminationRequest: function scrollResponderHandleTerminationRequest() {
    return !this.state.observedScrollSinceBecomingResponder;
  },

  /**
   * Invoke this from an `onTouchEnd` event.
   *
   * @param {SyntheticEvent} e Event.
   */
  scrollResponderHandleTouchEnd: function scrollResponderHandleTouchEnd(e) {
    var nativeEvent = e.nativeEvent;
    this.state.isTouching = nativeEvent.touches.length !== 0;
    this.props.onTouchEnd && this.props.onTouchEnd(e);
  },

  /**
   * Invoke this from an `onResponderRelease` event.
   */
  scrollResponderHandleResponderRelease: function scrollResponderHandleResponderRelease(e) {
    this.props.onResponderRelease && this.props.onResponderRelease(e); // By default scroll views will unfocus a textField
    // if another touch occurs outside of it

    var currentlyFocusedTextInput = TextInputState/* default.currentlyFocusedField */.Z.currentlyFocusedField();

    if (!this.props.keyboardShouldPersistTaps && currentlyFocusedTextInput != null && e.target !== currentlyFocusedTextInput && !this.state.observedScrollSinceBecomingResponder && !this.state.becameResponderWhileAnimating) {
      this.props.onScrollResponderKeyboardDismissed && this.props.onScrollResponderKeyboardDismissed(e);
      TextInputState/* default.blurTextInput */.Z.blurTextInput(currentlyFocusedTextInput);
    }
  },
  scrollResponderHandleScroll: function scrollResponderHandleScroll(e) {
    this.state.observedScrollSinceBecomingResponder = true;
    this.props.onScroll && this.props.onScroll(e);
  },

  /**
   * Invoke this from an `onResponderGrant` event.
   */
  scrollResponderHandleResponderGrant: function scrollResponderHandleResponderGrant(e) {
    this.state.observedScrollSinceBecomingResponder = false;
    this.props.onResponderGrant && this.props.onResponderGrant(e);
    this.state.becameResponderWhileAnimating = this.scrollResponderIsAnimating();
  },

  /**
   * Unfortunately, `onScrollBeginDrag` also fires when *stopping* the scroll
   * animation, and there's not an easy way to distinguish a drag vs. stopping
   * momentum.
   *
   * Invoke this from an `onScrollBeginDrag` event.
   */
  scrollResponderHandleScrollBeginDrag: function scrollResponderHandleScrollBeginDrag(e) {
    this.props.onScrollBeginDrag && this.props.onScrollBeginDrag(e);
  },

  /**
   * Invoke this from an `onScrollEndDrag` event.
   */
  scrollResponderHandleScrollEndDrag: function scrollResponderHandleScrollEndDrag(e) {
    this.props.onScrollEndDrag && this.props.onScrollEndDrag(e);
  },

  /**
   * Invoke this from an `onMomentumScrollBegin` event.
   */
  scrollResponderHandleMomentumScrollBegin: function scrollResponderHandleMomentumScrollBegin(e) {
    this.state.lastMomentumScrollBeginTime = Date.now();
    this.props.onMomentumScrollBegin && this.props.onMomentumScrollBegin(e);
  },

  /**
   * Invoke this from an `onMomentumScrollEnd` event.
   */
  scrollResponderHandleMomentumScrollEnd: function scrollResponderHandleMomentumScrollEnd(e) {
    this.state.lastMomentumScrollEndTime = Date.now();
    this.props.onMomentumScrollEnd && this.props.onMomentumScrollEnd(e);
  },

  /**
   * Invoke this from an `onTouchStart` event.
   *
   * Since we know that the `SimpleEventPlugin` occurs later in the plugin
   * order, after `ResponderEventPlugin`, we can detect that we were *not*
   * permitted to be the responder (presumably because a contained view became
   * responder). The `onResponderReject` won't fire in that case - it only
   * fires when a *current* responder rejects our request.
   *
   * @param {SyntheticEvent} e Touch Start event.
   */
  scrollResponderHandleTouchStart: function scrollResponderHandleTouchStart(e) {
    this.state.isTouching = true;
    this.props.onTouchStart && this.props.onTouchStart(e);
  },

  /**
   * Invoke this from an `onTouchMove` event.
   *
   * Since we know that the `SimpleEventPlugin` occurs later in the plugin
   * order, after `ResponderEventPlugin`, we can detect that we were *not*
   * permitted to be the responder (presumably because a contained view became
   * responder). The `onResponderReject` won't fire in that case - it only
   * fires when a *current* responder rejects our request.
   *
   * @param {SyntheticEvent} e Touch Start event.
   */
  scrollResponderHandleTouchMove: function scrollResponderHandleTouchMove(e) {
    this.props.onTouchMove && this.props.onTouchMove(e);
  },

  /**
   * A helper function for this class that lets us quickly determine if the
   * view is currently animating. This is particularly useful to know when
   * a touch has just started or ended.
   */
  scrollResponderIsAnimating: function scrollResponderIsAnimating() {
    var now = Date.now();
    var timeSinceLastMomentumScrollEnd = now - this.state.lastMomentumScrollEndTime;
    var isAnimating = timeSinceLastMomentumScrollEnd < IS_ANIMATING_TOUCH_START_THRESHOLD_MS || this.state.lastMomentumScrollEndTime < this.state.lastMomentumScrollBeginTime;
    return isAnimating;
  },

  /**
   * Returns the node that represents native view that can be scrolled.
   * Components can pass what node to use by defining a `getScrollableNode`
   * function otherwise `this` is used.
   */
  scrollResponderGetScrollableNode: function scrollResponderGetScrollableNode() {
    return this.getScrollableNode ? this.getScrollableNode() : (0,findNodeHandle/* default */.Z)(this);
  },

  /**
   * A helper function to scroll to a specific point in the scrollview.
   * This is currently used to help focus on child textviews, but can also
   * be used to quickly scroll to any element we want to focus. Syntax:
   *
   * scrollResponderScrollTo(options: {x: number = 0; y: number = 0; animated: boolean = true})
   *
   * Note: The weird argument signature is due to the fact that, for historical reasons,
   * the function also accepts separate arguments as as alternative to the options object.
   * This is deprecated due to ambiguity (y before x), and SHOULD NOT BE USED.
   */
  scrollResponderScrollTo: function scrollResponderScrollTo(x, y, animated) {
    if (typeof x === 'number') {
      console.warn('`scrollResponderScrollTo(x, y, animated)` is deprecated. Use `scrollResponderScrollTo({x: 5, y: 5, animated: true})` instead.');
    } else {
      var _ref = x || emptyObject;

      x = _ref.x;
      y = _ref.y;
      animated = _ref.animated;
    }

    var node = this.scrollResponderGetScrollableNode();
    var left = x || 0;
    var top = y || 0;

    if (typeof node.scroll === 'function') {
      node.scroll({
        top,
        left,
        behavior: !animated ? 'auto' : 'smooth'
      });
    } else {
      node.scrollLeft = left;
      node.scrollTop = top;
    }
  },

  /**
   * A helper function to zoom to a specific rect in the scrollview. The argument has the shape
   * {x: number; y: number; width: number; height: number; animated: boolean = true}
   *
   * @platform ios
   */
  scrollResponderZoomTo: function scrollResponderZoomTo(rect, animated) {
    if (Platform/* default.OS */.Z.OS !== 'ios') {
      invariant_default()('zoomToRect is not implemented');
    }
  },

  /**
   * Displays the scroll indicators momentarily.
   */
  scrollResponderFlashScrollIndicators: function scrollResponderFlashScrollIndicators() {},

  /**
   * This method should be used as the callback to onFocus in a TextInputs'
   * parent view. Note that any module using this mixin needs to return
   * the parent view's ref in getScrollViewRef() in order to use this method.
   * @param {any} nodeHandle The TextInput node handle
   * @param {number} additionalOffset The scroll view's top "contentInset".
   *        Default is 0.
   * @param {bool} preventNegativeScrolling Whether to allow pulling the content
   *        down to make it meet the keyboard's top. Default is false.
   */
  scrollResponderScrollNativeHandleToKeyboard: function scrollResponderScrollNativeHandleToKeyboard(nodeHandle, additionalOffset, preventNegativeScrollOffset) {
    this.additionalScrollOffset = additionalOffset || 0;
    this.preventNegativeScrollOffset = !!preventNegativeScrollOffset;
    UIManager/* default.measureLayout */.Z.measureLayout(nodeHandle, (0,findNodeHandle/* default */.Z)(this.getInnerViewNode()), this.scrollResponderTextInputFocusError, this.scrollResponderInputMeasureAndScrollToKeyboard);
  },

  /**
   * The calculations performed here assume the scroll view takes up the entire
   * screen - even if has some content inset. We then measure the offsets of the
   * keyboard, and compensate both for the scroll view's "contentInset".
   *
   * @param {number} left Position of input w.r.t. table view.
   * @param {number} top Position of input w.r.t. table view.
   * @param {number} width Width of the text input.
   * @param {number} height Height of the text input.
   */
  scrollResponderInputMeasureAndScrollToKeyboard: function scrollResponderInputMeasureAndScrollToKeyboard(left, top, width, height) {
    var keyboardScreenY = Dimensions/* default.get */.Z.get('window').height;

    if (this.keyboardWillOpenTo) {
      keyboardScreenY = this.keyboardWillOpenTo.endCoordinates.screenY;
    }

    var scrollOffsetY = top - keyboardScreenY + height + this.additionalScrollOffset; // By default, this can scroll with negative offset, pulling the content
    // down so that the target component's bottom meets the keyboard's top.
    // If requested otherwise, cap the offset at 0 minimum to avoid content
    // shifting down.

    if (this.preventNegativeScrollOffset) {
      scrollOffsetY = Math.max(0, scrollOffsetY);
    }

    this.scrollResponderScrollTo({
      x: 0,
      y: scrollOffsetY,
      animated: true
    });
    this.additionalOffset = 0;
    this.preventNegativeScrollOffset = false;
  },
  scrollResponderTextInputFocusError: function scrollResponderTextInputFocusError(e) {
    console.error('Error measuring text field: ', e);
  },

  /**
   * `componentWillMount` is the closest thing to a  standard "constructor" for
   * React components.
   *
   * The `keyboardWillShow` is called before input focus.
   */
  UNSAFE_componentWillMount: function UNSAFE_componentWillMount() {
    this.keyboardWillOpenTo = null;
    this.additionalScrollOffset = 0; // this.addListenerOn(RCTDeviceEventEmitter, 'keyboardWillShow', this.scrollResponderKeyboardWillShow);
    // this.addListenerOn(RCTDeviceEventEmitter, 'keyboardWillHide', this.scrollResponderKeyboardWillHide);
    // this.addListenerOn(RCTDeviceEventEmitter, 'keyboardDidShow', this.scrollResponderKeyboardDidShow);
    // this.addListenerOn(RCTDeviceEventEmitter, 'keyboardDidHide', this.scrollResponderKeyboardDidHide);
  },

  /**
   * Warning, this may be called several times for a single keyboard opening.
   * It's best to store the information in this method and then take any action
   * at a later point (either in `keyboardDidShow` or other).
   *
   * Here's the order that events occur in:
   * - focus
   * - willShow {startCoordinates, endCoordinates} several times
   * - didShow several times
   * - blur
   * - willHide {startCoordinates, endCoordinates} several times
   * - didHide several times
   *
   * The `ScrollResponder` providesModule callbacks for each of these events.
   * Even though any user could have easily listened to keyboard events
   * themselves, using these `props` callbacks ensures that ordering of events
   * is consistent - and not dependent on the order that the keyboard events are
   * subscribed to. This matters when telling the scroll view to scroll to where
   * the keyboard is headed - the scroll responder better have been notified of
   * the keyboard destination before being instructed to scroll to where the
   * keyboard will be. Stick to the `ScrollResponder` callbacks, and everything
   * will work.
   *
   * WARNING: These callbacks will fire even if a keyboard is displayed in a
   * different navigation pane. Filter out the events to determine if they are
   * relevant to you. (For example, only if you receive these callbacks after
   * you had explicitly focused a node etc).
   */
  scrollResponderKeyboardWillShow: function scrollResponderKeyboardWillShow(e) {
    this.keyboardWillOpenTo = e;
    this.props.onKeyboardWillShow && this.props.onKeyboardWillShow(e);
  },
  scrollResponderKeyboardWillHide: function scrollResponderKeyboardWillHide(e) {
    this.keyboardWillOpenTo = null;
    this.props.onKeyboardWillHide && this.props.onKeyboardWillHide(e);
  },
  scrollResponderKeyboardDidShow: function scrollResponderKeyboardDidShow(e) {
    // TODO(7693961): The event for DidShow is not available on iOS yet.
    // Use the one from WillShow and do not assign.
    if (e) {
      this.keyboardWillOpenTo = e;
    }

    this.props.onKeyboardDidShow && this.props.onKeyboardDidShow(e);
  },
  scrollResponderKeyboardDidHide: function scrollResponderKeyboardDidHide(e) {
    this.keyboardWillOpenTo = null;
    this.props.onKeyboardDidHide && this.props.onKeyboardDidHide(e);
  }
};
var ScrollResponder = {
  Mixin: ScrollResponderMixin
};
/* harmony default export */ var modules_ScrollResponder = (ScrollResponder);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/exports/StyleSheet/index.js + 6 modules
var StyleSheet = __webpack_require__(66068);
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/exports/View/index.js
var View = __webpack_require__(25686);
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/modules/useMergeRefs/index.js
var useMergeRefs = __webpack_require__(52778);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/exports/ScrollView/ScrollViewBase.js


var _excluded = ["onScroll", "onTouchMove", "onWheel", "scrollEnabled", "scrollEventThrottle", "showsHorizontalScrollIndicator", "showsVerticalScrollIndicator", "style"];

/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */





function normalizeScrollEvent(e) {
  return {
    nativeEvent: {
      contentOffset: {
        get x() {
          return e.target.scrollLeft;
        },

        get y() {
          return e.target.scrollTop;
        }

      },
      contentSize: {
        get height() {
          return e.target.scrollHeight;
        },

        get width() {
          return e.target.scrollWidth;
        }

      },
      layoutMeasurement: {
        get height() {
          return e.target.offsetHeight;
        },

        get width() {
          return e.target.offsetWidth;
        }

      }
    },
    timeStamp: Date.now()
  };
}

function shouldEmitScrollEvent(lastTick, eventThrottle) {
  var timeSinceLastTick = Date.now() - lastTick;
  return eventThrottle > 0 && timeSinceLastTick >= eventThrottle;
}
/**
 * Encapsulates the Web-specific scroll throttling and disabling logic
 */


var ScrollViewBase = /*#__PURE__*/react.forwardRef((props, forwardedRef) => {
  var onScroll = props.onScroll,
      onTouchMove = props.onTouchMove,
      onWheel = props.onWheel,
      _props$scrollEnabled = props.scrollEnabled,
      scrollEnabled = _props$scrollEnabled === void 0 ? true : _props$scrollEnabled,
      _props$scrollEventThr = props.scrollEventThrottle,
      scrollEventThrottle = _props$scrollEventThr === void 0 ? 0 : _props$scrollEventThr,
      showsHorizontalScrollIndicator = props.showsHorizontalScrollIndicator,
      showsVerticalScrollIndicator = props.showsVerticalScrollIndicator,
      style = props.style,
      rest = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);

  var scrollState = react.useRef({
    isScrolling: false,
    scrollLastTick: 0
  });
  var scrollTimeout = react.useRef(null);
  var scrollRef = react.useRef(null);

  function createPreventableScrollHandler(handler) {
    return e => {
      if (scrollEnabled) {
        if (handler) {
          handler(e);
        }
      }
    };
  }

  function handleScroll(e) {
    e.stopPropagation();

    if (e.target === scrollRef.current) {
      e.persist(); // A scroll happened, so the scroll resets the scrollend timeout.

      if (scrollTimeout.current != null) {
        clearTimeout(scrollTimeout.current);
      }

      scrollTimeout.current = setTimeout(() => {
        handleScrollEnd(e);
      }, 100);

      if (scrollState.current.isScrolling) {
        // Scroll last tick may have changed, check if we need to notify
        if (shouldEmitScrollEvent(scrollState.current.scrollLastTick, scrollEventThrottle)) {
          handleScrollTick(e);
        }
      } else {
        // Weren't scrolling, so we must have just started
        handleScrollStart(e);
      }
    }
  }

  function handleScrollStart(e) {
    scrollState.current.isScrolling = true;
    handleScrollTick(e);
  }

  function handleScrollTick(e) {
    scrollState.current.scrollLastTick = Date.now();

    if (onScroll) {
      onScroll(normalizeScrollEvent(e));
    }
  }

  function handleScrollEnd(e) {
    scrollState.current.isScrolling = false;

    if (onScroll) {
      onScroll(normalizeScrollEvent(e));
    }
  }

  var hideScrollbar = showsHorizontalScrollIndicator === false || showsVerticalScrollIndicator === false;
  return /*#__PURE__*/react.createElement(View/* default */.Z, (0,esm_extends/* default */.Z)({}, rest, {
    onScroll: handleScroll,
    onTouchMove: createPreventableScrollHandler(onTouchMove),
    onWheel: createPreventableScrollHandler(onWheel),
    ref: (0,useMergeRefs/* default */.Z)(scrollRef, forwardedRef),
    style: [style, !scrollEnabled && styles.scrollDisabled, hideScrollbar && styles.hideScrollbar]
  }));
}); // Chrome doesn't support e.preventDefault in this case; touch-action must be
// used to disable scrolling.
// https://developers.google.com/web/updates/2017/01/scrolling-intervention

var styles = StyleSheet/* default.create */.Z.create({
  scrollDisabled: {
    overflowX: 'hidden',
    overflowY: 'hidden',
    touchAction: 'none'
  },
  hideScrollbar: {
    scrollbarWidth: 'none'
  }
});
/* harmony default export */ var ScrollView_ScrollViewBase = (ScrollViewBase);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/exports/ScrollView/index.js



var ScrollView_excluded = ["contentContainerStyle", "horizontal", "onContentSizeChange", "refreshControl", "stickyHeaderIndices", "pagingEnabled", "forwardedRef", "keyboardDismissMode", "onScroll", "centerContent"];

/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */









var ScrollView_emptyObject = {};
/* eslint-disable react/prefer-es6-class */

var ScrollView = create_react_class_default()({
  displayName: "ScrollView",
  mixins: [modules_ScrollResponder.Mixin],

  getInitialState() {
    return this.scrollResponderMixinGetInitialState();
  },

  flashScrollIndicators() {
    this.scrollResponderFlashScrollIndicators();
  },

  /**
   * Returns a reference to the underlying scroll responder, which supports
   * operations like `scrollTo`. All ScrollView-like components should
   * implement this method so that they can be composed while providing access
   * to the underlying scroll responder's methods.
   */
  getScrollResponder() {
    return this;
  },

  getScrollableNode() {
    return this._scrollNodeRef;
  },

  getInnerViewRef() {
    return this._innerViewRef;
  },

  getInnerViewNode() {
    return this._innerViewRef;
  },

  getNativeScrollRef() {
    return this._scrollNodeRef;
  },

  /**
   * Scrolls to a given x, y offset, either immediately or with a smooth animation.
   * Syntax:
   *
   * scrollTo(options: {x: number = 0; y: number = 0; animated: boolean = true})
   *
   * Note: The weird argument signature is due to the fact that, for historical reasons,
   * the function also accepts separate arguments as as alternative to the options object.
   * This is deprecated due to ambiguity (y before x), and SHOULD NOT BE USED.
   */
  scrollTo(y, x, animated) {
    if (typeof y === 'number') {
      console.warn('`scrollTo(y, x, animated)` is deprecated. Use `scrollTo({x: 5, y: 5, animated: true})` instead.');
    } else {
      var _ref = y || ScrollView_emptyObject;

      x = _ref.x;
      y = _ref.y;
      animated = _ref.animated;
    }

    this.getScrollResponder().scrollResponderScrollTo({
      x: x || 0,
      y: y || 0,
      animated: animated !== false
    });
  },

  /**
   * If this is a vertical ScrollView scrolls to the bottom.
   * If this is a horizontal ScrollView scrolls to the right.
   *
   * Use `scrollToEnd({ animated: true })` for smooth animated scrolling,
   * `scrollToEnd({ animated: false })` for immediate scrolling.
   * If no options are passed, `animated` defaults to true.
   */
  scrollToEnd(options) {
    // Default to true
    var animated = (options && options.animated) !== false;
    var horizontal = this.props.horizontal;
    var scrollResponder = this.getScrollResponder();
    var scrollResponderNode = scrollResponder.scrollResponderGetScrollableNode();
    var x = horizontal ? scrollResponderNode.scrollWidth : 0;
    var y = horizontal ? 0 : scrollResponderNode.scrollHeight;
    scrollResponder.scrollResponderScrollTo({
      x,
      y,
      animated
    });
  },

  render() {
    var _this$props = this.props,
        contentContainerStyle = _this$props.contentContainerStyle,
        horizontal = _this$props.horizontal,
        onContentSizeChange = _this$props.onContentSizeChange,
        refreshControl = _this$props.refreshControl,
        stickyHeaderIndices = _this$props.stickyHeaderIndices,
        pagingEnabled = _this$props.pagingEnabled,
        forwardedRef = _this$props.forwardedRef,
        keyboardDismissMode = _this$props.keyboardDismissMode,
        onScroll = _this$props.onScroll,
        centerContent = _this$props.centerContent,
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(_this$props, ScrollView_excluded);

    if (false) { var childLayoutProps, style; }

    var contentSizeChangeProps = {};

    if (onContentSizeChange) {
      contentSizeChangeProps = {
        onLayout: this._handleContentOnLayout
      };
    }

    var hasStickyHeaderIndices = !horizontal && Array.isArray(stickyHeaderIndices);
    var children = hasStickyHeaderIndices || pagingEnabled ? react.Children.map(this.props.children, (child, i) => {
      var isSticky = hasStickyHeaderIndices && stickyHeaderIndices.indexOf(i) > -1;

      if (child != null && (isSticky || pagingEnabled)) {
        return /*#__PURE__*/react.createElement(View/* default */.Z, {
          style: StyleSheet/* default.compose */.Z.compose(isSticky && ScrollView_styles.stickyHeader, pagingEnabled && ScrollView_styles.pagingEnabledChild)
        }, child);
      } else {
        return child;
      }
    }) : this.props.children;
    var contentContainer = /*#__PURE__*/react.createElement(View/* default */.Z, (0,esm_extends/* default */.Z)({}, contentSizeChangeProps, {
      children: children,
      collapsable: false,
      ref: this._setInnerViewRef,
      style: [horizontal && ScrollView_styles.contentContainerHorizontal, centerContent && ScrollView_styles.contentContainerCenterContent, contentContainerStyle]
    }));
    var baseStyle = horizontal ? ScrollView_styles.baseHorizontal : ScrollView_styles.baseVertical;
    var pagingEnabledStyle = horizontal ? ScrollView_styles.pagingEnabledHorizontal : ScrollView_styles.pagingEnabledVertical;

    var props = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, other), {}, {
      style: [baseStyle, pagingEnabled && pagingEnabledStyle, this.props.style],
      onTouchStart: this.scrollResponderHandleTouchStart,
      onTouchMove: this.scrollResponderHandleTouchMove,
      onTouchEnd: this.scrollResponderHandleTouchEnd,
      onScrollBeginDrag: this.scrollResponderHandleScrollBeginDrag,
      onScrollEndDrag: this.scrollResponderHandleScrollEndDrag,
      onMomentumScrollBegin: this.scrollResponderHandleMomentumScrollBegin,
      onMomentumScrollEnd: this.scrollResponderHandleMomentumScrollEnd,
      onStartShouldSetResponder: this.scrollResponderHandleStartShouldSetResponder,
      onStartShouldSetResponderCapture: this.scrollResponderHandleStartShouldSetResponderCapture,
      onScrollShouldSetResponder: this.scrollResponderHandleScrollShouldSetResponder,
      onScroll: this._handleScroll,
      onResponderGrant: this.scrollResponderHandleResponderGrant,
      onResponderTerminationRequest: this.scrollResponderHandleTerminationRequest,
      onResponderTerminate: this.scrollResponderHandleTerminate,
      onResponderRelease: this.scrollResponderHandleResponderRelease,
      onResponderReject: this.scrollResponderHandleResponderReject
    });

    var ScrollViewClass = ScrollView_ScrollViewBase;
    invariant_default()(ScrollViewClass !== undefined, 'ScrollViewClass must not be undefined');
    var scrollView = /*#__PURE__*/react.createElement(ScrollViewClass, (0,esm_extends/* default */.Z)({}, props, {
      ref: this._setScrollNodeRef
    }), contentContainer);

    if (refreshControl) {
      return /*#__PURE__*/react.cloneElement(refreshControl, {
        style: props.style
      }, scrollView);
    }

    return scrollView;
  },

  _handleContentOnLayout(e) {
    var _e$nativeEvent$layout = e.nativeEvent.layout,
        width = _e$nativeEvent$layout.width,
        height = _e$nativeEvent$layout.height;
    this.props.onContentSizeChange(width, height);
  },

  _handleScroll(e) {
    if (false) {}

    if (this.props.keyboardDismissMode === 'on-drag') {
      (0,dismissKeyboard/* default */.Z)();
    }

    this.scrollResponderHandleScroll(e);
  },

  _setInnerViewRef(node) {
    this._innerViewRef = node;
  },

  _setScrollNodeRef(node) {
    this._scrollNodeRef = node; // ScrollView needs to add more methods to the hostNode in addition to those
    // added by `usePlatformMethods`. This is temporarily until an API like
    // `ScrollView.scrollTo(hostNode, { x, y })` is added to React Native.

    if (node != null) {
      node.getScrollResponder = this.getScrollResponder;
      node.getInnerViewNode = this.getInnerViewNode;
      node.getInnerViewRef = this.getInnerViewRef;
      node.getNativeScrollRef = this.getNativeScrollRef;
      node.getScrollableNode = this.getScrollableNode;
      node.scrollTo = this.scrollTo;
      node.scrollToEnd = this.scrollToEnd;
      node.flashScrollIndicators = this.flashScrollIndicators;
      node.scrollResponderZoomTo = this.scrollResponderZoomTo;
      node.scrollResponderScrollNativeHandleToKeyboard = this.scrollResponderScrollNativeHandleToKeyboard;
    }

    var ref = (0,mergeRefs/* default */.Z)(this.props.forwardedRef);
    ref(node);
  }

});
var commonStyle = {
  flexGrow: 1,
  flexShrink: 1,
  // Enable hardware compositing in modern browsers.
  // Creates a new layer with its own backing surface that can significantly
  // improve scroll performance.
  transform: [{
    translateZ: 0
  }],
  // iOS native scrolling
  WebkitOverflowScrolling: 'touch'
};
var ScrollView_styles = StyleSheet/* default.create */.Z.create({
  baseVertical: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, commonStyle), {}, {
    flexDirection: 'column',
    overflowX: 'hidden',
    overflowY: 'auto'
  }),
  baseHorizontal: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, commonStyle), {}, {
    flexDirection: 'row',
    overflowX: 'auto',
    overflowY: 'hidden'
  }),
  contentContainerHorizontal: {
    flexDirection: 'row'
  },
  contentContainerCenterContent: {
    justifyContent: 'center',
    flexGrow: 1
  },
  stickyHeader: {
    position: 'sticky',
    top: 0,
    zIndex: 10
  },
  pagingEnabledHorizontal: {
    scrollSnapType: 'x mandatory'
  },
  pagingEnabledVertical: {
    scrollSnapType: 'y mandatory'
  },
  pagingEnabledChild: {
    scrollSnapAlign: 'start'
  }
});
var ForwardedScrollView = /*#__PURE__*/react.forwardRef((props, forwardedRef) => {
  return /*#__PURE__*/react.createElement(ScrollView, (0,esm_extends/* default */.Z)({}, props, {
    forwardedRef: forwardedRef
  }));
});
ForwardedScrollView.displayName = 'ScrollView';
/* harmony default export */ var exports_ScrollView = (ForwardedScrollView);

/***/ }),

/***/ 72302:
/***/ (function(module) {

module.exports = worm(true)

function worm(root = false) {
  const obj = root
    ? {
        get default() {
          return worm()
        },
      }
    : function () {
        //  dev warning in debug mode
        if (false) {}

        return worm()
      }

  obj.displayName = `ProxyWorm - Check excludeReactNativeWebExports`
  obj._isProxyWorm = true

  return new Proxy(obj, {
    get(_, key) {
      if (Reflect.has(obj, key)) return Reflect.get(obj, key)
      return worm()
    },
    apply() {
      return worm()
    },
  })
}


/***/ }),

/***/ 44776:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */
var emptyFunction = () => {};

function StatusBar() {
  return null;
}

StatusBar.setBackgroundColor = emptyFunction;
StatusBar.setBarStyle = emptyFunction;
StatusBar.setHidden = emptyFunction;
StatusBar.setNetworkActivityIndicatorVisible = emptyFunction;
StatusBar.setTranslucent = emptyFunction;
/* harmony default export */ __webpack_exports__["Z"] = (StatusBar);

/***/ }),

/***/ 58609:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ compiler_normalizeColor; }
});

;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/modules/isWebColor/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */
var isWebColor = color => color === 'currentcolor' || color === 'currentColor' || color === 'inherit' || color.indexOf('var(') === 0;

/* harmony default export */ var modules_isWebColor = (isWebColor);
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/exports/processColor/index.js
var processColor = __webpack_require__(98091);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/exports/StyleSheet/compiler/normalizeColor.js
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var normalizeColor = function normalizeColor(color, opacity) {
  if (opacity === void 0) {
    opacity = 1;
  }

  if (color == null) return;

  if (typeof color === 'string' && modules_isWebColor(color)) {
    return color;
  }

  var colorInt = (0,processColor/* default */.Z)(color);

  if (colorInt != null) {
    var r = colorInt >> 16 & 255;
    var g = colorInt >> 8 & 255;
    var b = colorInt & 255;
    var a = (colorInt >> 24 & 255) / 255;
    var alpha = (a * opacity).toFixed(2);
    return "rgba(" + r + "," + g + "," + b + "," + alpha + ")";
  }
};

/* harmony default export */ var compiler_normalizeColor = (normalizeColor);

/***/ }),

/***/ 8901:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ normalizeValueWithProperty; }
});

;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/exports/StyleSheet/compiler/unitlessNumbers.js
/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */
var unitlessNumbers = {
  animationIterationCount: true,
  aspectRatio: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  flex: true,
  flexGrow: true,
  flexOrder: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  fontWeight: true,
  gridRow: true,
  gridRowEnd: true,
  gridRowGap: true,
  gridRowStart: true,
  gridColumn: true,
  gridColumnEnd: true,
  gridColumnGap: true,
  gridColumnStart: true,
  lineClamp: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,
  // SVG-related
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true,
  // transform types
  scale: true,
  scaleX: true,
  scaleY: true,
  scaleZ: true,
  // RN properties
  shadowOpacity: true
};
/**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 */

var prefixes = ['ms', 'Moz', 'O', 'Webkit'];

var prefixKey = (prefix, key) => {
  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
};

Object.keys(unitlessNumbers).forEach(prop => {
  prefixes.forEach(prefix => {
    unitlessNumbers[prefixKey(prefix, prop)] = unitlessNumbers[prop];
  });
});
/* harmony default export */ var compiler_unitlessNumbers = (unitlessNumbers);
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/exports/StyleSheet/compiler/normalizeColor.js + 1 modules
var normalizeColor = __webpack_require__(58609);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/exports/StyleSheet/compiler/normalizeValueWithProperty.js
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


var colorProps = {
  backgroundColor: true,
  borderColor: true,
  borderTopColor: true,
  borderRightColor: true,
  borderBottomColor: true,
  borderLeftColor: true,
  color: true,
  shadowColor: true,
  textDecorationColor: true,
  textShadowColor: true
};
function normalizeValueWithProperty(value, property) {
  var returnValue = value;

  if ((property == null || !compiler_unitlessNumbers[property]) && typeof value === 'number') {
    returnValue = value + "px";
  } else if (property != null && colorProps[property]) {
    returnValue = (0,normalizeColor/* default */.Z)(value);
  }

  return returnValue;
}

/***/ }),

/***/ 67410:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": function() { return /* binding */ createSheet; }
});

// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/modules/canUseDom/index.js
var canUseDom = __webpack_require__(19017);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/exports/StyleSheet/dom/createCSSStyleSheet.js
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */
 // $FlowFixMe: HTMLStyleElement is incorrectly typed - https://github.com/facebook/flow/issues/2696

function createCSSStyleSheet(id, rootNode, textContent) {
  if (canUseDom/* default */.Z) {
    var root = rootNode != null ? rootNode : document;
    var element = root.getElementById(id);

    if (element == null) {
      element = document.createElement('style');
      element.setAttribute('id', id);

      if (typeof textContent === 'string') {
        element.appendChild(document.createTextNode(textContent));
      }

      if (root instanceof ShadowRoot) {
        root.insertBefore(element, root.firstChild);
      } else {
        var head = root.head;

        if (head) {
          head.insertBefore(element, head.firstChild);
        }
      }
    } // $FlowFixMe: HTMLElement is incorrectly typed


    return element.sheet;
  } else {
    return null;
  }
}
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/exports/StyleSheet/dom/createOrderedCSSStyleSheet.js
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */
var slice = Array.prototype.slice;
/**
 * Order-based insertion of CSS.
 *
 * Each rule is associated with a numerically defined group.
 * Groups are ordered within the style sheet according to their number, with the
 * lowest first.
 *
 * Groups are implemented using marker rules. The selector of the first rule of
 * each group is used only to encode the group number for hydration. An
 * alternative implementation could rely on CSSMediaRule, allowing groups to be
 * treated as a sub-sheet, but the Edge implementation of CSSMediaRule is
 * broken.
 * https://developer.mozilla.org/en-US/docs/Web/API/CSSMediaRule
 * https://gist.github.com/necolas/aa0c37846ad6bd3b05b727b959e82674
 */

function createOrderedCSSStyleSheet(sheet) {
  var groups = {};
  var selectors = {};
  /**
   * Hydrate approximate record from any existing rules in the sheet.
   */

  if (sheet != null) {
    var group;
    slice.call(sheet.cssRules).forEach((cssRule, i) => {
      var cssText = cssRule.cssText; // Create record of existing selectors and rules

      if (cssText.indexOf('stylesheet-group') > -1) {
        group = decodeGroupRule(cssRule);
        groups[group] = {
          start: i,
          rules: [cssText]
        };
      } else {
        var selectorText = getSelectorText(cssText);

        if (selectorText != null) {
          selectors[selectorText] = true;
          groups[group].rules.push(cssText);
        }
      }
    });
  }

  function sheetInsert(sheet, group, text) {
    var orderedGroups = getOrderedGroups(groups);
    var groupIndex = orderedGroups.indexOf(group);
    var nextGroupIndex = groupIndex + 1;
    var nextGroup = orderedGroups[nextGroupIndex]; // Insert rule before the next group, or at the end of the stylesheet

    var position = nextGroup != null && groups[nextGroup].start != null ? groups[nextGroup].start : sheet.cssRules.length;
    var isInserted = insertRuleAt(sheet, text, position);

    if (isInserted) {
      // Set the starting index of the new group
      if (groups[group].start == null) {
        groups[group].start = position;
      } // Increment the starting index of all subsequent groups


      for (var i = nextGroupIndex; i < orderedGroups.length; i += 1) {
        var groupNumber = orderedGroups[i];
        var previousStart = groups[groupNumber].start || 0;
        groups[groupNumber].start = previousStart + 1;
      }
    }

    return isInserted;
  }

  var OrderedCSSStyleSheet = {
    /**
     * The textContent of the style sheet.
     */
    getTextContent() {
      return getOrderedGroups(groups).map(group => {
        var rules = groups[group].rules; // Sorting provides deterministic order of styles in group for
        // build-time extraction of the style sheet.

        var marker = rules.shift();
        rules.sort();
        rules.unshift(marker);
        return rules.join('\n');
      }).join('\n');
    },

    /**
     * Insert a rule into the style sheet
     */
    insert(cssText, groupValue) {
      var group = Number(groupValue); // Create a new group.

      if (groups[group] == null) {
        var markerRule = encodeGroupRule(group); // Create the internal record.

        groups[group] = {
          start: null,
          rules: [markerRule]
        }; // Update CSSOM.

        if (sheet != null) {
          sheetInsert(sheet, group, markerRule);
        }
      } // selectorText is more reliable than cssText for insertion checks. The
      // browser excludes vendor-prefixed properties and rewrites certain values
      // making cssText more likely to be different from what was inserted.


      var selectorText = getSelectorText(cssText);

      if (selectorText != null && selectors[selectorText] == null) {
        // Update the internal records.
        selectors[selectorText] = true;
        groups[group].rules.push(cssText); // Update CSSOM.

        if (sheet != null) {
          var isInserted = sheetInsert(sheet, group, cssText);

          if (!isInserted) {
            // Revert internal record change if a rule was rejected (e.g.,
            // unrecognized pseudo-selector)
            groups[group].rules.pop();
          }
        }
      }
    }

  };
  return OrderedCSSStyleSheet;
}
/**
 * Helper functions
 */

function encodeGroupRule(group) {
  return "[stylesheet-group=\"" + group + "\"]{}";
}

var groupPattern = /["']/g;

function decodeGroupRule(cssRule) {
  return Number(cssRule.selectorText.split(groupPattern)[1]);
}

function getOrderedGroups(obj) {
  return Object.keys(obj).map(Number).sort((a, b) => a > b ? 1 : -1);
}

var selectorPattern = /\s*([,])\s*/g;

function getSelectorText(cssText) {
  var selector = cssText.split('{')[0].trim();
  return selector !== '' ? selector.replace(selectorPattern, '$1') : null;
}

function insertRuleAt(root, cssText, position) {
  try {
    // $FlowFixMe: Flow is missing CSSOM types needed to type 'root'.
    root.insertRule(cssText, position);
    return true;
  } catch (e) {
    // JSDOM doesn't support `CSSSMediaRule#insertRule`.
    // Also ignore errors that occur from attempting to insert vendor-prefixed selectors.
    return false;
  }
}
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/exports/StyleSheet/dom/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var defaultId = 'react-native-stylesheet';
var roots = new WeakMap();
var sheets = [];
var initialRules = [// minimal top-level reset
'html{-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%;-webkit-tap-highlight-color:rgba(0,0,0,0);}', 'body{margin:0;}', // minimal form pseudo-element reset
'button::-moz-focus-inner,input::-moz-focus-inner{border:0;padding:0;}', 'input::-webkit-search-cancel-button,input::-webkit-search-decoration,input::-webkit-search-results-button,input::-webkit-search-results-decoration{display:none;}'];
function createSheet(root, id) {
  if (id === void 0) {
    id = defaultId;
  }

  var sheet;

  if (canUseDom/* default */.Z) {
    var rootNode = root != null ? root.getRootNode() : document; // Create the initial style sheet

    if (sheets.length === 0) {
      sheet = createOrderedCSSStyleSheet(createCSSStyleSheet(id));
      initialRules.forEach(rule => {
        sheet.insert(rule, 0);
      });
      roots.set(rootNode, sheets.length);
      sheets.push(sheet);
    } else {
      var index = roots.get(rootNode);

      if (index == null) {
        var initialSheet = sheets[0]; // If we're creating a new sheet, populate it with existing styles

        var textContent = initialSheet != null ? initialSheet.getTextContent() : ''; // Cast rootNode to 'any' because Flow types for getRootNode are wrong

        sheet = createOrderedCSSStyleSheet(createCSSStyleSheet(id, rootNode, textContent));
        roots.set(rootNode, sheets.length);
        sheets.push(sheet);
      } else {
        sheet = sheets[index];
      }
    }
  } else {
    // Create the initial style sheet
    if (sheets.length === 0) {
      sheet = createOrderedCSSStyleSheet(createCSSStyleSheet(id));
      initialRules.forEach(rule => {
        sheet.insert(rule, 0);
      });
      sheets.push(sheet);
    } else {
      sheet = sheets[0];
    }
  }

  return {
    getTextContent() {
      return sheet.getTextContent();
    },

    id,

    insert(cssText, groupValue) {
      sheets.forEach(s => {
        s.insert(cssText, groupValue);
      });
    }

  };
}

/***/ }),

/***/ 66068:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ exports_StyleSheet; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectSpread2.js + 4 modules
var objectSpread2 = __webpack_require__(29405);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/exports/StyleSheet/compiler/normalizeValueWithProperty.js + 1 modules
var normalizeValueWithProperty = __webpack_require__(8901);
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/modules/canUseDom/index.js
var canUseDom = __webpack_require__(19017);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/exports/StyleSheet/compiler/createReactDOMStyle.js
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * The browser implements the CSS cascade, where the order of properties is a
 * factor in determining which styles to paint. React Native is different. It
 * gives giving precedence to the more specific style property. For example,
 * the value of `paddingTop` takes precedence over that of `padding`.
 *
 * This module creates mutally exclusive style declarations by expanding all of
 * React Native's supported shortform properties (e.g. `padding`) to their
 * longfrom equivalents.
 */
var emptyObject = {};
var supportsCSS3TextDecoration = !canUseDom/* default */.Z || window.CSS != null && window.CSS.supports != null && (window.CSS.supports('text-decoration-line', 'none') || window.CSS.supports('-webkit-text-decoration-line', 'none'));
var ignoredProps = {
  elevation: true,
  overlayColor: true,
  resizeMode: true,
  tintColor: true
};
var MONOSPACE_FONT_STACK = 'monospace,monospace';
var SYSTEM_FONT_STACK = '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Helvetica,Arial,sans-serif';
var STYLE_SHORT_FORM_EXPANSIONS = {
  borderColor: ['borderTopColor', 'borderRightColor', 'borderBottomColor', 'borderLeftColor'],
  borderRadius: ['borderTopLeftRadius', 'borderTopRightRadius', 'borderBottomRightRadius', 'borderBottomLeftRadius'],
  borderStyle: ['borderTopStyle', 'borderRightStyle', 'borderBottomStyle', 'borderLeftStyle'],
  borderWidth: ['borderTopWidth', 'borderRightWidth', 'borderBottomWidth', 'borderLeftWidth'],
  marginHorizontal: ['marginRight', 'marginLeft'],
  marginVertical: ['marginTop', 'marginBottom'],
  overflow: ['overflowX', 'overflowY'],
  overscrollBehavior: ['overscrollBehaviorX', 'overscrollBehaviorY'],
  paddingHorizontal: ['paddingRight', 'paddingLeft'],
  paddingVertical: ['paddingTop', 'paddingBottom']
};
/**
 * Transform
 */
// { scale: 2 } => 'scale(2)'
// { translateX: 20 } => 'translateX(20px)'
// { matrix: [1,2,3,4,5,6] } => 'matrix(1,2,3,4,5,6)'

var mapTransform = transform => {
  var type = Object.keys(transform)[0];
  var value = transform[type];

  if (type === 'matrix' || type === 'matrix3d') {
    return type + "(" + value.join(',') + ")";
  } else {
    var normalizedValue = (0,normalizeValueWithProperty/* default */.Z)(value, type);
    return type + "(" + normalizedValue + ")";
  }
};

var createTransformValue = style => {
  var transform = style.transform;

  if (Array.isArray(style.transform)) {
    transform = style.transform.map(mapTransform).join(' ');
  }

  return transform;
};
/**
 * Reducer
 */

var createReactDOMStyle = (style, isInline) => {
  if (!style) {
    return emptyObject;
  }

  var resolvedStyle = {};

  for (var prop in style) {
    var value = style[prop];

    if ( // Ignore everything with a null value
    value == null || // Ignore some React Native styles
    ignoredProps[prop]) {
      continue;
    }

    if (prop === 'aspectRatio') {
      resolvedStyle[prop] = value.toString();
    } else if (prop === 'backgroundClip') {
      // TODO: remove once this issue is fixed
      // https://github.com/rofrischmann/inline-style-prefixer/issues/159
      if (value === 'text') {
        resolvedStyle.backgroundClip = value;
        resolvedStyle.WebkitBackgroundClip = value;
      }
    } else if (prop === 'flex') {
      if (value === -1) {
        resolvedStyle.flexGrow = 0;
        resolvedStyle.flexShrink = 1;
        resolvedStyle.flexBasis = 'auto';
      } else {
        resolvedStyle.flex = value;
      }
    } else if (prop === 'font') {
      resolvedStyle[prop] = value.replace('System', SYSTEM_FONT_STACK);
    } else if (prop === 'fontFamily') {
      if (value.indexOf('System') > -1) {
        var stack = value.split(/,\s*/);
        stack[stack.indexOf('System')] = SYSTEM_FONT_STACK;
        resolvedStyle[prop] = stack.join(',');
      } else if (value === 'monospace') {
        resolvedStyle[prop] = MONOSPACE_FONT_STACK;
      } else {
        resolvedStyle[prop] = value;
      }
    } else if (prop === 'fontVariant') {
      if (Array.isArray(value) && value.length > 0) {
        resolvedStyle.fontVariant = value.join(' ');
      }
    } else if (prop === 'textAlignVertical') {
      resolvedStyle.verticalAlign = value === 'center' ? 'middle' : value;
    } else if (prop === 'textDecorationLine') {
      // use 'text-decoration' for browsers that only support CSS2
      // text-decoration (e.g., IE, Edge)
      if (!supportsCSS3TextDecoration) {
        resolvedStyle.textDecoration = value;
      } else {
        resolvedStyle.textDecorationLine = value;
      }
    } else if (prop === 'transform' || prop === 'transformMatrix') {
      resolvedStyle.transform = createTransformValue(style);
    } else if (prop === 'writingDirection') {
      resolvedStyle.direction = value;
    } else {
      (function () {
        var value = (0,normalizeValueWithProperty/* default */.Z)(style[prop], prop);
        var longFormProperties = STYLE_SHORT_FORM_EXPANSIONS[prop];

        if (isInline && prop === 'margin') {
          if (style.marginHorizontal == null) {
            resolvedStyle.marginLeft = value;
            resolvedStyle.marginRight = value;
          }

          if (style.marginVertical == null) {
            resolvedStyle.marginTop = value;
            resolvedStyle.marginBottom = value;
          }
        } else if (isInline && prop === 'padding') {
          if (style.paddingHorizontal == null) {
            resolvedStyle.paddingLeft = value;
            resolvedStyle.paddingRight = value;
          }

          if (style.paddingVertical == null) {
            resolvedStyle.paddingTop = value;
            resolvedStyle.paddingBottom = value;
          }
        } else if (longFormProperties) {
          longFormProperties.forEach((longForm, i) => {
            // The value of any longform property in the original styles takes
            // precedence over the shortform's value.
            if (style[longForm] == null) {
              resolvedStyle[longForm] = value;
            }
          });
        } else {
          resolvedStyle[prop] = Array.isArray(value) ? value.join(',') : value;
        }
      })();
    }
  }

  return resolvedStyle;
};

/* harmony default export */ var compiler_createReactDOMStyle = (createReactDOMStyle);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/exports/StyleSheet/compiler/hash.js
/* eslint-disable */

/**
 * JS Implementation of MurmurHash2
 *
 * @author <a href="mailto:gary.court@gmail.com">Gary Court</a>
 * @see http://github.com/garycourt/murmurhash-js
 * @author <a href="mailto:aappleby@gmail.com">Austin Appleby</a>
 * @see http://sites.google.com/site/murmurhash/
 *
 * @param {string} str ASCII only
 * @param {number} seed Positive integer only
 * @return {number} 32-bit positive integer hash
 *
 * 
 */
function murmurhash2_32_gc(str, seed) {
  var l = str.length,
      h = seed ^ l,
      i = 0,
      k;

  while (l >= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    k ^= k >>> 24;
    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
    l -= 4;
    ++i;
  }

  switch (l) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  }

  h ^= h >>> 13;
  h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  h ^= h >>> 15;
  return h >>> 0;
}

var hash = str => murmurhash2_32_gc(str, 1).toString(36);

/* harmony default export */ var compiler_hash = (hash);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/exports/StyleSheet/compiler/hyphenateStyleName.js
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */
var uppercasePattern = /[A-Z]/g;
var msPattern = /^ms-/;
var cache = {};

function toHyphenLower(match) {
  return '-' + match.toLowerCase();
}

function hyphenateStyleName(name) {
  if (name in cache) {
    return cache[name];
  }

  var hName = name.replace(uppercasePattern, toHyphenLower);
  return cache[name] = msPattern.test(hName) ? '-' + hName : hName;
}

/* harmony default export */ var compiler_hyphenateStyleName = (hyphenateStyleName);
// EXTERNAL MODULE: ../../node_modules/inline-style-prefixer/lib/createPrefixer.js
var createPrefixer = __webpack_require__(35970);
// EXTERNAL MODULE: ../../node_modules/inline-style-prefixer/lib/plugins/backgroundClip.js
var backgroundClip = __webpack_require__(62204);
// EXTERNAL MODULE: ../../node_modules/inline-style-prefixer/lib/plugins/crossFade.js
var crossFade = __webpack_require__(19629);
// EXTERNAL MODULE: ../../node_modules/inline-style-prefixer/lib/plugins/cursor.js
var cursor = __webpack_require__(9270);
// EXTERNAL MODULE: ../../node_modules/inline-style-prefixer/lib/plugins/filter.js
var filter = __webpack_require__(69528);
// EXTERNAL MODULE: ../../node_modules/inline-style-prefixer/lib/plugins/imageSet.js
var imageSet = __webpack_require__(10876);
// EXTERNAL MODULE: ../../node_modules/inline-style-prefixer/lib/plugins/logical.js
var logical = __webpack_require__(14819);
// EXTERNAL MODULE: ../../node_modules/inline-style-prefixer/lib/plugins/position.js
var position = __webpack_require__(38572);
// EXTERNAL MODULE: ../../node_modules/inline-style-prefixer/lib/plugins/sizing.js
var sizing = __webpack_require__(70300);
// EXTERNAL MODULE: ../../node_modules/inline-style-prefixer/lib/plugins/transition.js
var transition = __webpack_require__(63132);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/modules/prefixStyles/static.js









var w = ['Webkit'];
var m = ['Moz'];
var wm = ['Webkit', 'Moz'];
var wms = ['Webkit', 'ms'];
var wmms = ['Webkit', 'Moz', 'ms'];
/* harmony default export */ var prefixStyles_static = ({
  plugins: [backgroundClip/* default */.Z, crossFade/* default */.Z, cursor/* default */.Z, filter/* default */.Z, imageSet/* default */.Z, logical/* default */.Z, position/* default */.Z, sizing/* default */.Z, transition/* default */.Z],
  prefixMap: {
    appearance: wmms,
    userSelect: wm,
    textEmphasisPosition: wms,
    textEmphasis: wms,
    textEmphasisStyle: wms,
    textEmphasisColor: wms,
    boxDecorationBreak: wms,
    clipPath: w,
    maskImage: wms,
    maskMode: wms,
    maskRepeat: wms,
    maskPosition: wms,
    maskClip: wms,
    maskOrigin: wms,
    maskSize: wms,
    maskComposite: wms,
    mask: wms,
    maskBorderSource: wms,
    maskBorderMode: wms,
    maskBorderSlice: wms,
    maskBorderWidth: wms,
    maskBorderOutset: wms,
    maskBorderRepeat: wms,
    maskBorder: wms,
    maskType: wms,
    textDecorationStyle: w,
    textDecorationSkip: w,
    textDecorationLine: w,
    textDecorationColor: w,
    filter: w,
    breakAfter: w,
    breakBefore: w,
    breakInside: w,
    columnCount: w,
    columnFill: w,
    columnGap: w,
    columnRule: w,
    columnRuleColor: w,
    columnRuleStyle: w,
    columnRuleWidth: w,
    columns: w,
    columnSpan: w,
    columnWidth: w,
    backdropFilter: w,
    hyphens: w,
    flowInto: w,
    flowFrom: w,
    regionFragment: w,
    textOrientation: w,
    tabSize: m,
    fontKerning: w,
    textSizeAdjust: w
  }
});
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/modules/prefixStyles/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


var prefixAll = (0,createPrefixer/* default */.Z)(prefixStyles_static);
/* harmony default export */ var prefixStyles = (prefixAll);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/exports/StyleSheet/compiler/index.js


var _excluded = ["animationKeyframes"];

/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */





var compiler_cache = new Map();
var compiler_emptyObject = {};
var classicGroup = 1;
var atomicGroup = 2.2;
var customGroup = {
  borderColor: 2,
  borderRadius: 2,
  borderStyle: 2,
  borderWidth: 2,
  display: 2,
  flex: 2,
  margin: 2,
  overflow: 2,
  overscrollBehavior: 2,
  padding: 2,
  marginHorizontal: 2.1,
  marginVertical: 2.1,
  paddingHorizontal: 2.1,
  paddingVertical: 2.1
};
var borderTopLeftRadius = 'borderTopLeftRadius';
var borderTopRightRadius = 'borderTopRightRadius';
var borderBottomLeftRadius = 'borderBottomLeftRadius';
var borderBottomRightRadius = 'borderBottomRightRadius';
var borderLeftColor = 'borderLeftColor';
var borderLeftStyle = 'borderLeftStyle';
var borderLeftWidth = 'borderLeftWidth';
var borderRightColor = 'borderRightColor';
var borderRightStyle = 'borderRightStyle';
var borderRightWidth = 'borderRightWidth';
var right = 'right';
var marginLeft = 'marginLeft';
var marginRight = 'marginRight';
var paddingLeft = 'paddingLeft';
var paddingRight = 'paddingRight';
var left = 'left'; // Map of LTR property names to their BiDi equivalent.

var PROPERTIES_FLIP = {
  [borderTopLeftRadius]: borderTopRightRadius,
  [borderTopRightRadius]: borderTopLeftRadius,
  [borderBottomLeftRadius]: borderBottomRightRadius,
  [borderBottomRightRadius]: borderBottomLeftRadius,
  [borderLeftColor]: borderRightColor,
  [borderLeftStyle]: borderRightStyle,
  [borderLeftWidth]: borderRightWidth,
  [borderRightColor]: borderLeftColor,
  [borderRightStyle]: borderLeftStyle,
  [borderRightWidth]: borderLeftWidth,
  [left]: right,
  [marginLeft]: marginRight,
  [marginRight]: marginLeft,
  [paddingLeft]: paddingRight,
  [paddingRight]: paddingLeft,
  [right]: left
}; // Map of I18N property names to their LTR equivalent.

var PROPERTIES_I18N = {
  borderTopStartRadius: borderTopLeftRadius,
  borderTopEndRadius: borderTopRightRadius,
  borderBottomStartRadius: borderBottomLeftRadius,
  borderBottomEndRadius: borderBottomRightRadius,
  borderStartColor: borderLeftColor,
  borderStartStyle: borderLeftStyle,
  borderStartWidth: borderLeftWidth,
  borderEndColor: borderRightColor,
  borderEndStyle: borderRightStyle,
  borderEndWidth: borderRightWidth,
  end: right,
  marginStart: marginLeft,
  marginEnd: marginRight,
  paddingStart: paddingLeft,
  paddingEnd: paddingRight,
  start: left
};
var PROPERTIES_VALUE = ['clear', 'float', 'textAlign'];
function atomic(style) {
  var compiledStyle = {
    $$css: true
  };
  var compiledRules = [];

  function atomicCompile(prop, value) {
    var valueString = stringifyValueWithProperty(value, prop);
    var cacheKey = prop + valueString;
    var cachedResult = compiler_cache.get(cacheKey);
    var identifier;

    if (cachedResult != null) {
      identifier = cachedResult[0];
      compiledRules.push(cachedResult[1]);
    } else {
      identifier = createIdentifier('r', prop, value);
      var order = customGroup[prop] || atomicGroup;
      var rules = createAtomicRules(identifier, prop, value);
      var orderedRules = [rules, order];
      compiledRules.push(orderedRules);
      compiler_cache.set(cacheKey, [identifier, orderedRules]);
    }

    return identifier;
  }

  Object.keys(style).sort().forEach(prop => {
    var value = style[prop];

    if (value != null) {
      var localizeableValue; // BiDi flip values

      if (PROPERTIES_VALUE.indexOf(prop) > -1) {
        var _left = atomicCompile(prop, 'left');

        var _right = atomicCompile(prop, 'right');

        if (value === 'start') {
          localizeableValue = [_left, _right];
        } else if (value === 'end') {
          localizeableValue = [_right, _left];
        }
      } // BiDi flip properties


      var propPolyfill = PROPERTIES_I18N[prop];

      if (propPolyfill != null) {
        var ltr = atomicCompile(propPolyfill, value);
        var rtl = atomicCompile(PROPERTIES_FLIP[propPolyfill], value);
        localizeableValue = [ltr, rtl];
      } // BiDi flip transitionProperty value


      if (prop === 'transitionProperty') {
        var values = Array.isArray(value) ? value : [value];
        var polyfillIndices = [];

        for (var i = 0; i < values.length; i++) {
          var val = values[i];

          if (typeof val === 'string' && PROPERTIES_I18N[val] != null) {
            polyfillIndices.push(i);
          }
        }

        if (polyfillIndices.length > 0) {
          var ltrPolyfillValues = [...values];
          var rtlPolyfillValues = [...values];
          polyfillIndices.forEach(i => {
            var ltrVal = ltrPolyfillValues[i];

            if (typeof ltrVal === 'string') {
              var ltrPolyfill = PROPERTIES_I18N[ltrVal];
              var rtlPolyfill = PROPERTIES_FLIP[ltrPolyfill];
              ltrPolyfillValues[i] = ltrPolyfill;
              rtlPolyfillValues[i] = rtlPolyfill;

              var _ltr = atomicCompile(prop, ltrPolyfillValues);

              var _rtl = atomicCompile(prop, rtlPolyfillValues);

              localizeableValue = [_ltr, _rtl];
            }
          });
        }
      }

      if (localizeableValue == null) {
        localizeableValue = atomicCompile(prop, value);
      } else {
        compiledStyle['$$css$localize'] = true;
      }

      compiledStyle[prop] = localizeableValue;
    }
  });
  return [compiledStyle, compiledRules];
}
/**
 * Compile simple style object to classic CSS rules.
 * No support for 'placeholderTextColor', 'scrollbarWidth', or 'pointerEvents'.
 */

function classic(style, name) {
  var compiledStyle = {
    $$css: true
  };
  var compiledRules = [];

  var animationKeyframes = style.animationKeyframes,
      rest = (0,objectWithoutPropertiesLoose/* default */.Z)(style, _excluded);

  var identifier = createIdentifier('css', name, style);
  var selector = "." + identifier;
  var animationName;

  if (animationKeyframes != null) {
    var _processKeyframesValu = processKeyframesValue(animationKeyframes),
        animationNames = _processKeyframesValu[0],
        keyframesRules = _processKeyframesValu[1];

    animationName = animationNames.join(',');
    compiledRules.push(...keyframesRules);
  }

  var block = createDeclarationBlock((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, rest), {}, {
    animationName
  }));
  compiledRules.push("" + selector + block);
  compiledStyle[identifier] = identifier;
  return [compiledStyle, [[compiledRules, classicGroup]]];
}
/**
 * Compile simple style object to inline DOM styles.
 * No support for 'animationKeyframes', 'placeholderTextColor', 'scrollbarWidth', or 'pointerEvents'.
 */

function inline(originalStyle, isRTL) {
  var style = originalStyle || compiler_emptyObject;
  var frozenProps = {};
  var nextStyle = {};

  for (var originalProp in style) {
    var originalValue = style[originalProp];
    var prop = originalProp;
    var value = originalValue;

    if (!Object.prototype.hasOwnProperty.call(style, originalProp) || originalValue == null) {
      continue;
    } // BiDi flip values


    if (PROPERTIES_VALUE.indexOf(originalProp) > -1) {
      if (originalValue === 'start') {
        value = isRTL ? 'right' : 'left';
      } else if (originalValue === 'end') {
        value = isRTL ? 'left' : 'right';
      }
    } // BiDi flip properties


    var propPolyfill = PROPERTIES_I18N[originalProp];

    if (propPolyfill != null) {
      prop = isRTL ? PROPERTIES_FLIP[propPolyfill] : propPolyfill;
    } // BiDi flip transitionProperty value


    if (originalProp === 'transitionProperty') {
      (function () {
        // $FlowFixMe
        var originalValues = Array.isArray(originalValue) ? originalValue : [originalValue];
        originalValues.forEach((val, i) => {
          if (typeof val === 'string') {
            var valuePolyfill = PROPERTIES_I18N[val];

            if (valuePolyfill != null) {
              originalValues[i] = isRTL ? PROPERTIES_FLIP[valuePolyfill] : valuePolyfill;
            }
          }
        });
      })();
    } // Create finalized style


    if (!frozenProps[prop]) {
      nextStyle[prop] = value;
    }

    if (PROPERTIES_I18N.hasOwnProperty(originalProp)) {
      frozenProps[prop] = true;
    }
  }

  return compiler_createReactDOMStyle(nextStyle, true);
}
/**
 * Create a value string that normalizes different input values with a common
 * output.
 */

function stringifyValueWithProperty(value, property) {
  // e.g., 0 => '0px', 'black' => 'rgba(0,0,0,1)'
  var normalizedValue = (0,normalizeValueWithProperty/* default */.Z)(value, property);
  return typeof normalizedValue !== 'string' ? JSON.stringify(normalizedValue || '') : normalizedValue;
}
/**
 * Create the Atomic CSS rules needed for a given StyleSheet rule.
 * Translates StyleSheet declarations to CSS.
 */

function createAtomicRules(identifier, property, value) {
  var rules = [];
  var selector = "." + identifier; // Handle non-standard properties and object values that require multiple
  // CSS rules to be created.

  switch (property) {
    case 'animationKeyframes':
      {
        var _processKeyframesValu2 = processKeyframesValue(value),
            animationNames = _processKeyframesValu2[0],
            keyframesRules = _processKeyframesValu2[1];

        var block = createDeclarationBlock({
          animationName: animationNames.join(',')
        });
        rules.push("" + selector + block, ...keyframesRules);
        break;
      }
    // Equivalent to using '::placeholder'

    case 'placeholderTextColor':
      {
        var _block = createDeclarationBlock({
          color: value,
          opacity: 1
        });

        rules.push(selector + "::-webkit-input-placeholder" + _block, selector + "::-moz-placeholder" + _block, selector + ":-ms-input-placeholder" + _block, selector + "::placeholder" + _block);
        break;
      }
    // Polyfill for additional 'pointer-events' values
    // See d13f78622b233a0afc0c7a200c0a0792c8ca9e58

    case 'pointerEvents':
      {
        var finalValue = value;

        if (value === 'auto' || value === 'box-only') {
          finalValue = 'auto!important';

          if (value === 'box-only') {
            var _block3 = createDeclarationBlock({
              pointerEvents: 'none'
            });

            rules.push(selector + ">*" + _block3);
          }
        } else if (value === 'none' || value === 'box-none') {
          finalValue = 'none!important';

          if (value === 'box-none') {
            var _block4 = createDeclarationBlock({
              pointerEvents: 'auto'
            });

            rules.push(selector + ">*" + _block4);
          }
        }

        var _block2 = createDeclarationBlock({
          pointerEvents: finalValue
        });

        rules.push("" + selector + _block2);
        break;
      }
    // Polyfill for draft spec
    // https://drafts.csswg.org/css-scrollbars-1/

    case 'scrollbarWidth':
      {
        if (value === 'none') {
          rules.push(selector + "::-webkit-scrollbar{display:none}");
        }

        var _block5 = createDeclarationBlock({
          scrollbarWidth: value
        });

        rules.push("" + selector + _block5);
        break;
      }

    default:
      {
        var _block6 = createDeclarationBlock({
          [property]: value
        });

        rules.push("" + selector + _block6);
        break;
      }
  }

  return rules;
}
/**
 * Creates a CSS declaration block from a StyleSheet object.
 */


function createDeclarationBlock(style) {
  var domStyle = prefixStyles(compiler_createReactDOMStyle(style));
  var declarationsString = Object.keys(domStyle).map(property => {
    var value = domStyle[property];
    var prop = compiler_hyphenateStyleName(property); // The prefixer may return an array of values:
    // { display: [ '-webkit-flex', 'flex' ] }
    // to represent "fallback" declarations
    // { display: -webkit-flex; display: flex; }

    if (Array.isArray(value)) {
      return value.map(v => prop + ":" + v).join(';');
    } else {
      return prop + ":" + value;
    }
  }) // Once properties are hyphenated, this will put the vendor
  // prefixed and short-form properties first in the list.
  .sort().join(';');
  return "{" + declarationsString + ";}";
}
/**
 * An identifier is associated with a unique set of styles.
 */


function createIdentifier(prefix, name, value) {
  var hashedString = compiler_hash(name + stringifyValueWithProperty(value, name));
  return  false ? 0 : prefix + "-" + hashedString;
}
/**
 * Create individual CSS keyframes rules.
 */


function createKeyframes(keyframes) {
  var prefixes = ['-webkit-', ''];
  var identifier = createIdentifier('r', 'animation', keyframes);
  var steps = '{' + Object.keys(keyframes).map(stepName => {
    var rule = keyframes[stepName];
    var block = createDeclarationBlock(rule);
    return "" + stepName + block;
  }).join('') + '}';
  var rules = prefixes.map(prefix => {
    return "@" + prefix + "keyframes " + identifier + steps;
  });
  return [identifier, rules];
}
/**
 * Create CSS keyframes rules and names from a StyleSheet keyframes object.
 */


function processKeyframesValue(keyframesValue) {
  if (typeof keyframesValue === 'number') {
    throw new Error("Invalid CSS keyframes type: " + typeof keyframesValue);
  }

  var animationNames = [];
  var rules = [];
  var value = Array.isArray(keyframesValue) ? keyframesValue : [keyframesValue];
  value.forEach(keyframes => {
    if (typeof keyframes === 'string') {
      // Support external animation libraries (identifiers only)
      animationNames.push(keyframes);
    } else {
      // Create rules for each of the keyframes
      var _createKeyframes = createKeyframes(keyframes),
          identifier = _createKeyframes[0],
          keyframesRules = _createKeyframes[1];

      animationNames.push(identifier);
      rules.push(...keyframesRules);
    }
  });
  return [animationNames, rules];
}
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/exports/StyleSheet/dom/index.js + 2 modules
var dom = __webpack_require__(67410);
// EXTERNAL MODULE: ../../node_modules/styleq/dist/transform-localize-style.js
var transform_localize_style = __webpack_require__(73699);
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/exports/StyleSheet/preprocess.js
var preprocess = __webpack_require__(49609);
// EXTERNAL MODULE: ../../node_modules/styleq/dist/styleq.js
var styleq = __webpack_require__(36169);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/exports/StyleSheet/index.js


/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */







var staticStyleMap = new WeakMap();
var sheet = (0,dom/* createSheet */.S)();

function customStyleq(styles, isRTL) {
  return styleq/* styleq.factory */.D.factory({
    transform(style) {
      var compiledStyle = staticStyleMap.get(style);

      if (compiledStyle != null) {
        return (0,transform_localize_style/* localizeStyle */.j)(compiledStyle, isRTL);
      }

      return style;
    }

  })(styles);
}

function insertRules(compiledOrderedRules) {
  compiledOrderedRules.forEach(_ref => {
    var rules = _ref[0],
        order = _ref[1];

    if (sheet != null) {
      rules.forEach(rule => {
        sheet.insert(rule, order);
      });
    }
  });
}

function compileAndInsertAtomic(style) {
  var _atomic = atomic((0,preprocess/* preprocess */.dj)(style)),
      compiledStyle = _atomic[0],
      compiledOrderedRules = _atomic[1];

  insertRules(compiledOrderedRules);
  return compiledStyle;
}

function compileAndInsertReset(style, key) {
  var _classic = classic(style, key),
      compiledStyle = _classic[0],
      compiledOrderedRules = _classic[1];

  insertRules(compiledOrderedRules);
  return compiledStyle;
}
/* ----- API ----- */


var absoluteFillObject = {
  position: 'absolute',
  left: 0,
  right: 0,
  top: 0,
  bottom: 0
};
var absoluteFill = create({
  x: (0,objectSpread2/* default */.Z)({}, absoluteFillObject)
}).x;
/**
 * create
 */

function create(styles) {
  Object.keys(styles).forEach(key => {
    var styleObj = styles[key]; // Only compile at runtime if the style is not already compiled

    if (styleObj != null && styleObj.$$css !== true) {
      var compiledStyles;

      if (key.indexOf('$raw') > -1) {
        compiledStyles = compileAndInsertReset(styleObj, key.split('$raw')[0]);
      } else {
        if (false) {}

        compiledStyles = compileAndInsertAtomic(styleObj);
      }

      staticStyleMap.set(styleObj, compiledStyles);
    }
  });
  return styles;
}
/**
 * compose
 */


function compose(style1, style2) {
  if (false) { var readableStyles, len; }

  if (style1 && style2) {
    return [style1, style2];
  } else {
    return style1 || style2;
  }
}
/**
 * flatten
 */


function flatten() {
  for (var _len = arguments.length, styles = new Array(_len), _key = 0; _key < _len; _key++) {
    styles[_key] = arguments[_key];
  }

  var flatArray = styles.flat(Infinity);
  var result = {};

  for (var i = 0; i < flatArray.length; i++) {
    var style = flatArray[i];

    if (style != null && typeof style === 'object') {
      // $FlowFixMe
      Object.assign(result, style);
    }
  }

  return result;
}
/**
 * getSheet
 */


function getSheet() {
  return {
    id: sheet.id,
    textContent: sheet.getTextContent()
  };
}
/**
 * resolve
 */


function StyleSheet(styles, options) {
  var isRTL = options != null && options.writingDirection === 'rtl';
  var styleProps = customStyleq(styles, isRTL);

  if (Array.isArray(styleProps) && styleProps[1] != null) {
    styleProps[1] = inline((0,preprocess/* preprocess */.dj)(styleProps[1]), isRTL);
  }

  return styleProps;
}

StyleSheet.absoluteFill = absoluteFill;
StyleSheet.absoluteFillObject = absoluteFillObject;
StyleSheet.create = create;
StyleSheet.compose = compose;
StyleSheet.flatten = flatten;
StyleSheet.getSheet = getSheet; // `hairlineWidth` is not implemented using screen density as browsers may
// round sub-pixel values down to `0`, causing the line not to be rendered.

StyleSheet.hairlineWidth = 1;

if (canUseDom/* default */.Z && window.__REACT_DEVTOOLS_GLOBAL_HOOK__) {
  window.__REACT_DEVTOOLS_GLOBAL_HOOK__.resolveRNStyle = StyleSheet.flatten;
}

var stylesheet = StyleSheet;
/* harmony default export */ var exports_StyleSheet = (stylesheet);

/***/ }),

/***/ 49609:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Lm": function() { return /* binding */ createBoxShadowValue; },
/* harmony export */   "dj": function() { return /* binding */ preprocess; }
/* harmony export */ });
/* unused harmony export createTextShadowValue */
/* harmony import */ var _compiler_normalizeColor__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58609);
/* harmony import */ var _compiler_normalizeValueWithProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8901);
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


var emptyObject = {};
/**
 * Shadows
 */

var defaultOffset = {
  height: 0,
  width: 0
};
var createBoxShadowValue = style => {
  var shadowColor = style.shadowColor,
      shadowOffset = style.shadowOffset,
      shadowOpacity = style.shadowOpacity,
      shadowRadius = style.shadowRadius;

  var _ref = shadowOffset || defaultOffset,
      height = _ref.height,
      width = _ref.width;

  var offsetX = (0,_compiler_normalizeValueWithProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(width);
  var offsetY = (0,_compiler_normalizeValueWithProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(height);
  var blurRadius = (0,_compiler_normalizeValueWithProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(shadowRadius || 0);
  var color = (0,_compiler_normalizeColor__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(shadowColor || 'black', shadowOpacity);

  if (color != null && offsetX != null && offsetY != null && blurRadius != null) {
    return offsetX + " " + offsetY + " " + blurRadius + " " + color;
  }
};
var createTextShadowValue = style => {
  var textShadowColor = style.textShadowColor,
      textShadowOffset = style.textShadowOffset,
      textShadowRadius = style.textShadowRadius;

  var _ref2 = textShadowOffset || defaultOffset,
      height = _ref2.height,
      width = _ref2.width;

  var radius = textShadowRadius || 0;
  var offsetX = (0,_compiler_normalizeValueWithProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(width);
  var offsetY = (0,_compiler_normalizeValueWithProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(height);
  var blurRadius = (0,_compiler_normalizeValueWithProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(radius);
  var color = (0,_compiler_normalizeValueWithProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(textShadowColor, 'textShadowColor');

  if (color && (height !== 0 || width !== 0 || radius !== 0) && offsetX != null && offsetY != null && blurRadius != null) {
    return offsetX + " " + offsetY + " " + blurRadius + " " + color;
  }
};
/**
 * Preprocess styles
 */

var preprocess = originalStyle => {
  var style = originalStyle || emptyObject;
  var nextStyle = {};

  for (var originalProp in style) {
    var originalValue = style[originalProp];
    var prop = originalProp;
    var value = originalValue;

    if (!Object.prototype.hasOwnProperty.call(style, originalProp) || originalValue == null) {
      continue;
    } // Convert shadow styles


    if (prop === 'shadowColor' || prop === 'shadowOffset' || prop === 'shadowOpacity' || prop === 'shadowRadius') {
      var boxShadowValue = createBoxShadowValue(style);

      if (boxShadowValue != null && nextStyle.boxShadow == null) {
        var boxShadow = style.boxShadow;
        prop = 'boxShadow';
        value = boxShadow ? boxShadow + ", " + boxShadowValue : boxShadowValue;
      } else {
        continue;
      }
    } // Convert text shadow styles


    if (prop === 'textShadowColor' || prop === 'textShadowOffset' || prop === 'textShadowRadius') {
      var textShadowValue = createTextShadowValue(style);

      if (textShadowValue != null && nextStyle.textShadow == null) {
        var textShadow = style.textShadow;
        prop = 'textShadow';
        value = textShadow ? textShadow + ", " + textShadowValue : textShadowValue;
      } else {
        continue;
      }
    }

    nextStyle[prop] = value;
  } // $FlowIgnore


  return nextStyle;
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (preprocess)));

/***/ }),

/***/ 24996:
/***/ (function(module) {

module.exports = worm(true)

function worm(root = false) {
  const obj = root
    ? {
        get default() {
          return worm()
        },
      }
    : function () {
        //  dev warning in debug mode
        if (false) {}

        return worm()
      }

  obj.displayName = `ProxyWorm - Check excludeReactNativeWebExports`
  obj._isProxyWorm = true

  return new Proxy(obj, {
    get(_, key) {
      if (Reflect.has(obj, key)) return Reflect.get(obj, key)
      return worm()
    },
    apply() {
      return worm()
    },
  })
}


/***/ }),

/***/ 94210:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var TextAncestorContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(false);
/* harmony default export */ __webpack_exports__["Z"] = (TextAncestorContext);

/***/ }),

/***/ 66999:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_objectSpread2__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(29405);
/* harmony import */ var _babel_runtime_helpers_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31461);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _createElement__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(90601);
/* harmony import */ var _modules_forwardedProps__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30464);
/* harmony import */ var _modules_pick__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89641);
/* harmony import */ var _modules_useElementLayout__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(17709);
/* harmony import */ var _modules_useMergeRefs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(52778);
/* harmony import */ var _modules_usePlatformMethods__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5719);
/* harmony import */ var _modules_useResponderEvents__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(20011);
/* harmony import */ var _StyleSheet__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(66068);
/* harmony import */ var _TextAncestorContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94210);
/* harmony import */ var _modules_useLocale__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(38639);


var _excluded = ["hrefAttrs", "numberOfLines", "onClick", "onLayout", "onPress", "onMoveShouldSetResponder", "onMoveShouldSetResponderCapture", "onResponderEnd", "onResponderGrant", "onResponderMove", "onResponderReject", "onResponderRelease", "onResponderStart", "onResponderTerminate", "onResponderTerminationRequest", "onScrollShouldSetResponder", "onScrollShouldSetResponderCapture", "onSelectionChangeShouldSetResponder", "onSelectionChangeShouldSetResponderCapture", "onStartShouldSetResponder", "onStartShouldSetResponderCapture", "selectable"];

/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */











var forwardPropsList = Object.assign({}, _modules_forwardedProps__WEBPACK_IMPORTED_MODULE_1__/* .defaultProps */ .lG, _modules_forwardedProps__WEBPACK_IMPORTED_MODULE_1__/* .accessibilityProps */ .LO, _modules_forwardedProps__WEBPACK_IMPORTED_MODULE_1__/* .clickProps */ ._T, _modules_forwardedProps__WEBPACK_IMPORTED_MODULE_1__/* .focusProps */ .YB, _modules_forwardedProps__WEBPACK_IMPORTED_MODULE_1__/* .keyboardProps */ .Uy, _modules_forwardedProps__WEBPACK_IMPORTED_MODULE_1__/* .mouseProps */ .hJ, _modules_forwardedProps__WEBPACK_IMPORTED_MODULE_1__/* .touchProps */ .E5, _modules_forwardedProps__WEBPACK_IMPORTED_MODULE_1__/* .styleProps */ .vr, {
  href: true,
  lang: true,
  pointerEvents: true
});

var pickProps = props => (0,_modules_pick__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props, forwardPropsList);

var Text = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((props, forwardedRef) => {
  var hrefAttrs = props.hrefAttrs,
      numberOfLines = props.numberOfLines,
      onClick = props.onClick,
      onLayout = props.onLayout,
      onPress = props.onPress,
      onMoveShouldSetResponder = props.onMoveShouldSetResponder,
      onMoveShouldSetResponderCapture = props.onMoveShouldSetResponderCapture,
      onResponderEnd = props.onResponderEnd,
      onResponderGrant = props.onResponderGrant,
      onResponderMove = props.onResponderMove,
      onResponderReject = props.onResponderReject,
      onResponderRelease = props.onResponderRelease,
      onResponderStart = props.onResponderStart,
      onResponderTerminate = props.onResponderTerminate,
      onResponderTerminationRequest = props.onResponderTerminationRequest,
      onScrollShouldSetResponder = props.onScrollShouldSetResponder,
      onScrollShouldSetResponderCapture = props.onScrollShouldSetResponderCapture,
      onSelectionChangeShouldSetResponder = props.onSelectionChangeShouldSetResponder,
      onSelectionChangeShouldSetResponderCapture = props.onSelectionChangeShouldSetResponderCapture,
      onStartShouldSetResponder = props.onStartShouldSetResponder,
      onStartShouldSetResponderCapture = props.onStartShouldSetResponderCapture,
      selectable = props.selectable,
      rest = (0,_babel_runtime_helpers_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(props, _excluded);

  var hasTextAncestor = react__WEBPACK_IMPORTED_MODULE_0__.useContext(_TextAncestorContext__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z);
  var hostRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(null);

  var _useLocaleContext = (0,_modules_useLocale__WEBPACK_IMPORTED_MODULE_5__/* .useLocaleContext */ .PE)(),
      contextDirection = _useLocaleContext.direction;

  (0,_modules_useElementLayout__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(hostRef, onLayout);
  (0,_modules_useResponderEvents__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(hostRef, {
    onMoveShouldSetResponder,
    onMoveShouldSetResponderCapture,
    onResponderEnd,
    onResponderGrant,
    onResponderMove,
    onResponderReject,
    onResponderRelease,
    onResponderStart,
    onResponderTerminate,
    onResponderTerminationRequest,
    onScrollShouldSetResponder,
    onScrollShouldSetResponderCapture,
    onSelectionChangeShouldSetResponder,
    onSelectionChangeShouldSetResponderCapture,
    onStartShouldSetResponder,
    onStartShouldSetResponderCapture
  });
  var handleClick = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(e => {
    if (onClick != null) {
      onClick(e);
    } else if (onPress != null) {
      e.stopPropagation();
      onPress(e);
    }
  }, [onClick, onPress]);
  var component = hasTextAncestor ? 'span' : 'div';
  var langDirection = props.lang != null ? (0,_modules_useLocale__WEBPACK_IMPORTED_MODULE_5__/* .getLocaleDirection */ .w1)(props.lang) : null;
  var componentDirection = props.dir || langDirection;
  var writingDirection = componentDirection || contextDirection;
  var supportedProps = pickProps(rest);
  supportedProps.dir = componentDirection; // 'auto' by default allows browsers to infer writing direction (root elements only)

  if (!hasTextAncestor) {
    supportedProps.dir = componentDirection != null ? componentDirection : 'auto';
  }

  if (onClick || onPress) {
    supportedProps.onClick = handleClick;
  }

  supportedProps.style = [numberOfLines != null && numberOfLines > 1 && {
    WebkitLineClamp: numberOfLines
  }, hasTextAncestor === true ? styles.textHasAncestor$raw : styles.text$raw, numberOfLines === 1 && styles.textOneLine, numberOfLines != null && numberOfLines > 1 && styles.textMultiLine, props.style, selectable === true && styles.selectable, selectable === false && styles.notSelectable, onPress && styles.pressable];

  if (props.href != null) {
    component = 'a';

    if (hrefAttrs != null) {
      var download = hrefAttrs.download,
          rel = hrefAttrs.rel,
          target = hrefAttrs.target;

      if (download != null) {
        supportedProps.download = download;
      }

      if (rel != null) {
        supportedProps.rel = rel;
      }

      if (typeof target === 'string') {
        supportedProps.target = target.charAt(0) !== '_' ? '_' + target : target;
      }
    }
  }

  var platformMethodsRef = (0,_modules_usePlatformMethods__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(supportedProps);
  var setRef = (0,_modules_useMergeRefs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(hostRef, platformMethodsRef, forwardedRef);
  supportedProps.ref = setRef;
  var element = (0,_createElement__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(component, supportedProps, {
    writingDirection
  });
  return hasTextAncestor ? element : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_TextAncestorContext__WEBPACK_IMPORTED_MODULE_4__/* ["default"].Provider */ .Z.Provider, {
    value: true
  }, element);
});
Text.displayName = 'Text';
var textStyle = {
  backgroundColor: 'transparent',
  border: '0 solid black',
  boxSizing: 'border-box',
  color: 'black',
  display: 'inline',
  font: '14px System',
  listStyle: 'none',
  margin: 0,
  padding: 0,
  textAlign: 'inherit',
  textDecoration: 'none',
  whiteSpace: 'pre-wrap',
  wordWrap: 'break-word'
};
var styles = _StyleSheet__WEBPACK_IMPORTED_MODULE_11__/* ["default"].create */ .Z.create({
  text$raw: textStyle,
  textHasAncestor$raw: (0,_babel_runtime_helpers_objectSpread2__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_babel_runtime_helpers_objectSpread2__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, textStyle), {}, {
    color: 'inherit',
    font: 'inherit',
    whiteSpace: 'inherit'
  }),
  textOneLine: {
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    wordWrap: 'normal'
  },
  // See #13
  textMultiLine: {
    display: '-webkit-box',
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    WebkitBoxOrient: 'vertical'
  },
  notSelectable: {
    userSelect: 'none'
  },
  selectable: {
    userSelect: 'text'
  },
  pressable: {
    cursor: 'pointer'
  }
});
/* harmony default export */ __webpack_exports__["Z"] = (Text);

/***/ }),

/***/ 3348:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _createElement__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(90601);
/* harmony import */ var _modules_forwardedProps__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30464);
/* harmony import */ var _modules_pick__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89641);
/* harmony import */ var _modules_useElementLayout__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17709);
/* harmony import */ var _modules_useLayoutEffect__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(56905);
/* harmony import */ var _modules_useMergeRefs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(52778);
/* harmony import */ var _modules_usePlatformMethods__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5719);
/* harmony import */ var _modules_useResponderEvents__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(20011);
/* harmony import */ var _modules_useLocale__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(38639);
/* harmony import */ var _StyleSheet__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(66068);
/* harmony import */ var _modules_TextInputState__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1736);
/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */












/**
 * Determines whether a 'selection' prop differs from a node's existing
 * selection state.
 */

var isSelectionStale = (node, selection) => {
  var selectionEnd = node.selectionEnd,
      selectionStart = node.selectionStart;
  var start = selection.start,
      end = selection.end;
  return start !== selectionStart || end !== selectionEnd;
};
/**
 * Certain input types do no support 'selectSelectionRange' and will throw an
 * error.
 */


var setSelection = (node, selection) => {
  if (isSelectionStale(node, selection)) {
    var start = selection.start,
        end = selection.end;

    try {
      node.setSelectionRange(start, end || start);
    } catch (e) {}
  }
};

var forwardPropsList = Object.assign({}, _modules_forwardedProps__WEBPACK_IMPORTED_MODULE_1__/* .defaultProps */ .lG, _modules_forwardedProps__WEBPACK_IMPORTED_MODULE_1__/* .accessibilityProps */ .LO, _modules_forwardedProps__WEBPACK_IMPORTED_MODULE_1__/* .clickProps */ ._T, _modules_forwardedProps__WEBPACK_IMPORTED_MODULE_1__/* .focusProps */ .YB, _modules_forwardedProps__WEBPACK_IMPORTED_MODULE_1__/* .keyboardProps */ .Uy, _modules_forwardedProps__WEBPACK_IMPORTED_MODULE_1__/* .mouseProps */ .hJ, _modules_forwardedProps__WEBPACK_IMPORTED_MODULE_1__/* .touchProps */ .E5, _modules_forwardedProps__WEBPACK_IMPORTED_MODULE_1__/* .styleProps */ .vr, {
  autoCapitalize: true,
  autoComplete: true,
  autoCorrect: true,
  autoFocus: true,
  defaultValue: true,
  disabled: true,
  lang: true,
  maxLength: true,
  onChange: true,
  onScroll: true,
  placeholder: true,
  pointerEvents: true,
  readOnly: true,
  rows: true,
  spellCheck: true,
  value: true,
  type: true
});

var pickProps = props => (0,_modules_pick__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props, forwardPropsList); // If an Input Method Editor is processing key input, the 'keyCode' is 229.
// https://www.w3.org/TR/uievents/#determine-keydown-keyup-keyCode


function isEventComposing(nativeEvent) {
  return nativeEvent.isComposing || nativeEvent.keyCode === 229;
}

var focusTimeout = null;
var TextInput = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((props, forwardedRef) => {
  var _props$autoCapitalize = props.autoCapitalize,
      autoCapitalize = _props$autoCapitalize === void 0 ? 'sentences' : _props$autoCapitalize,
      autoComplete = props.autoComplete,
      autoCompleteType = props.autoCompleteType,
      _props$autoCorrect = props.autoCorrect,
      autoCorrect = _props$autoCorrect === void 0 ? true : _props$autoCorrect,
      blurOnSubmit = props.blurOnSubmit,
      clearTextOnFocus = props.clearTextOnFocus,
      dir = props.dir,
      _props$editable = props.editable,
      editable = _props$editable === void 0 ? true : _props$editable,
      _props$keyboardType = props.keyboardType,
      keyboardType = _props$keyboardType === void 0 ? 'default' : _props$keyboardType,
      _props$multiline = props.multiline,
      multiline = _props$multiline === void 0 ? false : _props$multiline,
      _props$numberOfLines = props.numberOfLines,
      numberOfLines = _props$numberOfLines === void 0 ? 1 : _props$numberOfLines,
      onBlur = props.onBlur,
      onChange = props.onChange,
      onChangeText = props.onChangeText,
      onContentSizeChange = props.onContentSizeChange,
      onFocus = props.onFocus,
      onKeyPress = props.onKeyPress,
      onLayout = props.onLayout,
      onMoveShouldSetResponder = props.onMoveShouldSetResponder,
      onMoveShouldSetResponderCapture = props.onMoveShouldSetResponderCapture,
      onResponderEnd = props.onResponderEnd,
      onResponderGrant = props.onResponderGrant,
      onResponderMove = props.onResponderMove,
      onResponderReject = props.onResponderReject,
      onResponderRelease = props.onResponderRelease,
      onResponderStart = props.onResponderStart,
      onResponderTerminate = props.onResponderTerminate,
      onResponderTerminationRequest = props.onResponderTerminationRequest,
      onScrollShouldSetResponder = props.onScrollShouldSetResponder,
      onScrollShouldSetResponderCapture = props.onScrollShouldSetResponderCapture,
      onSelectionChange = props.onSelectionChange,
      onSelectionChangeShouldSetResponder = props.onSelectionChangeShouldSetResponder,
      onSelectionChangeShouldSetResponderCapture = props.onSelectionChangeShouldSetResponderCapture,
      onStartShouldSetResponder = props.onStartShouldSetResponder,
      onStartShouldSetResponderCapture = props.onStartShouldSetResponderCapture,
      onSubmitEditing = props.onSubmitEditing,
      placeholderTextColor = props.placeholderTextColor,
      returnKeyType = props.returnKeyType,
      _props$secureTextEntr = props.secureTextEntry,
      secureTextEntry = _props$secureTextEntr === void 0 ? false : _props$secureTextEntr,
      selection = props.selection,
      selectTextOnFocus = props.selectTextOnFocus,
      spellCheck = props.spellCheck;
  var type;
  var inputMode;

  switch (keyboardType) {
    case 'email-address':
      type = 'email';
      break;

    case 'number-pad':
    case 'numeric':
      inputMode = 'numeric';
      break;

    case 'decimal-pad':
      inputMode = 'decimal';
      break;

    case 'phone-pad':
      type = 'tel';
      break;

    case 'search':
    case 'web-search':
      type = 'search';
      break;

    case 'url':
      type = 'url';
      break;

    default:
      type = 'text';
  }

  if (secureTextEntry) {
    type = 'password';
  }

  var dimensions = react__WEBPACK_IMPORTED_MODULE_0__.useRef({
    height: null,
    width: null
  });
  var hostRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(null);
  var handleContentSizeChange = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(hostNode => {
    if (multiline && onContentSizeChange && hostNode != null) {
      var newHeight = hostNode.scrollHeight;
      var newWidth = hostNode.scrollWidth;

      if (newHeight !== dimensions.current.height || newWidth !== dimensions.current.width) {
        dimensions.current.height = newHeight;
        dimensions.current.width = newWidth;
        onContentSizeChange({
          nativeEvent: {
            contentSize: {
              height: dimensions.current.height,
              width: dimensions.current.width
            }
          }
        });
      }
    }
  }, [multiline, onContentSizeChange]);
  var imperativeRef = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => hostNode => {
    // TextInput needs to add more methods to the hostNode in addition to those
    // added by `usePlatformMethods`. This is temporarily until an API like
    // `TextInput.clear(hostRef)` is added to React Native.
    if (hostNode != null) {
      hostNode.clear = function () {
        if (hostNode != null) {
          hostNode.value = '';
        }
      };

      hostNode.isFocused = function () {
        return hostNode != null && _modules_TextInputState__WEBPACK_IMPORTED_MODULE_3__/* ["default"].currentlyFocusedField */ .Z.currentlyFocusedField() === hostNode;
      };

      handleContentSizeChange(hostNode);
    }
  }, [handleContentSizeChange]);

  function handleBlur(e) {
    _modules_TextInputState__WEBPACK_IMPORTED_MODULE_3__/* ["default"]._currentlyFocusedNode */ .Z._currentlyFocusedNode = null;

    if (onBlur) {
      e.nativeEvent.text = e.target.value;
      onBlur(e);
    }
  }

  function handleChange(e) {
    var hostNode = e.target;
    var text = hostNode.value;
    e.nativeEvent.text = text;
    handleContentSizeChange(hostNode);

    if (onChange) {
      onChange(e);
    }

    if (onChangeText) {
      onChangeText(text);
    }
  }

  function handleFocus(e) {
    var hostNode = e.target;

    if (onFocus) {
      e.nativeEvent.text = hostNode.value;
      onFocus(e);
    }

    if (hostNode != null) {
      _modules_TextInputState__WEBPACK_IMPORTED_MODULE_3__/* ["default"]._currentlyFocusedNode */ .Z._currentlyFocusedNode = hostNode;

      if (clearTextOnFocus) {
        hostNode.value = '';
      }

      if (selectTextOnFocus) {
        // Safari requires selection to occur in a setTimeout
        if (focusTimeout != null) {
          clearTimeout(focusTimeout);
        }

        focusTimeout = setTimeout(() => {
          if (hostNode != null) {
            hostNode.select();
          }
        }, 0);
      }
    }
  }

  function handleKeyDown(e) {
    var hostNode = e.target; // Prevent key events bubbling (see #612)

    e.stopPropagation();
    var blurOnSubmitDefault = !multiline;
    var shouldBlurOnSubmit = blurOnSubmit == null ? blurOnSubmitDefault : blurOnSubmit;
    var nativeEvent = e.nativeEvent;
    var isComposing = isEventComposing(nativeEvent);

    if (onKeyPress) {
      onKeyPress(e);
    }

    if (e.key === 'Enter' && !e.shiftKey && // Do not call submit if composition is occuring.
    !isComposing && !e.isDefaultPrevented()) {
      if ((blurOnSubmit || !multiline) && onSubmitEditing) {
        // prevent "Enter" from inserting a newline or submitting a form
        e.preventDefault();
        nativeEvent.text = e.target.value;
        onSubmitEditing(e);
      }

      if (shouldBlurOnSubmit && hostNode != null) {
        setTimeout(() => hostNode.blur(), 0);
      }
    }
  }

  function handleSelectionChange(e) {
    if (onSelectionChange) {
      try {
        var node = e.target;
        var selectionStart = node.selectionStart,
            selectionEnd = node.selectionEnd;
        e.nativeEvent.selection = {
          start: selectionStart,
          end: selectionEnd
        };
        e.nativeEvent.text = e.target.value;
        onSelectionChange(e);
      } catch (e) {}
    }
  }

  (0,_modules_useLayoutEffect__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(() => {
    var node = hostRef.current;

    if (node != null && selection != null) {
      setSelection(node, selection);
    }

    if (document.activeElement === node) {
      _modules_TextInputState__WEBPACK_IMPORTED_MODULE_3__/* ["default"]._currentlyFocusedNode */ .Z._currentlyFocusedNode = node;
    }
  }, [hostRef, selection]);
  var component = multiline ? 'textarea' : 'input';
  (0,_modules_useElementLayout__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(hostRef, onLayout);
  (0,_modules_useResponderEvents__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(hostRef, {
    onMoveShouldSetResponder,
    onMoveShouldSetResponderCapture,
    onResponderEnd,
    onResponderGrant,
    onResponderMove,
    onResponderReject,
    onResponderRelease,
    onResponderStart,
    onResponderTerminate,
    onResponderTerminationRequest,
    onScrollShouldSetResponder,
    onScrollShouldSetResponderCapture,
    onSelectionChangeShouldSetResponder,
    onSelectionChangeShouldSetResponderCapture,
    onStartShouldSetResponder,
    onStartShouldSetResponderCapture
  });

  var _useLocaleContext = (0,_modules_useLocale__WEBPACK_IMPORTED_MODULE_7__/* .useLocaleContext */ .PE)(),
      contextDirection = _useLocaleContext.direction;

  var supportedProps = pickProps(props);
  supportedProps.autoCapitalize = autoCapitalize;
  supportedProps.autoComplete = autoComplete || autoCompleteType || 'on';
  supportedProps.autoCorrect = autoCorrect ? 'on' : 'off'; // 'auto' by default allows browsers to infer writing direction

  supportedProps.dir = dir !== undefined ? dir : 'auto';
  supportedProps.enterKeyHint = returnKeyType;
  supportedProps.inputMode = inputMode;
  supportedProps.onBlur = handleBlur;
  supportedProps.onChange = handleChange;
  supportedProps.onFocus = handleFocus;
  supportedProps.onKeyDown = handleKeyDown;
  supportedProps.onSelect = handleSelectionChange;
  supportedProps.readOnly = !editable;
  supportedProps.rows = multiline ? numberOfLines : undefined;
  supportedProps.spellCheck = spellCheck != null ? spellCheck : autoCorrect;
  supportedProps.style = [{
    '--placeholderTextColor': placeholderTextColor
  }, styles.textinput$raw, styles.placeholder, props.style];
  supportedProps.type = multiline ? undefined : type;
  var platformMethodsRef = (0,_modules_usePlatformMethods__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(supportedProps);
  var setRef = (0,_modules_useMergeRefs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(hostRef, platformMethodsRef, imperativeRef, forwardedRef);
  supportedProps.ref = setRef;
  var langDirection = props.lang != null ? (0,_modules_useLocale__WEBPACK_IMPORTED_MODULE_7__/* .getLocaleDirection */ .w1)(props.lang) : null;
  var componentDirection = props.dir || langDirection;
  var writingDirection = componentDirection || contextDirection;
  var element = (0,_createElement__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(component, supportedProps, {
    writingDirection
  });
  return element;
});
TextInput.displayName = 'TextInput'; // $FlowFixMe

TextInput.State = _modules_TextInputState__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z;
var styles = _StyleSheet__WEBPACK_IMPORTED_MODULE_11__/* ["default"].create */ .Z.create({
  textinput$raw: {
    MozAppearance: 'textfield',
    WebkitAppearance: 'none',
    backgroundColor: 'transparent',
    border: '0 solid black',
    borderRadius: 0,
    boxSizing: 'border-box',
    font: '14px System',
    margin: 0,
    padding: 0,
    resize: 'none'
  },
  placeholder: {
    placeholderTextColor: 'var(--placeholderTextColor)'
  }
});
/* harmony default export */ __webpack_exports__["Z"] = (TextInput);

/***/ }),

/***/ 78539:
/***/ (function(module) {

module.exports = worm(true)

function worm(root = false) {
  const obj = root
    ? {
        get default() {
          return worm()
        },
      }
    : function () {
        //  dev warning in debug mode
        if (false) {}

        return worm()
      }

  obj.displayName = `ProxyWorm - Check excludeReactNativeWebExports`
  obj._isProxyWorm = true

  return new Proxy(obj, {
    get(_, key) {
      if (Reflect.has(obj, key)) return Reflect.get(obj, key)
      return worm()
    },
    apply() {
      return worm()
    },
  })
}


/***/ }),

/***/ 69447:
/***/ (function(module) {

module.exports = worm(true)

function worm(root = false) {
  const obj = root
    ? {
        get default() {
          return worm()
        },
      }
    : function () {
        //  dev warning in debug mode
        if (false) {}

        return worm()
      }

  obj.displayName = `ProxyWorm - Check excludeReactNativeWebExports`
  obj._isProxyWorm = true

  return new Proxy(obj, {
    get(_, key) {
      if (Reflect.has(obj, key)) return Reflect.get(obj, key)
      return worm()
    },
    apply() {
      return worm()
    },
  })
}


/***/ }),

/***/ 46852:
/***/ (function(module) {

module.exports = worm(true)

function worm(root = false) {
  const obj = root
    ? {
        get default() {
          return worm()
        },
      }
    : function () {
        //  dev warning in debug mode
        if (false) {}

        return worm()
      }

  obj.displayName = `ProxyWorm - Check excludeReactNativeWebExports`
  obj._isProxyWorm = true

  return new Proxy(obj, {
    get(_, key) {
      if (Reflect.has(obj, key)) return Reflect.get(obj, key)
      return worm()
    },
    apply() {
      return worm()
    },
  })
}


/***/ }),

/***/ 6307:
/***/ (function(module) {

module.exports = worm(true)

function worm(root = false) {
  const obj = root
    ? {
        get default() {
          return worm()
        },
      }
    : function () {
        //  dev warning in debug mode
        if (false) {}

        return worm()
      }

  obj.displayName = `ProxyWorm - Check excludeReactNativeWebExports`
  obj._isProxyWorm = true

  return new Proxy(obj, {
    get(_, key) {
      if (Reflect.has(obj, key)) return Reflect.get(obj, key)
      return worm()
    },
    apply() {
      return worm()
    },
  })
}


/***/ }),

/***/ 96258:
/***/ (function(module) {

module.exports = worm(true)

function worm(root = false) {
  const obj = root
    ? {
        get default() {
          return worm()
        },
      }
    : function () {
        //  dev warning in debug mode
        if (false) {}

        return worm()
      }

  obj.displayName = `ProxyWorm - Check excludeReactNativeWebExports`
  obj._isProxyWorm = true

  return new Proxy(obj, {
    get(_, key) {
      if (Reflect.has(obj, key)) return Reflect.get(obj, key)
      return worm()
    },
    apply() {
      return worm()
    },
  })
}


/***/ }),

/***/ 96187:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ exports_UIManager; }
});

// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/modules/getBoundingClientRect/index.js
var getBoundingClientRect = __webpack_require__(47351);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/modules/unitlessNumbers/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */
var unitlessNumbers = {
  animationIterationCount: true,
  aspectRatio: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  flex: true,
  flexGrow: true,
  flexOrder: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  fontWeight: true,
  gridRow: true,
  gridRowEnd: true,
  gridRowGap: true,
  gridRowStart: true,
  gridColumn: true,
  gridColumnEnd: true,
  gridColumnGap: true,
  gridColumnStart: true,
  lineClamp: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,
  // SVG-related
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true,
  // transform types
  scale: true,
  scaleX: true,
  scaleY: true,
  scaleZ: true,
  // RN properties
  shadowOpacity: true
};
/**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 */

var prefixes = ['ms', 'Moz', 'O', 'Webkit'];

var prefixKey = (prefix, key) => {
  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
};

Object.keys(unitlessNumbers).forEach(prop => {
  prefixes.forEach(prefix => {
    unitlessNumbers[prefixKey(prefix, prop)] = unitlessNumbers[prop];
  });
});
/* harmony default export */ var modules_unitlessNumbers = (unitlessNumbers);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/modules/setValueForStyles/dangerousStyleValue.js
/* eslint-disable */

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * From React 16.0.0
 * 
 */

/**
 * Convert a value into the proper css writable value. The style name `name`
 * should be logical (no hyphens), as specified
 * in `CSSProperty.isUnitlessNumber`.
 *
 * @param {string} name CSS property name such as `topMargin`.
 * @param {*} value CSS property value such as `10px`.
 * @return {string} Normalized style value with dimensions applied.
 */

function dangerousStyleValue(name, value, isCustomProperty) {
  // Note that we've removed escapeTextForBrowser() calls here since the
  // whole string will be escaped when the attribute is injected into
  // the markup. If you provide unsafe user data here they can inject
  // arbitrary CSS which may be problematic (I couldn't repro this):
  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
  // This is not an XSS hole but instead a potential CSS injection issue
  // which has lead to a greater discussion about how we're going to
  // trust URLs moving forward. See #2115901
  var isEmpty = value == null || typeof value === 'boolean' || value === '';

  if (isEmpty) {
    return '';
  }

  if (!isCustomProperty && typeof value === 'number' && value !== 0 && !(modules_unitlessNumbers.hasOwnProperty(name) && modules_unitlessNumbers[name])) {
    return value + 'px'; // Presumes implicit 'px' suffix for unitless numbers
  }

  return ('' + value).trim();
}

/* harmony default export */ var setValueForStyles_dangerousStyleValue = (dangerousStyleValue);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/modules/setValueForStyles/index.js
/* eslint-disable */

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * From React 16.3.0
 * 
 */

/**
 * Sets the value for multiple styles on a node.  If a value is specified as
 * '' (empty string), the corresponding style property will be unset.
 *
 * @param {DOMElement} node
 * @param {object} styles
 */

function setValueForStyles(node, styles) {
  var style = node.style;

  for (var styleName in styles) {
    if (!styles.hasOwnProperty(styleName)) {
      continue;
    }

    var isCustomProperty = styleName.indexOf('--') === 0;
    var styleValue = setValueForStyles_dangerousStyleValue(styleName, styles[styleName], isCustomProperty);

    if (styleName === 'float') {
      styleName = 'cssFloat';
    }

    if (isCustomProperty) {
      style.setProperty(styleName, styleValue);
    } else {
      style[styleName] = styleValue;
    }
  }
}

/* harmony default export */ var modules_setValueForStyles = (setValueForStyles);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/exports/UIManager/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var getRect = node => {
  // Unlike the DOM's getBoundingClientRect, React Native layout measurements
  // for "height" and "width" ignore scale transforms.
  // https://developer.mozilla.org/en-US/docs/Web/API/CSS_Object_Model/Determining_the_dimensions_of_elements
  var _getBoundingClientRec = (0,getBoundingClientRect/* default */.Z)(node),
      x = _getBoundingClientRec.x,
      y = _getBoundingClientRec.y,
      top = _getBoundingClientRec.top,
      left = _getBoundingClientRec.left;

  var width = node.offsetWidth;
  var height = node.offsetHeight;
  return {
    x,
    y,
    width,
    height,
    top,
    left
  };
};

var measureLayout = (node, relativeToNativeNode, callback) => {
  var relativeNode = relativeToNativeNode || node && node.parentNode;

  if (node && relativeNode) {
    setTimeout(() => {
      var relativeRect = (0,getBoundingClientRect/* default */.Z)(relativeNode);

      var _getRect = getRect(node),
          height = _getRect.height,
          left = _getRect.left,
          top = _getRect.top,
          width = _getRect.width;

      var x = left - relativeRect.left;
      var y = top - relativeRect.top;
      callback(x, y, width, height, left, top);
    }, 0);
  }
};

var elementsToIgnore = {
  A: true,
  BODY: true,
  INPUT: true,
  SELECT: true,
  TEXTAREA: true
};
var UIManager = {
  blur(node) {
    try {
      node.blur();
    } catch (err) {}
  },

  focus(node) {
    try {
      var name = node.nodeName; // A tabIndex of -1 allows element to be programmatically focused but
      // prevents keyboard focus. We don't want to set the tabindex value on
      // elements that should not prevent keyboard focus.

      if (node.getAttribute('tabIndex') == null && node.isContentEditable !== true && elementsToIgnore[name] == null) {
        node.setAttribute('tabIndex', '-1');
      }

      node.focus();
    } catch (err) {}
  },

  measure(node, callback) {
    measureLayout(node, null, callback);
  },

  measureInWindow(node, callback) {
    if (node) {
      setTimeout(() => {
        var _getRect2 = getRect(node),
            height = _getRect2.height,
            left = _getRect2.left,
            top = _getRect2.top,
            width = _getRect2.width;

        callback(left, top, width, height);
      }, 0);
    }
  },

  measureLayout(node, relativeToNativeNode, onFail, onSuccess) {
    measureLayout(node, relativeToNativeNode, onSuccess);
  },

  updateView(node, props) {
    for (var prop in props) {
      if (!Object.prototype.hasOwnProperty.call(props, prop)) {
        continue;
      }

      var value = props[prop];

      switch (prop) {
        case 'style':
          {
            modules_setValueForStyles(node, value);
            break;
          }

        case 'class':
        case 'className':
          {
            node.setAttribute('class', value);
            break;
          }

        case 'text':
        case 'value':
          // native platforms use `text` prop to replace text input value
          node.value = value;
          break;

        default:
          node.setAttribute(prop, value);
      }
    }
  },

  configureNextLayoutAnimation(config, onAnimationDidEnd) {
    onAnimationDidEnd();
  },

  // mocks
  setLayoutAnimationEnabledExperimental() {}

};
/* harmony default export */ var exports_UIManager = (UIManager);

/***/ }),

/***/ 25686:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31461);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _createElement__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(90601);
/* harmony import */ var _modules_forwardedProps__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30464);
/* harmony import */ var _modules_pick__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89641);
/* harmony import */ var _modules_useElementLayout__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(17709);
/* harmony import */ var _modules_useMergeRefs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(52778);
/* harmony import */ var _modules_usePlatformMethods__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5719);
/* harmony import */ var _modules_useResponderEvents__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(20011);
/* harmony import */ var _StyleSheet__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(66068);
/* harmony import */ var _Text_TextAncestorContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94210);
/* harmony import */ var _modules_useLocale__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(38639);

var _excluded = ["hrefAttrs", "onLayout", "onMoveShouldSetResponder", "onMoveShouldSetResponderCapture", "onResponderEnd", "onResponderGrant", "onResponderMove", "onResponderReject", "onResponderRelease", "onResponderStart", "onResponderTerminate", "onResponderTerminationRequest", "onScrollShouldSetResponder", "onScrollShouldSetResponderCapture", "onSelectionChangeShouldSetResponder", "onSelectionChangeShouldSetResponderCapture", "onStartShouldSetResponder", "onStartShouldSetResponderCapture"];

/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */











var forwardPropsList = Object.assign({}, _modules_forwardedProps__WEBPACK_IMPORTED_MODULE_1__/* .defaultProps */ .lG, _modules_forwardedProps__WEBPACK_IMPORTED_MODULE_1__/* .accessibilityProps */ .LO, _modules_forwardedProps__WEBPACK_IMPORTED_MODULE_1__/* .clickProps */ ._T, _modules_forwardedProps__WEBPACK_IMPORTED_MODULE_1__/* .defaultProps */ .lG, _modules_forwardedProps__WEBPACK_IMPORTED_MODULE_1__/* .accessibilityProps */ .LO, _modules_forwardedProps__WEBPACK_IMPORTED_MODULE_1__/* .clickProps */ ._T, _modules_forwardedProps__WEBPACK_IMPORTED_MODULE_1__/* .focusProps */ .YB, _modules_forwardedProps__WEBPACK_IMPORTED_MODULE_1__/* .keyboardProps */ .Uy, _modules_forwardedProps__WEBPACK_IMPORTED_MODULE_1__/* .mouseProps */ .hJ, _modules_forwardedProps__WEBPACK_IMPORTED_MODULE_1__/* .touchProps */ .E5, _modules_forwardedProps__WEBPACK_IMPORTED_MODULE_1__/* .styleProps */ .vr, {
  href: true,
  lang: true,
  onScroll: true,
  onWheel: true,
  pointerEvents: true
});

var pickProps = props => (0,_modules_pick__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props, forwardPropsList);

var View = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((props, forwardedRef) => {
  var hrefAttrs = props.hrefAttrs,
      onLayout = props.onLayout,
      onMoveShouldSetResponder = props.onMoveShouldSetResponder,
      onMoveShouldSetResponderCapture = props.onMoveShouldSetResponderCapture,
      onResponderEnd = props.onResponderEnd,
      onResponderGrant = props.onResponderGrant,
      onResponderMove = props.onResponderMove,
      onResponderReject = props.onResponderReject,
      onResponderRelease = props.onResponderRelease,
      onResponderStart = props.onResponderStart,
      onResponderTerminate = props.onResponderTerminate,
      onResponderTerminationRequest = props.onResponderTerminationRequest,
      onScrollShouldSetResponder = props.onScrollShouldSetResponder,
      onScrollShouldSetResponderCapture = props.onScrollShouldSetResponderCapture,
      onSelectionChangeShouldSetResponder = props.onSelectionChangeShouldSetResponder,
      onSelectionChangeShouldSetResponderCapture = props.onSelectionChangeShouldSetResponderCapture,
      onStartShouldSetResponder = props.onStartShouldSetResponder,
      onStartShouldSetResponderCapture = props.onStartShouldSetResponderCapture,
      rest = (0,_babel_runtime_helpers_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(props, _excluded);

  if (false) {}

  var hasTextAncestor = react__WEBPACK_IMPORTED_MODULE_0__.useContext(_Text_TextAncestorContext__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z);
  var hostRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(null);

  var _useLocaleContext = (0,_modules_useLocale__WEBPACK_IMPORTED_MODULE_5__/* .useLocaleContext */ .PE)(),
      contextDirection = _useLocaleContext.direction;

  (0,_modules_useElementLayout__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(hostRef, onLayout);
  (0,_modules_useResponderEvents__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(hostRef, {
    onMoveShouldSetResponder,
    onMoveShouldSetResponderCapture,
    onResponderEnd,
    onResponderGrant,
    onResponderMove,
    onResponderReject,
    onResponderRelease,
    onResponderStart,
    onResponderTerminate,
    onResponderTerminationRequest,
    onScrollShouldSetResponder,
    onScrollShouldSetResponderCapture,
    onSelectionChangeShouldSetResponder,
    onSelectionChangeShouldSetResponderCapture,
    onStartShouldSetResponder,
    onStartShouldSetResponderCapture
  });
  var component = 'div';
  var langDirection = props.lang != null ? (0,_modules_useLocale__WEBPACK_IMPORTED_MODULE_5__/* .getLocaleDirection */ .w1)(props.lang) : null;
  var componentDirection = props.dir || langDirection;
  var writingDirection = componentDirection || contextDirection;
  var supportedProps = pickProps(rest);
  supportedProps.dir = componentDirection;
  supportedProps.style = [styles.view$raw, hasTextAncestor && styles.inline, props.style];

  if (props.href != null) {
    component = 'a';

    if (hrefAttrs != null) {
      var download = hrefAttrs.download,
          rel = hrefAttrs.rel,
          target = hrefAttrs.target;

      if (download != null) {
        supportedProps.download = download;
      }

      if (rel != null) {
        supportedProps.rel = rel;
      }

      if (typeof target === 'string') {
        supportedProps.target = target.charAt(0) !== '_' ? '_' + target : target;
      }
    }
  }

  var platformMethodsRef = (0,_modules_usePlatformMethods__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(supportedProps);
  var setRef = (0,_modules_useMergeRefs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(hostRef, platformMethodsRef, forwardedRef);
  supportedProps.ref = setRef;
  return (0,_createElement__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(component, supportedProps, {
    writingDirection
  });
});
View.displayName = 'View';
var styles = _StyleSheet__WEBPACK_IMPORTED_MODULE_11__/* ["default"].create */ .Z.create({
  view$raw: {
    alignItems: 'stretch',
    backgroundColor: 'transparent',
    border: '0 solid black',
    boxSizing: 'border-box',
    display: 'flex',
    flexBasis: 'auto',
    flexDirection: 'column',
    flexShrink: 0,
    listStyle: 'none',
    margin: 0,
    minHeight: 0,
    minWidth: 0,
    padding: 0,
    position: 'relative',
    textDecoration: 'none',
    zIndex: 0
  },
  inline: {
    display: 'inline-flex'
  }
});
/* harmony default export */ __webpack_exports__["Z"] = (View);

/***/ }),

/***/ 44791:
/***/ (function(module) {

module.exports = worm(true)

function worm(root = false) {
  const obj = root
    ? {
        get default() {
          return worm()
        },
      }
    : function () {
        //  dev warning in debug mode
        if (false) {}

        return worm()
      }

  obj.displayName = `ProxyWorm - Check excludeReactNativeWebExports`
  obj._isProxyWorm = true

  return new Proxy(obj, {
    get(_, key) {
      if (Reflect.has(obj, key)) return Reflect.get(obj, key)
      return worm()
    },
    apply() {
      return worm()
    },
  })
}


/***/ }),

/***/ 90601:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _modules_AccessibilityUtil__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40819);
/* harmony import */ var _modules_createDOMProps__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45747);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _modules_useLocale__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38639);
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */





var createElement = (component, props, options) => {
  // Use equivalent platform elements where possible.
  var accessibilityComponent;

  if (component && component.constructor === String) {
    accessibilityComponent = _modules_AccessibilityUtil__WEBPACK_IMPORTED_MODULE_1__/* ["default"].propsToAccessibilityComponent */ .Z.propsToAccessibilityComponent(props);
  }

  var Component = accessibilityComponent || component;
  var domProps = (0,_modules_createDOMProps__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(Component, props, options);
  var element = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, domProps); // Update locale context if element's writing direction prop changes

  var elementWithLocaleProvider = domProps.dir ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_modules_useLocale__WEBPACK_IMPORTED_MODULE_3__/* .LocaleProvider */ .Iw, {
    children: element,
    direction: domProps.dir,
    locale: domProps.lang
  }) : element;
  return elementWithLocaleProvider;
};

/* harmony default export */ __webpack_exports__["Z"] = (createElement);

/***/ }),

/***/ 69150:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28316);
/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


var findNodeHandle = component => {
  var node;

  try {
    node = (0,react_dom__WEBPACK_IMPORTED_MODULE_0__.findDOMNode)(component);
  } catch (e) {}

  return node;
};

/* harmony default export */ __webpack_exports__["Z"] = (findNodeHandle);

/***/ }),

/***/ 98091:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var normalize_css_color__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89817);
/* harmony import */ var normalize_css_color__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(normalize_css_color__WEBPACK_IMPORTED_MODULE_0__);
/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


var processColor = color => {
  if (color === undefined || color === null) {
    return color;
  } // convert number and hex


  var int32Color = normalize_css_color__WEBPACK_IMPORTED_MODULE_0___default()(color);

  if (int32Color === undefined || int32Color === null) {
    return undefined;
  }

  int32Color = (int32Color << 24 | int32Color >>> 8) >>> 0;
  return int32Color;
};

/* harmony default export */ __webpack_exports__["Z"] = (processColor);

/***/ }),

/***/ 58440:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useWindowDimensions; }
/* harmony export */ });
/* harmony import */ var _Dimensions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78052);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 */




function useWindowDimensions() {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(() => _Dimensions__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get('window')),
      dims = _useState[0],
      setDims = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    function handleChange(_ref) {
      var window = _ref.window;

      if (window != null) {
        setDims(window);
      }
    }

    _Dimensions__WEBPACK_IMPORTED_MODULE_1__/* ["default"].addEventListener */ .Z.addEventListener('change', handleChange); // We might have missed an update between calling `get` in render and
    // `addEventListener` in this handler, so we set it here. If there was
    // no change, React will filter out this update as a no-op.

    setDims(_Dimensions__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get('window'));
    return () => {
      _Dimensions__WEBPACK_IMPORTED_MODULE_1__/* ["default"].removeEventListener */ .Z.removeEventListener('change', handleChange);
    };
  }, []);
  return dims;
}

/***/ }),

/***/ 22164:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "AccessibilityInfo": function() { return /* reexport */ exports_AccessibilityInfo; },
  "ActivityIndicator": function() { return /* reexport */ ActivityIndicator/* default */.Z; },
  "Alert": function() { return /* reexport */ exports_Alert; },
  "Animated": function() { return /* reexport */ Animated/* default */.Z; },
  "AppRegistry": function() { return /* reexport */ AppRegistry; },
  "AppState": function() { return /* reexport */ AppState; },
  "Appearance": function() { return /* reexport */ exports_Appearance; },
  "BackHandler": function() { return /* reexport */ exports_BackHandler; },
  "Button": function() { return /* reexport */ exports_Button; },
  "CheckBox": function() { return /* reexport */ (CheckBox_default()); },
  "Clipboard": function() { return /* reexport */ Clipboard; },
  "DeviceEventEmitter": function() { return /* reexport */ DeviceEventEmitter; },
  "DeviceInfo": function() { return /* reexport */ exports_DeviceInfo; },
  "Dimensions": function() { return /* reexport */ Dimensions/* default */.Z; },
  "DrawerLayoutAndroid": function() { return /* reexport */ DrawerLayoutAndroid; },
  "Easing": function() { return /* reexport */ Easing/* default */.Z; },
  "FlatList": function() { return /* reexport */ (FlatList_default()); },
  "I18nManager": function() { return /* reexport */ exports_I18nManager; },
  "Image": function() { return /* reexport */ Image/* default */.Z; },
  "ImageBackground": function() { return /* reexport */ exports_ImageBackground; },
  "InputAccessoryView": function() { return /* reexport */ InputAccessoryView; },
  "InteractionManager": function() { return /* reexport */ InteractionManager/* default */.Z; },
  "Keyboard": function() { return /* reexport */ Keyboard/* default */.Z; },
  "KeyboardAvoidingView": function() { return /* reexport */ exports_KeyboardAvoidingView; },
  "LayoutAnimation": function() { return /* reexport */ exports_LayoutAnimation; },
  "Linking": function() { return /* reexport */ Linking/* default */.Z; },
  "LogBox": function() { return /* reexport */ exports_LogBox; },
  "Modal": function() { return /* reexport */ exports_Modal; },
  "NativeEventEmitter": function() { return /* reexport */ exports_NativeEventEmitter; },
  "NativeModules": function() { return /* reexport */ exports_NativeModules; },
  "PanResponder": function() { return /* reexport */ PanResponder/* default */.Z; },
  "PermissionsAndroid": function() { return /* reexport */ PermissionsAndroid; },
  "Picker": function() { return /* reexport */ (Picker_default()); },
  "PixelRatio": function() { return /* reexport */ PixelRatio/* default */.Z; },
  "Platform": function() { return /* reexport */ Platform/* default */.Z; },
  "Pressable": function() { return /* reexport */ exports_Pressable; },
  "ProgressBar": function() { return /* reexport */ (ProgressBar_default()); },
  "RefreshControl": function() { return /* reexport */ exports_RefreshControl; },
  "SafeAreaView": function() { return /* reexport */ exports_SafeAreaView; },
  "ScrollView": function() { return /* reexport */ ScrollView/* default */.Z; },
  "SectionList": function() { return /* reexport */ (SectionList_default()); },
  "Settings": function() { return /* reexport */ Settings; },
  "Share": function() { return /* reexport */ exports_Share; },
  "StatusBar": function() { return /* reexport */ StatusBar/* default */.Z; },
  "StyleSheet": function() { return /* reexport */ StyleSheet/* default */.Z; },
  "Switch": function() { return /* reexport */ (Switch_default()); },
  "Systrace": function() { return /* reexport */ Systrace; },
  "TVEventHandler": function() { return /* reexport */ TVEventHandler; },
  "Text": function() { return /* reexport */ Text/* default */.Z; },
  "TextInput": function() { return /* reexport */ TextInput/* default */.Z; },
  "ToastAndroid": function() { return /* reexport */ ToastAndroid; },
  "Touchable": function() { return /* reexport */ (Touchable_default()); },
  "TouchableHighlight": function() { return /* reexport */ (TouchableHighlight_default()); },
  "TouchableNativeFeedback": function() { return /* reexport */ (TouchableNativeFeedback_default()); },
  "TouchableOpacity": function() { return /* reexport */ (TouchableOpacity_default()); },
  "TouchableWithoutFeedback": function() { return /* reexport */ (TouchableWithoutFeedback_default()); },
  "UIManager": function() { return /* reexport */ UIManager/* default */.Z; },
  "Vibration": function() { return /* reexport */ exports_Vibration; },
  "View": function() { return /* reexport */ View/* default */.Z; },
  "VirtualizedList": function() { return /* reexport */ (VirtualizedList_default()); },
  "YellowBox": function() { return /* reexport */ exports_YellowBox; },
  "findNodeHandle": function() { return /* reexport */ findNodeHandle/* default */.Z; },
  "processColor": function() { return /* reexport */ processColor/* default */.Z; },
  "render": function() { return /* reexport */ render; },
  "unmountComponentAtNode": function() { return /* reexport */ unmountComponentAtNode; },
  "unstable_createElement": function() { return /* reexport */ createElement/* default */.Z; },
  "useColorScheme": function() { return /* reexport */ useColorScheme; },
  "useLocaleContext": function() { return /* reexport */ useLocaleContext; },
  "useWindowDimensions": function() { return /* reexport */ useWindowDimensions/* default */.Z; }
});

// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/exports/createElement/index.js
var createElement = __webpack_require__(90601);
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/exports/findNodeHandle/index.js
var findNodeHandle = __webpack_require__(69150);
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/exports/processColor/index.js
var processColor = __webpack_require__(98091);
// EXTERNAL MODULE: ../../node_modules/react-dom/index.js
var react_dom = __webpack_require__(28316);
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/exports/StyleSheet/dom/index.js + 2 modules
var dom = __webpack_require__(67410);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/exports/render/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


function hydrate(element, root, callback) {
  (0,dom/* createSheet */.S)(root);
  return (0,react_dom.hydrate)(element, root, callback);
}
function render(element, root, callback) {
  (0,dom/* createSheet */.S)(root);
  return (0,react_dom.render)(element, root, callback);
}
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/exports/unmountComponentAtNode/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

/* harmony default export */ var unmountComponentAtNode = (react_dom.unmountComponentAtNode);
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/exports/UIManager/index.js + 3 modules
var UIManager = __webpack_require__(96187);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/exports/NativeModules/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */
 // NativeModules shim

var NativeModules = {
  UIManager: UIManager/* default */.Z
};
/* harmony default export */ var exports_NativeModules = (NativeModules);
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/modules/canUseDom/index.js
var canUseDom = __webpack_require__(19017);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/exports/AccessibilityInfo/index.js
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


function isScreenReaderEnabled() {
  return new Promise((resolve, reject) => {
    resolve(true);
  });
}

var prefersReducedMotionMedia = canUseDom/* default */.Z && typeof window.matchMedia === 'function' ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

function isReduceMotionEnabled() {
  return new Promise((resolve, reject) => {
    resolve(prefersReducedMotionMedia ? prefersReducedMotionMedia.matches : true);
  });
}

function addChangeListener(fn) {
  if (prefersReducedMotionMedia != null) {
    prefersReducedMotionMedia.addEventListener != null ? prefersReducedMotionMedia.addEventListener('change', fn) : prefersReducedMotionMedia.addListener(fn);
  }
}

function removeChangeListener(fn) {
  if (prefersReducedMotionMedia != null) {
    prefersReducedMotionMedia.removeEventListener != null ? prefersReducedMotionMedia.removeEventListener('change', fn) : prefersReducedMotionMedia.removeListener(fn);
  }
}

var handlers = {};
var AccessibilityInfo = {
  /**
   * Query whether a screen reader is currently enabled.
   *
   * Returns a promise which resolves to a boolean.
   * The result is `true` when a screen reader is enabled and `false` otherwise.
   */
  isScreenReaderEnabled,

  /**
   * Query whether the user prefers reduced motion.
   *
   * Returns a promise which resolves to a boolean.
   * The result is `true` when a screen reader is enabled and `false` otherwise.
   */
  isReduceMotionEnabled,

  /**
   * Deprecated
   */
  fetch: isScreenReaderEnabled,

  /**
   * Add an event handler. Supported events: reduceMotionChanged
   */
  addEventListener: function addEventListener(eventName, handler) {
    if (eventName === 'reduceMotionChanged') {
      if (!prefersReducedMotionMedia) {
        return;
      }

      var listener = event => {
        handler(event.matches);
      };

      addChangeListener(listener);
      handlers[handler] = listener;
    }

    return {
      remove: () => AccessibilityInfo.removeEventListener(eventName, handler)
    };
  },

  /**
   * Set accessibility focus to a react component.
   */
  setAccessibilityFocus: function setAccessibilityFocus(reactTag) {},

  /**
   * Post a string to be announced by the screen reader.
   */
  announceForAccessibility: function announceForAccessibility(announcement) {},

  /**
   * Remove an event handler.
   */
  removeEventListener: function removeEventListener(eventName, handler) {
    if (eventName === 'reduceMotionChanged') {
      var listener = handlers[handler];

      if (!listener || !prefersReducedMotionMedia) {
        return;
      }

      removeChangeListener(listener);
    }

    return;
  }
};
/* harmony default export */ var exports_AccessibilityInfo = (AccessibilityInfo);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/exports/Alert/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */
class Alert {
  static alert() {}

}

/* harmony default export */ var exports_Alert = (Alert);
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/exports/Animated/index.js + 37 modules
var Animated = __webpack_require__(48923);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/exports/Appearance/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


function getQuery() {
  return canUseDom/* default */.Z && window.matchMedia != null ? window.matchMedia('(prefers-color-scheme: dark)') : null;
}

var query = getQuery();
var listenerMapping = new WeakMap();
var Appearance = {
  getColorScheme() {
    return query && query.matches ? 'dark' : 'light';
  },

  addChangeListener(listener) {
    var mappedListener = listenerMapping.get(listener);

    if (!mappedListener) {
      mappedListener = _ref => {
        var matches = _ref.matches;
        listener({
          colorScheme: matches ? 'dark' : 'light'
        });
      };

      listenerMapping.set(listener, mappedListener);
    }

    if (query) {
      query.addListener(mappedListener);
    }

    function remove() {
      var mappedListener = listenerMapping.get(listener);

      if (query && mappedListener) {
        query.removeListener(mappedListener);
      }

      listenerMapping.delete(listener);
    }

    return {
      remove
    };
  }

};
/* harmony default export */ var exports_Appearance = (Appearance);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectSpread2.js + 4 modules
var objectSpread2 = __webpack_require__(29405);
// EXTERNAL MODULE: ../../node_modules/fbjs/lib/invariant.js
var invariant = __webpack_require__(14983);
var invariant_default = /*#__PURE__*/__webpack_require__.n(invariant);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/exports/StyleSheet/index.js + 6 modules
var StyleSheet = __webpack_require__(66068);
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/exports/View/index.js
var View = __webpack_require__(25686);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/exports/AppRegistry/AppContainer.js
/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var RootTagContext = /*#__PURE__*/react.createContext(null);
function AppContainer(props) {
  var children = props.children,
      WrapperComponent = props.WrapperComponent;
  var innerView = /*#__PURE__*/react.createElement(View/* default */.Z, {
    children: children,
    key: 1,
    pointerEvents: "box-none",
    style: styles.appContainer
  });

  if (WrapperComponent) {
    innerView = /*#__PURE__*/react.createElement(WrapperComponent, null, innerView);
  }

  return /*#__PURE__*/react.createElement(RootTagContext.Provider, {
    value: props.rootTag
  }, /*#__PURE__*/react.createElement(View/* default */.Z, {
    pointerEvents: "box-none",
    style: styles.appContainer
  }, innerView));
}
var styles = StyleSheet/* default.create */.Z.create({
  appContainer: {
    flex: 1
  }
});
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/exports/AppRegistry/renderApplication.js


/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */





function renderApplication(RootComponent, WrapperComponent, callback, options) {
  var shouldHydrate = options.hydrate,
      initialProps = options.initialProps,
      rootTag = options.rootTag;
  var renderFn = shouldHydrate ? hydrate : render;
  invariant_default()(rootTag, 'Expect to have a valid rootTag, instead got ', rootTag);
  renderFn( /*#__PURE__*/react.createElement(AppContainer, {
    WrapperComponent: WrapperComponent,
    rootTag: rootTag
  }, /*#__PURE__*/react.createElement(RootComponent, initialProps)), rootTag, callback);
}
function getApplication(RootComponent, initialProps, WrapperComponent) {
  var element = /*#__PURE__*/react.createElement(AppContainer, {
    WrapperComponent: WrapperComponent,
    rootTag: {}
  }, /*#__PURE__*/react.createElement(RootComponent, initialProps)); // Don't escape CSS text

  var getStyleElement = props => {
    var sheet = StyleSheet/* default.getSheet */.Z.getSheet();
    return /*#__PURE__*/react.createElement("style", (0,esm_extends/* default */.Z)({}, props, {
      dangerouslySetInnerHTML: {
        __html: sheet.textContent
      },
      id: sheet.id
    }));
  };

  return {
    element,
    getStyleElement
  };
}
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/exports/AppRegistry/index.js


/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var emptyObject = {};
var runnables = {};

var componentProviderInstrumentationHook = component => component();

var wrapperComponentProvider;
/**
 * `AppRegistry` is the JS entry point to running all React Native apps.
 */

class AppRegistry {
  static getAppKeys() {
    return Object.keys(runnables);
  }

  static getApplication(appKey, appParameters) {
    invariant_default()(runnables[appKey] && runnables[appKey].getApplication, "Application " + appKey + " has not been registered. " + 'This is either due to an import error during initialization or failure to call AppRegistry.registerComponent.');
    return runnables[appKey].getApplication(appParameters);
  }

  static registerComponent(appKey, componentProvider) {
    runnables[appKey] = {
      getApplication: appParameters => getApplication(componentProviderInstrumentationHook(componentProvider), appParameters ? appParameters.initialProps : emptyObject, wrapperComponentProvider && wrapperComponentProvider(appParameters)),
      run: appParameters => renderApplication(componentProviderInstrumentationHook(componentProvider), wrapperComponentProvider && wrapperComponentProvider(appParameters), appParameters.callback, {
        hydrate: appParameters.hydrate || false,
        initialProps: appParameters.initialProps || emptyObject,
        rootTag: appParameters.rootTag
      })
    };
    return appKey;
  }

  static registerConfig(config) {
    config.forEach(_ref => {
      var appKey = _ref.appKey,
          component = _ref.component,
          run = _ref.run;

      if (run) {
        AppRegistry.registerRunnable(appKey, run);
      } else {
        invariant_default()(component, 'No component provider passed in');
        AppRegistry.registerComponent(appKey, component);
      }
    });
  } // TODO: fix style sheet creation when using this method


  static registerRunnable(appKey, run) {
    runnables[appKey] = {
      run
    };
    return appKey;
  }

  static runApplication(appKey, appParameters) {
    var isDevelopment =  false && 0;

    if (isDevelopment) {
      var params = (0,objectSpread2/* default */.Z)({}, appParameters);

      params.rootTag = "#" + params.rootTag.id;
      console.log("Running application \"" + appKey + "\" with appParams:\n", params, "\nDevelopment-level warnings: " + (isDevelopment ? 'ON' : 'OFF') + "." + ("\nPerformance optimizations: " + (isDevelopment ? 'OFF' : 'ON') + "."));
    }

    invariant_default()(runnables[appKey] && runnables[appKey].run, "Application \"" + appKey + "\" has not been registered. " + 'This is either due to an import error during initialization or failure to call AppRegistry.registerComponent.');
    runnables[appKey].run(appParameters);
  }

  static setComponentProviderInstrumentationHook(hook) {
    componentProviderInstrumentationHook = hook;
  }

  static setWrapperComponentProvider(provider) {
    wrapperComponentProvider = provider;
  }

  static unmountApplicationComponentAtRootTag(rootTag) {
    unmountComponentAtNode(rootTag);
  }

}
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/vendor/react-native/emitter/_EventEmitter.js + 3 modules
var _EventEmitter = __webpack_require__(39269);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/exports/AppState/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


 // Android 4.4 browser

var isPrefixed = canUseDom/* default */.Z && !document.hasOwnProperty('hidden') && document.hasOwnProperty('webkitHidden');
var EVENT_TYPES = ['change', 'memoryWarning'];
var VISIBILITY_CHANGE_EVENT = isPrefixed ? 'webkitvisibilitychange' : 'visibilitychange';
var VISIBILITY_STATE_PROPERTY = isPrefixed ? 'webkitVisibilityState' : 'visibilityState';
var AppStates = {
  BACKGROUND: 'background',
  ACTIVE: 'active'
};
var changeEmitter = null;
class AppState {
  static get currentState() {
    if (!AppState.isAvailable) {
      return AppStates.ACTIVE;
    }

    switch (document[VISIBILITY_STATE_PROPERTY]) {
      case 'hidden':
      case 'prerender':
      case 'unloaded':
        return AppStates.BACKGROUND;

      default:
        return AppStates.ACTIVE;
    }
  }

  static addEventListener(type, handler) {
    if (AppState.isAvailable) {
      invariant_default()(EVENT_TYPES.indexOf(type) !== -1, 'Trying to subscribe to unknown event: "%s"', type);

      if (type === 'change') {
        if (!changeEmitter) {
          changeEmitter = new _EventEmitter/* default */.Z();
          document.addEventListener(VISIBILITY_CHANGE_EVENT, () => {
            if (changeEmitter) {
              changeEmitter.emit('change', AppState.currentState);
            }
          }, false);
        }

        return changeEmitter.addListener(type, handler);
      }
    }
  }

  static removeEventListener(type, handler) {
    if (AppState.isAvailable) {
      console.error("AppState.removeListener('" + type + "', ...): Method has been " + 'deprecated. Please instead use `remove()` on the subscription ' + 'returned by `AppState.addEventListener`.');
      invariant_default()(EVENT_TYPES.indexOf(type) !== -1, 'Trying to remove listener for unknown event: "%s"', type);

      if (type === 'change' && changeEmitter) {
        changeEmitter.removeListener(handler);
      }
    }
  }

}
AppState.isAvailable = canUseDom/* default */.Z && document[VISIBILITY_STATE_PROPERTY];
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/exports/BackHandler/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */
function emptyFunction() {}

var BackHandler = {
  exitApp: emptyFunction,

  addEventListener() {
    return {
      remove: emptyFunction
    };
  },

  removeEventListener: emptyFunction
};
/* harmony default export */ var exports_BackHandler = (BackHandler);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/exports/Clipboard/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */
var clipboardAvailable;
class Clipboard {
  static isAvailable() {
    if (clipboardAvailable === undefined) {
      clipboardAvailable = typeof document.queryCommandSupported === 'function' && document.queryCommandSupported('copy');
    }

    return clipboardAvailable;
  }

  static getString() {
    return Promise.resolve('');
  }

  static setString(text) {
    var success = false;
    var body = document.body;

    if (body) {
      // add the text to a hidden node
      var node = document.createElement('span');
      node.textContent = text;
      node.style.opacity = '0';
      node.style.position = 'absolute';
      node.style.whiteSpace = 'pre-wrap';
      node.style.userSelect = 'auto';
      body.appendChild(node); // select the text

      var selection = window.getSelection();
      selection.removeAllRanges();
      var range = document.createRange();
      range.selectNodeContents(node);
      selection.addRange(range); // attempt to copy

      try {
        document.execCommand('copy');
        success = true;
      } catch (e) {} // remove selection and node


      selection.removeAllRanges();
      body.removeChild(node);
    }

    return success;
  }

}
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/exports/Dimensions/index.js
var Dimensions = __webpack_require__(78052);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/exports/DeviceInfo/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


var DeviceInfo = {
  Dimensions: {
    get windowPhysicalPixels() {
      var _Dimensions$get = Dimensions/* default.get */.Z.get('window'),
          width = _Dimensions$get.width,
          height = _Dimensions$get.height,
          fontScale = _Dimensions$get.fontScale,
          scale = _Dimensions$get.scale;

      return {
        width: width * scale,
        height: height * scale,
        scale,
        fontScale
      };
    },

    get screenPhysicalPixels() {
      var _Dimensions$get2 = Dimensions/* default.get */.Z.get('screen'),
          width = _Dimensions$get2.width,
          height = _Dimensions$get2.height,
          fontScale = _Dimensions$get2.fontScale,
          scale = _Dimensions$get2.scale;

      return {
        width: width * scale,
        height: height * scale,
        scale,
        fontScale
      };
    }

  },

  get locale() {
    if (canUseDom/* default */.Z) {
      if (navigator.languages) {
        return navigator.languages[0];
      } else {
        return navigator.language;
      }
    }
  },

  get totalMemory() {
    // $FlowIssue deviceMemory not defined in navigator
    return canUseDom/* default */.Z ? navigator.deviceMemory : undefined;
  },

  get userAgent() {
    return canUseDom/* default */.Z ? navigator.userAgent : '';
  }

};
/* harmony default export */ var exports_DeviceInfo = (DeviceInfo);
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/exports/Easing/index.js + 2 modules
var Easing = __webpack_require__(25166);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/exports/I18nManager/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */
var I18nManager = {
  allowRTL() {
    return;
  },

  forceRTL() {
    return;
  },

  getConstants() {
    return {
      isRTL: false
    };
  }

};
/* harmony default export */ var exports_I18nManager = (I18nManager);
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/exports/Keyboard/index.js
var Keyboard = __webpack_require__(30024);
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/exports/InteractionManager/index.js + 1 modules
var InteractionManager = __webpack_require__(74984);
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/exports/Platform/index.js
var Platform = __webpack_require__(33229);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/vendor/react-native/LayoutAnimation/index.js
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */





var __DEV__ = (/* unused pure expression or super */ null && ("production" !== 'production'));

function configureNext(config, onAnimationDidEnd) {
  if (!Platform/* default.isTesting */.Z.isTesting) {
    UIManager/* default.configureNextLayoutAnimation */.Z.configureNextLayoutAnimation(config, onAnimationDidEnd !== null && onAnimationDidEnd !== void 0 ? onAnimationDidEnd : function () {}, function () {}
    /* unused onError */
    );
  }
}

function create(duration, type, property) {
  return {
    duration,
    create: {
      type,
      property
    },
    update: {
      type
    },
    delete: {
      type,
      property
    }
  };
}

var Presets = {
  easeInEaseOut: create(300, 'easeInEaseOut', 'opacity'),
  linear: create(500, 'linear', 'opacity'),
  spring: {
    duration: 700,
    create: {
      type: 'linear',
      property: 'opacity'
    },
    update: {
      type: 'spring',
      springDamping: 0.4
    },
    delete: {
      type: 'linear',
      property: 'opacity'
    }
  }
};
/**
 * Automatically animates views to their new positions when the
 * next layout happens.
 *
 * A common way to use this API is to call it before calling `setState`.
 *
 * Note that in order to get this to work on **Android** you need to set the following flags via `UIManager`:
 *
 *     UIManager.setLayoutAnimationEnabledExperimental && UIManager.setLayoutAnimationEnabledExperimental(true);
 */

var LayoutAnimation = {
  /**
   * Schedules an animation to happen on the next layout.
   *
   * @param config Specifies animation properties:
   *
   *   - `duration` in milliseconds
   *   - `create`, `AnimationConfig` for animating in new views
   *   - `update`, `AnimationConfig` for animating views that have been updated
   *
   * @param onAnimationDidEnd Called when the animation finished.
   * Only supported on iOS.
   * @param onError Called on error. Only supported on iOS.
   */
  configureNext,

  /**
   * Helper for creating a config for `configureNext`.
   */
  create,
  Types: Object.freeze({
    spring: 'spring',
    linear: 'linear',
    easeInEaseOut: 'easeInEaseOut',
    easeIn: 'easeIn',
    easeOut: 'easeOut',
    keyboard: 'keyboard'
  }),
  Properties: Object.freeze({
    opacity: 'opacity',
    scaleX: 'scaleX',
    scaleY: 'scaleY',
    scaleXY: 'scaleXY'
  }),

  checkConfig() {
    console.error('LayoutAnimation.checkConfig(...) has been disabled.');
  },

  Presets,
  easeInEaseOut: configureNext.bind(null, Presets.easeInEaseOut),
  linear: configureNext.bind(null, Presets.linear),
  spring: configureNext.bind(null, Presets.spring)
};
/* harmony default export */ var react_native_LayoutAnimation = (LayoutAnimation);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/exports/LayoutAnimation/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

/* harmony default export */ var exports_LayoutAnimation = (react_native_LayoutAnimation);
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/exports/Linking/index.js
var Linking = __webpack_require__(62460);
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/vendor/react-native/NativeEventEmitter/index.js
var NativeEventEmitter = __webpack_require__(2643);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/exports/NativeEventEmitter/index.js
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

/* harmony default export */ var exports_NativeEventEmitter = (NativeEventEmitter/* default */.Z);
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/exports/PanResponder/index.js + 2 modules
var PanResponder = __webpack_require__(56149);
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/exports/PixelRatio/index.js
var PixelRatio = __webpack_require__(72016);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/exports/Share/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


class Share {
  static share(content, options) {
    if (options === void 0) {
      options = {};
    }

    invariant_default()(typeof content === 'object' && content !== null, 'Content to share must be a valid object');
    invariant_default()(typeof content.url === 'string' || typeof content.message === 'string', 'At least one of URL and message is required');
    invariant_default()(typeof options === 'object' && options !== null, 'Options must be a valid object');
    invariant_default()(!content.title || typeof content.title === 'string', 'Invalid title: title should be a string.');

    if (window.navigator.share !== undefined) {
      return window.navigator.share({
        title: content.title,
        text: content.message,
        url: content.url
      });
    } else {
      return Promise.reject(new Error('Share is not supported in this browser'));
    }
  }
  /**
   * The content was successfully shared.
   */


  static get sharedAction() {
    return 'sharedAction';
  }
  /**
   * The dialog has been dismissed.
   * @platform ios
   */


  static get dismissedAction() {
    return 'dismissedAction';
  }

}

/* harmony default export */ var exports_Share = (Share);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/exports/Vibration/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */
var vibrate = pattern => {
  if ('vibrate' in window.navigator) {
    window.navigator.vibrate(pattern);
  }
};

var Vibration = {
  cancel() {
    vibrate(0);
  },

  vibrate(pattern) {
    if (pattern === void 0) {
      pattern = 400;
    }

    vibrate(pattern);
  }

};
/* harmony default export */ var exports_Vibration = (Vibration);
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/exports/ActivityIndicator/index.js
var ActivityIndicator = __webpack_require__(25825);
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/exports/TouchableOpacity/index.js
var TouchableOpacity = __webpack_require__(6307);
var TouchableOpacity_default = /*#__PURE__*/__webpack_require__.n(TouchableOpacity);
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/exports/Text/index.js
var Text = __webpack_require__(66999);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/exports/Button/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */




var Button = /*#__PURE__*/react.forwardRef((props, forwardedRef) => {
  var accessibilityLabel = props.accessibilityLabel,
      color = props.color,
      disabled = props.disabled,
      onPress = props.onPress,
      testID = props.testID,
      title = props.title;
  return /*#__PURE__*/react.createElement((TouchableOpacity_default()), {
    accessibilityLabel: accessibilityLabel,
    accessibilityRole: "button",
    disabled: disabled,
    focusable: !disabled,
    onPress: onPress,
    ref: forwardedRef,
    style: [Button_styles.button, color && {
      backgroundColor: color
    }, disabled && Button_styles.buttonDisabled],
    testID: testID
  }, /*#__PURE__*/react.createElement(Text/* default */.Z, {
    style: [Button_styles.text, disabled && Button_styles.textDisabled]
  }, title));
});
Button.displayName = 'Button';
var Button_styles = StyleSheet/* default.create */.Z.create({
  button: {
    backgroundColor: '#2196F3',
    borderRadius: 2
  },
  text: {
    color: '#fff',
    fontWeight: '500',
    padding: 8,
    textAlign: 'center',
    textTransform: 'uppercase'
  },
  buttonDisabled: {
    backgroundColor: '#dfdfdf'
  },
  textDisabled: {
    color: '#a1a1a1'
  }
});
/* harmony default export */ var exports_Button = (Button);
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/exports/CheckBox/index.js
var CheckBox = __webpack_require__(44345);
var CheckBox_default = /*#__PURE__*/__webpack_require__.n(CheckBox);
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/exports/FlatList/index.js
var FlatList = __webpack_require__(55874);
var FlatList_default = /*#__PURE__*/__webpack_require__.n(FlatList);
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/exports/Image/index.js + 2 modules
var Image = __webpack_require__(79470);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/exports/ImageBackground/index.js


var _excluded = ["children", "style", "imageStyle", "imageRef"];

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */





var ImageBackground_emptyObject = {};
/**
 * Very simple drop-in replacement for <Image> which supports nesting views.
 */

var ImageBackground = /*#__PURE__*/(0,react.forwardRef)((props, forwardedRef) => {
  var children = props.children,
      _props$style = props.style,
      style = _props$style === void 0 ? ImageBackground_emptyObject : _props$style,
      imageStyle = props.imageStyle,
      imageRef = props.imageRef,
      rest = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);

  var _StyleSheet$flatten = StyleSheet/* default.flatten */.Z.flatten(style),
      height = _StyleSheet$flatten.height,
      width = _StyleSheet$flatten.width;

  return /*#__PURE__*/react.createElement(View/* default */.Z, {
    ref: forwardedRef,
    style: style
  }, /*#__PURE__*/react.createElement(Image/* default */.Z, (0,esm_extends/* default */.Z)({}, rest, {
    ref: imageRef,
    style: [{
      // Temporary Workaround:
      // Current (imperfect yet) implementation of <Image> overwrites width and height styles
      // (which is not quite correct), and these styles conflict with explicitly set styles
      // of <ImageBackground> and with our internal layout model here.
      // So, we have to proxy/reapply these styles explicitly for actual <Image> component.
      // This workaround should be removed after implementing proper support of
      // intrinsic content size of the <Image>.
      width,
      height,
      zIndex: -1
    }, StyleSheet/* default.absoluteFill */.Z.absoluteFill, imageStyle]
  })), children);
});
ImageBackground.displayName = 'ImageBackground';
/* harmony default export */ var exports_ImageBackground = (ImageBackground);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/exports/KeyboardAvoidingView/index.js


var KeyboardAvoidingView_excluded = ["behavior", "contentContainerStyle", "keyboardVerticalOffset"];

/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



class KeyboardAvoidingView extends react.Component {
  constructor() {
    super(...arguments);
    this.frame = null;

    this.onLayout = event => {
      this.frame = event.nativeEvent.layout;
    };
  }

  relativeKeyboardHeight(keyboardFrame) {
    var frame = this.frame;

    if (!frame || !keyboardFrame) {
      return 0;
    }

    var keyboardY = keyboardFrame.screenY - (this.props.keyboardVerticalOffset || 0);
    return Math.max(frame.y + frame.height - keyboardY, 0);
  }

  onKeyboardChange(event) {}

  render() {
    var _this$props = this.props,
        behavior = _this$props.behavior,
        contentContainerStyle = _this$props.contentContainerStyle,
        keyboardVerticalOffset = _this$props.keyboardVerticalOffset,
        rest = (0,objectWithoutPropertiesLoose/* default */.Z)(_this$props, KeyboardAvoidingView_excluded);

    return /*#__PURE__*/react.createElement(View/* default */.Z, (0,esm_extends/* default */.Z)({
      onLayout: this.onLayout
    }, rest));
  }

}

/* harmony default export */ var exports_KeyboardAvoidingView = (KeyboardAvoidingView);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/exports/Modal/ModalPortal.js
/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */




function ModalPortal(props) {
  var children = props.children;
  var elementRef = react.useRef(null);

  if (canUseDom/* default */.Z && !elementRef.current) {
    var element = document.createElement('div');

    if (element && document.body) {
      document.body.appendChild(element);
      elementRef.current = element;
    }
  }

  react.useEffect(() => {
    if (canUseDom/* default */.Z) {
      return () => {
        if (document.body && elementRef.current) {
          document.body.removeChild(elementRef.current);
          elementRef.current = null;
        }
      };
    }
  }, []);
  return elementRef.current && canUseDom/* default */.Z ? /*#__PURE__*/react_dom.createPortal(children, elementRef.current) : null;
}

/* harmony default export */ var Modal_ModalPortal = (ModalPortal);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/exports/Modal/ModalAnimation.js
/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var ANIMATION_DURATION = 300;

function getAnimationStyle(animationType, visible) {
  if (animationType === 'slide') {
    return visible ? animatedSlideInStyles : animatedSlideOutStyles;
  }

  if (animationType === 'fade') {
    return visible ? animatedFadeInStyles : animatedFadeOutStyles;
  }

  return visible ? ModalAnimation_styles.container : ModalAnimation_styles.hidden;
}

function ModalAnimation(props) {
  var animationType = props.animationType,
      children = props.children,
      onDismiss = props.onDismiss,
      onShow = props.onShow,
      visible = props.visible;

  var _React$useState = react.useState(false),
      isRendering = _React$useState[0],
      setIsRendering = _React$useState[1];

  var wasVisible = react.useRef(false);
  var isAnimated = animationType && animationType !== 'none';
  var animationEndCallback = react.useCallback(e => {
    if (e && e.currentTarget !== e.target) {
      // If the event was generated for something NOT this element we
      // should ignore it as it's not relevant to us
      return;
    }

    if (visible) {
      if (onShow) {
        onShow();
      }
    } else {
      setIsRendering(false);

      if (onDismiss) {
        onDismiss();
      }
    }
  }, [onDismiss, onShow, visible]);
  react.useEffect(() => {
    if (visible) {
      setIsRendering(true);
    }

    if (visible !== wasVisible.current && !isAnimated) {
      // Manually call `animationEndCallback` if no animation is used
      animationEndCallback();
    }

    wasVisible.current = visible;
  }, [isAnimated, visible, animationEndCallback]);
  return isRendering || visible ? (0,createElement/* default */.Z)('div', {
    style: isRendering ? getAnimationStyle(animationType, visible) : ModalAnimation_styles.hidden,
    onAnimationEnd: animationEndCallback,
    children
  }) : null;
}

var ModalAnimation_styles = StyleSheet/* default.create */.Z.create({
  container: {
    position: 'fixed',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    zIndex: 9999
  },
  animatedIn: {
    animationDuration: ANIMATION_DURATION + "ms",
    animationTimingFunction: 'ease-in'
  },
  animatedOut: {
    pointerEvents: 'none',
    animationDuration: ANIMATION_DURATION + "ms",
    animationTimingFunction: 'ease-out'
  },
  fadeIn: {
    opacity: 1,
    animationKeyframes: {
      '0%': {
        opacity: 0
      },
      '100%': {
        opacity: 1
      }
    }
  },
  fadeOut: {
    opacity: 0,
    animationKeyframes: {
      '0%': {
        opacity: 1
      },
      '100%': {
        opacity: 0
      }
    }
  },
  slideIn: {
    transform: [{
      translateY: '0%'
    }],
    animationKeyframes: {
      '0%': {
        transform: [{
          translateY: '100%'
        }]
      },
      '100%': {
        transform: [{
          translateY: '0%'
        }]
      }
    }
  },
  slideOut: {
    transform: [{
      translateY: '100%'
    }],
    animationKeyframes: {
      '0%': {
        transform: [{
          translateY: '0%'
        }]
      },
      '100%': {
        transform: [{
          translateY: '100%'
        }]
      }
    }
  },
  hidden: {
    opacity: 0
  }
});
var animatedSlideInStyles = [ModalAnimation_styles.container, ModalAnimation_styles.animatedIn, ModalAnimation_styles.slideIn];
var animatedSlideOutStyles = [ModalAnimation_styles.container, ModalAnimation_styles.animatedOut, ModalAnimation_styles.slideOut];
var animatedFadeInStyles = [ModalAnimation_styles.container, ModalAnimation_styles.animatedIn, ModalAnimation_styles.fadeIn];
var animatedFadeOutStyles = [ModalAnimation_styles.container, ModalAnimation_styles.animatedOut, ModalAnimation_styles.fadeOut];
/* harmony default export */ var Modal_ModalAnimation = (ModalAnimation);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/exports/Modal/ModalContent.js


var ModalContent_excluded = ["active", "children", "onRequestClose", "transparent"];

/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */




var ModalContent = /*#__PURE__*/react.forwardRef((props, forwardedRef) => {
  var active = props.active,
      children = props.children,
      onRequestClose = props.onRequestClose,
      transparent = props.transparent,
      rest = (0,objectWithoutPropertiesLoose/* default */.Z)(props, ModalContent_excluded);

  react.useEffect(() => {
    if (canUseDom/* default */.Z) {
      var closeOnEscape = e => {
        if (active && e.key === 'Escape') {
          e.stopPropagation();

          if (onRequestClose) {
            onRequestClose();
          }
        }
      };

      document.addEventListener('keyup', closeOnEscape, false);
      return () => document.removeEventListener('keyup', closeOnEscape, false);
    }
  }, [active, onRequestClose]);
  var style = react.useMemo(() => {
    return [ModalContent_styles.modal, transparent ? ModalContent_styles.modalTransparent : ModalContent_styles.modalOpaque];
  }, [transparent]);
  return /*#__PURE__*/react.createElement(View/* default */.Z, (0,esm_extends/* default */.Z)({}, rest, {
    accessibilityModal: true,
    accessibilityRole: active ? 'dialog' : null,
    ref: forwardedRef,
    style: style
  }), /*#__PURE__*/react.createElement(View/* default */.Z, {
    style: ModalContent_styles.container
  }, children));
});
var ModalContent_styles = StyleSheet/* default.create */.Z.create({
  modal: {
    position: 'fixed',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  },
  modalTransparent: {
    backgroundColor: 'transparent'
  },
  modalOpaque: {
    backgroundColor: 'white'
  },
  container: {
    top: 0,
    flex: 1
  }
});
/* harmony default export */ var Modal_ModalContent = (ModalContent);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/exports/Modal/ModalFocusTrap.js
/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */






/**
 * This Component is used to "wrap" the modal we're opening
 * so that changing focus via tab will never leave the document.
 *
 * This allows us to properly trap the focus within a modal
 * even if the modal is at the start or end of a document.
 */

var FocusBracket = () => {
  return (0,createElement/* default */.Z)('div', {
    accessibilityRole: 'none',
    tabIndex: 0,
    style: ModalFocusTrap_styles.focusBracket
  });
};

function attemptFocus(element) {
  if (!canUseDom/* default */.Z) {
    return false;
  }

  try {
    element.focus();
  } catch (e) {// Do nothing
  }

  return document.activeElement === element;
}

function focusFirstDescendant(element) {
  for (var i = 0; i < element.childNodes.length; i++) {
    var child = element.childNodes[i];

    if (attemptFocus(child) || focusFirstDescendant(child)) {
      return true;
    }
  }

  return false;
}

function focusLastDescendant(element) {
  for (var i = element.childNodes.length - 1; i >= 0; i--) {
    var child = element.childNodes[i];

    if (attemptFocus(child) || focusLastDescendant(child)) {
      return true;
    }
  }

  return false;
}

var ModalFocusTrap = _ref => {
  var active = _ref.active,
      children = _ref.children;
  var trapElementRef = react.useRef();
  var focusRef = react.useRef({
    trapFocusInProgress: false,
    lastFocusedElement: null
  });
  react.useEffect(() => {
    if (canUseDom/* default */.Z) {
      var trapFocus = () => {
        // We should not trap focus if:
        // - The modal hasn't fully initialized with an HTMLElement ref
        // - Focus is already in the process of being trapped (e.g., we're refocusing)
        // - isTrapActive prop being falsey tells us to do nothing
        if (trapElementRef.current == null || focusRef.current.trapFocusInProgress || !active) {
          return;
        }

        try {
          focusRef.current.trapFocusInProgress = true;

          if (document.activeElement instanceof Node && !trapElementRef.current.contains(document.activeElement)) {
            // To handle keyboard focusing we can make an assumption here.
            // If you're tabbing through the focusable elements, the previously
            // active element will either be the first or the last.
            // If the previously selected element is the "first" descendant
            // and we're leaving it - this means that we should be looping
            // around to the other side of the modal.
            var hasFocused = focusFirstDescendant(trapElementRef.current);

            if (focusRef.current.lastFocusedElement === document.activeElement) {
              hasFocused = focusLastDescendant(trapElementRef.current);
            } // If we couldn't focus a new element then we need to focus onto the trap target


            if (!hasFocused && trapElementRef.current != null && document.activeElement) {
              UIManager/* default.focus */.Z.focus(trapElementRef.current);
            }
          }
        } finally {
          focusRef.current.trapFocusInProgress = false;
        }

        focusRef.current.lastFocusedElement = document.activeElement;
      }; // Call the trapFocus callback at least once when this modal has been activated.


      trapFocus();
      document.addEventListener('focus', trapFocus, true);
      return () => document.removeEventListener('focus', trapFocus, true);
    }
  }, [active]); // To be fully compliant with WCAG we need to refocus element that triggered opening modal
  // after closing it

  react.useEffect(function () {
    if (canUseDom/* default */.Z) {
      var lastFocusedElementOutsideTrap = document.activeElement;
      return function () {
        if (lastFocusedElementOutsideTrap && document.contains(lastFocusedElementOutsideTrap)) {
          UIManager/* default.focus */.Z.focus(lastFocusedElementOutsideTrap);
        }
      };
    }
  }, []);
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(FocusBracket, null), /*#__PURE__*/react.createElement(View/* default */.Z, {
    ref: trapElementRef
  }, children), /*#__PURE__*/react.createElement(FocusBracket, null));
};

/* harmony default export */ var Modal_ModalFocusTrap = (ModalFocusTrap);
var ModalFocusTrap_styles = StyleSheet/* default.create */.Z.create({
  focusBracket: {
    outlineStyle: 'none'
  }
});
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/exports/Modal/index.js


var Modal_excluded = ["animationType", "children", "onDismiss", "onRequestClose", "onShow", "transparent", "visible"];

/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */





var uniqueModalIdentifier = 0;
var activeModalStack = [];
var activeModalListeners = {};

function notifyActiveModalListeners() {
  if (activeModalStack.length === 0) {
    return;
  }

  var activeModalId = activeModalStack[activeModalStack.length - 1];
  activeModalStack.forEach(modalId => {
    if (modalId in activeModalListeners) {
      activeModalListeners[modalId](modalId === activeModalId);
    }
  });
}

function removeActiveModal(modalId) {
  if (modalId in activeModalListeners) {
    // Before removing this listener we should probably tell it
    // that it's no longer the active modal for sure.
    activeModalListeners[modalId](false);
    delete activeModalListeners[modalId];
  }

  var index = activeModalStack.indexOf(modalId);

  if (index !== -1) {
    activeModalStack.splice(index, 1);
    notifyActiveModalListeners();
  }
}

function addActiveModal(modalId, listener) {
  removeActiveModal(modalId);
  activeModalStack.push(modalId);
  activeModalListeners[modalId] = listener;
  notifyActiveModalListeners();
}

var Modal = /*#__PURE__*/react.forwardRef((props, forwardedRef) => {
  var animationType = props.animationType,
      children = props.children,
      onDismiss = props.onDismiss,
      onRequestClose = props.onRequestClose,
      onShow = props.onShow,
      transparent = props.transparent,
      _props$visible = props.visible,
      visible = _props$visible === void 0 ? true : _props$visible,
      rest = (0,objectWithoutPropertiesLoose/* default */.Z)(props, Modal_excluded); // Set a unique model identifier so we can correctly route
  // dismissals and check the layering of modals.


  var modalId = react.useMemo(() => uniqueModalIdentifier++, []);

  var _React$useState = react.useState(false),
      isActive = _React$useState[0],
      setIsActive = _React$useState[1];

  var onDismissCallback = react.useCallback(() => {
    removeActiveModal(modalId);

    if (onDismiss) {
      onDismiss();
    }
  }, [modalId, onDismiss]);
  var onShowCallback = react.useCallback(() => {
    addActiveModal(modalId, setIsActive);

    if (onShow) {
      onShow();
    }
  }, [modalId, onShow]);
  react.useEffect(() => {
    return () => removeActiveModal(modalId);
  }, [modalId]);
  return /*#__PURE__*/react.createElement(Modal_ModalPortal, null, /*#__PURE__*/react.createElement(Modal_ModalAnimation, {
    animationType: animationType,
    onDismiss: onDismissCallback,
    onShow: onShowCallback,
    visible: visible
  }, /*#__PURE__*/react.createElement(Modal_ModalFocusTrap, {
    active: isActive
  }, /*#__PURE__*/react.createElement(Modal_ModalContent, (0,esm_extends/* default */.Z)({}, rest, {
    active: isActive,
    onRequestClose: onRequestClose,
    ref: forwardedRef,
    transparent: transparent
  }), children))));
});
/* harmony default export */ var exports_Modal = (Modal);
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/exports/Picker/index.js
var Picker = __webpack_require__(92045);
var Picker_default = /*#__PURE__*/__webpack_require__.n(Picker);
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/modules/useMergeRefs/index.js
var useMergeRefs = __webpack_require__(52778);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/modules/createEventHandle/index.js
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */




var createEventHandle_emptyFunction = () => {};

function supportsPassiveEvents() {
  var supported = false; // Check if browser supports event with passive listeners
  // https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support

  if (canUseDom/* default */.Z) {
    try {
      var options = {};
      Object.defineProperty(options, 'passive', {
        get() {
          supported = true;
          return false;
        }

      });
      window.addEventListener('test', null, options);
      window.removeEventListener('test', null, options);
    } catch (e) {}
  }

  return supported;
}

var canUsePassiveEvents = supportsPassiveEvents();

function getOptions(options) {
  if (options == null) {
    return false;
  }

  return canUsePassiveEvents ? options : Boolean(options.capture);
}
/**
 * Shim generic API compatibility with ReactDOM's synthetic events, without needing the
 * large amount of code ReactDOM uses to do this. Ideally we wouldn't use a synthetic
 * event wrapper at all.
 */


function isPropagationStopped() {
  return this.cancelBubble;
}

function isDefaultPrevented() {
  return this.defaultPrevented;
}

function normalizeEvent(event) {
  event.nativeEvent = event;
  event.persist = createEventHandle_emptyFunction;
  event.isDefaultPrevented = isDefaultPrevented;
  event.isPropagationStopped = isPropagationStopped;
  return event;
}
/**
 *
 */


function createEventHandle(type, options) {
  var opts = getOptions(options);
  return function (target, listener) {
    if (target == null || typeof target.addEventListener !== 'function') {
      throw new Error('createEventHandle: called on an invalid target.');
    }

    var element = target;

    if (listener != null) {
      var compatListener = e => listener(normalizeEvent(e));

      element.addEventListener(type, compatListener, opts);
      return function removeListener() {
        if (element != null) {
          element.removeEventListener(type, compatListener, opts);
        }
      };
    } else {
      return createEventHandle_emptyFunction;
    }
  };
}
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/modules/modality/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var supportsPointerEvent = () => !!(typeof window !== 'undefined' && window.PointerEvent != null);

var activeModality = 'keyboard';
var modality = 'keyboard';
var previousModality;
var previousActiveModality;
var isEmulatingMouseEvents = false;
var listeners = new Set();
var KEYBOARD = 'keyboard';
var MOUSE = 'mouse';
var TOUCH = 'touch';
var BLUR = 'blur';
var CONTEXTMENU = 'contextmenu';
var FOCUS = 'focus';
var KEYDOWN = 'keydown';
var MOUSEDOWN = 'mousedown';
var MOUSEMOVE = 'mousemove';
var MOUSEUP = 'mouseup';
var POINTERDOWN = 'pointerdown';
var POINTERMOVE = 'pointermove';
var SCROLL = 'scroll';
var SELECTIONCHANGE = 'selectionchange';
var TOUCHCANCEL = 'touchcancel';
var TOUCHMOVE = 'touchmove';
var TOUCHSTART = 'touchstart';
var VISIBILITYCHANGE = 'visibilitychange';
var bubbleOptions = {
  passive: true
};
var captureOptions = {
  capture: true,
  passive: true
}; // Window events

var addBlurListener = createEventHandle(BLUR, bubbleOptions);
var addFocusListener = createEventHandle(FOCUS, bubbleOptions); // Must be capture phase because 'stopPropagation' might prevent these
// events bubbling to the document.

var addVisibilityChangeListener = createEventHandle(VISIBILITYCHANGE, captureOptions);
var addKeyDownListener = createEventHandle(KEYDOWN, captureOptions);
var addPointerDownListener = createEventHandle(POINTERDOWN, captureOptions);
var addPointerMoveListener = createEventHandle(POINTERMOVE, captureOptions); // Fallback events

var addContextMenuListener = createEventHandle(CONTEXTMENU, captureOptions);
var addMouseDownListener = createEventHandle(MOUSEDOWN, captureOptions);
var addMouseMoveListener = createEventHandle(MOUSEMOVE, captureOptions);
var addMouseUpListener = createEventHandle(MOUSEUP, captureOptions);
var addScrollListener = createEventHandle(SCROLL, captureOptions);
var addSelectiomChangeListener = createEventHandle(SELECTIONCHANGE, captureOptions);
var addTouchCancelListener = createEventHandle(TOUCHCANCEL, captureOptions);
var addTouchMoveListener = createEventHandle(TOUCHMOVE, captureOptions);
var addTouchStartListener = createEventHandle(TOUCHSTART, captureOptions);

function restoreModality() {
  if (previousModality != null || previousActiveModality != null) {
    if (previousModality != null) {
      modality = previousModality;
      previousModality = null;
    }

    if (previousActiveModality != null) {
      activeModality = previousActiveModality;
      previousActiveModality = null;
    }

    callListeners();
  }
}

function onBlurWindow() {
  previousModality = modality;
  previousActiveModality = activeModality;
  activeModality = KEYBOARD;
  modality = KEYBOARD;
  callListeners(); // for fallback events

  isEmulatingMouseEvents = false;
}

function onFocusWindow() {
  restoreModality();
}

function onKeyDown(event) {
  if (event.metaKey || event.altKey || event.ctrlKey) {
    return;
  }

  if (modality !== KEYBOARD) {
    modality = KEYBOARD;
    activeModality = KEYBOARD;
    callListeners();
  }
}

function onVisibilityChange() {
  if (document.visibilityState !== 'hidden') {
    restoreModality();
  }
}

function onPointerish(event) {
  var eventType = event.type;

  if (supportsPointerEvent()) {
    if (eventType === POINTERDOWN) {
      if (activeModality !== event.pointerType) {
        modality = event.pointerType;
        activeModality = event.pointerType;
        callListeners();
      }

      return;
    }

    if (eventType === POINTERMOVE) {
      if (modality !== event.pointerType) {
        modality = event.pointerType;
        callListeners();
      }

      return;
    }
  } // Fallback for non-PointerEvent environment
  else {
    if (!isEmulatingMouseEvents) {
      if (eventType === MOUSEDOWN) {
        if (activeModality !== MOUSE) {
          modality = MOUSE;
          activeModality = MOUSE;
          callListeners();
        }
      }

      if (eventType === MOUSEMOVE) {
        if (modality !== MOUSE) {
          modality = MOUSE;
          callListeners();
        }
      }
    } // Flag when browser may produce emulated events


    if (eventType === TOUCHSTART) {
      isEmulatingMouseEvents = true;

      if (event.touches && event.touches.length > 1) {
        isEmulatingMouseEvents = false;
      }

      if (activeModality !== TOUCH) {
        modality = TOUCH;
        activeModality = TOUCH;
        callListeners();
      }

      return;
    } // Remove flag after emulated events are finished or cancelled, and if an
    // event occurs that cuts short a touch event sequence.


    if (eventType === CONTEXTMENU || eventType === MOUSEUP || eventType === SELECTIONCHANGE || eventType === SCROLL || eventType === TOUCHCANCEL || eventType === TOUCHMOVE) {
      isEmulatingMouseEvents = false;
    }
  }
}

if (canUseDom/* default */.Z) {
  addBlurListener(window, onBlurWindow);
  addFocusListener(window, onFocusWindow);
  addKeyDownListener(document, onKeyDown);
  addPointerDownListener(document, onPointerish);
  addPointerMoveListener(document, onPointerish);
  addVisibilityChangeListener(document, onVisibilityChange); // fallbacks

  addContextMenuListener(document, onPointerish);
  addMouseDownListener(document, onPointerish);
  addMouseMoveListener(document, onPointerish);
  addMouseUpListener(document, onPointerish);
  addTouchCancelListener(document, onPointerish);
  addTouchMoveListener(document, onPointerish);
  addTouchStartListener(document, onPointerish);
  addSelectiomChangeListener(document, onPointerish);
  addScrollListener(document, onPointerish);
}

function callListeners() {
  var value = {
    activeModality,
    modality
  };
  listeners.forEach(listener => {
    listener(value);
  });
}

function getActiveModality() {
  return activeModality;
}
function getModality() {
  return modality;
}
function addModalityListener(listener) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
function testOnly_resetActiveModality() {
  isEmulatingMouseEvents = false;
  activeModality = KEYBOARD;
  modality = KEYBOARD;
}
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/modules/useLayoutEffect/index.js
var useLayoutEffect = __webpack_require__(56905);
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/modules/useStable/index.js
var useStable = __webpack_require__(9121);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/modules/useEvent/index.js
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */




/**
 * This can be used with any event type include custom events.
 *
 * const click = useEvent('click', options);
 * useEffect(() => {
 *   click.setListener(target, onClick);
 *   return () => click.clear();
 * }).
 */
function useEvent(event, options) {
  var targetListeners = (0,useStable/* default */.Z)(() => new Map());
  var addListener = (0,useStable/* default */.Z)(() => {
    var addEventListener = createEventHandle(event, options);
    return (target, callback) => {
      var removeTargetListener = targetListeners.get(target);

      if (removeTargetListener != null) {
        removeTargetListener();
      }

      if (callback == null) {
        targetListeners.delete(target);
      }

      var removeEventListener = addEventListener(target, callback);
      targetListeners.set(target, removeEventListener);
      return removeEventListener;
    };
  });
  (0,useLayoutEffect/* default */.Z)(() => {
    return () => {
      targetListeners.forEach(removeListener => {
        removeListener();
      });
      targetListeners.clear();
    };
  }, [targetListeners]);
  return addListener;
}
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/modules/useHover/index.js
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * Types
 */

/**
 * Implementation
 */
var useHover_emptyObject = {};
var opts = {
  passive: true
};
var lockEventType = 'react-gui:hover:lock';
var unlockEventType = 'react-gui:hover:unlock';

var useHover_supportsPointerEvent = () => !!(typeof window !== 'undefined' && window.PointerEvent != null);

function dispatchCustomEvent(target, type, payload) {
  var event = document.createEvent('CustomEvent');

  var _ref = payload || useHover_emptyObject,
      _ref$bubbles = _ref.bubbles,
      bubbles = _ref$bubbles === void 0 ? true : _ref$bubbles,
      _ref$cancelable = _ref.cancelable,
      cancelable = _ref$cancelable === void 0 ? true : _ref$cancelable,
      detail = _ref.detail;

  event.initCustomEvent(type, bubbles, cancelable, detail);
  target.dispatchEvent(event);
} // This accounts for the non-PointerEvent fallback events.


function getPointerType(event) {
  var pointerType = event.pointerType;
  return pointerType != null ? pointerType : getModality();
}

function useHover(targetRef, config) {
  var contain = config.contain,
      disabled = config.disabled,
      onHoverStart = config.onHoverStart,
      onHoverChange = config.onHoverChange,
      onHoverUpdate = config.onHoverUpdate,
      onHoverEnd = config.onHoverEnd;
  var canUsePE = useHover_supportsPointerEvent();
  var addMoveListener = useEvent(canUsePE ? 'pointermove' : 'mousemove', opts);
  var addEnterListener = useEvent(canUsePE ? 'pointerenter' : 'mouseenter', opts);
  var addLeaveListener = useEvent(canUsePE ? 'pointerleave' : 'mouseleave', opts); // These custom events are used to implement the "contain" prop.

  var addLockListener = useEvent(lockEventType, opts);
  var addUnlockListener = useEvent(unlockEventType, opts);
  (0,useLayoutEffect/* default */.Z)(() => {
    var target = targetRef.current;

    if (target !== null) {
      /**
       * End the hover gesture
       */
      var hoverEnd = function hoverEnd(e) {
        if (onHoverEnd != null) {
          onHoverEnd(e);
        }

        if (onHoverChange != null) {
          onHoverChange(false);
        } // Remove the listeners once finished.


        addMoveListener(target, null);
        addLeaveListener(target, null);
      };
      /**
       * Leave element
       */


      var leaveListener = function leaveListener(e) {
        var target = targetRef.current;

        if (target != null && getPointerType(e) !== 'touch') {
          if (contain) {
            dispatchCustomEvent(target, unlockEventType);
          }

          hoverEnd(e);
        }
      };
      /**
       * Move within element
       */


      var moveListener = function moveListener(e) {
        if (getPointerType(e) !== 'touch') {
          if (onHoverUpdate != null) {
            // Not all browsers have these properties
            if (e.x == null) {
              e.x = e.clientX;
            }

            if (e.y == null) {
              e.y = e.clientY;
            }

            onHoverUpdate(e);
          }
        }
      };
      /**
       * Start the hover gesture
       */


      var hoverStart = function hoverStart(e) {
        if (onHoverStart != null) {
          onHoverStart(e);
        }

        if (onHoverChange != null) {
          onHoverChange(true);
        } // Set the listeners needed for the rest of the hover gesture.


        if (onHoverUpdate != null) {
          addMoveListener(target, !disabled ? moveListener : null);
        }

        addLeaveListener(target, !disabled ? leaveListener : null);
      };
      /**
       * Enter element
       */


      var enterListener = function enterListener(e) {
        var target = targetRef.current;

        if (target != null && getPointerType(e) !== 'touch') {
          if (contain) {
            dispatchCustomEvent(target, lockEventType);
          }

          hoverStart(e);

          var lockListener = function lockListener(lockEvent) {
            if (lockEvent.target !== target) {
              hoverEnd(e);
            }
          };

          var unlockListener = function unlockListener(lockEvent) {
            if (lockEvent.target !== target) {
              hoverStart(e);
            }
          };

          addLockListener(target, !disabled ? lockListener : null);
          addUnlockListener(target, !disabled ? unlockListener : null);
        }
      };

      addEnterListener(target, !disabled ? enterListener : null);
    }
  }, [addEnterListener, addMoveListener, addLeaveListener, addLockListener, addUnlockListener, contain, disabled, onHoverStart, onHoverChange, onHoverUpdate, onHoverEnd, targetRef]);
}
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/modules/usePressEvents/PressResponder.js
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */


var DELAY = 'DELAY';
var ERROR = 'ERROR';
var LONG_PRESS_DETECTED = 'LONG_PRESS_DETECTED';
var NOT_RESPONDER = 'NOT_RESPONDER';
var RESPONDER_ACTIVE_LONG_PRESS_START = 'RESPONDER_ACTIVE_LONG_PRESS_START';
var RESPONDER_ACTIVE_PRESS_START = 'RESPONDER_ACTIVE_PRESS_START';
var RESPONDER_INACTIVE_PRESS_START = 'RESPONDER_INACTIVE_PRESS_START';
var RESPONDER_GRANT = 'RESPONDER_GRANT';
var RESPONDER_RELEASE = 'RESPONDER_RELEASE';
var RESPONDER_TERMINATED = 'RESPONDER_TERMINATED';
var Transitions = Object.freeze({
  NOT_RESPONDER: {
    DELAY: ERROR,
    RESPONDER_GRANT: RESPONDER_INACTIVE_PRESS_START,
    RESPONDER_RELEASE: ERROR,
    RESPONDER_TERMINATED: ERROR,
    LONG_PRESS_DETECTED: ERROR
  },
  RESPONDER_INACTIVE_PRESS_START: {
    DELAY: RESPONDER_ACTIVE_PRESS_START,
    RESPONDER_GRANT: ERROR,
    RESPONDER_RELEASE: NOT_RESPONDER,
    RESPONDER_TERMINATED: NOT_RESPONDER,
    LONG_PRESS_DETECTED: ERROR
  },
  RESPONDER_ACTIVE_PRESS_START: {
    DELAY: ERROR,
    RESPONDER_GRANT: ERROR,
    RESPONDER_RELEASE: NOT_RESPONDER,
    RESPONDER_TERMINATED: NOT_RESPONDER,
    LONG_PRESS_DETECTED: RESPONDER_ACTIVE_LONG_PRESS_START
  },
  RESPONDER_ACTIVE_LONG_PRESS_START: {
    DELAY: ERROR,
    RESPONDER_GRANT: ERROR,
    RESPONDER_RELEASE: NOT_RESPONDER,
    RESPONDER_TERMINATED: NOT_RESPONDER,
    LONG_PRESS_DETECTED: RESPONDER_ACTIVE_LONG_PRESS_START
  },
  ERROR: {
    DELAY: NOT_RESPONDER,
    RESPONDER_GRANT: RESPONDER_INACTIVE_PRESS_START,
    RESPONDER_RELEASE: NOT_RESPONDER,
    RESPONDER_TERMINATED: NOT_RESPONDER,
    LONG_PRESS_DETECTED: NOT_RESPONDER
  }
});

var isActiveSignal = signal => signal === RESPONDER_ACTIVE_PRESS_START || signal === RESPONDER_ACTIVE_LONG_PRESS_START;

var isButtonRole = element => element.getAttribute('role') === 'button';

var isPressStartSignal = signal => signal === RESPONDER_INACTIVE_PRESS_START || signal === RESPONDER_ACTIVE_PRESS_START || signal === RESPONDER_ACTIVE_LONG_PRESS_START;

var isTerminalSignal = signal => signal === RESPONDER_TERMINATED || signal === RESPONDER_RELEASE;

var isValidKeyPress = event => {
  var key = event.key,
      target = event.target;
  var role = target.getAttribute('role');
  var isSpacebar = key === ' ' || key === 'Spacebar';
  return key === 'Enter' || isSpacebar && role === 'button';
};

var DEFAULT_LONG_PRESS_DELAY_MS = 450; // 500 - 50

var DEFAULT_PRESS_DELAY_MS = 50;
/**
 * =========================== PressResponder Tutorial ===========================
 *
 * The `PressResponder` class helps you create press interactions by analyzing the
 * geometry of elements and observing when another responder (e.g. ScrollView)
 * has stolen the touch lock. It offers hooks for your component to provide
 * interaction feedback to the user:
 *
 * - When a press has activated (e.g. highlight an element)
 * - When a press has deactivated (e.g. un-highlight an element)
 * - When a press sould trigger an action, meaning it activated and deactivated
 *   while within the geometry of the element without the lock being stolen.
 *
 * A high quality interaction isn't as simple as you might think. There should
 * be a slight delay before activation. Moving your finger beyond an element's
 * bounds should trigger deactivation, but moving the same finger back within an
 * element's bounds should trigger reactivation.
 *
 * In order to use `PressResponder`, do the following:
 *
 *     const pressResponder = new PressResponder(config);
 *
 * 2. Choose the rendered component who should collect the press events. On that
 *    element, spread `pressability.getEventHandlers()` into its props.
 *
 *    return (
 *      <View {...this.state.pressResponder.getEventHandlers()} />
 *    );
 *
 * 3. Reset `PressResponder` when your component unmounts.
 *
 *    componentWillUnmount() {
 *      this.state.pressResponder.reset();
 *    }
 *
 * ==================== Implementation Details ====================
 *
 * `PressResponder` only assumes that there exists a `HitRect` node. The `PressRect`
 * is an abstract box that is extended beyond the `HitRect`.
 *
 * # Geometry
 *
 *  ┌────────────────────────┐
 *  │  ┌──────────────────┐  │ - Presses start anywhere within `HitRect`.
 *  │  │  ┌────────────┐  │  │
 *  │  │  │ VisualRect │  │  │
 *  │  │  └────────────┘  │  │ - When pressed down for sufficient amount of time
 *  │  │    HitRect       │  │   before letting up, `VisualRect` activates.
 *  │  └──────────────────┘  │
 *  │       Out Region   o   │
 *  └────────────────────│───┘
 *                       └────── When the press is released outside the `HitRect`,
 *                               the responder is NOT eligible for a "press".
 *
 * # State Machine
 *
 * ┌───────────────┐ ◀──── RESPONDER_RELEASE
 * │ NOT_RESPONDER │
 * └───┬───────────┘ ◀──── RESPONDER_TERMINATED
 *     │
 *     │ RESPONDER_GRANT (HitRect)
 *     │
 *     ▼
 * ┌─────────────────────┐          ┌───────────────────┐              ┌───────────────────┐
 * │ RESPONDER_INACTIVE_ │  DELAY   │ RESPONDER_ACTIVE_ │  T + DELAY   │ RESPONDER_ACTIVE_ │
 * │ PRESS_START         ├────────▶ │ PRESS_START       ├────────────▶ │ LONG_PRESS_START  │
 * └─────────────────────┘          └───────────────────┘              └───────────────────┘
 *
 * T + DELAY => LONG_PRESS_DELAY + DELAY
 *
 * Not drawn are the side effects of each transition. The most important side
 * effect is the invocation of `onLongPress`. Only when the browser produces a
 * `click` event is `onPress` invoked.
 */

class PressResponder {
  constructor(config) {
    this._eventHandlers = null;
    this._isPointerTouch = false;
    this._longPressDelayTimeout = null;
    this._longPressDispatched = false;
    this._pressDelayTimeout = null;
    this._pressOutDelayTimeout = null;
    this._touchState = NOT_RESPONDER;
    this.configure(config);
  }

  configure(config) {
    this._config = config;
  }
  /**
   * Resets any pending timers. This should be called on unmount.
   */


  reset() {
    this._cancelLongPressDelayTimeout();

    this._cancelPressDelayTimeout();

    this._cancelPressOutDelayTimeout();
  }
  /**
   * Returns a set of props to spread into the interactive element.
   */


  getEventHandlers() {
    if (this._eventHandlers == null) {
      this._eventHandlers = this._createEventHandlers();
    }

    return this._eventHandlers;
  }

  _createEventHandlers() {
    var start = (event, shouldDelay) => {
      event.persist();

      this._cancelPressOutDelayTimeout();

      this._longPressDispatched = false;
      this._selectionTerminated = false;
      this._touchState = NOT_RESPONDER;
      this._isPointerTouch = event.nativeEvent.type === 'touchstart';

      this._receiveSignal(RESPONDER_GRANT, event);

      var delayPressStart = normalizeDelay(this._config.delayPressStart, 0, DEFAULT_PRESS_DELAY_MS);

      if (shouldDelay !== false && delayPressStart > 0) {
        this._pressDelayTimeout = setTimeout(() => {
          this._receiveSignal(DELAY, event);
        }, delayPressStart);
      } else {
        this._receiveSignal(DELAY, event);
      }

      var delayLongPress = normalizeDelay(this._config.delayLongPress, 10, DEFAULT_LONG_PRESS_DELAY_MS);
      this._longPressDelayTimeout = setTimeout(() => {
        this._handleLongPress(event);
      }, delayLongPress + delayPressStart);
    };

    var end = event => {
      this._receiveSignal(RESPONDER_RELEASE, event);
    };

    var keyupHandler = event => {
      var onPress = this._config.onPress;
      var target = event.target;

      if (this._touchState !== NOT_RESPONDER && isValidKeyPress(event)) {
        end(event);
        document.removeEventListener('keyup', keyupHandler);
        var role = target.getAttribute('role');
        var elementType = target.tagName.toLowerCase();
        var isNativeInteractiveElement = role === 'link' || elementType === 'a' || elementType === 'button' || elementType === 'input' || elementType === 'select' || elementType === 'textarea';

        if (onPress != null && !isNativeInteractiveElement) {
          onPress(event);
        }
      }
    };

    return {
      onStartShouldSetResponder: event => {
        var disabled = this._config.disabled;

        if (disabled && isButtonRole(event.currentTarget)) {
          event.stopPropagation();
        }

        if (disabled == null) {
          return true;
        }

        return !disabled;
      },
      onKeyDown: event => {
        var disabled = this._config.disabled;
        var key = event.key,
            target = event.target;

        if (!disabled && isValidKeyPress(event)) {
          if (this._touchState === NOT_RESPONDER) {
            start(event, false); // Listen to 'keyup' on document to account for situations where
            // focus is moved to another element during 'keydown'.

            document.addEventListener('keyup', keyupHandler);
          }

          var role = target.getAttribute('role');
          var isSpacebarKey = key === ' ' || key === 'Spacebar';

          var _isButtonRole = role === 'button' || role === 'menuitem';

          if (isSpacebarKey && _isButtonRole) {
            // Prevent spacebar scrolling the window
            event.preventDefault();
          }

          event.stopPropagation();
        }
      },
      onResponderGrant: event => start(event),
      onResponderMove: event => {
        if (this._config.onPressMove != null) {
          this._config.onPressMove(event);
        }

        var touch = getTouchFromResponderEvent(event);

        if (this._touchActivatePosition != null) {
          var deltaX = this._touchActivatePosition.pageX - touch.pageX;
          var deltaY = this._touchActivatePosition.pageY - touch.pageY;

          if (Math.hypot(deltaX, deltaY) > 10) {
            this._cancelLongPressDelayTimeout();
          }
        }
      },
      onResponderRelease: event => end(event),
      onResponderTerminate: event => {
        if (event.nativeEvent.type === 'selectionchange') {
          this._selectionTerminated = true;
        }

        this._receiveSignal(RESPONDER_TERMINATED, event);
      },
      onResponderTerminationRequest: event => {
        var _this$_config = this._config,
            cancelable = _this$_config.cancelable,
            disabled = _this$_config.disabled,
            onLongPress = _this$_config.onLongPress; // If `onLongPress` is provided, don't terminate on `contextmenu` as default
        // behavior will be prevented for non-mouse pointers.

        if (!disabled && onLongPress != null && this._isPointerTouch && event.nativeEvent.type === 'contextmenu') {
          return false;
        }

        if (cancelable == null) {
          return true;
        }

        return cancelable;
      },
      // NOTE: this diverges from react-native in 3 significant ways:
      // * The `onPress` callback is not connected to the responder system (the native
      //  `click` event must be used but is dispatched in many scenarios where no pointers
      //   are on the screen.) Therefore, it's possible for `onPress` to be called without
      //   `onPress{Start,End}` being called first.
      // * The `onPress` callback is only be called on the first ancestor of the native
      //   `click` target that is using the PressResponder.
      // * The event's `nativeEvent` is a `MouseEvent` not a `TouchEvent`.
      onClick: event => {
        var _this$_config2 = this._config,
            disabled = _this$_config2.disabled,
            onPress = _this$_config2.onPress;

        if (!disabled) {
          // If long press dispatched, cancel default click behavior.
          // If the responder terminated because text was selected during the gesture,
          // cancel the default click behavior.
          event.stopPropagation();

          if (this._longPressDispatched || this._selectionTerminated) {
            event.preventDefault();
          } else if (onPress != null && event.altKey === false) {
            onPress(event);
          }
        } else {
          if (isButtonRole(event.currentTarget)) {
            event.stopPropagation();
          }
        }
      },
      // If `onLongPress` is provided and a touch pointer is being used, prevent the
      // default context menu from opening.
      onContextMenu: event => {
        var _this$_config3 = this._config,
            disabled = _this$_config3.disabled,
            onLongPress = _this$_config3.onLongPress;

        if (!disabled) {
          if (onLongPress != null && this._isPointerTouch && !event.defaultPrevented) {
            event.preventDefault();
            event.stopPropagation();
          }
        } else {
          if (isButtonRole(event.currentTarget)) {
            event.stopPropagation();
          }
        }
      }
    };
  }
  /**
   * Receives a state machine signal, performs side effects of the transition
   * and stores the new state. Validates the transition as well.
   */


  _receiveSignal(signal, event) {
    var prevState = this._touchState;
    var nextState = null;

    if (Transitions[prevState] != null) {
      nextState = Transitions[prevState][signal];
    }

    if (this._touchState === NOT_RESPONDER && signal === RESPONDER_RELEASE) {
      return;
    }

    if (nextState == null || nextState === ERROR) {
      console.error("PressResponder: Invalid signal " + signal + " for state " + prevState + " on responder");
    } else if (prevState !== nextState) {
      this._performTransitionSideEffects(prevState, nextState, signal, event);

      this._touchState = nextState;
    }
  }
  /**
   * Performs a transition between touchable states and identify any activations
   * or deactivations (and callback invocations).
   */


  _performTransitionSideEffects(prevState, nextState, signal, event) {
    if (isTerminalSignal(signal)) {
      // Pressable suppression of contextmenu on windows.
      // On Windows, the contextmenu is displayed after pointerup.
      // https://github.com/necolas/react-native-web/issues/2296
      setTimeout(() => {
        this._isPointerTouch = false;
      }, 0);
      this._touchActivatePosition = null;

      this._cancelLongPressDelayTimeout();
    }

    if (isPressStartSignal(prevState) && signal === LONG_PRESS_DETECTED) {
      var onLongPress = this._config.onLongPress; // Long press is not supported for keyboards because 'click' can be dispatched
      // immediately (and multiple times) after 'keydown'.

      if (onLongPress != null && event.nativeEvent.key == null) {
        onLongPress(event);
        this._longPressDispatched = true;
      }
    }

    var isPrevActive = isActiveSignal(prevState);
    var isNextActive = isActiveSignal(nextState);

    if (!isPrevActive && isNextActive) {
      this._activate(event);
    } else if (isPrevActive && !isNextActive) {
      this._deactivate(event);
    }

    if (isPressStartSignal(prevState) && signal === RESPONDER_RELEASE) {
      var _this$_config4 = this._config,
          _onLongPress = _this$_config4.onLongPress,
          onPress = _this$_config4.onPress;

      if (onPress != null) {
        var isPressCanceledByLongPress = _onLongPress != null && prevState === RESPONDER_ACTIVE_LONG_PRESS_START;

        if (!isPressCanceledByLongPress) {
          // If we never activated (due to delays), activate and deactivate now.
          if (!isNextActive && !isPrevActive) {
            this._activate(event);

            this._deactivate(event);
          }
        }
      }
    }

    this._cancelPressDelayTimeout();
  }

  _activate(event) {
    var _this$_config5 = this._config,
        onPressChange = _this$_config5.onPressChange,
        onPressStart = _this$_config5.onPressStart;
    var touch = getTouchFromResponderEvent(event);
    this._touchActivatePosition = {
      pageX: touch.pageX,
      pageY: touch.pageY
    };

    if (onPressStart != null) {
      onPressStart(event);
    }

    if (onPressChange != null) {
      onPressChange(true);
    }
  }

  _deactivate(event) {
    var _this$_config6 = this._config,
        onPressChange = _this$_config6.onPressChange,
        onPressEnd = _this$_config6.onPressEnd;

    function end() {
      if (onPressEnd != null) {
        onPressEnd(event);
      }

      if (onPressChange != null) {
        onPressChange(false);
      }
    }

    var delayPressEnd = normalizeDelay(this._config.delayPressEnd);

    if (delayPressEnd > 0) {
      this._pressOutDelayTimeout = setTimeout(() => {
        end();
      }, delayPressEnd);
    } else {
      end();
    }
  }

  _handleLongPress(event) {
    if (this._touchState === RESPONDER_ACTIVE_PRESS_START || this._touchState === RESPONDER_ACTIVE_LONG_PRESS_START) {
      this._receiveSignal(LONG_PRESS_DETECTED, event);
    }
  }

  _cancelLongPressDelayTimeout() {
    if (this._longPressDelayTimeout != null) {
      clearTimeout(this._longPressDelayTimeout);
      this._longPressDelayTimeout = null;
    }
  }

  _cancelPressDelayTimeout() {
    if (this._pressDelayTimeout != null) {
      clearTimeout(this._pressDelayTimeout);
      this._pressDelayTimeout = null;
    }
  }

  _cancelPressOutDelayTimeout() {
    if (this._pressOutDelayTimeout != null) {
      clearTimeout(this._pressOutDelayTimeout);
      this._pressOutDelayTimeout = null;
    }
  }

}

function normalizeDelay(delay, min, fallback) {
  if (min === void 0) {
    min = 0;
  }

  if (fallback === void 0) {
    fallback = 0;
  }

  return Math.max(min, delay !== null && delay !== void 0 ? delay : fallback);
}

function getTouchFromResponderEvent(event) {
  var _event$nativeEvent = event.nativeEvent,
      changedTouches = _event$nativeEvent.changedTouches,
      touches = _event$nativeEvent.touches;

  if (touches != null && touches.length > 0) {
    return touches[0];
  }

  if (changedTouches != null && changedTouches.length > 0) {
    return changedTouches[0];
  }

  return event.nativeEvent;
}
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/modules/usePressEvents/index.js
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */




function usePressEvents(hostRef, config) {
  var pressResponderRef = (0,react.useRef)(null);

  if (pressResponderRef.current == null) {
    pressResponderRef.current = new PressResponder(config);
  }

  var pressResponder = pressResponderRef.current; // Re-configure to use the current node and configuration.

  (0,react.useEffect)(() => {
    pressResponder.configure(config);
  }, [config, pressResponder]); // Reset the `pressResponder` when cleanup needs to occur. This is
  // a separate effect because we do not want to rest the responder when `config` changes.

  (0,react.useEffect)(() => {
    return () => {
      pressResponder.reset();
    };
  }, [pressResponder]);
  (0,react.useDebugValue)(config);
  return pressResponder.getEventHandlers();
}
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/exports/Pressable/index.js
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */




var Pressable_excluded = ["children", "delayLongPress", "delayPressIn", "delayPressOut", "disabled", "focusable", "onBlur", "onContextMenu", "onFocus", "onHoverIn", "onHoverOut", "onKeyDown", "onLongPress", "onPress", "onPressMove", "onPressIn", "onPressOut", "style", "testOnly_hovered", "testOnly_pressed"];








/**
 * Component used to build display components that should respond to whether the
 * component is currently pressed or not.
 */
function Pressable(props, forwardedRef) {
  var children = props.children,
      delayLongPress = props.delayLongPress,
      delayPressIn = props.delayPressIn,
      delayPressOut = props.delayPressOut,
      disabled = props.disabled,
      focusable = props.focusable,
      onBlur = props.onBlur,
      onContextMenu = props.onContextMenu,
      onFocus = props.onFocus,
      onHoverIn = props.onHoverIn,
      onHoverOut = props.onHoverOut,
      onKeyDown = props.onKeyDown,
      onLongPress = props.onLongPress,
      onPress = props.onPress,
      onPressMove = props.onPressMove,
      onPressIn = props.onPressIn,
      onPressOut = props.onPressOut,
      style = props.style,
      testOnly_hovered = props.testOnly_hovered,
      testOnly_pressed = props.testOnly_pressed,
      rest = (0,objectWithoutPropertiesLoose/* default */.Z)(props, Pressable_excluded);

  var _useForceableState = useForceableState(testOnly_hovered === true),
      hovered = _useForceableState[0],
      setHovered = _useForceableState[1];

  var _useForceableState2 = useForceableState(false),
      focused = _useForceableState2[0],
      setFocused = _useForceableState2[1];

  var _useForceableState3 = useForceableState(testOnly_pressed === true),
      pressed = _useForceableState3[0],
      setPressed = _useForceableState3[1];

  var hostRef = (0,react.useRef)(null);
  var setRef = (0,useMergeRefs/* default */.Z)(forwardedRef, hostRef);
  var pressConfig = (0,react.useMemo)(() => ({
    delayLongPress,
    delayPressStart: delayPressIn,
    delayPressEnd: delayPressOut,
    disabled,
    onLongPress,
    onPress,
    onPressChange: setPressed,
    onPressStart: onPressIn,
    onPressMove,
    onPressEnd: onPressOut
  }), [delayLongPress, delayPressIn, delayPressOut, disabled, onLongPress, onPress, onPressIn, onPressMove, onPressOut, setPressed]);
  var pressEventHandlers = usePressEvents(hostRef, pressConfig);
  var onContextMenuPress = pressEventHandlers.onContextMenu,
      onKeyDownPress = pressEventHandlers.onKeyDown;
  useHover(hostRef, {
    contain: true,
    disabled,
    onHoverChange: setHovered,
    onHoverStart: onHoverIn,
    onHoverEnd: onHoverOut
  });
  var interactionState = {
    hovered,
    focused,
    pressed
  };
  var blurHandler = react.useCallback(e => {
    if (e.nativeEvent.target === hostRef.current) {
      setFocused(false);

      if (onBlur != null) {
        onBlur(e);
      }
    }
  }, [hostRef, setFocused, onBlur]);
  var focusHandler = react.useCallback(e => {
    if (e.nativeEvent.target === hostRef.current) {
      setFocused(true);

      if (onFocus != null) {
        onFocus(e);
      }
    }
  }, [hostRef, setFocused, onFocus]);
  var contextMenuHandler = react.useCallback(e => {
    if (onContextMenuPress != null) {
      onContextMenuPress(e);
    }

    if (onContextMenu != null) {
      onContextMenu(e);
    }
  }, [onContextMenu, onContextMenuPress]);
  var keyDownHandler = react.useCallback(e => {
    if (onKeyDownPress != null) {
      onKeyDownPress(e);
    }

    if (onKeyDown != null) {
      onKeyDown(e);
    }
  }, [onKeyDown, onKeyDownPress]);
  return /*#__PURE__*/react.createElement(View/* default */.Z, (0,esm_extends/* default */.Z)({}, rest, pressEventHandlers, {
    accessibilityDisabled: disabled,
    focusable: !disabled && focusable !== false,
    onBlur: blurHandler,
    onContextMenu: contextMenuHandler,
    onFocus: focusHandler,
    onKeyDown: keyDownHandler,
    pointerEvents: disabled ? 'none' : rest.pointerEvents,
    ref: setRef,
    style: [!disabled && Pressable_styles.root, typeof style === 'function' ? style(interactionState) : style]
  }), typeof children === 'function' ? children(interactionState) : children);
}

function useForceableState(forced) {
  var _useState = (0,react.useState)(false),
      bool = _useState[0],
      setBool = _useState[1];

  return [bool || forced, setBool];
}

var Pressable_styles = StyleSheet/* default.create */.Z.create({
  root: {
    cursor: 'pointer',
    touchAction: 'manipulation'
  }
});
var MemoedPressable = /*#__PURE__*/(0,react.memo)( /*#__PURE__*/(0,react.forwardRef)(Pressable));
MemoedPressable.displayName = 'Pressable';
/* harmony default export */ var exports_Pressable = (MemoedPressable);
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/exports/ProgressBar/index.js
var ProgressBar = __webpack_require__(40228);
var ProgressBar_default = /*#__PURE__*/__webpack_require__.n(ProgressBar);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/exports/RefreshControl/index.js

var RefreshControl_excluded = ["colors", "enabled", "onRefresh", "progressBackgroundColor", "progressViewOffset", "refreshing", "size", "tintColor", "title", "titleColor"];

/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



function RefreshControl(props) {
  var colors = props.colors,
      enabled = props.enabled,
      onRefresh = props.onRefresh,
      progressBackgroundColor = props.progressBackgroundColor,
      progressViewOffset = props.progressViewOffset,
      refreshing = props.refreshing,
      size = props.size,
      tintColor = props.tintColor,
      title = props.title,
      titleColor = props.titleColor,
      rest = (0,objectWithoutPropertiesLoose/* default */.Z)(props, RefreshControl_excluded);

  return /*#__PURE__*/react.createElement(View/* default */.Z, rest);
}

/* harmony default export */ var exports_RefreshControl = (RefreshControl);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/exports/SafeAreaView/index.js


var SafeAreaView_excluded = ["style"];

/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */





var cssFunction = function () {
  if (canUseDom/* default */.Z && window.CSS && window.CSS.supports && window.CSS.supports('top: constant(safe-area-inset-top)')) {
    return 'constant';
  }

  return 'env';
}();

var SafeAreaView = /*#__PURE__*/react.forwardRef((props, ref) => {
  var style = props.style,
      rest = (0,objectWithoutPropertiesLoose/* default */.Z)(props, SafeAreaView_excluded);

  return /*#__PURE__*/react.createElement(View/* default */.Z, (0,esm_extends/* default */.Z)({}, rest, {
    ref: ref,
    style: StyleSheet/* default.compose */.Z.compose(SafeAreaView_styles.root, style)
  }));
});
SafeAreaView.displayName = 'SafeAreaView';
var SafeAreaView_styles = StyleSheet/* default.create */.Z.create({
  root: {
    paddingTop: cssFunction + "(safe-area-inset-top)",
    paddingRight: cssFunction + "(safe-area-inset-right)",
    paddingBottom: cssFunction + "(safe-area-inset-bottom)",
    paddingLeft: cssFunction + "(safe-area-inset-left)"
  }
});
/* harmony default export */ var exports_SafeAreaView = (SafeAreaView);
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/exports/ScrollView/index.js + 2 modules
var ScrollView = __webpack_require__(79450);
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/exports/SectionList/index.js
var SectionList = __webpack_require__(72302);
var SectionList_default = /*#__PURE__*/__webpack_require__.n(SectionList);
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/exports/StatusBar/index.js
var StatusBar = __webpack_require__(44776);
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/exports/Switch/index.js
var Switch = __webpack_require__(24996);
var Switch_default = /*#__PURE__*/__webpack_require__.n(Switch);
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/exports/TextInput/index.js
var TextInput = __webpack_require__(3348);
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/exports/Touchable/index.js
var Touchable = __webpack_require__(78539);
var Touchable_default = /*#__PURE__*/__webpack_require__.n(Touchable);
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/exports/TouchableHighlight/index.js
var TouchableHighlight = __webpack_require__(69447);
var TouchableHighlight_default = /*#__PURE__*/__webpack_require__.n(TouchableHighlight);
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/exports/TouchableNativeFeedback/index.js
var TouchableNativeFeedback = __webpack_require__(46852);
var TouchableNativeFeedback_default = /*#__PURE__*/__webpack_require__.n(TouchableNativeFeedback);
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/exports/TouchableWithoutFeedback/index.js
var TouchableWithoutFeedback = __webpack_require__(96258);
var TouchableWithoutFeedback_default = /*#__PURE__*/__webpack_require__.n(TouchableWithoutFeedback);
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/exports/VirtualizedList/index.js
var VirtualizedList = __webpack_require__(44791);
var VirtualizedList_default = /*#__PURE__*/__webpack_require__.n(VirtualizedList);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/modules/UnimplementedView/index.js
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


/**
 * Common implementation for a simple stubbed view.
 */

class UnimplementedView extends react.Component {
  setNativeProps() {// Do nothing.
  }

  render() {
    return /*#__PURE__*/react.createElement(View/* default */.Z, {
      style: [unimplementedViewStyles, this.props.style]
    }, this.props.children);
  }

}

var unimplementedViewStyles =  false ? 0 : {};
/* harmony default export */ var modules_UnimplementedView = (UnimplementedView);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/exports/YellowBox/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



function YellowBox(props) {
  return /*#__PURE__*/react.createElement(modules_UnimplementedView, props);
}

YellowBox.ignoreWarnings = () => {};

/* harmony default export */ var exports_YellowBox = (YellowBox);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/exports/LogBox/index.js
/**
 * Copyright (c) 2016-present, Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */
var LogBox = {
  ignoreLogs() {},

  ignoreAllLogs() {},

  uninstall() {},

  install() {}

};
/* harmony default export */ var exports_LogBox = (LogBox);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/exports/DrawerLayoutAndroid/index.js

/* harmony default export */ var DrawerLayoutAndroid = (modules_UnimplementedView);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/exports/InputAccessoryView/index.js

/* harmony default export */ var InputAccessoryView = (modules_UnimplementedView);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/exports/ToastAndroid/index.js

/* harmony default export */ var ToastAndroid = (modules_UnimplementedView);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/exports/PermissionsAndroid/index.js
var promiseMock = () => Promise.resolve(false);

/* harmony default export */ var PermissionsAndroid = ({
  PERMISSIONS: {},
  RESULTS: {},
  checkPermission: promiseMock,
  check: promiseMock,
  requestPermission: promiseMock,
  request: promiseMock,
  requestMultiple: promiseMock
});
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/exports/Settings/index.js
/* harmony default export */ var Settings = ({});
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/exports/Systrace/index.js
/* harmony default export */ var Systrace = ({});
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/exports/TVEventHandler/index.js
/* harmony default export */ var TVEventHandler = ({});
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/vendor/react-native/NativeEventEmitter/RCTDeviceEventEmitter.js + 1 modules
var RCTDeviceEventEmitter = __webpack_require__(63153);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/exports/DeviceEventEmitter/index.js

/* harmony default export */ var DeviceEventEmitter = (RCTDeviceEventEmitter/* default */.Z);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/exports/useColorScheme/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


function useColorScheme() {
  var _React$useState = react.useState(exports_Appearance.getColorScheme()),
      colorScheme = _React$useState[0],
      setColorScheme = _React$useState[1];

  react.useEffect(() => {
    function listener(appearance) {
      setColorScheme(appearance.colorScheme);
    }

    var _Appearance$addChange = exports_Appearance.addChangeListener(listener),
        remove = _Appearance$addChange.remove;

    return remove;
  });
  return colorScheme;
}
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/modules/useLocale/index.js + 1 modules
var useLocale = __webpack_require__(38639);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/exports/useLocaleContext/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

/* harmony default export */ var useLocaleContext = (useLocale/* useLocaleContext */.PE);
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/exports/useWindowDimensions/index.js
var useWindowDimensions = __webpack_require__(58440);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/index.js





 // APIs
























 // components




























 // compat (components)



 // compat (apis)




 // plugins

 // hooks





/***/ }),

/***/ 40819:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ modules_AccessibilityUtil; }
});

;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/modules/AccessibilityUtil/isDisabled.js
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */
var isDisabled = props => props.disabled || Array.isArray(props.accessibilityStates) && props.accessibilityStates.indexOf('disabled') > -1;

/* harmony default export */ var AccessibilityUtil_isDisabled = (isDisabled);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/modules/AccessibilityUtil/propsToAriaRole.js
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */
var accessibilityRoleToWebRole = {
  adjustable: 'slider',
  button: 'button',
  header: 'heading',
  image: 'img',
  imagebutton: null,
  keyboardkey: null,
  label: null,
  link: 'link',
  none: 'presentation',
  search: 'search',
  summary: 'region',
  text: null
};

var propsToAriaRole = _ref => {
  var accessibilityRole = _ref.accessibilityRole;

  if (accessibilityRole) {
    var inferredRole = accessibilityRoleToWebRole[accessibilityRole];

    if (inferredRole !== null) {
      // ignore roles that don't map to web
      return inferredRole || accessibilityRole;
    }
  }
};

/* harmony default export */ var AccessibilityUtil_propsToAriaRole = (propsToAriaRole);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/modules/AccessibilityUtil/propsToAccessibilityComponent.js
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var roleComponents = {
  article: 'article',
  banner: 'header',
  blockquote: 'blockquote',
  code: 'code',
  complementary: 'aside',
  contentinfo: 'footer',
  deletion: 'del',
  emphasis: 'em',
  figure: 'figure',
  insertion: 'ins',
  form: 'form',
  list: 'ul',
  listitem: 'li',
  main: 'main',
  navigation: 'nav',
  region: 'section',
  strong: 'strong'
};
var emptyObject = {};

var propsToAccessibilityComponent = function propsToAccessibilityComponent(props) {
  if (props === void 0) {
    props = emptyObject;
  }

  // special-case for "label" role which doesn't map to an ARIA role
  if (props.accessibilityRole === 'label') {
    return 'label';
  }

  var role = AccessibilityUtil_propsToAriaRole(props);

  if (role) {
    if (role === 'heading') {
      var level = props.accessibilityLevel || props['aria-level'];

      if (level != null) {
        return "h" + level;
      }

      return 'h1';
    }

    return roleComponents[role];
  }
};

/* harmony default export */ var AccessibilityUtil_propsToAccessibilityComponent = (propsToAccessibilityComponent);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/modules/AccessibilityUtil/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var AccessibilityUtil = {
  isDisabled: AccessibilityUtil_isDisabled,
  propsToAccessibilityComponent: AccessibilityUtil_propsToAccessibilityComponent,
  propsToAriaRole: AccessibilityUtil_propsToAriaRole
};
/* harmony default export */ var modules_AccessibilityUtil = (AccessibilityUtil);

/***/ }),

/***/ 1736:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _exports_UIManager__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96187);
/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

/**
 * This class is responsible for coordinating the "focused"
 * state for TextInputs. All calls relating to the keyboard
 * should be funneled through here
 */

var TextInputState = {
  /**
   * Internal state
   */
  _currentlyFocusedNode: null,

  /**
   * Returns the ID of the currently focused text field, if one exists
   * If no text field is focused it returns null
   */
  currentlyFocusedField() {
    if (document.activeElement !== this._currentlyFocusedNode) {
      this._currentlyFocusedNode = null;
    }

    return this._currentlyFocusedNode;
  },

  /**
   * @param {Object} TextInputID id of the text field to focus
   * Focuses the specified text field
   * noop if the text field was already focused
   */
  focusTextInput(textFieldNode) {
    if (textFieldNode !== null) {
      this._currentlyFocusedNode = textFieldNode;

      if (document.activeElement !== textFieldNode) {
        _exports_UIManager__WEBPACK_IMPORTED_MODULE_0__/* ["default"].focus */ .Z.focus(textFieldNode);
      }
    }
  },

  /**
   * @param {Object} textFieldNode id of the text field to focus
   * Unfocuses the specified text field
   * noop if it wasn't focused
   */
  blurTextInput(textFieldNode) {
    if (textFieldNode !== null) {
      this._currentlyFocusedNode = null;

      if (document.activeElement === textFieldNode) {
        _exports_UIManager__WEBPACK_IMPORTED_MODULE_0__/* ["default"].blur */ .Z.blur(textFieldNode);
      }
    }
  }

};
/* harmony default export */ __webpack_exports__["Z"] = (TextInputState);

/***/ }),

/***/ 19017:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
/* harmony default export */ __webpack_exports__["Z"] = (canUseDOM);

/***/ }),

/***/ 45747:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31461);
/* harmony import */ var _AccessibilityUtil__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40819);
/* harmony import */ var _exports_StyleSheet__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66068);

var _excluded = ["accessibilityActiveDescendant", "accessibilityAtomic", "accessibilityAutoComplete", "accessibilityBusy", "accessibilityChecked", "accessibilityColumnCount", "accessibilityColumnIndex", "accessibilityColumnSpan", "accessibilityControls", "accessibilityCurrent", "accessibilityDescribedBy", "accessibilityDetails", "accessibilityDisabled", "accessibilityErrorMessage", "accessibilityExpanded", "accessibilityFlowTo", "accessibilityHasPopup", "accessibilityHidden", "accessibilityInvalid", "accessibilityKeyShortcuts", "accessibilityLabel", "accessibilityLabelledBy", "accessibilityLevel", "accessibilityLiveRegion", "accessibilityModal", "accessibilityMultiline", "accessibilityMultiSelectable", "accessibilityOrientation", "accessibilityOwns", "accessibilityPlaceholder", "accessibilityPosInSet", "accessibilityPressed", "accessibilityReadOnly", "accessibilityRequired", "accessibilityRole", "accessibilityRoleDescription", "accessibilityRowCount", "accessibilityRowIndex", "accessibilityRowSpan", "accessibilitySelected", "accessibilitySetSize", "accessibilitySort", "accessibilityValueMax", "accessibilityValueMin", "accessibilityValueNow", "accessibilityValueText", "dataSet", "focusable", "nativeID", "pointerEvents", "style", "testID"];

/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


var emptyObject = {};
var hasOwnProperty = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;
var uppercasePattern = /[A-Z]/g;

function toHyphenLower(match) {
  return '-' + match.toLowerCase();
}

function hyphenateString(str) {
  return str.replace(uppercasePattern, toHyphenLower);
}

function processIDRefList(idRefList) {
  return isArray(idRefList) ? idRefList.join(' ') : idRefList;
}

var pointerEventsStyles = _exports_StyleSheet__WEBPACK_IMPORTED_MODULE_0__/* ["default"].create */ .Z.create({
  auto: {
    pointerEvents: 'auto'
  },
  'box-none': {
    pointerEvents: 'box-none'
  },
  'box-only': {
    pointerEvents: 'box-only'
  },
  none: {
    pointerEvents: 'none'
  }
});

var createDOMProps = (elementType, props, options) => {
  if (!props) {
    props = emptyObject;
  }

  var _props = props,
      accessibilityActiveDescendant = _props.accessibilityActiveDescendant,
      accessibilityAtomic = _props.accessibilityAtomic,
      accessibilityAutoComplete = _props.accessibilityAutoComplete,
      accessibilityBusy = _props.accessibilityBusy,
      accessibilityChecked = _props.accessibilityChecked,
      accessibilityColumnCount = _props.accessibilityColumnCount,
      accessibilityColumnIndex = _props.accessibilityColumnIndex,
      accessibilityColumnSpan = _props.accessibilityColumnSpan,
      accessibilityControls = _props.accessibilityControls,
      accessibilityCurrent = _props.accessibilityCurrent,
      accessibilityDescribedBy = _props.accessibilityDescribedBy,
      accessibilityDetails = _props.accessibilityDetails,
      accessibilityDisabled = _props.accessibilityDisabled,
      accessibilityErrorMessage = _props.accessibilityErrorMessage,
      accessibilityExpanded = _props.accessibilityExpanded,
      accessibilityFlowTo = _props.accessibilityFlowTo,
      accessibilityHasPopup = _props.accessibilityHasPopup,
      accessibilityHidden = _props.accessibilityHidden,
      accessibilityInvalid = _props.accessibilityInvalid,
      accessibilityKeyShortcuts = _props.accessibilityKeyShortcuts,
      accessibilityLabel = _props.accessibilityLabel,
      accessibilityLabelledBy = _props.accessibilityLabelledBy,
      accessibilityLevel = _props.accessibilityLevel,
      accessibilityLiveRegion = _props.accessibilityLiveRegion,
      accessibilityModal = _props.accessibilityModal,
      accessibilityMultiline = _props.accessibilityMultiline,
      accessibilityMultiSelectable = _props.accessibilityMultiSelectable,
      accessibilityOrientation = _props.accessibilityOrientation,
      accessibilityOwns = _props.accessibilityOwns,
      accessibilityPlaceholder = _props.accessibilityPlaceholder,
      accessibilityPosInSet = _props.accessibilityPosInSet,
      accessibilityPressed = _props.accessibilityPressed,
      accessibilityReadOnly = _props.accessibilityReadOnly,
      accessibilityRequired = _props.accessibilityRequired,
      accessibilityRole = _props.accessibilityRole,
      accessibilityRoleDescription = _props.accessibilityRoleDescription,
      accessibilityRowCount = _props.accessibilityRowCount,
      accessibilityRowIndex = _props.accessibilityRowIndex,
      accessibilityRowSpan = _props.accessibilityRowSpan,
      accessibilitySelected = _props.accessibilitySelected,
      accessibilitySetSize = _props.accessibilitySetSize,
      accessibilitySort = _props.accessibilitySort,
      accessibilityValueMax = _props.accessibilityValueMax,
      accessibilityValueMin = _props.accessibilityValueMin,
      accessibilityValueNow = _props.accessibilityValueNow,
      accessibilityValueText = _props.accessibilityValueText,
      dataSet = _props.dataSet,
      focusable = _props.focusable,
      nativeID = _props.nativeID,
      pointerEvents = _props.pointerEvents,
      style = _props.style,
      testID = _props.testID,
      domProps = (0,_babel_runtime_helpers_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_props, _excluded);

  var disabled = accessibilityDisabled;
  var role = _AccessibilityUtil__WEBPACK_IMPORTED_MODULE_2__/* ["default"].propsToAriaRole */ .Z.propsToAriaRole(props); // ACCESSIBILITY

  if (accessibilityActiveDescendant != null) {
    domProps['aria-activedescendant'] = accessibilityActiveDescendant;
  }

  if (accessibilityAtomic != null) {
    domProps['aria-atomic'] = accessibilityAtomic;
  }

  if (accessibilityAutoComplete != null) {
    domProps['aria-autocomplete'] = accessibilityAutoComplete;
  }

  if (accessibilityBusy != null) {
    domProps['aria-busy'] = accessibilityBusy;
  }

  if (accessibilityChecked != null) {
    domProps['aria-checked'] = accessibilityChecked;
  }

  if (accessibilityColumnCount != null) {
    domProps['aria-colcount'] = accessibilityColumnCount;
  }

  if (accessibilityColumnIndex != null) {
    domProps['aria-colindex'] = accessibilityColumnIndex;
  }

  if (accessibilityColumnSpan != null) {
    domProps['aria-colspan'] = accessibilityColumnSpan;
  }

  if (accessibilityControls != null) {
    domProps['aria-controls'] = processIDRefList(accessibilityControls);
  }

  if (accessibilityCurrent != null) {
    domProps['aria-current'] = accessibilityCurrent;
  }

  if (accessibilityDescribedBy != null) {
    domProps['aria-describedby'] = processIDRefList(accessibilityDescribedBy);
  }

  if (accessibilityDetails != null) {
    domProps['aria-details'] = accessibilityDetails;
  }

  if (disabled === true) {
    domProps['aria-disabled'] = true; // Enhance with native semantics

    if (elementType === 'button' || elementType === 'form' || elementType === 'input' || elementType === 'select' || elementType === 'textarea') {
      domProps.disabled = true;
    }
  }

  if (accessibilityErrorMessage != null) {
    domProps['aria-errormessage'] = accessibilityErrorMessage;
  }

  if (accessibilityExpanded != null) {
    domProps['aria-expanded'] = accessibilityExpanded;
  }

  if (accessibilityFlowTo != null) {
    domProps['aria-flowto'] = processIDRefList(accessibilityFlowTo);
  }

  if (accessibilityHasPopup != null) {
    domProps['aria-haspopup'] = accessibilityHasPopup;
  }

  if (accessibilityHidden === true) {
    domProps['aria-hidden'] = accessibilityHidden;
  }

  if (accessibilityInvalid != null) {
    domProps['aria-invalid'] = accessibilityInvalid;
  }

  if (accessibilityKeyShortcuts != null && Array.isArray(accessibilityKeyShortcuts)) {
    domProps['aria-keyshortcuts'] = accessibilityKeyShortcuts.join(' ');
  }

  if (accessibilityLabel != null) {
    domProps['aria-label'] = accessibilityLabel;
  }

  if (accessibilityLabelledBy != null) {
    domProps['aria-labelledby'] = processIDRefList(accessibilityLabelledBy);
  }

  if (accessibilityLevel != null) {
    domProps['aria-level'] = accessibilityLevel;
  }

  if (accessibilityLiveRegion != null) {
    domProps['aria-live'] = accessibilityLiveRegion === 'none' ? 'off' : accessibilityLiveRegion;
  }

  if (accessibilityModal != null) {
    domProps['aria-modal'] = accessibilityModal;
  }

  if (accessibilityMultiline != null) {
    domProps['aria-multiline'] = accessibilityMultiline;
  }

  if (accessibilityMultiSelectable != null) {
    domProps['aria-multiselectable'] = accessibilityMultiSelectable;
  }

  if (accessibilityOrientation != null) {
    domProps['aria-orientation'] = accessibilityOrientation;
  }

  if (accessibilityOwns != null) {
    domProps['aria-owns'] = processIDRefList(accessibilityOwns);
  }

  if (accessibilityPlaceholder != null) {
    domProps['aria-placeholder'] = accessibilityPlaceholder;
  }

  if (accessibilityPosInSet != null) {
    domProps['aria-posinset'] = accessibilityPosInSet;
  }

  if (accessibilityPressed != null) {
    domProps['aria-pressed'] = accessibilityPressed;
  }

  if (accessibilityReadOnly != null) {
    domProps['aria-readonly'] = accessibilityReadOnly; // Enhance with native semantics

    if (elementType === 'input' || elementType === 'select' || elementType === 'textarea') {
      domProps.readOnly = true;
    }
  }

  if (accessibilityRequired != null) {
    domProps['aria-required'] = accessibilityRequired; // Enhance with native semantics

    if (elementType === 'input' || elementType === 'select' || elementType === 'textarea') {
      domProps.required = accessibilityRequired;
    }
  }

  if (role != null) {
    // 'presentation' synonym has wider browser support
    domProps['role'] = role === 'none' ? 'presentation' : role;
  }

  if (accessibilityRoleDescription != null) {
    domProps['aria-roledescription'] = accessibilityRoleDescription;
  }

  if (accessibilityRowCount != null) {
    domProps['aria-rowcount'] = accessibilityRowCount;
  }

  if (accessibilityRowIndex != null) {
    domProps['aria-rowindex'] = accessibilityRowIndex;
  }

  if (accessibilityRowSpan != null) {
    domProps['aria-rowspan'] = accessibilityRowSpan;
  }

  if (accessibilitySelected != null) {
    domProps['aria-selected'] = accessibilitySelected;
  }

  if (accessibilitySetSize != null) {
    domProps['aria-setsize'] = accessibilitySetSize;
  }

  if (accessibilitySort != null) {
    domProps['aria-sort'] = accessibilitySort;
  }

  if (accessibilityValueMax != null) {
    domProps['aria-valuemax'] = accessibilityValueMax;
  }

  if (accessibilityValueMin != null) {
    domProps['aria-valuemin'] = accessibilityValueMin;
  }

  if (accessibilityValueNow != null) {
    domProps['aria-valuenow'] = accessibilityValueNow;
  }

  if (accessibilityValueText != null) {
    domProps['aria-valuetext'] = accessibilityValueText;
  } // "dataSet" replaced with "data-*"


  if (dataSet != null) {
    for (var dataProp in dataSet) {
      if (hasOwnProperty.call(dataSet, dataProp)) {
        var dataName = hyphenateString(dataProp);
        var dataValue = dataSet[dataProp];

        if (dataValue != null) {
          domProps["data-" + dataName] = dataValue;
        }
      }
    }
  } // FOCUS
  // "focusable" indicates that an element may be a keyboard tab-stop.


  if (focusable === false) {
    domProps.tabIndex = '-1';
  }

  if ( // These native elements are keyboard focusable by default
  elementType === 'a' || elementType === 'button' || elementType === 'input' || elementType === 'select' || elementType === 'textarea') {
    if (focusable === false || accessibilityDisabled === true) {
      domProps.tabIndex = '-1';
    }
  } else if ( // These roles are made keyboard focusable by default
  role === 'button' || role === 'checkbox' || role === 'link' || role === 'radio' || role === 'textbox' || role === 'switch') {
    if (focusable !== false) {
      domProps.tabIndex = '0';
    }
  } else {
    // Everything else must explicitly set the prop
    if (focusable === true) {
      domProps.tabIndex = '0';
    }
  } // Resolve styles


  var _StyleSheet = (0,_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([style, pointerEvents && pointerEventsStyles[pointerEvents]], {
    writingDirection: options ? options.writingDirection : 'ltr'
  }),
      className = _StyleSheet[0],
      inlineStyle = _StyleSheet[1];

  if (className) {
    domProps.className = className;
  }

  if (inlineStyle) {
    domProps.style = inlineStyle;
  } // OTHER
  // Native element ID


  if (nativeID != null) {
    domProps.id = nativeID;
  } // Automated test IDs


  if (testID != null) {
    domProps['data-testid'] = testID;
  }

  return domProps;
};

/* harmony default export */ __webpack_exports__["Z"] = (createDOMProps);

/***/ }),

/***/ 9198:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _TextInputState__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1736);
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


var dismissKeyboard = () => {
  _TextInputState__WEBPACK_IMPORTED_MODULE_0__/* ["default"].blurTextInput */ .Z.blurTextInput(_TextInputState__WEBPACK_IMPORTED_MODULE_0__/* ["default"].currentlyFocusedField */ .Z.currentlyFocusedField());
};

/* harmony default export */ __webpack_exports__["Z"] = (dismissKeyboard);

/***/ }),

/***/ 30464:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E5": function() { return /* binding */ touchProps; },
/* harmony export */   "LO": function() { return /* binding */ accessibilityProps; },
/* harmony export */   "Uy": function() { return /* binding */ keyboardProps; },
/* harmony export */   "YB": function() { return /* binding */ focusProps; },
/* harmony export */   "_T": function() { return /* binding */ clickProps; },
/* harmony export */   "hJ": function() { return /* binding */ mouseProps; },
/* harmony export */   "lG": function() { return /* binding */ defaultProps; },
/* harmony export */   "vr": function() { return /* binding */ styleProps; }
/* harmony export */ });
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */
var defaultProps = {
  children: true,
  dataSet: true,
  nativeID: true,
  ref: true,
  suppressHydrationWarning: true,
  testID: true
};
var accessibilityProps = {
  accessibilityActiveDescendant: true,
  accessibilityAtomic: true,
  accessibilityAutoComplete: true,
  accessibilityBusy: true,
  accessibilityChecked: true,
  accessibilityColumnCount: true,
  accessibilityColumnIndex: true,
  accessibilityColumnSpan: true,
  accessibilityControls: true,
  accessibilityCurrent: true,
  accessibilityDescribedBy: true,
  accessibilityDetails: true,
  accessibilityDisabled: true,
  accessibilityErrorMessage: true,
  accessibilityExpanded: true,
  accessibilityFlowTo: true,
  accessibilityHasPopup: true,
  accessibilityHidden: true,
  accessibilityInvalid: true,
  accessibilityKeyShortcuts: true,
  accessibilityLabel: true,
  accessibilityLabelledBy: true,
  accessibilityLevel: true,
  accessibilityLiveRegion: true,
  accessibilityModal: true,
  accessibilityMultiline: true,
  accessibilityMultiSelectable: true,
  accessibilityOrientation: true,
  accessibilityOwns: true,
  accessibilityPlaceholder: true,
  accessibilityPosInSet: true,
  accessibilityPressed: true,
  accessibilityReadOnly: true,
  accessibilityRequired: true,
  accessibilityRole: true,
  accessibilityRoleDescription: true,
  accessibilityRowCount: true,
  accessibilityRowIndex: true,
  accessibilityRowSpan: true,
  accessibilitySelected: true,
  accessibilitySetSize: true,
  accessibilitySort: true,
  accessibilityValueMax: true,
  accessibilityValueMin: true,
  accessibilityValueNow: true,
  accessibilityValueText: true,
  dir: true,
  focusable: true
};
var clickProps = {
  onClick: true,
  onClickCapture: true,
  onContextMenu: true
};
var focusProps = {
  onBlur: true,
  onFocus: true
};
var keyboardProps = {
  onKeyDown: true,
  onKeyDownCapture: true,
  onKeyUp: true,
  onKeyUpCapture: true
};
var mouseProps = {
  onMouseDown: true,
  onMouseEnter: true,
  onMouseLeave: true,
  onMouseMove: true,
  onMouseOver: true,
  onMouseOut: true,
  onMouseUp: true
};
var touchProps = {
  onTouchCancel: true,
  onTouchCancelCapture: true,
  onTouchEnd: true,
  onTouchEndCapture: true,
  onTouchMove: true,
  onTouchMoveCapture: true,
  onTouchStart: true,
  onTouchStartCapture: true
};
var styleProps = {
  classList: true,
  style: true
};

/***/ }),

/***/ 47351:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */
var getBoundingClientRect = node => {
  if (node != null) {
    var isElement = node.nodeType === 1;
    /* Node.ELEMENT_NODE */

    if (isElement && typeof node.getBoundingClientRect === 'function') {
      return node.getBoundingClientRect();
    }
  }
};

/* harmony default export */ __webpack_exports__["Z"] = (getBoundingClientRect);

/***/ }),

/***/ 88212:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ mergeRefs; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function mergeRefs() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return function forwardRef(node) {
    args.forEach(ref => {
      if (ref == null) {
        return;
      }

      if (typeof ref === 'function') {
        ref(node);
        return;
      }

      if (typeof ref === 'object') {
        ref.current = node;
        return;
      }

      console.error("mergeRefs cannot handle Refs of type boolean, number or string, received ref " + String(ref));
    });
  };
}

/***/ }),

/***/ 89641:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ pick; }
/* harmony export */ });
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */
function pick(obj, list) {
  var nextObj = {};

  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      if (list[key] === true) {
        nextObj[key] = obj[key];
      }
    }
  }

  return nextObj;
}

/***/ }),

/***/ 17709:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useElementLayout; }
/* harmony export */ });
/* harmony import */ var _useLayoutEffect__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56905);
/* harmony import */ var _exports_UIManager__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96187);
/* harmony import */ var _canUseDom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19017);
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var DOM_LAYOUT_HANDLER_NAME = '__reactLayoutHandler';
var didWarn = !_canUseDom__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z;
var resizeObserver = null;

function getResizeObserver() {
  if (_canUseDom__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z && typeof window.ResizeObserver !== 'undefined') {
    if (resizeObserver == null) {
      resizeObserver = new window.ResizeObserver(function (entries) {
        entries.forEach(entry => {
          var node = entry.target;
          var onLayout = node[DOM_LAYOUT_HANDLER_NAME];

          if (typeof onLayout === 'function') {
            // We still need to measure the view because browsers don't yet provide
            // border-box dimensions in the entry
            _exports_UIManager__WEBPACK_IMPORTED_MODULE_1__/* ["default"].measure */ .Z.measure(node, (x, y, width, height, left, top) => {
              var event = {
                // $FlowFixMe
                nativeEvent: {
                  layout: {
                    x,
                    y,
                    width,
                    height,
                    left,
                    top
                  }
                },
                timeStamp: Date.now()
              };
              Object.defineProperty(event.nativeEvent, 'target', {
                enumerable: true,
                get: () => entry.target
              });
              onLayout(event);
            });
          }
        });
      });
    }
  } else if (!didWarn) {
    if (false) {}
  }

  return resizeObserver;
}

function useElementLayout(ref, onLayout) {
  var observer = getResizeObserver();
  (0,_useLayoutEffect__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(() => {
    var node = ref.current;

    if (node != null) {
      node[DOM_LAYOUT_HANDLER_NAME] = onLayout;
    }
  }, [ref, onLayout]); // Observing is done in a separate effect to avoid this effect running
  // when 'onLayout' changes.

  (0,_useLayoutEffect__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(() => {
    var node = ref.current;

    if (node != null && observer != null) {
      if (typeof node[DOM_LAYOUT_HANDLER_NAME] === 'function') {
        observer.observe(node);
      } else {
        observer.unobserve(node);
      }
    }

    return () => {
      if (node != null && observer != null) {
        observer.unobserve(node);
      }
    };
  }, [ref, observer]);
}

/***/ }),

/***/ 56905:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _canUseDom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19017);
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * useLayoutEffect throws an error on the server. On the few occasions where is
 * problematic, use this hook.
 *
 * 
 */


var useLayoutEffectImpl = _canUseDom__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : react__WEBPACK_IMPORTED_MODULE_0__.useEffect;
/* harmony default export */ __webpack_exports__["Z"] = (useLayoutEffectImpl);

/***/ }),

/***/ 38639:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Iw": function() { return /* binding */ LocaleProvider; },
  "w1": function() { return /* binding */ getLocaleDirection; },
  "PE": function() { return /* binding */ useLocaleContext; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/modules/useLocale/isLocaleRTL.js
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */
var rtlScripts = new Set(['Arab', 'Syrc', 'Samr', 'Mand', 'Thaa', 'Mend', 'Nkoo', 'Adlm', 'Rohg', 'Hebr']);
var rtlLangs = new Set(['ae', // Avestan
'ar', // Arabic
'arc', // Aramaic
'bcc', // Southern Balochi
'bqi', // Bakthiari
'ckb', // Sorani
'dv', // Dhivehi
'fa', 'far', // Persian
'glk', // Gilaki
'he', 'iw', // Hebrew
'khw', // Khowar
'ks', // Kashmiri
'ku', // Kurdish
'mzn', // Mazanderani
'nqo', // N'Ko
'pnb', // Western Punjabi
'ps', // Pashto
'sd', // Sindhi
'ug', // Uyghur
'ur', // Urdu
'yi' // Yiddish
]);
var cache = new Map();
/**
 * Determine the writing direction of a locale
 */

function isLocaleRTL(locale) {
  var cachedRTL = cache.get(locale);

  if (cachedRTL) {
    return cachedRTL;
  }

  var isRTL = false; // $FlowFixMe

  if (Intl.Locale) {
    // $FlowFixMe
    var script = new Intl.Locale(locale).maximize().script;
    isRTL = rtlScripts.has(script);
  } else {
    // Fallback to inferring from language
    var lang = locale.split('-')[0];
    isRTL = rtlLangs.has(lang);
  }

  cache.set(locale, isRTL);
  return isRTL;
}
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/modules/useLocale/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


var defaultLocale = {
  direction: 'ltr',
  locale: 'en-US'
};
var LocaleContext = /*#__PURE__*/(0,react.createContext)(defaultLocale);
function getLocaleDirection(locale) {
  return isLocaleRTL(locale) ? 'rtl' : 'ltr';
}
function LocaleProvider(props) {
  var direction = props.direction,
      locale = props.locale,
      children = props.children;
  var needsContext = direction || locale;
  return needsContext ? /*#__PURE__*/react.createElement(LocaleContext.Provider, {
    children: children,
    value: {
      direction: locale ? getLocaleDirection(locale) : direction,
      locale
    }
  }) : children;
}
function useLocaleContext() {
  return (0,react.useContext)(LocaleContext);
}

/***/ }),

/***/ 52778:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useMergeRefs; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _mergeRefs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88212);
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


function useMergeRefs() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => (0,_mergeRefs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(...args), // eslint-disable-next-line
  [...args]);
}

/***/ }),

/***/ 5719:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ usePlatformMethods; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_objectSpread2__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29405);
/* harmony import */ var _exports_UIManager__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96187);
/* harmony import */ var _createDOMProps__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45747);
/* harmony import */ var _useStable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9121);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);


/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */




var didWarn = false;
var emptyObject = {};

function setNativeProps(node, nativeProps, pointerEvents, style, previousStyleRef) {
  if (!didWarn) {
    console.warn('setNativeProps is deprecated. Please update props using React state instead.');
    didWarn = true;
  }

  if (node != null && nativeProps) {
    var domProps = (0,_createDOMProps__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(null, (0,_babel_runtime_helpers_objectSpread2__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_babel_runtime_helpers_objectSpread2__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
      pointerEvents
    }, nativeProps), {}, {
      style: [style, nativeProps.style]
    }));
    var nextDomStyle = domProps.style;

    if (previousStyleRef.current != null) {
      if (domProps.style == null) {
        domProps.style = {};
      }

      for (var styleName in previousStyleRef.current) {
        if (domProps.style[styleName] == null) {
          domProps.style[styleName] = '';
        }
      }
    }

    previousStyleRef.current = nextDomStyle;
    _exports_UIManager__WEBPACK_IMPORTED_MODULE_3__/* ["default"].updateView */ .Z.updateView(node, domProps);
  }
}
/**
 * Adds non-standard methods to the hode element. This is temporarily until an
 * API like `ReactNative.measure(hostRef, callback)` is added to React Native.
 */


function usePlatformMethods(_ref) {
  var pointerEvents = _ref.pointerEvents,
      style = _ref.style;
  var previousStyleRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  var setNativePropsArgsRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  setNativePropsArgsRef.current = {
    pointerEvents,
    style
  }; // Avoid creating a new ref on every render. The props only need to be
  // available to 'setNativeProps' when it is called.

  var ref = (0,_useStable__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(() => hostNode => {
    if (hostNode != null) {
      hostNode.measure = callback => _exports_UIManager__WEBPACK_IMPORTED_MODULE_3__/* ["default"].measure */ .Z.measure(hostNode, callback);

      hostNode.measureLayout = (relativeToNode, success, failure) => _exports_UIManager__WEBPACK_IMPORTED_MODULE_3__/* ["default"].measureLayout */ .Z.measureLayout(hostNode, relativeToNode, failure, success);

      hostNode.measureInWindow = callback => _exports_UIManager__WEBPACK_IMPORTED_MODULE_3__/* ["default"].measureInWindow */ .Z.measureInWindow(hostNode, callback);

      hostNode.setNativeProps = nativeProps => {
        var _ref2 = setNativePropsArgsRef.current || emptyObject,
            style = _ref2.style,
            pointerEvents = _ref2.pointerEvents;

        setNativeProps(hostNode, nativeProps, pointerEvents, style, previousStyleRef);
      };
    }
  });
  return ref;
}

/***/ }),

/***/ 20011:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useResponderEvents; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/modules/getBoundingClientRect/index.js
var getBoundingClientRect = __webpack_require__(47351);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/modules/useResponderEvents/createResponderEvent.js
/**
 * Copyright (c) Nicolas Gallagher
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


var emptyFunction = () => {};

var emptyObject = {};
var emptyArray = [];
/**
 * Safari produces very large identifiers that would cause the `touchBank` array
 * length to be so large as to crash the browser, if not normalized like this.
 * In the future the `touchBank` should use an object/map instead.
 */

function normalizeIdentifier(identifier) {
  return identifier > 20 ? identifier % 20 : identifier;
}
/**
 * Converts a native DOM event to a ResponderEvent.
 * Mouse events are transformed into fake touch events.
 */


function createResponderEvent(domEvent, responderTouchHistoryStore) {
  var rect;
  var propagationWasStopped = false;
  var changedTouches;
  var touches;
  var domEventChangedTouches = domEvent.changedTouches;
  var domEventType = domEvent.type;
  var metaKey = domEvent.metaKey === true;
  var shiftKey = domEvent.shiftKey === true;
  var force = domEventChangedTouches && domEventChangedTouches[0].force || 0;
  var identifier = normalizeIdentifier(domEventChangedTouches && domEventChangedTouches[0].identifier || 0);
  var clientX = domEventChangedTouches && domEventChangedTouches[0].clientX || domEvent.clientX;
  var clientY = domEventChangedTouches && domEventChangedTouches[0].clientY || domEvent.clientY;
  var pageX = domEventChangedTouches && domEventChangedTouches[0].pageX || domEvent.pageX;
  var pageY = domEventChangedTouches && domEventChangedTouches[0].pageY || domEvent.pageY;
  var preventDefault = typeof domEvent.preventDefault === 'function' ? domEvent.preventDefault.bind(domEvent) : emptyFunction;
  var timestamp = domEvent.timeStamp;

  function normalizeTouches(touches) {
    return Array.prototype.slice.call(touches).map(touch => {
      return {
        force: touch.force,
        identifier: normalizeIdentifier(touch.identifier),

        get locationX() {
          return locationX(touch.clientX);
        },

        get locationY() {
          return locationY(touch.clientY);
        },

        pageX: touch.pageX,
        pageY: touch.pageY,
        target: touch.target,
        timestamp
      };
    });
  }

  if (domEventChangedTouches != null) {
    changedTouches = normalizeTouches(domEventChangedTouches);
    touches = normalizeTouches(domEvent.touches);
  } else {
    var emulatedTouches = [{
      force,
      identifier,

      get locationX() {
        return locationX(clientX);
      },

      get locationY() {
        return locationY(clientY);
      },

      pageX,
      pageY,
      target: domEvent.target,
      timestamp
    }];
    changedTouches = emulatedTouches;
    touches = domEventType === 'mouseup' || domEventType === 'dragstart' ? emptyArray : emulatedTouches;
  }

  var responderEvent = {
    bubbles: true,
    cancelable: true,
    // `currentTarget` is set before dispatch
    currentTarget: null,
    defaultPrevented: domEvent.defaultPrevented,
    dispatchConfig: emptyObject,
    eventPhase: domEvent.eventPhase,

    isDefaultPrevented() {
      return domEvent.defaultPrevented;
    },

    isPropagationStopped() {
      return propagationWasStopped;
    },

    isTrusted: domEvent.isTrusted,
    nativeEvent: {
      altKey: false,
      ctrlKey: false,
      metaKey,
      shiftKey,
      changedTouches,
      force,
      identifier,

      get locationX() {
        return locationX(clientX);
      },

      get locationY() {
        return locationY(clientY);
      },

      pageX,
      pageY,
      target: domEvent.target,
      timestamp,
      touches,
      type: domEventType
    },
    persist: emptyFunction,
    preventDefault,

    stopPropagation() {
      propagationWasStopped = true;
    },

    target: domEvent.target,
    timeStamp: timestamp,
    touchHistory: responderTouchHistoryStore.touchHistory
  }; // Using getters and functions serves two purposes:
  // 1) The value of `currentTarget` is not initially available.
  // 2) Measuring the clientRect may cause layout jank and should only be done on-demand.

  function locationX(x) {
    rect = rect || (0,getBoundingClientRect/* default */.Z)(responderEvent.currentTarget);

    if (rect) {
      return x - rect.left;
    }
  }

  function locationY(y) {
    rect = rect || (0,getBoundingClientRect/* default */.Z)(responderEvent.currentTarget);

    if (rect) {
      return y - rect.top;
    }
  }

  return responderEvent;
}
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/modules/useResponderEvents/ResponderEventTypes.js
/**
 * Copyright (c) Nicolas Gallagher
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */
var BLUR = 'blur';
var CONTEXT_MENU = 'contextmenu';
var FOCUS_OUT = 'focusout';
var MOUSE_DOWN = 'mousedown';
var MOUSE_MOVE = 'mousemove';
var MOUSE_UP = 'mouseup';
var MOUSE_CANCEL = 'dragstart';
var TOUCH_START = 'touchstart';
var TOUCH_MOVE = 'touchmove';
var TOUCH_END = 'touchend';
var TOUCH_CANCEL = 'touchcancel';
var SCROLL = 'scroll';
var SELECT = 'select';
var SELECTION_CHANGE = 'selectionchange';
function isStartish(eventType) {
  return eventType === TOUCH_START || eventType === MOUSE_DOWN;
}
function isMoveish(eventType) {
  return eventType === TOUCH_MOVE || eventType === MOUSE_MOVE;
}
function isEndish(eventType) {
  return eventType === TOUCH_END || eventType === MOUSE_UP || isCancelish(eventType);
}
function isCancelish(eventType) {
  return eventType === TOUCH_CANCEL || eventType === MOUSE_CANCEL;
}
function isScroll(eventType) {
  return eventType === SCROLL;
}
function isSelectionChange(eventType) {
  return eventType === SELECT || eventType === SELECTION_CHANGE;
}
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/modules/isSelectionValid/index.js
/**
 * Copyright (c) Nicolas Gallagher
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */
function isSelectionValid() {
  var selection = window.getSelection();
  var string = selection.toString();
  var anchorNode = selection.anchorNode;
  var focusNode = selection.focusNode;
  var isTextNode = anchorNode && anchorNode.nodeType === window.Node.TEXT_NODE || focusNode && focusNode.nodeType === window.Node.TEXT_NODE;
  return string.length >= 1 && string !== '\n' && isTextNode;
}
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/modules/useResponderEvents/utils.js
/**
 * Copyright (c) Nicolas Gallagher
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var keyName = '__reactResponderId';

function getEventPath(domEvent) {
  // The 'selectionchange' event always has the 'document' as the target.
  // Use the anchor node as the initial target to reconstruct a path.
  // (We actually only need the first "responder" node in practice.)
  if (domEvent.type === 'selectionchange') {
    var target = window.getSelection().anchorNode;
    return composedPathFallback(target);
  } else {
    var path = domEvent.composedPath != null ? domEvent.composedPath() : composedPathFallback(domEvent.target);
    return path;
  }
}

function composedPathFallback(target) {
  var path = [];

  while (target != null && target !== document.body) {
    path.push(target);
    target = target.parentNode;
  }

  return path;
}
/**
 * Retrieve the responderId from a host node
 */


function getResponderId(node) {
  if (node != null) {
    return node[keyName];
  }

  return null;
}
/**
 * Store the responderId on a host node
 */


function setResponderId(node, id) {
  if (node != null) {
    node[keyName] = id;
  }
}
/**
 * Filter the event path to contain only the nodes attached to the responder system
 */

function getResponderPaths(domEvent) {
  var idPath = [];
  var nodePath = [];
  var eventPath = getEventPath(domEvent);

  for (var i = 0; i < eventPath.length; i++) {
    var node = eventPath[i];
    var id = getResponderId(node);

    if (id != null) {
      idPath.push(id);
      nodePath.push(node);
    }
  }

  return {
    idPath,
    nodePath
  };
}
/**
 * Walk the paths and find the first common ancestor
 */

function getLowestCommonAncestor(pathA, pathB) {
  var pathALength = pathA.length;
  var pathBLength = pathB.length;

  if ( // If either path is empty
  pathALength === 0 || pathBLength === 0 || // If the last elements aren't the same there can't be a common ancestor
  // that is connected to the responder system
  pathA[pathALength - 1] !== pathB[pathBLength - 1]) {
    return null;
  }

  var itemA = pathA[0];
  var indexA = 0;
  var itemB = pathB[0];
  var indexB = 0; // If A is deeper, skip indices that can't match.

  if (pathALength - pathBLength > 0) {
    indexA = pathALength - pathBLength;
    itemA = pathA[indexA];
    pathALength = pathBLength;
  } // If B is deeper, skip indices that can't match


  if (pathBLength - pathALength > 0) {
    indexB = pathBLength - pathALength;
    itemB = pathB[indexB];
    pathBLength = pathALength;
  } // Walk in lockstep until a match is found


  var depth = pathALength;

  while (depth--) {
    if (itemA === itemB) {
      return itemA;
    }

    itemA = pathA[indexA++];
    itemB = pathB[indexB++];
  }

  return null;
}
/**
 * Determine whether any of the active touches are within the current responder.
 * This cannot rely on W3C `targetTouches`, as neither IE11 nor Safari implement it.
 */

function hasTargetTouches(target, touches) {
  if (!touches || touches.length === 0) {
    return false;
  }

  for (var i = 0; i < touches.length; i++) {
    var node = touches[i].target;

    if (node != null) {
      if (target.contains(node)) {
        return true;
      }
    }
  }

  return false;
}
/**
 * Ignore 'selectionchange' events that don't correspond with a person's intent to
 * select text.
 */

function hasValidSelection(domEvent) {
  if (domEvent.type === 'selectionchange') {
    return isSelectionValid();
  }

  return domEvent.type === 'select';
}
/**
 * Events are only valid if the primary button was used without specific modifier keys.
 */

function isPrimaryPointerDown(domEvent) {
  var altKey = domEvent.altKey,
      button = domEvent.button,
      buttons = domEvent.buttons,
      ctrlKey = domEvent.ctrlKey,
      type = domEvent.type;
  var isTouch = type === 'touchstart' || type === 'touchmove';
  var isPrimaryMouseDown = type === 'mousedown' && (button === 0 || buttons === 1);
  var isPrimaryMouseMove = type === 'mousemove' && buttons === 1;
  var noModifiers = altKey === false && ctrlKey === false;

  if (isTouch || isPrimaryMouseDown && noModifiers || isPrimaryMouseMove && noModifiers) {
    return true;
  }

  return false;
}
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/modules/useResponderEvents/ResponderTouchHistoryStore.js
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


/**
 * Tracks the position and time of each active touch by `touch.identifier`. We
 * should typically only see IDs in the range of 1-20 because IDs get recycled
 * when touches end and start again.
 */
var __DEV__ = "production" !== 'production';

var MAX_TOUCH_BANK = 20;

function timestampForTouch(touch) {
  // The legacy internal implementation provides "timeStamp", which has been
  // renamed to "timestamp".
  return touch.timeStamp || touch.timestamp;
}
/**
 * TODO: Instead of making gestures recompute filtered velocity, we could
 * include a built in velocity computation that can be reused globally.
 */


function createTouchRecord(touch) {
  return {
    touchActive: true,
    startPageX: touch.pageX,
    startPageY: touch.pageY,
    startTimeStamp: timestampForTouch(touch),
    currentPageX: touch.pageX,
    currentPageY: touch.pageY,
    currentTimeStamp: timestampForTouch(touch),
    previousPageX: touch.pageX,
    previousPageY: touch.pageY,
    previousTimeStamp: timestampForTouch(touch)
  };
}

function resetTouchRecord(touchRecord, touch) {
  touchRecord.touchActive = true;
  touchRecord.startPageX = touch.pageX;
  touchRecord.startPageY = touch.pageY;
  touchRecord.startTimeStamp = timestampForTouch(touch);
  touchRecord.currentPageX = touch.pageX;
  touchRecord.currentPageY = touch.pageY;
  touchRecord.currentTimeStamp = timestampForTouch(touch);
  touchRecord.previousPageX = touch.pageX;
  touchRecord.previousPageY = touch.pageY;
  touchRecord.previousTimeStamp = timestampForTouch(touch);
}

function getTouchIdentifier(_ref) {
  var identifier = _ref.identifier;

  if (identifier == null) {
    console.error('Touch object is missing identifier.');
  }

  if (__DEV__) {
    if (identifier > MAX_TOUCH_BANK) {
      console.error('Touch identifier %s is greater than maximum supported %s which causes ' + 'performance issues backfilling array locations for all of the indices.', identifier, MAX_TOUCH_BANK);
    }
  }

  return identifier;
}

function recordTouchStart(touch, touchHistory) {
  var identifier = getTouchIdentifier(touch);
  var touchRecord = touchHistory.touchBank[identifier];

  if (touchRecord) {
    resetTouchRecord(touchRecord, touch);
  } else {
    touchHistory.touchBank[identifier] = createTouchRecord(touch);
  }

  touchHistory.mostRecentTimeStamp = timestampForTouch(touch);
}

function recordTouchMove(touch, touchHistory) {
  var touchRecord = touchHistory.touchBank[getTouchIdentifier(touch)];

  if (touchRecord) {
    touchRecord.touchActive = true;
    touchRecord.previousPageX = touchRecord.currentPageX;
    touchRecord.previousPageY = touchRecord.currentPageY;
    touchRecord.previousTimeStamp = touchRecord.currentTimeStamp;
    touchRecord.currentPageX = touch.pageX;
    touchRecord.currentPageY = touch.pageY;
    touchRecord.currentTimeStamp = timestampForTouch(touch);
    touchHistory.mostRecentTimeStamp = timestampForTouch(touch);
  } else {
    console.warn('Cannot record touch move without a touch start.\n', "Touch Move: " + printTouch(touch) + "\n", "Touch Bank: " + printTouchBank(touchHistory));
  }
}

function recordTouchEnd(touch, touchHistory) {
  var touchRecord = touchHistory.touchBank[getTouchIdentifier(touch)];

  if (touchRecord) {
    touchRecord.touchActive = false;
    touchRecord.previousPageX = touchRecord.currentPageX;
    touchRecord.previousPageY = touchRecord.currentPageY;
    touchRecord.previousTimeStamp = touchRecord.currentTimeStamp;
    touchRecord.currentPageX = touch.pageX;
    touchRecord.currentPageY = touch.pageY;
    touchRecord.currentTimeStamp = timestampForTouch(touch);
    touchHistory.mostRecentTimeStamp = timestampForTouch(touch);
  } else {
    console.warn('Cannot record touch end without a touch start.\n', "Touch End: " + printTouch(touch) + "\n", "Touch Bank: " + printTouchBank(touchHistory));
  }
}

function printTouch(touch) {
  return JSON.stringify({
    identifier: touch.identifier,
    pageX: touch.pageX,
    pageY: touch.pageY,
    timestamp: timestampForTouch(touch)
  });
}

function printTouchBank(touchHistory) {
  var touchBank = touchHistory.touchBank;
  var printed = JSON.stringify(touchBank.slice(0, MAX_TOUCH_BANK));

  if (touchBank.length > MAX_TOUCH_BANK) {
    printed += ' (original size: ' + touchBank.length + ')';
  }

  return printed;
}

class ResponderTouchHistoryStore {
  constructor() {
    this._touchHistory = {
      touchBank: [],
      //Array<TouchRecord>
      numberActiveTouches: 0,
      // If there is only one active touch, we remember its location. This prevents
      // us having to loop through all of the touches all the time in the most
      // common case.
      indexOfSingleActiveTouch: -1,
      mostRecentTimeStamp: 0
    };
  }

  recordTouchTrack(topLevelType, nativeEvent) {
    var touchHistory = this._touchHistory;

    if (isMoveish(topLevelType)) {
      nativeEvent.changedTouches.forEach(touch => recordTouchMove(touch, touchHistory));
    } else if (isStartish(topLevelType)) {
      nativeEvent.changedTouches.forEach(touch => recordTouchStart(touch, touchHistory));
      touchHistory.numberActiveTouches = nativeEvent.touches.length;

      if (touchHistory.numberActiveTouches === 1) {
        touchHistory.indexOfSingleActiveTouch = nativeEvent.touches[0].identifier;
      }
    } else if (isEndish(topLevelType)) {
      nativeEvent.changedTouches.forEach(touch => recordTouchEnd(touch, touchHistory));
      touchHistory.numberActiveTouches = nativeEvent.touches.length;

      if (touchHistory.numberActiveTouches === 1) {
        var touchBank = touchHistory.touchBank;

        for (var i = 0; i < touchBank.length; i++) {
          var touchTrackToCheck = touchBank[i];

          if (touchTrackToCheck != null && touchTrackToCheck.touchActive) {
            touchHistory.indexOfSingleActiveTouch = i;
            break;
          }
        }

        if (__DEV__) {
          var activeRecord = touchBank[touchHistory.indexOfSingleActiveTouch];

          if (!(activeRecord != null && activeRecord.touchActive)) {
            console.error('Cannot find single active touch.');
          }
        }
      }
    }
  }

  get touchHistory() {
    return this._touchHistory;
  }

}
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/modules/canUseDom/index.js
var canUseDom = __webpack_require__(19017);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/modules/useResponderEvents/ResponderSystem.js
/**
 * Copyright (c) Nicolas Gallagher
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

/**
 * RESPONDER EVENT SYSTEM
 *
 * A single, global "interaction lock" on views. For a view to be the "responder" means
 * that pointer interactions are exclusive to that view and none other. The "interaction
 * lock" can be transferred (only) to ancestors of the current "responder" as long as
 * pointers continue to be active.
 *
 * Responder being granted:
 *
 * A view can become the "responder" after the following events:
 *  * "pointerdown" (implemented using "touchstart", "mousedown")
 *  * "pointermove" (implemented using "touchmove", "mousemove")
 *  * "scroll" (while a pointer is down)
 *  * "selectionchange" (while a pointer is down)
 *
 * If nothing is already the "responder", the event propagates to (capture) and from
 * (bubble) the event target until a view returns `true` for
 * `on*ShouldSetResponder(Capture)`.
 *
 * If something is already the responder, the event propagates to (capture) and from
 * (bubble) the lowest common ancestor of the event target and the current "responder".
 * Then negotiation happens between the current "responder" and a view that wants to
 * become the "responder": see the timing diagram below.
 *
 * (NOTE: Scrolled views either automatically become the "responder" or release the
 * "interaction lock". A native scroll view that isn't built on top of the responder
 * system must result in the current "responder" being notified that it no longer has
 * the "interaction lock" - the native system has taken over.
 *
 * Responder being released:
 *
 * As soon as there are no more active pointers that *started* inside descendants
 * of the *current* "responder", an `onResponderRelease` event is dispatched to the
 * current "responder", and the responder lock is released.
 *
 * Typical sequence of events:
 *  * startShouldSetResponder
 *  * responderGrant/Reject
 *  * responderStart
 *  * responderMove
 *  * responderEnd
 *  * responderRelease
 */

/*                                             Negotiation Performed
                                             +-----------------------+
                                            /                         \
Process low level events to    +     Current Responder      +   wantsResponderID
determine who to perform negot-|   (if any exists at all)   |
iation/transition              | Otherwise just pass through|
-------------------------------+----------------------------+------------------+
Bubble to find first ID        |                            |
to return true:wantsResponderID|                            |
                               |                            |
     +--------------+          |                            |
     | onTouchStart |          |                            |
     +------+-------+    none  |                            |
            |            return|                            |
+-----------v-------------+true| +------------------------+ |
|onStartShouldSetResponder|----->| onResponderStart (cur) |<-----------+
+-----------+-------------+    | +------------------------+ |          |
            |                  |                            | +--------+-------+
            | returned true for|       false:REJECT +-------->|onResponderReject
            | wantsResponderID |                    |       | +----------------+
            | (now attempt     | +------------------+-----+ |
            |  handoff)        | | onResponder            | |
            +------------------->|    TerminationRequest  | |
                               | +------------------+-----+ |
                               |                    |       | +----------------+
                               |         true:GRANT +-------->|onResponderGrant|
                               |                            | +--------+-------+
                               | +------------------------+ |          |
                               | | onResponderTerminate   |<-----------+
                               | +------------------+-----+ |
                               |                    |       | +----------------+
                               |                    +-------->|onResponderStart|
                               |                            | +----------------+
Bubble to find first ID        |                            |
to return true:wantsResponderID|                            |
                               |                            |
     +-------------+           |                            |
     | onTouchMove |           |                            |
     +------+------+     none  |                            |
            |            return|                            |
+-----------v-------------+true| +------------------------+ |
|onMoveShouldSetResponder |----->| onResponderMove (cur)  |<-----------+
+-----------+-------------+    | +------------------------+ |          |
            |                  |                            | +--------+-------+
            | returned true for|       false:REJECT +-------->|onResponderReject
            | wantsResponderID |                    |       | +----------------+
            | (now attempt     | +------------------+-----+ |
            |  handoff)        | |   onResponder          | |
            +------------------->|      TerminationRequest| |
                               | +------------------+-----+ |
                               |                    |       | +----------------+
                               |         true:GRANT +-------->|onResponderGrant|
                               |                            | +--------+-------+
                               | +------------------------+ |          |
                               | |   onResponderTerminate |<-----------+
                               | +------------------+-----+ |
                               |                    |       | +----------------+
                               |                    +-------->|onResponderMove |
                               |                            | +----------------+
                               |                            |
                               |                            |
      Some active touch started|                            |
      inside current responder | +------------------------+ |
      +------------------------->|      onResponderEnd    | |
      |                        | +------------------------+ |
  +---+---------+              |                            |
  | onTouchEnd  |              |                            |
  +---+---------+              |                            |
      |                        | +------------------------+ |
      +------------------------->|     onResponderEnd     | |
      No active touches started| +-----------+------------+ |
      inside current responder |             |              |
                               |             v              |
                               | +------------------------+ |
                               | |    onResponderRelease  | |
                               | +------------------------+ |
                               |                            |
                               +                            + */





/* ------------ TYPES ------------ */

var ResponderSystem_emptyObject = {};
/* ------------ IMPLEMENTATION ------------ */

var startRegistration = ['onStartShouldSetResponderCapture', 'onStartShouldSetResponder', {
  bubbles: true
}];
var moveRegistration = ['onMoveShouldSetResponderCapture', 'onMoveShouldSetResponder', {
  bubbles: true
}];
var scrollRegistration = ['onScrollShouldSetResponderCapture', 'onScrollShouldSetResponder', {
  bubbles: false
}];
var shouldSetResponderEvents = {
  touchstart: startRegistration,
  mousedown: startRegistration,
  touchmove: moveRegistration,
  mousemove: moveRegistration,
  scroll: scrollRegistration
};
var emptyResponder = {
  id: null,
  idPath: null,
  node: null
};
var responderListenersMap = new Map();
var isEmulatingMouseEvents = false;
var trackedTouchCount = 0;
var currentResponder = {
  id: null,
  node: null,
  idPath: null
};
var responderTouchHistoryStore = new ResponderTouchHistoryStore();

function changeCurrentResponder(responder) {
  currentResponder = responder;
}

function getResponderConfig(id) {
  var config = responderListenersMap.get(id);
  return config != null ? config : ResponderSystem_emptyObject;
}
/**
 * Process native events
 *
 * A single event listener is used to manage the responder system.
 * All pointers are tracked in the ResponderTouchHistoryStore. Native events
 * are interpreted in terms of the Responder System and checked to see if
 * the responder should be transferred. Each host node that is attached to
 * the Responder System has an ID, which is used to look up its associated
 * callbacks.
 */


function eventListener(domEvent) {
  var eventType = domEvent.type;
  var eventTarget = domEvent.target;
  /**
   * Manage emulated events and early bailout.
   * Since PointerEvent is not used yet (lack of support in older Safari), it's
   * necessary to manually manage the mess of browser touch/mouse events.
   * And bailout early for termination events when there is no active responder.
   */
  // Flag when browser may produce emulated events

  if (eventType === 'touchstart') {
    isEmulatingMouseEvents = true;
  } // Remove flag when browser will not produce emulated events


  if (eventType === 'touchmove' || trackedTouchCount > 1) {
    isEmulatingMouseEvents = false;
  } // Ignore various events in particular circumstances


  if ( // Ignore browser emulated mouse events
  eventType === 'mousedown' && isEmulatingMouseEvents || eventType === 'mousemove' && isEmulatingMouseEvents || // Ignore mousemove if a mousedown didn't occur first
  eventType === 'mousemove' && trackedTouchCount < 1) {
    return;
  } // Remove flag after emulated events are finished


  if (isEmulatingMouseEvents && eventType === 'mouseup') {
    if (trackedTouchCount === 0) {
      isEmulatingMouseEvents = false;
    }

    return;
  }

  var isStartEvent = isStartish(eventType) && isPrimaryPointerDown(domEvent);
  var isMoveEvent = isMoveish(eventType);
  var isEndEvent = isEndish(eventType);
  var isScrollEvent = isScroll(eventType);
  var isSelectionChangeEvent = isSelectionChange(eventType);
  var responderEvent = createResponderEvent(domEvent, responderTouchHistoryStore);
  /**
   * Record the state of active pointers
   */

  if (isStartEvent || isMoveEvent || isEndEvent) {
    if (domEvent.touches) {
      trackedTouchCount = domEvent.touches.length;
    } else {
      if (isStartEvent) {
        trackedTouchCount = 1;
      } else if (isEndEvent) {
        trackedTouchCount = 0;
      }
    }

    responderTouchHistoryStore.recordTouchTrack(eventType, responderEvent.nativeEvent);
  }
  /**
   * Responder System logic
   */


  var eventPaths = getResponderPaths(domEvent);
  var wasNegotiated = false;
  var wantsResponder; // If an event occured that might change the current responder...

  if (isStartEvent || isMoveEvent || isScrollEvent && trackedTouchCount > 0) {
    // If there is already a responder, prune the event paths to the lowest common ancestor
    // of the existing responder and deepest target of the event.
    var currentResponderIdPath = currentResponder.idPath;
    var eventIdPath = eventPaths.idPath;

    if (currentResponderIdPath != null && eventIdPath != null) {
      var lowestCommonAncestor = getLowestCommonAncestor(currentResponderIdPath, eventIdPath);

      if (lowestCommonAncestor != null) {
        var indexOfLowestCommonAncestor = eventIdPath.indexOf(lowestCommonAncestor); // Skip the current responder so it doesn't receive unexpected "shouldSet" events.

        var index = indexOfLowestCommonAncestor + (lowestCommonAncestor === currentResponder.id ? 1 : 0);
        eventPaths = {
          idPath: eventIdPath.slice(index),
          nodePath: eventPaths.nodePath.slice(index)
        };
      } else {
        eventPaths = null;
      }
    }

    if (eventPaths != null) {
      // If a node wants to become the responder, attempt to transfer.
      wantsResponder = findWantsResponder(eventPaths, domEvent, responderEvent);

      if (wantsResponder != null) {
        // Sets responder if none exists, or negotates with existing responder.
        attemptTransfer(responderEvent, wantsResponder);
        wasNegotiated = true;
      }
    }
  } // If there is now a responder, invoke its callbacks for the lifecycle of the gesture.


  if (currentResponder.id != null && currentResponder.node != null) {
    var _currentResponder = currentResponder,
        id = _currentResponder.id,
        node = _currentResponder.node;

    var _getResponderConfig = getResponderConfig(id),
        onResponderStart = _getResponderConfig.onResponderStart,
        onResponderMove = _getResponderConfig.onResponderMove,
        onResponderEnd = _getResponderConfig.onResponderEnd,
        onResponderRelease = _getResponderConfig.onResponderRelease,
        onResponderTerminate = _getResponderConfig.onResponderTerminate,
        onResponderTerminationRequest = _getResponderConfig.onResponderTerminationRequest;

    responderEvent.bubbles = false;
    responderEvent.cancelable = false;
    responderEvent.currentTarget = node; // Start

    if (isStartEvent) {
      if (onResponderStart != null) {
        responderEvent.dispatchConfig.registrationName = 'onResponderStart';
        onResponderStart(responderEvent);
      }
    } // Move
    else if (isMoveEvent) {
      if (onResponderMove != null) {
        responderEvent.dispatchConfig.registrationName = 'onResponderMove';
        onResponderMove(responderEvent);
      }
    } else {
      var isTerminateEvent = isCancelish(eventType) || // native context menu
      eventType === 'contextmenu' || // window blur
      eventType === 'blur' && eventTarget === window || // responder (or ancestors) blur
      eventType === 'blur' && eventTarget.contains(node) && domEvent.relatedTarget !== node || // native scroll without using a pointer
      isScrollEvent && trackedTouchCount === 0 || // native scroll on node that is parent of the responder (allow siblings to scroll)
      isScrollEvent && eventTarget.contains(node) && eventTarget !== node || // native select/selectionchange on node
      isSelectionChangeEvent && hasValidSelection(domEvent);
      var isReleaseEvent = isEndEvent && !isTerminateEvent && !hasTargetTouches(node, domEvent.touches); // End

      if (isEndEvent) {
        if (onResponderEnd != null) {
          responderEvent.dispatchConfig.registrationName = 'onResponderEnd';
          onResponderEnd(responderEvent);
        }
      } // Release


      if (isReleaseEvent) {
        if (onResponderRelease != null) {
          responderEvent.dispatchConfig.registrationName = 'onResponderRelease';
          onResponderRelease(responderEvent);
        }

        changeCurrentResponder(emptyResponder);
      } // Terminate


      if (isTerminateEvent) {
        var shouldTerminate = true; // Responders can still avoid termination but only for these events.

        if (eventType === 'contextmenu' || eventType === 'scroll' || eventType === 'selectionchange') {
          // Only call this function is it wasn't already called during negotiation.
          if (wasNegotiated) {
            shouldTerminate = false;
          } else if (onResponderTerminationRequest != null) {
            responderEvent.dispatchConfig.registrationName = 'onResponderTerminationRequest';

            if (onResponderTerminationRequest(responderEvent) === false) {
              shouldTerminate = false;
            }
          }
        }

        if (shouldTerminate) {
          if (onResponderTerminate != null) {
            responderEvent.dispatchConfig.registrationName = 'onResponderTerminate';
            onResponderTerminate(responderEvent);
          }

          changeCurrentResponder(emptyResponder);
          isEmulatingMouseEvents = false;
          trackedTouchCount = 0;
        }
      }
    }
  }
}
/**
 * Walk the event path to/from the target node. At each node, stop and call the
 * relevant "shouldSet" functions for the given event type. If any of those functions
 * call "stopPropagation" on the event, stop searching for a responder.
 */


function findWantsResponder(eventPaths, domEvent, responderEvent) {
  var shouldSetCallbacks = shouldSetResponderEvents[domEvent.type]; // for Flow

  if (shouldSetCallbacks != null) {
    var idPath = eventPaths.idPath,
        nodePath = eventPaths.nodePath;
    var shouldSetCallbackCaptureName = shouldSetCallbacks[0];
    var shouldSetCallbackBubbleName = shouldSetCallbacks[1];
    var bubbles = shouldSetCallbacks[2].bubbles;

    var check = function check(id, node, callbackName) {
      var config = getResponderConfig(id);
      var shouldSetCallback = config[callbackName];

      if (shouldSetCallback != null) {
        responderEvent.currentTarget = node;

        if (shouldSetCallback(responderEvent) === true) {
          // Start the path from the potential responder
          var prunedIdPath = idPath.slice(idPath.indexOf(id));
          return {
            id,
            node,
            idPath: prunedIdPath
          };
        }
      }
    }; // capture


    for (var i = idPath.length - 1; i >= 0; i--) {
      var id = idPath[i];
      var node = nodePath[i];
      var result = check(id, node, shouldSetCallbackCaptureName);

      if (result != null) {
        return result;
      }

      if (responderEvent.isPropagationStopped() === true) {
        return;
      }
    } // bubble


    if (bubbles) {
      for (var _i = 0; _i < idPath.length; _i++) {
        var _id = idPath[_i];
        var _node = nodePath[_i];

        var _result = check(_id, _node, shouldSetCallbackBubbleName);

        if (_result != null) {
          return _result;
        }

        if (responderEvent.isPropagationStopped() === true) {
          return;
        }
      }
    } else {
      var _id2 = idPath[0];
      var _node2 = nodePath[0];
      var target = domEvent.target;

      if (target === _node2) {
        return check(_id2, _node2, shouldSetCallbackBubbleName);
      }
    }
  }
}
/**
 * Attempt to transfer the responder.
 */


function attemptTransfer(responderEvent, wantsResponder) {
  var _currentResponder2 = currentResponder,
      currentId = _currentResponder2.id,
      currentNode = _currentResponder2.node;
  var id = wantsResponder.id,
      node = wantsResponder.node;

  var _getResponderConfig2 = getResponderConfig(id),
      onResponderGrant = _getResponderConfig2.onResponderGrant,
      onResponderReject = _getResponderConfig2.onResponderReject;

  responderEvent.bubbles = false;
  responderEvent.cancelable = false;
  responderEvent.currentTarget = node; // Set responder

  if (currentId == null) {
    if (onResponderGrant != null) {
      responderEvent.currentTarget = node;
      responderEvent.dispatchConfig.registrationName = 'onResponderGrant';
      onResponderGrant(responderEvent);
    }

    changeCurrentResponder(wantsResponder);
  } // Negotiate with current responder
  else {
    var _getResponderConfig3 = getResponderConfig(currentId),
        onResponderTerminate = _getResponderConfig3.onResponderTerminate,
        onResponderTerminationRequest = _getResponderConfig3.onResponderTerminationRequest;

    var allowTransfer = true;

    if (onResponderTerminationRequest != null) {
      responderEvent.currentTarget = currentNode;
      responderEvent.dispatchConfig.registrationName = 'onResponderTerminationRequest';

      if (onResponderTerminationRequest(responderEvent) === false) {
        allowTransfer = false;
      }
    }

    if (allowTransfer) {
      // Terminate existing responder
      if (onResponderTerminate != null) {
        responderEvent.currentTarget = currentNode;
        responderEvent.dispatchConfig.registrationName = 'onResponderTerminate';
        onResponderTerminate(responderEvent);
      } // Grant next responder


      if (onResponderGrant != null) {
        responderEvent.currentTarget = node;
        responderEvent.dispatchConfig.registrationName = 'onResponderGrant';
        onResponderGrant(responderEvent);
      }

      changeCurrentResponder(wantsResponder);
    } else {
      // Reject responder request
      if (onResponderReject != null) {
        responderEvent.currentTarget = node;
        responderEvent.dispatchConfig.registrationName = 'onResponderReject';
        onResponderReject(responderEvent);
      }
    }
  }
}
/* ------------ PUBLIC API ------------ */

/**
 * Attach Listeners
 *
 * Use native events as ReactDOM doesn't have a non-plugin API to implement
 * this system.
 */


var documentEventsCapturePhase = ['blur', 'scroll'];
var documentEventsBubblePhase = [// mouse
'mousedown', 'mousemove', 'mouseup', 'dragstart', // touch
'touchstart', 'touchmove', 'touchend', 'touchcancel', // other
'contextmenu', 'select', 'selectionchange'];
function attachListeners() {
  if (canUseDom/* default */.Z && window.__reactResponderSystemActive == null) {
    window.addEventListener('blur', eventListener);
    documentEventsBubblePhase.forEach(eventType => {
      document.addEventListener(eventType, eventListener);
    });
    documentEventsCapturePhase.forEach(eventType => {
      document.addEventListener(eventType, eventListener, true);
    });
    window.__reactResponderSystemActive = true;
  }
}
/**
 * Register a node with the ResponderSystem.
 */

function addNode(id, node, config) {
  setResponderId(node, id);
  responderListenersMap.set(id, config);
}
/**
 * Unregister a node with the ResponderSystem.
 */

function removeNode(id) {
  if (currentResponder.id === id) {
    terminateResponder();
  }

  if (responderListenersMap.has(id)) {
    responderListenersMap.delete(id);
  }
}
/**
 * Allow the current responder to be terminated from within components to support
 * more complex requirements, such as use with other React libraries for working
 * with scroll views, input views, etc.
 */

function terminateResponder() {
  var _currentResponder3 = currentResponder,
      id = _currentResponder3.id,
      node = _currentResponder3.node;

  if (id != null && node != null) {
    var _getResponderConfig4 = getResponderConfig(id),
        onResponderTerminate = _getResponderConfig4.onResponderTerminate;

    if (onResponderTerminate != null) {
      var event = createResponderEvent({}, responderTouchHistoryStore);
      event.currentTarget = node;
      onResponderTerminate(event);
    }

    changeCurrentResponder(emptyResponder);
  }

  isEmulatingMouseEvents = false;
  trackedTouchCount = 0;
}
/**
 * Allow unit tests to inspect the current responder in the system.
 * FOR TESTING ONLY.
 */

function getResponderNode() {
  return currentResponder.node;
}
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/modules/useResponderEvents/index.js
/**
 * Copyright (c) Nicolas Gallagher
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

/**
 * Hook for integrating the Responder System into React
 *
 *   function SomeComponent({ onStartShouldSetResponder }) {
 *     const ref = useRef(null);
 *     useResponderEvents(ref, { onStartShouldSetResponder });
 *     return <div ref={ref} />
 *   }
 */


var useResponderEvents_emptyObject = {};
var idCounter = 0;

function useStable(getInitialValue) {
  var ref = react.useRef(null);

  if (ref.current == null) {
    ref.current = getInitialValue();
  }

  return ref.current;
}

function useResponderEvents(hostRef, config) {
  if (config === void 0) {
    config = useResponderEvents_emptyObject;
  }

  var id = useStable(() => idCounter++);
  var isAttachedRef = react.useRef(false); // This is a separate effects so it doesn't run when the config changes.
  // On initial mount, attach global listeners if needed.
  // On unmount, remove node potentially attached to the Responder System.

  react.useEffect(() => {
    attachListeners();
    return () => {
      removeNode(id);
    };
  }, [id]); // Register and unregister with the Responder System as necessary

  react.useEffect(() => {
    var _config = config,
        onMoveShouldSetResponder = _config.onMoveShouldSetResponder,
        onMoveShouldSetResponderCapture = _config.onMoveShouldSetResponderCapture,
        onScrollShouldSetResponder = _config.onScrollShouldSetResponder,
        onScrollShouldSetResponderCapture = _config.onScrollShouldSetResponderCapture,
        onSelectionChangeShouldSetResponder = _config.onSelectionChangeShouldSetResponder,
        onSelectionChangeShouldSetResponderCapture = _config.onSelectionChangeShouldSetResponderCapture,
        onStartShouldSetResponder = _config.onStartShouldSetResponder,
        onStartShouldSetResponderCapture = _config.onStartShouldSetResponderCapture;
    var requiresResponderSystem = onMoveShouldSetResponder != null || onMoveShouldSetResponderCapture != null || onScrollShouldSetResponder != null || onScrollShouldSetResponderCapture != null || onSelectionChangeShouldSetResponder != null || onSelectionChangeShouldSetResponderCapture != null || onStartShouldSetResponder != null || onStartShouldSetResponderCapture != null;
    var node = hostRef.current;

    if (requiresResponderSystem) {
      addNode(id, node, config);
      isAttachedRef.current = true;
    } else if (isAttachedRef.current) {
      removeNode(id);
      isAttachedRef.current = false;
    }
  }, [config, hostRef, id]);
  react.useDebugValue({
    isResponder: hostRef.current === getResponderNode()
  });
  react.useDebugValue(config);
}

/***/ }),

/***/ 9121:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useStable; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var UNINITIALIZED = typeof Symbol === 'function' && typeof Symbol() === 'symbol' ? Symbol() : Object.freeze({});
function useStable(getInitialValue) {
  var ref = react__WEBPACK_IMPORTED_MODULE_0__.useRef(UNINITIALIZED);

  if (ref.current === UNINITIALIZED) {
    ref.current = getInitialValue();
  } // $FlowFixMe (#64650789) Trouble refining types where `Symbol` is concerned.


  return ref.current;
}

/***/ }),

/***/ 53615:
/***/ (function(module) {

module.exports = worm(true)

function worm(root = false) {
  const obj = root
    ? {
        get default() {
          return worm()
        },
      }
    : function () {
        //  dev warning in debug mode
        if (false) {}

        return worm()
      }

  obj.displayName = `ProxyWorm - Check excludeReactNativeWebExports`
  obj._isProxyWorm = true

  return new Proxy(obj, {
    get(_, key) {
      if (Reflect.has(obj, key)) return Reflect.get(obj, key)
      return worm()
    },
    apply() {
      return worm()
    },
  })
}


/***/ }),

/***/ 49887:
/***/ (function(module) {

module.exports = worm(true)

function worm(root = false) {
  const obj = root
    ? {
        get default() {
          return worm()
        },
      }
    : function () {
        //  dev warning in debug mode
        if (false) {}

        return worm()
      }

  obj.displayName = `ProxyWorm - Check excludeReactNativeWebExports`
  obj._isProxyWorm = true

  return new Proxy(obj, {
    get(_, key) {
      if (Reflect.has(obj, key)) return Reflect.get(obj, key)
      return worm()
    },
    apply() {
      return worm()
    },
  })
}


/***/ }),

/***/ 63153:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ RCTDeviceEventEmitter; }
});

// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/vendor/react-native/emitter/_EventEmitter.js + 3 modules
var _EventEmitter = __webpack_require__(39269);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/vendor/react-native/emitter/EventEmitter.js
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */



/* harmony default export */ var EventEmitter = (_EventEmitter/* default */.Z);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/vendor/react-native/NativeEventEmitter/RCTDeviceEventEmitter.js
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */
 // FIXME: use typed events

/**
 * Global EventEmitter used by the native platform to emit events to JavaScript.
 * Events are identified by globally unique event names.
 *
 * NativeModules that emit events should instead subclass `NativeEventEmitter`.
 */
/* harmony default export */ var RCTDeviceEventEmitter = (new EventEmitter());

/***/ }),

/***/ 2643:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ NativeEventEmitter; }
/* harmony export */ });
/* harmony import */ var _exports_Platform__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33229);
/* harmony import */ var _RCTDeviceEventEmitter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63153);
/* harmony import */ var fbjs_lib_invariant__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14983);
/* harmony import */ var fbjs_lib_invariant__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(fbjs_lib_invariant__WEBPACK_IMPORTED_MODULE_0__);
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */






/**
 * `NativeEventEmitter` is intended for use by Native Modules to emit events to
 * JavaScript listeners. If a `NativeModule` is supplied to the constructor, it
 * will be notified (via `addListener` and `removeListeners`) when the listener
 * count changes to manage "native memory".
 *
 * Currently, all native events are fired via a global `RCTDeviceEventEmitter`.
 * This means event names must be globally unique, and it means that call sites
 * can theoretically listen to `RCTDeviceEventEmitter` (although discouraged).
 */
class NativeEventEmitter {
  constructor(nativeModule) {
    if (_exports_Platform__WEBPACK_IMPORTED_MODULE_1__/* ["default"].OS */ .Z.OS === 'ios') {
      fbjs_lib_invariant__WEBPACK_IMPORTED_MODULE_0___default()(nativeModule != null, '`new NativeEventEmitter()` requires a non-null argument.');
      this._nativeModule = nativeModule;
    }
  }

  addListener(eventType, listener, context) {
    var _this$_nativeModule;

    (_this$_nativeModule = this._nativeModule) == null ? void 0 : _this$_nativeModule.addListener(eventType);
    var subscription = _RCTDeviceEventEmitter__WEBPACK_IMPORTED_MODULE_2__/* ["default"].addListener */ .Z.addListener(eventType, listener, context);
    return {
      remove: () => {
        if (subscription != null) {
          var _this$_nativeModule2;

          (_this$_nativeModule2 = this._nativeModule) == null ? void 0 : _this$_nativeModule2.removeListeners(1); // $FlowFixMe[incompatible-use]

          subscription.remove();
          subscription = null;
        }
      }
    };
  }
  /**
   * @deprecated Use `remove` on the EventSubscription from `addListener`.
   */


  removeListener(eventType, listener) {
    var _this$_nativeModule3;

    (_this$_nativeModule3 = this._nativeModule) == null ? void 0 : _this$_nativeModule3.removeListeners(1); // NOTE: This will report a deprecation notice via `console.error`.
    // $FlowFixMe[prop-missing] - `removeListener` exists but is deprecated.

    _RCTDeviceEventEmitter__WEBPACK_IMPORTED_MODULE_2__/* ["default"].removeListener */ .Z.removeListener(eventType, listener);
  }

  emit(eventType) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    // Generally, `RCTDeviceEventEmitter` is directly invoked. But this is
    // included for completeness.
    _RCTDeviceEventEmitter__WEBPACK_IMPORTED_MODULE_2__/* ["default"].emit */ .Z.emit(eventType, ...args);
  }

  removeAllListeners(eventType) {
    var _this$_nativeModule4;

    fbjs_lib_invariant__WEBPACK_IMPORTED_MODULE_0___default()(eventType != null, '`NativeEventEmitter.removeAllListener()` requires a non-null argument.');
    (_this$_nativeModule4 = this._nativeModule) == null ? void 0 : _this$_nativeModule4.removeListeners(this.listenerCount(eventType));
    _RCTDeviceEventEmitter__WEBPACK_IMPORTED_MODULE_2__/* ["default"].removeAllListeners */ .Z.removeAllListeners(eventType);
  }

  listenerCount(eventType) {
    return _RCTDeviceEventEmitter__WEBPACK_IMPORTED_MODULE_2__/* ["default"].listenerCount */ .Z.listenerCount(eventType);
  }

}

/***/ }),

/***/ 39269:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _EventEmitter; }
});

// EXTERNAL MODULE: ../../node_modules/fbjs/lib/invariant.js
var invariant = __webpack_require__(14983);
var invariant_default = /*#__PURE__*/__webpack_require__.n(invariant);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/vendor/react-native/emitter/_EventSubscription.js
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 */


/**
 * EventSubscription represents a subscription to a particular event. It can
 * remove its own subscription.
 */
class _EventSubscription {
  /**
   * @param {EventSubscriptionVendor} subscriber the subscriber that controls
   *   this subscription.
   */
  constructor(subscriber) {
    this.subscriber = subscriber;
  }
  /**
   * Removes this subscription from the subscriber that controls it.
   */


  remove() {
    this.subscriber.removeSubscription(this);
  }

}

/* harmony default export */ var emitter_EventSubscription = (_EventSubscription);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/vendor/react-native/emitter/_EmitterSubscription.js
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 */




/**
 * EmitterSubscription represents a subscription with listener and context data.
 */
class EmitterSubscription extends emitter_EventSubscription {
  /**
   * @param {EventEmitter} emitter - The event emitter that registered this
   *   subscription
   * @param {EventSubscriptionVendor} subscriber - The subscriber that controls
   *   this subscription
   * @param {function} listener - Function to invoke when the specified event is
   *   emitted
   * @param {*} context - Optional context object to use when invoking the
   *   listener
   */
  constructor(emitter, subscriber, listener, context) {
    super(subscriber);
    this.emitter = emitter;
    this.listener = listener;
    this.context = context;
  }
  /**
   * Removes this subscription from the emitter that registered it.
   * Note: we're overriding the `remove()` method of _EventSubscription here
   * but deliberately not calling `super.remove()` as the responsibility
   * for removing the subscription lies with the EventEmitter.
   */


  remove() {
    this.emitter.removeSubscription(this);
  }

}

/* harmony default export */ var _EmitterSubscription = (EmitterSubscription);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/vendor/react-native/emitter/_EventSubscriptionVendor.js
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 */




/**
 * EventSubscriptionVendor stores a set of EventSubscriptions that are
 * subscribed to a particular event type.
 */
class EventSubscriptionVendor {
  constructor() {
    this._subscriptionsForType = {};
  }
  /**
   * Adds a subscription keyed by an event type.
   *
   * @param {string} eventType
   * @param {EventSubscription} subscription
   */


  addSubscription(eventType, subscription) {
    invariant_default()(subscription.subscriber === this, 'The subscriber of the subscription is incorrectly set.');

    if (!this._subscriptionsForType[eventType]) {
      this._subscriptionsForType[eventType] = [];
    }

    var key = this._subscriptionsForType[eventType].length;

    this._subscriptionsForType[eventType].push(subscription);

    subscription.eventType = eventType;
    subscription.key = key;
    return subscription;
  }
  /**
   * Removes a bulk set of the subscriptions.
   *
   * @param {?string} eventType - Optional name of the event type whose
   *   registered supscriptions to remove, if null remove all subscriptions.
   */


  removeAllSubscriptions(eventType) {
    if (eventType == null) {
      this._subscriptionsForType = {};
    } else {
      delete this._subscriptionsForType[eventType];
    }
  }
  /**
   * Removes a specific subscription. Instead of calling this function, call
   * `subscription.remove()` directly.
   *
   * @param {object} subscription
   */


  removeSubscription(subscription) {
    var eventType = subscription.eventType;
    var key = subscription.key;
    var subscriptionsForType = this._subscriptionsForType[eventType];

    if (subscriptionsForType) {
      delete subscriptionsForType[key];
    }
  }
  /**
   * Returns the array of subscriptions that are currently registered for the
   * given event type.
   *
   * Note: This array can be potentially sparse as subscriptions are deleted
   * from it when they are removed.
   *
   * TODO: This returns a nullable array. wat?
   *
   * @param {string} eventType
   * @returns {?array}
   */


  getSubscriptionsForType(eventType) {
    return this._subscriptionsForType[eventType];
  }

}

/* harmony default export */ var _EventSubscriptionVendor = (EventSubscriptionVendor);
;// CONCATENATED MODULE: ../../node_modules/react-native-web/dist/vendor/react-native/emitter/_EventEmitter.js
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @typecheck
 */




var sparseFilterPredicate = () => true;

/**
 * @class EventEmitter
 * @description
 * An EventEmitter is responsible for managing a set of listeners and publishing
 * events to them when it is told that such events happened. In addition to the
 * data for the given event it also sends a event control object which allows
 * the listeners/handlers to prevent the default behavior of the given event.
 *
 * The emitter is designed to be generic enough to support all the different
 * contexts in which one might want to emit events. It is a simple multicast
 * mechanism on top of which extra functionality can be composed. For example, a
 * more advanced emitter may use an EventHolder and EventFactory.
 */
class EventEmitter {
  /**
   * @constructor
   *
   * @param {EventSubscriptionVendor} subscriber - Optional subscriber instance
   *   to use. If omitted, a new subscriber will be created for the emitter.
   */
  constructor(subscriber) {
    this._subscriber = subscriber || new _EventSubscriptionVendor();
  }
  /**
   * Adds a listener to be invoked when events of the specified type are
   * emitted. An optional calling context may be provided. The data arguments
   * emitted will be passed to the listener function.
   *
   * TODO: Annotate the listener arg's type. This is tricky because listeners
   *       can be invoked with varargs.
   *
   * @param {string} eventType - Name of the event to listen to
   * @param {function} listener - Function to invoke when the specified event is
   *   emitted
   * @param {*} context - Optional context object to use when invoking the
   *   listener
   */


  addListener(eventType, // FIXME: listeners should return void instead of mixed to prevent issues
  listener, context) {
    return this._subscriber.addSubscription(eventType, new _EmitterSubscription(this, this._subscriber, listener, context));
  }
  /**
   * Removes all of the registered listeners, including those registered as
   * listener maps.
   *
   * @param {?string} eventType - Optional name of the event whose registered
   *   listeners to remove
   */


  removeAllListeners(eventType) {
    this._subscriber.removeAllSubscriptions(eventType);
  }
  /**
   * @deprecated Use `remove` on the EventSubscription from `addListener`.
   */


  removeSubscription(subscription) {
    invariant_default()(subscription.emitter === this, 'Subscription does not belong to this emitter.');

    this._subscriber.removeSubscription(subscription);
  }
  /**
   * Returns the number of listeners that are currently registered for the given
   * event.
   *
   * @param {string} eventType - Name of the event to query
   * @returns {number}
   */


  listenerCount(eventType) {
    var subscriptions = this._subscriber.getSubscriptionsForType(eventType);

    return subscriptions ? // We filter out missing entries because the array is sparse.
    // "callbackfn is called only for elements of the array which actually
    // exist; it is not called for missing elements of the array."
    // https://www.ecma-international.org/ecma-262/9.0/index.html#sec-array.prototype.filter
    subscriptions.filter(sparseFilterPredicate).length : 0;
  }
  /**
   * Emits an event of the given type with the given data. All handlers of that
   * particular type will be notified.
   *
   * @param {string} eventType - Name of the event to emit
   * @param {...*} Arbitrary arguments to be passed to each registered listener
   *
   * @example
   *   emitter.addListener('someEvent', function(message) {
   *     console.log(message);
   *   });
   *
   *   emitter.emit('someEvent', 'abc'); // logs 'abc'
   */


  emit(eventType) {
    var subscriptions = this._subscriber.getSubscriptionsForType(eventType);

    if (subscriptions) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      for (var i = 0, l = subscriptions.length; i < l; i++) {
        var subscription = subscriptions[i]; // The subscription may have been removed during this event loop.

        if (subscription && subscription.listener) {
          subscription.listener.apply(subscription.context, args);
        }
      }
    }
  }
  /**
   * @deprecated Use `remove` on the EventSubscription from `addListener`.
   */


  removeListener(eventType, // FIXME: listeners should return void instead of mixed to prevent issues
  listener) {
    console.error("EventEmitter.removeListener('" + eventType + "', ...): Method has been " + 'deprecated. Please instead use `remove()` on the subscription ' + 'returned by `EventEmitter.addListener`.');

    var subscriptions = this._subscriber.getSubscriptionsForType(eventType);

    if (subscriptions) {
      for (var i = 0, l = subscriptions.length; i < l; i++) {
        var subscription = subscriptions[i]; // The subscription may have been removed during this event loop.
        // its listener matches the listener in method parameters

        if (subscription && subscription.listener === listener) {
          subscription.remove();
        }
      }
    }
  }

}

/* harmony default export */ var _EventEmitter = (EventEmitter);

/***/ }),

/***/ 18217:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Combination; }
});

;// CONCATENATED MODULE: ../../node_modules/tslib/tslib.es6.js
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.push(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.push(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};

function __runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};

function __propKey(x) {
    return typeof x === "symbol" ? x : "".concat(x);
};

function __setFunctionName(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: false } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../node_modules/react-remove-scroll-bar/dist/es2015/constants.js
var zeroRightClassName = 'right-scroll-bar-position';
var fullWidthClassName = 'width-before-scroll-bar';
var noScrollbarsClassName = 'with-scroll-bars-hidden';
/**
 * Name of a CSS variable containing the amount of "hidden" scrollbar
 * ! might be undefined ! use will fallback!
 */
var removedBarSizeVariable = '--removed-body-scroll-bar-size';

;// CONCATENATED MODULE: ../../node_modules/use-callback-ref/dist/es2015/assignRef.js
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */
function assignRef(ref, value) {
    if (typeof ref === 'function') {
        ref(value);
    }
    else if (ref) {
        ref.current = value;
    }
    return ref;
}

;// CONCATENATED MODULE: ../../node_modules/use-callback-ref/dist/es2015/useRef.js

/**
 * creates a MutableRef with ref change callback
 * @param initialValue - initial ref value
 * @param {Function} callback - a callback to run when value changes
 *
 * @example
 * const ref = useCallbackRef(0, (newValue, oldValue) => console.log(oldValue, '->', newValue);
 * ref.current = 1;
 * // prints 0 -> 1
 *
 * @see https://reactjs.org/docs/hooks-reference.html#useref
 * @see https://github.com/theKashey/use-callback-ref#usecallbackref---to-replace-reactuseref
 * @returns {MutableRefObject}
 */
function useCallbackRef(initialValue, callback) {
    var ref = (0,react.useState)(function () { return ({
        // value
        value: initialValue,
        // last callback
        callback: callback,
        // "memoized" public interface
        facade: {
            get current() {
                return ref.value;
            },
            set current(value) {
                var last = ref.value;
                if (last !== value) {
                    ref.value = value;
                    ref.callback(value, last);
                }
            },
        },
    }); })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}

;// CONCATENATED MODULE: ../../node_modules/use-callback-ref/dist/es2015/useMergeRef.js


/**
 * Merges two or more refs together providing a single interface to set their value
 * @param {RefObject|Ref} refs
 * @returns {MutableRefObject} - a new ref, which translates all changes to {refs}
 *
 * @see {@link mergeRefs} a version without buit-in memoization
 * @see https://github.com/theKashey/use-callback-ref#usemergerefs
 * @example
 * const Component = React.forwardRef((props, ref) => {
 *   const ownRef = useRef();
 *   const domRef = useMergeRefs([ref, ownRef]); // 👈 merge together
 *   return <div ref={domRef}>...</div>
 * }
 */
function useMergeRefs(refs, defaultValue) {
    return useCallbackRef(defaultValue || null, function (newValue) { return refs.forEach(function (ref) { return assignRef(ref, newValue); }); });
}

;// CONCATENATED MODULE: ../../node_modules/use-sidecar/dist/es2015/medium.js

function ItoI(a) {
    return a;
}
function innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) { middleware = ItoI; }
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function () {
            if (assigned) {
                throw new Error('Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.');
            }
            if (buffer.length) {
                return buffer[buffer.length - 1];
            }
            return defaults;
        },
        useMedium: function (data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function () {
                buffer = buffer.filter(function (x) { return x !== item; });
            };
        },
        assignSyncMedium: function (cb) {
            assigned = true;
            while (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function (x) { return cb(x); },
                filter: function () { return buffer; },
            };
        },
        assignMedium: function (cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function () {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function () { return Promise.resolve().then(executeQueue); };
            cycle();
            buffer = {
                push: function (x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function (filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                },
            };
        },
    };
    return medium;
}
function createMedium(defaults, middleware) {
    if (middleware === void 0) { middleware = ItoI; }
    return innerCreateMedium(defaults, middleware);
}
// eslint-disable-next-line @typescript-eslint/ban-types
function createSidecarMedium(options) {
    if (options === void 0) { options = {}; }
    var medium = innerCreateMedium(null);
    medium.options = __assign({ async: true, ssr: false }, options);
    return medium;
}

;// CONCATENATED MODULE: ../../node_modules/react-remove-scroll/dist/es2015/medium.js

var effectCar = createSidecarMedium();

;// CONCATENATED MODULE: ../../node_modules/react-remove-scroll/dist/es2015/UI.js





var nothing = function () {
    return;
};
/**
 * Removes scrollbar from the page and contain the scroll within the Lock
 */
var RemoveScroll = react.forwardRef(function (props, parentRef) {
    var ref = react.useRef(null);
    var _a = react.useState({
        onScrollCapture: nothing,
        onWheelCapture: nothing,
        onTouchMoveCapture: nothing,
    }), callbacks = _a[0], setCallbacks = _a[1];
    var forwardProps = props.forwardProps, children = props.children, className = props.className, removeScrollBar = props.removeScrollBar, enabled = props.enabled, shards = props.shards, sideCar = props.sideCar, noIsolation = props.noIsolation, inert = props.inert, allowPinchZoom = props.allowPinchZoom, _b = props.as, Container = _b === void 0 ? 'div' : _b, rest = __rest(props, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as"]);
    var SideCar = sideCar;
    var containerRef = useMergeRefs([ref, parentRef]);
    var containerProps = __assign(__assign({}, rest), callbacks);
    return (react.createElement(react.Fragment, null,
        enabled && (react.createElement(SideCar, { sideCar: effectCar, removeScrollBar: removeScrollBar, shards: shards, noIsolation: noIsolation, inert: inert, setCallbacks: setCallbacks, allowPinchZoom: !!allowPinchZoom, lockRef: ref })),
        forwardProps ? (react.cloneElement(react.Children.only(children), __assign(__assign({}, containerProps), { ref: containerRef }))) : (react.createElement(Container, __assign({}, containerProps, { className: className, ref: containerRef }), children))));
});
RemoveScroll.defaultProps = {
    enabled: true,
    removeScrollBar: true,
    inert: false,
};
RemoveScroll.classNames = {
    fullWidth: fullWidthClassName,
    zeroRight: zeroRightClassName,
};


;// CONCATENATED MODULE: ../../node_modules/use-sidecar/dist/es2015/exports.js


var SideCar = function (_a) {
    var sideCar = _a.sideCar, rest = __rest(_a, ["sideCar"]);
    if (!sideCar) {
        throw new Error('Sidecar: please provide `sideCar` property to import the right car');
    }
    var Target = sideCar.read();
    if (!Target) {
        throw new Error('Sidecar medium not found');
    }
    return react.createElement(Target, __assign({}, rest));
};
SideCar.isSideCarExport = true;
function exportSidecar(medium, exported) {
    medium.useMedium(exported);
    return SideCar;
}

;// CONCATENATED MODULE: ../../node_modules/get-nonce/dist/es2015/index.js
var currentNonce;
var setNonce = function (nonce) {
    currentNonce = nonce;
};
var getNonce = function () {
    if (currentNonce) {
        return currentNonce;
    }
    if (true) {
        return __webpack_require__.nc;
    }
    return undefined;
};

;// CONCATENATED MODULE: ../../node_modules/react-style-singleton/dist/es2015/singleton.js

function makeStyleTag() {
    if (!document)
        return null;
    var tag = document.createElement('style');
    tag.type = 'text/css';
    var nonce = getNonce();
    if (nonce) {
        tag.setAttribute('nonce', nonce);
    }
    return tag;
}
function injectStyles(tag, css) {
    // @ts-ignore
    if (tag.styleSheet) {
        // @ts-ignore
        tag.styleSheet.cssText = css;
    }
    else {
        tag.appendChild(document.createTextNode(css));
    }
}
function insertStyleTag(tag) {
    var head = document.head || document.getElementsByTagName('head')[0];
    head.appendChild(tag);
}
var stylesheetSingleton = function () {
    var counter = 0;
    var stylesheet = null;
    return {
        add: function (style) {
            if (counter == 0) {
                if ((stylesheet = makeStyleTag())) {
                    injectStyles(stylesheet, style);
                    insertStyleTag(stylesheet);
                }
            }
            counter++;
        },
        remove: function () {
            counter--;
            if (!counter && stylesheet) {
                stylesheet.parentNode && stylesheet.parentNode.removeChild(stylesheet);
                stylesheet = null;
            }
        },
    };
};

;// CONCATENATED MODULE: ../../node_modules/react-style-singleton/dist/es2015/hook.js


/**
 * creates a hook to control style singleton
 * @see {@link styleSingleton} for a safer component version
 * @example
 * ```tsx
 * const useStyle = styleHookSingleton();
 * ///
 * useStyle('body { overflow: hidden}');
 */
var styleHookSingleton = function () {
    var sheet = stylesheetSingleton();
    return function (styles, isDynamic) {
        react.useEffect(function () {
            sheet.add(styles);
            return function () {
                sheet.remove();
            };
        }, [styles && isDynamic]);
    };
};

;// CONCATENATED MODULE: ../../node_modules/react-style-singleton/dist/es2015/component.js

/**
 * create a Component to add styles on demand
 * - styles are added when first instance is mounted
 * - styles are removed when the last instance is unmounted
 * - changing styles in runtime does nothing unless dynamic is set. But with multiple components that can lead to the undefined behavior
 */
var styleSingleton = function () {
    var useStyle = styleHookSingleton();
    var Sheet = function (_a) {
        var styles = _a.styles, dynamic = _a.dynamic;
        useStyle(styles, dynamic);
        return null;
    };
    return Sheet;
};

;// CONCATENATED MODULE: ../../node_modules/react-style-singleton/dist/es2015/index.js




;// CONCATENATED MODULE: ../../node_modules/react-remove-scroll-bar/dist/es2015/utils.js
var zeroGap = {
    left: 0,
    top: 0,
    right: 0,
    gap: 0,
};
var parse = function (x) { return parseInt(x || '', 10) || 0; };
var getOffset = function (gapMode) {
    var cs = window.getComputedStyle(document.body);
    var left = cs[gapMode === 'padding' ? 'paddingLeft' : 'marginLeft'];
    var top = cs[gapMode === 'padding' ? 'paddingTop' : 'marginTop'];
    var right = cs[gapMode === 'padding' ? 'paddingRight' : 'marginRight'];
    return [parse(left), parse(top), parse(right)];
};
var getGapWidth = function (gapMode) {
    if (gapMode === void 0) { gapMode = 'margin'; }
    if (typeof window === 'undefined') {
        return zeroGap;
    }
    var offsets = getOffset(gapMode);
    var documentWidth = document.documentElement.clientWidth;
    var windowWidth = window.innerWidth;
    return {
        left: offsets[0],
        top: offsets[1],
        right: offsets[2],
        gap: Math.max(0, windowWidth - documentWidth + offsets[2] - offsets[0]),
    };
};

;// CONCATENATED MODULE: ../../node_modules/react-remove-scroll-bar/dist/es2015/component.js




var Style = styleSingleton();
// important tip - once we measure scrollBar width and remove them
// we could not repeat this operation
// thus we are using style-singleton - only the first "yet correct" style will be applied.
var getStyles = function (_a, allowRelative, gapMode, important) {
    var left = _a.left, top = _a.top, right = _a.right, gap = _a.gap;
    if (gapMode === void 0) { gapMode = 'margin'; }
    return "\n  .".concat(noScrollbarsClassName, " {\n   overflow: hidden ").concat(important, ";\n   padding-right: ").concat(gap, "px ").concat(important, ";\n  }\n  body {\n    overflow: hidden ").concat(important, ";\n    overscroll-behavior: contain;\n    ").concat([
        allowRelative && "position: relative ".concat(important, ";"),
        gapMode === 'margin' &&
            "\n    padding-left: ".concat(left, "px;\n    padding-top: ").concat(top, "px;\n    padding-right: ").concat(right, "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(gap, "px ").concat(important, ";\n    "),
        gapMode === 'padding' && "padding-right: ".concat(gap, "px ").concat(important, ";"),
    ]
        .filter(Boolean)
        .join(''), "\n  }\n  \n  .").concat(zeroRightClassName, " {\n    right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat(fullWidthClassName, " {\n    margin-right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat(zeroRightClassName, " .").concat(zeroRightClassName, " {\n    right: 0 ").concat(important, ";\n  }\n  \n  .").concat(fullWidthClassName, " .").concat(fullWidthClassName, " {\n    margin-right: 0 ").concat(important, ";\n  }\n  \n  body {\n    ").concat(removedBarSizeVariable, ": ").concat(gap, "px;\n  }\n");
};
/**
 * Removes page scrollbar and blocks page scroll when mounted
 */
var RemoveScrollBar = function (props) {
    var noRelative = props.noRelative, noImportant = props.noImportant, _a = props.gapMode, gapMode = _a === void 0 ? 'margin' : _a;
    /*
     gap will be measured on every component mount
     however it will be used only by the "first" invocation
     due to singleton nature of <Style
     */
    var gap = react.useMemo(function () { return getGapWidth(gapMode); }, [gapMode]);
    return react.createElement(Style, { styles: getStyles(gap, !noRelative, gapMode, !noImportant ? '!important' : '') });
};

;// CONCATENATED MODULE: ../../node_modules/react-remove-scroll-bar/dist/es2015/index.js





;// CONCATENATED MODULE: ../../node_modules/react-remove-scroll/dist/es2015/aggresiveCapture.js
var passiveSupported = false;
if (typeof window !== 'undefined') {
    try {
        var options = Object.defineProperty({}, 'passive', {
            get: function () {
                passiveSupported = true;
                return true;
            },
        });
        // @ts-ignore
        window.addEventListener('test', options, options);
        // @ts-ignore
        window.removeEventListener('test', options, options);
    }
    catch (err) {
        passiveSupported = false;
    }
}
var nonPassive = passiveSupported ? { passive: false } : false;

;// CONCATENATED MODULE: ../../node_modules/react-remove-scroll/dist/es2015/handleScroll.js
var alwaysContainsScroll = function (node) {
    // textarea will always _contain_ scroll inside self. It only can be hidden
    return node.tagName === 'TEXTAREA';
};
var elementCanBeScrolled = function (node, overflow) {
    var styles = window.getComputedStyle(node);
    return (
    // not-not-scrollable
    styles[overflow] !== 'hidden' &&
        // contains scroll inside self
        !(styles.overflowY === styles.overflowX && !alwaysContainsScroll(node) && styles[overflow] === 'visible'));
};
var elementCouldBeVScrolled = function (node) { return elementCanBeScrolled(node, 'overflowY'); };
var elementCouldBeHScrolled = function (node) { return elementCanBeScrolled(node, 'overflowX'); };
var locationCouldBeScrolled = function (axis, node) {
    var current = node;
    do {
        // Skip over shadow root
        if (typeof ShadowRoot !== 'undefined' && current instanceof ShadowRoot) {
            current = current.host;
        }
        var isScrollable = elementCouldBeScrolled(axis, current);
        if (isScrollable) {
            var _a = getScrollVariables(axis, current), s = _a[1], d = _a[2];
            if (s > d) {
                return true;
            }
        }
        current = current.parentNode;
    } while (current && current !== document.body);
    return false;
};
var getVScrollVariables = function (_a) {
    var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
    return [
        scrollTop,
        scrollHeight,
        clientHeight,
    ];
};
var getHScrollVariables = function (_a) {
    var scrollLeft = _a.scrollLeft, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
    return [
        scrollLeft,
        scrollWidth,
        clientWidth,
    ];
};
var elementCouldBeScrolled = function (axis, node) {
    return axis === 'v' ? elementCouldBeVScrolled(node) : elementCouldBeHScrolled(node);
};
var getScrollVariables = function (axis, node) {
    return axis === 'v' ? getVScrollVariables(node) : getHScrollVariables(node);
};
var getDirectionFactor = function (axis, direction) {
    /**
     * If the element's direction is rtl (right-to-left), then scrollLeft is 0 when the scrollbar is at its rightmost position,
     * and then increasingly negative as you scroll towards the end of the content.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollLeft
     */
    return axis === 'h' && direction === 'rtl' ? -1 : 1;
};
var handleScroll = function (axis, endTarget, event, sourceDelta, noOverscroll) {
    var directionFactor = getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
    var delta = directionFactor * sourceDelta;
    // find scrollable target
    var target = event.target;
    var targetInLock = endTarget.contains(target);
    var shouldCancelScroll = false;
    var isDeltaPositive = delta > 0;
    var availableScroll = 0;
    var availableScrollTop = 0;
    do {
        var _a = getScrollVariables(axis, target), position = _a[0], scroll_1 = _a[1], capacity = _a[2];
        var elementScroll = scroll_1 - capacity - directionFactor * position;
        if (position || elementScroll) {
            if (elementCouldBeScrolled(axis, target)) {
                availableScroll += elementScroll;
                availableScrollTop += position;
            }
        }
        target = target.parentNode;
    } while (
    // portaled content
    (!targetInLock && target !== document.body) ||
        // self content
        (targetInLock && (endTarget.contains(target) || endTarget === target)));
    if (isDeltaPositive && ((noOverscroll && availableScroll === 0) || (!noOverscroll && delta > availableScroll))) {
        shouldCancelScroll = true;
    }
    else if (!isDeltaPositive &&
        ((noOverscroll && availableScrollTop === 0) || (!noOverscroll && -delta > availableScrollTop))) {
        shouldCancelScroll = true;
    }
    return shouldCancelScroll;
};

;// CONCATENATED MODULE: ../../node_modules/react-remove-scroll/dist/es2015/SideEffect.js






var getTouchXY = function (event) {
    return 'changedTouches' in event ? [event.changedTouches[0].clientX, event.changedTouches[0].clientY] : [0, 0];
};
var getDeltaXY = function (event) { return [event.deltaX, event.deltaY]; };
var extractRef = function (ref) {
    return ref && 'current' in ref ? ref.current : ref;
};
var deltaCompare = function (x, y) { return x[0] === y[0] && x[1] === y[1]; };
var generateStyle = function (id) { return "\n  .block-interactivity-".concat(id, " {pointer-events: none;}\n  .allow-interactivity-").concat(id, " {pointer-events: all;}\n"); };
var idCounter = 0;
var lockStack = [];
function RemoveScrollSideCar(props) {
    var shouldPreventQueue = react.useRef([]);
    var touchStartRef = react.useRef([0, 0]);
    var activeAxis = react.useRef();
    var id = react.useState(idCounter++)[0];
    var Style = react.useState(function () { return styleSingleton(); })[0];
    var lastProps = react.useRef(props);
    react.useEffect(function () {
        lastProps.current = props;
    }, [props]);
    react.useEffect(function () {
        if (props.inert) {
            document.body.classList.add("block-interactivity-".concat(id));
            var allow_1 = __spreadArray([props.lockRef.current], (props.shards || []).map(extractRef), true).filter(Boolean);
            allow_1.forEach(function (el) { return el.classList.add("allow-interactivity-".concat(id)); });
            return function () {
                document.body.classList.remove("block-interactivity-".concat(id));
                allow_1.forEach(function (el) { return el.classList.remove("allow-interactivity-".concat(id)); });
            };
        }
        return;
    }, [props.inert, props.lockRef.current, props.shards]);
    var shouldCancelEvent = react.useCallback(function (event, parent) {
        if ('touches' in event && event.touches.length === 2) {
            return !lastProps.current.allowPinchZoom;
        }
        var touch = getTouchXY(event);
        var touchStart = touchStartRef.current;
        var deltaX = 'deltaX' in event ? event.deltaX : touchStart[0] - touch[0];
        var deltaY = 'deltaY' in event ? event.deltaY : touchStart[1] - touch[1];
        var currentAxis;
        var target = event.target;
        var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? 'h' : 'v';
        // allow horizontal touch move on Range inputs. They will not cause any scroll
        if ('touches' in event && moveDirection === 'h' && target.type === 'range') {
            return false;
        }
        var canBeScrolledInMainDirection = locationCouldBeScrolled(moveDirection, target);
        if (!canBeScrolledInMainDirection) {
            return true;
        }
        if (canBeScrolledInMainDirection) {
            currentAxis = moveDirection;
        }
        else {
            currentAxis = moveDirection === 'v' ? 'h' : 'v';
            canBeScrolledInMainDirection = locationCouldBeScrolled(moveDirection, target);
            // other axis might be not scrollable
        }
        if (!canBeScrolledInMainDirection) {
            return false;
        }
        if (!activeAxis.current && 'changedTouches' in event && (deltaX || deltaY)) {
            activeAxis.current = currentAxis;
        }
        if (!currentAxis) {
            return true;
        }
        var cancelingAxis = activeAxis.current || currentAxis;
        return handleScroll(cancelingAxis, parent, event, cancelingAxis === 'h' ? deltaX : deltaY, true);
    }, []);
    var shouldPrevent = react.useCallback(function (_event) {
        var event = _event;
        if (!lockStack.length || lockStack[lockStack.length - 1] !== Style) {
            // not the last active
            return;
        }
        var delta = 'deltaY' in event ? getDeltaXY(event) : getTouchXY(event);
        var sourceEvent = shouldPreventQueue.current.filter(function (e) { return e.name === event.type && e.target === event.target && deltaCompare(e.delta, delta); })[0];
        // self event, and should be canceled
        if (sourceEvent && sourceEvent.should) {
            if (event.cancelable) {
                event.preventDefault();
            }
            return;
        }
        // outside or shard event
        if (!sourceEvent) {
            var shardNodes = (lastProps.current.shards || [])
                .map(extractRef)
                .filter(Boolean)
                .filter(function (node) { return node.contains(event.target); });
            var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
            if (shouldStop) {
                if (event.cancelable) {
                    event.preventDefault();
                }
            }
        }
    }, []);
    var shouldCancel = react.useCallback(function (name, delta, target, should) {
        var event = { name: name, delta: delta, target: target, should: should };
        shouldPreventQueue.current.push(event);
        setTimeout(function () {
            shouldPreventQueue.current = shouldPreventQueue.current.filter(function (e) { return e !== event; });
        }, 1);
    }, []);
    var scrollTouchStart = react.useCallback(function (event) {
        touchStartRef.current = getTouchXY(event);
        activeAxis.current = undefined;
    }, []);
    var scrollWheel = react.useCallback(function (event) {
        shouldCancel(event.type, getDeltaXY(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    var scrollTouchMove = react.useCallback(function (event) {
        shouldCancel(event.type, getTouchXY(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    react.useEffect(function () {
        lockStack.push(Style);
        props.setCallbacks({
            onScrollCapture: scrollWheel,
            onWheelCapture: scrollWheel,
            onTouchMoveCapture: scrollTouchMove,
        });
        document.addEventListener('wheel', shouldPrevent, nonPassive);
        document.addEventListener('touchmove', shouldPrevent, nonPassive);
        document.addEventListener('touchstart', scrollTouchStart, nonPassive);
        return function () {
            lockStack = lockStack.filter(function (inst) { return inst !== Style; });
            document.removeEventListener('wheel', shouldPrevent, nonPassive);
            document.removeEventListener('touchmove', shouldPrevent, nonPassive);
            document.removeEventListener('touchstart', scrollTouchStart, nonPassive);
        };
    }, []);
    var removeScrollBar = props.removeScrollBar, inert = props.inert;
    return (react.createElement(react.Fragment, null,
        inert ? react.createElement(Style, { styles: generateStyle(id) }) : null,
        removeScrollBar ? react.createElement(RemoveScrollBar, { gapMode: "margin" }) : null));
}

;// CONCATENATED MODULE: ../../node_modules/react-remove-scroll/dist/es2015/sidecar.js



/* harmony default export */ var sidecar = (exportSidecar(effectCar, RemoveScrollSideCar));

;// CONCATENATED MODULE: ../../node_modules/react-remove-scroll/dist/es2015/Combination.js




var ReactRemoveScroll = react.forwardRef(function (props, ref) { return (react.createElement(RemoveScroll, __assign({}, props, { ref: ref, sideCar: sidecar }))); });
ReactRemoveScroll.classNames = RemoveScroll.classNames;
/* harmony default export */ var Combination = (ReactRemoveScroll);


/***/ }),

/***/ 99271:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RemoveScroll": function() { return /* reexport safe */ _Combination__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Combination__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18217);




/***/ }),

/***/ 36169:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;
/**
 * Copyright (c) Nicolas Gallagher
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


__webpack_unused_export__ = ({
  value: true
});
exports.D = void 0;
var cache = new WeakMap();
var compiledKey = '$$css';

function createStyleq(options) {
  var disableCache;
  var disableMix;
  var transform;

  if (options != null) {
    disableCache = options.disableCache === true;
    disableMix = options.disableMix === true;
    transform = options.transform;
  }

  return function styleq() {
    // Keep track of property commits to the className
    var definedProperties = []; // The className and inline style to build up

    var className = '';
    var inlineStyle = null; // The current position in the cache graph

    var nextCache = disableCache ? null : cache; // This way of creating an array from arguments is fastest

    var styles = new Array(arguments.length);

    for (var i = 0; i < arguments.length; i++) {
      styles[i] = arguments[i];
    } // Iterate over styles from last to first


    while (styles.length > 0) {
      var possibleStyle = styles.pop(); // Skip empty items

      if (possibleStyle == null || possibleStyle === false) {
        continue;
      } // Push nested styles back onto the stack to be processed


      if (Array.isArray(possibleStyle)) {
        for (var _i = 0; _i < possibleStyle.length; _i++) {
          styles.push(possibleStyle[_i]);
        }

        continue;
      } // Process an individual style object


      var style = transform != null ? transform(possibleStyle) : possibleStyle;

      if (style.$$css) {
        // Build up the class names defined by this object
        var classNameChunk = ''; // Check the cache to see if we've already done this work

        if (nextCache != null && nextCache.has(style)) {
          // Cache: read
          var cacheEntry = nextCache.get(style);

          if (cacheEntry != null) {
            classNameChunk = cacheEntry[0]; // $FlowIgnore

            definedProperties.push.apply(definedProperties, cacheEntry[1]);
            nextCache = cacheEntry[2];
          }
        } // Update the chunks with data from this object
        else {
          // The properties defined by this object
          var definedPropertiesChunk = [];

          for (var prop in style) {
            var value = style[prop];
            if (prop === compiledKey) continue; // Each property value is used as an HTML class name
            // { 'debug.string': 'debug.string', opacity: 's-jskmnoqp' }

            if (typeof value === 'string' || value === null) {
              // Only add to chunks if this property hasn't already been seen
              if (!definedProperties.includes(prop)) {
                definedProperties.push(prop);

                if (nextCache != null) {
                  definedPropertiesChunk.push(prop);
                }

                if (typeof value === 'string') {
                  classNameChunk += classNameChunk ? ' ' + value : value;
                }
              }
            } // If we encounter a value that isn't a string or `null`
            else {
              console.error("styleq: ".concat(prop, " typeof ").concat(String(value), " is not \"string\" or \"null\"."));
            }
          } // Cache: write


          if (nextCache != null) {
            // Create the next WeakMap for this sequence of styles
            var weakMap = new WeakMap();
            nextCache.set(style, [classNameChunk, definedPropertiesChunk, weakMap]);
            nextCache = weakMap;
          }
        } // Order of classes in chunks matches property-iteration order of style
        // object. Order of chunks matches passed order of styles from first to
        // last (which we iterate over in reverse).


        if (classNameChunk) {
          className = className ? classNameChunk + ' ' + className : classNameChunk;
        }
      } // ----- DYNAMIC: Process inline style object -----
      else {
        if (disableMix) {
          if (inlineStyle == null) {
            inlineStyle = {};
          }

          inlineStyle = Object.assign({}, style, inlineStyle);
        } else {
          var subStyle = null;

          for (var _prop in style) {
            var _value = style[_prop];

            if (_value !== undefined) {
              if (!definedProperties.includes(_prop)) {
                if (_value != null) {
                  if (inlineStyle == null) {
                    inlineStyle = {};
                  }

                  if (subStyle == null) {
                    subStyle = {};
                  }

                  subStyle[_prop] = _value;
                }

                definedProperties.push(_prop); // Cache is unnecessary overhead if results can't be reused.

                nextCache = null;
              }
            }
          }

          if (subStyle != null) {
            inlineStyle = Object.assign(subStyle, inlineStyle);
          }
        }
      }
    }

    var styleProps = [className, inlineStyle];
    return styleProps;
  };
}

var styleq = createStyleq();
exports.D = styleq;
styleq.factory = createStyleq;

/***/ }),

/***/ 73699:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;
/**
 * Copyright (c) Nicolas Gallagher
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */


__webpack_unused_export__ = ({
  value: true
});
exports.j = localizeStyle;
var cache = new WeakMap();
var markerProp = '$$css$localize';
/**
 * The compiler polyfills logical properties and values, generating a class
 * name for both writing directions. The style objects are annotated by
 * the compiler as needing this runtime transform. The results are memoized.
 *
 * { '$$css$localize': true, float: [ 'float-left', 'float-right' ] }
 * => { float: 'float-left' }
 */

function compileStyle(style, isRTL) {
  // Create a new compiled style for styleq
  var compiledStyle = {};

  for (var prop in style) {
    if (prop !== markerProp) {
      var value = style[prop];

      if (Array.isArray(value)) {
        compiledStyle[prop] = isRTL ? value[1] : value[0];
      } else {
        compiledStyle[prop] = value;
      }
    }
  }

  return compiledStyle;
}

function localizeStyle(style, isRTL) {
  if (style[markerProp] != null) {
    var compiledStyleIndex = isRTL ? 1 : 0; // Check the cache in case we've already seen this object

    if (cache.has(style)) {
      var _cachedStyles = cache.get(style);

      var _compiledStyle = _cachedStyles[compiledStyleIndex];

      if (_compiledStyle == null) {
        // Update the missing cache entry
        _compiledStyle = compileStyle(style, isRTL);
        _cachedStyles[compiledStyleIndex] = _compiledStyle;
        cache.set(style, _cachedStyles);
      }

      return _compiledStyle;
    } // Create a new compiled style for styleq


    var compiledStyle = compileStyle(style, isRTL);
    var cachedStyles = new Array(2);
    cachedStyles[compiledStyleIndex] = compiledStyle;
    cache.set(style, cachedStyles);
    return compiledStyle;
  }

  return style;
}

/***/ }),

/***/ 55217:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* reexport safe */ _compose_refs__WEBPACK_IMPORTED_MODULE_0__.F; },
/* harmony export */   "e": function() { return /* reexport safe */ _compose_refs__WEBPACK_IMPORTED_MODULE_0__.e; }
/* harmony export */ });
/* harmony import */ var _compose_refs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4429);

//# sourceMappingURL=index.mjs.map


/***/ }),

/***/ 11649:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$L": function() { return /* binding */ isWeb; },
/* harmony export */   "Ax": function() { return /* binding */ isWindowDefined; },
/* harmony export */   "C5": function() { return /* binding */ isClient; },
/* harmony export */   "LI": function() { return /* binding */ useIsomorphicLayoutEffect; },
/* harmony export */   "PS": function() { return /* binding */ isRSC; },
/* harmony export */   "i4": function() { return /* binding */ isWebTouchable; },
/* harmony export */   "i7": function() { return /* binding */ isChrome; },
/* harmony export */   "sk": function() { return /* binding */ isServer; },
/* harmony export */   "wT": function() { return /* binding */ isTouchable; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* provided dependency */ var process = __webpack_require__(34406);

const isWeb = "web" === "web";
const isWindowDefined = typeof window !== "undefined";
const isServer = isWeb && !isWindowDefined;
const isClient = isWeb && isWindowDefined;
const isRSC = process.env.ENABLE_RSC ? (
  // note this is statically analyzed so no funny business, just access it without optional chaining
  // @ts-ignore
   false ? (
    // @ts-ignore
    0
  ) : false
) : false;
const idFn = () => {
};
const useIsomorphicLayoutEffect = isRSC ? idFn : isServer ? react__WEBPACK_IMPORTED_MODULE_0__.useEffect : react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect;
const isChrome = typeof navigator !== "undefined" && /Chrome/.test(navigator.userAgent || "");
const isWebTouchable = isClient && ("ontouchstart" in window || navigator.maxTouchPoints > 0);
const isTouchable = !isWeb || isWebTouchable;
if (false) {}

//# sourceMappingURL=index.mjs.map


/***/ }),

/***/ 44996:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Stack": function() { return /* binding */ Stack; },
/* harmony export */   "Text": function() { return /* binding */ Text; }
/* harmony export */ });
/* harmony import */ var _tamagui_react_native_use_responder_events__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26826);
/* harmony import */ var _tamagui_web__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42039);
/* harmony import */ var _tamagui_web__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8669);
/* harmony import */ var _tamagui_web__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46713);
/* harmony import */ var _tamagui_web__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11649);
/* harmony import */ var _hooks_useElementLayout__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3379);
/* harmony import */ var _hooks_usePlatformMethods__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29561);
/* harmony import */ var _tamagui_web__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44571);
/* harmony reexport (unknown) */ var __WEBPACK_REEXPORT_OBJECT__ = {};
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _tamagui_web__WEBPACK_IMPORTED_MODULE_1__) if(["default","Stack","Text"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) __WEBPACK_REEXPORT_OBJECT__[__WEBPACK_IMPORT_KEY__] = function(key) { return _tamagui_web__WEBPACK_IMPORTED_MODULE_1__[key]; }.bind(0, __WEBPACK_IMPORT_KEY__)
/* harmony reexport (unknown) */ __webpack_require__.d(__webpack_exports__, __WEBPACK_REEXPORT_OBJECT__);






const Stack = _tamagui_web__WEBPACK_IMPORTED_MODULE_2__/* .Stack */ .K;
const Text = _tamagui_web__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .x;
(0,_tamagui_web__WEBPACK_IMPORTED_MODULE_4__/* .setupHooks */ .b)({
  getBaseViews() {
    const native = require("react-native");
    return {
      View: native.View || native.default.View,
      Text: native.Text || native.default.Text
    };
  },
  usePropsTransform(elementType, propsIn, hostRef) {
    const {
      // event props
      onMoveShouldSetResponder,
      onMoveShouldSetResponderCapture,
      onResponderEnd,
      onResponderGrant,
      onResponderMove,
      onResponderReject,
      onResponderRelease,
      onResponderStart,
      onResponderTerminate,
      onResponderTerminationRequest,
      onScrollShouldSetResponder,
      onScrollShouldSetResponderCapture,
      onSelectionChangeShouldSetResponder,
      onSelectionChangeShouldSetResponderCapture,
      onStartShouldSetResponder,
      onStartShouldSetResponderCapture,
      // android
      collapsable,
      focusable,
      // deprecated,
      accessible,
      accessibilityDisabled,
      onLayout,
      hrefAttrs,
      ...viewProps
    } = propsIn;
    if (!_tamagui_web__WEBPACK_IMPORTED_MODULE_5__/* .isRSC */ .PS) {
      (0,_hooks_usePlatformMethods__WEBPACK_IMPORTED_MODULE_6__/* .usePlatformMethods */ .V)(hostRef);
      (0,_hooks_useElementLayout__WEBPACK_IMPORTED_MODULE_7__/* .useElementLayout */ .g)(hostRef, onLayout);
      (0,_tamagui_react_native_use_responder_events__WEBPACK_IMPORTED_MODULE_0__/* .useResponderEvents */ .Gy)(hostRef, {
        onMoveShouldSetResponder,
        onMoveShouldSetResponderCapture,
        onResponderEnd,
        onResponderGrant,
        onResponderMove,
        onResponderReject,
        onResponderRelease,
        onResponderStart,
        onResponderTerminate,
        onResponderTerminationRequest,
        onScrollShouldSetResponder,
        onScrollShouldSetResponderCapture,
        onSelectionChangeShouldSetResponder,
        onSelectionChangeShouldSetResponderCapture,
        onStartShouldSetResponder,
        onStartShouldSetResponderCapture
      });
    }
    if (viewProps.href !== void 0 && hrefAttrs !== void 0) {
      const { download, rel, target } = hrefAttrs;
      if (download != null) {
        viewProps.download = download;
      }
      if (rel != null) {
        viewProps.rel = rel;
      }
      if (typeof target === "string") {
        viewProps.target = target.charAt(0) !== "_" ? `_${target}` : target;
      }
    }
    if (!viewProps.tabIndex) {
      const _focusable = focusable !== void 0 ? focusable : accessible;
      const role = viewProps.role;
      if (_focusable === false) {
        viewProps.tabIndex = "-1";
      }
      if (
        // These native elements are focusable by default
        elementType === "a" || elementType === "button" || elementType === "input" || elementType === "select" || elementType === "textarea"
      ) {
        if (_focusable === false || accessibilityDisabled === true) {
          viewProps.tabIndex = "-1";
        }
      } else if (
        // These roles are made focusable by default
        role === "button" || role === "checkbox" || role === "link" || role === "radio" || role === "textbox" || role === "switch"
      ) {
        if (_focusable !== false) {
          viewProps.tabIndex = "0";
        }
      }
      if (_focusable === true) {
        viewProps.tabIndex = "0";
      }
    }
    return viewProps;
  },
  useEvents(viewProps, events, { pseudos }, setStateShallow) {
    if (false) {}
  }
});
const dontComposePressabilityKeys = {
  onClick: true
};

//# sourceMappingURL=index.mjs.map


/***/ }),

/***/ 95591:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "clamp": function() { return /* reexport safe */ _clamp__WEBPACK_IMPORTED_MODULE_0__.u; },
/* harmony export */   "composeEventHandlers": function() { return /* reexport safe */ _composeEventHandlers__WEBPACK_IMPORTED_MODULE_1__.M; },
/* harmony export */   "concatClassName": function() { return /* reexport safe */ _concatClassName__WEBPACK_IMPORTED_MODULE_2__.E; },
/* harmony export */   "isValidCSSCharCode": function() { return /* reexport safe */ _tamagui_simple_hash__WEBPACK_IMPORTED_MODULE_5__.z; },
/* harmony export */   "simpleHash": function() { return /* reexport safe */ _tamagui_simple_hash__WEBPACK_IMPORTED_MODULE_5__.M; },
/* harmony export */   "stylePropsAll": function() { return /* reexport safe */ _validStyleProps__WEBPACK_IMPORTED_MODULE_3__.cC; },
/* harmony export */   "stylePropsText": function() { return /* reexport safe */ _validStyleProps__WEBPACK_IMPORTED_MODULE_3__.FB; },
/* harmony export */   "stylePropsTextOnly": function() { return /* reexport safe */ _validStyleProps__WEBPACK_IMPORTED_MODULE_3__.hT; },
/* harmony export */   "stylePropsTransform": function() { return /* reexport safe */ _validStyleProps__WEBPACK_IMPORTED_MODULE_3__.Dc; },
/* harmony export */   "stylePropsView": function() { return /* reexport safe */ _validStyleProps__WEBPACK_IMPORTED_MODULE_3__.Ji; },
/* harmony export */   "validPseudoKeys": function() { return /* reexport safe */ _validStyleProps__WEBPACK_IMPORTED_MODULE_3__.M6; },
/* harmony export */   "validStyles": function() { return /* reexport safe */ _validStyleProps__WEBPACK_IMPORTED_MODULE_3__.Qn; },
/* harmony export */   "validStylesOnBaseProps": function() { return /* reexport safe */ _validStyleProps__WEBPACK_IMPORTED_MODULE_3__.bX; }
/* harmony export */ });
/* harmony import */ var _clamp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96397);
/* harmony import */ var _composeEventHandlers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91093);
/* harmony import */ var _concatClassName__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31016);
/* harmony import */ var _validStyleProps__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21152);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45792);
/* harmony reexport (unknown) */ var __WEBPACK_REEXPORT_OBJECT__ = {};
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _types__WEBPACK_IMPORTED_MODULE_4__) if(["default","clamp","composeEventHandlers","concatClassName","stylePropsAll","stylePropsText","stylePropsTextOnly","stylePropsTransform","stylePropsView","validPseudoKeys","validStyles","validStylesOnBaseProps"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) __WEBPACK_REEXPORT_OBJECT__[__WEBPACK_IMPORT_KEY__] = function(key) { return _types__WEBPACK_IMPORTED_MODULE_4__[key]; }.bind(0, __WEBPACK_IMPORT_KEY__)
/* harmony reexport (unknown) */ __webpack_require__.d(__webpack_exports__, __WEBPACK_REEXPORT_OBJECT__);
/* harmony import */ var _tamagui_simple_hash__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14709);






//# sourceMappingURL=index.mjs.map


/***/ }),

/***/ 4751:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* reexport */ useEvent; },
  "X": function() { return /* reexport */ useGet; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ./node_modules/@tamagui/use-event/dist/esm/useGet.js

const isWeb = "web" === "web";
const isClient = typeof window !== "undefined";
const useIsomorphicLayoutEffect = !isWeb || isClient ? react.useLayoutEffect : react.useEffect;
function useGet(currentValue, initialValue, forwardToFunction) {
  const curRef = (0,react.useRef)(initialValue ?? currentValue);
  useIsomorphicLayoutEffect(() => {
    curRef.current = currentValue;
  });
  return (0,react.useCallback)(
    forwardToFunction ? (...args) => {
      var _a;
      return (_a = curRef.current) == null ? void 0 : _a.apply(null, args);
    } : () => curRef.current,
    []
  );
}

//# sourceMappingURL=useGet.js.map

;// CONCATENATED MODULE: ./node_modules/@tamagui/use-event/dist/esm/useEvent.js

function useEvent(callback) {
  return useGet(callback, defaultValue, true);
}
const defaultValue = () => {
  throw new Error("Cannot call an event handler while rendering.");
};

//# sourceMappingURL=useEvent.js.map

;// CONCATENATED MODULE: ./node_modules/@tamagui/use-event/dist/esm/index.mjs


//# sourceMappingURL=index.mjs.map


/***/ }),

/***/ 53261:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ useForceUpdate; },
/* harmony export */   "s": function() { return /* binding */ isServerSide; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

const isServerSide =  true && typeof window === "undefined";
const idFn = () => {
};
function useForceUpdate() {
  return isServerSide ? idFn : (0,react__WEBPACK_IMPORTED_MODULE_0__.useReducer)((x) => x + 1, 0)[1];
}

//# sourceMappingURL=index.mjs.map


/***/ }),

/***/ 44571:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ButtonNestingContext": function() { return /* reexport safe */ _contexts_ButtonNestingContext_js__WEBPACK_IMPORTED_MODULE_32__.e; },
/* harmony export */   "FontLanguage": function() { return /* reexport safe */ _views_FontLanguage__WEBPACK_IMPORTED_MODULE_45__.o; },
/* harmony export */   "PROP_SPLIT": function() { return /* reexport safe */ _helpers_getSplitStyles_js__WEBPACK_IMPORTED_MODULE_20__.Fu; },
/* harmony export */   "ReactNativeStaticConfigs": function() { return /* reexport safe */ _setupReactNative_js__WEBPACK_IMPORTED_MODULE_14__.GE; },
/* harmony export */   "Slot": function() { return /* reexport safe */ _views_Slot_js__WEBPACK_IMPORTED_MODULE_39__.g7; },
/* harmony export */   "Slottable": function() { return /* reexport safe */ _views_Slot_js__WEBPACK_IMPORTED_MODULE_39__.A4; },
/* harmony export */   "Spacer": function() { return /* reexport safe */ _createComponent_js__WEBPACK_IMPORTED_MODULE_1__.LZ; },
/* harmony export */   "Stack": function() { return /* reexport safe */ _views_Stack_js__WEBPACK_IMPORTED_MODULE_40__.K; },
/* harmony export */   "THEME_CLASSNAME_PREFIX": function() { return /* reexport safe */ _constants_constants_js__WEBPACK_IMPORTED_MODULE_15__.nx; },
/* harmony export */   "THEME_NAME_SEPARATOR": function() { return /* reexport safe */ _constants_constants_js__WEBPACK_IMPORTED_MODULE_15__.L2; },
/* harmony export */   "Tamagui": function() { return /* reexport safe */ _Tamagui_js__WEBPACK_IMPORTED_MODULE_0__.jS; },
/* harmony export */   "TamaguiProvider": function() { return /* reexport safe */ _views_TamaguiProvider_js__WEBPACK_IMPORTED_MODULE_46__.r; },
/* harmony export */   "Text": function() { return /* reexport safe */ _views_Text_js__WEBPACK_IMPORTED_MODULE_41__.x; },
/* harmony export */   "TextAncestorContext": function() { return /* reexport safe */ _contexts_TextAncestorContext_js__WEBPACK_IMPORTED_MODULE_42__.M; },
/* harmony export */   "Theme": function() { return /* reexport safe */ _views_Theme_js__WEBPACK_IMPORTED_MODULE_43__.Q; },
/* harmony export */   "ThemeProvider": function() { return /* reexport safe */ _views_ThemeProvider_js__WEBPACK_IMPORTED_MODULE_44__.f; },
/* harmony export */   "ThemeProviderRootContext": function() { return /* reexport safe */ _views_ThemeProvider_js__WEBPACK_IMPORTED_MODULE_44__.B; },
/* harmony export */   "Unspaced": function() { return /* reexport safe */ _createComponent_js__WEBPACK_IMPORTED_MODULE_1__.GJ; },
/* harmony export */   "activeThemeManagers": function() { return /* reexport safe */ _hooks_useTheme_js__WEBPACK_IMPORTED_MODULE_35__.UP; },
/* harmony export */   "addTheme": function() { return /* reexport safe */ _addTheme_js__WEBPACK_IMPORTED_MODULE_10__._; },
/* harmony export */   "composeRefs": function() { return /* reexport safe */ _tamagui_compose_refs__WEBPACK_IMPORTED_MODULE_50__.F; },
/* harmony export */   "configureMedia": function() { return /* reexport safe */ _hooks_useMedia_js__WEBPACK_IMPORTED_MODULE_54__.jl; },
/* harmony export */   "createCSSVariable": function() { return /* reexport safe */ _createVariable_js__WEBPACK_IMPORTED_MODULE_7__.bK; },
/* harmony export */   "createComponent": function() { return /* reexport safe */ _createComponent_js__WEBPACK_IMPORTED_MODULE_1__.LM; },
/* harmony export */   "createFont": function() { return /* reexport safe */ _createFont_js__WEBPACK_IMPORTED_MODULE_5__.v; },
/* harmony export */   "createShorthands": function() { return /* reexport safe */ _createShorthands_js__WEBPACK_IMPORTED_MODULE_2__.L; },
/* harmony export */   "createTamagui": function() { return /* reexport safe */ _createTamagui_js__WEBPACK_IMPORTED_MODULE_4__._; },
/* harmony export */   "createTheme": function() { return /* reexport safe */ _createTheme_js__WEBPACK_IMPORTED_MODULE_3__.j; },
/* harmony export */   "createTokens": function() { return /* reexport safe */ _createTokens_js__WEBPACK_IMPORTED_MODULE_6__.l; },
/* harmony export */   "createVariable": function() { return /* reexport safe */ _createVariable_js__WEBPACK_IMPORTED_MODULE_7__.Os; },
/* harmony export */   "createVariables": function() { return /* reexport safe */ _createVariables_js__WEBPACK_IMPORTED_MODULE_8__.D; },
/* harmony export */   "defaultComponentState": function() { return /* reexport safe */ _createComponent_js__WEBPACK_IMPORTED_MODULE_1__.Lb; },
/* harmony export */   "didGetVariableValue": function() { return /* reexport safe */ _createVariable_js__WEBPACK_IMPORTED_MODULE_7__.yx; },
/* harmony export */   "expandStyles": function() { return /* reexport safe */ _helpers_expandStyles_js__WEBPACK_IMPORTED_MODULE_24__.Z; },
/* harmony export */   "fixStyles": function() { return /* reexport safe */ _helpers_expandStyles_js__WEBPACK_IMPORTED_MODULE_24__.S; },
/* harmony export */   "getAnimationDriver": function() { return /* reexport safe */ _helpers_getAnimationDriver_js__WEBPACK_IMPORTED_MODULE_18__.B; },
/* harmony export */   "getAtomicStyle": function() { return /* reexport safe */ _helpers_getStylesAtomic__WEBPACK_IMPORTED_MODULE_21__.sG; },
/* harmony export */   "getConfig": function() { return /* reexport safe */ _config_js__WEBPACK_IMPORTED_MODULE_55__.iE; },
/* harmony export */   "getExpandedShorthands": function() { return /* reexport safe */ _helpers_getExpandedShorthands_js__WEBPACK_IMPORTED_MODULE_19__.p; },
/* harmony export */   "getFontsForLanguage": function() { return /* reexport safe */ _helpers_getVariantExtras_js__WEBPACK_IMPORTED_MODULE_17__.r; },
/* harmony export */   "getMedia": function() { return /* reexport safe */ _hooks_useMedia_js__WEBPACK_IMPORTED_MODULE_54__.om; },
/* harmony export */   "getReactNativeConfig": function() { return /* reexport safe */ _setupReactNative_js__WEBPACK_IMPORTED_MODULE_14__.fA; },
/* harmony export */   "getSplitStyles": function() { return /* reexport safe */ _helpers_getSplitStyles_js__WEBPACK_IMPORTED_MODULE_20__.Dt; },
/* harmony export */   "getStylesAtomic": function() { return /* reexport safe */ _helpers_getStylesAtomic__WEBPACK_IMPORTED_MODULE_21__.yq; },
/* harmony export */   "getSubStyle": function() { return /* reexport safe */ _helpers_getSplitStyles_js__WEBPACK_IMPORTED_MODULE_20__.AQ; },
/* harmony export */   "getThemeProxied": function() { return /* reexport safe */ _hooks_useTheme_js__WEBPACK_IMPORTED_MODULE_35__.Wk; },
/* harmony export */   "getThemes": function() { return /* reexport safe */ _config_js__WEBPACK_IMPORTED_MODULE_55__.RC; },
/* harmony export */   "getTokens": function() { return /* reexport safe */ _config_js__WEBPACK_IMPORTED_MODULE_55__.lz; },
/* harmony export */   "getValueFromIdentifier": function() { return /* reexport safe */ _Tamagui_js__WEBPACK_IMPORTED_MODULE_0__.CW; },
/* harmony export */   "getVariable": function() { return /* reexport safe */ _createVariable_js__WEBPACK_IMPORTED_MODULE_7__.E0; },
/* harmony export */   "getVariableName": function() { return /* reexport safe */ _createVariable_js__WEBPACK_IMPORTED_MODULE_7__.H; },
/* harmony export */   "getVariableValue": function() { return /* reexport safe */ _createVariable_js__WEBPACK_IMPORTED_MODULE_7__.Ve; },
/* harmony export */   "getVariableVariable": function() { return /* reexport safe */ _createVariable_js__WEBPACK_IMPORTED_MODULE_7__.kv; },
/* harmony export */   "getVariantExtras": function() { return /* reexport safe */ _helpers_getVariantExtras_js__WEBPACK_IMPORTED_MODULE_17__.A; },
/* harmony export */   "hooks": function() { return /* reexport safe */ _setupHooks_js__WEBPACK_IMPORTED_MODULE_53__.P; },
/* harmony export */   "insertFont": function() { return /* reexport safe */ _insertFont_js__WEBPACK_IMPORTED_MODULE_9__.os; },
/* harmony export */   "insertSplitStyles": function() { return /* reexport safe */ _helpers_getSplitStyles_js__WEBPACK_IMPORTED_MODULE_20__.ts; },
/* harmony export */   "isChrome": function() { return /* reexport safe */ _tamagui_constants__WEBPACK_IMPORTED_MODULE_52__.i7; },
/* harmony export */   "isClient": function() { return /* reexport safe */ _tamagui_constants__WEBPACK_IMPORTED_MODULE_52__.C5; },
/* harmony export */   "isRSC": function() { return /* reexport safe */ _tamagui_constants__WEBPACK_IMPORTED_MODULE_52__.PS; },
/* harmony export */   "isServer": function() { return /* reexport safe */ _tamagui_constants__WEBPACK_IMPORTED_MODULE_52__.sk; },
/* harmony export */   "isServerSide": function() { return /* reexport safe */ _tamagui_use_force_update__WEBPACK_IMPORTED_MODULE_47__.s; },
/* harmony export */   "isTamaguiComponent": function() { return /* reexport safe */ _helpers_isTamaguiComponent_js__WEBPACK_IMPORTED_MODULE_26__.R; },
/* harmony export */   "isTamaguiElement": function() { return /* reexport safe */ _helpers_isTamaguiElement_js__WEBPACK_IMPORTED_MODULE_25__.y; },
/* harmony export */   "isTouchable": function() { return /* reexport safe */ _tamagui_constants__WEBPACK_IMPORTED_MODULE_52__.wT; },
/* harmony export */   "isVariable": function() { return /* reexport safe */ _createVariable_js__WEBPACK_IMPORTED_MODULE_7__.cG; },
/* harmony export */   "isWeb": function() { return /* reexport safe */ _tamagui_constants__WEBPACK_IMPORTED_MODULE_52__.$L; },
/* harmony export */   "isWebTouchable": function() { return /* reexport safe */ _tamagui_constants__WEBPACK_IMPORTED_MODULE_52__.i4; },
/* harmony export */   "isWindowDefined": function() { return /* reexport safe */ _tamagui_constants__WEBPACK_IMPORTED_MODULE_52__.Ax; },
/* harmony export */   "matchMedia": function() { return /* reexport safe */ _helpers_matchMedia__WEBPACK_IMPORTED_MODULE_27__.L; },
/* harmony export */   "mediaObjectToString": function() { return /* reexport safe */ _hooks_useMedia_js__WEBPACK_IMPORTED_MODULE_54__.yS; },
/* harmony export */   "mediaQueryConfig": function() { return /* reexport safe */ _hooks_useMedia_js__WEBPACK_IMPORTED_MODULE_54__.aN; },
/* harmony export */   "mediaState": function() { return /* reexport safe */ _hooks_useMedia_js__WEBPACK_IMPORTED_MODULE_54__.nA; },
/* harmony export */   "mergeEvent": function() { return /* reexport safe */ _views_Slot_js__WEBPACK_IMPORTED_MODULE_39__.qR; },
/* harmony export */   "mergeProps": function() { return /* reexport safe */ _helpers_mergeProps_js__WEBPACK_IMPORTED_MODULE_23__.d; },
/* harmony export */   "mouseUps": function() { return /* reexport safe */ _createComponent_js__WEBPACK_IMPORTED_MODULE_1__.s0; },
/* harmony export */   "names": function() { return /* reexport safe */ _helpers_normalizeColor_js__WEBPACK_IMPORTED_MODULE_31__.R5; },
/* harmony export */   "normalizeColor": function() { return /* reexport safe */ _helpers_normalizeColor_js__WEBPACK_IMPORTED_MODULE_31__.ut; },
/* harmony export */   "onConfiguredOnce": function() { return /* reexport safe */ _config_js__WEBPACK_IMPORTED_MODULE_55__.xC; },
/* harmony export */   "parseFont": function() { return /* reexport safe */ _insertFont_js__WEBPACK_IMPORTED_MODULE_9__.ZL; },
/* harmony export */   "proxyThemeVariables": function() { return /* reexport safe */ _helpers_proxyThemeVariables_js__WEBPACK_IMPORTED_MODULE_28__.Q; },
/* harmony export */   "pseudoDescriptors": function() { return /* reexport safe */ _helpers_pseudoDescriptors_js__WEBPACK_IMPORTED_MODULE_22__.Q; },
/* harmony export */   "registerFontVariables": function() { return /* reexport safe */ _insertFont_js__WEBPACK_IMPORTED_MODULE_9__.QF; },
/* harmony export */   "rgba": function() { return /* reexport safe */ _helpers_normalizeColor_js__WEBPACK_IMPORTED_MODULE_31__.m4; },
/* harmony export */   "setDidGetVariableValue": function() { return /* reexport safe */ _createVariable_js__WEBPACK_IMPORTED_MODULE_7__.zY; },
/* harmony export */   "setIdentifierValue": function() { return /* reexport safe */ _Tamagui_js__WEBPACK_IMPORTED_MODULE_0__.eH; },
/* harmony export */   "setupHooks": function() { return /* reexport safe */ _setupHooks_js__WEBPACK_IMPORTED_MODULE_53__.b; },
/* harmony export */   "setupMatchMedia": function() { return /* reexport safe */ _helpers_matchMedia__WEBPACK_IMPORTED_MODULE_27__.D; },
/* harmony export */   "setupReactNative": function() { return /* reexport safe */ _setupReactNative_js__WEBPACK_IMPORTED_MODULE_14__.Gy; },
/* harmony export */   "spacedChildren": function() { return /* reexport safe */ _createComponent_js__WEBPACK_IMPORTED_MODULE_1__.P9; },
/* harmony export */   "stackDefaultStyles": function() { return /* reexport safe */ _constants_constants_js__WEBPACK_IMPORTED_MODULE_15__.tn; },
/* harmony export */   "styleToCSS": function() { return /* reexport safe */ _helpers_getStylesAtomic__WEBPACK_IMPORTED_MODULE_21__.FL; },
/* harmony export */   "styled": function() { return /* reexport safe */ _styled_js__WEBPACK_IMPORTED_MODULE_12__.z; },
/* harmony export */   "themeable": function() { return /* reexport safe */ _helpers_themeable_js__WEBPACK_IMPORTED_MODULE_29__.Y; },
/* harmony export */   "tokensKeysOrdered": function() { return /* reexport safe */ _createVariables_js__WEBPACK_IMPORTED_MODULE_8__.O; },
/* harmony export */   "updateTheme": function() { return /* reexport safe */ _updateTheme_js__WEBPACK_IMPORTED_MODULE_11__.x; },
/* harmony export */   "useChangeThemeEffect": function() { return /* reexport safe */ _hooks_useTheme_js__WEBPACK_IMPORTED_MODULE_35__.fe; },
/* harmony export */   "useComposedRefs": function() { return /* reexport safe */ _tamagui_compose_refs__WEBPACK_IMPORTED_MODULE_50__.e; },
/* harmony export */   "useDidFinishSSR": function() { return /* reexport safe */ _tamagui_use_did_finish_ssr__WEBPACK_IMPORTED_MODULE_48__.S; },
/* harmony export */   "useEvent": function() { return /* reexport safe */ _tamagui_use_event__WEBPACK_IMPORTED_MODULE_49__.z; },
/* harmony export */   "useForceUpdate": function() { return /* reexport safe */ _tamagui_use_force_update__WEBPACK_IMPORTED_MODULE_47__.N; },
/* harmony export */   "useGet": function() { return /* reexport safe */ _tamagui_use_event__WEBPACK_IMPORTED_MODULE_49__.X; },
/* harmony export */   "useId": function() { return /* reexport safe */ _hooks_useId_js__WEBPACK_IMPORTED_MODULE_33__.M; },
/* harmony export */   "useIsTouchDevice": function() { return /* reexport safe */ _hooks_useIsTouchDevice_js__WEBPACK_IMPORTED_MODULE_34__.Y; },
/* harmony export */   "useIsomorphicLayoutEffect": function() { return /* reexport safe */ _tamagui_constants__WEBPACK_IMPORTED_MODULE_52__.LI; },
/* harmony export */   "useMedia": function() { return /* reexport safe */ _hooks_useMedia_js__WEBPACK_IMPORTED_MODULE_54__.GS; },
/* harmony export */   "useMediaPropsActive": function() { return /* reexport safe */ _hooks_useMedia_js__WEBPACK_IMPORTED_MODULE_54__.lA; },
/* harmony export */   "useSafeRef": function() { return /* reexport safe */ _hooks_useSafeRef_js__WEBPACK_IMPORTED_MODULE_37__.p; },
/* harmony export */   "useShallowSetState": function() { return /* reexport safe */ _helpers_useShallowSetState_js__WEBPACK_IMPORTED_MODULE_16__.S; },
/* harmony export */   "useSplitStyles": function() { return /* reexport safe */ _helpers_getSplitStyles_js__WEBPACK_IMPORTED_MODULE_20__.DP; },
/* harmony export */   "useStyle": function() { return /* reexport safe */ _hooks_useStyle_js__WEBPACK_IMPORTED_MODULE_38__.X; },
/* harmony export */   "useTheme": function() { return /* reexport safe */ _hooks_useTheme_js__WEBPACK_IMPORTED_MODULE_35__.Fg; },
/* harmony export */   "useThemeName": function() { return /* reexport safe */ _hooks_useThemeName_js__WEBPACK_IMPORTED_MODULE_36__.C; },
/* harmony export */   "useThemeWithState": function() { return /* reexport safe */ _hooks_useTheme_js__WEBPACK_IMPORTED_MODULE_35__.WU; },
/* harmony export */   "useThemedChildren": function() { return /* reexport safe */ _views_Theme_js__WEBPACK_IMPORTED_MODULE_43__.y; },
/* harmony export */   "variableToString": function() { return /* reexport safe */ _createVariable_js__WEBPACK_IMPORTED_MODULE_7__.lk; },
/* harmony export */   "webOnlyDefaultStyles": function() { return /* reexport safe */ _constants_constants_js__WEBPACK_IMPORTED_MODULE_15__.F2; },
/* harmony export */   "withStaticProperties": function() { return /* reexport safe */ _helpers_withStaticProperties_js__WEBPACK_IMPORTED_MODULE_30__.$; }
/* harmony export */ });
/* harmony import */ var _Tamagui_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68709);
/* harmony import */ var _createComponent_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6905);
/* harmony import */ var _createShorthands_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8396);
/* harmony import */ var _createTheme_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65139);
/* harmony import */ var _createTamagui_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44417);
/* harmony import */ var _createFont_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47727);
/* harmony import */ var _createTokens_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(93122);
/* harmony import */ var _createVariable_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(13209);
/* harmony import */ var _createVariables_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(61298);
/* harmony import */ var _insertFont_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(62498);
/* harmony import */ var _addTheme_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(38226);
/* harmony import */ var _updateTheme_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(91885);
/* harmony import */ var _styled_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(90662);
/* harmony import */ var _types_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(66335);
/* harmony reexport (unknown) */ var __WEBPACK_REEXPORT_OBJECT__ = {};
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _types_js__WEBPACK_IMPORTED_MODULE_13__) if(["default","configureMedia","getConfig","getMedia","getThemes","getTokens","mediaObjectToString","mediaQueryConfig","mediaState","onConfiguredOnce","useMedia","useMediaPropsActive","Tamagui","getValueFromIdentifier","setIdentifierValue","Spacer","Unspaced","createComponent","defaultComponentState","mouseUps","spacedChildren","createShorthands","createTheme","createTamagui","createFont","createTokens","createCSSVariable","createVariable","didGetVariableValue","getVariable","getVariableName","getVariableValue","getVariableVariable","isVariable","setDidGetVariableValue","variableToString","createVariables","tokensKeysOrdered","insertFont","parseFont","registerFontVariables","addTheme","updateTheme","styled"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) __WEBPACK_REEXPORT_OBJECT__[__WEBPACK_IMPORT_KEY__] = function(key) { return _types_js__WEBPACK_IMPORTED_MODULE_13__[key]; }.bind(0, __WEBPACK_IMPORT_KEY__)
/* harmony reexport (unknown) */ __webpack_require__.d(__webpack_exports__, __WEBPACK_REEXPORT_OBJECT__);
/* harmony import */ var _setupReactNative_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(26575);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_55__ = __webpack_require__(47269);
/* harmony import */ var _constants_constants_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(74288);
/* harmony import */ var _helpers_useShallowSetState_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(1493);
/* harmony import */ var _helpers_getVariantExtras_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(40192);
/* harmony import */ var _helpers_getAnimationDriver_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(12500);
/* harmony import */ var _helpers_getExpandedShorthands_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(57248);
/* harmony import */ var _helpers_getSplitStyles_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(49678);
/* harmony import */ var _helpers_getStylesAtomic__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(89249);
/* harmony import */ var _helpers_pseudoDescriptors_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(58325);
/* harmony import */ var _helpers_mergeProps_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(88410);
/* harmony import */ var _helpers_expandStyles_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(38217);
/* harmony import */ var _helpers_isTamaguiElement_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(67423);
/* harmony import */ var _helpers_isTamaguiComponent_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(85120);
/* harmony import */ var _helpers_matchMedia__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(80906);
/* harmony import */ var _helpers_proxyThemeVariables_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(8503);
/* harmony import */ var _helpers_themeable_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(8573);
/* harmony import */ var _helpers_withStaticProperties_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(74387);
/* harmony import */ var _helpers_normalizeColor_js__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(97202);
/* harmony import */ var _contexts_ButtonNestingContext_js__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(19924);
/* harmony import */ var _hooks_useId_js__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(33744);
/* harmony import */ var _hooks_useIsTouchDevice_js__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(45856);
/* harmony import */ var _hooks_useMedia_js__WEBPACK_IMPORTED_MODULE_54__ = __webpack_require__(5755);
/* harmony import */ var _hooks_useTheme_js__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(39107);
/* harmony import */ var _hooks_useThemeName_js__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(55173);
/* harmony import */ var _hooks_useSafeRef_js__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(67180);
/* harmony import */ var _hooks_useStyle_js__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(75428);
/* harmony import */ var _views_Slot_js__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(84367);
/* harmony import */ var _views_Stack_js__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(42039);
/* harmony import */ var _views_Text_js__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(8669);
/* harmony import */ var _contexts_TextAncestorContext_js__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(67364);
/* harmony import */ var _views_Theme_js__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(56283);
/* harmony import */ var _views_ThemeProvider_js__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(83589);
/* harmony import */ var _views_FontLanguage__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(26815);
/* harmony import */ var _views_TamaguiProvider_js__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(57450);
/* harmony import */ var _tamagui_use_force_update__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(53261);
/* harmony import */ var _tamagui_use_did_finish_ssr__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(43635);
/* harmony import */ var _tamagui_use_event__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__(4751);
/* harmony import */ var _tamagui_compose_refs__WEBPACK_IMPORTED_MODULE_50__ = __webpack_require__(55217);
/* harmony import */ var _tamagui_helpers__WEBPACK_IMPORTED_MODULE_51__ = __webpack_require__(95591);
/* harmony reexport (unknown) */ var __WEBPACK_REEXPORT_OBJECT__ = {};
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _tamagui_helpers__WEBPACK_IMPORTED_MODULE_51__) if(["default","configureMedia","getConfig","getMedia","getThemes","getTokens","mediaObjectToString","mediaQueryConfig","mediaState","onConfiguredOnce","useMedia","useMediaPropsActive","Tamagui","getValueFromIdentifier","setIdentifierValue","Spacer","Unspaced","createComponent","defaultComponentState","mouseUps","spacedChildren","createShorthands","createTheme","createTamagui","createFont","createTokens","createCSSVariable","createVariable","didGetVariableValue","getVariable","getVariableName","getVariableValue","getVariableVariable","isVariable","setDidGetVariableValue","variableToString","createVariables","tokensKeysOrdered","insertFont","parseFont","registerFontVariables","addTheme","updateTheme","styled","ReactNativeStaticConfigs","getReactNativeConfig","setupReactNative","THEME_CLASSNAME_PREFIX","THEME_NAME_SEPARATOR","stackDefaultStyles","webOnlyDefaultStyles","useShallowSetState","getFontsForLanguage","getVariantExtras","getAnimationDriver","getExpandedShorthands","PROP_SPLIT","getSplitStyles","getSubStyle","insertSplitStyles","useSplitStyles","getAtomicStyle","getStylesAtomic","styleToCSS","pseudoDescriptors","mergeProps","expandStyles","fixStyles","isTamaguiElement","isTamaguiComponent","matchMedia","setupMatchMedia","proxyThemeVariables","themeable","withStaticProperties","names","normalizeColor","rgba","ButtonNestingContext","useId","useIsTouchDevice","activeThemeManagers","getThemeProxied","useChangeThemeEffect","useTheme","useThemeWithState","useThemeName","useSafeRef","useStyle","Slot","Slottable","mergeEvent","Stack","Text","TextAncestorContext","Theme","useThemedChildren","ThemeProvider","ThemeProviderRootContext","FontLanguage","TamaguiProvider","isServerSide","useForceUpdate","useDidFinishSSR","useEvent","useGet","composeRefs","useComposedRefs"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) __WEBPACK_REEXPORT_OBJECT__[__WEBPACK_IMPORT_KEY__] = function(key) { return _tamagui_helpers__WEBPACK_IMPORTED_MODULE_51__[key]; }.bind(0, __WEBPACK_IMPORT_KEY__)
/* harmony reexport (unknown) */ __webpack_require__.d(__webpack_exports__, __WEBPACK_REEXPORT_OBJECT__);
/* harmony import */ var _tamagui_constants__WEBPACK_IMPORTED_MODULE_52__ = __webpack_require__(11649);
/* harmony import */ var _setupHooks_js__WEBPACK_IMPORTED_MODULE_53__ = __webpack_require__(46713);

























































//# sourceMappingURL=index.mjs.map


/***/ }),

/***/ 7896:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

/***/ }),

/***/ 29405:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectSpread2; }
});

;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/typeof.js
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/toPrimitive.js

function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/toPropertyKey.js


function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/defineProperty.js

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectSpread2.js

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}

/***/ }),

/***/ 31461:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectWithoutPropertiesLoose; }
/* harmony export */ });
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

/***/ }),

/***/ 20189:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cp": function() { return /* binding */ P; },
/* harmony export */   "JB": function() { return /* binding */ l; },
/* harmony export */   "Qo": function() { return /* binding */ T; },
/* harmony export */   "RR": function() { return /* binding */ b; },
/* harmony export */   "US": function() { return /* binding */ s; },
/* harmony export */   "X5": function() { return /* binding */ v; },
/* harmony export */   "cv": function() { return /* binding */ O; },
/* harmony export */   "dp": function() { return /* binding */ k; },
/* harmony export */   "dr": function() { return /* binding */ L; },
/* harmony export */   "oo": function() { return /* binding */ r; },
/* harmony export */   "uY": function() { return /* binding */ D; },
/* harmony export */   "x7": function() { return /* binding */ u; }
/* harmony export */ });
function t(t){return t.split("-")[1]}function e(t){return"y"===t?"height":"width"}function n(t){return t.split("-")[0]}function o(t){return["top","bottom"].includes(n(t))?"x":"y"}function i(i,r,a){let{reference:l,floating:s}=i;const c=l.x+l.width/2-s.width/2,f=l.y+l.height/2-s.height/2,m=o(r),u=e(m),g=l[u]/2-s[u]/2,d="x"===m;let p;switch(n(r)){case"top":p={x:c,y:l.y-s.height};break;case"bottom":p={x:c,y:l.y+l.height};break;case"right":p={x:l.x+l.width,y:f};break;case"left":p={x:l.x-s.width,y:f};break;default:p={x:l.x,y:l.y}}switch(t(r)){case"start":p[m]-=g*(a&&d?-1:1);break;case"end":p[m]+=g*(a&&d?-1:1)}return p}const r=async(t,e,n)=>{const{placement:o="bottom",strategy:r="absolute",middleware:a=[],platform:l}=n,s=a.filter(Boolean),c=await(null==l.isRTL?void 0:l.isRTL(e));let f=await l.getElementRects({reference:t,floating:e,strategy:r}),{x:m,y:u}=i(f,o,c),g=o,d={},p=0;for(let n=0;n<s.length;n++){const{name:a,fn:h}=s[n],{x:y,y:x,data:w,reset:v}=await h({x:m,y:u,initialPlacement:o,placement:g,strategy:r,middlewareData:d,rects:f,platform:l,elements:{reference:t,floating:e}});m=null!=y?y:m,u=null!=x?x:u,d={...d,[a]:{...d[a],...w}},v&&p<=50&&(p++,"object"==typeof v&&(v.placement&&(g=v.placement),v.rects&&(f=!0===v.rects?await l.getElementRects({reference:t,floating:e,strategy:r}):v.rects),({x:m,y:u}=i(f,g,c))),n=-1)}return{x:m,y:u,placement:g,strategy:r,middlewareData:d}};function a(t){return"number"!=typeof t?function(t){return{top:0,right:0,bottom:0,left:0,...t}}(t):{top:t,right:t,bottom:t,left:t}}function l(t){return{...t,top:t.y,left:t.x,right:t.x+t.width,bottom:t.y+t.height}}async function s(t,e){var n;void 0===e&&(e={});const{x:o,y:i,platform:r,rects:s,elements:c,strategy:f}=t,{boundary:m="clippingAncestors",rootBoundary:u="viewport",elementContext:g="floating",altBoundary:d=!1,padding:p=0}=e,h=a(p),y=c[d?"floating"===g?"reference":"floating":g],x=l(await r.getClippingRect({element:null==(n=await(null==r.isElement?void 0:r.isElement(y)))||n?y:y.contextElement||await(null==r.getDocumentElement?void 0:r.getDocumentElement(c.floating)),boundary:m,rootBoundary:u,strategy:f})),w="floating"===g?{...s.floating,x:o,y:i}:s.reference,v=await(null==r.getOffsetParent?void 0:r.getOffsetParent(c.floating)),b=await(null==r.isElement?void 0:r.isElement(v))&&await(null==r.getScale?void 0:r.getScale(v))||{x:1,y:1},R=l(r.convertOffsetParentRelativeRectToViewportRelativeRect?await r.convertOffsetParentRelativeRectToViewportRelativeRect({rect:w,offsetParent:v,strategy:f}):w);return{top:(x.top-R.top+h.top)/b.y,bottom:(R.bottom-x.bottom+h.bottom)/b.y,left:(x.left-R.left+h.left)/b.x,right:(R.right-x.right+h.right)/b.x}}const c=Math.min,f=Math.max;function m(t,e,n){return f(t,c(e,n))}const u=n=>({name:"arrow",options:n,async fn(i){const{element:r,padding:l=0}=n||{},{x:s,y:c,placement:f,rects:u,platform:g,elements:d}=i;if(null==r)return{};const p=a(l),h={x:s,y:c},y=o(f),x=e(y),w=await g.getDimensions(r),v="y"===y,b=v?"top":"left",R=v?"bottom":"right",A=v?"clientHeight":"clientWidth",P=u.reference[x]+u.reference[y]-h[y]-u.floating[x],T=h[y]-u.reference[y],O=await(null==g.getOffsetParent?void 0:g.getOffsetParent(r));let E=O?O[A]:0;E&&await(null==g.isElement?void 0:g.isElement(O))||(E=d.floating[A]||u.floating[x]);const D=P/2-T/2,L=p[b],k=E-w[x]-p[R],B=E/2-w[x]/2+D,C=m(L,B,k),H=null!=t(f)&&B!=C&&u.reference[x]/2-(B<L?p[b]:p[R])-w[x]/2<0;return{[y]:h[y]-(H?B<L?L-B:k-B:0),data:{[y]:C,centerOffset:B-C}}}}),g=["top","right","bottom","left"],d=g.reduce(((t,e)=>t.concat(e,e+"-start",e+"-end")),[]),p={left:"right",right:"left",bottom:"top",top:"bottom"};function h(t){return t.replace(/left|right|bottom|top/g,(t=>p[t]))}function y(n,i,r){void 0===r&&(r=!1);const a=t(n),l=o(n),s=e(l);let c="x"===l?a===(r?"end":"start")?"right":"left":"start"===a?"bottom":"top";return i.reference[s]>i.floating[s]&&(c=h(c)),{main:c,cross:h(c)}}const x={start:"end",end:"start"};function w(t){return t.replace(/start|end/g,(t=>x[t]))}const v=function(e){return void 0===e&&(e={}),{name:"autoPlacement",options:e,async fn(o){var i,r,a;const{rects:l,middlewareData:c,placement:f,platform:m,elements:u}=o,{crossAxis:g=!1,alignment:p,allowedPlacements:h=d,autoAlignment:x=!0,...v}=e,b=void 0!==p||h===d?function(e,o,i){return(e?[...i.filter((n=>t(n)===e)),...i.filter((n=>t(n)!==e))]:i.filter((t=>n(t)===t))).filter((n=>!e||t(n)===e||!!o&&w(n)!==n))}(p||null,x,h):h,R=await s(o,v),A=(null==(i=c.autoPlacement)?void 0:i.index)||0,P=b[A];if(null==P)return{};const{main:T,cross:O}=y(P,l,await(null==m.isRTL?void 0:m.isRTL(u.floating)));if(f!==P)return{reset:{placement:b[0]}};const E=[R[n(P)],R[T],R[O]],D=[...(null==(r=c.autoPlacement)?void 0:r.overflows)||[],{placement:P,overflows:E}],L=b[A+1];if(L)return{data:{index:A+1,overflows:D},reset:{placement:L}};const k=D.map((e=>{const n=t(e.placement);return[e.placement,n&&g?e.overflows.slice(0,2).reduce(((t,e)=>t+e),0):e.overflows[0],e.overflows]})).sort(((t,e)=>t[1]-e[1])),B=(null==(a=k.filter((e=>e[2].slice(0,t(e[0])?2:3).every((t=>t<=0))))[0])?void 0:a[0])||k[0][0];return B!==f?{data:{index:A+1,overflows:D},reset:{placement:B}}:{}}}};const b=function(e){return void 0===e&&(e={}),{name:"flip",options:e,async fn(o){var i;const{placement:r,middlewareData:a,rects:l,initialPlacement:c,platform:f,elements:m}=o,{mainAxis:u=!0,crossAxis:g=!0,fallbackPlacements:d,fallbackStrategy:p="bestFit",fallbackAxisSideDirection:x="none",flipAlignment:v=!0,...b}=e,R=n(r),A=n(c)===c,P=await(null==f.isRTL?void 0:f.isRTL(m.floating)),T=d||(A||!v?[h(c)]:function(t){const e=h(t);return[w(t),e,w(e)]}(c));d||"none"===x||T.push(...function(e,o,i,r){const a=t(e);let l=function(t,e,n){const o=["left","right"],i=["right","left"],r=["top","bottom"],a=["bottom","top"];switch(t){case"top":case"bottom":return n?e?i:o:e?o:i;case"left":case"right":return e?r:a;default:return[]}}(n(e),"start"===i,r);return a&&(l=l.map((t=>t+"-"+a)),o&&(l=l.concat(l.map(w)))),l}(c,v,x,P));const O=[c,...T],E=await s(o,b),D=[];let L=(null==(i=a.flip)?void 0:i.overflows)||[];if(u&&D.push(E[R]),g){const{main:t,cross:e}=y(r,l,P);D.push(E[t],E[e])}if(L=[...L,{placement:r,overflows:D}],!D.every((t=>t<=0))){var k,B;const t=((null==(k=a.flip)?void 0:k.index)||0)+1,e=O[t];if(e)return{data:{index:t,overflows:L},reset:{placement:e}};let n=null==(B=L.filter((t=>t.overflows[0]<=0)).sort(((t,e)=>t.overflows[1]-e.overflows[1]))[0])?void 0:B.placement;if(!n)switch(p){case"bestFit":{var C;const t=null==(C=L.map((t=>[t.placement,t.overflows.filter((t=>t>0)).reduce(((t,e)=>t+e),0)])).sort(((t,e)=>t[1]-e[1]))[0])?void 0:C[0];t&&(n=t);break}case"initialPlacement":n=c}if(r!==n)return{reset:{placement:n}}}return{}}}};function R(t,e){return{top:t.top-e.height,right:t.right-e.width,bottom:t.bottom-e.height,left:t.left-e.width}}function A(t){return g.some((e=>t[e]>=0))}const P=function(t){return void 0===t&&(t={}),{name:"hide",options:t,async fn(e){const{strategy:n="referenceHidden",...o}=t,{rects:i}=e;switch(n){case"referenceHidden":{const t=R(await s(e,{...o,elementContext:"reference"}),i.reference);return{data:{referenceHiddenOffsets:t,referenceHidden:A(t)}}}case"escaped":{const t=R(await s(e,{...o,altBoundary:!0}),i.floating);return{data:{escapedOffsets:t,escaped:A(t)}}}default:return{}}}}},T=function(t){return void 0===t&&(t={}),{name:"inline",options:t,async fn(e){const{placement:i,elements:r,rects:s,platform:m,strategy:u}=e,{padding:g=2,x:d,y:p}=t,h=l(m.convertOffsetParentRelativeRectToViewportRelativeRect?await m.convertOffsetParentRelativeRectToViewportRelativeRect({rect:s.reference,offsetParent:await(null==m.getOffsetParent?void 0:m.getOffsetParent(r.floating)),strategy:u}):s.reference),y=await(null==m.getClientRects?void 0:m.getClientRects(r.reference))||[],x=a(g);const w=await m.getElementRects({reference:{getBoundingClientRect:function(){if(2===y.length&&y[0].left>y[1].right&&null!=d&&null!=p)return y.find((t=>d>t.left-x.left&&d<t.right+x.right&&p>t.top-x.top&&p<t.bottom+x.bottom))||h;if(y.length>=2){if("x"===o(i)){const t=y[0],e=y[y.length-1],o="top"===n(i),r=t.top,a=e.bottom,l=o?t.left:e.left,s=o?t.right:e.right;return{top:r,bottom:a,left:l,right:s,width:s-l,height:a-r,x:l,y:r}}const t="left"===n(i),e=f(...y.map((t=>t.right))),r=c(...y.map((t=>t.left))),a=y.filter((n=>t?n.left===r:n.right===e)),l=a[0].top,s=a[a.length-1].bottom;return{top:l,bottom:s,left:r,right:e,width:e-r,height:s-l,x:r,y:l}}return h}},floating:r.floating,strategy:u});return s.reference.x!==w.reference.x||s.reference.y!==w.reference.y||s.reference.width!==w.reference.width||s.reference.height!==w.reference.height?{reset:{rects:w}}:{}}}};const O=function(e){return void 0===e&&(e=0),{name:"offset",options:e,async fn(i){const{x:r,y:a}=i,l=await async function(e,i){const{placement:r,platform:a,elements:l}=e,s=await(null==a.isRTL?void 0:a.isRTL(l.floating)),c=n(r),f=t(r),m="x"===o(r),u=["left","top"].includes(c)?-1:1,g=s&&m?-1:1,d="function"==typeof i?i(e):i;let{mainAxis:p,crossAxis:h,alignmentAxis:y}="number"==typeof d?{mainAxis:d,crossAxis:0,alignmentAxis:null}:{mainAxis:0,crossAxis:0,alignmentAxis:null,...d};return f&&"number"==typeof y&&(h="end"===f?-1*y:y),m?{x:h*g,y:p*u}:{x:p*u,y:h*g}}(i,e);return{x:r+l.x,y:a+l.y,data:l}}}};function E(t){return"x"===t?"y":"x"}const D=function(t){return void 0===t&&(t={}),{name:"shift",options:t,async fn(e){const{x:i,y:r,placement:a}=e,{mainAxis:l=!0,crossAxis:c=!1,limiter:f={fn:t=>{let{x:e,y:n}=t;return{x:e,y:n}}},...u}=t,g={x:i,y:r},d=await s(e,u),p=o(n(a)),h=E(p);let y=g[p],x=g[h];if(l){const t="y"===p?"bottom":"right";y=m(y+d["y"===p?"top":"left"],y,y-d[t])}if(c){const t="y"===h?"bottom":"right";x=m(x+d["y"===h?"top":"left"],x,x-d[t])}const w=f.fn({...e,[p]:y,[h]:x});return{...w,data:{x:w.x-i,y:w.y-r}}}}},L=function(t){return void 0===t&&(t={}),{options:t,fn(e){const{x:i,y:r,placement:a,rects:l,middlewareData:s}=e,{offset:c=0,mainAxis:f=!0,crossAxis:m=!0}=t,u={x:i,y:r},g=o(a),d=E(g);let p=u[g],h=u[d];const y="function"==typeof c?c(e):c,x="number"==typeof y?{mainAxis:y,crossAxis:0}:{mainAxis:0,crossAxis:0,...y};if(f){const t="y"===g?"height":"width",e=l.reference[g]-l.floating[t]+x.mainAxis,n=l.reference[g]+l.reference[t]-x.mainAxis;p<e?p=e:p>n&&(p=n)}if(m){var w,v;const t="y"===g?"width":"height",e=["top","left"].includes(n(a)),o=l.reference[d]-l.floating[t]+(e&&(null==(w=s.offset)?void 0:w[d])||0)+(e?0:x.crossAxis),i=l.reference[d]+l.reference[t]+(e?0:(null==(v=s.offset)?void 0:v[d])||0)-(e?x.crossAxis:0);h<o?h=o:h>i&&(h=i)}return{[g]:p,[d]:h}}}},k=function(e){return void 0===e&&(e={}),{name:"size",options:e,async fn(i){const{placement:r,rects:a,platform:l,elements:m}=i,{apply:u=(()=>{}),...g}=e,d=await s(i,g),p=n(r),h=t(r),y="x"===o(r),{width:x,height:w}=a.floating;let v,b;"top"===p||"bottom"===p?(v=p,b=h===(await(null==l.isRTL?void 0:l.isRTL(m.floating))?"start":"end")?"left":"right"):(b=p,v="end"===h?"top":"bottom");const R=w-d[v],A=x-d[b];let P=R,T=A;if(y?T=c(x-d.right-d.left,A):P=c(w-d.bottom-d.top,R),!i.middlewareData.shift&&!h){const t=f(d.left,0),e=f(d.right,0),n=f(d.top,0),o=f(d.bottom,0);y?T=x-2*(0!==t||0!==e?t+e:f(d.left,d.right)):P=w-2*(0!==n||0!==o?n+o:f(d.top,d.bottom))}await u({...i,availableWidth:T,availableHeight:P});const O=await l.getDimensions(m.floating);return x!==O.width||w!==O.height?{reset:{rects:!0}}:{}}}};


/***/ }),

/***/ 40771:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Jv": function() { return /* binding */ O; },
/* harmony export */   "Kx": function() { return /* binding */ D; },
/* harmony export */   "Me": function() { return /* binding */ P; },
/* harmony export */   "oo": function() { return /* binding */ z; }
/* harmony export */ });
/* harmony import */ var _floating_ui_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20189);
function n(t){var e;return(null==(e=t.ownerDocument)?void 0:e.defaultView)||window}function o(t){return n(t).getComputedStyle(t)}const i=Math.min,r=Math.max,l=Math.round;function c(t){const e=o(t);let n=parseFloat(e.width),i=parseFloat(e.height);const r=t.offsetWidth,c=t.offsetHeight,s=l(n)!==r||l(i)!==c;return s&&(n=r,i=c),{width:n,height:i,fallback:s}}function s(t){return h(t)?(t.nodeName||"").toLowerCase():""}let f;function u(){if(f)return f;const t=navigator.userAgentData;return t&&Array.isArray(t.brands)?(f=t.brands.map((t=>t.brand+"/"+t.version)).join(" "),f):navigator.userAgent}function a(t){return t instanceof n(t).HTMLElement}function d(t){return t instanceof n(t).Element}function h(t){return t instanceof n(t).Node}function p(t){if("undefined"==typeof ShadowRoot)return!1;return t instanceof n(t).ShadowRoot||t instanceof ShadowRoot}function g(t){const{overflow:e,overflowX:n,overflowY:i,display:r}=o(t);return/auto|scroll|overlay|hidden|clip/.test(e+i+n)&&!["inline","contents"].includes(r)}function m(t){return["table","td","th"].includes(s(t))}function y(t){const e=/firefox/i.test(u()),n=o(t),i=n.backdropFilter||n.WebkitBackdropFilter;return"none"!==n.transform||"none"!==n.perspective||!!i&&"none"!==i||e&&"filter"===n.willChange||e&&!!n.filter&&"none"!==n.filter||["transform","perspective"].some((t=>n.willChange.includes(t)))||["paint","layout","strict","content"].some((t=>{const e=n.contain;return null!=e&&e.includes(t)}))}function x(){return/^((?!chrome|android).)*safari/i.test(u())}function w(t){return["html","body","#document"].includes(s(t))}function v(t){return d(t)?t:t.contextElement}const b={x:1,y:1};function L(t){const e=v(t);if(!a(e))return b;const n=e.getBoundingClientRect(),{width:o,height:i,fallback:r}=c(e);let s=(r?l(n.width):n.width)/o,f=(r?l(n.height):n.height)/i;return s&&Number.isFinite(s)||(s=1),f&&Number.isFinite(f)||(f=1),{x:s,y:f}}function E(e,o,i,r){var l,c;void 0===o&&(o=!1),void 0===i&&(i=!1);const s=e.getBoundingClientRect(),f=v(e);let u=b;o&&(r?d(r)&&(u=L(r)):u=L(e));const a=f?n(f):window,h=x()&&i;let p=(s.left+(h&&(null==(l=a.visualViewport)?void 0:l.offsetLeft)||0))/u.x,g=(s.top+(h&&(null==(c=a.visualViewport)?void 0:c.offsetTop)||0))/u.y,m=s.width/u.x,y=s.height/u.y;if(f){const t=n(f),e=r&&d(r)?n(r):r;let o=t.frameElement;for(;o&&r&&e!==t;){const t=L(o),e=o.getBoundingClientRect(),i=getComputedStyle(o);e.x+=(o.clientLeft+parseFloat(i.paddingLeft))*t.x,e.y+=(o.clientTop+parseFloat(i.paddingTop))*t.y,p*=t.x,g*=t.y,m*=t.x,y*=t.y,p+=e.x,g+=e.y,o=n(o).frameElement}}return (0,_floating_ui_core__WEBPACK_IMPORTED_MODULE_0__/* .rectToClientRect */ .JB)({width:m,height:y,x:p,y:g})}function R(t){return((h(t)?t.ownerDocument:t.document)||window.document).documentElement}function T(t){return d(t)?{scrollLeft:t.scrollLeft,scrollTop:t.scrollTop}:{scrollLeft:t.pageXOffset,scrollTop:t.pageYOffset}}function C(t){return E(R(t)).left+T(t).scrollLeft}function F(t){if("html"===s(t))return t;const e=t.assignedSlot||t.parentNode||p(t)&&t.host||R(t);return p(e)?e.host:e}function W(t){const e=F(t);return w(e)?e.ownerDocument.body:a(e)&&g(e)?e:W(e)}function D(t,e){var o;void 0===e&&(e=[]);const i=W(t),r=i===(null==(o=t.ownerDocument)?void 0:o.body),l=n(i);return r?e.concat(l,l.visualViewport||[],g(i)?i:[]):e.concat(i,D(i))}function S(e,i,l){let c;if("viewport"===i)c=function(t,e){const o=n(t),i=R(t),r=o.visualViewport;let l=i.clientWidth,c=i.clientHeight,s=0,f=0;if(r){l=r.width,c=r.height;const t=x();(!t||t&&"fixed"===e)&&(s=r.offsetLeft,f=r.offsetTop)}return{width:l,height:c,x:s,y:f}}(e,l);else if("document"===i)c=function(t){const e=R(t),n=T(t),i=t.ownerDocument.body,l=r(e.scrollWidth,e.clientWidth,i.scrollWidth,i.clientWidth),c=r(e.scrollHeight,e.clientHeight,i.scrollHeight,i.clientHeight);let s=-n.scrollLeft+C(t);const f=-n.scrollTop;return"rtl"===o(i).direction&&(s+=r(e.clientWidth,i.clientWidth)-l),{width:l,height:c,x:s,y:f}}(R(e));else if(d(i))c=function(t,e){const n=E(t,!0,"fixed"===e),o=n.top+t.clientTop,i=n.left+t.clientLeft,r=a(t)?L(t):{x:1,y:1};return{width:t.clientWidth*r.x,height:t.clientHeight*r.y,x:i*r.x,y:o*r.y}}(i,l);else{const t={...i};if(x()){var s,f;const o=n(e);t.x-=(null==(s=o.visualViewport)?void 0:s.offsetLeft)||0,t.y-=(null==(f=o.visualViewport)?void 0:f.offsetTop)||0}c=t}return (0,_floating_ui_core__WEBPACK_IMPORTED_MODULE_0__/* .rectToClientRect */ .JB)(c)}function A(t,e){return a(t)&&"fixed"!==o(t).position?e?e(t):t.offsetParent:null}function H(t,e){const i=n(t);if(!a(t))return i;let r=A(t,e);for(;r&&m(r)&&"static"===o(r).position;)r=A(r,e);return r&&("html"===s(r)||"body"===s(r)&&"static"===o(r).position&&!y(r))?i:r||function(t){let e=F(t);for(;a(e)&&!w(e);){if(y(e))return e;e=F(e)}return null}(t)||i}function V(t,e,n){const o=a(e),i=R(e),r=E(t,!0,"fixed"===n,e);let l={scrollLeft:0,scrollTop:0};const c={x:0,y:0};if(o||!o&&"fixed"!==n)if(("body"!==s(e)||g(i))&&(l=T(e)),a(e)){const t=E(e,!0);c.x=t.x+e.clientLeft,c.y=t.y+e.clientTop}else i&&(c.x=C(i));return{x:r.left+l.scrollLeft-c.x,y:r.top+l.scrollTop-c.y,width:r.width,height:r.height}}const O={getClippingRect:function(t){let{element:e,boundary:n,rootBoundary:l,strategy:c}=t;const f="clippingAncestors"===n?function(t,e){const n=e.get(t);if(n)return n;let i=D(t).filter((t=>d(t)&&"body"!==s(t))),r=null;const l="fixed"===o(t).position;let c=l?F(t):t;for(;d(c)&&!w(c);){const t=o(c),e=y(c);"fixed"===t.position?r=null:(l?e||r:e||"static"!==t.position||!r||!["absolute","fixed"].includes(r.position))?r=t:i=i.filter((t=>t!==c)),c=F(c)}return e.set(t,i),i}(e,this._c):[].concat(n),u=[...f,l],a=u[0],h=u.reduce(((t,n)=>{const o=S(e,n,c);return t.top=r(o.top,t.top),t.right=i(o.right,t.right),t.bottom=i(o.bottom,t.bottom),t.left=r(o.left,t.left),t}),S(e,a,c));return{width:h.right-h.left,height:h.bottom-h.top,x:h.left,y:h.top}},convertOffsetParentRelativeRectToViewportRelativeRect:function(t){let{rect:e,offsetParent:n,strategy:o}=t;const i=a(n),r=R(n);if(n===r)return e;let l={scrollLeft:0,scrollTop:0},c={x:1,y:1};const f={x:0,y:0};if((i||!i&&"fixed"!==o)&&(("body"!==s(n)||g(r))&&(l=T(n)),a(n))){const t=E(n);c=L(n),f.x=t.x+n.clientLeft,f.y=t.y+n.clientTop}return{width:e.width*c.x,height:e.height*c.y,x:e.x*c.x-l.scrollLeft*c.x+f.x,y:e.y*c.y-l.scrollTop*c.y+f.y}},isElement:d,getDimensions:function(t){return a(t)?c(t):t.getBoundingClientRect()},getOffsetParent:H,getDocumentElement:R,getScale:L,async getElementRects(t){let{reference:e,floating:n,strategy:o}=t;const i=this.getOffsetParent||H,r=this.getDimensions;return{reference:V(e,await i(n),o),floating:{x:0,y:0,...await r(n)}}},getClientRects:t=>Array.from(t.getClientRects()),isRTL:t=>"rtl"===o(t).direction};function P(t,e,n,o){void 0===o&&(o={});const{ancestorScroll:i=!0,ancestorResize:r=!0,elementResize:l=!0,animationFrame:c=!1}=o,s=i&&!c,f=s||r?[...d(t)?D(t):t.contextElement?D(t.contextElement):[],...D(e)]:[];f.forEach((t=>{s&&t.addEventListener("scroll",n,{passive:!0}),r&&t.addEventListener("resize",n)}));let u,a=null;if(l){let o=!0;a=new ResizeObserver((()=>{o||n(),o=!1})),d(t)&&!c&&a.observe(t),d(t)||!t.contextElement||c||a.observe(t.contextElement),a.observe(e)}let h=c?E(t):null;return c&&function e(){const o=E(t);!h||o.x===h.x&&o.y===h.y&&o.width===h.width&&o.height===h.height||n();h=o,u=requestAnimationFrame(e)}(),n(),()=>{var t;f.forEach((t=>{s&&t.removeEventListener("scroll",n),r&&t.removeEventListener("resize",n)})),null==(t=a)||t.disconnect(),a=null,c&&cancelAnimationFrame(u)}}const z=(t,n,o)=>{const i=new Map,r={platform:O,...o},l={...r.platform,_c:i};return (0,_floating_ui_core__WEBPACK_IMPORTED_MODULE_0__/* .computePosition */ .oo)(t,n,{...r,platform:l})};


/***/ }),

/***/ 99677:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "clamp": function() { return /* reexport safe */ _clamp__WEBPACK_IMPORTED_MODULE_0__.u; },
/* harmony export */   "composeEventHandlers": function() { return /* reexport safe */ _composeEventHandlers__WEBPACK_IMPORTED_MODULE_1__.M; },
/* harmony export */   "concatClassName": function() { return /* reexport safe */ _concatClassName__WEBPACK_IMPORTED_MODULE_2__.E; },
/* harmony export */   "isValidCSSCharCode": function() { return /* reexport safe */ _tamagui_simple_hash__WEBPACK_IMPORTED_MODULE_5__.z; },
/* harmony export */   "simpleHash": function() { return /* reexport safe */ _tamagui_simple_hash__WEBPACK_IMPORTED_MODULE_5__.M; },
/* harmony export */   "stylePropsAll": function() { return /* reexport safe */ _validStyleProps__WEBPACK_IMPORTED_MODULE_3__.cC; },
/* harmony export */   "stylePropsText": function() { return /* reexport safe */ _validStyleProps__WEBPACK_IMPORTED_MODULE_3__.FB; },
/* harmony export */   "stylePropsTextOnly": function() { return /* reexport safe */ _validStyleProps__WEBPACK_IMPORTED_MODULE_3__.hT; },
/* harmony export */   "stylePropsTransform": function() { return /* reexport safe */ _validStyleProps__WEBPACK_IMPORTED_MODULE_3__.Dc; },
/* harmony export */   "stylePropsView": function() { return /* reexport safe */ _validStyleProps__WEBPACK_IMPORTED_MODULE_3__.Ji; },
/* harmony export */   "validPseudoKeys": function() { return /* reexport safe */ _validStyleProps__WEBPACK_IMPORTED_MODULE_3__.M6; },
/* harmony export */   "validStyles": function() { return /* reexport safe */ _validStyleProps__WEBPACK_IMPORTED_MODULE_3__.Qn; },
/* harmony export */   "validStylesOnBaseProps": function() { return /* reexport safe */ _validStyleProps__WEBPACK_IMPORTED_MODULE_3__.bX; }
/* harmony export */ });
/* harmony import */ var _clamp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(58829);
/* harmony import */ var _composeEventHandlers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53998);
/* harmony import */ var _concatClassName__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72539);
/* harmony import */ var _validStyleProps__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99058);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92263);
/* harmony reexport (unknown) */ var __WEBPACK_REEXPORT_OBJECT__ = {};
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _types__WEBPACK_IMPORTED_MODULE_4__) if(["default","clamp","composeEventHandlers","concatClassName","stylePropsAll","stylePropsText","stylePropsTextOnly","stylePropsTransform","stylePropsView","validPseudoKeys","validStyles","validStylesOnBaseProps"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) __WEBPACK_REEXPORT_OBJECT__[__WEBPACK_IMPORT_KEY__] = function(key) { return _types__WEBPACK_IMPORTED_MODULE_4__[key]; }.bind(0, __WEBPACK_IMPORT_KEY__)
/* harmony reexport (unknown) */ __webpack_require__.d(__webpack_exports__, __WEBPACK_REEXPORT_OBJECT__);
/* harmony import */ var _tamagui_simple_hash__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9904);






//# sourceMappingURL=index.mjs.map


/***/ }),

/***/ 82276:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Portal": function() { return /* reexport safe */ _Portal__WEBPACK_IMPORTED_MODULE_0__.h; },
/* harmony export */   "PortalHost": function() { return /* reexport safe */ _GorhomPortal__WEBPACK_IMPORTED_MODULE_2__.$2; },
/* harmony export */   "PortalItem": function() { return /* reexport safe */ _GorhomPortal__WEBPACK_IMPORTED_MODULE_2__.b5; },
/* harmony export */   "PortalProvider": function() { return /* reexport safe */ _GorhomPortal__WEBPACK_IMPORTED_MODULE_2__.Xp; }
/* harmony export */ });
/* harmony import */ var _Portal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42048);
/* harmony import */ var _PortalProps__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67360);
/* harmony reexport (checked) */ if(__webpack_require__.o(_PortalProps__WEBPACK_IMPORTED_MODULE_1__, "Paragraph")) __webpack_require__.d(__webpack_exports__, { "Paragraph": function() { return _PortalProps__WEBPACK_IMPORTED_MODULE_1__.Paragraph; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_PortalProps__WEBPACK_IMPORTED_MODULE_1__, "PortalHost")) __webpack_require__.d(__webpack_exports__, { "PortalHost": function() { return _PortalProps__WEBPACK_IMPORTED_MODULE_1__.PortalHost; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_PortalProps__WEBPACK_IMPORTED_MODULE_1__, "PortalItem")) __webpack_require__.d(__webpack_exports__, { "PortalItem": function() { return _PortalProps__WEBPACK_IMPORTED_MODULE_1__.PortalItem; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_PortalProps__WEBPACK_IMPORTED_MODULE_1__, "PortalProvider")) __webpack_require__.d(__webpack_exports__, { "PortalProvider": function() { return _PortalProps__WEBPACK_IMPORTED_MODULE_1__.PortalProvider; } });
/* harmony import */ var _GorhomPortal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76919);



//# sourceMappingURL=index.mjs.map


/***/ }),

/***/ 9904:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ simpleHash; },
/* harmony export */   "z": function() { return /* binding */ isValidCSSCharCode; }
/* harmony export */ });
const simpleHash = (str, hashMin = 10) => {
  let hash = 0;
  let valids = "";
  const len = str.length;
  for (let i = 0; i < len; i++) {
    const char = str.charCodeAt(i);
    if (char === 46) {
      valids += "d0t";
    }
    if (isValidCSSCharCode(char) && len <= hashMin) {
      valids += str[i];
    } else {
      hash = (hash << 5) - hash + char;
      hash &= hash;
    }
  }
  return valids + (hash ? new Uint32Array([hash])[0].toString(36) : "");
};
function isValidCSSCharCode(code) {
  return (
    // A-Z
    code >= 65 && code <= 90 || // a-z
    code >= 97 && code <= 122 || // _
    code === 95 || // -
    code === 45 || // 0-9
    code >= 48 && code <= 57
  );
}

//# sourceMappingURL=index.mjs.map


/***/ }),

/***/ 41277:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* reexport */ useEvent; }
});

// UNUSED EXPORTS: useGet

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../node_modules/@tamagui/use-event/dist/esm/useGet.js

const isWeb = "web" === "web";
const isClient = typeof window !== "undefined";
const useIsomorphicLayoutEffect = !isWeb || isClient ? react.useLayoutEffect : react.useEffect;
function useGet(currentValue, initialValue, forwardToFunction) {
  const curRef = (0,react.useRef)(initialValue ?? currentValue);
  useIsomorphicLayoutEffect(() => {
    curRef.current = currentValue;
  });
  return (0,react.useCallback)(
    forwardToFunction ? (...args) => {
      var _a;
      return (_a = curRef.current) == null ? void 0 : _a.apply(null, args);
    } : () => curRef.current,
    []
  );
}

//# sourceMappingURL=useGet.js.map

;// CONCATENATED MODULE: ../../node_modules/@tamagui/use-event/dist/esm/useEvent.js

function useEvent(callback) {
  return useGet(callback, defaultValue, true);
}
const defaultValue = () => {
  throw new Error("Cannot call an event handler while rendering.");
};

//# sourceMappingURL=useEvent.js.map

;// CONCATENATED MODULE: ../../node_modules/@tamagui/use-event/dist/esm/index.mjs


//# sourceMappingURL=index.mjs.map


/***/ }),

/***/ 41539:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Oy": function() { return /* reexport */ PresenceContext_PresenceContext; },
  "oO": function() { return /* reexport */ usePresence; }
});

// UNUSED EXPORTS: isPresent, useIsPresent

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../node_modules/@tamagui/use-presence/dist/esm/PresenceContext.js

const PresenceContext_PresenceContext = (0,react.createContext)(null);

//# sourceMappingURL=PresenceContext.js.map

;// CONCATENATED MODULE: ../../node_modules/@tamagui/use-presence/dist/esm/usePresence.js


function usePresence() {
  const context = (0,react.useContext)(PresenceContext_PresenceContext);
  if (!context) {
    return [true, null, context];
  }
  const { isPresent: isPresent2, onExitComplete, register } = context;
  const id = (0,react.useId)() || "";
  (0,react.useEffect)(() => register(id), [id, register]);
  const safeToRemove = () => onExitComplete == null ? void 0 : onExitComplete(id);
  return !isPresent2 && onExitComplete ? [false, safeToRemove, context] : [true, void 0, context];
}
function useIsPresent() {
  return isPresent(useContext(PresenceContext));
}
function isPresent(context) {
  return context === null ? true : context.isPresent;
}

//# sourceMappingURL=usePresence.js.map

;// CONCATENATED MODULE: ../../node_modules/@tamagui/use-presence/dist/esm/index.mjs


//# sourceMappingURL=index.mjs.map


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,179], function() { return __webpack_exec__(86570), __webpack_exec__(41984); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);